export const notionJson = {
	"comics": [
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/24d276f5-2af1-40b3-8d3b-4a844b4c7a6a/netosdearquibalda-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=060976697053a78db841f630c2099b9b942db763dbc9e484668469c65033a915&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T23:26:00.000Z",
			"id": "1c7e1ce0-0fd5-80b8-b1cd-e512250100dd",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "netosdearquibalda-hq",
			"data_leitura": "2025-03-30",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/netos-de-arquibalda-r32e",
			"name": "Netos de Arquibalda",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"1b7e1ce0-0fd5-80a5-a33c-efbbc0095134"
			],
			"autor": [
				"Kuraishi Rei “Bagul” ⭐"
			],
			"insta": "https://www.instagram.com/kuraishi_rei",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/abf3640d-a301-4e27-9050-91dd64d46b40/memriasdesangue-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=c23058dfe35020a17b6fc2ab7f348ac639baa402e63bb03c6d82b6212eee4f83&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T23:24:00.000Z",
			"id": "1c7e1ce0-0fd5-8021-9ced-c21339c352c8",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "memóriasdesangue-hq",
			"data_leitura": "2025-03-27",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/memorias-de-sangue-cqw9",
			"name": "Memórias de Sangue",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"1c7e1ce0-0fd5-8077-b321-f8155d314ac1"
			],
			"autor": [
				"Devil Bell"
			],
			"insta": "https://www.instagram.com/devilbell_artes?igsh=MXRzazNza25wbGRidw%3D%3D",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1bf5d6db-4770-42d6-bddf-13954e5d5cfe/neevena-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=cb4a1d65537e1383b7336859e0a5fd85cfbd3191c0d7f9c2c0facba5f4af2890&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T23:20:00.000Z",
			"id": "1c7e1ce0-0fd5-806e-98ad-e2a9bd5f2642",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "neevena-hq",
			"data_leitura": "2025-03-24",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/neevena-a-rainha-sucubus",
			"name": "Neevena - A Rainha Succubus",
			"porcentagem_leitura": 25,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "8",
			"autores": [
				"1c7e1ce0-0fd5-8007-b410-dd818d88ec65"
			],
			"autor": [
				"Nay Veiga"
			],
			"insta": "https://www.instagram.com/nayanaveiga.art/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/891b78cc-3f2b-4fd9-aca7-2b5c85fb7cf1/guiltyheartofabsoluteevil-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=93b499c8bae9ea80127d08ff2fe2254ad7a0bae3360ed0c09d7d398dcd0de009&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T23:12:00.000Z",
			"id": "1c7e1ce0-0fd5-80ea-8304-f2d7ffabd773",
			"contadores": [
				"Logos",
				"Furry",
				"Quadrinhos para ler chapado",
				"Astros Celestes com carinhas"
			],
			"caps_lidos": "2",
			"imagem_name": "guiltyheartofabsoluteevil-hq",
			"data_leitura": "2025-03-26",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/guilty-heart-of-absolute-evil",
			"name": "Guilty Heart of Absolute Evil",
			"porcentagem_leitura": 22,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"1c7e1ce0-0fd5-809c-a97c-d77a33ca45ad"
			],
			"autor": [
				"Wanderjegson"
			],
			"insta": "https://www.instagram.com/wanderjegson/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e84facfa-8e5e-471a-a110-fcd058cb1064/serraverde-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=6b0cebc3e5d06e43eaa454578ba35cf6912924a133ed828de49107df7498a433&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T23:09:00.000Z",
			"id": "1c7e1ce0-0fd5-8099-a360-fdbd5d442962",
			"contadores": [
				"Declaro que fudeu"
			],
			"caps_lidos": "2",
			"imagem_name": "serraverde-hq",
			"data_leitura": "2025-03-25",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/serra-verde-pbj9",
			"name": "Serra Verde",
			"porcentagem_leitura": 40,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"1c7e1ce0-0fd5-8062-aac4-e2c9671ce508"
			],
			"autor": [
				"Caosmose"
			],
			"insta": "https://www.instagram.com/caosmose.zine/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c321932f-5ba9-4eab-8d01-cd70718af589/maiado-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=57fd1e6aca2873a0c4767bf7d4d0b6a6e23e601e1aef049d6c68c482d291706f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T23:03:00.000Z",
			"id": "1c7e1ce0-0fd5-80bd-a1ff-e6e64f4146ea",
			"contadores": [
				"Declaro que fudeu"
			],
			"caps_lidos": "1",
			"imagem_name": "maiado-hq",
			"data_leitura": "2025-03-24",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/maiado",
			"name": "Maiado",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"1c7e1ce0-0fd5-8055-9d38-c5d4e3f445a4"
			],
			"autor": [
				"Krats ⭐"
			],
			"insta": "https://www.instagram.com/krats.hqs/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cf99c33e-83ff-4007-9388-ff708e456def/deoutrosmundos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=19314404383724ee4828118ef3158873e5ab9a79027b6cff2ec7c77978b71fbf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T22:57:00.000Z",
			"id": "1c7e1ce0-0fd5-80f9-90e6-f2c26fbf1fce",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "deoutrosmundos-hq",
			"data_leitura": "2025-03-21",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/de-outros-mundos",
			"name": "De Outros Mundos",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"3b056d0c-e22e-4628-a1a1-06f64dd57645"
			],
			"autor": [
				"S.Bittencourt ⭐"
			],
			"insta": "https://www.instagram.com/s_bittencourt_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/S_Bittencourt__"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/735c210b-117e-4874-8f59-bf23f16961df/darkrose-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=5dfaaa6b764e6d0f275f3629391baa2300d9b47a66b6e89f965f402522925aab&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T22:55:00.000Z",
			"id": "1c7e1ce0-0fd5-80f3-8532-d844676f30be",
			"contadores": [
				"Protagonistas perdidos"
			],
			"caps_lidos": "3",
			"imagem_name": "darkrose-hq",
			"data_leitura": "2025-03-21",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/dark-rose",
			"name": "Dark Rose",
			"porcentagem_leitura": 5,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "53",
			"autores": [
				"6912135f-8037-40f4-ba66-c847e42c059c"
			],
			"autor": [
				"Valdo Artes"
			],
			"insta": "https://www.instagram.com/valdoarts/",
			"tags": "♂️",
			"twitter": "https://twitter.com/ValdoDesenhos"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9c8dd7ea-d4aa-444e-8e79-3366eaebb7d8/irmaoscarranca-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=d18612f47e60a317a88a34e346297709a78bee4055c571e6152913d9c36adb3a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T22:42:00.000Z",
			"id": "1c7e1ce0-0fd5-8050-b75c-d82740e1bfe4",
			"contadores": [
				"Cobras Gigantes",
				"Duplinhas do Barulho",
				"Aura"
			],
			"caps_lidos": "1",
			"imagem_name": "irmaoscarranca-hq",
			"data_leitura": "2025-03-17",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Irmaos-Carranca/info",
			"name": "Irmãos Carranca",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"1c7e1ce0-0fd5-80b4-be5d-f5594adb0d14"
			],
			"autor": [
				"Guilherme “BrushRush” Freitas ⭐"
			],
			"insta": "https://www.instagram.com/gui.gfreitas/",
			"tags": "♂️",
			"twitter": "https://x.com/CanalBrushRush"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a4699b0a-c7c7-4386-a788-30e2ca3607b1/cidadedesucata-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=3acf9b3abb0b63d74d9a2aa80232b186e887530c1ad44c617d5e4a158350afdd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T22:32:00.000Z",
			"id": "1c7e1ce0-0fd5-80af-82c2-c300ca487640",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "cidadedesucata-hq",
			"data_leitura": "2025-02-22",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://chimeracomics.online/",
			"name": "Cidade de Sucata",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"ec8ced61-4b99-427b-a993-f43d1123617c"
			],
			"autor": [
				"Rafael Lima ⭐"
			],
			"insta": "https://www.instagram.com/rafalima831/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/dab4e676-8715-421d-a429-aca231e111c6/sobojugo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=8c570020a05136088701796fe4bcbd910c72917c0d4db259271d79d069732b25&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-16T23:47:00.000Z",
			"id": "1b8e1ce0-0fd5-80a4-bbf4-eed509860df2",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "sobojugo-hq",
			"data_leitura": "2025-03-02",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/sob-o-jugo",
			"name": "Sob o Jugo",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"1b8e1ce0-0fd5-80d9-9222-d8beb1f33d7e"
			],
			"autor": [
				"Aninha chan"
			],
			"insta": "https://www.instagram.com/an_chan_s2?igsh=MXRpYnJucTVsdWJ0aQ%3D%3D",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/708094fe-aa18-4c3a-8a10-e87e3d70c15c/tala-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=3720c1752b944f6752188c0c504b6d4996c69c9e436c96993e29b1d78e7ba7f1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-16T16:33:00.000Z",
			"id": "1b8e1ce0-0fd5-803a-8ea8-e85b7d90a5ee",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "tala-hq",
			"data_leitura": "2025-03-12",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/tala",
			"name": "Tala",
			"porcentagem_leitura": 100,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"223f7dfd-bcca-475d-bcbd-115536c079e9"
			],
			"autor": [
				"Duhgetsu ⭐"
			],
			"insta": "https://www.instagram.com/duhgetsu/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Duhgetsu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2cd10c23-6a80-4d79-961a-14ff56acef43/magiccrusaders-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=a1fb2ed3d062838fea0e774b39b64a1cddb7b4b94760b17e4ddcef482c5a1d4d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T15:19:00.000Z",
			"id": "1b7e1ce0-0fd5-8069-993a-e64909260934",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "magiccrusaders-hq",
			"data_leitura": "2025-03-14",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/magic-crusaders-vuu5",
			"name": "Magic Crusaders",
			"porcentagem_leitura": 9,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"1b7e1ce0-0fd5-8044-bd3b-ef0c3bec3b2e"
			],
			"autor": [
				"Dyce G ⭐"
			],
			"insta": "https://fliptru.com.br/@Dyce_G",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e3903013-75d2-4bb5-bbfb-70d9e089db12/alendadedipp-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=2167df5b4d276ac1468e588767f1498017bf8c5237c44cb6410353bdd54a7552&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T15:16:00.000Z",
			"id": "1b7e1ce0-0fd5-8001-b43d-e306faa8440a",
			"contadores": [
				"Vegetas Chegando",
				"Quadrinhos para ler chapado",
				"Astros Celestes com carinhas"
			],
			"caps_lidos": "1",
			"imagem_name": "alendadedipp-hq",
			"data_leitura": "2025-03-14",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-lenda-de-dipp",
			"name": "A Lenda de Dipp",
			"porcentagem_leitura": 25,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"1b7e1ce0-0fd5-8084-995d-c3c8484f6677"
			],
			"autor": [
				"Markin the Starboy"
			],
			"insta": "https://fliptru.com.br/@Markin_the_Starboy",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/54ee0656-bd64-4679-84c9-0c54a892c026/paulorangers-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=a93d0e4357276a49d94c8b048d7a425a13c3e32827f1b36f688a3d670ff7fc11&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T15:12:00.000Z",
			"id": "1b7e1ce0-0fd5-8023-ad9b-c4edfc5786d3",
			"contadores": [
				"Transformações"
			],
			"caps_lidos": "5",
			"imagem_name": "paulorangers-hq",
			"data_leitura": "2025-03-14",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/paulo-rangers",
			"name": "Paulo Rangers",
			"porcentagem_leitura": 7,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "65",
			"autores": [
				"48f611c0-b671-4d10-ba7d-d9a7ee8acbff"
			],
			"autor": [
				"Owlopes ⭐"
			],
			"insta": "https://www.instagram.com/owlopes.arts/",
			"tags": "♂️",
			"twitter": "https://twitter.com/walparadise"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/dab110fe-c499-44c8-bdf5-06f8a22a4d18/kennylendasdeforya-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=2eae1fa5fcaf1a37e47a8e1886e077b12afda6bad6344aec96630ced0a51e5a1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T15:07:00.000Z",
			"id": "1b7e1ce0-0fd5-8055-b489-ce1d3453cb92",
			"contadores": [
				"Pais que foram comprar cigarro"
			],
			"caps_lidos": "1",
			"imagem_name": "kennylendasdeforya-hq",
			"data_leitura": "2025-03-11",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/kenny-lendas-de-forya-ir9o",
			"name": "Kenny - Lendas de Forya",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"1b7e1ce0-0fd5-8060-b536-d5adc8dbbbb9"
			],
			"autor": [
				"Roger “Excelencia” Alberto ⭐"
			],
			"insta": "https://www.instagram.com/roger_alb3rto/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/544678c3-295c-4298-99fc-5a8c85517a3c/lovewars-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=e152910c6528994c8896efbd6a10636233a2979bedd4c63aa15060939375fbb5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T15:04:00.000Z",
			"id": "1b7e1ce0-0fd5-803e-8d72-ee57868215f7",
			"contadores": [
				"Camisas 10",
				"Waifus",
				"Casamentos"
			],
			"caps_lidos": "1",
			"imagem_name": "lovewars-hq",
			"data_leitura": "2025-03-10",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/love-wars-sfbq",
			"name": "Love Wars",
			"porcentagem_leitura": 20,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"8653e55c-4480-4d10-b294-f9ac267c8447"
			],
			"autor": [
				"GringoComics ⭐"
			],
			"insta": "https://www.instagram.com/gringocomics_insta/",
			"tags": "♂️",
			"twitter": "https://twitter.com/gringoscomics"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9cdf98a3-ce28-45a7-bc3b-fe6e5d5f5e3e/axiomavetiti-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=e8301c8626620aa10fa9d369ae83b40cec2d2b14eec259c734b8c4512e4abd60&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:58:00.000Z",
			"id": "1b7e1ce0-0fd5-80f2-a89c-e5b64841a914",
			"contadores": [
				"Organizações Malígnas",
				"Entradas fodas"
			],
			"caps_lidos": "1",
			"imagem_name": "axiomavetiti-hq",
			"data_leitura": "2025-03-07",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/axioma-vetiti-boao",
			"name": "Axioma Vetiti",
			"porcentagem_leitura": 11,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"1b7e1ce0-0fd5-8098-83bb-f46b1e4cf565"
			],
			"autor": [
				"Cristiano ‘Haeckel’ Oliveira"
			],
			"insta": "https://www.instagram.com/haeckelalmeida/?hl=pt-br",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6ee0d690-6881-438d-bc8f-8a9c4675de1c/aprofeciaprofunda-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=908ebe5434800393a1601b36ba52dfa3aaba249430f7032a1aff331c3e93f549&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:43:00.000Z",
			"id": "1b7e1ce0-0fd5-80b2-8685-e3d799354335",
			"contadores": [
				"Melhores Sinopses",
				"Quadrinhos para ler chapado"
			],
			"caps_lidos": "1",
			"imagem_name": "aprofeciaprofunda-hq",
			"data_leitura": "2025-03-05",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-profecia-profunda",
			"name": "A Profecia Profunda",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"16fe1ce0-0fd5-8049-a9c9-d441adac3119"
			],
			"autor": [
				"Darky Jr ⭐"
			],
			"insta": "https://www.instagram.com/bloodyportals",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ea1b6cd0-3460-4652-8717-04cf157f1cd3/pingponk-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=328e42713adf228a00d0c1b3f5ac087cee4373a10c4bbb3951a3b3296011802e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:41:00.000Z",
			"id": "1b7e1ce0-0fd5-808c-847e-e8c97aa274cc",
			"contadores": [
				"Escolas que ninguem tem aula de verdade"
			],
			"caps_lidos": "1",
			"imagem_name": "pingponk-hq",
			"data_leitura": "2025-03-05",
			"genero": [
				{
					"name": "Esporte",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/ping-ponk",
			"name": "Ping Ponk",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"8653e55c-4480-4d10-b294-f9ac267c8447"
			],
			"autor": [
				"GringoComics ⭐"
			],
			"insta": "https://www.instagram.com/gringocomics_insta/",
			"tags": "♂️",
			"twitter": "https://twitter.com/gringoscomics"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b0a8613d-53f0-4584-93f0-18c789bdc4fa/smellslikeshonenspirit-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=c0899512b8c64d1910c2687bba2085ce3e8bcb75560da9e45171540d7db8b7c4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:39:00.000Z",
			"id": "1b7e1ce0-0fd5-8021-bae3-f14978b04d11",
			"contadores": [
				"Peitões do Quadrinho Nacional"
			],
			"caps_lidos": "2",
			"imagem_name": "smellslikeshonenspirit-hq",
			"data_leitura": "2025-03-05",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/smells-like-shonen-spirit",
			"name": "Smells Like Shonen Spirit",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"ee3b4003-45ee-4238-a184-d547171a6650"
			],
			"autor": [
				"Ricardo Mango"
			],
			"insta": "https://www.instagram.com/ricardomango/",
			"tags": "♂️",
			"twitter": "https://twitter.com/_ricardomango"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3902c7c7-8862-47a1-aa84-5f614d877ebb/kellyyoungshifty-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=c050f67606438571b80646c31518977b4efe5443def73603e51c94cdd326ac7d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:37:00.000Z",
			"id": "1b7e1ce0-0fd5-80cf-bc03-c2ac978e849d",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "kellyyoungshifty-hq",
			"data_leitura": "2025-03-03",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/as-desventuras-de-kelly-young-shifty",
			"name": "Kelly Young Shifty",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"8653e55c-4480-4d10-b294-f9ac267c8447"
			],
			"autor": [
				"GringoComics ⭐"
			],
			"insta": "https://www.instagram.com/gringocomics_insta/",
			"tags": "♂️",
			"twitter": "https://twitter.com/gringoscomics"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9250111f-79fb-488b-b312-5ffdbd56edd9/osguardioesdetupa-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=31fc2fc6affef5faf79b8982ce5f875006c523aa50dd52edd4a28f2df848f8cd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:33:00.000Z",
			"id": "1b7e1ce0-0fd5-80c1-8891-c7eadec2f8cc",
			"contadores": [
				"Inícios mitológicos",
				"Personagens PCD"
			],
			"caps_lidos": "3",
			"imagem_name": "osguardioesdetupa-hq",
			"data_leitura": "2025-03-02",
			"genero": [
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				},
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Os-Guardioes-de-Tupa/info",
			"name": "Os Guardiões de Tupã",
			"porcentagem_leitura": 5,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "51",
			"autores": [
				"1b7e1ce0-0fd5-80f2-bf2d-d9e4842336a9"
			],
			"autor": [
				"Ice Angel Simon"
			],
			"insta": "https://www.instagram.com/ice.angel.simon/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/42adbdde-a4e9-4d7c-940d-e985ed5bb1f2/eunaotoafimdomocinho-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=8e91693e8bee9efd8de78cd1d34e5c4ec5f585d901dea699fcd7adaded0b030f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:27:00.000Z",
			"id": "1b7e1ce0-0fd5-80d0-9d9e-db7545313f2a",
			"contadores": [
				"Crias",
				"Escolas que ninguem tem aula de verdade",
				"LQN Aparecendo em Quadrinhos Nacionais"
			],
			"caps_lidos": "1",
			"imagem_name": "eunaotoafimdomocinho-hq",
			"data_leitura": "2025-03-01",
			"genero": [
				{
					"name": "Shoujo",
					"color": "pink"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/eu-nao-to-afim-do-mocinho",
			"name": "Eu Não Tô A fim do Mocinho",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"510c6a3a-5ba9-47fa-bfb1-24d4469cf7c5"
			],
			"autor": [
				"Beatriz (Bid Desenhos) ⭐"
			],
			"insta": "https://www.instagram.com/bid_desenhos",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/633007cf-f5bf-44dc-96b4-a13815fbcadc/inospito-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=b90eb8f7f939349ecfa63b25277b4510e24a865f7f314f2ced626bfb2b19b980&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:24:00.000Z",
			"id": "1b7e1ce0-0fd5-80a5-a94f-ec2d691a6b90",
			"contadores": [
				"Mentores",
				"Arma Inusitada",
				"Calvos",
				"Cicatrizes e Tatuagens",
				"Wikiman/Palestrinha"
			],
			"caps_lidos": "3",
			"imagem_name": "inospito-hq",
			"data_leitura": "2025-02-27",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/inospito-primeira-temporada-qww0",
			"name": "Inóspito",
			"porcentagem_leitura": 15,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "19",
			"autores": [
				"1b7e1ce0-0fd5-8043-a8a0-d75bf74fb404"
			],
			"autor": [
				"Inospito Will"
			],
			"insta": "https://www.instagram.com/willianinpt345/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a4ce1508-b391-44e4-b867-52be024a15a3/twinheartzodiac-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=28b01058d983d6dd62ffabd485126e332887f0a1d56e0385cea5557995de2a64&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:19:00.000Z",
			"id": "1b7e1ce0-0fd5-8070-a859-d1b4fbfef1fe",
			"contadores": [
				"Silhuetas",
				"Mentores"
			],
			"caps_lidos": "1",
			"imagem_name": "twinheartzodiac-hq",
			"data_leitura": "2025-02-26",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/twin-heart-zodiac",
			"name": "Twin Heart Zodiac",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"1b7e1ce0-0fd5-80a5-a33c-efbbc0095134"
			],
			"autor": [
				"Kuraishi Rei “Bagul” ⭐"
			],
			"insta": "https://www.instagram.com/kuraishi_rei",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ec40faeb-a1a8-447f-9838-b7325adcf92a/missfortune-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=db6d28d9b6d9bd6029c73f30f6b95396c7b7b748208ae846c73ce06cf233de68&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:14:00.000Z",
			"id": "1b7e1ce0-0fd5-80c7-8591-fd528029fefa",
			"contadores": [
				"Quadrinhos Feels"
			],
			"caps_lidos": "3",
			"imagem_name": "missfortune-hq",
			"data_leitura": "2025-02-26",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/miss-fortune",
			"name": "Miss Fortune",
			"porcentagem_leitura": 7,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "40",
			"autores": [
				"2858a502-756c-4772-9bc5-6b7e5040b7fb"
			],
			"autor": [
				"Kavalmarinho"
			],
			"insta": "https://www.instagram.com/kavalomarinho/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Gust4voL"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/57560b30-dbb8-48b0-acd3-6d7b0986893b/edificio-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=035f7892267a304d8155fc46de9824539f3ddcf917bfd6b52ee6baace357c76f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:11:00.000Z",
			"id": "1b7e1ce0-0fd5-8067-9473-de156a999ec8",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "edificio-hq",
			"data_leitura": "2025-02-24",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/edificio-pius",
			"name": "Edifício",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"1b7e1ce0-0fd5-80a3-b3dc-edf027b631b2"
			],
			"autor": [
				"Coelho Comic ⭐"
			],
			"insta": "https://www.instagram.com/coelhocomic",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8cae7a32-4f90-4695-add2-97e36725766e/abutre-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=33d5e8a08eefd0ec2b9922871edf77a07da8e70bbaac65ea3ea25a216f43c584&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:08:00.000Z",
			"id": "1b7e1ce0-0fd5-807a-befd-d255c7d1d7df",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "abutre-hq",
			"data_leitura": "2025-02-23",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/abutre-ync8",
			"name": "Abutre",
			"porcentagem_leitura": 13,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "15",
			"autores": [
				"1b7e1ce0-0fd5-809c-adff-ff6e5b2fcfa4"
			],
			"autor": [
				"Vesper “AGUA” ⭐"
			],
			"insta": "https://www.instagram.com/teiuvesper/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7ad11b47-0dcb-4d82-907d-f767ba8f4ee6/operdedor-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=24e11703848b884702532e4f70a16291587b84fcdd82fc1b2eea4b841d8a71f2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:59:00.000Z",
			"id": "1b7e1ce0-0fd5-8034-a4a3-ef6c55bf2eb0",
			"contadores": [
				"Calvos",
				"Duplinhas do Barulho"
			],
			"caps_lidos": "2",
			"imagem_name": "operdedor-hq",
			"data_leitura": "2025-02-19",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/o-perdedor",
			"name": "O Perdedor",
			"porcentagem_leitura": 8,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "23",
			"autores": [
				"1b7e1ce0-0fd5-8079-9015-d5b3fdbd552c"
			],
			"autor": [
				"Bruno Cezar"
			],
			"insta": "https://www.instagram.com/22o9l/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/efbbc871-eaf7-46b3-9076-588719579046/splittingimage-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=20861124f68074e6106058ca2103e2bb80d655a53f39b0ea565cfe45391bd2bf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:52:00.000Z",
			"id": "1b7e1ce0-0fd5-80d6-a66f-e05a21683a7d",
			"contadores": [
				"Vilões",
				"Segundas Chances"
			],
			"caps_lidos": "3",
			"imagem_name": "splittingimage-hq",
			"data_leitura": "2025-02-19",
			"genero": [
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/splitting-image",
			"name": "Splitting Image",
			"porcentagem_leitura": 15,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "19",
			"autores": [
				"1b7e1ce0-0fd5-805b-a4eb-c3affe98336f"
			],
			"autor": [
				"Iris Grimoire ⭐"
			],
			"insta": "https://www.instagram.com/irisgrimoire_/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4f2ab2c3-9a95-4396-886b-dd205db32ff9/paradisecity-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=75a0d4dac0535aec31b9a40d0052fee81d10214fe69cc77dff66095ec7382c7a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:49:00.000Z",
			"id": "1b7e1ce0-0fd5-8091-b5a3-f6ed3ae89033",
			"contadores": [
				"Beijocas"
			],
			"caps_lidos": "1",
			"imagem_name": "paradisecity-hq",
			"data_leitura": "2025-02-19",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/paradise-city-histories-space-e-perolas-arcanas-especial-dia-dos-namorados",
			"name": "Paradise City Stories",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"b34e152b-0055-4e00-8399-e06cb303d0dd",
				"197e1ce0-0fd5-8015-b7ec-fd6620de9f95"
			],
			"autor": [
				"Leonardo Gomes ⭐",
				"Ailton DB"
			],
			"insta": "https://www.instagram.com/leonardogomes4908/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3096b876-28e5-4374-9deb-bf1fcb2c75b7/fantasyland-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=19941f48b8b9637d7f889e8314914b4569f0d10628f978dffde22e7cf8277c44&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:47:00.000Z",
			"id": "1b7e1ce0-0fd5-80ed-b367-db2369438d3b",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "fantasyland-hq",
			"data_leitura": "2025-02-18",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/fantasyland-o-segredo-da-bruxa",
			"name": "FantasyLand",
			"porcentagem_leitura": 25,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "12",
			"autores": [
				"84b7ce4a-beec-4715-9ab6-778b7bb89853"
			],
			"autor": [
				"J S Art ⭐"
			],
			"insta": "https://www.instagram.com/j.s.art_/",
			"tags": "♂️",
			"twitter": "https://twitter.com/JSArt12"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/99fe354d-491f-4a85-aefe-8d81fe964c47/embuscadescientia-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=8bf83e3286f2d2cc17937946f8016835ae920e717cb682fb82c64ac430ed325c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:44:00.000Z",
			"id": "1b7e1ce0-0fd5-80df-9bf3-faee14be8d4e",
			"contadores": [
				"Caloteiros"
			],
			"caps_lidos": "2",
			"imagem_name": "embuscadescientia-hq",
			"data_leitura": "2025-02-18",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/em-busca-de-scientia",
			"name": "Em busca de Scientia",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"1b7e1ce0-0fd5-80b1-9808-e70669815a7c"
			],
			"autor": [
				"Otatter ⭐"
			],
			"insta": "https://www.instagram.com/otatter/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/aaf8aa97-b752-450b-aca4-6fe9bac3aa42/numikins-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=246b7ccf7d0a0751c85257d780c8b3a03fee8f963fef152c02493f069b8c34d7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:32:00.000Z",
			"id": "1b7e1ce0-0fd5-80a1-b88c-d2711faa51d6",
			"contadores": [
				"Entradas fodas",
				"Aura"
			],
			"caps_lidos": "1",
			"imagem_name": "numikins-hq",
			"data_leitura": "2025-02-17",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/numikins-ri1i",
			"name": "Numikins",
			"porcentagem_leitura": 12,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "8",
			"autores": [
				"1b7e1ce0-0fd5-802b-a87c-d97e01f7ac31"
			],
			"autor": [
				"Elinho Galvão"
			],
			"insta": "https://www.instagram.com/elinhogalvao/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ec83a3e9-e853-42e6-9d45-e30a664c98b7/dragoncity-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=43e4e237d0ace295a9c0297a8bbb27048bff5d3b652b17d0c4077addfb904d2d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:24:00.000Z",
			"id": "1b7e1ce0-0fd5-80f2-8912-dbff2317d0f3",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "dragoncity-hq",
			"data_leitura": "2025-02-17",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/dragon-city-neo-gen-star",
			"name": "Dragon City",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"1b7e1ce0-0fd5-809e-a106-ef889aafe920"
			],
			"autor": [
				"DCCGAMES ⭐"
			],
			"insta": "https://www.instagram.com/dccgames.3333/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/dfffb504-7769-46d6-93a3-48db62ef85b9/slave-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=15290e808c10e716c4c7af4de8d804ef1702a0dd55a8d4689d4d5fa9c06520af&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:08:00.000Z",
			"id": "1b7e1ce0-0fd5-802b-a5d4-cfe865ac456f",
			"contadores": [
				"Artes Pikassas",
				"Mulheres Bombadas",
				"Manos Bombados",
				"Segundas Chances"
			],
			"caps_lidos": "1",
			"imagem_name": "slave-hq",
			"data_leitura": "2025-02-16",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/slave",
			"name": "SLAVE",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"1b7e1ce0-0fd5-8016-a726-e5d12c714758"
			],
			"autor": [
				"Hashimura ⭐"
			],
			"insta": "https://www.instagram.com/hashimura.yutaro/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9168dbc5-a8df-46c8-bbf7-98d1aba56aac/aesperademisun-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=c25e213846e5320b1b97f4538bd02d24011c31c9cc50e3cd4aae9a359b72fc38&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:05:00.000Z",
			"id": "1b7e1ce0-0fd5-804c-a834-f36f17a9895f",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "aesperademisun-hq",
			"data_leitura": "2025-02-15",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-espera-de-mi-sun",
			"name": "A Espera de Mi Sun",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"1b7e1ce0-0fd5-80a6-aa97-d997c53869ff"
			],
			"autor": [
				"Ivan Anderson"
			],
			"insta": "https://www.instagram.com/1977player",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8a44c434-7add-43b6-ae77-97094277610f/taico-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=f579598f20dfbdfcb280832d8cc53daf34d14e55d89af11f964506722ce72db3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T12:56:00.000Z",
			"id": "1b7e1ce0-0fd5-808c-ad91-d11447136daf",
			"contadores": [
				"Inícios mitológicos",
				"parece que você andou treinando desde a ultima vez que nos encontramos",
				"Pq diabos você mandou uma criança?",
				"Idosos agressores",
				"Idosos sendo agredidos",
				"Hehe"
			],
			"caps_lidos": "3",
			"imagem_name": "taico-hq",
			"data_leitura": "2025-02-14",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/taico",
			"name": "Taico",
			"porcentagem_leitura": 23,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "13",
			"autores": [
				"1b7e1ce0-0fd5-806a-8c60-c2555f3c8bb6"
			],
			"autor": [
				"Rubinho ⭐"
			],
			"insta": "https://www.instagram.com/binhokonoha/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5d2c5e22-ac9c-4575-8d65-d7a102f38525/umapea-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=f4324ebae4e9c815d32852a1f8a0ca4638c8770b94fcae939dfcd68d3c1b4e1b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T12:48:00.000Z",
			"id": "1b7e1ce0-0fd5-8032-ad06-ec9a2aeaf33c",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "umapeça-hq",
			"data_leitura": "2025-02-09",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/uma-peca",
			"name": "Uma Peça",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"223f7dfd-bcca-475d-bcbd-115536c079e9"
			],
			"autor": [
				"Duhgetsu ⭐"
			],
			"insta": "https://www.instagram.com/duhgetsu/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Duhgetsu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c62e0780-a36a-4e68-b1a8-376d0c11e394/sentiapormim-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=9e7737d6621d51994ebcf7c94924b6b43fa3d1bb146467264aee37b50abd05c1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-11T23:45:00.000Z",
			"id": "197e1ce0-0fd5-8036-a055-cda395cd9955",
			"contadores": [
				"Camisas 10",
				"Heterofobia nos olhos",
				"Desenhistas",
				"Comidas aconchegantes"
			],
			"caps_lidos": "2",
			"imagem_name": "sentiapormim-hq  ",
			"data_leitura": "2025-02-12",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/sentia-por-mim",
			"name": "Sentia Por Mim",
			"porcentagem_leitura": 13,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "15",
			"autores": [
				"197e1ce0-0fd5-807c-94cf-e54924178a03"
			],
			"autor": [
				"Za Bucci"
			],
			"insta": "https://www.instagram.com/za_bucci/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/45a633fa-3811-4263-aa5d-051b29f41072/space-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=9719bf30d681684de56d2a00442cb8cf2939e0786ae628554c642810ba66ef8a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-11T23:40:00.000Z",
			"id": "197e1ce0-0fd5-80a9-9b5c-d515ad3d17d5",
			"contadores": [
				"Vegetas Chegando",
				"Não humanos se passando por humanos"
			],
			"caps_lidos": "1",
			"imagem_name": "space-hq  ",
			"data_leitura": "2025-02-10",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/space",
			"name": "Space",
			"porcentagem_leitura": 4,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "25",
			"autores": [
				"197e1ce0-0fd5-8015-b7ec-fd6620de9f95"
			],
			"autor": [
				"Ailton DB"
			],
			"insta": "https://www.instagram.com/ailton.db/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cc6652bf-9234-4915-b2b2-2dc491e2c0c1/florence-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=430874ed7861b1ffc756e7296e2f7c371da0290ba87a1efc72b284358beaa6de&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-11T23:35:00.000Z",
			"id": "197e1ce0-0fd5-80e4-8696-eace5bdab623",
			"contadores": [
				"Desenhistas"
			],
			"caps_lidos": "1",
			"imagem_name": "florence-hq  ",
			"data_leitura": "2025-01-09",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/florence-61ab",
			"name": "Florence",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"197e1ce0-0fd5-8023-a1f3-cd6d0e6981d8"
			],
			"autor": [
				"Caffe"
			],
			"insta": "https://www.instagram.com/caffetaminado/",
			"tags": "♂️",
			"twitter": "https://x.com/caffetaminado"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4ca4265a-7838-4421-89b9-0ed35b4b13fa/terraqueo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=3fbeb50520051c222403d715c6f899ca54e43ebe97dfcdc11aad1af3a3a6e555&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-11T23:31:00.000Z",
			"id": "197e1ce0-0fd5-80d6-a611-ed4f768ef9db",
			"contadores": [
				"Não humanos se passando por humanos"
			],
			"caps_lidos": "7",
			"imagem_name": "terraqueo-hq  ",
			"data_leitura": "2025-01-09",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/TERRAQUEO/info",
			"name": "Terraqueo",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"197e1ce0-0fd5-80b7-a20e-fdb2929b3512"
			],
			"autor": [
				"Liw Bug"
			],
			"insta": "https://www.instagram.com/annoyingbug26/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/16586b3d-a52c-4edf-964f-1c7f6160948a/aruadecima-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=7bde871039f7141c35be9640b0c77d91509f01569f142bb3c1bb0686d6355b18&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-11T23:22:00.000Z",
			"id": "197e1ce0-0fd5-8097-9d9a-f8b138935da3",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "aruadecima-hq  ",
			"data_leitura": "2025-02-09",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-rua-de-cima",
			"name": "A Rua de Cima",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"63fe1f46-bef0-4274-9eb9-3d0ec9497af4"
			],
			"autor": [
				"Diego SSA ⭐"
			],
			"insta": "https://www.instagram.com/diegosanderson3/",
			"tags": "♂️",
			"twitter": "https://twitter.com/ssa_diego"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/78198a9a-0d86-4a20-a00b-453ee85ea673/southcurse-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=c23ba4793576f06451e69e7348c01cc687f37527643f67937e02e3f685ab20ac&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-07T00:03:00.000Z",
			"id": "193e1ce0-0fd5-80d6-b62c-d3101e755412",
			"contadores": [
				"Temática de Céu/Inferno",
				"Criaturas sobrenaturais",
				"Alices",
				"Cenas na Chuva"
			],
			"caps_lidos": "4",
			"imagem_name": "southcurse-hq  ",
			"data_leitura": "2025-02-02",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.webtoons.com/en/canvas/south-curse-/list?title_no=1003588",
			"name": "South Curse",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"193e1ce0-0fd5-80a9-bcdf-e3a5535d1f91"
			],
			"autor": [
				"Clancy “South Curse”"
			],
			"insta": "https://www.instagram.com/south_curse/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0da85a11-392b-46d3-b894-6943c5025237/livrosepiercings-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=b2c8c2a8f8f4d2b31fab86115c961e7b3a62afd5f96bd5e19c8e047ce68612bf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-06T23:51:00.000Z",
			"id": "192e1ce0-0fd5-8093-8934-c3a72794b808",
			"contadores": [
				"Camisas 10"
			],
			"caps_lidos": "1",
			"imagem_name": "livrosepiercings-hq  ",
			"data_leitura": "2025-01-16",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/livros-piercings-0lfl",
			"name": "Livros & Piercings",
			"porcentagem_leitura": 20,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"192e1ce0-0fd5-80ff-9576-f58e4ec98586"
			],
			"autor": [
				"MariVih"
			],
			"insta": "https://www.instagram.com/vih_adona/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/17f3fe5e-989b-4227-8aea-7f13eae4b995/adoutoraealoba-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=82a56b32548b9faf643947732c531043b5b91fbf220737a1f85a2be800dae4a7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-06T23:44:00.000Z",
			"id": "192e1ce0-0fd5-8046-b81d-dc50ede9916c",
			"contadores": [
				"Reviravoltas"
			],
			"caps_lidos": "1",
			"imagem_name": "adoutoraealoba-hq  ",
			"data_leitura": "2025-01-16",
			"genero": [
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-doutora-e-a-loba",
			"name": "A Doutora e a Loba",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"192e1ce0-0fd5-80a0-a37a-efba6f5ec4f6"
			],
			"autor": [
				"Makice Hit"
			],
			"insta": "https://www.instagram.com/makice.hit/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/77d1cf53-743f-4aaf-b6b3-3af269c59c19/cramunho-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=440b43df355b8ded2a4b14745fa065eba1fdc4103013871b288718fa194e127e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-06T23:42:00.000Z",
			"id": "192e1ce0-0fd5-8098-9aa5-e2cb43e74c93",
			"contadores": [
				"Quadrinhos pra se ler no churrasco"
			],
			"caps_lidos": "1",
			"imagem_name": "cramunho-hq  ",
			"data_leitura": "2025-01-16",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/cramunho",
			"name": "Cramunho",
			"porcentagem_leitura": 3,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "30",
			"autores": [
				"192e1ce0-0fd5-806b-8c0c-c6b0b051c241"
			],
			"autor": [
				"Davi “Sakkay” Guimarães"
			],
			"insta": "https://www.instagram.com/sakkay.chester/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9494a282-b935-47c3-ae39-f41510bff02a/laosproibidos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=06af32c081c8ebdedc4975512c1e33e910ddae148db60c047ebbf0a0b01c012f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-15T01:37:00.000Z",
			"id": "17ce1ce0-0fd5-80c7-8b35-fb382697ec6d",
			"contadores": [
				"Autores pelo Celular / Mouse"
			],
			"caps_lidos": "3",
			"imagem_name": "laçosproibidos-hq",
			"data_leitura": "2025-01-14",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/lacos-proibidos-o-sacrificio-do-amor",
			"name": "Laços Proibidos: O Sacrifício do Amor",
			"porcentagem_leitura": 15,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "19",
			"autores": [
				"17ce1ce0-0fd5-80b2-bba9-d2185b5082b9"
			],
			"autor": [
				"Mila DN ⭐"
			],
			"insta": "https://www.instagram.com/mila_dn_/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b3a251ed-1ece-4908-a4bf-ce6989b3addb/botequeiros-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=ec6a82ae1bab7172377b7eec83d3cfd2b92a9354d16b4428f1d33b22ae76be28&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T16:37:00.000Z",
			"id": "170e1ce0-0fd5-8037-88d7-d333b77b7f8b",
			"contadores": [
				"Quadrinhos pra se ler no churrasco"
			],
			"caps_lidos": "1",
			"imagem_name": "botequeiros-hq  ",
			"data_leitura": "2024-11-05",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/botequeiros",
			"name": "Botequeiros",
			"porcentagem_leitura": 50,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"16fe1ce0-0fd5-8049-a9c9-d441adac3119"
			],
			"autor": [
				"Darky Jr ⭐"
			],
			"insta": "https://www.instagram.com/bloodyportals",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/25bb03ab-dad5-47dc-bfa2-3ba6a6be4d46/omnistrife-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=be3f381f123c01e9a47a440f5d19b38f20e60b32a75fb450c704b6db2627f2b2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T16:33:00.000Z",
			"id": "170e1ce0-0fd5-80ab-a0c3-ca9a30830da6",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "omnistreife-hq  ",
			"data_leitura": "2024-11-28",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/deus-x-machina",
			"name": "Omni Streife: Deus X Machina",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"d303258b-feaf-467a-85c8-fb32274390c6"
			],
			"autor": [
				"Rafael “Hexverse” Arcucio"
			],
			"insta": "https://www.instagram.com/hexverse.oficial/",
			"tags": "♂️",
			"twitter": "https://twitter.com/NeroHexverse"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/71bc624d-d622-48d0-8e3f-796d699f0264/odiariodeprata-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=3f2c1720112d911a756570dd6b9ee0f166feb6922174e2f651c2104e994f0a80&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T16:28:00.000Z",
			"id": "170e1ce0-0fd5-8019-9cdb-d5b7bc8f3039",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "odiariodeprata-hq  ",
			"data_leitura": "2024-11-12",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/o-diario-de-prata",
			"name": "O Diário de Prata",
			"porcentagem_leitura": 7,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "38",
			"autores": [
				"170e1ce0-0fd5-806c-9f73-f88565370ec5"
			],
			"autor": [
				"Antônio Ruiz ⭐"
			],
			"insta": "https://www.instagram.com/antonruiz_hq/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/26292017-4f47-44a9-88b9-5a130cdb2808/straypigs-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=8dca2c093914e239dd52e19559cf462eb3cae3b2dd7e5ccf820818c85f101cb6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T01:03:00.000Z",
			"id": "170e1ce0-0fd5-8075-9357-f7556b87bcdf",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "straypigs-hq  ",
			"data_leitura": "2024-12-19",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/stray-pigs-1oxp",
			"name": "Stray Pigs",
			"porcentagem_leitura": 9,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "31",
			"autores": [
				"b76e79b9-e1e1-40b7-ae1d-1061e8a97529"
			],
			"autor": [
				"Roberto koga"
			],
			"insta": "https://www.instagram.com/roberto_kogalima/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7b96e267-f161-4270-8cce-d125ce755f7e/brainrootmirage-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=ce9c09788c7c437945773f68f094dfd277469a21df2e65590fd4b1686333c670&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:56:00.000Z",
			"id": "170e1ce0-0fd5-8011-9fd2-f9ce7de53eff",
			"contadores": [
				"Quadrinhos com trilha sonoras indicadas pelo autor",
				"Críticas Sociais Foderosas",
				"Criaturas sobrenaturais"
			],
			"caps_lidos": "1",
			"imagem_name": "brainrootmirage-hq  ",
			"data_leitura": "2024-12-10",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/brainroot-mirage",
			"name": "Brainroot Mirage",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"170e1ce0-0fd5-803e-aae1-d686528b1a64"
			],
			"autor": [
				"Yoru Taiyou"
			],
			"insta": "https://www.instagram.com/taiyouyoru_",
			"tags": "♂️",
			"twitter": "https://x.com/TaiyouYoru"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4f16008e-7c21-4b39-b74f-2b2805e7641e/alcateia-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=7a579ba4fb0da5fd0c8c2ca1d3bb25f091c31d933d7ac75d0d91a0ab7066e00c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:51:00.000Z",
			"id": "170e1ce0-0fd5-80ef-9824-e8cbb85f73c2",
			"contadores": [
				"Criaturas sobrenaturais"
			],
			"caps_lidos": "1",
			"imagem_name": "alcateia-hq  ",
			"data_leitura": "2024-12-08",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/alcateia-ou-a-foto-amaldicoada",
			"name": "Alcatéia",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"170e1ce0-0fd5-80c3-a167-d3492f8cc335"
			],
			"autor": [
				"L Cotrim"
			],
			"insta": "https://www.instagram.com/l.cotrim1993/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1702cdbd-587d-42a0-9d50-d16b57ecb877/haruka-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=0deb0aacc32d635264b0ecb83f3f96b750f5967e4f30b4c39e22fdf6d5a9f1e3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:34:00.000Z",
			"id": "170e1ce0-0fd5-803b-a2d7-cf2a147ed88d",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "haruka-hq  ",
			"data_leitura": "2024-11-30",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": null,
			"name": "Haruka",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"170e1ce0-0fd5-80bc-a14b-db6f3382c1ab"
			],
			"autor": [
				"Carol “Eclética” Hencklein"
			],
			"insta": "https://www.instagram.com/ecleticaleitura/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/abfbf932-994a-4009-9e74-c197232c99f6/arinopaisdasmascaras-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=507304d5fe846cd806e94f830cd8e8bc674bfce3fbf5fa5b359e6da7e49bf0c2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:19:00.000Z",
			"id": "170e1ce0-0fd5-80eb-a8d8-c7503f478c88",
			"contadores": [
				"Protagonistas perdidos"
			],
			"caps_lidos": "1",
			"imagem_name": "arinopaisdasmascaras-hq  ",
			"data_leitura": "2024-11-28",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/ari-e-o-pais-das-mascaras-previa",
			"name": "Ari no país das máscaras",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"7bfaecd8-dba6-4d7f-9659-497c13833690"
			],
			"autor": [
				"L Eklipse ⭐"
			],
			"insta": "https://www.instagram.com/l.eklipse",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9ecda7bd-417f-44f7-a624-fd987bd1573a/foradesi-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=1014bda72dabd117ca25e1e18c9941da7291276760ebd9d66ce8ac0f019dfd74&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:59:00.000Z",
			"id": "16fe1ce0-0fd5-808c-887c-e0deeb343284",
			"contadores": [
				"Uberização"
			],
			"caps_lidos": "1",
			"imagem_name": "foradesi-hq  ",
			"data_leitura": "2024-10-26",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/fora-de-si",
			"name": "Fora de Si",
			"porcentagem_leitura": 25,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"bc0cbfff-b781-42fa-bf31-f7b7c2b3aa82"
			],
			"autor": [
				"Kizolf ⭐"
			],
			"insta": "https://www.instagram.com/kizolf/",
			"tags": "🜬",
			"twitter": "https://twitter.com/kizolf"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f7897361-36c6-4fae-b0e8-32cf51c2d3b9/ochamadolqn-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=1fdc93fa60e90cfd06eae886fc78140e905f3cc24572a67a4caed93175967371&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:50:00.000Z",
			"id": "16fe1ce0-0fd5-80c7-81e2-d1619461f119",
			"contadores": [
				"Quebras de quarta parede"
			],
			"caps_lidos": "1",
			"imagem_name": "ochamadolqn-hq  ",
			"data_leitura": "2024-10-26",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/o-chamado-lqn",
			"name": "O chamado LQN",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"16fe1ce0-0fd5-8049-a9c9-d441adac3119",
				"0a5c4afd-020a-44b9-a061-b46ac5ff9288",
				"223f7dfd-bcca-475d-bcbd-115536c079e9",
				"84b7ce4a-beec-4715-9ab6-778b7bb89853",
				"7b7c421e-4065-4eee-b500-8cc5ad0d9b86",
				"32296dc6-93c4-49e9-8061-b43d35c544d6",
				"68845b7c-7f06-4cd6-9f7b-fd8583164fd9",
				"dc013947-ecd4-4de6-a37f-3aa70d6765ae",
				"16fe1ce0-0fd5-800b-80fa-d883ddbf4e7a",
				"1570fad2-9a0f-4c30-9669-5900ad3649b0",
				"bc0cbfff-b781-42fa-bf31-f7b7c2b3aa82"
			],
			"autor": [
				"Darky Jr ⭐",
				"Bundas Art ⭐",
				"Duhgetsu ⭐",
				"J S Art ⭐",
				"Hanna Mello ⭐",
				"Yzumsm ⭐",
				"Victor M Ilustra ⭐",
				"Ture ⭐",
				"Skyle ⭐",
				"636",
				"Kizolf ⭐"
			],
			"insta": "https://www.instagram.com/bloodyportals",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4882b99c-2989-4545-bd38-46417dfe0c17/nimbus-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=a08713ef7367e53735dc863ec86933e6f79495720b3b5a47a361a50d3c90be31&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:44:00.000Z",
			"id": "16fe1ce0-0fd5-80e7-9e3f-d0bdc4513661",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "nimbus-hq  ",
			"data_leitura": "2024-10-26",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/nimbus-the-rising-storm",
			"name": "Nimbus",
			"porcentagem_leitura": 9,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"16fe1ce0-0fd5-800b-80fa-d883ddbf4e7a"
			],
			"autor": [
				"Skyle ⭐"
			],
			"insta": "https://www.instagram.com/skyle_oc/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7efe2e42-911e-4277-8ffe-9dc217f8c3d0/caramelorex-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=ea8c27f53fb360da8106dc54a5f23b24d9afb7756d26bb6c45a58be79ce85cd2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:32:00.000Z",
			"id": "16fe1ce0-0fd5-8051-b26e-dabd5b755325",
			"contadores": [
				"Melhores Sinopses",
				"Energia",
				"Power System",
				"parece que você andou treinando desde a ultima vez que nos encontramos",
				"Transformações"
			],
			"caps_lidos": "1",
			"imagem_name": "caramelorex-hq  ",
			"data_leitura": "2024-10-26",
			"genero": [
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/caramelo-rex",
			"name": "Caramelo Rex",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"223f7dfd-bcca-475d-bcbd-115536c079e9"
			],
			"autor": [
				"Duhgetsu ⭐"
			],
			"insta": "https://www.instagram.com/duhgetsu/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Duhgetsu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5e32108f-bf6f-41b5-8fd2-99a043a54970/lockedoutofhell-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=cc9763fbb48775640a7bb9d389b2f3378dd8c8007b899a4619b00a6e16c7a3c7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T01:03:00.000Z",
			"id": "13be1ce0-0fd5-80e1-b394-f602da84ddbd",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "lockedoutofhell-hq  ",
			"data_leitura": "2024-11-07",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/locked-out-of-hell-36se",
			"name": "Locked Out of Hell",
			"porcentagem_leitura": 33,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"13be1ce0-0fd5-8000-9fbd-e7aff4304658"
			],
			"autor": [
				"L1nkUwu"
			],
			"insta": "https://www.instagram.com/l1nkuwu/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4343bfb0-b0d4-46b5-a550-e0980404dafe/ovoluntario-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=d7dbfef63bbef50fd723f1f2e648a2f961640d6404b7392898b35e6853d09aa1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T00:52:00.000Z",
			"id": "13be1ce0-0fd5-80e8-b151-fc4a78afe574",
			"contadores": [
				"Quadrinhos conhecidos por um nome que não é o nome dele",
				"Melhores Sinopses",
				"Brasil Alternativo",
				"Hehe",
				"Apocalipses Brasileiros",
				"Críticas Sociais Foderosas",
				"Azulzinho Gostoso"
			],
			"caps_lidos": "1",
			"imagem_name": "ovoluntario-hq  ",
			"data_leitura": "2024-11-03",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/o-voluntario",
			"name": "O Voluntário",
			"porcentagem_leitura": 25,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"13be1ce0-0fd5-80ba-93c6-f2afc39051c0"
			],
			"autor": [
				"Miguel Kurse"
			],
			"insta": "https://www.instagram.com/miguelfilter/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7b4bc67c-1b93-4832-b91e-b284cfca1d6d/kellyyoungcreepy-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=3a83623f6db7dcc16fdc909bdf7d525be9beeb2937ebacc6ba5451a15957c1f6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T00:46:00.000Z",
			"id": "13be1ce0-0fd5-80a1-8ed3-fdcbe093e962",
			"contadores": [
				"Criaturas sobrenaturais",
				"Cenas na Chuva"
			],
			"caps_lidos": "1",
			"imagem_name": "kellyyoungcreepy-hq  ",
			"data_leitura": "2024-10-31",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/creepy",
			"name": "Kelly Young - Creepy",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"8653e55c-4480-4d10-b294-f9ac267c8447"
			],
			"autor": [
				"GringoComics ⭐"
			],
			"insta": "https://www.instagram.com/gringocomics_insta/",
			"tags": "♂️",
			"twitter": "https://twitter.com/gringoscomics"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/dded8a16-f00b-48c2-a155-751a516ddbbf/impiedoso-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=eef675ee06a1404d79cc19ab8d33ff2b23d0e461d52d1422961ddbe47b76220d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T00:44:00.000Z",
			"id": "13be1ce0-0fd5-80c0-a676-d006ceeb48a2",
			"contadores": [],
			"caps_lidos": "6",
			"imagem_name": "impiedoso-hq  ",
			"data_leitura": "2024-10-31",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": null,
			"name": "Impiedoso",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"b8b710a2-aaa7-49ce-b645-9fb53496e4c9",
				"dbf63566-b2be-49d7-ba35-d5bffd16e9ec"
			],
			"autor": [
				"Michel Costa ⭐",
				"Lucas Rennó ⭐"
			],
			"insta": "https://www.instagram.com/mimscosara/",
			"tags": "♂️",
			"twitter": "https://twitter.com/mimscosara"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8bf8eae4-5e65-4045-a5aa-1b242d2f4c2e/nobicodurubu-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=686f7b485ae41d4b5f40c6e59871092a32dea85286f46e04a10cb16a49744f57&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T00:33:00.000Z",
			"id": "13be1ce0-0fd5-8054-a615-db7be429fb73",
			"contadores": [
				"Duplinhas do Barulho",
				"Sacolé"
			],
			"caps_lidos": "3",
			"imagem_name": "nobicodurubu-hq  ",
			"data_leitura": "2024-10-24",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/no-bico-durubu-xzln",
			"name": "No Bico D’urubu",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"13be1ce0-0fd5-809b-9a74-ddbfa6327c2c"
			],
			"autor": [
				"Gabzzz"
			],
			"insta": "https://www.instagram.com/gabs.gabs.gabzzz/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fd2bceaf-3c60-47db-a1d6-ec108e5b10c1/gigantesdeoutromundo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=ff7bf909cea7d35ddb5d48164f586f926bfaba15c54ea411a308a4b5e76de831&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-20T22:26:00.000Z",
			"id": "125e1ce0-0fd5-8042-96b4-e6194749aa4d",
			"contadores": [],
			"caps_lidos": "8",
			"imagem_name": "gigantesdeoutromundo-hq",
			"data_leitura": "2024-10-17",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/coletanea-gigantes-de-outro-mundo-vpqj",
			"name": "Coletânea: Gigantes de Outro Mundo",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "8",
			"autores": [
				"b76e79b9-e1e1-40b7-ae1d-1061e8a97529",
				"125e1ce0-0fd5-80f8-89a1-f8c26caab191",
				"125e1ce0-0fd5-8095-a200-fc787c02e357",
				"125e1ce0-0fd5-80fb-96b5-c1f022a4784c",
				"45b07f79-970e-4a9e-903c-0c99068250b4",
				"d5181c07-657d-4ccd-bddc-0f963644a27b",
				"36b54fc7-4aee-4aee-b9ef-21a08fd14664",
				"9248f707-2513-4387-ba94-fb571a336ce0",
				"4cfd6e03-2f49-4d90-bdd2-df4e8bde2ec4",
				"7bfaecd8-dba6-4d7f-9659-497c13833690"
			],
			"autor": [
				"Roberto koga",
				"Priscila Bernardo",
				"Athus Daniel",
				"Dan Helhundaz",
				"Buga Arts ⭐",
				"Minervini ⭐",
				"LetyCorujapa",
				"Millie ⭐",
				"Bulho",
				"L Eklipse ⭐"
			],
			"insta": "https://www.instagram.com/roberto_kogalima/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/93b173a7-88eb-4d8b-961f-0dcd0f4190a4/lendasamazonicas-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=aa9d3830217920f76f5e11930c97d400172132e20cd9b9a9e48a4d300fbbcf86&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-18T00:23:00.000Z",
			"id": "123e1ce0-0fd5-80e2-8f0f-d7044f4dd4dc",
			"contadores": [
				"Aparições do Jeje",
				"Linguagem Nativa"
			],
			"caps_lidos": "3",
			"imagem_name": "lendasamazonicas-hq  ",
			"data_leitura": "2024-10-15",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/lendas-amazonicas-por-heliton-mota-atayde",
			"name": "Lendas Amazônicas",
			"porcentagem_leitura": 42,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"123e1ce0-0fd5-80b6-b2fe-c5b531817efb"
			],
			"autor": [
				"Heliton Mota"
			],
			"insta": "https://www.instagram.com/heliton_mota_atayde/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c76fda43-de4b-4373-a4fc-267db4c99dda/potentiaorigin-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=4a8f557216e6e4a05428e74d42185b5a6840f00653f6c1d4108d4bba8bd259a2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-18T00:05:00.000Z",
			"id": "123e1ce0-0fd5-8038-8fd5-d9167801ac65",
			"contadores": [
				"Vestidos",
				"Cabelos Estilosos",
				"Vilões",
				"parece que você andou treinando desde a ultima vez que nos encontramos",
				"Azulzinho Gostoso",
				"Noitadas",
				"Episódio de Praia",
				"Ruivinhos Metidos",
				"Desenhistas"
			],
			"caps_lidos": "3",
			"imagem_name": "potentiaorigin-hq  ",
			"data_leitura": "2024-10-13",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/potentia-origin",
			"name": "Potentia: Origin",
			"porcentagem_leitura": 8,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "34",
			"autores": [
				"dd110086-2650-43b7-822f-e0b70ce2656e"
			],
			"autor": [
				"Yel Mizuno"
			],
			"insta": "https://www.instagram.com/yelmizuno/",
			"tags": "♀️",
			"twitter": "https://twitter.com/mizunoyel"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/46ebd02d-d245-43d0-b52d-e868303bfba5/willowitch-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=d556cdea0cebffdfc2e1f82a7fd783e5e6940db11af8921b68174f9181a1a496&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-04T00:12:00.000Z",
			"id": "115e1ce0-0fd5-806d-a507-e40ade9eeacd",
			"contadores": [
				"Bruxas",
				"Ordem Religiosas",
				"Segundas Chances"
			],
			"caps_lidos": "1",
			"imagem_name": "willowitch-hq",
			"data_leitura": "2024-10-03",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/will-o-witch-48j7",
			"name": "Will-O’-Witch",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"115e1ce0-0fd5-80d0-bc85-c7d23fda9967"
			],
			"autor": [
				"Abrakuxas ⭐"
			],
			"insta": "https://www.instagram.com/abrakuxas/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/eb62fd24-d251-427c-a143-5eadcdc99767/nospaceforus-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=5d75918e09b1473749c0f4b9413a6d564f4c62391204d2103cb2c6db6e959efd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-04T00:09:00.000Z",
			"id": "115e1ce0-0fd5-8066-83a1-ffd37bdee223",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "nospaceforus-hq  ",
			"data_leitura": "2024-10-03",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/No-Space-For-Us/info",
			"name": "No Space For Us",
			"porcentagem_leitura": 9,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"115e1ce0-0fd5-8054-a517-d80018b88210"
			],
			"autor": [
				"Gabriela Paciulo"
			],
			"insta": "https://www.instagram.com/paciulo/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/518091b5-3fc4-4d1c-9fb3-020bfef3bebf/byebyebunny-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=0136c7f7d83466d263349ff25ae0d3e10a4c64a6989fcde53a53876950d03c7e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-04T00:03:00.000Z",
			"id": "115e1ce0-0fd5-80b7-ad94-cc30899b9e20",
			"contadores": [
				"Alices"
			],
			"caps_lidos": "1",
			"imagem_name": "byebyebunny-hq  ",
			"data_leitura": "2024-10-03",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/byebyebunny/info",
			"name": "Bye Bye Bunny",
			"porcentagem_leitura": 16,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"114e1ce0-0fd5-8093-b9f2-ff24e20c056d"
			],
			"autor": [
				"Hyoguera"
			],
			"insta": "https://www.instagram.com/hyoguera/",
			"tags": "♂️",
			"twitter": "https://www.twitter.com/hyogoborges"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7baed237-49d3-4a39-b412-fc562f097b44/bloodgriffin-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=25de4a98a05f35eda321ef7701a6a155633e8abff6beaccdb0fe892b198710c3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-09-29T18:57:00.000Z",
			"id": "110e1ce0-0fd5-80e2-8ba1-c888b76f4ea7",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "bloodgriffin-hq  ",
			"data_leitura": "2024-09-26",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/blood-griffin-atgv/",
			"name": "Blood Griffin",
			"porcentagem_leitura": 6,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "16",
			"autores": [
				"110e1ce0-0fd5-8099-832c-f22ba5c9b43e",
				"110e1ce0-0fd5-80dc-8574-c9dcb15abe3c"
			],
			"autor": [
				"Sir Ysak",
				"Sir Gawain"
			],
			"insta": "https://www.instagram.com/sir.ysaki/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/88fa7a1b-db21-430f-b42c-dc5a876f944d/livingthemoment-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=c7489fefa589b6826cb86e1c35e7f6af78d46f7d4eab3861cc372ea102b38af1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-09-29T18:53:00.000Z",
			"id": "110e1ce0-0fd5-807d-94fa-c747e3e75690",
			"contadores": [
				"Ida na diretoria",
				"LQN Aparecendo em Quadrinhos Nacionais",
				"Cenas na Cama"
			],
			"caps_lidos": "1",
			"imagem_name": "livingthemoment-hq  ",
			"data_leitura": "2024-09-22",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/living-in-the-moment",
			"name": "Living the Moment",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"32296dc6-93c4-49e9-8061-b43d35c544d6"
			],
			"autor": [
				"Yzumsm ⭐"
			],
			"insta": "https://www.instagram.com/yzumsm",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/43e35b3c-6084-456e-aed0-f07c18813918/tudoaotempo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=a5bdb315cfae30af1898150b37286d546437ec6e92f16e07315c06f917836389&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-09-16T02:43:00.000Z",
			"id": "103e1ce0-0fd5-80c9-b507-e3c392f3a436",
			"contadores": [
				"Bullies"
			],
			"caps_lidos": "2",
			"imagem_name": "tudoaotempo-hq  ",
			"data_leitura": "2024-09-15",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/tudo-ao-tempo",
			"name": "Tudo ao Tempo",
			"porcentagem_leitura": 5,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "39",
			"autores": [
				"103e1ce0-0fd5-800e-8227-e279d59de29c"
			],
			"autor": [
				"Bibisavi"
			],
			"insta": "https://www.instagram.com/bibivs1221/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6a34297d-fd7e-43e9-98d5-781bcb12dcb4/tiamat-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=3d02e39d3c4afd75bbaa00839fed8cf34cd290c118cdfaff629ff870cbb21071&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-09-05T23:22:00.000Z",
			"id": "72f3f906-9719-4068-910e-81de91c44a55",
			"contadores": [
				"Mamães Fodas"
			],
			"caps_lidos": "4",
			"imagem_name": "tiamat-hq  ",
			"data_leitura": "2024-09-05",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "+18",
					"color": "red"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/origens-tiamat-a-rainha-dos-dragoes",
			"name": "Tiamat",
			"porcentagem_leitura": 12,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "33",
			"autores": [
				"84b7ce4a-beec-4715-9ab6-778b7bb89853"
			],
			"autor": [
				"J S Art ⭐"
			],
			"insta": "https://www.instagram.com/j.s.art_/",
			"tags": "♂️",
			"twitter": "https://twitter.com/JSArt12"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bd8094e7-5214-41de-b4c4-ccb357b31d4c/contosdecinderella-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=cf8b3b8c8d72bbb86d552b29910de4bee782c69704c75b59ce49510a2c013a0f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-09-05T23:19:00.000Z",
			"id": "a5aa737b-f597-4a89-a61c-56c0af041970",
			"contadores": [
				"Melhores Sinopses",
				"Squad Goals",
				"Beijocas",
				"Casos de Familia"
			],
			"caps_lidos": "3",
			"imagem_name": "contosdecinderella-hq  ",
			"data_leitura": "2024-09-01",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/contos-de-cinderella",
			"name": "Contos de Cinderella",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"ec8ced61-4b99-427b-a993-f43d1123617c"
			],
			"autor": [
				"Rafael Lima ⭐"
			],
			"insta": "https://www.instagram.com/rafalima831/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/52652032-ef8e-4b72-a9f8-6ddbdc02295b/iwannabegod-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=567f446d38cf0fdbc400cf9a9bf5452ab9018a50a5452ee315227f81ca5a357b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-29T23:12:00.000Z",
			"id": "42e667a4-d6cb-4acf-aa03-bdde4d2368be",
			"contadores": [
				"Quadrinhos conhecidos por um nome que não é o nome dele",
				"Alices"
			],
			"caps_lidos": "1",
			"imagem_name": "iwannabegod-hq  ",
			"data_leitura": "2024-08-29",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Shonen",
					"color": "red"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/i-wanna-be-god",
			"name": "I Wanna Be God",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"feecc179-8e29-4967-9452-c992f8fbeb91"
			],
			"autor": [
				"Raphael HHS ⭐"
			],
			"insta": "https://www.instagram.com/raphaelhhs/",
			"tags": "♂️",
			"twitter": "https://twitter.com/RaphaelHhs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4d98e9c1-b4da-474b-b489-24bbb4988994/razor-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=0bec78032d1ab1d3c7686b3689a776294d9d2317c66c4a1ae01286dda2a5aea7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-25T23:20:00.000Z",
			"id": "86199f5d-6800-4a38-9a50-e6013ab409f3",
			"contadores": [
				"Logos",
				"Drift",
				"Balões diferenciados",
				"Duplinhas do Barulho",
				"Golpes bem aplicados"
			],
			"caps_lidos": "1",
			"imagem_name": "razor-hq  ",
			"data_leitura": "2024-08-22",
			"genero": [
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/razor-12hy",
			"name": "Razor",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"681feb2e-2b51-49ce-b705-47413e971ec2",
				"68abf776-b951-4b4d-ac5d-4f660086621a"
			],
			"autor": [
				"Mouch ⭐",
				"Jayson Santos"
			],
			"insta": "https://www.instagram.com/mouch_ch/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b2b82fb3-5748-4f0b-80a2-7f2b5098f7ff/aturacamuira-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=5202dad24bc73b6a8c27630a176122f62588fdb587d77d789dd498d279218bb3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-25T23:13:00.000Z",
			"id": "a94ee5d3-90a2-4d10-9ad1-ff0ff87f02e7",
			"contadores": [
				"Melhores Sinopses",
				"Caolhos"
			],
			"caps_lidos": "2",
			"imagem_name": "aturacaimura-hq  ",
			"data_leitura": "2024-08-22",
			"genero": [
				{
					"name": "Shoujo",
					"color": "pink"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/atura-camuira-a-olho-da-morte-j1ah",
			"name": "Atura Caimurá - A Olho da Morte",
			"porcentagem_leitura": 18,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"d6d82d6d-545b-4c91-bc9c-185536159c48"
			],
			"autor": [
				"Evaristo Ramos ⭐"
			],
			"insta": "https://www.instagram.com/_evaristoramos/",
			"tags": "♂️",
			"twitter": "https://x.com/evaristorart"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7db6d69f-6bdf-45bd-a727-d101eba773dd/appleparadise-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=5144043319c111c41b776fc0a890ec746c63fa9eec822c3664a7cf79c5cfdfd1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-25T23:01:00.000Z",
			"id": "a29a53a7-aafe-42b3-91d7-bb8b17cbd508",
			"contadores": [
				"Coisas no olho",
				"Pactos",
				"Energia"
			],
			"caps_lidos": "3",
			"imagem_name": "appleparadise-hq  ",
			"data_leitura": "2024-08-18",
			"genero": [
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": null,
			"name": "Apple Paradise",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"aaad16e0-54a5-471b-b649-8c8c7446b211"
			],
			"autor": [
				"Gaboy ⭐"
			],
			"insta": null,
			"tags": "♂️",
			"twitter": "https://x.com/gabsfromAP"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/92f30100-c52f-4e43-947c-14956bffc242/penitente-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=fa17c478ec960697366fa9a252373226116d5f33496bbdb56117e2e495147ed8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-25T22:54:00.000Z",
			"id": "17cca0bb-0dec-4f98-ad89-c04ac2eb71c1",
			"contadores": [
				"Entradas fodas",
				"Jarras em formato de abacaxi",
				"Aparições do Jeje",
				"Natalinos"
			],
			"caps_lidos": "1",
			"imagem_name": "penitente-hq  ",
			"data_leitura": "2024-08-15",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "http://www.lordelobo.com.br/penitente/revista/PNTT_001/01.htm",
			"name": "Penitente",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"b9a6203d-29a9-481a-babf-1406a4c69130"
			],
			"autor": [
				"Lorde Lobo"
			],
			"insta": "https://www.instagram.com/lorde_lobo/",
			"tags": "♂️",
			"twitter": "https://x.com/lordelobo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6ec1363b-af6a-4400-acfa-54d0527d5d0b/comofazeramigoseenfrentarfantasmas-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=ff514563fa03a0342d2d27b2186420f5ed9e41c2ed206d735fbb50ea13e57544&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-25T22:50:00.000Z",
			"id": "ab2f8fc7-617d-4910-9d0f-0fa6369ef182",
			"contadores": [
				"Jarras em formato de abacaxi"
			],
			"caps_lidos": "1",
			"imagem_name": "comofazeramigoseenfrentarfantasmas-hq  ",
			"data_leitura": "2024-08-15",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": "https://www.peleias.com.br/product-page/como-fazer-amigos-e-enfrentar-fantasmas",
			"link_leitura": "https://www.peleias.com.br/product-page/como-fazer-amigos-e-enfrentar-fantasmas",
			"name": "Como Fazer Amigos e Enfrentar Fantasmas",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"5984fc32-f3f3-4ca2-85f6-cbbb9e0f7f90",
				"42b27be0-320b-4397-859a-d5a6fbc791f1"
			],
			"autor": [
				"Eric Peleias",
				"Gustavo Borges"
			],
			"insta": "https://www.instagram.com/ericpeleias/",
			"tags": "♂️",
			"twitter": "https://x.com/EricPeleias"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/480c2591-9cc5-432a-b6ca-50edb9d7f6c6/inbetween-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=4cd101e877d5a415934bc871f7c67680f55fca4f3ca233cd5b79499b226f955e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-08T21:06:00.000Z",
			"id": "7a75dc99-2390-420f-9f0a-f6bf40f9a0c6",
			"contadores": [
				"Inícios mitológicos",
				"Mamães Fodas"
			],
			"caps_lidos": "1",
			"imagem_name": "inbetween-hq  ",
			"data_leitura": "2024-08-01T20:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/in-between-a-lenda-do-principe",
			"name": "In Between",
			"porcentagem_leitura": 11,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"cce60cfc-446d-46bd-b9b8-aef611f664f3"
			],
			"autor": [
				"Guilherme Dias"
			],
			"insta": "https://www.instagram.com/ilustreguilherme/",
			"tags": "♂️",
			"twitter": "https://x.com/ilustre_gui"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9e4884c6-39eb-405e-8722-9ac5b77f0cd5/redghost-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=44bc3bfd03621e824f0b0faaa4b0c6eb9e3a2f3dcdcaf9d192947b33321e30c5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-08T21:05:00.000Z",
			"id": "b0367733-af29-4113-8dfc-e6ffb79e5a3c",
			"contadores": [
				"Veículos Bolados"
			],
			"caps_lidos": "1",
			"imagem_name": "redghost-hq  ",
			"data_leitura": "2024-08-01T21:00:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Shonen",
					"color": "red"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/redghost-4bby",
			"name": "Red Ghost",
			"porcentagem_leitura": 25,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"0fce9ad5-6a3f-4a79-8cb4-ccbbfafd05e1"
			],
			"autor": [
				"Yanagawa"
			],
			"insta": "https://www.instagram.com/yanagawa_masashi/",
			"tags": "♂️",
			"twitter": "https://x.com/GawaYana"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bacd5042-d23b-477e-88e9-cc228ea9be14/tamers-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=3f5b5d0485ed0081c8901b288af6acbd63cad4d19aef160cd413f0d8054fad3d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-25T18:49:00.000Z",
			"id": "ef5a29a0-c598-4f55-8e3b-c3e95673682d",
			"contadores": [
				"Ovo"
			],
			"caps_lidos": "1",
			"imagem_name": "tamers-hq  ",
			"data_leitura": "2024-07-21",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://swmangas.com/capitulos/tamers-01-parte-01/",
			"name": "Tamers",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"dadefabc-351f-488a-b535-c82dbcb47f9c",
				"a62ad15d-1a0a-4636-a309-589f7ae38c31"
			],
			"autor": [
				"Matheus Avanco",
				"Eruru Comics"
			],
			"insta": "https://www.instagram.com/mateusu_muto/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c9ce6aaa-cf91-47f2-803e-d1552476704b/jonasoquasemago-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=98f518431328264aaf771239fc0031468721d789686b9f6a85c9b91fdb476200&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-25T18:45:00.000Z",
			"id": "2436fab4-4346-4401-bac8-f96336b28df0",
			"contadores": [
				"Críticas Sociais Foderosas"
			],
			"caps_lidos": "1",
			"imagem_name": "jonasoquasemago-hq  ",
			"data_leitura": "2024-07-21",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://swmangas.com/capitulos/jonas-o-quase-mago/",
			"name": "Jonas o Quase Mago",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"8d2bf7de-7c24-4245-91a7-c820c1f56ff6"
			],
			"autor": [
				"Vitor Bardo ⭐"
			],
			"insta": "https://www.instagram.com/vbardoarts/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bf5eab51-7d83-4257-8ef2-fbee3178c579/larvas-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=6286c2f3a79cf2262c7029d4c53e1b9aabe0acd3d8b3bded4d29108a85db0cdd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-15T01:30:00.000Z",
			"id": "b654bda0-baec-41c7-97c0-aae86150e79d",
			"contadores": [
				"Youtubers",
				"Comidas aconchegantes",
				"Vilões",
				"Monstros Além da Compreensão",
				"Aparições do Jeje",
				"Beijocas"
			],
			"caps_lidos": "3",
			"imagem_name": "larvas-hq  ",
			"data_leitura": "2024-07-14",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/larvas-5the",
			"name": "Larvas",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"ec8ced61-4b99-427b-a993-f43d1123617c"
			],
			"autor": [
				"Rafael Lima ⭐"
			],
			"insta": "https://www.instagram.com/rafalima831/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8d64ca4a-9c88-44f5-824e-08db81db9f20/amalgama-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=05ded97d7144a761a391149d22ee3cf937bd9cc275e2d2ed0789cbbdf6da5e5b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-12T02:30:00.000Z",
			"id": "bc68c49e-8609-4923-9d9f-22d9051bdb21",
			"contadores": [
				"Folclóre Brasileiro",
				"Questões Religiosas",
				"Canalhas também envelhecem",
				"Vilões",
				"Botecos",
				"Crias",
				"Beijocas",
				"Criaturas sobrenaturais",
				"Pais Fodas",
				"Quadrinhos conhecidos por um nome que não é o nome dele",
				"Broly",
				"Cobras Gigantes",
				"Wikiman/Palestrinha"
			],
			"caps_lidos": "8",
			"imagem_name": "amalgama-hq  ",
			"data_leitura": "2024-07-11",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/amalgama",
			"name": "Amálgama",
			"porcentagem_leitura": 57,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "14",
			"autores": [
				"17f1a340-4ba6-4079-a58b-d4409e49663f"
			],
			"autor": [
				"Fred Moreatti ⭐"
			],
			"insta": "https://www.instagram.com/lordmoreatti/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/946fca78-f6a8-4d81-8c1a-a390ecd385a6/macacadas-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=72f7edb03ccbe1890b43fa15c47e7d0ceda401d8e10eddd3831f6dec85390d18&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-07T21:15:00.000Z",
			"id": "e4e45844-56fa-4528-8666-612cd44cedad",
			"contadores": [
				"Astros Celestes com carinhas",
				"Noitadas",
				"LQN Aparecendo em Quadrinhos Nacionais",
				"parece que você andou treinando desde a ultima vez que nos encontramos",
				"Time 7"
			],
			"caps_lidos": "14",
			"imagem_name": "macacadas-hq  ",
			"data_leitura": "2024-07-04",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/macacadas-75zc",
			"name": "Macacadas",
			"porcentagem_leitura": 87,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "16",
			"autores": [
				"68845b7c-7f06-4cd6-9f7b-fd8583164fd9"
			],
			"autor": [
				"Victor M Ilustra ⭐"
			],
			"insta": "https://www.instagram.com/victor_m_ilustra/",
			"tags": "♂️",
			"twitter": "https://x.com/Victor_M_sketch"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fc35de3c-71d2-4724-8deb-3390b6c7ac4f/aordemdeavalon-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=7a1565d8788d62e8ee8dd41cdce36baacca39631c32f76f6f9affff8e00ce0aa&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-27T22:18:00.000Z",
			"id": "37606a8a-344b-48ef-ad02-6ef1579c3500",
			"contadores": [
				"Lendas Arturianas",
				"Calvos",
				"Começos JRPGlike",
				"No Shape",
				"Mulheres Bombadas",
				"Mulheres Fodas",
				"Hehe",
				"Desenhistas",
				"Heterofobia nos olhos",
				"Broly"
			],
			"caps_lidos": "3",
			"imagem_name": "aordemdeavalon-hq  ",
			"data_leitura": "2024-06-27",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/A-Ordem-de-Avalon/info",
			"name": "A Ordem de Avalon",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"c89ad8e4-19b8-4146-a125-a9aa48e2198f"
			],
			"autor": [
				"Mau Clemente ⭐"
			],
			"insta": "https://www.instagram.com/mau_clemente_arts/",
			"tags": "♂️",
			"twitter": "https://x.com/MauClementeArts"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/572b1df6-204a-41fc-bb73-96ee3b9e67bd/amon-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=cf259d66dfda3426cc0a2bdfc29b34b0968755e4bac251cfaad1670c06da7e36&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-23T21:02:00.000Z",
			"id": "6d134d6e-f741-44e9-b7ed-943a14d6a1fb",
			"contadores": [
				"Bigodudos",
				"Taberneiros carecas",
				"Calvos"
			],
			"caps_lidos": "3",
			"imagem_name": "amon-hq  ",
			"data_leitura": "2024-06-20",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/amon",
			"name": "Amon",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"d2934e44-0f42-44b6-b42c-3bba147b2c4b"
			],
			"autor": [
				"Gustavo Colman ⭐"
			],
			"insta": "https://www.instagram.com/gugacolman",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/dc70896f-737a-4a48-ae0c-3427f0216599/prolasarcanas-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=c48528140b2fa692fdb965fc9976b3e95c1211a59c19fe8c9e469d14439c2f14&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-17T02:12:00.000Z",
			"id": "faf5f79f-c223-49c6-b9cb-f8e949438518",
			"contadores": [
				"Bigodudos",
				"Personagens com poderes elétricos",
				"Beijocas",
				"Calvos",
				"Famosos",
				"Broly",
				"Transformações",
				"Entradas fodas"
			],
			"caps_lidos": "15",
			"imagem_name": "pérolasarcanas-hq",
			"data_leitura": "2024-06-16",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/perolas-arcanas-formato-webtoon",
			"name": "Pérolas Arcanas",
			"porcentagem_leitura": 65,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "23",
			"autores": [
				"b34e152b-0055-4e00-8399-e06cb303d0dd"
			],
			"autor": [
				"Leonardo Gomes ⭐"
			],
			"insta": "https://www.instagram.com/leonardogomes4908/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/04584d9a-1a5e-4ddb-a47a-ca9d961dfa7a/junhonaojuno-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=fc2c5053ad65063c8e145c0ca0169f37258808b6305bc39d75e50b367c9d0c32&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-13T22:04:00.000Z",
			"id": "40e9af8f-7ce5-470b-bcfd-720cdeb03728",
			"contadores": [
				"Haters to Lovers",
				"Escolas que ninguem tem aula de verdade",
				"Azulzinho Gostoso",
				"Cenas na Chuva"
			],
			"caps_lidos": "3",
			"imagem_name": "junhonaoéjuno-hq  ",
			"data_leitura": "2024-06-13",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Shoujo",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/junho-nao-e-juno",
			"name": "Junho Não é Juno",
			"porcentagem_leitura": 37,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "8",
			"autores": [
				"d83b09b3-1e12-4427-9643-7423c0a44ce2"
			],
			"autor": [
				"Alienyando ⭐"
			],
			"insta": "https://www.instagram.com/alienyando",
			"tags": "♀️",
			"twitter": "https://x.com/Alienyando"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cf5d6f07-3ba9-4621-892b-b8f91766efd9/sobosoldehelena-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=e61f6d6169430e4281493291436ebdb14bc6c894c27f79d3c580d6dafb66943e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-13T22:02:00.000Z",
			"id": "dd6fbf1e-23a3-43f6-b6aa-0e42475d3bc7",
			"contadores": [
				"Sonhadores",
				"Autores pelo Celular / Mouse"
			],
			"caps_lidos": "1",
			"imagem_name": "sobosoldehelena-hq  ",
			"data_leitura": "2024-06-13",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/sob-o-sol-de-helena",
			"name": "Sob o Sol de Helena",
			"porcentagem_leitura": 33,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"4d1aa834-8934-48b9-9181-d3a3a1fefc8b"
			],
			"autor": [
				"Niane"
			],
			"insta": "https://www.instagram.com/_nianee/",
			"tags": "♀️",
			"twitter": "https://x.com/_Nianee"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e5ff1f7d-4a2d-4c35-a11e-6e73e480aabc/etheryum-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=3df4a4386fd45533b38ca9a25bf4b20b811c7f61d44f4f103701f1fd3d60b807&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-09T22:38:00.000Z",
			"id": "f0e4b5bf-a033-492c-be48-b0b6a53059fe",
			"contadores": [
				"Idosos sendo agredidos"
			],
			"caps_lidos": "1",
			"imagem_name": "etheryum-hq  ",
			"data_leitura": "2024-06-09T21:00:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/etheryum-va0q",
			"name": "Etheryum",
			"porcentagem_leitura": 6,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "15",
			"autores": [
				"b4ebc8da-f313-4719-8f75-56d0d0d4944c"
			],
			"autor": [
				"Kaiser Estudio ⭐"
			],
			"insta": "https://www.instagram.com/kaiserestudio/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/961a9950-f7d0-4d39-bcea-fdb415e39c18/apervertidaeovirtuoso-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232847Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=86d502d89d87524753462fb839f42c58b314cfd690aef07c0662c0921f28ba1b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-06T23:50:00.000Z",
			"id": "7ee95af4-ded0-46d9-891f-0e4cbca7de4d",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"Respeitador"
			],
			"caps_lidos": "3",
			"imagem_name": "apervertidaeovirtuoso-hq  ",
			"data_leitura": "2024-06-06",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-pervertida-e-o-virtuoso?origin=lqn",
			"name": "A pervertida e o Virtuoso",
			"porcentagem_leitura": 33,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"8f7b6008-0ffe-4fe5-aa44-b1f2486b2282"
			],
			"autor": [
				"Gonçalo-sensei"
			],
			"insta": "https://www.instagram.com/goncalo.sensei/",
			"tags": "♂️",
			"twitter": "https://x.com/GnascimentoSamy"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/74dc93db-33b7-4c6b-a15c-d70ec2835dc8/mortisweb-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=54b988cf0c6292c0743b7fd6ac5fce8f8f5f8ab00a5def3531cd32316dbdabb3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-05-16T21:27:00.000Z",
			"id": "cfec0b27-9ef0-46af-9737-0ef2ecbc7de7",
			"contadores": [
				"Gore"
			],
			"caps_lidos": "1",
			"imagem_name": "mortisweb-hq  ",
			"data_leitura": "2024-05-16",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/mortisweb",
			"name": "MORTIS.web",
			"porcentagem_leitura": 33,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"e4b27ba0-1807-46bd-876a-e88b0b44d080",
				"85ecaba3-0539-4684-9a3c-dd69fd90522d"
			],
			"autor": [
				"Steven Constant ⭐",
				"Edgar Clemente ⭐"
			],
			"insta": "https://www.instagram.com/steven_constant42/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8f4b9468-cc89-48db-b91c-ad5ba59ed25a/persefone-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466WGW3NOMZ%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232848Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCpMMXbSZudBirNMuHkbCE5wpubCGS2TscvapPmoKeooQIhANSsRtDVcPrn1hKz%2F0T1f4%2Fi1kPpyavXHVPcC9f0ATDsKogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1Igy4NB%2BNtfh1%2BdtU9JAq3APzPuPXAna%2FfB9NlJ%2BNoK57Z5xYTdEEOPTXlsp0A9bUx0F3YQBVc3x%2BlrWw9grE9WbqY6BjM4cdFZ43Ab%2F10GoShAXQle9V38QQPIpO0ROMNpJP62%2FNma3VoQMs%2Fl44uTGxkXo6VPxpeuVF2ofS%2BQsCp6XjHq4XwYJgZ9ZxCgPgSwmBUK67RNYs%2Fkwrt8IyXHuKvQkllAM3w0dU70iY7zNSfgtxOQCjC97EuBkYOMqmqg4u0nNmfhKVReHnrPlFDoyDSuSGRbSJnHstIUcf9LMzODcrJ%2BZ58nvix6QkfndKsm9yVdn84hEZ4uxG8MPrc%2BUrphfvxLTcy86%2FT%2F1eOR23cifT%2BYgaRUOJJaT0eYesSMy895q8ApDULt3E7OxAgBWiN3lxx3WerM9xh7v9siuJtijgAoCG01AZYrXfqIu9dINZHzXszxC0CC5y0fBFyJCiAH3ZrSQ0lpprmGCdqKVGctt7Ejgaf2Ge57a82YmMn0CuPmActOq4BMrlpTX0ZwJB6xM0mSPrGeEW0B10SS8kxvLZBpRQJHrUDYAkHU7oYsP0gMKmLwOPEzW3dkdeBtcfRr%2FYiex%2BwjFVcsPnNPeYwRFgsk12tKT%2BYaNSbW2tZHZLMN1kBxSVKTcz6DDAuKu%2FBjqkARhRHsw20ZptnDxsc7CQyU72VCahPmlLlwt5BD9s%2BEU88ecpybgt%2FStJV%2BTE4tmS7ytYAmOcBpanyUNju7dweQZ3fiqrFQdW7mMD8uKpGkWei8eVsQpVpYUVcuf64nE4JLdHrUY2jojzHG%2BkruSDwhzLXDTmPXjvhshFO9g0XM8Bu3q77jn2QHH0afG31xZkRVpGMohyIquU%2FpiNVxXCalQGzna9&X-Amz-Signature=8a9bee25ab14bb01341ab19b2c7fdeef44c5fb77ae87e9bc1312b07e0b357518&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-05-06T02:45:00.000Z",
			"id": "bfa103ea-925f-4386-9ebf-11ab376460a1",
			"contadores": [
				"Quadrinhos Proféticos",
				"Vegetas Chegando",
				"Críticas Sociais Foderosas",
				"Quadrinhos com trilha sonoras indicadas pelo autor"
			],
			"caps_lidos": "1",
			"imagem_name": "persefone-hq  ",
			"data_leitura": "2024-05-05",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/persefone-ggkw",
			"name": "Perséfone",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"63fe1f46-bef0-4274-9eb9-3d0ec9497af4"
			],
			"autor": [
				"Diego SSA ⭐"
			],
			"insta": "https://www.instagram.com/diegosanderson3/",
			"tags": "♂️",
			"twitter": "https://twitter.com/ssa_diego"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/97587033-7295-4943-ae7a-5069e3a11ad7/bomdiaestrelinha-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=0747c678024ef1259268e28c79f1f7e1287ebf2ca83b98eaee51f4942dc0c394&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-28T13:52:00.000Z",
			"id": "bc91f549-0554-479d-b41f-7df356dc3227",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "bomdiaestrelinha-hq  ",
			"data_leitura": "2024-04-27",
			"genero": [
				{
					"name": "+18",
					"color": "red"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/bom-dia",
			"name": "Bom dia estrelinha",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"bc0cbfff-b781-42fa-bf31-f7b7c2b3aa82"
			],
			"autor": [
				"Kizolf ⭐"
			],
			"insta": "https://www.instagram.com/kizolf/",
			"tags": "🜬",
			"twitter": "https://twitter.com/kizolf"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/45d0cb4f-4171-4b10-829e-203c74af76a7/suriblade-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=3d7e33d30a04b27df5d167643b4762b6e6ef895b34e2190e21ccfdb2f8ea50fd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-26T00:00:00.000Z",
			"id": "839ca949-368a-4dfb-91f3-f261904ddfdd",
			"contadores": [
				"Astros Celestes com carinhas"
			],
			"caps_lidos": "1",
			"imagem_name": "suriblade-hq  ",
			"data_leitura": "2024-04-25",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.estudioarmon.com.br/2019/06/suriblade-capitulo-01.html",
			"name": "Suriblade",
			"porcentagem_leitura": 20,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"6b18db60-0999-4f34-a95b-3e94bf2d4d0b"
			],
			"autor": [
				"Ever Sousa"
			],
			"insta": "https://www.instagram.com/everardosousa123/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ec1a348e-4512-422d-a00c-1f7ef4122482/matandoaula-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=62725bfbeb419db8d6adbf66cef8a6beaed68062bd6bf7be879585b7fcb9f7a8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-22T00:15:00.000Z",
			"id": "0dc5816f-17e3-4893-b75b-f738fb7c55d2",
			"contadores": [
				"Beijocas",
				"Sacolé"
			],
			"caps_lidos": "1",
			"imagem_name": "matandoaula-hq  ",
			"data_leitura": "2024-04-21",
			"genero": [
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				},
				{
					"name": "+18",
					"color": "red"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/matando-aula",
			"name": "Matando Aula",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"bc0cbfff-b781-42fa-bf31-f7b7c2b3aa82"
			],
			"autor": [
				"Kizolf ⭐"
			],
			"insta": "https://www.instagram.com/kizolf/",
			"tags": "🜬",
			"twitter": "https://twitter.com/kizolf"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0c5f3b9b-d4c5-4868-9228-58a0fba5be2d/firula-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=0dc1825a08dec8a3a692aea7dca9798c57aa4d339902f902063597eac34040f6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-22T00:11:00.000Z",
			"id": "8e46d93e-f000-4492-b630-8893425d1864",
			"contadores": [
				"Hehe",
				"Escolas que ninguem tem aula de verdade"
			],
			"caps_lidos": "1",
			"imagem_name": "firula-hq  ",
			"data_leitura": "2024-04-21",
			"genero": [
				{
					"name": "Esporte",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/firula",
			"name": "Firula",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"2de18382-03b1-4440-8653-6cbe3514a474"
			],
			"autor": [
				"Michel V.P. ⭐"
			],
			"insta": "https://www.instagram.com/michelvp.oficial/",
			"tags": "♂️",
			"twitter": "https://twitter.com/MichelVPoficial"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1b0a9a08-fddc-47e0-a892-d1bbd584677e/comosetornarhumano-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=a9a1fcd1ab1cd5fddbf50bc295af893e094857b54461330734ff03fa1a7772a6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-11T23:05:00.000Z",
			"id": "cd1cf97e-6c92-47b3-89fd-36acfa1f3ecb",
			"contadores": [
				"Melhores Sinopses",
				"Hehe",
				"Quadrinhos conhecidos por um nome que não é o nome dele",
				"Artes Pikassas",
				"Não humanos se passando por humanos",
				"Azulzinho Gostoso",
				"Segundas Chances"
			],
			"caps_lidos": "7",
			"imagem_name": "comosetornarhumano-hq  ",
			"data_leitura": "2024-04-11",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/como-se-tornar-humano-hi00",
			"name": "Como se tornar Humano",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"3b056d0c-e22e-4628-a1a1-06f64dd57645"
			],
			"autor": [
				"S.Bittencourt ⭐"
			],
			"insta": "https://www.instagram.com/s_bittencourt_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/S_Bittencourt__"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ecd7bb91-d35a-4df2-8777-1641f45bd947/nubentes-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=a56ebb8557421d21d1334d7212968f73cdedca5cafc24d7fe9e1309b3b9d19ba&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-05T01:21:00.000Z",
			"id": "f8cc7553-233f-47c6-967c-8259085e5708",
			"contadores": [
				"Músiquinhas tocadas no quadrinho",
				"Comidas aconchegantes",
				"Brasilidade",
				"Casamentos"
			],
			"caps_lidos": "2",
			"imagem_name": "nubentes-hq  ",
			"data_leitura": "2024-04-04T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/nubentes",
			"name": "Nubentes",
			"porcentagem_leitura": 7,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "28",
			"autores": [
				"8d1a3576-9bb9-4124-9f3b-39447c15d60f"
			],
			"autor": [
				"Johnny Braga"
			],
			"insta": "https://www.instagram.com/uhhuhhq/",
			"tags": "♂️",
			"twitter": "https://twitter.com/uhhuhhq"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5369b3ac-c6a3-4f11-8409-aee1155b7de3/bacecemena-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=8febea0f94e6b335fb88981c05b46d71594abf0c26f02454ea3c05086fc1f0f4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-05T01:18:00.000Z",
			"id": "e413cb87-0f8b-473d-b4d8-3b068b77c132",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "bacecemena-hq",
			"data_leitura": "2024-04-04",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/behcece-mena-ponatinoce",
			"name": "Bahcecé Mena Ponatinocé",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"5345a81f-7381-43d0-9dad-78ed3f0d7ce1"
			],
			"autor": [
				"Pepasmaga ⭐"
			],
			"insta": "https://www.instagram.com/pepasmaga/",
			"tags": "♂️",
			"twitter": "https://twitter.com/pepasmaga2"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ffecd597-fe8a-4ae4-b375-f54dd3c3dc24/cennetaespadarubra-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=7ad2b3568978191f3a21c1249e4fa488a5960202bea423dd725fe3a37a955d38&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-31T22:14:00.000Z",
			"id": "533fbd39-5317-4dcc-a101-cc1b27d6cd9b",
			"contadores": [
				"Inícios mitológicos",
				"FDPs",
				"Ruivinhos Metidos",
				"Coisas no olho",
				"Cenas na Chuva",
				"Lutas até a morte",
				"Heterofobia nos olhos"
			],
			"caps_lidos": "6",
			"imagem_name": "cennetaespadarubra-hq",
			"data_leitura": "2024-03-31",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/cennet-a-espada-rubra",
			"name": "Cennet: A Espada Rubra",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"dacd03bb-5dac-4dae-9aea-a93d25f8a2fa",
				"8a4d6848-564d-424c-8164-e59d9b0df121"
			],
			"autor": [
				"Mauricio Miranda",
				"Silva Verso ⭐"
			],
			"insta": "https://www.instagram.com/mauriciomiranda976/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/56ffcce5-5a63-4c40-bb2d-09a1e79dca55/animus-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=419f9c86f0beb06cb3f5dcd3d713d35fcbaff185e390e944a7801f41e4964ea4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-29T13:47:00.000Z",
			"id": "ec7eda0a-6954-46f7-9bb1-90e67fcd8b2b",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "animus-hq  ",
			"data_leitura": "2024-03-28",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": null,
			"name": "Animus",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"fcebc835-e59d-44f4-9af7-1c8fc0c0385f"
			],
			"autor": [
				"Manoela Costa ⭐"
			],
			"insta": "https://www.instagram.com/manoelacostaartwork/",
			"tags": "♀️",
			"twitter": "https://twitter.com/ManoelaCostaArt"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3552f83c-840d-4b10-b332-ffe26f42bdf1/cupid-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=f04ec2c5dd4db964bf49164e56fdd0484e05b2dfc158c155e51a5e7af86a7081&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-25T01:46:00.000Z",
			"id": "d67f7c5f-9570-416d-b976-bb79e7f06ba5",
			"contadores": [
				"Ruivinhos Metidos",
				"Husbandos",
				"Camisas 10"
			],
			"caps_lidos": "1",
			"imagem_name": "cupid-hq  ",
			"data_leitura": "2024-05-16",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Cupidcomic/info",
			"name": "Cupid",
			"porcentagem_leitura": 20,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"15e8625f-9719-48d1-adc2-ffa92a8034a2"
			],
			"autor": [
				"Eduarda “Noha” Nohama ⭐"
			],
			"insta": "https://www.instagram.com/cinnamonoha/",
			"tags": "♀️",
			"twitter": "https://twitter.com/cinnamonoha"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a56f73b9-1899-478e-bbd1-f599d9d9258f/xeretive-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=180099b96ef3404c059a33d5b5bda0c6ca01138bed555badc7d1b91e102a6277&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-23T01:02:00.000Z",
			"id": "1e33ae79-8ada-4c0a-89ea-7aa31a2eb053",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"Bullies"
			],
			"caps_lidos": "1",
			"imagem_name": "xeretive-hq  ",
			"data_leitura": "2024-03-22T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": "https://www.catarse.me/Xeretive",
			"link_leitura": "https://fliptru.com.br/comic/xeretive",
			"name": "Xeretive",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"626e9184-fc74-49ce-bafd-1f1b11b351ce"
			],
			"autor": [
				"Sixtty ⭐"
			],
			"insta": null,
			"tags": "♂️",
			"twitter": "https://twitter.com/Sixttygraph"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d6f91b5d-8e5a-423f-9e0f-5e9bfb91298d/mellohi-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=9373a9c3ebf2bda15787b1671efd9507b494edd9a3473ef4fdee1e9762e3ecb7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-18T04:51:00.000Z",
			"id": "2969ddcf-cefd-4cc5-9417-c1e1b4147094",
			"contadores": [
				"LQN Aparecendo em Quadrinhos Nacionais"
			],
			"caps_lidos": "1",
			"imagem_name": "mellohi-hq  ",
			"data_leitura": "2024-04-27T23:40:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/mellohi-phj3",
			"name": "Mellohi",
			"porcentagem_leitura": 20,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"7b7c421e-4065-4eee-b500-8cc5ad0d9b86"
			],
			"autor": [
				"Hanna Mello ⭐"
			],
			"insta": "https://www.instagram.com/hannamelldraw/",
			"tags": "♀️",
			"twitter": "https://twitter.com/MellohiOficial"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f70e6e2b-7357-4fc1-96ee-6c50313b3b33/thegoatwitch.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=67db8d1abfd5a09fd4459b5ad4e1dc948b57eb0a8140bb157e7c316c675c7217&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-09T21:11:00.000Z",
			"id": "141d6abc-ac27-43f5-8a1d-425fa86bdc74",
			"contadores": [
				"Pato",
				"Bruxas"
			],
			"caps_lidos": "1",
			"imagem_name": "thegoatwitch-hq",
			"data_leitura": "2024-06-09T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://m.tapas.io/series/The-Goat-Witch/info",
			"name": "The Goat Witch",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"3543d9bb-8639-4c06-8866-9c1e4da358e3"
			],
			"autor": [
				"Naythf  ⭐"
			],
			"insta": "https://www.instagram.com/naythf/",
			"tags": "♂️",
			"twitter": "https://twitter.com/naythf"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/96dcea92-83a4-4f0c-a37f-ee4794b11ebc/askingyou-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=bf6f7de7bc93b99b1a6f741dea32bb833a70859949b35abfe2d3af1f42fa7f83&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-08T01:08:00.000Z",
			"id": "75ad13a9-dc0d-481a-9520-85a569931fc9",
			"contadores": [
				"Hehe",
				"Camisas 10"
			],
			"caps_lidos": "9",
			"imagem_name": "askingyou-hq  ",
			"data_leitura": "2024-03-07",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Asking-You-PT-BR/info",
			"name": "Asking You",
			"porcentagem_leitura": 9,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "96",
			"autores": [
				"28cc19a6-6535-4709-9634-e6249b25b15a"
			],
			"autor": [
				"Nori"
			],
			"insta": "https://www.instagram.com/noriyuuart/",
			"tags": "♂️",
			"twitter": "https://twitter.com/noriyoukinky"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a0d580cc-1b32-4c71-a25f-7b9864c50e56/asentregasdejunior-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=5f68e05264f681e12cfb228a947fb31dd4981bfe72051339fb82ea36c7ecbd14&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-28T00:24:00.000Z",
			"id": "96ddc133-25d1-4d38-b470-10eb25d1208f",
			"contadores": [
				"Girias Cariocas",
				"Pix"
			],
			"caps_lidos": "2",
			"imagem_name": "asentregasdejunior-hq",
			"data_leitura": "2024-02-27",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/as-entregas-de-junior",
			"name": "As Entregas do Junior",
			"porcentagem_leitura": 40,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"79d8c194-7143-4a2b-8965-69807db69eb2"
			],
			"autor": [
				"Matheus lobto"
			],
			"insta": "https://www.instagram.com/matheuslobto/",
			"tags": "♂️",
			"twitter": "https://twitter.com/so_chave"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/031c7f29-fe73-4803-b9eb-610906e64d3f/contosdosamuraidamontanha-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=9c950b9c3f2ef6260ea18ec35e9f64e3c1a0a633cfae58c7e3f2270bf98d475b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-26T01:17:00.000Z",
			"id": "90de0867-ec3d-40e8-9be7-6422eca33881",
			"contadores": [
				"Squad Goals",
				"Comidas aconchegantes"
			],
			"caps_lidos": "21",
			"imagem_name": "contosdosamuraidamontanha-hq  ",
			"data_leitura": "2024-02-22",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/o-professor-da-montanha",
			"name": "Contos do Samurai da Montanha",
			"porcentagem_leitura": 77,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "27",
			"autores": [
				"9c16133f-4074-4a9e-8c9f-7e3676764d8e"
			],
			"autor": [
				"Paulo Estefano ⭐"
			],
			"insta": "https://www.instagram.com/pauloeartes/",
			"tags": "♂️",
			"twitter": "https://twitter.com/pauloeartes"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/23f8da5f-e18d-41c1-b385-0bf4e3400cea/sanguedimensional-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=06b87864b06d862b30e0f1107dc29725b5e2c63d592849c138605c4dd49f6bdb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-26T01:08:00.000Z",
			"id": "b78a5e2b-9d6a-4d9e-9941-aa4397b60668",
			"contadores": [
				"Peitões do Quadrinho Nacional",
				"Monstros dentro da compreensão",
				"Porradas Bem Dadas",
				"No Shape",
				"Beijocas",
				"Sacodes",
				"Aura"
			],
			"caps_lidos": "1",
			"imagem_name": "sanguedimensional-hq  ",
			"data_leitura": "2024-02-25T22:08:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/sangue-dimensional",
			"name": "Sangue Dimensional",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"7d156117-b3a3-44ec-8224-a6f32913a9f5"
			],
			"autor": [
				"Edgard Carrijo ⭐"
			],
			"insta": "https://www.instagram.com/studioperrijo/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cdc2dc9a-cc5c-479c-b36d-1b9903a26a49/pescaria-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=137cd446ff228d30e9802352a41c3c6e399be4d481a16ab38f6350610bfc03b1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-19T01:28:00.000Z",
			"id": "047e3399-0e5a-4a01-9f57-7d6de26fb9cd",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "pescaria-hq  ",
			"data_leitura": "2024-02-18T22:34:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088257",
			"name": "Pescaria",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"3fcaeef3-6671-4240-90bd-e1f4ff9b8226"
			],
			"autor": [
				"José Luiz M Pinheiro"
			],
			"insta": "https://www.instagram.com/luinhadesenhista",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1336b004-b274-40f0-a0b3-6942b385af6a/anjosedemonios2-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=d13eeb2b7b286b7117f64874c789efafa2cf3e3ac0f7cba7d69b9c02ad5a407a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-18T23:49:00.000Z",
			"id": "c479f12a-7251-4573-a93e-3f985f56f3a0",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "anjosedemonios2-hq  ",
			"data_leitura": "2024-02-18T23:53:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088451",
			"name": "Anjos e Dêmonios",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"5629fc91-95e5-4761-b73c-f5b52084c0ed",
				"45b07f79-970e-4a9e-903c-0c99068250b4"
			],
			"autor": [
				"vini_dsoul",
				"Buga Arts ⭐"
			],
			"insta": "https://www.instagram.com/Vini_dsoul",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f164072f-98a6-46d6-97b8-08b1a6e02560/anjosedemonios-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=895f6d0f0c68ee9ae0b5bf8fb7d74830d0ae445011541f4fafe14023f54474c5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-18T23:47:00.000Z",
			"id": "5a06efcc-0421-4f11-a594-2f74959548d0",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "anjosedemonios-hq  ",
			"data_leitura": "2024-02-18T23:48:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088448",
			"name": "Anjos e Dêmonios",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"5629fc91-95e5-4761-b73c-f5b52084c0ed"
			],
			"autor": [
				"vini_dsoul"
			],
			"insta": "https://www.instagram.com/Vini_dsoul",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ef5fb36d-b9e1-4b16-8906-e43c540f665d/agatha-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=306426357f6e3803153ec9c375e7989266859ed36c4c05712c8e9601d390e67a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-18T23:46:00.000Z",
			"id": "e0b0d201-7b34-4193-ba1d-b68c642cc0b6",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "agatha-hq  ",
			"data_leitura": "2024-02-18T23:36:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088442",
			"name": "Agatha",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"b76e79b9-e1e1-40b7-ae1d-1061e8a97529"
			],
			"autor": [
				"Roberto koga"
			],
			"insta": "https://www.instagram.com/roberto_kogalima/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d7f51886-f5ee-48ea-a2f8-4c8f9c0e340e/inundao-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=03e3a73e08542138af636215d30f3126780ee40dfceeef27e65abeec07dc49da&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-18T23:42:00.000Z",
			"id": "3244cf31-de42-4ada-af88-eafc4646e28d",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "inundação-hq",
			"data_leitura": "2024-02-18T23:23:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088389",
			"name": "Inundação",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"4cfd6e03-2f49-4d90-bdd2-df4e8bde2ec4"
			],
			"autor": [
				"Bulho"
			],
			"insta": "https://www.instagram.com/bulhoarts/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/da2a89f3-0302-4d36-a553-aca58f1ec8a6/enquantoanevecai-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=d233e01d55e8c8451d8f3331035c19171d03f39220b425902a7ca44ec8f3ddb3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-18T23:41:00.000Z",
			"id": "7792c7df-8129-4ed6-823c-081f253c4733",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "enquantoanevecai-hq  ",
			"data_leitura": "2024-02-18T23:11:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088374",
			"name": "Enquanto a neve cai",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"5acadfec-5c64-4238-af27-29051ba79f03"
			],
			"autor": [
				"Marina Fujita"
			],
			"insta": "https://www.instagram.com/marifujiart",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/753d3557-7bcc-4e13-adf0-3a4f50de6a50/minhacompanheiradiaba-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=17df6c082f7c96b62ec48ce4c1e496d18195eb77e496e9074eae753eb504fb5c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-18T23:40:00.000Z",
			"id": "19424419-cc80-43ef-8e04-9b9023ad851a",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "minhacompanheiradiaba-hq  ",
			"data_leitura": "2024-02-18T22:53:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088346",
			"name": "Minha Companheira Diaba",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"7bfaecd8-dba6-4d7f-9659-497c13833690"
			],
			"autor": [
				"L Eklipse ⭐"
			],
			"insta": "https://www.instagram.com/l.eklipse",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0d612a24-723f-494e-9b94-d6a3dc11b3a6/osorrisooculto-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=eb3787806aa5ef04b261b3ab95752086c7267c4c518739e3fdb1ed12b6e1bdd7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-18T23:39:00.000Z",
			"id": "99f07811-c192-44e8-8279-42668b9f6626",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "osorrisooculto-hq  ",
			"data_leitura": "2024-02-18T22:36:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088324",
			"name": "O Sorriso Oculto",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"7bfaecd8-dba6-4d7f-9659-497c13833690"
			],
			"autor": [
				"L Eklipse ⭐"
			],
			"insta": "https://www.instagram.com/l.eklipse",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a90cdc51-b392-46e8-a289-58e45058ab78/tedomonstrinho-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=aff1da8cca096c295f354af20d074cf37cf1124debe9dcac5f72b5dfe6f04b88&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-18T23:37:00.000Z",
			"id": "cdeae53b-2f5b-46fc-8daa-de82e1ad8791",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "tedomonstrinho-hq",
			"data_leitura": "2024-02-18T22:25:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088249",
			"name": "TED O monstrinho",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"efbce7b7-77ea-4841-ac9e-ec54df6f9bc5",
				"45b07f79-970e-4a9e-903c-0c99068250b4"
			],
			"autor": [
				"Janeth Vieira da Silva",
				"Buga Arts ⭐"
			],
			"insta": "https://www.instagram.com/janethvieiradasilvaoficial/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4ed115c7-52bd-45e1-a94b-7ed9d2dd4e0c/hidingplace-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=48df1d7f2f3fe4c8d64ac9d2fae01beb14838a4cde4eb70aea6ea1c1a3c3f646&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-18T23:35:00.000Z",
			"id": "95346e5b-8957-4e1f-83dc-64a40f41ef2b",
			"contadores": [
				"Cabelos Estilosos"
			],
			"caps_lidos": "1",
			"imagem_name": "hidingplace-hq  ",
			"data_leitura": "2024-02-18T22:19:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088206",
			"name": "Hiding Place",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"9248f707-2513-4387-ba94-fb571a336ce0"
			],
			"autor": [
				"Millie ⭐"
			],
			"insta": "https://www.instagram.com/millicamacho_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/CamachoMilli"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/493ea6d6-faaf-4f4e-a43d-6ec7b11467da/teatime-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=76252eb496a22f9abbbc61e5c4422ee60ef33851abbc9b7eaf040d8cb0ac9f6c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-18T23:19:00.000Z",
			"id": "da85fc15-be8f-44eb-bd4b-26876c3d5541",
			"contadores": [
				"Charmosinho"
			],
			"caps_lidos": "1",
			"imagem_name": "teatime-hq  ",
			"data_leitura": "2024-02-18T22:10:00.000-03:00",
			"genero": [
				{
					"name": "Coletânea",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3088203",
			"name": "Tea Time",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"90ba8561-e559-436b-ae63-5e691204199a"
			],
			"autor": [
				"Mincchi Nyan ⭐"
			],
			"insta": "https://www.instagram.com/mincchi.nyan/",
			"tags": "♀️",
			"twitter": "https://twitter.com/mincchi_nyan"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/834856bb-54c7-4799-a68b-7150d5c685f0/fraternidades-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=af29577d6c04ba0c881ed3da7729c969cdacd87270f4b6e7c24e11a080649140&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-16T00:11:00.000Z",
			"id": "3b8056dc-0008-45da-942e-3bb6b2da78f1",
			"contadores": [
				"Organizações",
				"Bandas",
				"Botecos",
				"Ruivinhos Metidos",
				"Logos",
				"Power System",
				"Patadas",
				"Pais que foram comprar cigarro",
				"Ordem Religiosas",
				"parece que você andou treinando desde a ultima vez que nos encontramos"
			],
			"caps_lidos": "18",
			"imagem_name": "fraternidades-hq  ",
			"data_leitura": "2024-02-15",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/fraternidades",
			"name": "Fraternidades",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "18",
			"autores": [
				"872f2a9d-3ff9-435a-9ffe-3b0bef36b43d"
			],
			"autor": [
				"Fabricio Andrade ⭐"
			],
			"insta": "https://www.instagram.com/fabricio_andrade88/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/14bdd14d-f0b1-447e-9c0a-8c3ea28eb599/everydaylifeatbrightrosebushhighschool-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=b0efdb0a9586ba17cc1b812cef56e29b6f2af0f7ae51d68436627330d47080dc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-07T01:40:00.000Z",
			"id": "92b9941c-94b4-4758-87f7-49439afea6a0",
			"contadores": [
				"Camisas 10"
			],
			"caps_lidos": "1",
			"imagem_name": "everydaylifeatbrightrosebushhighschool-hq  ",
			"data_leitura": "2024-02-06",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/everyday-life-at-bright-rosebush-high-school",
			"name": "Everyday life at Bright Rosebush High School",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"510c6a3a-5ba9-47fa-bfb1-24d4469cf7c5"
			],
			"autor": [
				"Beatriz (Bid Desenhos) ⭐"
			],
			"insta": "https://www.instagram.com/bid_desenhos",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5343792e-d0e7-4525-8f7d-3ed4f79e5298/osomdavida-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=a725e0d43fa8deadf8ca6728afc77a16b62f7dea59dd600ae05526798a3b4e02&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-07T01:33:00.000Z",
			"id": "83740dac-785d-4a2a-946f-aaa286e5695c",
			"contadores": [
				"Hehe"
			],
			"caps_lidos": "1",
			"imagem_name": "osomdavida-hq  ",
			"data_leitura": "2024-02-06",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/3000171",
			"name": "O Som da Vida",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"c10c128b-143d-465b-b75c-4c4d68442739"
			],
			"autor": [
				"Adrikachan ⭐"
			],
			"insta": "https://www.instagram.com/adrikachan/",
			"tags": "♀️",
			"twitter": "https://twitter.com/Just_Adrika"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ccc742db-beff-426e-81cf-e72ac8a23884/kellyyoungspooky-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=bab4acbfbc1433af0cd5cfa022e1fa37e988617572ccac53d5a419d398176c01&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-01T23:33:00.000Z",
			"id": "08ddce89-0318-4287-a65d-bcfe10e362dc",
			"contadores": [
				"Mudanças",
				"Equipe Rocket decolando de novo"
			],
			"caps_lidos": "1",
			"imagem_name": "kellyyoungspooky-hq",
			"data_leitura": "2024-02-01",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/as-desventuras-de-kelly-young-spooky",
			"name": "As Desventuras de Kelly Young",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"8653e55c-4480-4d10-b294-f9ac267c8447"
			],
			"autor": [
				"GringoComics ⭐"
			],
			"insta": "https://www.instagram.com/gringocomics_insta/",
			"tags": "♂️",
			"twitter": "https://twitter.com/gringoscomics"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0a1d3f2e-fa91-46d8-8db6-28be907351c1/brunotemumnamorado-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=be348e33cb7e63370f770ac94d27c5105529421de5b7f1958af1608cd46d89a4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-01-27T00:42:00.000Z",
			"id": "b1b2a48d-0860-4057-8851-a9e2219936b9",
			"contadores": [
				"Cenários Convenientemente muito bem Posicionados",
				"Quebras de quarta parede",
				"LQN Aparecendo em Quadrinhos Nacionais",
				"Beijocas",
				"Camisas 10",
				"Ruivinhos Metidos",
				"Sorrisinho do Light",
				"Vilões",
				"Mamães Fodas",
				"Episódio de Praia"
			],
			"caps_lidos": "26",
			"imagem_name": "brunotemumnamorado-hq  ",
			"data_leitura": "2024-03-10",
			"genero": [
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				},
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/brunotemumnamorado",
			"name": "Bruno Tem um Namorado",
			"porcentagem_leitura": 63,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "41",
			"autores": [
				"dc013947-ecd4-4de6-a37f-3aa70d6765ae"
			],
			"autor": [
				"Ture ⭐"
			],
			"insta": "https://www.instagram.com/oarture/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/68b02d05-2e1e-4218-ae2d-c262dd8d91fb/pitakoxpitako-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=9af139311e98988275dcd239f73b9c3630e24472937757b438a0825edfc0045c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-01-23T21:01:00.000Z",
			"id": "81780fd3-dc42-4c7c-8436-dd496d36d065",
			"contadores": [
				"Vilões",
				"Quadrinhos para ler chapado",
				"Entrando pela janela"
			],
			"caps_lidos": "4",
			"imagem_name": "pitakoxpitako-hq  ",
			"data_leitura": "2024-01-18",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Ficção Científica",
					"color": "blue"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/pitako-x-pitako",
			"name": "Pitako x Pitako",
			"porcentagem_leitura": 80,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"1b66bf90-c6cb-410a-84f7-f5fef523b53e"
			],
			"autor": [
				"Chinês ⭐"
			],
			"insta": "https://www.instagram.com/mkd_pitakoxpitako",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7be50344-a5a9-4f70-88ac-0f9cc34f7cc2/pongocomics-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=05b53ad3cbe231a4d403d5149b7a4fdc414e6c02a883daf687b52904cfc93ace&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-28T22:36:00.000Z",
			"id": "34c26087-1164-4772-92a9-f35d00a30214",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "pongocomics-hq",
			"data_leitura": "2023-11-28T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": null,
			"name": "Tiras Variadas",
			"porcentagem_leitura": 0,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "999",
			"autores": [
				"cc633744-fd7a-4464-96e7-279db196842c"
			],
			"autor": [
				"Pongo Comics"
			],
			"insta": "https://www.instagram.com/pongocomics/",
			"tags": "♂️",
			"twitter": "https://twitter.com/PongoComics"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e09f53cd-48c6-4b3e-8352-591d27310e97/oamorreceita-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=10678ca475c59cb5100b435fa940d0ea2db46b4f7b389e04687f576ff31d750e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-28T22:30:00.000Z",
			"id": "630fcf5d-1086-4963-9ca7-097e7df70c6c",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "oamoréreceita-hq",
			"data_leitura": "2023-11-26T21:30:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": null,
			"name": "O Amor é Receita",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"b6165c8c-e6a2-4582-a394-ea7ec9d33163"
			],
			"autor": [
				"Dika Araújo"
			],
			"insta": "https://www.instagram.com/dikaraujo/",
			"tags": "♀️",
			"twitter": "https://twitter.com/mobydika"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/22583a30-be10-4163-829e-fc02889759d9/hex-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=6cad4dcea2a91bbd6286a84a77888417c60cc098a39a5272492ff841bfed03b5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-28T22:28:00.000Z",
			"id": "46d0cd90-0b84-4a23-9c48-098147d84a17",
			"contadores": [],
			"caps_lidos": "14",
			"imagem_name": "hex-hq  ",
			"data_leitura": "2023-11-26T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/hexverse-lef5",
			"name": "HEX",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "14",
			"autores": [
				"d303258b-feaf-467a-85c8-fb32274390c6"
			],
			"autor": [
				"Rafael “Hexverse” Arcucio"
			],
			"insta": "https://www.instagram.com/hexverse.oficial/",
			"tags": "♂️",
			"twitter": "https://twitter.com/NeroHexverse"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f96cfef7-c4df-40c4-a96b-0411c78e830f/magh-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=b37ab4da2f32867cfa542399ba4eeb01f9b7a44d0fb05ab99a785c5706292384&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-28T22:24:00.000Z",
			"id": "1ee0fa67-fbec-42fc-b605-35a3db69617d",
			"contadores": [
				"Cabelos Estilosos",
				"Criaturas sobrenaturais",
				"Quebras de quarta parede",
				"FDPs",
				"Autores pelo Celular / Mouse",
				"Artes Pikassas",
				"Universos que o B ia de base",
				"Bruxas",
				"Protagonistas perdidos",
				"Quadrinhos para ler chapado",
				"Entrando pela janela",
				"Wikiman/Palestrinha"
			],
			"caps_lidos": "21",
			"imagem_name": "magh-hq  ",
			"data_leitura": "2023-11-26",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/magh-todas-as-edicoes",
			"name": "Magh",
			"porcentagem_leitura": 39,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "53",
			"autores": [
				"84b7ce4a-beec-4715-9ab6-778b7bb89853"
			],
			"autor": [
				"J S Art ⭐"
			],
			"insta": "https://www.instagram.com/j.s.art_/",
			"tags": "♂️",
			"twitter": "https://twitter.com/JSArt12"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2d5c8bcb-2be7-4532-987d-b4780adc68ea/sidyoaventureiro-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=ac31d441e63f7af274037d1234f5d147167ce97aad4bc22a57828e546ddf8467&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-21T23:46:00.000Z",
			"id": "67126124-0c47-4273-a099-205dc132e071",
			"contadores": [
				"Começos JRPGlike"
			],
			"caps_lidos": "1",
			"imagem_name": "sidyoaventureiro-hq  ",
			"data_leitura": "2023-11-21",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.webtoons.com/en/canvas/sidy-o-aventureiro/list?title_no=418967",
			"name": "Sidy o Aventureiro",
			"porcentagem_leitura": 14,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"7e931a62-806f-416c-a9dc-267f12ecf5b4"
			],
			"autor": [
				"Gustavo Neves"
			],
			"insta": "https://www.instagram.com/gus_estudios/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c1c706b7-7654-4874-9437-2b9696aa9315/abordodobeagle-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=af632b723f2fd8d33c00fa49f1812a7205fc2f57541661ba5393415e573a233d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-21T23:41:00.000Z",
			"id": "d818ff3d-ad0e-4ca5-bf80-06f70eb3a233",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "abordodobeagle-hq  ",
			"data_leitura": "2023-11-21",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://drive.google.com/file/d/1U_dXXNhSCsmQU8aj3ylvzTvQ-C9rvt_G/view",
			"name": "A Bordo do Beagle",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"efd4af21-0c53-462c-836e-67cd3400a7ce"
			],
			"autor": [
				"Bennê Oliveira"
			],
			"insta": "https://www.instagram.com/leve.mente.insana/",
			"tags": "♀️",
			"twitter": "https://twitter.com/Bennearte/media"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1acc2e19-13c6-4a53-9362-6c0116203e4a/redlightning-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=14818c414711db5ef1d2aa0495787dc42fc5d28fd64aea29ef98206d73d96dc1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-21T23:28:00.000Z",
			"id": "de88d288-484d-4a6f-96db-ef76765d651e",
			"contadores": [
				"Alienígenas",
				"Promessas entre amigos"
			],
			"caps_lidos": "2",
			"imagem_name": "redlightning-hq  ",
			"data_leitura": "2023-11-19",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/red-lightning",
			"name": "Red Lightning",
			"porcentagem_leitura": 6,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "33",
			"autores": [
				"ad291298-776f-490c-9dc3-36b99e5384e3",
				"fbf44b20-9532-4d16-9960-cf9f728ee565"
			],
			"autor": [
				"Zolly Artz ⭐",
				"Leo The Pard"
			],
			"insta": "https://www.instagram.com/zollyartz/",
			"tags": "♂️",
			"twitter": "https://twitter.com/ZOLLYartz"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/de2d678d-d865-4e3e-81f8-57c435723434/kairuede-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=41690a834e3014a5bee8d36e2737c6d40d7c8d1928b7406dbc56409e710668eb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-16T22:49:00.000Z",
			"id": "b5203e86-b991-4258-b0db-0273c87d0e20",
			"contadores": [
				"Melhores Sinopses",
				"Brasil Alternativo",
				"Mapinhas"
			],
			"caps_lidos": "3",
			"imagem_name": "kairuede-hq  ",
			"data_leitura": "2023-11-14T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/kairu-ede",
			"name": "Kairu-Edé",
			"porcentagem_leitura": 21,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "14",
			"autores": [
				"6b3b8ed4-ae56-4a49-b399-c58e8b4d009a"
			],
			"autor": [
				"Dangotirinhas"
			],
			"insta": "https://www.instagram.com/dangotirinhas/",
			"tags": "♂️",
			"twitter": "https://twitter.com/dangotirinhas"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e96f1d60-36bc-43c4-930b-e11a0799fb6b/esquadraocoraocadente-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=9dce4f64503722eed4b7881b2151a8fd2832ef7bec438b38c3f4eae832b41a42&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-16T22:45:00.000Z",
			"id": "18d8bd5e-f9d1-4a1f-af8d-99d9424cc284",
			"contadores": [
				"Alienígenas",
				"Quadrinhos Feels",
				"Desilusão amorosa"
			],
			"caps_lidos": "1",
			"imagem_name": "esquadraocoraçãocadente-hq",
			"data_leitura": "2023-11-14T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.instagram.com/stories/highlights/17921236466427200/",
			"name": "Esquadrão Coração Cadente",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"06a0e031-70e1-4596-8c3a-3629d4bed3b4"
			],
			"autor": [
				"Leo CE Saturn"
			],
			"insta": "https://www.instagram.com/leocesaturn/",
			"tags": "♂️",
			"twitter": "https://twitter.com/leocesaturn"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/79d80321-c25b-4be1-a1c6-48faa016fae1/leitederramado-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=38f46480020610c63a1b1b8a3d948b2f6ea49ecf6f3590645f0b88b2f67c1b93&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-16T22:37:00.000Z",
			"id": "b2535464-993a-45fe-b50c-1c334c19ce77",
			"contadores": [
				"Quadrinhos com trilha sonoras indicadas pelo autor",
				"Quadrinhos Feels",
				"Desilusão amorosa"
			],
			"caps_lidos": "1",
			"imagem_name": "leitederramado-hq  ",
			"data_leitura": "2023-11-14T21:00:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://online.fliphtml5.com/lhgev/bska/#p=1",
			"name": "Leite derramado",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"b03472b4-35ac-47db-a311-261bc8c931b9"
			],
			"autor": [
				"Apalomarte"
			],
			"insta": "https://www.instagram.com/apalomarte/",
			"tags": "♀️",
			"twitter": "https://twitter.com/apalomarte"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9d60638f-12e9-42af-83bf-84e100ebf36c/thesteelpolice-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=aa54958b89c8ce92805f0db846be8041c65dcd8e1f2962d222b68556cfe07339&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-13T00:55:00.000Z",
			"id": "89a2705e-980c-452e-8224-16469d8109f0",
			"contadores": [
				"Busão",
				"Meios de Transporte",
				"Vinganças"
			],
			"caps_lidos": "1",
			"imagem_name": "thesteelpolice-hq  ",
			"data_leitura": "2023-11-12T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/the-steel-police",
			"name": "The Steel Police",
			"porcentagem_leitura": 6,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "15",
			"autores": [
				"06479745-853b-4522-ad43-4cae317479fc"
			],
			"autor": [
				"Guicaires"
			],
			"insta": "https://www.instagram.com/gc_history_drawings/",
			"tags": "♂️",
			"twitter": "https://twitter.com/GuiCaires21"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/22b43686-e0df-4c7c-bcbd-20fe59f5b736/veronikaeosapo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=d194e666538516b0e3507cf8883dfc46e094a9ce765d2de28f966c6e58e064d7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-13T00:51:00.000Z",
			"id": "c611aedc-09fe-4746-ad4e-9bd8ccc4d862",
			"contadores": [
				"Quebras de quarta parede"
			],
			"caps_lidos": "6",
			"imagem_name": "veronikaeosapo-hq  ",
			"data_leitura": "2023-11-12T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/veronica",
			"name": "Veronika e o Sapo",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"97088075-94fd-44e8-983e-b12774cbde62"
			],
			"autor": [
				"EmogiArts"
			],
			"insta": "https://www.instagram.com/emogiarts/?hl=pt-br",
			"tags": "♂️",
			"twitter": "https://twitter.com/EmogiArts"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/149cabbc-dab0-4d01-9c32-171054dd66e6/thecoop-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=3037f7420d899db019fe9408d3f90aa9d92fe301c71839e94ba7156b72d3a3ce&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-13T00:48:00.000Z",
			"id": "42ae580b-4abf-4d8b-8076-dcfddbd526b2",
			"contadores": [
				"CLTs"
			],
			"caps_lidos": "1",
			"imagem_name": "thecoop-hq  ",
			"data_leitura": "2023-11-12T21:30:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/the-coop",
			"name": "The Coop",
			"porcentagem_leitura": 6,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "16",
			"autores": [
				"3a54bc1b-7b3e-470e-99a9-2b83d1282f2a"
			],
			"autor": [
				"CarretaComics ⭐"
			],
			"insta": "https://www.instagram.com/thecarretacomics/",
			"tags": "♂️",
			"twitter": "https://twitter.com/CarretaComics"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/77d38613-584f-4689-b97e-fa951e19e65c/diascinzentos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=1ca19e10c6cc8e85dd58784e991de2b3f2357a30066e8c844fab7f56a6271a0d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-13T00:39:00.000Z",
			"id": "313bb11d-2310-4976-bd74-2fb7d707598a",
			"contadores": [
				"Quebras de quarta parede",
				"Dêmonios",
				"Mapinhas",
				"Drift",
				"Flashbacks de Guerra",
				"Universos que o B ia de base",
				"Aura"
			],
			"caps_lidos": "8",
			"imagem_name": "diascinzentos-hq  ",
			"data_leitura": "2023-11-09",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/dias-cinzentos",
			"name": "Dias Cinzentos",
			"porcentagem_leitura": 53,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "15",
			"autores": [
				"68c86ebb-9415-42b6-aa63-7a5df311fb9d"
			],
			"autor": [
				"Eduardo Aguiar ⭐"
			],
			"insta": "https://www.instagram.com/eduardoaguiarofc/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e85e8cce-1462-4a9e-8496-904a272e3600/notaemsangue-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=d60d615f5024315fd2c923f2a75c07535b91674ea558cca97fdd00da6e0b8d6d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-03T00:04:00.000Z",
			"id": "17e583bc-3117-417a-89d7-9e10a9aa4541",
			"contadores": [
				"Músicos",
				"Cabelos Estilosos",
				"LQN Aparecendo em Quadrinhos Nacionais",
				"Já chega",
				"Beijocas",
				"Cicatrizes e Tatuagens"
			],
			"caps_lidos": "1",
			"imagem_name": "notaemsangue-hq  ",
			"data_leitura": "2023-11-03",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/nota-em-sangue-ppl6",
			"name": "Nota em Sangue",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"a2790792-9d40-4b5a-b7bf-84418b11f41c"
			],
			"autor": [
				"psyuro ⭐"
			],
			"insta": "https://www.instagram.com/p.sdraws/",
			"tags": "♀️",
			"twitter": "https://twitter.com/yuroich"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/30a9c42c-d4b7-439e-877b-d4e973d8892b/amaterasu-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232849Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=b58df746c3c3536f8b16f5d13da7caae8ee1c9c6d49aa20aeb73fee3f40f265a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-01T00:46:00.000Z",
			"id": "edd05a2d-eeab-406b-9532-9d0e3a1f6425",
			"contadores": [
				"Protagonistas com pais vivos",
				"Pq diabos você mandou uma criança?"
			],
			"caps_lidos": "1",
			"imagem_name": "amaterasu-hq  ",
			"data_leitura": "2024-09-22",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/amaterasu",
			"name": "Amaterasu ",
			"porcentagem_leitura": 20,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"32296dc6-93c4-49e9-8061-b43d35c544d6"
			],
			"autor": [
				"Yzumsm ⭐"
			],
			"insta": "https://www.instagram.com/yzumsm",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a48ab21a-11db-480a-b163-89483d4504b2/oceifadordemonstros-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=46719ebb4a6b5ba6256c3359457c1b026ee32ff4cea61fd34764576ec8e0f814&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-31T23:40:00.000Z",
			"id": "f1347b3a-fb52-41e3-a9c8-31575d0f6c9f",
			"contadores": [
				"Criança fazendo merda",
				"Invocações",
				"Criaturas sobrenaturais",
				"Personagens que esticam"
			],
			"caps_lidos": "1",
			"imagem_name": "oceifadordemonstros-hq  ",
			"data_leitura": "2023-10-31",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.zinnes.com.br/serie/805",
			"name": "O Ceifador de Monstros",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"662e3a22-ecf1-4c72-8f53-f804f0cbe823"
			],
			"autor": [
				"Caixopolis ⭐"
			],
			"insta": "https://www.instagram.com/caixopolis/",
			"tags": "♂️",
			"twitter": "https://twitter.com/caixopolis"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e9bff524-e25c-4afa-a8a2-6ca400d9a79f/assombrao-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=bba615bbb0d6f45a52689455a2728d99b52163ba89a007171cf966822f9cffde&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-31T12:50:00.000Z",
			"id": "78609969-f628-4619-8334-cbd4eeb6cabb",
			"contadores": [
				"Hehe",
				"Monstros Além da Compreensão",
				"Vilões"
			],
			"caps_lidos": "1",
			"imagem_name": "assombração-hq",
			"data_leitura": "2023-10-31T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/assombracao/info",
			"name": "Assombração",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"223f7dfd-bcca-475d-bcbd-115536c079e9"
			],
			"autor": [
				"Duhgetsu ⭐"
			],
			"insta": "https://www.instagram.com/duhgetsu/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Duhgetsu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3eee561c-1823-4a67-bc46-5826b98fe311/mediunidade-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=3a82914c191fb1fb9308de5541b05bd3288620d2fc2797d071ea7d87e0e2a63d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-30T01:14:00.000Z",
			"id": "59304ab4-21cf-4f71-9c2a-1b0dfb01fbfb",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "mediunidade-hq  ",
			"data_leitura": "2023-10-29",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/mediunidade",
			"name": "Mediunidade",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"69626598-4d93-4e11-8b11-a96e37b81dbe"
			],
			"autor": [
				"Stéphanie Rachel ⭐"
			],
			"insta": "https://www.instagram.com/_stephanierachel_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/Teffyrachel_"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9aa4006b-eae8-43be-aa5d-92ced123f58e/contosmacabrosdotumulododemonio-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=9c0758e1b59e672bab6f9fcd8f886f07d813cf29e83afe8a5790ff634971c781&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-30T01:12:00.000Z",
			"id": "f1a137b8-c1e7-4e2b-a12d-5205e0e95da1",
			"contadores": [
				"Quebras de Expectativa",
				"Calvos",
				"Dêmonios",
				"Armas Improvisadas"
			],
			"caps_lidos": "2",
			"imagem_name": "contosmacabrosdotumulododemonio-hq  ",
			"data_leitura": "2023-10-29",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/2996013",
			"name": "Contos Macabros do Túmulo do Demônio",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"f338d09a-6987-43e6-bf55-bcfd61cde494"
			],
			"autor": [
				"Gilton Ferreira ⭐"
			],
			"insta": "https://www.instagram.com/gilton_ferreira/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Passarumaru"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1f7d4807-72e9-4bf1-b0e9-474bd1ae9692/fatalabruxadebeliverde-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=00734d9229995f8680a6deb3aff96ab7fc8e671cf9496ab1308473646e1b0071&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-27T00:00:00.000Z",
			"id": "f5414002-efb6-45bd-b80f-296dee47d279",
			"contadores": [
				"Peitões do Quadrinho Nacional",
				"Furry",
				"Sacodes",
				"Artes Pikassas",
				"LQN Aparecendo em Quadrinhos Nacionais",
				"Máscaras Maneiras",
				"Bruxas",
				"Aura"
			],
			"caps_lidos": "7",
			"imagem_name": "fatalabruxadebeliverde-hq",
			"data_leitura": "2023-10-26T21:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/fatal-a-bruxa-de-beliverde",
			"name": "FATAL: A Bruxa de Beliverde",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"de15dde0-2c25-4278-bf37-0fdad910e4ee"
			],
			"autor": [
				"PROJ Fatal ⭐"
			],
			"insta": "https://www.instagram.com/proj_fatal/",
			"tags": "♂️",
			"twitter": "https://twitter.com/ProjFATAL"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e2b85a61-0495-4d9c-9ed8-95d58162e750/brokenangelsarah-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=2f40fd70fe76bb8c193531e7311a998892effa25919f4e76dce15767d2a9bf5a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-26T23:52:00.000Z",
			"id": "f1f4354d-4aa5-477a-9676-c0aa64bb54ed",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"Busão",
				"Beijocas",
				"Bullying"
			],
			"caps_lidos": "2",
			"imagem_name": "brokenangelsarah-hq  ",
			"data_leitura": "2023-10-26T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/broken-angel-sarah-e-o-multiverso-de-questoes-internas-7uzo",
			"name": "Broken Angel Sarah",
			"porcentagem_leitura": 40,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"a14bf342-da57-4e9a-af14-ca60abb1c0e9"
			],
			"autor": [
				"Johnny Oliver ⭐"
			],
			"insta": "https://www.instagram.com/johnnyoliver.art",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0c36f542-a593-44de-b677-b3758e67c0d1/osetfinal-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=b2aa918b189301dda40f5f0cfff3efe676548f4372e4c2a9c1d7bc3438de19eb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-19T22:22:00.000Z",
			"id": "9cd197ad-22ff-45b4-bf26-4cfe2c934f34",
			"contadores": [
				"Melhores Sinopses",
				"Calvos"
			],
			"caps_lidos": "1",
			"imagem_name": "osetfinal-hq  ",
			"data_leitura": "2023-10-19T21:40:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Esporte",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/OSetFinal/info",
			"name": "O Set Final",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"39f33dc5-7f22-4e65-90d0-a0f0b6572af3",
				"18f3da79-246e-4fd6-8b8b-011ba4b2ef15"
			],
			"autor": [
				"Leo Amirati",
				"Nicomikha"
			],
			"insta": "https://www.instagram.com/leoamirati/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1d75bfeb-113a-4c61-b4b3-717131dd6265/oladrodemundos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=b87f93e7b5e020f65b59bdd85056d01797002206554c4813619cbf196563539e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-18T00:23:00.000Z",
			"id": "f5c95399-8fc7-4b64-83b7-68fb7e4794d4",
			"contadores": [
				"Alienígenas",
				"Cósmico",
				"Naves",
				"Meios de Transporte"
			],
			"caps_lidos": "2",
			"imagem_name": "oladrãodemundos-hq",
			"data_leitura": "2023-10-17",
			"genero": [
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				},
				{
					"name": "Ficção Científica",
					"color": "blue"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/O-Ladro-de-Mundos/info",
			"name": "O Ladrão de Mundos",
			"porcentagem_leitura": 15,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "13",
			"autores": [
				"ff097212-1106-48c9-b37e-2f8167a5a27e"
			],
			"autor": [
				"Sayuritake ⭐"
			],
			"insta": "https://www.instagram.com/sayuritake/",
			"tags": "♀️",
			"twitter": "https://twitter.com/sayuritake_arts"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/843f2ab8-3940-46df-89e6-059862b839c5/sociedadesecretadosanduiche-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=b8cbd400159318753af9d3aeeec362e905cdb1eeda2ea64df048bf101bcc2db4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:41:00.000Z",
			"id": "267a413c-7bfb-497c-bfe5-a59f8ff8bdbd",
			"contadores": [
				"Duplinhas do Barulho"
			],
			"caps_lidos": "1",
			"imagem_name": "sociedadesecretadosanduiche-hq  ",
			"data_leitura": "2023-10-10",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.zinnes.com.br/serie/825",
			"name": "Sociedade Secreta do Sanduíche",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"0703c28d-949a-4909-bf04-3ee5158393e5"
			],
			"autor": [
				"Biulitarts"
			],
			"insta": "https://www.instagram.com/biulit.arts/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3c037b8f-a5da-4854-b6ee-ffc75f73cac6/planetasagrado-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=e0493af605166e4a684860ad9d1d85c2e4178bdc58f6dab25f4eb07f3c568aa8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:38:00.000Z",
			"id": "6e9d01b0-6705-4b19-8c20-5e15c30e72e1",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "planetasagrado-hq  ",
			"data_leitura": "2023-10-10",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/planeta-sagrado",
			"name": "Planeta Sagrado",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"81cb51ce-aba6-45fc-bae4-43c0d42ee305"
			],
			"autor": [
				"Diego Breno"
			],
			"insta": "https://www.instagram.com/hqplanetasagrado/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/194f19c9-1e2b-46be-90fb-d8c088226ef7/ginga-seriehq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=4fe08ccb4216c24cb8ecfd8d7dfda191b8113bb78125b75bbb5e531766f6dd6a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:28:00.000Z",
			"id": "47df8ba6-f6f6-47ac-a203-92d0358a52a5",
			"contadores": [
				"Hehe",
				"Personagens que usam o suco",
				"Busão",
				"Crias",
				"parece que você andou treinando desde a ultima vez que nos encontramos",
				"Apelidos",
				"Caolhos",
				"Cenas com ventinhos e folhinhas"
			],
			"caps_lidos": "3",
			"imagem_name": "ginga-hq  ",
			"data_leitura": "2023-10-15",
			"genero": [
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Esporte",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/ginga-serie",
			"name": "Ginga",
			"porcentagem_leitura": 75,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"02e41580-e160-47d5-a4df-7970f8226f29"
			],
			"autor": [
				"Paulo Marcello ⭐"
			],
			"insta": "https://www.instagram.com/paulo_marcello_art/",
			"tags": "♂️",
			"twitter": "https://twitter.com/PauloMarcelo16"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/94f5e953-1dbc-4316-8059-9f35f25a4a1d/oultimofliperama-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=cc4f532951575e670fa6e48fa7aaf52349a30398dd637236e08b60d0bd5fd6d8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:20:00.000Z",
			"id": "a08a2103-93bb-4b2c-a62e-d0d31e10e0ba",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "oultimofliperama-hq  ",
			"data_leitura": "2023-10-10",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/serie/983",
			"name": "O Último Fliperama",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"50d9467e-350d-4f04-b3f3-962a48135e19"
			],
			"autor": [
				"Lari “Lariarts” Macedo ⭐"
			],
			"insta": "https://www.instagram.com/lariarts/",
			"tags": "♀️",
			"twitter": "https://twitter.com/lariarts"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/eeab70b2-95c6-4a24-9376-5f94d021e699/kingspath-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=527a87435271cd30918dcaaab0577fe59a1cfb9fa542701ffc8a94579afe6144&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:15:00.000Z",
			"id": "24d95aa2-d80e-4931-8579-6cd9f10cdb5c",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "kingspath-hq  ",
			"data_leitura": "2023-10-08",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": "https://linktr.ee/blessingeditora?utm_source=linktree_admin_share",
			"link_leitura": null,
			"name": "King’s Path",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"ea798f57-6441-49b1-84c6-9201894a4333"
			],
			"autor": [
				"Filipe Oliveira"
			],
			"insta": "https://www.instagram.com/kings_path1/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e76cc360-cb6d-4f0b-9bd6-2a56f4d3410d/primos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=76d9976f75bf65e755e77d4fec72a94a50243b042902fc457fe2b69690a58f35&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:12:00.000Z",
			"id": "70ef1e0a-3d22-4ffc-bc19-660f6fc3d746",
			"contadores": [
				"Crias",
				"Busão",
				"Haters to Lovers"
			],
			"caps_lidos": "1",
			"imagem_name": "primos-hq  ",
			"data_leitura": "2023-10-05",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/PRIMOS",
			"name": "Primos",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"feecc179-8e29-4967-9452-c992f8fbeb91"
			],
			"autor": [
				"Raphael HHS ⭐"
			],
			"insta": "https://www.instagram.com/raphaelhhs/",
			"tags": "♂️",
			"twitter": "https://twitter.com/RaphaelHhs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0216e79a-3bcc-4cac-abd8-499a83d5131d/deusdachuva-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=01f1deca94cb0be05c6c58cf8cfae714440d787ff3ce8202be9bbbb956ffc5e5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:06:00.000Z",
			"id": "df12d508-d467-429a-bbe7-a24038c012a5",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "deusdachuva-hq  ",
			"data_leitura": "2023-10-05",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": "https://www.editorailustra-do.com.br/deus-da-chuva-one-shot/p",
			"link_leitura": "https://www.editorailustra-do.com.br/deus-da-chuva-one-shot/p",
			"name": "Deus da Chuva",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"eeaace21-e4e2-4dec-8758-1882a28ebf1c"
			],
			"autor": [
				"Lonpetrock"
			],
			"insta": "https://www.instagram.com/manga_deusdachuva/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/069d9fdf-9da1-4f0c-8dd8-6fca5910141d/amodestrebellion-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=ad3b46bf1eb861c626cd2824077bf45f1ace631e646d706137199ab5c6af73f0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-27T00:17:00.000Z",
			"id": "df45bb04-bea1-43cc-b03d-3c79e51710bc",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "amodestrebellion-hq  ",
			"data_leitura": "2023-09-26T22:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma15/a-modest-rebellion-by-laica-chrose/?lang=en,",
			"name": "A Modest Rebellion",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"c0498f9e-c712-4928-b3b4-2db3af59c56d"
			],
			"autor": [
				"Laica Chrose"
			],
			"insta": "https://www.instagram.com/laica.chrose/",
			"tags": "♀️",
			"twitter": "https://twitter.com/LaicaChrose"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2ccecbaf-e1e7-4207-a149-e56caa1a9fe6/invisible-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=9d8a602953cb33c52454f785a5c945e3bbc3be8ce5afd93494be4a06248865bb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-26T23:14:00.000Z",
			"id": "2ab5ca3b-2017-4d6d-a1a1-78ee540bc7c3",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "invisible-hq  ",
			"data_leitura": "2023-09-26T22:56:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma13/invisible-by-joo-eddie/?lang=en#0",
			"name": "Invisible",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"bd7e305f-fbde-45ab-8772-de9c9e6cf886"
			],
			"autor": [
				"João Eddie"
			],
			"insta": "https://www.instagram.com/joaoeddie",
			"tags": "♂️",
			"twitter": "https://twitter.com/joao_eddie"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d3c0eb3d-9dd7-4433-b0ca-1958b659618b/tattoo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=e6b5a7b7eac5b53bf18fa340449bc6c86dfa9b63605c87b48ea315e9388c0e5f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-26T23:13:00.000Z",
			"id": "cb639e71-b0ab-4758-8e56-38c4e137ae06",
			"contadores": [
				"No Shape"
			],
			"caps_lidos": "1",
			"imagem_name": "tattoo-hq  ",
			"data_leitura": "2023-09-26T22:25:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma10/tattoo-by-leonardo-himura-and-dani-bolinho/?lang=en",
			"name": "Tattoo",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"19d86a05-c01f-43f2-b4ca-5b632e61b78a"
			],
			"autor": [
				"Dani Bolinho ⭐"
			],
			"insta": "https://www.instagram.com/dani_bolim/",
			"tags": "♂️",
			"twitter": "https://twitter.com/BolimDani"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1c87bc27-0daf-47e9-867d-ba3bb14955b0/heartofthetruefriend-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=1a4efaa0aa3cf9f2e0eb9c401ac69fa189f177ea75647b8652da5e8b75ce9703&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-26T23:12:00.000Z",
			"id": "2fab168e-8131-47b2-8b99-0d46b53d9c95",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "heartofthetruefriend-hq",
			"data_leitura": "2023-09-26T21:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma9/heart-of-the-true-friend-by-juloyola/",
			"name": "Heart of the true Cake",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"08961d54-6825-41a2-a439-3ba341d5e7a6"
			],
			"autor": [
				"Ju Loyola"
			],
			"insta": "https://www.instagram.com/loyola_ju/",
			"tags": "♀️",
			"twitter": "https://twitter.com/loyola_ju"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7193d42e-ebb7-4bd0-9e62-b8aa229737f5/humanitystaste-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=3ba6c8cedf8644546533914edcaf4ad1c9b21d110fe1afca80fa6fb5cf02a0a9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-21T22:27:00.000Z",
			"id": "cebc4963-adf1-4ea4-8371-07a92169a9a6",
			"contadores": [
				"Aparições do Jeje"
			],
			"caps_lidos": "1",
			"imagem_name": "humanitystaste-hq  ",
			"data_leitura": "2023-09-21T23:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma7/humanitys-taste-by-studio-seasons/",
			"name": "Humanity’s Taste",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"88db6903-6042-4dea-91eb-3db28e1381db"
			],
			"autor": [
				"Studio Seasons"
			],
			"insta": "https://www.instagram.com/studio.seasons.manga",
			"tags": "♀️",
			"twitter": "https://twitter.com/studioseasons"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2ed7d901-98da-47c4-940e-f98b4c34a4e0/play-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=18ede3b70268844636e20548ea3faf967e88c8b0aed565e81bbad2afd6f5da5d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-21T22:24:00.000Z",
			"id": "1ad0e940-ad7b-439e-879c-fab15e91a9f0",
			"contadores": [
				"Calvos"
			],
			"caps_lidos": "1",
			"imagem_name": "play-hq  ",
			"data_leitura": "2023-09-21T21:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma4/play-by-roberto-f/",
			"name": "PLAY",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"7b2ff3b6-c46c-48f0-9c27-3578f2083e52"
			],
			"autor": [
				"Roberto F."
			],
			"insta": "https://www.instagram.com/mr.houseki/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Mr_Houseki"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/790e9e42-2df8-4ece-8b27-cac671d988a0/thankyou-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=8c20eda8916889420721357f195bfa0ff6b67ea3a4ef7173c83bc4cb6266a6db&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-21T22:21:00.000Z",
			"id": "aec52ecf-233c-4c9b-aaf2-048c08999fee",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "thankyou-hq  ",
			"data_leitura": "2023-09-21T22:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/smaex1/thank-you-by-joao-eddie/",
			"name": "Thank you",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"bd7e305f-fbde-45ab-8772-de9c9e6cf886"
			],
			"autor": [
				"João Eddie"
			],
			"insta": "https://www.instagram.com/joaoeddie",
			"tags": "♂️",
			"twitter": "https://twitter.com/joao_eddie"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/55d537f8-7c92-4048-94f3-ddf15110efac/lilyslove-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=da746de659c907ffea5cb8489cbaa043adfdac179a8703d6174897e1df8c324d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-19T22:06:00.000Z",
			"id": "8c800bc6-bcbc-4ccc-b1f3-69570e524f55",
			"contadores": [
				"Indigenas"
			],
			"caps_lidos": "1",
			"imagem_name": "lilyslove-hq  ",
			"data_leitura": "2023-09-19T21:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma14/lilys-love-by-mille-bitten-and-selene-hammer/?lang=en#0",
			"name": "Lily's Love",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"8cdbd618-4f2e-43d6-b87e-cad8da9611a5",
				"4a2d3376-c035-4142-a428-efda4614a99e"
			],
			"autor": [
				"Selene Hammer",
				"MilleBitten"
			],
			"insta": "https://www.instagram.com/selene.hammer",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fbbe885a-eda9-46b6-b6c6-4e5ba7eed9e8/neverlate-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=ea5265c4c18a90b15c4f6be84ce06a733d05da8cb53c7d320e666efe4815b538&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-19T22:03:00.000Z",
			"id": "60eeea2c-8a02-4371-8b9c-a6ac73e100cb",
			"contadores": [
				"Melhores Sinopses",
				"Calvos",
				"Desempregados \"Autonomos\" MEI ou sem direitos trabalhistas (\"\"Empreendedores\"\")",
				"CLTs"
			],
			"caps_lidos": "1",
			"imagem_name": "neverlate-hq  ",
			"data_leitura": "2023-09-19T22:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma12/never-late-by-lucas-marques-and-priscilla-miranda/?lang=en#0",
			"name": "Never Late",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"5041ec2b-69d4-4adb-88d9-8ed134016525",
				"f224ed6d-aa44-47f6-ad15-8b95f8be2b13"
			],
			"autor": [
				"Lucas Marques",
				"Priscilla Miranda"
			],
			"insta": "https://www.instagram.com/lucmarqx/",
			"tags": "♂️",
			"twitter": "https://twitter.com/lucmarqx"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2bb87f73-b66c-4707-933e-989d9e2a0afc/atinypromiseinaneverendingday-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=c7bd7193ab91d7f5d9965800e24a9063ffc1b930e9d330870b0d9646fcd68d24&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-19T21:58:00.000Z",
			"id": "217bf8d2-8922-4145-9622-6d3191d074f0",
			"contadores": [
				"Pais Fodas",
				"Quadrinhos Feels"
			],
			"caps_lidos": "1",
			"imagem_name": "atinypromiseinaneverendingday-hq",
			"data_leitura": "2023-09-19T22:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma11/a-tiny-promise-in-a-never-ending-day-by-psi-team-wmachado-rogrio-hanata-daniel-cipriano-and-jos-raue/?lang=en#0",
			"name": "A tiny promise in a never ending day",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"649b9961-6198-4a77-91e0-f535a1a645ac"
			],
			"autor": [
				"Rogério Hanata"
			],
			"insta": "https://www.instagram.com/rogeriohanata/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/497f24ab-a445-4238-94b2-829dd2593f0a/wecanhelp-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=101cabb77e71952f1441bfb731c14b0f33ec87a38be12bde58682d961c3ffb01&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-14T23:08:00.000Z",
			"id": "d618789e-df19-4860-89ba-cc591b76a58f",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "wecanhelp-hq  ",
			"data_leitura": "2023-09-14T23:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma9/we-can-help-by-camille-bittencourt/#0",
			"name": "We can help",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"4a2d3376-c035-4142-a428-efda4614a99e"
			],
			"autor": [
				"MilleBitten"
			],
			"insta": "https://www.instagram.com/millebittenart",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d7b1633c-34ae-4325-a939-17d97558c918/toyfriend-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=5e585d548d5189319556e40fd55a67e8babbf45a0f0db6cb4db3e9488782dac6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-14T23:05:00.000Z",
			"id": "f274988c-d9fa-4086-98f5-ff61fbb8f033",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "toyfriend-hq  ",
			"data_leitura": "2023-09-14T22:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma5/toy-friend-by-alan-morais-godinho/",
			"name": "Toy Friend",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"83f1e44a-ce3b-43e5-b57d-df25f0e38d62"
			],
			"autor": [
				"Alan \"Dark Hirkey” Godinho"
			],
			"insta": "https://www.instagram.com/dark_hirkey",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8ed5c93e-af17-4b10-8f78-063aa54d53f4/folklorewarriors98-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=4ed26b301e2fc4190187e54066cbf3d3819318125f6082a18ee90e95ad441375&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-14T23:02:00.000Z",
			"id": "fdc3dac7-b5da-4f88-83ef-a4fee64c50e3",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "folklorewarriors98-hq  ",
			"data_leitura": "2023-09-14T21:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma14/folklore-warriors-98-by-ricardo-mango/?lang=en#0",
			"name": "Folklore Warriors 98",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"ee3b4003-45ee-4238-a184-d547171a6650"
			],
			"autor": [
				"Ricardo Mango"
			],
			"insta": "https://www.instagram.com/ricardomango/",
			"tags": "♂️",
			"twitter": "https://twitter.com/_ricardomango"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1fd1fe99-88ff-4243-96f7-648274f80d72/justkeepdrawing-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=368e983c0e6856306ba6665a463efea6f08e8ad02fde27512cee0234fd898150&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-14T23:00:00.000Z",
			"id": "89c6a26e-0a85-4b8f-b029-3139a956ba55",
			"contadores": [
				"Quebras de quarta parede"
			],
			"caps_lidos": "1",
			"imagem_name": "justkeepdrawing-hq  ",
			"data_leitura": "2023-09-12T23:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma10/just-keep-drawing-by-dersa-marques/?lang=en#0",
			"name": "Just Keep Drawing",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"06d3b37a-8697-484b-9259-d920129c1c1e"
			],
			"autor": [
				"Dersa Marques"
			],
			"insta": "https://www.instagram.com/dersamarques/",
			"tags": "♂️",
			"twitter": "https://twitter.com/dersamarques"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bb31f0ea-1f06-482b-a2e4-dad4a1d9eb37/justaminute-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=49c7ca0bd1cdc94c13945a6c638515d766def84ad842301a61ba709f0850e048&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-14T22:58:00.000Z",
			"id": "969c7267-520f-4b5c-8dd8-c80300a3bca0",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "justaminute-hq  ",
			"data_leitura": "2023-09-12T22:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma8/just-a-minute-by-walther-romualdo/#5",
			"name": "Just A Minute",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"f548ba7a-0c7f-4513-9144-d0afeccb8eea"
			],
			"autor": [
				"Walther Romualdo"
			],
			"insta": null,
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7082ae66-7b83-489d-9db5-9ad0b924d77c/comeasyouare-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=28d5b41030acf30c2c00c68378abc1408b07a2fa358625faf44c515f187617a2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-14T22:55:00.000Z",
			"id": "8f549780-f9c2-4041-94ff-cabfdd8c6cba",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "comeasyouare-hq  ",
			"data_leitura": "2023-09-12T21:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma8/come-as-you-are-by-quillcannon-and-eudetenis/#0",
			"name": "Come As You Are",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"15ce72c7-4f8d-4807-bd7d-ff663cb73685",
				"3ed0d619-6c9a-4dab-81c5-2a43d3b42812"
			],
			"autor": [
				"Eudetenis",
				"Quillcannon"
			],
			"insta": "https://www.instagram.com/eudetenis/",
			"tags": "♂️",
			"twitter": "https://twitter.com/EUDETENIS"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/04d61f1a-e578-4c61-ac0c-746c11376c7f/quebraqueixo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=1d3a889bcd1fd5983030e8c77cd37a8fa6f2065a7a0fc3477141ee075a4a2c23&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-10T23:49:00.000Z",
			"id": "c27f4bf4-e746-4fe7-a37f-d347738d01ff",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "quebraqueixo-hq  ",
			"data_leitura": "2023-09-10T21:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma9/quebra-queixo-by-viwa-vinicius-de-souza-and-wmachado/#3",
			"name": "Quebra Queixo",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"1705dfef-ccac-42df-b453-53ca349b261e"
			],
			"autor": [
				"Vinicius de Souza"
			],
			"insta": "https://www.instagram.com/viniciusdesouzaart/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8a14c5e3-b94b-43bb-8f78-0d8dd4e4b180/roar-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=92c7bdeaeebab49510c7afdae57522832eb0e83593dbe32ed2752b93438e7eb7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-10T23:47:00.000Z",
			"id": "adcb8b06-f1fc-4a27-ae11-6228e3ff8680",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "roar-hq  ",
			"data_leitura": "2023-09-10T23:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma9/roar-by-daniel-bretas/#3",
			"name": "Roar",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"2c625568-0c92-4c6a-8b58-5a2f45294304"
			],
			"autor": [
				"Daniel Bretas"
			],
			"insta": "https://www.instagram.com/calaboca.co",
			"tags": "♂️",
			"twitter": "https://twitter.com/bisualvoy"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/32fb090c-6d9b-429c-b875-1bbf35993044/thepromisseofhappiness-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=e62f866868d59c345a1ea9d2dfc24f84ca232a4c38b7189a2e3d6c2e3b5c7490&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-10T23:28:00.000Z",
			"id": "c441a6f9-f7c6-4961-b3a4-4cfae9cdcad0",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "thepromisseofhappiness-hq  ",
			"data_leitura": "2023-09-10T22:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/smaex1/the-promise-of-happiness-by-juloyola/",
			"name": "The Promisse of Happiness",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"08961d54-6825-41a2-a439-3ba341d5e7a6"
			],
			"autor": [
				"Ju Loyola"
			],
			"insta": "https://www.instagram.com/loyola_ju/",
			"tags": "♀️",
			"twitter": "https://twitter.com/loyola_ju"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b9c448a5-f037-4aec-bafc-6562dfbe9ec2/tryagain-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=0b1f92c0e93f5067260eb1943e3f527276f3b606c91a8f517d0d550e14f58727&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-08T01:06:00.000Z",
			"id": "3a89d144-9027-46e3-9cae-87eca3b93059",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "tryagain-hq  ",
			"data_leitura": "2023-09-07T23:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma5/try-again-by-zazo-aguiar/",
			"name": "Try Again?",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"a7e21f52-ac62-4e3c-ad45-213ec5882184"
			],
			"autor": [
				"Zazo Aguiar"
			],
			"insta": "https://www.instagram.com/zazoaguiar/",
			"tags": "♂️",
			"twitter": "https://twitter.com/ZazoAguiar"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f17616d1-ab1f-44de-a0ef-fa181dcf45a8/6reasons-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=298aba25a1992be893fec22909522fbb7bfef35bf89fd15006cba9c745de09c9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-08T01:05:00.000Z",
			"id": "038f1bd0-cba6-4e58-89c7-174189150525",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "6reasons-hq  ",
			"data_leitura": "2023-09-07T21:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma3/six-reasons-by-roberto-f/",
			"name": "6 Reasons",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"7b2ff3b6-c46c-48f0-9c27-3578f2083e52"
			],
			"autor": [
				"Roberto F."
			],
			"insta": "https://www.instagram.com/mr.houseki/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Mr_Houseki"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/80baa50e-416a-45b2-bb64-414955d85593/lendahand-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=c82084870c15b10dc03bc20d6f63fb8584e7afb126d8df147bebc7acf292de44&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-08T01:04:00.000Z",
			"id": "ada11d59-9500-40d1-b3b4-916de1ae6e7b",
			"contadores": [],
			"caps_lidos": "0",
			"imagem_name": "lendahand-hq  ",
			"data_leitura": "2023-09-05T23:30:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/smaex1/lend-a-hand-by-max-andrade/#3",
			"name": "Lend a Hand",
			"porcentagem_leitura": 0,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"6465bc2a-15f1-450e-ab13-1f82f0da7b71"
			],
			"autor": [
				"Max Andrade"
			],
			"insta": "https://www.instagram.com/puffnopiripaf/",
			"tags": "♂️",
			"twitter": "https://twitter.com/puffnopiripaf"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a1a9bb2b-afaf-45c1-88e9-f74bcd32a2af/fishermantales-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=4f814ab1e8ab723a6654a337c2e3cc358c5ebf838d6d5c0c702cc213e5c211e4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-08T01:03:00.000Z",
			"id": "3e695df3-f54d-473e-8f05-bb5ec920b039",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "fishermantales-hq  ",
			"data_leitura": "2023-09-07T22:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma9/fisherman-tales-by-joao-eddie/",
			"name": "Fisherman Tales",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"bd7e305f-fbde-45ab-8772-de9c9e6cf886"
			],
			"autor": [
				"João Eddie"
			],
			"insta": "https://www.instagram.com/joaoeddie",
			"tags": "♂️",
			"twitter": "https://twitter.com/joao_eddie"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bd2d7750-8a46-4822-a9be-f94d04526d71/fathersgift-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=eb9ebcd8fef41653a7a31f7fddf76edbff1e4ebe15a867277969261476d35fd0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-05T23:32:00.000Z",
			"id": "891580ca-09d0-4410-8012-d6641986eac4",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "fathersgift-hq  ",
			"data_leitura": "2023-09-05T23:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma2/fathers-gift-by-ichirou/",
			"name": "Father’s Gift",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"af20bb9c-99d7-40ec-833f-ff6f8dc52970"
			],
			"autor": [
				"Ichirou"
			],
			"insta": null,
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/dc89a8bd-d2e2-49d6-aeef-c887d48c05d0/wannabealegend-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=de78ec4ad8d7ffb5f22eefd630eb41306cca98f649e1c8b26a361581f66b3401&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-05T23:05:00.000Z",
			"id": "733a35a1-2053-4b3f-af72-1246df259206",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "wannabealegend-hq  ",
			"data_leitura": "2023-09-05T22:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma6/wanna-be-a-legend-by-paaf/#0",
			"name": "Wanna be a Legend",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"6465bc2a-15f1-450e-ab13-1f82f0da7b71"
			],
			"autor": [
				"Max Andrade"
			],
			"insta": "https://www.instagram.com/puffnopiripaf/",
			"tags": "♂️",
			"twitter": "https://twitter.com/puffnopiripaf"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bc24ecdd-be3f-4bf2-a803-7f4709f9867d/rabbitfriend-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=77397f4d0b00a9046c4e12f1775f1f11dd92deff4e7d9b372cb7294bdb74edd4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-05T23:04:00.000Z",
			"id": "8fa22147-8e3d-4aa4-b400-880e08dd9c93",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "rabbitfriend-hq  ",
			"data_leitura": "2023-09-05T21:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma8/rabbit-friend-by-renata-rinaldi/",
			"name": "Rabbit Friend",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"dc4ad9e5-2ab0-400b-9201-9b06e49a3909"
			],
			"autor": [
				"Rê Rinaldi"
			],
			"insta": "https://www.instagram.com/tintaderaposa/",
			"tags": "♀️",
			"twitter": "https://twitter.com/raposamatcha"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/761c031b-bc38-48f9-a24a-c8568b264203/iniciao-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=94f1a62c0d2e1f6d8a00179fc7292d6eba17a3c893642a3e29dfc145c2bcad7c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-04T00:31:00.000Z",
			"id": "428245a1-5c9f-481c-8648-5ffa6968f65b",
			"contadores": [
				"Squad Goals"
			],
			"caps_lidos": "1",
			"imagem_name": "iniciação-hq",
			"data_leitura": "2023-09-03T22:12:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				}
			],
			"link_compra": "https://jamboeditora.com.br/produto/ordem-paranormal-vol-1-iniciacao/",
			"link_leitura": null,
			"name": "Ordem Paranormal - Iniciação",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"7c78cedb-935a-4644-9aac-c31b9ba4c071"
			],
			"autor": [
				"Akila ⭐"
			],
			"insta": "https://www.instagram.com/_akigabriel/",
			"tags": "♂️",
			"twitter": "https://twitter.com/HQ_Forma"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c476e97f-3073-486d-985b-fc44a0418479/someonetocare-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=c84d4b0cabfe6056c7e71b2cf676e5b7f59ed3a4b309bb0dd6517147b4cfebf6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-01T00:02:00.000Z",
			"id": "01e9365b-2662-4890-a6e7-91fd1cc980f9",
			"contadores": [
				"Noitadas",
				"Biritas"
			],
			"caps_lidos": "1",
			"imagem_name": "someonetocare-hq  ",
			"data_leitura": "2023-08-31T22:23:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma11/someone-to-care-by-lucas-marques-and-priscilla-miranda/",
			"name": "Someone To Care",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"f224ed6d-aa44-47f6-ad15-8b95f8be2b13"
			],
			"autor": [
				"Priscilla Miranda"
			],
			"insta": "https://www.instagram.com/priscillamirands/",
			"tags": "♀️",
			"twitter": "https://twitter.com/pricicologa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7b8a8d80-2c9c-4933-854a-7e8cb93fbde6/neitherbrightnordark-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=f8812c23cc1383cd66de3ed54fc4de4044ccfd700f75c8964d4fa55c1547b2ae&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-31T23:58:00.000Z",
			"id": "db4f7f97-e231-4c1b-b088-6187e25d32c2",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "neitherbrightnordark-hq  ",
			"data_leitura": "2023-08-31T22:42:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma13/neither-bright-nor-dark-by-laica-chrose/",
			"name": "Neither Bright Nor Dark",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"c0498f9e-c712-4928-b3b4-2db3af59c56d"
			],
			"autor": [
				"Laica Chrose"
			],
			"insta": "https://www.instagram.com/laica.chrose/",
			"tags": "♀️",
			"twitter": "https://twitter.com/LaicaChrose"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3eb49bcf-47f6-4a4e-8000-33f3f231ee61/grandmasflavor-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=22967cd3a8d0614323248d275d10e8c0aa78ec5f3b982b3d840957b5424eb9d4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-31T23:52:00.000Z",
			"id": "56835aa2-f306-47ca-922f-dbb5c1ca4308",
			"contadores": [
				"Vovós fofas",
				"Orfãos",
				"Cenas emocionantes"
			],
			"caps_lidos": "1",
			"imagem_name": "grandmasflavor-hq  ",
			"data_leitura": "2023-08-31T22:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma7/grandmas-flavor-by-eudetenis/#0",
			"name": "Grandma’s Flavor",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"15ce72c7-4f8d-4807-bd7d-ff663cb73685"
			],
			"autor": [
				"Eudetenis"
			],
			"insta": "https://www.instagram.com/eudetenis/",
			"tags": "♂️",
			"twitter": "https://twitter.com/EUDETENIS"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e1926b96-1336-4daf-85d4-e62f68ce26bd/matamata-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=87cdac63418d5b8b75339c78f2775b01709018aa8236d7e710fa2ca33978a660&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-29T22:39:00.000Z",
			"id": "10c2ae9d-21a9-4702-a286-fcb4e5845fa1",
			"contadores": [
				"Melhores Sinopses",
				"Legalizer",
				"Revoluções contra governos autoritarios",
				"Quadrinhos para ler chapado"
			],
			"caps_lidos": "4",
			"imagem_name": "matamata-hq  ",
			"data_leitura": "2023-08-29T22:45:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/s/serie/mata-mata?id=698",
			"name": "Mata Mata",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"56a37eb4-272a-42a3-8d61-7f2a2c0ac3a6"
			],
			"autor": [
				"Larissa Odarp ⭐"
			],
			"insta": "https://www.instagram.com/odarp.inkart/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b721ecfe-87a8-4d78-80b3-11d6f2ed1af3/memoriasagridoces-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=92e94c6d63b0c53e0aa1ee97ffce98185d1a35631df5eb0acce0a8ead86e4659&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-29T22:36:00.000Z",
			"id": "a49730c7-d6f9-435f-b069-d0d41d4cdbb7",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "memoriasagridoces-hq  ",
			"data_leitura": "2023-08-29T22:20:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/s/serie/memorias-agridoces?id=666",
			"name": "Memórias Agridoces",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"6dd09aec-6919-43e4-97b9-270c54802f73"
			],
			"autor": [
				"Nicoly “Niceea” ⭐"
			],
			"insta": "https://www.instagram.com/niiceea/",
			"tags": "♀️",
			"twitter": "https://twitter.com/niiceea"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/42c635f7-fa53-4e94-b146-15b07ce391a5/perolasperdidas-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=dbf59eee7cfacb50755bf22724768cdbaced10e34f19aadb854a990e7260c35f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-29T22:32:00.000Z",
			"id": "eeecf494-7790-44b3-b323-6562abf4872d",
			"contadores": [],
			"caps_lidos": "6",
			"imagem_name": "perolasperdidas-hq  ",
			"data_leitura": "2023-08-29T23:40:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/s/serie/perolas-perdidas?id=685",
			"name": "Pérolas Perdidas",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"04b581be-ae6e-42eb-a1e4-c4d6aa3a320e"
			],
			"autor": [
				"Sabina Anzuategui"
			],
			"insta": "https://www.instagram.com/sabina.anz/",
			"tags": "♀️",
			"twitter": "https://twitter.com/SabinaAnz"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fc90bd5d-b680-4f22-92f7-58bbe2c9833b/decisoes-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=d94a4abb1bdfb4b58f576900d0d2cf994ea5044f10380153ec681c428baed1a7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-29T22:29:00.000Z",
			"id": "5eee2f57-9a7b-4e64-85ac-4df29a7ed0c8",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "decisoes-hq  ",
			"data_leitura": "2023-08-29T23:25:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/s/serie/decisoes?id=370",
			"name": "Decisões",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"e4e24980-bb00-4649-85c1-be9b9f0fcbd3"
			],
			"autor": [
				"Jey"
			],
			"insta": "https://www.instagram.com/jeygglypuff/",
			"tags": "♀️",
			"twitter": "https://twitter.com/jeygglypuff"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2dc37b94-05ad-4425-85ee-7e27acf3ac92/forgetmenot-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4664XNTLQZW%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIGn7zxTzljXkqGWN2QbmHwoYWyjW%2BuhbVM9Q5sM%2Fd%2FAQAiEAy%2BACLxefef5b7t57exGBw1%2BlQt24MiqKHOZfgvLGKlIqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDKif7nPdsWUUk9H%2BuyrcA0a5i%2Fs2xcZ%2FMU9neTNgX%2BNtsguYCWPfpqxnBrZOn25JG438aPYQHeuSDFoIw11AjM7rDuQZ2rrm8a8vEdujygaUPSvuksv8xVJ1GuTWxUiiNV3h5URjDzHcRVAaX3yIIGduLMXkTFlGQpp3fUDb8UeXS%2B%2BERRr8r5%2Fsp0i8nOU%2FE4DbY6xrYd19j2KTQKX0mD6Whb1OppPKBmAAhMl5tAjGPFiBQ%2Fu9sak5tn5hf8Mz%2Fa%2BSAAc83yhLUlDePuVpvlaUhXj%2FNbDMwx5tpmulIA7Iz4sBlVObI%2BelqwxPnNlxt6v2J%2B7rRgWBzHvWjuZZOT8sE0JrLAjBZ1JWMxwTDSm4%2FcEO%2F1K6oC4pdMfd5gySDfF3cEyDMbLS%2FZp1ChaAYrb2jinyeWmlNJLgkBo3n5A5x2HMiULEnbXIawOwjufdsQrYB1ax7Jo1zQp1c7kzgYKLqdw49omNPgOvMflGRMnec1vhSt3MTGqCxJBjPHFsHudPQqdHpm9etBWxHq0Ek2ihKe%2FxzBsklz2bnSokWDy8jUXrtWKnPIw16u0Sx4ksrEQCNaRNZHDpAEG6R1uWyzf6hMoaO9vraD%2BxvDEOZsE23GPDwNMwUWC8bbfXVBiH9aqx2%2FI%2F%2Fzuxx80DMKG5q78GOqUBDRyQcqbRHBnP4yE%2FCOFq4e40%2BDNxAfUk3VyPBnRPSVspFBMiBkmFw2v5NX7Jjkgym2%2FPSNR8OuOdP2EB0UJNe3WStC8XqK5bqBFQ3ja3lXUXFOgYt7IxeF%2Bi1isgGq3lnljRQSUCvtZK%2Fpt0I1D9ohk3DgHmHfKrF95ruO7j6J%2Fa1E8uaxnx0eAIoosHOS0rVOH8O3tQ274eMQk%2Bi0wpxUXaTBbU&X-Amz-Signature=f18c127327d1b979cf6fbd74c7557e88f02845114c2c817f8c71029574e12d0a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-29T22:25:00.000Z",
			"id": "f272b5ea-b8a6-4baa-a71f-73081bccdf5c",
			"contadores": [
				"Orfãos"
			],
			"caps_lidos": "1",
			"imagem_name": "forgetmenot-hq  ",
			"data_leitura": "2023-08-29T21:55:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/serie/586",
			"name": "Forget-me-not",
			"porcentagem_leitura": 11,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"b9fa13a8-088d-42ea-8fcd-e3a9e2b0a044"
			],
			"autor": [
				"Debbie Garcia ⭐"
			],
			"insta": "https://www.instagram.com/debbiegarcia/",
			"tags": "♀️",
			"twitter": "https://twitter.com/florescativas"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bb534fca-6961-4475-b0b7-a236d83d5440/oretratoinacabadodemadamebardin-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=7feb996718dee55c9b6a20be6e8d183253b245a711500a2c5b2aea0d82665602&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-28T00:08:00.000Z",
			"id": "5f412d82-407f-41b4-85ee-47aa0d4812a8",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "oretratoinacabadodemadamebardin-hq  ",
			"data_leitura": "2023-08-27T21:45:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/RetratoMadame/info",
			"name": "O Retrato Inacabado de Madame Bardin",
			"porcentagem_leitura": 27,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"50d9467e-350d-4f04-b3f3-962a48135e19"
			],
			"autor": [
				"Lari “Lariarts” Macedo ⭐"
			],
			"insta": "https://www.instagram.com/lariarts/",
			"tags": "♀️",
			"twitter": "https://twitter.com/lariarts"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4272b61a-591d-4bce-a454-8a1d1ee309e8/jucistar-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=4431fe68c91cabae4095e11becaca5e72da03214cb142cf2034e760951c465b6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-28T00:05:00.000Z",
			"id": "a80ba308-39b9-4bf0-9c4b-5725cd54d054",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "jucistar-hq  ",
			"data_leitura": "2023-08-27T22:15:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/s/serie/jucistar?id=682",
			"name": "Juci⭐Star",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"de5ababf-5214-4ad1-b2fa-86868495af1e"
			],
			"autor": [
				"Carine “Coisarine” Araújo"
			],
			"insta": "https://www.instagram.com/coisarine/",
			"tags": "♀️",
			"twitter": "https://twitter.com/coisarine"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5f8f2200-fb9a-4150-be6e-9db9c0926f65/boitataespacial-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=49104ffe18a0e6ebdf6bc75daa6d9deaeff2ddf7fbed20e338203fdc46be0553&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-28T00:01:00.000Z",
			"id": "3c2a8ed8-7d23-4394-9a1b-6d5f34b520dc",
			"contadores": [
				"Revoluções contra governos autoritarios",
				"Cliffhangers foda",
				"Alienígenas"
			],
			"caps_lidos": "25",
			"imagem_name": "boitataespacial-hq  ",
			"data_leitura": "2023-08-27T23:20:00.000-03:00",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/boitata",
			"name": "Boitata Espacial",
			"porcentagem_leitura": 42,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "59",
			"autores": [
				"370a5d3a-a76e-4ba0-86f4-39bb8362886a"
			],
			"autor": [
				"Raviolivs"
			],
			"insta": "https://www.instagram.com/raviolifolio/",
			"tags": "♀️",
			"twitter": "https://twitter.com/raviolivs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/11681e31-cea5-4faf-84e1-bbcabc8f88d0/cursedwolf-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=7dfd43d45ce694c661d3c14fc96f93da52ae64864dfc7855bc8e66865b96c4cf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-25T00:06:00.000Z",
			"id": "5d73e71d-f4ca-40f1-b2a4-9e4eced5beb8",
			"contadores": [
				"Criaturas sobrenaturais"
			],
			"caps_lidos": "3",
			"imagem_name": "cursedwolf-hq  ",
			"data_leitura": "2023-08-24T22:35:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Cursed-Wolf/info",
			"name": "Cursed Wolf",
			"porcentagem_leitura": 100,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"b09e6692-f831-45c4-b023-752ae1af5c6c"
			],
			"autor": [
				"Cah Spirit"
			],
			"insta": "https://www.instagram.com/spiritcrowstudio/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c1634cab-2725-4775-bc7a-cf07c68cb654/overwift-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=93c50cf3446889e7fb7dcb5f411fa7634869b7338599a6aa391dd01171713ae8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-25T00:01:00.000Z",
			"id": "aa3ee854-0c0e-4d34-acae-5ea17f607be1",
			"contadores": [
				"Isekai"
			],
			"caps_lidos": "1",
			"imagem_name": "overwift-hq  ",
			"data_leitura": "2023-08-24T21:40:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Overwift/info",
			"name": "Overwift",
			"porcentagem_leitura": 100,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"2587c142-3d6c-48b5-87f8-638a1a64dd05"
			],
			"autor": [
				"mariihsartt"
			],
			"insta": "https://www.instagram.com/mariihsartt/",
			"tags": "♀️",
			"twitter": "https://twitter.com/mariihsartt"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/08577d87-9a52-408f-a31a-99664f0eb760/amunatan-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=28cb1ae24d191c486f8201cd4a83e3d5b49c2b1d80280fb68ddd4e4ad2ec3579&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-24T23:56:00.000Z",
			"id": "fb5c8334-7908-4da4-890d-87fd74b74b92",
			"contadores": [
				"Inícios mitológicos"
			],
			"caps_lidos": "3",
			"imagem_name": "amunatan-hq",
			"data_leitura": "2023-08-24T22:05:00.000-03:00",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/amunatan?origin=chapter-nav-button&extra=list",
			"name": "Amun’Atan",
			"porcentagem_leitura": 20,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "15",
			"autores": [
				"9478d4c4-3d0a-4af0-8818-cd867f94ceb3"
			],
			"autor": [
				"Krizael ⭐"
			],
			"insta": "https://www.instagram.com/krizael/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/53176250-27a1-4bd6-ae02-671d5c8cee66/thebrideofthefox-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=616b9fbae11ba0fa8bef237a9d9aea4245b915ff7430c3a0d7f6c8073dc98989&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-24T16:10:00.000Z",
			"id": "bac85bed-0ab9-41d8-a285-0dbf4491fbe4",
			"contadores": [
				"Pais Fodas",
				"Furry"
			],
			"caps_lidos": "11",
			"imagem_name": "thebrideofthefox-hq  ",
			"data_leitura": "2023-08-22T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/The-Bride-of-the-Fox-PT-BR/info",
			"name": "The Bride of the Fox",
			"porcentagem_leitura": 7,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "145",
			"autores": [
				"3335884f-c66f-42f8-9ca5-e6be99b4a456"
			],
			"autor": [
				"Mmyoi"
			],
			"insta": "https://www.instagram.com/mmyoi_art/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f01a9b35-1590-411f-b647-60d0319cba18/ossonsqueouo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=4c3fe583d050a694060965d496180f1e397e8eec8e70af0d3af3b0efb5842e2b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-24T16:02:00.000Z",
			"id": "a6ea284f-c025-48eb-a3d4-59ca773aa567",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "ossonsqueouço-hq",
			"data_leitura": "2023-08-22T22:30:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.webtoons.com/en/canvas/os-sons-que-ou%C3%A7o/list?title_no=884933",
			"name": "Os sons que ouço",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"fc661167-528b-4314-a048-ece7d5039c04"
			],
			"autor": [
				"Sara “Floras” Camargo ⭐"
			],
			"insta": "https://www.instagram.com/_floraas/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/64579d35-c96a-4f76-81ba-e241a231ae32/krestgale-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=004821c65076ab61c16d915188424873a35bfb58d20ecdd74300824bf89d397c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-24T15:54:00.000Z",
			"id": "bb2168c6-5bf5-4eba-97f7-360e9fd457ba",
			"contadores": [
				"Pais Fodas"
			],
			"caps_lidos": "2",
			"imagem_name": "krestgale-hq  ",
			"data_leitura": "2023-08-22T21:45:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.zinnes.com.br/serie/341",
			"name": "Krest Gale",
			"porcentagem_leitura": 66,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"2365a7b3-17c0-446d-8fe3-481dda2989fc",
				"6ded92b5-9237-4ad7-a0f2-ed5d9a20db15"
			],
			"autor": [
				"Fernanda Cardozo ⭐",
				"João Kaile"
			],
			"insta": "https://www.instagram.com/krestgale/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3eed69f5-69f0-42a0-bee6-82515c715a0f/samael-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=3d08265d80ee842d3c69a5cf389fa026f14c781be9bb0292b0c07a31fe3e23ba&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-21T16:39:00.000Z",
			"id": "8247c1b6-da5b-4769-9404-dab9fa591caf",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "samael-hq  ",
			"data_leitura": "2023-08-20T22:40:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Samael-PT-BR/info",
			"name": "Samael",
			"porcentagem_leitura": 5,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "19",
			"autores": [
				"e9b47739-2781-4626-bab2-dbbac7f2278e"
			],
			"autor": [
				"Endermaul"
			],
			"insta": "https://www.instagram.com/endermaul_art/",
			"tags": "♀️",
			"twitter": "https://twitter.com/endermaul_bleh"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4bb1ac90-fe0b-48e7-a0fb-0b391124e526/dandara-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=fbf31731f9a2ea05ee3b63a5600bfdce7cd1ec732a4b282a9506823588baee8f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-21T16:32:00.000Z",
			"id": "180c74ab-8544-4f28-8e2f-08a01bb72a51",
			"contadores": [
				"Melhores Sinopses"
			],
			"caps_lidos": "4",
			"imagem_name": "dandara-hq  ",
			"data_leitura": "2023-08-20T22:00:00.000-03:00",
			"genero": [
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/HQ-Dandara/info",
			"name": "Dandara",
			"porcentagem_leitura": 36,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"304ea369-c65f-46ae-8cbe-e0f5a4f476f9"
			],
			"autor": [
				"Lana Portiguara"
			],
			"insta": "https://www.instagram.com/lanaflowerz/",
			"tags": "♀️",
			"twitter": "https://twitter.com/lanaflowerz"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c25298c2-3aec-4710-9217-a5184a3f62fc/metalmancer-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=78becc2804e0c79905e28b0406a17ec1647d06172489956b764c59d84d369a46&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-18T02:40:00.000Z",
			"id": "68c391e8-079c-49ef-9996-e441b8e06ef4",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "metalmancer-hq  ",
			"data_leitura": "2024-06-06",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Metalmancer",
			"name": "Metalmancer",
			"porcentagem_leitura": 1,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "85",
			"autores": [
				"c4a055e4-72c7-4854-ab4e-1962c3684aac"
			],
			"autor": [
				"Jéssica “Neon Jess” Lang"
			],
			"insta": "https://www.instagram.com/_neonjess",
			"tags": "♀️",
			"twitter": "https://twitter.com/_neonjess"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d5d8e812-84d0-43ea-ae31-eed3fecdb418/oabismo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=bd2f86c17072916d5585875fc253e994ad585dd6e25243338a4e5379885198b2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-16T02:16:00.000Z",
			"id": "66498b9b-60ef-4b3c-bce8-023f706eaf50",
			"contadores": [],
			"caps_lidos": "22",
			"imagem_name": "oabismo-hq  ",
			"data_leitura": "2023-08-17T21:50:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/O-Abismo",
			"name": "O Abismo",
			"porcentagem_leitura": 16,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "130",
			"autores": [
				"67d378ee-2f6a-4d92-8cde-b7cdd5ae3d3e"
			],
			"autor": [
				"Má Matiazi ⭐"
			],
			"insta": "https://www.instagram.com/mamatiazi/",
			"tags": "♀️",
			"twitter": "https://twitter.com/mamatiazi"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/df1e5468-3bb1-4e1d-b386-c457af34222f/desculpaeugostodevc-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=31753a254693aaf27a39756e5b2222eb82c1fb2a949f8150b8207d76dd8ca678&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-15T23:53:00.000Z",
			"id": "96f7930f-cb9f-4a31-9d53-5dc4179f6300",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"Personagens de Óculos",
				"Ogras",
				"Protagonistas sentados na janela",
				"Hehe",
				"Camisas 10",
				"Quadrinhos conhecidos por um nome que não é o nome dele",
				"Comidas aconchegantes",
				"Beijocas",
				"Entrando pela janela"
			],
			"caps_lidos": "17",
			"imagem_name": "desculpaeugostodevc-hq  ",
			"data_leitura": "2023-08-17T22:40:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/desculpa-eu-gosto-de-voce-k7kk",
			"name": "Desculpa eu gosto de você",
			"porcentagem_leitura": 94,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "18",
			"autores": [
				"a7cb1646-de96-4d98-8745-6872b3c25544"
			],
			"autor": [
				"ClauMazzu ⭐"
			],
			"insta": "https://www.instagram.com/claumazzu/",
			"tags": "♀️",
			"twitter": "https://twitter.com/ClauMazzu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5e589fd9-71d7-4db5-9c25-c8256ba7cef0/dahlia-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=37ceca4f3e790b26e6cbbc2447079d4837c24bc65a235e02a57133919eb0215b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-12T02:39:00.000Z",
			"id": "4947fa9e-cb78-4f5d-8be1-bf8ee763df80",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "dahlia-hq",
			"data_leitura": "2023-08-13T22:35:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/serie/828",
			"name": "Dahlia",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"846bb6b2-a380-492a-a0ff-4ca07d2bb75c"
			],
			"autor": [
				"Mari Casimiro"
			],
			"insta": "https://www.instagram.com/mari.casimiro82/",
			"tags": "♀️",
			"twitter": "https://twitter.com/mari_casimiro82"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e7666a10-4612-49ad-accb-b22e2115844b/cores-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=22c4eec6977b853c0fcdbeb698ef5b1a266124d9346c34501ae5c0fe4d6f5ebe&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-11T00:13:00.000Z",
			"id": "d3bd3ee6-49d2-4404-8c90-13b82df29b8e",
			"contadores": [
				"Críticas Sociais Foderosas",
				"Quebras de quarta parede"
			],
			"caps_lidos": "20",
			"imagem_name": "cores-hq",
			"data_leitura": "2023-08-10T23:15:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.facebook.com/photo/?fbid=1021176724668537&set=a.867626760023535.1073741856.562486247204256",
			"name": "Cores",
			"porcentagem_leitura": 31,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "64",
			"autores": [
				"a64e1682-fb4e-4235-b072-008746739ef4"
			],
			"autor": [
				"Carol Rossetti"
			],
			"insta": "https://www.instagram.com/carolrossettidesign/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d2cd692c-45a8-4c38-ae08-112a46aa0758/asperipeciasdegabi-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=acf8e20d0492ae064a70ea94154f54e26c8ff7dfd70eb732b8a14d2df9ee2440&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-11T00:11:00.000Z",
			"id": "0ed97ee9-4e05-40f4-944d-1ac32b54b392",
			"contadores": [],
			"caps_lidos": "4",
			"imagem_name": "asperipeciasdegabi-hq",
			"data_leitura": "2023-08-10T21:46:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/As-Peripecias-de-Gabii/info",
			"name": "As Peripécias de Gabi",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"698239f4-bec1-4a2f-ba2c-63423048f1f8"
			],
			"autor": [
				"Cristal Ilustra ⭐"
			],
			"insta": "https://www.instagram.com/cristalilustra/",
			"tags": "♀️",
			"twitter": "https://twitter.com/TheCristalDS"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/da9874bd-5ce5-4096-85aa-a752e1b0263b/brisaerrada-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=539349d3ab1058b5d10ff3d40733c696a382d12beae1c5d6a6ef26c47f46b0b6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-09T02:08:00.000Z",
			"id": "ca1176bc-a12c-4d65-a5f4-2c6dfa7c3b53",
			"contadores": [
				"Melhores Sinopses",
				"Quadrinhos com trilha sonoras indicadas pelo autor",
				"Quadrinhos Reflexivos",
				"Quadrinhos pra se ler no churrasco"
			],
			"caps_lidos": "21",
			"imagem_name": "brisaerrada-hq",
			"data_leitura": "2023-08-13T21:30:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/1485328",
			"name": "Brisa errada",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "21",
			"autores": [
				"28301475-072d-474d-8b7c-514b2cb6ae8d"
			],
			"autor": [
				"Amanda Treze ⭐"
			],
			"insta": "https://www.instagram.com/amdtreze/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/64bdb447-ed95-46a5-a951-e9398ad8ad24/karina-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=ab2b8a7f72121b7c0b854b4bcce97906937f376a44e144089c6a9e420652e0ba&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-08T22:54:00.000Z",
			"id": "cc638d80-47bc-4bb1-9096-dd7a2accaf4d",
			"contadores": [
				"CLTs"
			],
			"caps_lidos": "1",
			"imagem_name": "karina-hq",
			"data_leitura": "2023-08-08T22:16:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/karina_ptbr/info",
			"name": "Karina",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"f8f947af-1208-4456-be55-eebf99886494"
			],
			"autor": [
				"Loreartsy"
			],
			"insta": "https://www.instagram.com/loreartsy",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/70dcb365-9637-4180-adf7-eb1750e26909/bear-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=c4fbd4cd501643fd80f3762e7e76288c2a1b77946ddbcc98ecb100c1e2460032&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-08T22:50:00.000Z",
			"id": "bb7a7bc7-81f6-43d0-9845-c7499c7f7809",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "bear-hq",
			"data_leitura": "2023-08-08T21:40:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://bear-pt.tumblr.com/",
			"name": "Bear",
			"porcentagem_leitura": 25,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"16cf2f41-3870-42af-8af8-c3dce7a6a9d7"
			],
			"autor": [
				"Bianca Pinheiro"
			],
			"insta": "https://www.instagram.com/bianc_pinheir/",
			"tags": "♀️",
			"twitter": "https://twitter.com/bianc_pinheir"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0ecfafb5-976b-43c8-b64e-601ce9316438/cortinarasgada-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=d731b1178ad7b5a2b875555bd4d51d31a0959798a04c7de3d1544326e982b2bf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-08T22:43:00.000Z",
			"id": "b20f429b-8ec4-4a35-9463-2bc536fb2a56",
			"contadores": [
				"Beijocas"
			],
			"caps_lidos": "17",
			"imagem_name": "cortinarasgada-hq",
			"data_leitura": "2023-08-08T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.instagram.com/curupira.maria/",
			"name": "Cortina Rasgada",
			"porcentagem_leitura": 17,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "100",
			"autores": [
				"be3697cf-fa7c-4eed-814b-52fcd83ebb6d"
			],
			"autor": [
				"Maria Jupira"
			],
			"insta": "https://www.instagram.com/curupira.maria/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/54139c9a-a0c9-4a8d-8591-56bf061779a4/kungfu-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=d1ebe10b5b5f415365cd2990e32c52d9ec527c04e763003cfcb8c90c1686d6d8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-06T17:40:00.000Z",
			"id": "147936a6-60fc-40ca-889b-f1685c3089c2",
			"contadores": [
				"Idosos sendo agredidos"
			],
			"caps_lidos": "1",
			"imagem_name": "kungfu-hq",
			"data_leitura": "2023-08-15T22:10:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://ellieirineu.artstation.com/projects/0nDmY4",
			"name": "Kung-Fu",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"6b3cfec4-1380-4d22-bf87-91bf273c2ca0"
			],
			"autor": [
				"Ellie Irineu"
			],
			"insta": "https://www.instagram.com/ellie.irineu/",
			"tags": "♀️",
			"twitter": "https://twitter.com/gentenemegente"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8d1f4ea5-bf80-40c4-a3b7-bbd1e0174456/escritoriodospassaros-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=fa945b0223d8dc28dd9c496fbf1687de0883e5da85e9ef33d2ca81af57513ccd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-06T17:39:00.000Z",
			"id": "338b9eef-4914-4112-975c-343bbeee9fc4",
			"contadores": [
				"Melhores Sinopses",
				"Críticas Sociais Foderosas"
			],
			"caps_lidos": "12",
			"imagem_name": "escritoriodospassaros-hq",
			"data_leitura": "2023-08-15T21:37:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/serie/75",
			"name": "Escritório dos pássaros",
			"porcentagem_leitura": 15,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "79",
			"autores": [
				"fdf16b91-95f8-421d-b8da-b8370a813ed9"
			],
			"autor": [
				"Lark"
			],
			"insta": "https://www.instagram.com/larkness_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/larknessart"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ec97b832-fae4-43d7-8a5d-b61954346aa1/tudoounada-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=dfe197d1ffd2c083397daa25044454503fc56ae249120be20130e578000b9ddc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-04T00:10:00.000Z",
			"id": "5d7ceeb6-3054-442a-9d1b-4230cd8cea50",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "tudoounada-hq",
			"data_leitura": "2023-08-03T22:45:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.stecavalcantiart.com/post/tudo-ou-nada-historia-curta",
			"name": "Tudo ou nada",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"eca31094-c3f8-4058-89df-80754dc9adb3",
				"f40ae311-6bd7-4aa1-a2a7-a40bb6ed3ab1",
				"366e9ce3-d848-4426-abae-3cb38cb40148"
			],
			"autor": [
				"Sté Cavalcanti ⭐",
				"Marcella Fiorelli",
				"Gabriel Baptista"
			],
			"insta": "https://www.instagram.com/_stecavalcanti",
			"tags": "♀️",
			"twitter": "https://twitter.com/stearts"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/30f59e1e-6aef-4d2e-9373-192c580a6873/bemdoseulado-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=ecc9876f4872ce6e7937d16eed414ee898faa4e0da198f6fbf205c7c7be2e613&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-04T00:06:00.000Z",
			"id": "73f51b33-a312-4ce4-abf6-9b85c827c438",
			"contadores": [
				"Squad Goals",
				"Camisas 10",
				"Personagens PCD"
			],
			"caps_lidos": "12",
			"imagem_name": "bemdoseulado-hq",
			"data_leitura": "2023-08-03T21:30:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Bem-Do-Seu-Lado/info",
			"name": "Bem do seu Lado",
			"porcentagem_leitura": 100,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "12",
			"autores": [
				"cb3709e6-092d-4643-8727-c1d63b80a1c3"
			],
			"autor": [
				"IsaGC ⭐"
			],
			"insta": "https://www.instagram.com/isacg_01/",
			"tags": "♀️",
			"twitter": "https://twitter.com/isaCG_01"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/656354b7-3982-442f-8163-8fb93f9e8c9b/potentia-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=68dbf0c854e7665d5a6520fb1827b38e58d70b1dc596d617964ce88537860d48&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-02T02:31:00.000Z",
			"id": "978692df-dde8-4d9c-aeb4-5e9d48349776",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "potentia-hq",
			"data_leitura": "2023-08-15",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Shoujo",
					"color": "pink"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/potentia?origin=&extra=profile",
			"name": "Potentia: Hero",
			"porcentagem_leitura": 10,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"dd110086-2650-43b7-822f-e0b70ce2656e"
			],
			"autor": [
				"Yel Mizuno"
			],
			"insta": "https://www.instagram.com/yelmizuno/",
			"tags": "♀️",
			"twitter": "https://twitter.com/mizunoyel"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/05d48ed7-b69f-4f5a-b379-360080fe81e6/orca-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=84393bd38b193a515d2144b839c05020ceffce604cecdf3aed98458f66108821&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-02T02:29:00.000Z",
			"id": "491b817b-61c5-484e-8c98-247559e01468",
			"contadores": [
				"Homens vs Natureza",
				"Cabelos Estilosos",
				"Beijocas",
				"Furry"
			],
			"caps_lidos": "1",
			"imagem_name": "orca-hq  ",
			"data_leitura": "2024-04-27",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/orca?origin=&extra=profile",
			"name": "Orca",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"fae88c26-6738-4485-8741-b1172c1596f6"
			],
			"autor": [
				"Loba Art ⭐"
			],
			"insta": "https://www.instagram.com/loba.art/",
			"tags": "♀️",
			"twitter": "https://twitter.com/ArtLoba"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/51a41513-f1f9-479b-8953-116af95085bd/starsquad-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=c0cb282af748c13016f0ae130bb0124d86c326eaffd8f0925966a72371b026d3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-01T22:44:00.000Z",
			"id": "a3074102-e47a-447a-8fe6-d12a804145fc",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "starsquad-hq",
			"data_leitura": "2023-08-01T21:40:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": "https://ilustrado.my.canva.site/",
			"link_leitura": null,
			"name": "Star Squad",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"9a6601b8-47e9-4c9f-a3c7-7f6c011e2376"
			],
			"autor": [
				"Dibis Conrado ⭐"
			],
			"insta": "https://www.instagram.com/dibis_conrado/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b1eb0cb9-1510-42f6-aa8d-f00a4120190e/florestadosespiritos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=a7d7bf4bd3b8d97a0304fdc303cbd2179a9d3d2171c2b57c355cf34b4c1bb904&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-01T22:40:00.000Z",
			"id": "b9174c78-933e-438b-8993-8fd6c65f37c4",
			"contadores": [
				"Vilarejos em um mundo Fantasia",
				"Heróis duvidosos",
				"Golpes bem aplicados"
			],
			"caps_lidos": "1",
			"imagem_name": "florestadosespiritos-hq",
			"data_leitura": "2023-08-01T22:30:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": "https://ilustrado.my.canva.site/",
			"link_leitura": null,
			"name": "Floresta dos Espíritos",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"969ccfc9-ca78-4e38-8a7a-901ce09084d8"
			],
			"autor": [
				"Little Tenshi ⭐"
			],
			"insta": "https://www.instagram.com/lyttle_tenshi_arts/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1b52ff1a-2d86-4a86-bd81-4f092e86de3a/azurasheart-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=7cf7f523df33138dfeceecd66c4f11a7903cda6a287795c26b7c4d5c6d3625ea&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-01T22:31:00.000Z",
			"id": "56104468-872b-4e2e-a0f8-9b6c00a4b05b",
			"contadores": [
				"CLTs",
				"Camisas 10"
			],
			"caps_lidos": "1",
			"imagem_name": "azurasheart-hq",
			"data_leitura": "2023-08-01T23:10:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/azuras-heart",
			"name": "Azura’s Heart",
			"porcentagem_leitura": 12,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "8",
			"autores": [
				"54dc9681-88cb-4cce-b950-ed407e9242a9"
			],
			"autor": [
				"Dani Martins"
			],
			"insta": "https://www.instagram.com/dannimee",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e064d328-7ee7-4663-a174-8b8f28926324/ada-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=d52a31b05f81d72ea7fb831d97fdbae627a3d8bc53dd739b24cdc5e816f7f72d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-30T23:56:00.000Z",
			"id": "25c2cd7f-be31-4494-8c82-692cc88f5435",
			"contadores": [
				"Vovós fofas",
				"Bullies",
				"Escolas que ninguem tem aula de verdade"
			],
			"caps_lidos": "1",
			"imagem_name": "ada-hq",
			"data_leitura": "2023-08-13T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Ada",
			"name": "Ada",
			"porcentagem_leitura": 20,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"0889d274-087c-4208-a66a-17f4a86c0cd4"
			],
			"autor": [
				"Samanta Flôor"
			],
			"insta": "https://www.instagram.com/samantamanta/",
			"tags": "♀️",
			"twitter": "https://twitter.com/samantamanta"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2e99a882-3033-465f-9a55-77d1e5a36217/ahistoriadepiabinha-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=a6d40a18599e9e74f892a0e62525be4836acb13d8a1d73b6d4078b85a43b0e21&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-30T23:54:00.000Z",
			"id": "d01d19cf-506b-4b3b-a3fd-a544f8353c3f",
			"contadores": [
				"Quadrinhos Feels"
			],
			"caps_lidos": "2",
			"imagem_name": "ahistoriadepiabinha-hq  ",
			"data_leitura": "2023-08-17T23:30:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/A-Historia-de-Piabinha-PT-BR/info",
			"name": "A Historia de Piabinha",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"a287bdb2-9802-4513-bd50-d2f2f3aca983"
			],
			"autor": [
				"Debs"
			],
			"insta": "https://www.instagram.com/boradebs/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cf7ae016-27ad-4340-b9ff-2f78c0f89a93/sanguedoce-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=290dc74e14680223042d7ac079253d4a971f67089defe42b1f14ed12e1e2687b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-27T23:53:00.000Z",
			"id": "3220051e-5e4e-499c-b773-af1090586ccd",
			"contadores": [
				"Melhores Sinopses"
			],
			"caps_lidos": "6",
			"imagem_name": "sanguedoce-hq",
			"data_leitura": "2023-07-27T22:10:00.000-03:00",
			"genero": [
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/SangueDoce/info",
			"name": "Sangue Doce",
			"porcentagem_leitura": 16,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "37",
			"autores": [
				"ce185b5d-3fd1-485e-8575-9853f0304624"
			],
			"autor": [
				"Anju"
			],
			"insta": "https://www.instagram.com/4njuart/",
			"tags": "♀️",
			"twitter": "https://twitter.com/4njuart"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2a65232b-62e8-4ac0-8e6a-f2fdb392cc9a/metagemma-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=8b8c3aee9319dcd13bb4e9e224f065da9d575d433ac1457729582ebe9aa532ed&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-27T23:49:00.000Z",
			"id": "e95c0ee3-03c8-4923-ac24-bded8853a041",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "metagemma-hq",
			"data_leitura": "2023-07-27T23:39:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/metagemma",
			"name": "Metagemma",
			"porcentagem_leitura": 33,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"2c02b408-7ac6-41bb-b014-00646a56c5e2"
			],
			"autor": [
				"LoveGameplayz"
			],
			"insta": "https://www.instagram.com/love_gameplayz/",
			"tags": "♀️",
			"twitter": "https://twitter.com/Lovegameplayz"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/34e11c2d-dfcc-4aad-affd-d8c632eda7c7/abolhadesol-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=e51b768c57fa9d4667dfdde56827cda0bee0f500d6f0e6779cda64e0542aab0f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-27T23:42:00.000Z",
			"id": "ab1b63c1-3408-494f-a595-2759c4d41348",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "abolhadesol-hq",
			"data_leitura": "2023-07-25T22:40:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-bolha-de-sol-fxve",
			"name": "A Bolha de Sol",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"18f3da79-246e-4fd6-8b8b-011ba4b2ef15"
			],
			"autor": [
				"Nicomikha"
			],
			"insta": "https://www.instagram.com/nicomikha/",
			"tags": "♀️",
			"twitter": "https://twitter.com/nicomikha"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b4bd6000-d44c-4e19-ae7d-276218907962/lostlilled-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=2095aadba442d195e9b30d541f978d6edbaee2ec77ccd4a28e49c2b61f98df37&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-27T23:36:00.000Z",
			"id": "69110e23-6b70-4f64-b52a-6b12281d0430",
			"contadores": [
				"Último sobrevivente do clã",
				"Máscaras Maneiras",
				"Quebras de quarta parede",
				"Protagonistas perdidos",
				"LQN Aparecendo em Quadrinhos Nacionais",
				"Akira reference",
				"Heterofobia nos olhos",
				"Escolas que ninguem tem aula de verdade"
			],
			"caps_lidos": "2",
			"imagem_name": "lostlilled-hq",
			"data_leitura": "2023-07-25T22:10:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/s/serie/lost-lilled?id=744",
			"name": "Lost Lilled",
			"porcentagem_leitura": 16,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "12",
			"autores": [
				"6ccde704-9fd4-42ee-adcf-f4fb60869e4a"
			],
			"autor": [
				"Magic Rold ⭐"
			],
			"insta": "https://www.instagram.com/magic_rold/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4e549180-a326-4d4f-bbee-41541aa394b7/ogarotodosino-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=57872eb8ac746cbf2fe45ae6ed16ef4e39bf17c404abd5f43b745df9215274e4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-27T23:28:00.000Z",
			"id": "35b69e69-9c94-4631-9a5f-1e8f13b5d440",
			"contadores": [
				"Vovós fofas",
				"Quem sou eu?"
			],
			"caps_lidos": "2",
			"imagem_name": "ogarotodosino-hq",
			"data_leitura": "2023-07-25T21:30:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/o-garoto-do-sino-e-seus-motivos",
			"name": "O Garoto do Sino",
			"porcentagem_leitura": 33,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"7fc01f66-676d-4f8c-b00f-04f64ecf726c"
			],
			"autor": [
				"Yasmin Celeste ⭐"
			],
			"insta": "https://www.instagram.com/yasz.ilustra/",
			"tags": "♀️",
			"twitter": "https://twitter.com/yasonenom"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3bbe636a-8bce-41fb-a22b-af0f0753f184/naganoken-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=3b582cb8214ef8c08f75bf65ff40b1fd448b0760994bf37845b1d480facc36ee&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-11T23:15:00.000Z",
			"id": "bfabdca1-6b72-464c-9cb1-2cdff3b73f39",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "naganoken-hq",
			"data_leitura": "2023-07-11T23:18:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/nagano-ken",
			"name": "Nagano-ken",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"ea5cd2aa-d31d-491f-ad10-566deebfaf58"
			],
			"autor": [
				"L1nkUwU"
			],
			"insta": null,
			"tags": "♂️",
			"twitter": "https://twitter.com/L1nkUwU"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4d11ac16-0a9f-4d58-a929-92c5030231ee/purpose-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=b0a3109131ee2c74720b6e24676ea271ae6aeab319af458ba35bf2c2f9fd7968&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-11T23:11:00.000Z",
			"id": "c9e63afa-15f9-4aa1-b726-e620d55c0b79",
			"contadores": [
				"Melhores Sinopses",
				"Melhores notas explicativas"
			],
			"caps_lidos": "1",
			"imagem_name": "purpose-hq",
			"data_leitura": "2023-07-11T22:16:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Purpose-PT-BR/info",
			"name": "Purpose",
			"porcentagem_leitura": 5,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "17",
			"autores": [
				"d18ac3c5-26d5-44f2-97c8-20d8aecc878b"
			],
			"autor": [
				"Rai Skyland ⭐"
			],
			"insta": "https://www.instagram.com/raiskyland/",
			"tags": "♀️",
			"twitter": "https://twitter.com/RaiSkyland"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0ef979e2-7b9a-4790-93f0-a98758645799/flyhighshiny-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=ac1886e97b42015cbfc022c7f1af83740a0f98e6dc58ad76111a87d4527cab72&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-11T23:07:00.000Z",
			"id": "d5ca0b23-f73d-40ff-8fe3-f0a9cb363b7e",
			"contadores": [
				"Garotas Mágicas"
			],
			"caps_lidos": "4",
			"imagem_name": "flyhighshiny-hq",
			"data_leitura": "2023-07-11T21:53:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/flyhigh-shiny",
			"name": "FlyHigh Shiny!",
			"porcentagem_leitura": 16,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "24",
			"autores": [
				"7152fb82-f8a6-40ac-81ce-a07e1dacb5b1"
			],
			"autor": [
				"Casty Maat ⭐"
			],
			"insta": "https://www.instagram.com/castymaat/",
			"tags": "♀️",
			"twitter": "https://twitter.com/castymaat"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ad9d38a8-7f48-43d1-a5d0-6ec8b3b47c9c/mortalia-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=4e610f58844f0e8c3dd54ae0bf34aa3199b0531fbdfa2f4cf094d1e0e7d20218&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-11T23:01:00.000Z",
			"id": "b4e8c36f-e24f-4ab1-bcc8-650f0d3ef301",
			"contadores": [
				"Máscaras Maneiras",
				"Mulheres Fodas",
				"Mamães Fodas"
			],
			"caps_lidos": "5",
			"imagem_name": "mortalia-hq",
			"data_leitura": "2023-07-11T23:04:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/mortalia",
			"name": "Mortalia",
			"porcentagem_leitura": 15,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "32",
			"autores": [
				"5345a81f-7381-43d0-9dad-78ed3f0d7ce1"
			],
			"autor": [
				"Pepasmaga ⭐"
			],
			"insta": "https://www.instagram.com/pepasmaga/",
			"tags": "♂️",
			"twitter": "https://twitter.com/pepasmaga2"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/09e1e5e8-f7bf-4a46-9f00-c720f4b57817/alendadedarkenmallus-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=a71e9e849cbfc44b99366289fa0278145af53600db9d12098d407ce4bf2fc663&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-11T22:52:00.000Z",
			"id": "958e18df-4f38-414c-8050-206c6926a183",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "alendadedarkenmallus-hq",
			"data_leitura": "2023-07-11T22:47:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-lenda-de-darken-mallus",
			"name": "A Lenda de Darken Mallus",
			"porcentagem_leitura": 7,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "13",
			"autores": [
				"eadbcf08-b51b-4a5a-8175-0c4f89d24e40"
			],
			"autor": [
				"Fuinha Sagaz ⭐"
			],
			"insta": "https://www.instagram.com/fuinha_sagaz/",
			"tags": "♂️",
			"twitter": "https://twitter.com/OsSlaps"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6110e299-e9eb-476a-bd06-464e565aebb6/contosdoespelho-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=f4cff7523f19c5039b98348e5633e7e39c7db293be8f71bfd1f610aeba3c0af2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-11T22:50:00.000Z",
			"id": "abab2d79-9031-42e7-a094-1c2533ef24e9",
			"contadores": [
				"Niihilismo"
			],
			"caps_lidos": "1",
			"imagem_name": "contosdoespelho-hq",
			"data_leitura": "2023-07-11T21:30:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/contos-do-espelho",
			"name": "Contos do Espelho - Meu primo e o Espelho",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"4d76b611-484c-418d-be26-73f83526dcc2"
			],
			"autor": [
				"Rafael M ⭐"
			],
			"insta": "https://www.instagram.com/cigato.mentolado/",
			"tags": "♂️",
			"twitter": "https://twitter.com/c_mentolado"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/408bbe54-1264-4de2-ab6f-3b9c8dbf5196/20minutos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=81760c5dade7410944475b47f230b893a6aa7f9a75aa4961ab017ca7f782dc8d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-09T23:22:00.000Z",
			"id": "6e79e835-b3ba-481e-b710-2247b4eb8ec0",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "20minutos-hq",
			"data_leitura": "2023-07-09T22:56:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/20-minutos/info",
			"name": "20 minutos",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"ec8e8e1b-1691-4c71-a3aa-25c39fb1c524"
			],
			"autor": [
				"Princesa Lombriga ⭐"
			],
			"insta": "https://www.instagram.com/princesa_lombriga/",
			"tags": "♀️",
			"twitter": "https://twitter.com/PLombrigaXD?t=1MrANH0bwHLY5fENx3x6jA&s=09"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ec94ef6e-935b-4b01-85d8-3d5ba46b88ef/ospalhaos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=9e0c617135fb14b1d8245f03de36f1dd636e540616a74cf84d633f8cb052f9d6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-09T23:20:00.000Z",
			"id": "ad95c23c-9100-459b-b24d-cbc31927bc3a",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "ospalhaços-hq",
			"data_leitura": "2023-07-09T22:40:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/os-palhacos-rjce",
			"name": "Os Palhaços",
			"porcentagem_leitura": 60,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"dacd03bb-5dac-4dae-9aea-a93d25f8a2fa"
			],
			"autor": [
				"Mauricio Miranda"
			],
			"insta": "https://www.instagram.com/mauriciomiranda976/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8c950966-f091-489c-afa5-9fe3d14be5b8/apenasumpedro-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=d1f4e3f384fa0c0c3d130cedb6d150758ad6da868362af52a2022c39e62a0e7c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-09T23:14:00.000Z",
			"id": "12089536-1000-4d85-93df-4dc699ebb271",
			"contadores": [
				"Quebras de quarta parede"
			],
			"caps_lidos": "1",
			"imagem_name": "apenasumpedro-hq",
			"data_leitura": "2023-07-09T21:48:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Apenas-um-Pedro1/info",
			"name": "Apenas um Pedro",
			"porcentagem_leitura": 4,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "23",
			"autores": [
				"e1e460b6-c059-4946-bd7c-537826f903af"
			],
			"autor": [
				"Apenas um Pedro"
			],
			"insta": "https://www.instagram.com/apenasumpedro/",
			"tags": "♂️",
			"twitter": "https://twitter.com/oapenasumpedro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e36703a6-eeac-485b-bf29-3b8eb22c42c5/desejosvampiricos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=7dc4cfff8e2dcb41a32be2f67ba0e9cada612ba136c63a5a1d8c9199004a35db&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-09T23:11:00.000Z",
			"id": "4ad2c656-5021-4ed7-bff2-1bce1f95e290",
			"contadores": [
				"CLTs"
			],
			"caps_lidos": "1",
			"imagem_name": "desejosvampiricos-hq",
			"data_leitura": "2023-07-09T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.webtoons.com/en/challenge/desejos-vamp%C3%ADricos",
			"name": "Desejos Vampíricos",
			"porcentagem_leitura": 25,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"64e4140d-3d47-4d32-9fcd-eda32af73a86"
			],
			"autor": [
				"Gabe “Southsenpai” ⭐"
			],
			"insta": "https://www.instagram.com/southsenpai/",
			"tags": "♂️",
			"twitter": "https://twitter.com/southsenpai"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/10e6a243-b4e3-4af9-836d-ca869e6b9cdd/quack-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=08a7c5a553e596c6d25aeb26828cee1a9a34570586b2bd3bb1f66b42a777ce5c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-04T21:43:00.000Z",
			"id": "9c7e91b0-df2d-47d8-990c-52a09ef517b6",
			"contadores": [
				"Melhores Sinopses",
				"Ovo",
				"Beijocas",
				"Pato"
			],
			"caps_lidos": "2",
			"imagem_name": "quack-hq",
			"data_leitura": "2023-07-04T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": "https://www.amazon.com.br/Quack-1-Kaji-Pato/dp/8582431627",
			"link_leitura": "https://noisemanga.com/quack/",
			"name": "Quack v1",
			"porcentagem_leitura": 100,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"1b4fb92a-06dc-48bd-9a46-cc12375e2b20"
			],
			"autor": [
				"Kaji Pato"
			],
			"insta": "https://www.instagram.com/kaji_pato/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b96fa793-1bb2-4b5c-b5eb-d8282b5536c8/starmind-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=a4a8447b7f7b2ed8d434d19b60a74aff7fd892c4b39bd2b72abce2474176998d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-04T21:28:00.000Z",
			"id": "c0fe1c30-47de-4d78-b0f1-d2f8eba5c224",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "starmind-hq",
			"data_leitura": "2023-07-04T23:30:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Starmind/info",
			"name": "Starmind",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"9c952ca7-2569-4afd-92da-d19b85c9da5a",
				"2c625568-0c92-4c6a-8b58-5a2f45294304"
			],
			"autor": [
				"Ricardo “Ryot” Tokumoto",
				"Daniel Bretas"
			],
			"insta": "https://www.instagram.com/ryotokumoto",
			"tags": "♂️",
			"twitter": "https://twitter.com/ryot"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8afafe2a-f6e6-4cbc-8e50-fcb140deb896/seca-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=e4e0d39e9f83072b27989b0a96c13872686d4ff4349a5adf38ab1afd6005ad67&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-03T00:33:00.000Z",
			"id": "6a6523bb-fed6-42a5-82e9-a7c0439e2b71",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "seca-hq",
			"data_leitura": "2023-07-02T23:00:00.000-03:00",
			"genero": [
				{
					"name": "SMA",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma19/seca-by-carlo/",
			"name": "Seca",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"19d86a05-c01f-43f2-b4ca-5b632e61b78a",
				"aba466e0-6283-4328-a5a2-4dd1dc45c1ab"
			],
			"autor": [
				"Dani Bolinho ⭐",
				"Carlo"
			],
			"insta": "https://www.instagram.com/dani_bolim/",
			"tags": "♂️",
			"twitter": "https://twitter.com/BolimDani"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ae7d7fc5-53b5-49d9-b0db-47d831783bf8/tropikalia-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=4083ed9f104c0431f95169c347883999a126efcb6e0407781b1ce8d14af04e40&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-29T23:36:00.000Z",
			"id": "0210646b-3d70-443b-baf6-c9e3d9383fcc",
			"contadores": [
				"Críticas Sociais Foderosas",
				"Cabelos Estilosos"
			],
			"caps_lidos": "2",
			"imagem_name": "tropikalia-hq",
			"data_leitura": "2023-06-29T23:32:00.000-03:00",
			"genero": [
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.komix.com.br/tropikalia/",
			"name": "Tropikalia",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"d5e79061-03e5-450f-8d54-e91ff2e298e5"
			],
			"autor": [
				"Luiz Lekston ⭐"
			],
			"insta": "https://www.instagram.com/luizlekston.com.br/?hl=pt",
			"tags": "♂️",
			"twitter": "https://twitter.com/luizlekston"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/faadbcf4-9c7f-4585-b9ce-cd7c81ca3e6f/debiloids-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=c59e065e72b87167bccc84220089bfc8310b2d55c87a647035a02b0354b7e745&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-29T23:33:00.000Z",
			"id": "369cc446-cde6-4f37-a2f9-b8a6bd6dc0a2",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "debiloids-hq",
			"data_leitura": "2023-06-29T23:09:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "http://www.debiverso.com.br/search/label/hist%C3%B3rias",
			"name": "Debiloid’s",
			"porcentagem_leitura": 0,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "999",
			"autores": [
				"d55724ba-4802-4642-925f-d08555a9599f"
			],
			"autor": [
				"Debiverso"
			],
			"insta": "https://www.instagram.com/debiverso/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/dba0d993-5017-4e97-b350-25ad6ead3678/terex-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=e907ec85a7f70275d3b2abf6facd87b3a9aa020a841aa2fc50a8e3ee34b6876b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-29T23:21:00.000Z",
			"id": "1715f655-f719-436c-843f-99aca48bfaa2",
			"contadores": [
				"Quebras de quarta parede",
				"Críticas Sociais Foderosas"
			],
			"caps_lidos": "13",
			"imagem_name": "terex-hq",
			"data_leitura": "2023-06-29T22:24:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "http://te-rexhq.blogspot.com/p/blog-page.html",
			"name": "Tê Rex",
			"porcentagem_leitura": 1,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "999",
			"autores": [
				"ced82f98-db04-488c-9ff9-1313ba0fa35a",
				"43d599f5-f2db-4038-871a-5858ec63381c"
			],
			"autor": [
				"Marcel Ibaldo ⭐",
				"Marcelli Ibaldo ⭐"
			],
			"insta": "https://www.instagram.com/marcel_ibaldo",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4edfd60c-3772-4c1c-a673-3febdb1bf67b/flowerfield-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=dac578777b46397d79e03d7dfc7d9e1908be95a4c3fa62483f68d35fa37cd2e7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-29T23:18:00.000Z",
			"id": "ed2ae771-7912-420f-a6a0-4f7ad3a813ee",
			"contadores": [
				"Melhores Sinopses"
			],
			"caps_lidos": "1",
			"imagem_name": "flowerfield-hq",
			"data_leitura": "2023-06-29T22:36:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Flower-Field-PtBr/info",
			"name": "Flower Field",
			"porcentagem_leitura": 2,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "42",
			"autores": [
				"9996afa4-e8ed-4976-9333-825f7cd607fc"
			],
			"autor": [
				"Thayse “Coati” ⭐"
			],
			"insta": "https://www.instagram.com/artcoati/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ef0b6174-2109-43f4-abf2-6d7d72a4ea87/perfectcheese-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=b2377d17583710df5eaa48938dbe869378e67aef66d9682f138f3866a604afe0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-20T23:19:00.000Z",
			"id": "0347502c-39b0-46d0-8365-06d66d05f243",
			"contadores": [
				"Furry",
				"Quebras de quarta parede"
			],
			"caps_lidos": "29",
			"imagem_name": "perfectcheese-hq",
			"data_leitura": "2023-06-20T23:09:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/serie/122",
			"name": "Perfect Cheese",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "57",
			"autores": [
				"8a800299-91a0-4c6f-b965-fa94ac0888f0"
			],
			"autor": [
				"Anderson Barboza ⭐"
			],
			"insta": "https://www.instagram.com/andersonbarboza/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/05708adf-75a4-425f-8999-fd3579722c5e/aliceanimoserie-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=e082dd632272e9ec0cbca3cbcd9ded3e549b4ca81c9ab95797df52b2573b48fd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-19T01:16:00.000Z",
			"id": "be5d39ec-2f62-4c55-af1e-221a58de77ae",
			"contadores": [
				"Golpes bem aplicados",
				"Alices",
				"Pq diabos você mandou uma criança?"
			],
			"caps_lidos": "4",
			"imagem_name": "aliceanimo-hq",
			"data_leitura": "2023-06-18T22:20:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.zinnes.com.br/serie/705",
			"name": "Alice Animo",
			"porcentagem_leitura": 30,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "13",
			"autores": [
				"8767f477-fb98-482d-ada8-5cd397351530"
			],
			"autor": [
				"Matheus Nobrega ⭐"
			],
			"insta": "https://www.instagram.com/matheusnobrega_dxtrm/",
			"tags": "♂️",
			"twitter": "https://twitter.com/The_Xtreme28"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4785f2d3-eda5-4870-86f4-e87ef7ad2e47/doraeagata-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=f7172487ee3993fa9b1bae127dca18a6e68cb7576e56b85fc2d371c65634969e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-15T23:30:00.000Z",
			"id": "6b64791c-2cac-4b9b-bf68-9e7146bc4ac8",
			"contadores": [],
			"caps_lidos": "6",
			"imagem_name": "doraeagata-hq",
			"data_leitura": "2023-06-15T22:28:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/serie/29",
			"name": "Dora e a gata",
			"porcentagem_leitura": 42,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "14",
			"autores": [
				"250c9248-189f-4d75-a590-f0999e8a8836"
			],
			"autor": [
				"Helô D’Angelo"
			],
			"insta": "https://www.instagram.com/helodangeloarte/",
			"tags": "♀️",
			"twitter": "https://twitter.com/helodangeloarte"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/882d4a04-9741-4cc3-94de-f29bc281e578/manakaru-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=abe93243683b43e04395ada0ba61006fb53505c3cd4a03817b98411960ee50c9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-15T23:27:00.000Z",
			"id": "7723a503-f864-43d8-9f36-69e28ac423cf",
			"contadores": [
				"Brasil Alternativo",
				"Apocalipses Brasileiros",
				"Squad Goals",
				"Golpes bem aplicados",
				"Lutas até a morte"
			],
			"caps_lidos": "1",
			"imagem_name": "manakaru-hq",
			"data_leitura": "2023-06-15T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/manakaru",
			"name": "Manakaru",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"524c8e26-b338-42f9-a7f9-ef206a99bf0a"
			],
			"autor": [
				"Diego Kongink ⭐"
			],
			"insta": "https://www.instagram.com/kongink_02/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bb35a5c3-923d-4b25-9bff-26aa2068e482/obliteringrage-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=169e6d7f40567423a74f0d3768af10fd00ba50529f296d580d32f6f60559286c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-15T23:23:00.000Z",
			"id": "5286b57e-838f-481b-a546-2540725ce71b",
			"contadores": [
				"Melhores Sinopses",
				"Talarico",
				"Squad Goals",
				"Palavrões"
			],
			"caps_lidos": "1",
			"imagem_name": "obliteringrage-hq",
			"data_leitura": "2023-06-15T21:52:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Obliterating-Rage/info",
			"name": "Oblitering Rage",
			"porcentagem_leitura": 3,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "32",
			"autores": [
				"ea98178c-5df5-4af9-b329-b7b917036710"
			],
			"autor": [
				"Victor Papa ⭐"
			],
			"insta": "https://www.instagram.com/darkkartrealm/",
			"tags": "♂️",
			"twitter": "https://twitter.com/DerFroschGott"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/82b45c87-f6e6-40cd-8175-db5f3368a461/etapoarr-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=2c594b0dd0c78f2a3ceb516e47a445ff7cf8f3a2839bbebf83adf0881872f4ee&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-01T22:18:00.000Z",
			"id": "b13d3383-8f47-4cbf-ab39-4b0375414507",
			"contadores": [
				"Bigodudos",
				"Calvos",
				"Orfãos"
			],
			"caps_lidos": "2",
			"imagem_name": "etapoarr-hq",
			"data_leitura": "2023-06-01T21:50:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.webtoons.com/en/challenge/eta-porr/list?title_no=845190",
			"name": "ETA PORR#",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"d5239b5b-f379-4174-9972-7be545d51903"
			],
			"autor": [
				"Gabriel Boaventura"
			],
			"insta": null,
			"tags": "♂️",
			"twitter": "https://twitter.com/nypsint"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9ddda457-b503-4ec2-b454-89c268320ca5/sideral-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=ff8e59b951513024eae31081f1fb01d0a09fe72edc709ecad8a90b5f35bb0a07&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-01T22:10:00.000Z",
			"id": "7c69191f-00cd-4384-a3e8-b89deb47824c",
			"contadores": [
				"Alienígenas",
				"Personagens fofinhos",
				"Vegetas Chegando"
			],
			"caps_lidos": "1",
			"imagem_name": "sideral-hq",
			"data_leitura": "2023-06-01T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/sideral?origin=search",
			"name": "Sideral",
			"porcentagem_leitura": 5,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "20",
			"autores": [
				"5b8754e8-c5b0-4558-8352-6d6762a20329"
			],
			"autor": [
				"Ednaldo Alves"
			],
			"insta": "https://www.instagram.com/kamieditora",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/18740138-01c0-4143-878d-f82c8d751736/ironlady-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=ae22c8e107ee1e840757b36341d74712e0bd085456692d392925a51841820410&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-01T22:00:00.000Z",
			"id": "26ebf6cb-a54e-4716-91cd-4aa4d3574c61",
			"contadores": [
				"Taberneiros carecas",
				"Calvos",
				"Pessoas sem senso de direção",
				"Podrão"
			],
			"caps_lidos": "1",
			"imagem_name": "ironlady-hq",
			"data_leitura": "2023-06-01T22:20:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/iron-lady",
			"name": "Iron Lady",
			"porcentagem_leitura": 16,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"ea4f890b-5f88-42bb-80cd-8e1be7bce2e5"
			],
			"autor": [
				"Flavia Andrade"
			],
			"insta": "https://www.instagram.com/legiao_s.a/",
			"tags": "♀️",
			"twitter": "https://twitter.com/ClaveDeFah"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/38d992d2-1c6c-401b-aad8-52ec112ce1cc/noah-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=876d428035233654a8135252569ded1648e0abbbf247e77bd806b8933fd1c9ef&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-31T00:11:00.000Z",
			"id": "124f755e-15a2-4aa6-b85e-07a2cfe973e1",
			"contadores": [
				"Golpes bem aplicados"
			],
			"caps_lidos": "1",
			"imagem_name": "noah-hq",
			"data_leitura": "2023-05-30T22:23:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": "https://ilustrado.my.canva.site/",
			"link_leitura": null,
			"name": "Noah",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"5ced3f73-f4ac-4292-b37e-12e0cde5302f"
			],
			"autor": [
				"Lucas Augusto ⭐"
			],
			"insta": "https://www.instagram.com/mkd.noah/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f863c8e0-c7cb-494a-bd54-c2ce9be40f58/bloodring-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=87b671ac4936126d58ef4810e3612cc3ce3c913e53cba03d9211ecf63f52f32e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-31T00:08:00.000Z",
			"id": "ad1221fc-432b-4be1-ba33-5b35d276404e",
			"contadores": [
				"Taberneiros carecas",
				"Calvos",
				"Portinhas abrindo de forma dramática",
				"Filhos exemplares",
				"Golpes bem aplicados",
				"Entradas fodas"
			],
			"caps_lidos": "1",
			"imagem_name": "bloodring-hq",
			"data_leitura": "2023-05-30T22:58:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": "https://ilustrado.my.canva.site/",
			"link_leitura": null,
			"name": "Blood Ring",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"c77bcf20-9b01-44b4-a84e-27d82178280c"
			],
			"autor": [
				"Ivan Silva"
			],
			"insta": "https://www.instagram.com/ivan.s1lva/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cb61face-81fa-4324-bfcd-bdde04312ea3/westranger-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=0a20028c2df24f14f438758a4caec7ed7953279be99b5059895ce8091bad6220&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-31T00:04:00.000Z",
			"id": "85a31998-ba25-45b6-95df-532a98e3868a",
			"contadores": [
				"Nomes fodas",
				"Cobradores de Impostos",
				"Entradas fodas",
				"Armas Improvisadas",
				"Quebras de quarta parede",
				"Personagens comendo coisas estranhas",
				"Citação de Memes"
			],
			"caps_lidos": "1",
			"imagem_name": "westranger-hq",
			"data_leitura": "2023-05-31T00:20:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": "https://ilustrado.my.canva.site/",
			"link_leitura": null,
			"name": "West Ranger",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"515b169c-eaf2-48b7-8709-fcb1130edf29"
			],
			"autor": [
				"Pablo Fernandes ⭐"
			],
			"insta": "https://www.instagram.com/mkd.westranger_/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0b63eb3d-bb42-46b6-926b-2c938eb60339/escarrabrasa-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=c39a8fe45a75fc8a59ca8bf66a9e4790f25d4f7de00d654b6d7c4b067ffcb428&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-28T23:52:00.000Z",
			"id": "090c2337-1a29-4a4d-a6bb-200f11531fbb",
			"contadores": [
				"Brasil Alternativo",
				"Squad Goals",
				"Entradas fodas",
				"Nomes fodas"
			],
			"caps_lidos": "1",
			"imagem_name": "escarrabrasa-hq",
			"data_leitura": "2023-05-28T23:34:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/escacrra-brasa-o-cangaceiro-gentil",
			"name": "Escarra Brasa",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"ba7b10da-e36f-4f2c-bb3c-e8522a801df8",
				"7e7f7a45-a811-4b4e-8d3e-0bcb76ebab7c"
			],
			"autor": [
				"Wagner Elias ⭐",
				"Rafa Santos ⭐"
			],
			"insta": "https://www.instagram.com/wagner_commissions/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fdf199a9-de21-4b28-84bc-2aeddbaa3153/comvoce-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=2deb525fe1e5abe2dd62117e589ca48719d4b0aca4bf9e11d813a34b8cf4a614&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-28T23:44:00.000Z",
			"id": "7f802b99-e08b-490a-9137-443fffa7a9b9",
			"contadores": [
				"Personagens fofinhos"
			],
			"caps_lidos": "6",
			"imagem_name": "comvoce-hq",
			"data_leitura": "2023-05-28T22:32:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.facebook.com/media/set/?set=a.718519812189549&type=3",
			"name": "Com Você",
			"porcentagem_leitura": 6,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "86",
			"autores": [
				"0afd88c7-924b-49c1-ab37-e076168febe4"
			],
			"autor": [
				"Taired"
			],
			"insta": "https://www.instagram.com/_taired/",
			"tags": "♀️",
			"twitter": "https://twitter.com/OrangeTaired"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/25fad2ab-514c-40af-a2b0-5a9150941da7/cellatrix-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=6ee2f35df4edb8dce3d587dddec38f84329cf62a14b33eb71269b0970173c10e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-28T13:26:00.000Z",
			"id": "521e84d8-3849-422a-9010-35b2da0007aa",
			"contadores": [
				"Squad Goals",
				"Golpes bem aplicados",
				"Quebras de Expectativa"
			],
			"caps_lidos": "1",
			"imagem_name": "cellatrix-hq",
			"data_leitura": "2023-05-25T23:15:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/cellatrix",
			"name": "Cellatrix",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"ba7b10da-e36f-4f2c-bb3c-e8522a801df8",
				"7e7f7a45-a811-4b4e-8d3e-0bcb76ebab7c"
			],
			"autor": [
				"Wagner Elias ⭐",
				"Rafa Santos ⭐"
			],
			"insta": "https://www.instagram.com/wagner_commissions/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/851d070a-df41-4a28-8e20-3e3c032375ce/zanecia-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=8ea7a45189c5c2f73392b0424cb2c658c51cdf3cbae6b3bc688e566fdc2c0a31&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-23T23:02:00.000Z",
			"id": "ab6f0497-741f-45f5-a9d2-67bf8a76696b",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "zanecia-hq",
			"data_leitura": "2023-05-23T23:30:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/zanecia?origin=&extra=profile",
			"name": "Zanecia",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"209c6600-53dc-4353-aabe-18bd0058bfc6"
			],
			"autor": [
				"Marcus Beck"
			],
			"insta": "https://www.instagram.com/themarcusbeck/",
			"tags": "♂️",
			"twitter": "https://twitter.com/beckenkamp"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4135da71-9a72-4b6d-a316-077a6133e30d/garotatoupeira-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=67dda48341961fa8ced31cee2cb6715b74e4f01b04fe86347df9faee2a17d613&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-16T22:14:00.000Z",
			"id": "dc969a78-2295-469f-8785-db15ddb9ea84",
			"contadores": [
				"Quebras de quarta parede",
				"Brasil Alternativo"
			],
			"caps_lidos": "1",
			"imagem_name": "garotatoupeira-hq",
			"data_leitura": "2023-05-16T21:40:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/GAROTA-TOUPEIRA---adventures-in-brazil/info",
			"name": "Garota Toupeira",
			"porcentagem_leitura": 25,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"bfd0fc80-b73a-4cfe-9aee-6331a8e79d12"
			],
			"autor": [
				"Mellman ⭐"
			],
			"insta": "https://www.instagram.com/mellman_art/",
			"tags": "♂️",
			"twitter": "https://twitter.com/MellmanArt"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a9f0d185-55bb-4cfb-84dc-e84d056fb8f1/tobiassalazar-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=a20e118ec509fefed2c777f0d897bc8ae9131e3b2b98406d55c78c29def2bcc2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-16T22:11:00.000Z",
			"id": "2dbad268-6f3b-4c1f-9adf-63cd05c7ae96",
			"contadores": [
				"Quebras de Expectativa",
				"Desempregados \"Autonomos\" MEI ou sem direitos trabalhistas (\"\"Empreendedores\"\")"
			],
			"caps_lidos": "1",
			"imagem_name": "tobiassalazar-hq",
			"data_leitura": "2023-05-16T22:55:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/tobias-salazar-o-detetive-baixa-renda-p4vc",
			"name": "Tobias Salazar o Detetive baixa renda",
			"porcentagem_leitura": 10,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"7e7f7a45-a811-4b4e-8d3e-0bcb76ebab7c"
			],
			"autor": [
				"Rafa Santos ⭐"
			],
			"insta": "https://www.instagram.com/tobias_detetive/",
			"tags": "♂️",
			"twitter": "https://twitter.com/gibitales?lang=pt-br"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cb30d686-ac47-4c6d-b81e-47f69f4441ed/meyrin-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=cfb658bac4790e148fe99b299900c6d7425eb4c8396a916c8f5e384c766f5fda&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-16T22:09:00.000Z",
			"id": "1aaa1f63-8d7e-40a9-a153-d84175e94b13",
			"contadores": [
				"Golpes bem aplicados"
			],
			"caps_lidos": "5",
			"imagem_name": "meyrin-hq",
			"data_leitura": "2023-05-16T23:42:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/meyrim-the-bodyguards-tale?origin=chapter-nav-button&extra=list",
			"name": "Meyrin: The Bodyguards Tale",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"aac86322-5c06-43a9-8dce-ff61b5bbd65c"
			],
			"autor": [
				"Daydreamer Art ⭐"
			],
			"insta": "https://www.instagram.com/daydreamer_d_art/",
			"tags": "♂️",
			"twitter": "https://twitter.com/daydreamerd_art"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1d4142e7-21b7-470f-9d36-7eb1238d2f0b/colatino-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=fc30d2eb3666f7ee2cb0a7fab2705f7db081e7989c7cdbefdcb5868dc7370fef&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-16T22:07:00.000Z",
			"id": "517eea1e-3d6a-4a83-bb47-b03949210ac2",
			"contadores": [
				"Cicatrizes e Tatuagens",
				"Taberneiros carecas",
				"Calvos",
				"Vilões",
				"Aura"
			],
			"caps_lidos": "3",
			"imagem_name": "colatino-hq",
			"data_leitura": "2023-05-16T22:25:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/colatino-caca-tretas?origin=chapter-nav-button&extra=list",
			"name": "Colatino - Caça Tretas",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"ba7b10da-e36f-4f2c-bb3c-e8522a801df8"
			],
			"autor": [
				"Wagner Elias ⭐"
			],
			"insta": "https://www.instagram.com/wagner_commissions/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/588dbe36-1d40-4b21-8ced-e9e63d35f24d/soberania-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=7252a6c797d5a005d2d3cff3f1dae7a99b329e9370ead7baaab990b37c615c74&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-15T00:15:00.000Z",
			"id": "0e4e474a-01be-45df-ba35-e82d446503fe",
			"contadores": [
				"Autores pelo Celular / Mouse"
			],
			"caps_lidos": "3",
			"imagem_name": "soberania-hq",
			"data_leitura": "2023-05-14T23:35:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.zinnes.com.br/serie/723",
			"name": "Soberania",
			"porcentagem_leitura": 8,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "37",
			"autores": [
				"a2790792-9d40-4b5a-b7bf-84418b11f41c"
			],
			"autor": [
				"psyuro ⭐"
			],
			"insta": "https://www.instagram.com/p.sdraws/",
			"tags": "♀️",
			"twitter": "https://twitter.com/yuroich"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/67f22dd2-0b13-43ff-ae80-15dfa194bfe7/entredoismundos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=51a229a5119822dcd714df9f20c6269c56fedc0d551da329f4d67d47afeed218&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-15T00:13:00.000Z",
			"id": "d313e70c-e54b-4714-bfee-02f2b8dc0191",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "entredoismundos-hq",
			"data_leitura": "2023-05-14T22:40:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": null,
			"name": "Entre Dois Mundos",
			"porcentagem_leitura": 37,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "8",
			"autores": [
				"ccfc55bb-551a-4f45-8e88-eaaa54e06224"
			],
			"autor": [
				"Aquaryart - Juliana Silva ⭐"
			],
			"insta": "https://www.instagram.com/_aquaryart/",
			"tags": "♀️",
			"twitter": "https://twitter.com/aquaryart"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/802655fd-35d8-4811-906a-d2d0c8103af8/medalhadark-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=c7848b4fc5ab48653a30a56718f0cca7ce995daad06f44d91e6529a9ae5002ef&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T20:26:00.000Z",
			"id": "2180d6ef-6acc-491f-8a4d-ef847f3f873b",
			"contadores": [
				"Bigodudos",
				"Cenas na Chuva",
				"Bang Bang"
			],
			"caps_lidos": "1",
			"imagem_name": "medalhadark-hq",
			"data_leitura": "2023-05-06",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/medalha-dark/001",
			"name": "Medalha Dark",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"1570fad2-9a0f-4c30-9669-5900ad3649b0"
			],
			"autor": [
				"636"
			],
			"insta": "https://www.instagram.com/lscastro_636/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b4010b7c-4f80-4df6-80b1-8d782b188b44/tinodesanto-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=2fba67b95613301bdfe6640ff67a8d0423665124078d4eb4d3db2b4028d85008&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T19:09:00.000Z",
			"id": "0ab27508-bbad-4de6-acd4-ba7ce051478d",
			"contadores": [
				"Beijocas",
				"Gols de placa",
				"Calvos",
				"Bang Bang"
			],
			"caps_lidos": "1",
			"imagem_name": "tinodesanto-hq",
			"data_leitura": "2023-05-09T23:15:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/tino-desanto-decisoes",
			"name": "TINO DeSANTO",
			"porcentagem_leitura": 25,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"db1ffb67-5754-4955-894c-c4309d5258b7"
			],
			"autor": [
				"Magu ⭐"
			],
			"insta": "https://www.instagram.com/magu_capa/",
			"tags": "♂️",
			"twitter": "https://twitter.com/magu_capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/af286f86-3494-453f-b217-5536ad0f9782/joesangar-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=e16653919812ec955c34046e5b75d4d760a71121fb6ad7fba2cb76c3ff846139&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-06T18:14:00.000Z",
			"id": "64d09944-887e-4ad2-95d4-95e818303045",
			"contadores": [
				"Casamentos"
			],
			"caps_lidos": "3",
			"imagem_name": "joesangar-hq",
			"data_leitura": "2025-03-20",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/jo-e-sangar",
			"name": "Jô e Sangar",
			"porcentagem_leitura": 15,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "19",
			"autores": [
				"62f1c30a-aaba-4416-8551-c7022647ba32"
			],
			"autor": [
				"Siri"
			],
			"insta": "https://www.instagram.com/silvestre_siri/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fe33251e-b2c1-4a3a-834b-fb9f7867f7c3/digude-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=b4a15fa264c8d6f5af482139234bb0c99b0bc320015892b888b747cfc41a2279&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-04T23:16:00.000Z",
			"id": "22e79d5d-b39d-46e3-aedc-790004bdcf54",
			"contadores": [
				"Herdeiros",
				"Protagonistas se apaixonando por esporte"
			],
			"caps_lidos": "12",
			"imagem_name": "digude-hq",
			"data_leitura": "2022-12-04",
			"genero": [
				{
					"name": "Esporte",
					"color": "green"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Digude/info",
			"name": "Digude",
			"porcentagem_leitura": 92,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "13",
			"autores": [
				"1705dfef-ccac-42df-b453-53ca349b261e"
			],
			"autor": [
				"Vinicius de Souza"
			],
			"insta": "https://www.instagram.com/viniciusdesouzaart/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f307aeec-6b8c-4001-8e14-b78bdb115b57/madreluna-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=3b6cf27defe844072e6f8c24a58f240475e347e8d1de8e6ccef7dee86400d7f1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-02T16:36:00.000Z",
			"id": "89952172-36cc-4170-89a8-8f841dc4534e",
			"contadores": [
				"Cicatrizes e Tatuagens",
				"Críticas Sociais Foderosas",
				"Criaturas sobrenaturais"
			],
			"caps_lidos": "1",
			"imagem_name": "madreluna-hq",
			"data_leitura": "2023-05-02T23:23:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Madre-Luna/info",
			"name": "Madre Luna",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"4cfd6e03-2f49-4d90-bdd2-df4e8bde2ec4"
			],
			"autor": [
				"Bulho"
			],
			"insta": "https://www.instagram.com/bulhoarts/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fe3d71a5-35ac-4b08-9663-12ed0044194d/insanecrow-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=249f1acfba4526f7e11bbf8dcb1ad8f1673ad1cf1cbe300d1428f35f2a7e090b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-30T22:07:00.000Z",
			"id": "360d16a9-8f7a-4182-bb76-c95acbeb6168",
			"contadores": [
				"Furry",
				"CLTs",
				"Autores pelo Celular / Mouse",
				"Caolhos",
				"Husbandos",
				"Cenas na Chuva",
				"Bang Bang"
			],
			"caps_lidos": "1",
			"imagem_name": "insanecrow-hq",
			"data_leitura": "2023-04-30T23:36:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/insane-crow?origin=search",
			"name": "Insane Crow",
			"porcentagem_leitura": 7,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "14",
			"autores": [
				"aef34030-8446-4a52-892f-a61d06ec00a7"
			],
			"autor": [
				"Juarez Oliveira"
			],
			"insta": "https://www.instagram.com/juarezoliveira760/",
			"tags": "♂️",
			"twitter": "https://twitter.com/JoneByro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/df854dd8-007b-43b5-bf09-6ca0c97d032a/gatho-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=a2221e1aebe11d138759b005f8680017ee4c98c259743553983d9974313509a0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-27T15:56:00.000Z",
			"id": "fbe83128-d63f-4ff7-8119-e005c2e652dc",
			"contadores": [
				"Cliffhangers foda",
				"Cabelos Estilosos",
				"Biritas"
			],
			"caps_lidos": "21",
			"imagem_name": "gatho-hq",
			"data_leitura": "2023-04-27T22:24:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Gatho-PtBr/info",
			"name": "Gatho",
			"porcentagem_leitura": 84,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "25",
			"autores": [
				"c511a6f6-70af-47a1-a758-dd0dc8f43e49"
			],
			"autor": [
				"Gabriel Kolbe ⭐"
			],
			"insta": "https://www.instagram.com/gabrielkolbe/",
			"tags": "♂️",
			"twitter": "https://twitter.com/GabrielKolbe"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3a965725-e471-4697-b929-7e7428a9435a/paranormalpanic-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=9ca96ab97950534b5ee2de0641f42b90f8fc521b0163ae479d60e5cb4043d3d6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-26T01:46:00.000Z",
			"id": "cbeb0a73-33a4-4071-8e80-93052c71a59d",
			"contadores": [
				"Cabelos Estilosos",
				"Garçons",
				"Vegetas Chegando"
			],
			"caps_lidos": "1",
			"imagem_name": "paranormalpanic-hq",
			"data_leitura": "2023-06-20T22:30:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Paranormal-Panic/info",
			"name": "Paranormal Panic",
			"porcentagem_leitura": 3,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "28",
			"autores": [
				"4fcfe067-2123-49e9-aa88-96181009e3cb"
			],
			"autor": [
				"Milena Zarate ⭐"
			],
			"insta": "https://www.instagram.com/miileskine/",
			"tags": "♀️",
			"twitter": "https://twitter.com/miileskine"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8b79174c-9a4e-4f5c-a714-d4185fdc776b/cavaleirosdeferro-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=39eb6584db9ecede4311803ae9848386fecae058bec927588479efe72d9222bf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-25T16:11:00.000Z",
			"id": "57b450b7-75b5-48a1-9a90-3973ec249c91",
			"contadores": [
				"Cabelos Estilosos",
				"Orfãos",
				"Vegetas Chegando",
				"Cliffhangers foda",
				"Alienígenas"
			],
			"caps_lidos": "2",
			"imagem_name": "cavaleirosdeferro-hq",
			"data_leitura": "2023-04-25T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Cavaleiros-de-ferro-PT-BR/info",
			"name": "Cavaleiros de Ferro",
			"porcentagem_leitura": 7,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "26",
			"autores": [
				"636cfb84-51a9-4629-9962-2cfef2834afc"
			],
			"autor": [
				"Chris Red Artist ⭐"
			],
			"insta": "https://www.instagram.com/chris_red_artist/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8e6f33df-3186-4de9-a641-545f964b9fa6/ajornadadeari-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=ce775b2b9bdc03f0051e05e8b304b7b7f9a6ca214c7494a3659cccbfb3954299&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-25T16:09:00.000Z",
			"id": "ec441778-dd4f-48be-8756-e0224adaea6a",
			"contadores": [
				"Vilarejos em um mundo Fantasia",
				"Cabelos Estilosos",
				"Cliffhangers foda",
				"Herdeiros",
				"Passados Trágicos",
				"Lendas Arturianas"
			],
			"caps_lidos": "1",
			"imagem_name": "ajornadadeari-hq",
			"data_leitura": "2023-04-25T23:39:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-jornada-de-ari-qaf1",
			"name": "A Jornada de Ari",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"8653e55c-4480-4d10-b294-f9ac267c8447"
			],
			"autor": [
				"GringoComics ⭐"
			],
			"insta": "https://www.instagram.com/gringocomics_insta/",
			"tags": "♂️",
			"twitter": "https://twitter.com/gringoscomics"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/54240c3d-a33e-4df3-ab18-832b00b6ccab/omonstrodebaixodacama-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=23e9d337eb42b73fa1f1e2a62ac01098a28fed8a6d452d9894d1c6b0488c267d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-24T01:28:00.000Z",
			"id": "ab92b08e-9276-43bd-9c7b-feef1006dc45",
			"contadores": [
				"Furry",
				"Beijocas",
				"Inícios mitológicos",
				"Cabelos Estilosos",
				"Idosos agressores",
				"Críticas Sociais Foderosas",
				"Quadrinhos Reflexivos",
				"Husbandos",
				"Criaturas sobrenaturais"
			],
			"caps_lidos": "12",
			"imagem_name": "omonstrodebaixodacama-hq",
			"data_leitura": "2023-04-23T22:20:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/O-Monstro-Embaixo-da-Cama/info",
			"name": "Coletânea: O Monstro Embaixo da Cama",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "12",
			"autores": [
				"9248f707-2513-4387-ba94-fb571a336ce0",
				"d5181c07-657d-4ccd-bddc-0f963644a27b"
			],
			"autor": [
				"Millie ⭐",
				"Minervini ⭐"
			],
			"insta": "https://www.instagram.com/millicamacho_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/CamachoMilli"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fbcc5973-9374-4951-a3c3-8063d40519db/embaraada-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=98af1a199670852d44203c71c239e619fc6e37aa686791cfcf7d3a873652790c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-20T12:57:00.000Z",
			"id": "e17d9f15-cd14-4159-8b87-fafc651ca856",
			"contadores": [
				"Quadrinhos Reflexivos"
			],
			"caps_lidos": "5",
			"imagem_name": "embaraçada-hq",
			"data_leitura": "2023-04-20T22:06:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Embaraada/info",
			"name": "Embaraçada",
			"porcentagem_leitura": 100,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"14ffa5d0-1a6a-4dfe-9932-5d4d360eb590"
			],
			"autor": [
				"Xenomorphzoid ⭐"
			],
			"insta": "https://www.instagram.com/xenomorphzoid/",
			"tags": "♀️",
			"twitter": "https://twitter.com/xenomorphzoid"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1245b601-bb8d-4957-ae76-5c793c49e308/naoidentificado-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=c1a39059b95c863b4188804a5e2c574ae4c56507452d363e2d0b53383fd908e5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-20T12:50:00.000Z",
			"id": "0263228c-1be2-48e4-8e69-a8d2520867b0",
			"contadores": [
				"Quadrinhos Reflexivos",
				"Alienígenas",
				"Vegetas Chegando",
				"Peladões"
			],
			"caps_lidos": "1",
			"imagem_name": "naoidentificados-hq",
			"data_leitura": "2023-04-20T23:46:00.000-03:00",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Nao-Identificados/info",
			"name": "Não Identificados",
			"porcentagem_leitura": 16,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"c7d5bd15-ee3d-4419-81d5-f547353d728e"
			],
			"autor": [
				"Dangoverso ⭐"
			],
			"insta": "https://www.instagram.com/dangoverso/",
			"tags": "♂️",
			"twitter": "https://twitter.com/dangoverso"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b4cbaebf-6a34-476d-9153-ed1734b33407/stellacintilante-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=b3e9661d7411c9bf62c55197e7704e54805d3c2b0db1768b718d58e66cc276bb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-18T16:10:00.000Z",
			"id": "c427aea3-68c3-461d-a2b1-88e2a2d24484",
			"contadores": [
				"Quebras de Expectativa",
				"CLTs"
			],
			"caps_lidos": "1",
			"imagem_name": "stellacintilante-hq",
			"data_leitura": "2023-04-18T23:37:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/stella-cintilante-1mvw?origin=comic-index-list",
			"name": "Stella Cintilante",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"48f611c0-b671-4d10-ba7d-d9a7ee8acbff"
			],
			"autor": [
				"Owlopes ⭐"
			],
			"insta": "https://www.instagram.com/owlopes.arts/",
			"tags": "♂️",
			"twitter": "https://twitter.com/walparadise"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/26f2f64a-d589-466e-b64a-215037bf1641/aordem-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=c218c07ea58594c667c6ea86f163141f71f963007b4edf22433a1f4391b639db&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-17T11:07:00.000Z",
			"id": "838f81b2-c452-403d-a9dd-df82780b5d9a",
			"contadores": [
				"Husbandos",
				"Brasil Alternativo"
			],
			"caps_lidos": "4",
			"imagem_name": "aordem-hq",
			"data_leitura": "2023-04-18T22:09:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-ordem-origem-8j52?origin=search",
			"name": "A Ordem",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"0715a05a-d018-4216-a1dc-afc63995b3c7"
			],
			"autor": [
				"O Anhanguera"
			],
			"insta": "https://www.instagram.com/oanhanguera/",
			"tags": "♂️",
			"twitter": "https://twitter.com/oanhanguera_"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/36e384e8-1f4f-4c7c-9b3f-755bdc2d41f7/10-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=9ba0d6f572c1a69722f0b3835597b9f03e6f0e23e700ce693e38eb20fce96b35&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-17T03:05:00.000Z",
			"id": "7d10797a-e80a-4fd5-9988-6fd48149be74",
			"contadores": [
				"Bullies"
			],
			"caps_lidos": "1",
			"imagem_name": "10percent-hq",
			"data_leitura": "2023-08-03T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/2498062",
			"name": "10%",
			"porcentagem_leitura": 33,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"159a4449-259b-4314-9e29-165095aa956a"
			],
			"autor": [
				"Morgana"
			],
			"insta": "https://www.instagram.com/morgana.dayo/",
			"tags": "♀️",
			"twitter": "https://twitter.com/PlaviaMorgana"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d5080860-a2ff-4aef-9834-242e373cf0a4/thecurseoftheequinox-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=0d77272326538d49117e0e7ae2e14b0575ddb57bf8c0e5f2744acb0cdf6f1960&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-17T03:03:00.000Z",
			"id": "5705870c-6059-4774-a7f6-37064e2c0f02",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "thecurseoftheequinox-hq",
			"data_leitura": "2023-07-30T23:50:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/the-curse-of-the-equinox?origin=comic-index-list",
			"name": "The Curse of the Equinox",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"2f36e4d8-796f-4594-b649-8df008eb0642"
			],
			"autor": [
				"Nathalianime"
			],
			"insta": "https://www.instagram.com/curse_equinox/",
			"tags": "♀️",
			"twitter": "https://twitter.com/cursed_equinox"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/60b38a20-65e4-4fa7-8734-b5d1857f3651/rebirthofshadows-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=243d862efed2f7cbecc1736f9447314fae6b3b85ebf81e7d2af90f444b05d65d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-17T02:39:00.000Z",
			"id": "acd6fb22-b852-4c2c-b4b7-7d038aaae6c4",
			"contadores": [
				"CLTs",
				"Legalizer",
				"Melhor relação entre pais e filhos",
				"Peitões do Quadrinho Nacional"
			],
			"caps_lidos": "5",
			"imagem_name": "rebirthofshadows-hq",
			"data_leitura": "2023-06-18T21:30:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/rebirth-of-shadows",
			"name": "Rebirth Of Shadows",
			"porcentagem_leitura": 33,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "15",
			"autores": [
				"0a5c4afd-020a-44b9-a061-b46ac5ff9288"
			],
			"autor": [
				"Bundas Art ⭐"
			],
			"insta": "https://www.instagram.com/bundas_art/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2edf7e5c-b5e7-48b6-9278-0128c4c6bb77/kikronicles-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=52239959406336351f1dfe337aee949060ebcf4d19d3b6d5d9f2c058982a64f9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-17T02:37:00.000Z",
			"id": "881b508d-1120-46bb-a7ef-88801368cf09",
			"contadores": [
				"Anjo biblícamente acurado"
			],
			"caps_lidos": "1",
			"imagem_name": "kikronicles-hq  ",
			"data_leitura": "2024-10-26",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/kikronicles",
			"name": "Kikronicles",
			"porcentagem_leitura": 1,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "62",
			"autores": [
				"448cd2ed-76f9-4619-aed3-59789f8cf102"
			],
			"autor": [
				"Kikeluzi ⭐"
			],
			"insta": "https://www.instagram.com/kikeluzi/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b78f18b0-a43b-4b26-ac37-6b98e30051af/istella-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=299b7a7463ba245e60cb1733ca840a42983a8116b5a00681095cdaa9f629db7c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-16T15:40:00.000Z",
			"id": "486d5639-4ac3-4279-aff1-c53f9da4efc4",
			"contadores": [
				"Cabelos Estilosos",
				"Golpes bem aplicados",
				"Caolhos",
				"Mulheres Negras",
				"Squad Goals",
				"Temática de Piratas",
				"Hehe",
				"Convites inusitados",
				"Roupas fodas",
				"FDPs",
				"Sacolé"
			],
			"caps_lidos": "11",
			"imagem_name": "istella-hq",
			"data_leitura": "2023-04-16T23:55:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Istella/info",
			"name": "Istella",
			"porcentagem_leitura": 68,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "16",
			"autores": [
				"f338d09a-6987-43e6-bf55-bcfd61cde494"
			],
			"autor": [
				"Gilton Ferreira ⭐"
			],
			"insta": "https://www.instagram.com/gilton_ferreira/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Passarumaru"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9077ca0a-7dde-441c-86c8-ff3597530a19/redoni-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=151d44ff3550597815aab2507bc8f8a7b112f2eda7895df453bba202bbd9eec6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-16T01:29:00.000Z",
			"id": "d2f86747-726c-42bd-882f-37c8c208e687",
			"contadores": [
				"Vinganças",
				"Pactos",
				"Samurais",
				"Caolhos",
				"Criaturas sobrenaturais",
				"Cenários Convenientemente muito bem Posicionados"
			],
			"caps_lidos": "4",
			"imagem_name": "redoni-hq",
			"data_leitura": "2023-04-25T22:59:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Red-Oni",
			"name": "Red Oni",
			"porcentagem_leitura": 80,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"03ab1bed-df44-49ec-85e5-e82afd6c66fa"
			],
			"autor": [
				"Clara Carvalho - (TimidFelidae) ⭐"
			],
			"insta": "https://www.instagram.com/timidfelidae/",
			"tags": "♀️",
			"twitter": "https://twitter.com/timidfelidae"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bb3f5cd2-0e82-4606-b8bd-50cbdc82a1e7/omisteriodaquintanoite-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=cdf5c59fd1526fcf4afad211cbebd5ddde0512fa4a9222734e56002b20b54fe0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-15T17:34:00.000Z",
			"id": "1c40208f-26ba-43ce-befd-01cf939b13c3",
			"contadores": [
				"Crias",
				"Criaturas sobrenaturais",
				"Personagens de Óculos"
			],
			"caps_lidos": "2",
			"imagem_name": "omisteriodaquintanoite-hq",
			"data_leitura": "2023-04-30T22:30:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/OMQN/info",
			"name": "O Mistério da Quinta Noite ",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"7189c3de-7cd6-4eae-acfc-bc45726d88d7"
			],
			"autor": [
				"Analu ⭐"
			],
			"insta": "https://www.instagram.com/arts.wiwi/",
			"tags": "♀️",
			"twitter": "https://twitter.com/wiwiArts"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c3735c2c-93a3-430b-a266-7b12e881d604/perfectblackhq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=eb51af8079889ba8f92b4fa4688de69aff59afcb1e05c63482a47be978d2525b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-14T01:14:00.000Z",
			"id": "1b3bfd55-ad83-4fb9-9b42-b1cee3b61801",
			"contadores": [
				"Críticas Sociais Foderosas",
				"Revoluções contra governos autoritarios",
				"Mulheres Negras"
			],
			"caps_lidos": "1",
			"imagem_name": "perfectblack-hq",
			"data_leitura": "2023-04-27T23:03:00.000-03:00",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/perfect-black?origin=comic-index-list",
			"name": "Perfect black",
			"porcentagem_leitura": 11,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"f8aa891a-6231-4169-9d81-755ba52a3897"
			],
			"autor": [
				"CyberPanda ⭐"
			],
			"insta": "https://www.instagram.com/vulgo_cyberpanda/",
			"tags": "♂️",
			"twitter": "https://twitter.com/CyberLedisMan"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/84a61120-263e-40ef-a2e0-ea3fd49fcb09/aliceanimo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=6a1bf1d55dcade0bd5d96842c58039c968509b70e4608c7147e2e0a2f7652726&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-13T18:42:00.000Z",
			"id": "6b863645-18c8-463a-8e85-7007950d2329",
			"contadores": [
				"Cicatrizes e Tatuagens",
				"Quebras de Expectativa",
				"Vovós fofas",
				"Mulheres Bombadas",
				"Bullies"
			],
			"caps_lidos": "1",
			"imagem_name": "aliceanimo-hq",
			"data_leitura": "2023-04-13T22:12:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": null,
			"name": "Alice Animo (OneShot)",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"8767f477-fb98-482d-ada8-5cd397351530"
			],
			"autor": [
				"Matheus Nobrega ⭐"
			],
			"insta": "https://www.instagram.com/matheusnobrega_dxtrm/",
			"tags": "♂️",
			"twitter": "https://twitter.com/The_Xtreme28"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8ba6d6b6-33e1-44c4-b8ae-cccba36ae73f/deltaparadise-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4665YTM3S2V%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232853Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIDKCK%2FM%2BhwbZMm9wy%2BpV6E7VC0ZO36u7JkR80CrDDkdyAiBxkc6KUprITMQuI%2FyhaAkJ5O1LhWCoD9goLjSPVSx5OSqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMIHW%2FTYLGwdlTOyCdKtwDMzrm1jiF%2Bo%2B%2FG4mXMqaGof2DRNLbBMCCNMKzh6viyi0ATfReqTaVj5ONm3WVeWOF2xo1twd7Uwe7u0VQfHgTVnsD7Ct%2BnFQZxQPjHZq89xCt3MZvuhNhFlqL94JfN0sWckGYEGnvD174zLBfAN087AQLFPTx4EZL0Y%2BDpuEjlNz6btG7raUFH6JZhtXnExYIgDKvsqSUqq8FgwZqvQZLS0w%2Ft3QEkvh37thvwi0oQUDI7BrWKU75ZCIl%2BmppoR%2B3luaxdI%2BayLdFas0tiBamoILYGqM%2BZhNwqOLLNkIlnsvQbBpjg3bGyixkBumHK4D22S%2BFafglKAa%2FgoEoIoa8JLEaWEbgmRYpHdwij%2B%2FvMWFkPZL6SL2Qe8XESM66cofF9J%2Ft2KxS6FmOiZXt0O2JxP8FZ64DkrNJpCVWApsCcuRAaYbd3U0QJG77NAEAaoUuqzYfOhhIKcllnqqlDiHB11Q1Mb%2BsClSFi9MvjhpRMZJPft4axeR843bFhDUV1pf8OhTUKD1V581SAvEO6b6J2nCxhubNt%2BBugvqR69fh%2BfEhnydu1ES9TU5OyWiMoPXmBFqMJgJ9xPuvTxGmAhtUDaPehVacJ6lfGj1iJgxaDYTyRuP6TlCQRm6JbxkwurirvwY6pgGKf52%2BV6ATwwy7iNaitIVQ60oGHyXVYi74w%2BBNXn6%2FVn%2BkqiytcJzz0joMU9rinlMFzaz8rCFYSRe%2BsAT1zAOEvZvhy7bcMyf9vjYW%2Flsu7gxQ72%2BlA%2FL%2BcrJr%2BNIOuSNkG9YKuHSUR2Qs234saNwMUG75Qs29it7bY0casx%2F%2BpUML7P73SqRphea5qxBkH776VvFIJ6mLN%2Bi84ppuIsj7F%2Fz4KmD7&X-Amz-Signature=d7ab501a053cc6e747a06762dd44515c4f9ca02192868a31c258db28e3f2ed2b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-13T18:40:00.000Z",
			"id": "fd4ba310-9890-4d98-87d4-1d719de81dd4",
			"contadores": [
				"Cicatrizes e Tatuagens",
				"Squad Goals",
				"Bullies"
			],
			"caps_lidos": "2",
			"imagem_name": "deltaparadise-hq",
			"data_leitura": "2023-04-14T00:40:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/delta-paradise",
			"name": "Delta Paradise",
			"porcentagem_leitura": 40,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"17ac82f3-82ae-4ccb-b55c-250dfb9c6439"
			],
			"autor": [
				"DamitGabriel ⭐"
			],
			"insta": "https://www.instagram.com/_ivensgabriel_/",
			"tags": "♂️",
			"twitter": "https://twitter.com/_ivensgabriel_"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9d58cd9d-34da-4a7d-abd3-b015b0d1603f/superguerreiroomega-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=f7a67c54e720e0e6f32e249b1a22bf083b666059b86d536ecb6f1fd29e804392&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-10T21:22:00.000Z",
			"id": "1c149649-221c-43b7-9ada-68cde9fad049",
			"contadores": [
				"Bullies",
				"Críticas Sociais Foderosas",
				"Quadrinhos Feels",
				"Gore",
				"Quebras de Expectativa",
				"Criaturas sobrenaturais",
				"Homens vs Natureza"
			],
			"caps_lidos": "1",
			"imagem_name": "superguerreiroomega-hq",
			"data_leitura": "2023-04-12T00:45:00.000-03:00",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/supe-guerreiro-omega",
			"name": "Super Guerreiro Ômega",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"764f2a4d-4d36-49bf-90df-e84317b9f273"
			],
			"autor": [
				"Milo Paulino"
			],
			"insta": "https://www.instagram.com/milo.paulino/",
			"tags": "♂️",
			"twitter": "https://twitter.com/MiloPaulino"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6cb49cd5-f5a8-42ca-81ba-56ce6ff38c56/oscontosdeazgra-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=be1a07c88c3d5a61899ff1e6523323407f32b7746563f6589275e9dd6bcbf1a2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-10T21:19:00.000Z",
			"id": "2a444947-e063-4789-b302-ce83aba732c6",
			"contadores": [
				"Quadrinhos Feels",
				"Protagonistas que não deixam os mortos mortos",
				"Pessoas apaixonadas até demais"
			],
			"caps_lidos": "1",
			"imagem_name": "oscontosdeazgra-hq",
			"data_leitura": "2023-04-11T22:09:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/os-contos-de-azgra-por-ti",
			"name": "Os Contos de Azgra: Por ti!",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"8de8feac-dc83-49a6-b6ca-9a0501ded48d"
			],
			"autor": [
				"Moisés Souza ⭐"
			],
			"insta": "https://www.instagram.com/moisesz_13/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/61b7734d-e8ba-4d46-a7ca-0f420f120377/cosmico-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=11afa61358f4181923d4bad7db012eb46f93c50df23843e4566dc1157497c545&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-09T04:38:00.000Z",
			"id": "2542a4fe-5fcd-4602-a18c-039446d1969b",
			"contadores": [
				"Cósmico",
				"Quadrinhos Feels",
				"Quadrinhos Reflexivos",
				"Nham nham",
				"Cliffhangers foda"
			],
			"caps_lidos": "2",
			"imagem_name": "cosmico-hq",
			"data_leitura": "2023-06-13T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Cosmico-PT-BR/info",
			"name": "Cosmico",
			"porcentagem_leitura": 28,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"2bbeb681-77b7-426d-8532-81fa797912d9"
			],
			"autor": [
				"Caioyo"
			],
			"insta": "https://www.instagram.com/caioyo/",
			"tags": "♂️",
			"twitter": "https://twitter.com/caioyo_art"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e15b94a2-09df-4e23-94b5-547baf0680c5/virutal-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=8fec343d6c0a3fd537d569f66b89f1a76662389d1af8ee9ac9300eefa0a73af0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-09T04:16:00.000Z",
			"id": "3a95235b-deaf-4d2d-a745-4ab933ffb2a2",
			"contadores": [],
			"caps_lidos": "10",
			"imagem_name": "virtual-hq",
			"data_leitura": "2023-04-18T22:51:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Virtual-PT-BR/info",
			"name": "Virtual",
			"porcentagem_leitura": 9,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "102",
			"autores": [
				"4b985faa-091e-4f40-b858-39b72e601a53"
			],
			"autor": [
				"Toro K."
			],
			"insta": null,
			"tags": "♀️",
			"twitter": "https://twitter.com/ranbuescalation"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8e2d6924-d774-4c48-86bf-c3339eb1adf5/ocordomistico-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=ea8b49050d470dfcfba7780e477b95be55862fd29c263af824663de72efeda27&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-08T20:20:00.000Z",
			"id": "78f442b4-c403-4c03-83dd-60e13988d111",
			"contadores": [
				"Inícios mitológicos",
				"Brasil Alternativo",
				"Golpes bem aplicados",
				"Omissões do IBAMA",
				"Husbandos",
				"Criaturas sobrenaturais",
				"Personagens de Óculos",
				"No Shape"
			],
			"caps_lidos": "9",
			"imagem_name": "cordãomistico-hq",
			"data_leitura": "2023-04-09T22:09:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/cordao-mistico",
			"name": "Cordão Místico",
			"porcentagem_leitura": 90,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"07dfc847-e1bb-4f15-8595-88cea34edb29"
			],
			"autor": [
				"Palam Gil Amorin ⭐"
			],
			"insta": null,
			"tags": "♂️",
			"twitter": "https://twitter.com/g_palam"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8949ea97-7ca5-4d98-98c9-18226cdfdffb/mafiadrip-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=df2507d5af96337bf5f9806b8ca0df0b1ef65dd64d90599c4e6bdf862b3e21e4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-06T20:24:00.000Z",
			"id": "6ebfd638-b581-4a2f-b168-cd145a67bd57",
			"contadores": [
				"Carros/Veículos sendo levantados",
				"Quebras de Expectativa",
				"Pais fumantes",
				"Casos de Familia",
				"Personagens Badass",
				"Ash Botando o boné pra trás"
			],
			"caps_lidos": "1",
			"imagem_name": "mafiadrip-hq",
			"data_leitura": "2023-04-08T00:30:00.000-03:00",
			"genero": [
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/mafia-drip",
			"name": "Mafia Drip",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"feecc179-8e29-4967-9452-c992f8fbeb91"
			],
			"autor": [
				"Raphael HHS ⭐"
			],
			"insta": "https://www.instagram.com/raphaelhhs/",
			"tags": "♂️",
			"twitter": "https://twitter.com/RaphaelHhs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a34fc270-eedf-493b-9621-39cc9a7fdfc9/jefejeb-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=bcf6eae803aa347fa381dd71579f06c4d1b1afcec05b9a9c53a3746887713ee7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-02T18:46:00.000Z",
			"id": "9774c9aa-0a6b-4e90-916f-46ea7fb0244d",
			"contadores": [
				"Duplinhas do Barulho",
				"Atrasildos",
				"Entradas fodas"
			],
			"caps_lidos": "1",
			"imagem_name": "jefejeb-hq",
			"data_leitura": "2023-05-28T21:57:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/jef-jeb",
			"name": "Jef & Jeb",
			"porcentagem_leitura": 10,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"99671b98-0918-43e7-adae-269e1b1542b8"
			],
			"autor": [
				"Gus Draw ⭐"
			],
			"insta": "https://www.instagram.com/gus_draw_/?igshid=zn60735ar7kb",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9b8785a5-c028-47e0-9c2c-152e68835289/thetalesoflibertalia-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=b33f1eca17e334dd1e2dd11b7e3d504d6139f6b85e87e174d6c170445b986906&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-01T19:49:00.000Z",
			"id": "d3b18c21-6ef4-4068-993d-0e25f25c7a5f",
			"contadores": [
				"Bang Bang",
				"Idosos agressores",
				"Temática de Piratas"
			],
			"caps_lidos": "1",
			"imagem_name": "thetalesoflibertalia-hq",
			"data_leitura": "2023-04-02T23:30:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/the-tales-of-libertalia-fjwy?origin=comic-index-list",
			"name": "The Tales of Libertália",
			"porcentagem_leitura": 50,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"01a2f557-17ec-4b37-8099-4669c86127ad"
			],
			"autor": [
				"João Vitor ⭐"
			],
			"insta": "https://www.instagram.com/tales_of_libertalia/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f5df0f94-02e2-4f78-9a1a-9bc048d97e8c/lotusdesangue-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=5bd6c440246ea224672e7f573c334014b4387ef71ff47ea6b70e798e82cf4d99&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-31T02:45:00.000Z",
			"id": "cf2bf61b-db13-4823-869b-2a3774c08a47",
			"contadores": [
				"Squad Goals"
			],
			"caps_lidos": "1",
			"imagem_name": "lotusdesangue-hq",
			"data_leitura": "2023-04-17T00:25:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/lotus-de-sangue?origin=comic-index-list",
			"name": "Lótus de sangue",
			"porcentagem_leitura": 50,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"0f0a3b52-3c2a-407a-9324-302356efeb9f"
			],
			"autor": [
				"Lucsil Art ⭐"
			],
			"insta": "https://www.instagram.com/lucsil.art/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8cfe138f-42f0-4125-857e-3a39073b863a/alice-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=1f471eec5469022f560ba5e919c5ab2e5ead810f4b5fefe1d856b7b675bb66a7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-31T01:42:00.000Z",
			"id": "e2dae309-4512-4655-a62e-33fe84772d27",
			"contadores": [
				"Pessoas sem senso de direção",
				"Rotinas Reais",
				"Protagonistas sentados na janela",
				"Camisas 10",
				"Alices"
			],
			"caps_lidos": "4",
			"imagem_name": "alice-hq",
			"data_leitura": "2023-04-16T22:26:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.zinnes.com.br/serie/718",
			"name": "#ALICE",
			"porcentagem_leitura": 44,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"c1c9f9b3-5ded-4f61-b3ca-624d85b4d0b9"
			],
			"autor": [
				"Dani Henke ⭐"
			],
			"insta": "https://www.instagram.com/danihenke_/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/68b04056-b3c2-4ea2-a526-ff2a6c35e654/aretomada-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=a3f79a27dad87b66cd312ac9ef39af951d52c261b7c03d0e86ba8e33f6f2091a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-30T11:17:00.000Z",
			"id": "d03f85f3-40c5-4da9-b942-b058e5a6bb0b",
			"contadores": [
				"Husbandos",
				"Críticas Sociais Foderosas",
				"Squad Goals",
				"Brasil Alternativo"
			],
			"caps_lidos": "3",
			"imagem_name": "aretomada-hq",
			"data_leitura": "2023-04-20T23:13:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-retomada-the-resumption?origin=search",
			"name": "A Retomada",
			"porcentagem_leitura": 13,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "22",
			"autores": [
				"a2790792-9d40-4b5a-b7bf-84418b11f41c"
			],
			"autor": [
				"psyuro ⭐"
			],
			"insta": "https://www.instagram.com/p.sdraws/",
			"tags": "♀️",
			"twitter": "https://twitter.com/yuroich"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7f8a615e-3d35-43cd-ab4e-1861f8bf3f6f/aorigemdosdeuses-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=df087588d1e733acb372fe71b446dc01eaef830d9671cf2e2bb19ca575a4f5b2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-30T11:15:00.000Z",
			"id": "8fe29f2a-99b7-458f-9854-7d4f8888f2b6",
			"contadores": [
				"Inícios mitológicos",
				"Temática de Céu/Inferno",
				"Sugar Daddies",
				"Autores pelo Celular / Mouse",
				"Entradas fodas",
				"Husbandos"
			],
			"caps_lidos": "2",
			"imagem_name": "aorigemdosdeuses-hq",
			"data_leitura": "2023-05-06T22:38:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-origem-dos-deuses?origin=search",
			"name": "Origem dos Deuses",
			"porcentagem_leitura": 11,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "18",
			"autores": [
				"1cf219d7-a8be-485f-923d-c4a7d9a36c17"
			],
			"autor": [
				"Dandh'ara Cássia"
			],
			"insta": "https://www.instagram.com/dandharacassia/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/576649e3-27f3-4ffe-8efc-0aeb5b61afaa/thatspecialperson-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=7593c26feb35c2a7abaa747c2d4b2d9325850ced918e173904b545edd8833a52&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-29T05:16:00.000Z",
			"id": "23e80167-a3ff-4a29-8130-b42be42914f1",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"Cabelos Estilosos",
				"Bullies",
				"Furry"
			],
			"caps_lidos": "2",
			"imagem_name": "thatspecialperson-hq",
			"data_leitura": "2023-04-09T22:35:00.000-03:00",
			"genero": [
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/that-special-person-m0n2",
			"name": "That Special Person",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"70c21685-8fbe-42ec-8aae-e943dfd9070d"
			],
			"autor": [
				"Mamãe Frederick ⭐"
			],
			"insta": "https://www.instagram.com/mamae_frederick/",
			"tags": "♀️",
			"twitter": "https://twitter.com/FrederickMamae"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/235290fd-6ad9-4b9d-9ced-c2a2abc686bd/chronosandray-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=9c1312977b22de0bff822f5d2e25d470d9a7fdc65573b4f1740ca6ab1a785da4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-29T01:52:00.000Z",
			"id": "bb2800e7-96d5-4ad7-9f04-6ff162c8e6d5",
			"contadores": [
				"Herdeiros",
				"Era Vitoriana",
				"Heterofobia nos olhos"
			],
			"caps_lidos": "1",
			"imagem_name": "chronosandray-hq  ",
			"data_leitura": "2024-09-15T23:06:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/chronos-ray",
			"name": "Chronos And Ray",
			"porcentagem_leitura": 11,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"ae310a6a-8bce-47de-8865-98b18638040d"
			],
			"autor": [
				"Aline Nyoh ⭐"
			],
			"insta": "https://www.instagram.com/aline_nidoriko/",
			"tags": "♀️",
			"twitter": "https://twitter.com/Nydoriko"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2b42104c-6af6-4d95-8a4a-d6ba943837e3/demonsonearth-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=7e16c7a2fbc03f3e91b4895fa27298834349e27af346ff996e73f1db379ded76&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-29T00:51:00.000Z",
			"id": "74c4c82e-9ebb-4eed-bfc7-7e59142cf79a",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"Gore",
				"Calvos",
				"Cenários Convenientemente muito bem Posicionados",
				"Peladões",
				"Golpes bem aplicados",
				"Universos que o B ia de base",
				"Anjo biblícamente acurado"
			],
			"caps_lidos": "1",
			"imagem_name": "demonsonearth-hq",
			"data_leitura": "2023-05-06",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/demons-on-earth?origin=latest-comics-list&fbclid=PAAaYuKvD4rxj-_0pCYDdh6TnhuTS_ZWlVhzpZ5S7HvFYvPrDjs40CxXWAvvM",
			"name": "DEMONS on EARTH",
			"porcentagem_leitura": 25,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"0703c28d-949a-4909-bf04-3ee5158393e5"
			],
			"autor": [
				"Biulitarts"
			],
			"insta": "https://www.instagram.com/biulit.arts/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1a168803-5ad2-4e45-a565-04d39053300e/troublemakers-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=666e382153519b35a30460bf9969b7e366941c5ecf69ccd433b1db5d39f2cf72&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-27T01:26:00.000Z",
			"id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"contadores": [
				"Taberneiros carecas",
				"Cabelos Estilosos",
				"Personagens Espivitados",
				"Golpes bem aplicados",
				"Idosos agressores",
				"Mulheres Negras",
				"Duplinhas do Barulho",
				"Mulheres Bombadas",
				"Caos instaurado",
				"Bigodudos",
				"Criaturas sobrenaturais",
				"No Shape",
				"Squad Goals",
				"Poses Fodas",
				"Personagens PCD",
				"Pais Fodas",
				"LQN Aparecendo em Quadrinhos Nacionais",
				"Vilões",
				"Véi Maluco",
				"Organizações Malígnas",
				"Ordem Religiosas",
				"Transformações",
				"Crias",
				"Pq diabos você mandou uma criança?",
				"Entrando pela janela"
			],
			"caps_lidos": "12",
			"imagem_name": "troublemakers-hq",
			"data_leitura": "2023-04-07T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": "https://loja.uiclap.com/titulo/ua34691/",
			"link_leitura": "https://www.zinnes.com.br/serie/686",
			"name": "Trouble makers ",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "12",
			"autores": [
				"4bc73f64-c423-4a4c-8bfc-a91032c14a22"
			],
			"autor": [
				"Jon Lizard ⭐"
			],
			"insta": "https://www.instagram.com/trouble_makersoficial/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b0f1c649-30a9-4d6b-931b-adcb34cf3680/lily-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=c6d383b36bf86131e0905483a10f139a551e1bca4bd22a918bb085b763f8f580&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-26T01:14:00.000Z",
			"id": "b7242228-56cd-42a4-b119-ba9b5e23ef4c",
			"contadores": [
				"Vovós fofas",
				"Personagens PCD",
				"Personagens Badass"
			],
			"caps_lidos": "4",
			"imagem_name": "lily-hq",
			"data_leitura": "2023-04-13T23:11:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Lily1/info",
			"name": "Lily",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"1fd0131b-f771-4752-8988-080ad5fcb287"
			],
			"autor": [
				"Juliana Lossio ⭐"
			],
			"insta": "https://www.instagram.com/julianalossioart/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6cc5d311-a08d-494b-9bdc-d2581f6e2555/aalmagemeadoanjo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=a500229000eecef697c230f0f2527e7e8712e0b818c4e75f705afd3917e78d09&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-22T01:19:00.000Z",
			"id": "39b3a465-2887-41e4-815b-faa5f9b8809c",
			"contadores": [
				"Beijocas"
			],
			"caps_lidos": "2",
			"imagem_name": "aalmagemeadoanjo-hq",
			"data_leitura": "2023-06-13T21:00:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/A-Alma-Gmea-do-Anjo/info",
			"name": "A Alma Gêmea do Anjo ",
			"porcentagem_leitura": 12,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "16",
			"autores": [
				"ff097212-1106-48c9-b37e-2f8167a5a27e"
			],
			"autor": [
				"Sayuritake ⭐"
			],
			"insta": "https://www.instagram.com/sayuritake/",
			"tags": "♀️",
			"twitter": "https://twitter.com/sayuritake_arts"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/aaf8dcdf-6228-4ca7-8f5c-8986e910c968/newgame-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=7b4ad03906e7ee732e87de0d3995d11eca4527b92af05952ac5ab98d84507ba9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-22T01:16:00.000Z",
			"id": "24f3c128-18f4-4cdc-87cf-a67dd38930ac",
			"contadores": [
				"Começos JRPGlike",
				"Artes Pikassas",
				"Ideias Superoriginais",
				"Personagens fofinhos",
				"Beijocas",
				"Camisas 10"
			],
			"caps_lidos": "10",
			"imagem_name": "newgame+-hq",
			"data_leitura": "2023-05-28T22:53:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": "https://shopee.com.br/New-Game-(Quadrinho)-i.406441702.21396919023",
			"link_leitura": "https://tapas.io/series/New-Game-PT-BR/info",
			"name": "New Game+",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"ff097212-1106-48c9-b37e-2f8167a5a27e"
			],
			"autor": [
				"Sayuritake ⭐"
			],
			"insta": "https://www.instagram.com/sayuritake/",
			"tags": "♀️",
			"twitter": "https://twitter.com/sayuritake_arts"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7cf3968c-5a3e-4862-b9c3-0d4d95591784/perdadecontrole-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=388dd37fcf805d8782d4dd4ee5c36da58184db403bbc40cbf98886478241b81e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-21T19:38:00.000Z",
			"id": "d0919065-baf2-40f1-9b27-d6d4547d2ad3",
			"contadores": [
				"Cliffhangers foda",
				"Histórias com policiais eficientes de verdade",
				"Artes Pikassas",
				"Gore",
				"Personagens de Óculos",
				"Beijocas",
				"Noitadas"
			],
			"caps_lidos": "7",
			"imagem_name": "perdadecontrole-hq",
			"data_leitura": "2023-03-21T22:30:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "+18",
					"color": "red"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/perda-de-controle",
			"name": "Perda de Controle",
			"porcentagem_leitura": 63,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"9da7f6e3-cb52-4c65-a4b9-0fdff2b646bf"
			],
			"autor": [
				"Manoela ⭐"
			],
			"insta": "https://www.instagram.com/perdadecontrole/",
			"tags": "♀️",
			"twitter": "https://twitter.com/perdadecontrole"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/213c7806-516a-4b15-a6ec-e9a958d2893e/universidadedosmortos-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=ba8d464cbcecb51967c7b4e8ce3311455bc4c4757e3734223c08d92131371342&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T23:28:00.000Z",
			"id": "73c17471-afb1-44bd-ad40-74a6670819cc",
			"contadores": [
				"Cliffhangers foda",
				"Criaturas sobrenaturais"
			],
			"caps_lidos": "1",
			"imagem_name": "universidadedosmortos-hq",
			"data_leitura": "2023-04-09T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/universidade-dos-mortos?origin=profile-list",
			"name": "Universidade dos Mortos",
			"porcentagem_leitura": 20,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"770dd53b-eba3-43b7-96bf-42a6bb0eac7f"
			],
			"autor": [
				"RelaxeBoy ⭐"
			],
			"insta": "https://www.instagram.com/relaxeboy_/",
			"tags": "♂️",
			"twitter": "https://twitter.com/RelaxeBoy"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/56e23c1c-20a1-4b8b-9b1c-28297e4f69d8/oataquedosvirus-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=a3038bb80e6b6b2dc4d782ca58db9a9b84b2a0ab5fa059069431b08209f5fadb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T23:12:00.000Z",
			"id": "d05fcb24-b471-435b-831a-0d9470f44c2c",
			"contadores": [
				"Camisas 10"
			],
			"caps_lidos": "1",
			"imagem_name": "oataquedosvirus-hq",
			"data_leitura": "2023-04-12T00:20:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/ovoselente?origin=profile-list",
			"name": "O Ataque dos Vírus ",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"3bb96b29-bf73-4008-b876-ec6b8df32133"
			],
			"autor": [
				"Mariana Santos"
			],
			"insta": "https://www.instagram.com/mari_ink2002/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2b08a15a-5e14-4512-81f4-8cc7ebaff376/purpura-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=ae61917c2469e24f5c539cf5aaba6d66777a0c4a91abfefee404c02e833e825d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T23:04:00.000Z",
			"id": "edc72a4a-cf3f-41e7-83a2-3ff40ef31ca7",
			"contadores": [
				"Pessoas sem senso de direção"
			],
			"caps_lidos": "8",
			"imagem_name": "purpura-hq",
			"data_leitura": "2023-05-09T22:05:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.zinnes.com.br/serie/685",
			"name": "Púrpura ",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "8",
			"autores": [
				"b61e554e-ca9e-4982-861b-573da1d734c3"
			],
			"autor": [
				"Beto Hessel ⭐"
			],
			"insta": "https://www.instagram.com/ohezzel/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/718c3314-45bd-4f33-9646-28896b89413f/docelegado-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=6976a6d16659e66f78ea08e88dd90c2e30b7e4fdb57a3b28e4e8e448898b47d9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T23:02:00.000Z",
			"id": "a2d38323-4ded-4405-a908-f4a56e967b7b",
			"contadores": [
				"Mafias",
				"Casos de Familia",
				"Bullies",
				"Cabelos Estilosos"
			],
			"caps_lidos": "2",
			"imagem_name": "docelegado-hq",
			"data_leitura": "2023-07-30T21:30:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/doce-legado?origin=profile-list",
			"name": "Doce Legado",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"b1ac50c4-2fb4-4f8e-90ed-1d3257ede6e3",
				"a9e2b1af-6b6b-44c3-9c4b-ce0bb534b740"
			],
			"autor": [
				"Krow ⭐",
				"Bell ⭐"
			],
			"insta": "https://www.instagram.com/krowruja_khosmika/",
			"tags": "♀️",
			"twitter": "https://twitter.com/Bell_e_Krow"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/aa314dcf-7b4b-4295-b078-5856ed16cdda/monstersoul-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=7fe23db8a7ee652d7246b2c3f40f5d9d7a8f5793d252a0b2a0a39818ca85796e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T22:57:00.000Z",
			"id": "6d3e80ee-d71c-4c43-9315-e89e1c60a999",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "monstersoul-hq",
			"data_leitura": "2023-07-30T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/monster-soul?origin=search",
			"name": "Monster Soul",
			"porcentagem_leitura": 25,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"72eea417-b394-47b4-947c-d442844db15b"
			],
			"autor": [
				"Uma Gata Muda"
			],
			"insta": "https://www.instagram.com/uma_gata_muda/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4adf5e4c-c105-4778-b988-7a18eecd1b9b/meuamigogelado-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=917a46d97772d402e62511530ae5c69655bc653fc77edd8c59d7ae96828f2028&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T22:53:00.000Z",
			"id": "3ad3b7c2-9117-4517-b3d9-6923ca234821",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "meuamigogelado-hq  ",
			"data_leitura": "2024-04-27",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/meu-amigo-gelado?origin=search",
			"name": "Meu Amigo Gelado",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"bea4327d-4683-4bc6-ac4d-499cea569084"
			],
			"autor": [
				"Gustavo Assis"
			],
			"insta": null,
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/acfafa61-1b85-46d2-8ed8-c042ceb83950/emocoes-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=8ecf3ac5e2e13174cb51267e7c4aaf2a37ba5b63c20e7a856288d3a4574e288b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T22:51:00.000Z",
			"id": "f8db11d5-2817-4ce5-b06f-d283e7ead629",
			"contadores": [
				"Quadrinhos Reflexivos"
			],
			"caps_lidos": "1",
			"imagem_name": "emocoes-hq",
			"data_leitura": "2023-03-30T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/emocoes?origin=search",
			"name": "Emoções ",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"855318bb-bdd6-4eda-9638-b2ea1111cd39"
			],
			"autor": [
				"Isabella Gomes ⭐"
			],
			"insta": "https://www.instagram.com/imagisfera/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2825fff2-a798-4742-a9f2-9017b984f618/vivendodedesenho-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=5cb06355cd94b5cf7baf80d407924fbe1965064c51bef8944a8a3a13e5a2f1a1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T22:49:00.000Z",
			"id": "82d3c612-e1a5-420c-8b23-6fa2c79a4c1c",
			"contadores": [
				"Mulheres Negras",
				"Pactos"
			],
			"caps_lidos": "1",
			"imagem_name": "vivendodedesenho-hq",
			"data_leitura": "2023-03-28T22:20:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/vivendo-de-desenho?origin=search",
			"name": "Vivendo de Desenho ",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"7fc01f66-676d-4f8c-b00f-04f64ecf726c"
			],
			"autor": [
				"Yasmin Celeste ⭐"
			],
			"insta": "https://www.instagram.com/yasz.ilustra/",
			"tags": "♀️",
			"twitter": "https://twitter.com/yasonenom"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5dd9f117-84e2-4744-af70-bc9b05445f25/pansy-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=f7eefc6bfc23ffb8a95219b4bffb671e43d68761c31199934608fbd6dc97bbff&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T22:46:00.000Z",
			"id": "ff0749fb-8929-4f98-ac9b-0aa55e648cf5",
			"contadores": [
				"Noitadas",
				"No Shape",
				"Biritas",
				"Beijocas"
			],
			"caps_lidos": "3",
			"imagem_name": "pansy-hq",
			"data_leitura": "2023-03-21T21:50:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/pansy?origin=search",
			"name": "Pansy",
			"porcentagem_leitura": 17,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "17",
			"autores": [
				"0a5c4afd-020a-44b9-a061-b46ac5ff9288"
			],
			"autor": [
				"Bundas Art ⭐"
			],
			"insta": "https://www.instagram.com/bundas_art/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/336859cd-4636-4502-bb7a-e7bba22f4c7c/quimera-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=da5e97ed020d29a2791a2bdb11ec2adc85e61d65720665902c8c3d3e2cd8401f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T22:43:00.000Z",
			"id": "ee7d46ce-ee4a-4504-bcf7-afebb4b45cea",
			"contadores": [
				"Power System"
			],
			"caps_lidos": "2",
			"imagem_name": "quimera-hq",
			"data_leitura": "2023-03-30T23:30:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Histórico",
					"color": "red"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/quimera-volume-1?origin=search",
			"name": "Quimera",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"fd0f3c4e-17f5-4638-b29f-70e9b85a12a1"
			],
			"autor": [
				"Kellen Karollyne"
			],
			"insta": "https://www.instagram.com/kellenkarollyne_/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4ed2b9f2-f030-40ca-951d-cbb3a93bb50d/conseguemeentender-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=451ffe7d6871f12654a7001580d41481ada17868e96716801b6f8cacdafee787&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T22:34:00.000Z",
			"id": "9b5a4bc0-f192-4d22-b839-df57b5a5db70",
			"contadores": [
				"Quadrinhos Reflexivos"
			],
			"caps_lidos": "1",
			"imagem_name": "conseguemeentender-hq",
			"data_leitura": "2023-03-30T22:10:00.000-03:00",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/consegue-me-entender?origin=search",
			"name": "Consegue me Entender?",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"5fde470e-f257-4364-9a63-39095f90ab7d"
			],
			"autor": [
				"Grazielle Gomes ⭐"
			],
			"insta": "https://www.instagram.com/_red.wings/",
			"tags": "♀️",
			"twitter": "https://twitter.com/gomas_redwings"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cb1bb41b-1d18-4985-95e0-cea0c05276f9/wodamigosecreto-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=dee3d9db2a542dfd26cffabe753f181cada612f198bbe058d203822721fae9d8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T11:57:00.000Z",
			"id": "f09b71b7-edad-42bc-ab95-4613c841a3c4",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "wodamigosecreto-hq",
			"data_leitura": "2023-03-28T23:50:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/wod-amigo-oculto?origin=comic-index-list",
			"name": "WOD - Amigo Oculto ",
			"porcentagem_leitura": 16,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"6bbc581e-6873-4665-a033-0b28259bb375"
			],
			"autor": [
				"Ana Bia ⭐"
			],
			"insta": "https://www.instagram.com/anabia_arte/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c5cb92d8-d71c-45c0-999e-6796dd14a39e/kyleeemkabusmo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=aeea40672d265d06bce942022bdddba565441dea5106baba14fc624789b6d818&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T11:49:00.000Z",
			"id": "97749624-c0e9-4017-85c4-4efccb7edc26",
			"contadores": [
				"Personagens fumantes",
				"Cicatrizes e Tatuagens",
				"Cabelos Estilosos",
				"Pintadas de Clima",
				"Rotinas Reais"
			],
			"caps_lidos": "4",
			"imagem_name": "kyleeemkabusmo-hq",
			"data_leitura": "2023-03-28T22:47:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/kylee-in-kabusmo?origin=search",
			"name": "Kylee em Kabusmo",
			"porcentagem_leitura": 66,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"91d50fd7-31a9-4826-a852-ae07d3e67b86"
			],
			"autor": [
				"Sarah Amagi ⭐"
			],
			"insta": "https://www.instagram.com/sarahamagiart/",
			"tags": "♀️",
			"twitter": "https://twitter.com/dinosarah101"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1c8cded1-fa2b-48d3-a36b-c5c1f2ae11bb/diadesaovalentim-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=29e85533821b5dc4b9be29fe70f9ce3fda304f02e6cac702e568158056a80406&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T11:46:00.000Z",
			"id": "6451b8d6-2aa9-439e-9c18-8d2759b151ce",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "diadesaovalentim-hq",
			"data_leitura": "2023-03-26T23:06:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/dia-de-sao-valentim-rejeitado-desl?origin=search",
			"name": "Dia de São Valentim Rejeitado",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"3db2ca98-29f0-47aa-9cd7-900b2cf54165"
			],
			"autor": [
				"Mariana Takafuji"
			],
			"insta": "https://www.instagram.com/maritakafuji/",
			"tags": "♀️",
			"twitter": "https://twitter.com/MariTakafuji"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2afe260c-07ec-448b-bdf4-80a5d714a73a/bluemoon-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=f53e256cc91cce10885af677aa4ca41afe2b06a76555d3d2ab63ddedb371d762&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T11:45:00.000Z",
			"id": "38ee8870-8d2d-4fae-b521-027f80b2e117",
			"contadores": [
				"Personagens fofinhos",
				"Rotinas Reais"
			],
			"caps_lidos": "2",
			"imagem_name": "bluemoon-hq",
			"data_leitura": "2023-03-26T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/blue-moon?origin=search",
			"name": "Blue Moon",
			"porcentagem_leitura": 50,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"e983213c-2ffd-4190-af66-d82e65cf4579"
			],
			"autor": [
				"Liebe Leta ⭐"
			],
			"insta": "https://www.instagram.com/liebe.leta/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a043f541-d427-4620-a7a6-80168643d16c/amoralemdotempo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=0e2322a0aa78887e53fa689162dd6c58fc57087107945e14870ae6ba9fceb74a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T11:43:00.000Z",
			"id": "a27478fb-c589-4169-ba7c-4f8e1c2105c4",
			"contadores": [
				"Calvos",
				"Viagem no Tempo"
			],
			"caps_lidos": "2",
			"imagem_name": "amoralemdotempo-hq",
			"data_leitura": "2023-03-26T23:42:00.000-03:00",
			"genero": [
				{
					"name": "Sobrenatural",
					"color": "default"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/amor-alem-do-tempo-love-beyond-time-pt-br?origin=search",
			"name": "Amor Além do Tempo",
			"porcentagem_leitura": 25,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "8",
			"autores": [
				"39c242bc-29e4-4fab-9427-547e6d0d7747"
			],
			"autor": [
				"Andrielle Bezerra"
			],
			"insta": "https://www.instagram.com/fartura.art/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f860d34a-462f-4ceb-b3ed-b387b8efc57b/eclipse-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=1ccf55b254915a779e3142f848c5928d64b176c23d98b090584bcf58e335acd0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T11:42:00.000Z",
			"id": "42625a1b-face-493e-b799-01d5bde2d8ec",
			"contadores": [
				"Pais que foram comprar cigarro",
				"Criaturas sobrenaturais"
			],
			"caps_lidos": "1",
			"imagem_name": "eclipse-hq",
			"data_leitura": "2023-03-23T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/eclipse-n7ey?origin=search",
			"name": "Eclipse ",
			"porcentagem_leitura": 50,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"0d53e9f8-8d44-4615-8118-56ec551cb555"
			],
			"autor": [
				"RavenNoodle"
			],
			"insta": "https://www.instagram.com/_ravennoodle_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/raven_noodle"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5aee0895-76be-45d8-81fe-51cfc3a81182/basket360-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=60349bb7b9677a6a98c3c06301bfa86ce1930a55819bc6e23529a0f882e405ef&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T11:39:00.000Z",
			"id": "1fc59bde-ae22-4ddf-abe1-2bbed1f675ab",
			"contadores": [
				"Autores pelo Celular / Mouse"
			],
			"caps_lidos": "1",
			"imagem_name": "basket360-hq",
			"data_leitura": "2023-03-24T23:20:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/basket360?origin=search",
			"name": "Basket360",
			"porcentagem_leitura": 25,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"b14717f2-d896-4399-a125-77402bf34c07"
			],
			"autor": [
				"Anna Viegas"
			],
			"insta": "https://www.instagram.com/basket360_oficial/",
			"tags": "♀️",
			"twitter": "https://twitter.com/saferehys"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/17023eae-0064-491c-9f5a-90463fd1fe5a/princesadeareia-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=f812acaaabdd3a65eb20fcc397560c2209a57287b93e42cf01f92c6dc7d5c85e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-14T19:44:00.000Z",
			"id": "7a322772-319e-437b-8a8c-2c0f6d4dcfd8",
			"contadores": [
				"Quadrinhos Reflexivos",
				"Mulheres Negras"
			],
			"caps_lidos": "3",
			"imagem_name": "princesadeareia-hq",
			"data_leitura": "2023-03-15T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/serie/28",
			"name": "Princesa de Areia",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"9a910562-d74f-4ff2-b636-42b8e1c0d2b8"
			],
			"autor": [
				"Verônica Berta"
			],
			"insta": "https://www.instagram.com/veronica.berta/",
			"tags": "♀️",
			"twitter": "https://twitter.com/veronicaberta_"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8726b2b3-a985-4e24-98d2-c268c06eb13e/desviantes-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=5207e59ab79ab5649888e90d72181388bd21da8bdd117ceb2d14d22e7b778f5c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-13T03:07:00.000Z",
			"id": "605b8c53-24f6-4a8c-8dcd-9b70af1c1f47",
			"contadores": [
				"Apocalipses Brasileiros"
			],
			"caps_lidos": "1",
			"imagem_name": "desviantes-hq",
			"data_leitura": "2023-03-17T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/serie/9",
			"name": "Desviantes",
			"porcentagem_leitura": 5,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "20",
			"autores": [
				"60c87919-d5ed-4a24-aca3-a5a039eaa4c4",
				"c9539f60-94e7-438e-b4db-7f7ad836af97",
				"1e2c5717-df23-42f1-8f10-bc35502b6286"
			],
			"autor": [
				"Gabriel Barros ⭐",
				"Ana Recalde",
				"Fred Hildebrand ⭐"
			],
			"insta": "https://www.instagram.com/gabsthegabs/",
			"tags": "♂️",
			"twitter": "https://twitter.com/gabsthegabs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/63f9be1b-350d-4dae-b419-808ee043ceaf/sanguequente-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=cf3d1ba51520ef111e42483ba10f5a90e4859007e1ca20464e23fccf9a85631f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-12T16:47:00.000Z",
			"id": "79d2fb3d-d4d0-488d-a219-a984504a39ae",
			"contadores": [
				"Críticas Sociais Foderosas",
				"Crias",
				"Criaturas sobrenaturais"
			],
			"caps_lidos": "3",
			"imagem_name": "sanguequente-hq",
			"data_leitura": "2023-03-12T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Sobrenatural",
					"color": "default"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://funktoon.com/serie/sangue-quente",
			"name": "Sangue Quente",
			"porcentagem_leitura": 25,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "12",
			"autores": [
				"1f305618-54f8-420b-93fb-399650df1fee"
			],
			"autor": [
				"Juliana Moon"
			],
			"insta": "https://www.instagram.com/julianamoon/",
			"tags": "♀️",
			"twitter": "https://twitter.com/notjulianamoon"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e5117c9b-68eb-4e9e-ba5d-7cc15476f99e/circodelata-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=66a7f41bda1fb387db404773335ed533e7819ee6ab68d775aeab995ad9c34646&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-10T20:54:00.000Z",
			"id": "e206a308-0597-416f-bb06-dfa8e998e622",
			"contadores": [
				"Protagonistas sentados na janela",
				"Escolas que ninguem tem aula de verdade"
			],
			"caps_lidos": "1",
			"imagem_name": "circodelata-hq",
			"data_leitura": "2023-03-19T23:33:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Shonen",
					"color": "red"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/circo-de-lata?origin=profile-list",
			"name": "Circo de Lata",
			"porcentagem_leitura": 10,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"7449dc02-789b-467e-b6e2-fdf67af7b27f"
			],
			"autor": [
				"Sofia"
			],
			"insta": "https://www.instagram.com/sofiaborges0306/",
			"tags": "♀️",
			"twitter": "https://twitter.com/SofiaB0306"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b550047a-87a5-47f3-aaa0-ade10ce8797e/nevoaescarlate-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=b5f6acdc129131d78e71aab8577f5977a4a4a14b6e28694fab8270351bad2b3e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-09T21:33:00.000Z",
			"id": "9c72d594-2881-45c9-928c-151fd89cb671",
			"contadores": [
				"Cicatrizes e Tatuagens",
				"Mulheres Negras",
				"Ruivinhos Metidos",
				"Personagens de Óculos",
				"Era Vitoriana"
			],
			"caps_lidos": "7",
			"imagem_name": "nevoaescarlate-hq",
			"data_leitura": "2023-03-09T22:58:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Nevoa-Escarlate/info",
			"name": "Névoa Escarlate",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"55e0ea12-3c08-48ad-b430-19ba2284b289"
			],
			"autor": [
				"LariSugarNeko ⭐"
			],
			"insta": "https://www.instagram.com/larisugarneko/",
			"tags": "♀️",
			"twitter": "https://twitter.com/LariSugarNeko"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/587039ce-cd4a-43f3-8ced-677c5328cc43/lourrence-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=2b824dc4dcfb91795019952e57a69b7194a3d051fc6f66a61e1aded8cbddddb0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-07T12:39:00.000Z",
			"id": "17f5a8a3-34f0-4f84-aa99-f3106a072d5f",
			"contadores": [
				"Vinganças",
				"Bang Bang"
			],
			"caps_lidos": "3",
			"imagem_name": "lourrence-hq",
			"data_leitura": "2023-03-08T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/lourrence",
			"name": "Lourrence",
			"porcentagem_leitura": 15,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "19",
			"autores": [
				"02886f08-e1b5-4376-8a30-040567d125b0"
			],
			"autor": [
				"HT Café"
			],
			"insta": "https://www.instagram.com/hora_de_tomar_cafe/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/19760c23-1363-4489-969d-6d0fb2e112d3/lynneogatocarteiro-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=8361b504e2c8c046c02d7b87a82f3199d0ad28e022b375e68a5411217ef2ad83&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-06T21:14:00.000Z",
			"id": "0c193d2b-ca91-4a8c-9ea9-777f06ebb236",
			"contadores": [
				"Melhores Sinopses"
			],
			"caps_lidos": "1",
			"imagem_name": "lynneogatocarteiro-hq",
			"data_leitura": "2023-08-10T22:30:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Lynn-e-o-Gato-Carteiro",
			"name": "Lynn e o Gato Carteiro",
			"porcentagem_leitura": 50,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"a230cd95-01be-471e-841f-553e86c3eb61"
			],
			"autor": [
				"Lobo Lualua ⭐"
			],
			"insta": "https://www.instagram.com/lobolualua/",
			"tags": "♀️",
			"twitter": "https://twitter.com/lobolualua"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/45503eb6-d76a-4e04-9877-7a221582bdc8/spaceshit-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=f5e7cd4949794aa8a922f9048def8a0da75f09d56f0ddf84d34fdc7e384ed2b2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-06T15:54:00.000Z",
			"id": "26e60eb0-ed06-41ff-b885-f7c80c80f34d",
			"contadores": [
				"Personagens PCD"
			],
			"caps_lidos": "1",
			"imagem_name": "spaceshit-hq",
			"data_leitura": "2023-06-20T21:30:00.000-03:00",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/spaceshit?origin=profile-list",
			"name": "SPACESHIT",
			"porcentagem_leitura": 16,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"1e2c5717-df23-42f1-8f10-bc35502b6286"
			],
			"autor": [
				"Fred Hildebrand ⭐"
			],
			"insta": "https://www.instagram.com/fredhildebrandart/",
			"tags": "♂️",
			"twitter": "https://twitter.com/FredHildebrand5"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/adbc56e6-2cdc-47da-afa0-c4de72f8b263/umbra-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=e124a6747b7b5af76d468dbcab438277cf74ed6704780a4a330fd01dbc4059ac&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-06T14:07:00.000Z",
			"id": "27c5b787-dbcb-4bff-94f9-549332c25eff",
			"contadores": [
				"Quebras de Expectativa",
				"Vinganças",
				"Lutas até a morte"
			],
			"caps_lidos": "1",
			"imagem_name": "umbra-hq",
			"data_leitura": "2023-03-15T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/UMBRA_",
			"name": "Umbra",
			"porcentagem_leitura": 9,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"f0ebbdc1-09e3-4d4d-a64a-09ef2224810e"
			],
			"autor": [
				"Sangalli"
			],
			"insta": "https://www.instagram.com/sangalli_draws/",
			"tags": "♂️",
			"twitter": "https://twitter.com/sangalli__"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/41fd6ab5-389a-4963-8fdb-94a4bd01d16b/acquine-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=a709d43baf365bee8e167b86a57a6319b89d7c68dcfa9b67b415e6708e4b7d87&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-06T14:06:00.000Z",
			"id": "7140661f-836c-4661-8432-31b2dbd9020f",
			"contadores": [
				"Husbandos",
				"Criaturas sobrenaturais"
			],
			"caps_lidos": "2",
			"imagem_name": "acquine-hq",
			"data_leitura": "2023-05-06",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Acquine",
			"name": "Acquine (PT-BR)",
			"porcentagem_leitura": 1,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "146",
			"autores": [
				"2f140e08-0d24-4647-8a24-c3fbd94f4d8c"
			],
			"autor": [
				"André Inácio"
			],
			"insta": "https://www.instagram.com/desinho_x/",
			"tags": "♂️",
			"twitter": "https://twitter.com/desinho_x"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/96145591-54e0-4011-8c95-69c75ea50313/alemdalua-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=fb0592655af74df2f2e0b4f323cc6253d2d2f661eef3e0fe7e76e5c8a2ae9186&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-05T22:29:00.000Z",
			"id": "62e9c68e-81c6-43e4-9801-cf6149ddd8aa",
			"contadores": [
				"Power System"
			],
			"caps_lidos": "2",
			"imagem_name": "alemdalua-hq",
			"data_leitura": "2023-03-05T22:25:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/alem-da-lua-xkgq?origin=most-pop-list",
			"name": "Além da lua",
			"porcentagem_leitura": 6,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "32",
			"autores": [
				"1a7f8c62-2000-4d3e-918f-84f7978c0d1e"
			],
			"autor": [
				"Mi Silva ⭐"
			],
			"insta": "https://www.instagram.com/m_mmstarmoon/",
			"tags": "♀️",
			"twitter": "https://twitter.com/Harley77704287"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4ff49117-71dc-4925-87b6-e686f302f4be/vaderetro-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=42c04b3b76242039f06aee7d3347222d4f5224279f2e0c0010488e59040f163d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-05T01:47:00.000Z",
			"id": "ac948942-dc73-4bf2-8141-c293ff73c1d5",
			"contadores": [
				"Carros/Veículos sendo levantados",
				"Crias",
				"Criaturas sobrenaturais",
				"Busão"
			],
			"caps_lidos": "13",
			"imagem_name": "vaderetro-hq",
			"data_leitura": "2023-03-16T22:17:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Vade-Retro/info",
			"name": "Vade Retro",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "13",
			"autores": [
				"b680b3db-c25a-4668-b8f0-8ddd0abf9004"
			],
			"autor": [
				"Dyo ⭐"
			],
			"insta": "https://www.instagram.com/_dyonisian_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/dyonisian_"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c5a34416-1c6d-479a-b60d-7d3d98ab9159/mondolis-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=92876e218a8f3cec5ec817f53ce6eb6438afe2f46c8e86d5477164697b08ec41&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-04T22:40:00.000Z",
			"id": "6e8f55a1-5d20-424d-9b89-d47adcabf13e",
			"contadores": [
				"Coisas no olho",
				"Logos"
			],
			"caps_lidos": "1",
			"imagem_name": "mondolis-hq  ",
			"data_leitura": "2024-02-27",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Mondolis-PTBR",
			"name": "Mondolis",
			"porcentagem_leitura": 20,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"f205d964-707c-4dfb-9bdf-af19a7bd3200"
			],
			"autor": [
				"Monge Han ⭐"
			],
			"insta": "https://www.instagram.com/mongehan/",
			"tags": "♂️",
			"twitter": "https://twitter.com/MongeHan"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7ddc84ae-e7bf-445f-8ca3-42f8d910b8a0/algaia-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=7afeb423ba3e8a566672ed876ceb40b7ec0f3974da33e476834d64fd7b6dd75a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-04T18:44:00.000Z",
			"id": "d4643cfd-f450-4d70-aa96-4c5224fc7132",
			"contadores": [
				"Revoluções contra governos autoritarios",
				"Inícios mitológicos",
				"Cicatrizes e Tatuagens",
				"Começos JRPGlike",
				"Passados Trágicos",
				"CLTs",
				"Golpes bem aplicados",
				"Vilarejos em um mundo Fantasia",
				"Vinganças",
				"Husbandos",
				"No Shape"
			],
			"caps_lidos": "3",
			"imagem_name": "algaia-hq",
			"data_leitura": "2023-03-07T22:11:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Shonen",
					"color": "red"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.zinnes.com.br/serie/431",
			"name": "Algaia",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"8d2bf7de-7c24-4245-91a7-c820c1f56ff6"
			],
			"autor": [
				"Vitor Bardo ⭐"
			],
			"insta": "https://www.instagram.com/vbardoarts/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f1af4739-d03a-433c-85d7-38aa05c79f29/jerimun-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=86ae9887aa77b1a1d583fd54c79ac25a15b866126b0d4ee009ed64c88c0645b1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-27T15:56:00.000Z",
			"id": "02495cc0-1fc5-417a-82a1-8ea77bdfb0ce",
			"contadores": [
				"CLTs",
				"Furry",
				"Duplinhas do Barulho"
			],
			"caps_lidos": "1",
			"imagem_name": "jerimum-hq",
			"data_leitura": "2023-04-30T23:02:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Jerimum---Exorcista-Assalariada/info",
			"name": "Jerimum - Exorcista Assalariada",
			"porcentagem_leitura": 10,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"8caf0be8-cb98-4115-bfef-03c73ff7f581"
			],
			"autor": [
				"Deleon Stu"
			],
			"insta": "https://www.instagram.com/deleonstu/",
			"tags": "♂️",
			"twitter": "https://twitter.com/studeleon"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bcb1510f-62e6-4a04-91f3-c947409d3fb2/grughappydays-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=7746e142fcad1cab05ce7b8087513dd30ef41017202140865a3879f4ca4871e3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-27T03:15:00.000Z",
			"id": "461bea2d-98f0-4f75-b135-cce8f4e9d58d",
			"contadores": [
				"Isekai"
			],
			"caps_lidos": "6",
			"imagem_name": "grughappydays-hq",
			"data_leitura": "2023-04-16T00:14:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/grug-happy-days",
			"name": "Grug: Happy Days",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"ca730233-854e-49bc-a1da-bcb9dbc89651",
				"8b381255-655c-480b-908e-472152232fc0"
			],
			"autor": [
				"Reiko Yuma ⭐",
				"Bruwi ⭐"
			],
			"insta": "https://www.instagram.com/reiko_yuma/",
			"tags": "♀️",
			"twitter": "https://twitter.com/studioarkano"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/95bec0a8-158e-443f-ac2e-27d559d25110/unluckycrow-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=b434dbcfb154f60f990166075f4a15c33fae19ebbb82b00196cdfd5c7a7cb625&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-24T01:20:00.000Z",
			"id": "707b68d5-b4f4-4923-9b59-89324371ea82",
			"contadores": [
				"Pais que foram comprar cigarro",
				"Cliffhangers foda",
				"Olhares fodas",
				"Cabelos Estilosos",
				"Passados Trágicos",
				"Ovo",
				"Duplinhas do Barulho"
			],
			"caps_lidos": "13",
			"imagem_name": "unluckycrow-hq",
			"data_leitura": "2023-02-26T22:44:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/unlucky-crow",
			"name": "Unlucky Crow",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "13",
			"autores": [
				"ca730233-854e-49bc-a1da-bcb9dbc89651"
			],
			"autor": [
				"Reiko Yuma ⭐"
			],
			"insta": "https://www.instagram.com/reiko_yuma/",
			"tags": "♀️",
			"twitter": "https://twitter.com/studioarkano"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f33e322c-31b6-4c09-8fbc-cd121c37054f/filhosdafenix-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=ab5955e96203c3733c7aa988b27d79d48147c896b9d0eab85f8b2f7b6452fefb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-03T22:38:00.000Z",
			"id": "dd8117b6-d775-49b7-bb5e-6e6b55daa77d",
			"contadores": [
				"Cicatrizes e Tatuagens",
				"Golpes bem aplicados",
				"Caolhos",
				"No Shape"
			],
			"caps_lidos": "1",
			"imagem_name": "filhosdafenix-hq",
			"data_leitura": "2023-04-16T22:45:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/2744513",
			"name": "Filhos da Fênix",
			"porcentagem_leitura": 25,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"4c22a57b-82e5-4df0-9c9c-60819d302f86"
			],
			"autor": [
				"Athos Kauã ⭐"
			],
			"insta": null,
			"tags": "♂️",
			"twitter": "https://twitter.com/SilverWinchest"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4635a680-38b8-4984-999b-d585d221a1de/soulmates-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=bd9f0f5f90d9aa5ef3f2ee74c49fe87a072e20646364c18ab8f892f10233fc5c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-03T22:34:00.000Z",
			"id": "a9839e64-e156-4b1b-be04-a7ab157b45e8",
			"contadores": [
				"Hehe"
			],
			"caps_lidos": "1",
			"imagem_name": "soulmates-hq  ",
			"data_leitura": "2024-04-27T23:30:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Soulmats",
			"name": "Soulmates",
			"porcentagem_leitura": 2,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "41",
			"autores": [
				"b574b279-9786-4768-ba2c-c4652f65db48"
			],
			"autor": [
				"Raqli ⭐"
			],
			"insta": "https://www.instagram.com/raqli_art/",
			"tags": "♀️",
			"twitter": "https://twitter.com/raqli_art"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d6276052-5e72-4058-a1ca-18869bb8b109/oretornodekurt-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=9a0506c3c93230067735f25613f5d3bb0decd902e8fc6d934f6ea97099891430&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-03T22:33:00.000Z",
			"id": "98578353-e750-4e43-b839-1d26572bfef1",
			"contadores": [
				"Protagonistas que não deixam os mortos mortos",
				"Criaturas sobrenaturais",
				"Artes Pikassas",
				"Pactos",
				"Legalizer"
			],
			"caps_lidos": "3",
			"imagem_name": "oretornodekurt-hq",
			"data_leitura": "2023-03-31T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/O-retorno-de-Kurt",
			"name": "O retorno de Kurt",
			"porcentagem_leitura": 60,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"b574b279-9786-4768-ba2c-c4652f65db48"
			],
			"autor": [
				"Raqli ⭐"
			],
			"insta": "https://www.instagram.com/raqli_art/",
			"tags": "♀️",
			"twitter": "https://twitter.com/raqli_art"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/aa7f8fc3-0344-4d60-90c3-434a2ea9cbfc/arlindo-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=c01900b2f90001c0db4f69920d4660bebd63dc2f6a1eddb464c63bb5ee60c4d8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-03T22:32:00.000Z",
			"id": "690cc70b-99e2-4e7c-a952-9e1fcecc0ff0",
			"contadores": [
				"Bullies",
				"Quadrinhos Feels"
			],
			"caps_lidos": "2",
			"imagem_name": "arlindo-hq",
			"data_leitura": "2023-03-21T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": "https://www.amazon.com.br/Arlindo-Brochura-Ilustralu/dp/8555341914/ref=sr_1_3?__mk_pt_BR=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3MOZIX8H0TI0W&keywords=arlindo+brochura&qid=1646309278&s=books&sprefix=arlindo+brochura%2Cstripbooks%2C263&sr=1-3",
			"link_leitura": "https://twitter.com/ilustralu/status/1499360719921418254",
			"name": "Arlindo",
			"porcentagem_leitura": 66,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"a856237d-ccc9-4e2d-8beb-7276a7ad4b9e"
			],
			"autor": [
				"Ilustralu"
			],
			"insta": "https://www.instagram.com/ilustralu/",
			"tags": "♀️",
			"twitter": "https://twitter.com/ilustralu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9142ab56-8116-41ed-a47b-ef41ebf1d8ad/ainsurgenciaceleste-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=56cfff115b63918e4c6065ddbdd43dcd9a0e844c0153da0abadec2254f76dc7c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-03T22:31:00.000Z",
			"id": "f37b3e11-ecf3-4c6b-be20-8da070592520",
			"contadores": [
				"Personagens com medo de falar com o crush",
				"Escolas que ninguem tem aula de verdade",
				"Protagonistas sentados na janela",
				"Camisas 10",
				"Temática de Céu/Inferno",
				"Criaturas sobrenaturais",
				"Balões diferenciados",
				"Akira reference",
				"Mitologias"
			],
			"caps_lidos": "2",
			"imagem_name": "ainsurgenciaceleste-hq",
			"data_leitura": "2023-03-19T22:45:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-insurgencia-celeste",
			"name": "A INSURGÊNCIA CELESTE",
			"porcentagem_leitura": 7,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "26",
			"autores": [
				"980ddb2b-2320-4f86-a8ac-bede423b7e4a"
			],
			"autor": [
				"Maíra Colares ⭐"
			],
			"insta": "https://www.instagram.com/mairadraws/",
			"tags": "♀️",
			"twitter": "https://twitter.com/ColaresMaira"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/83825bef-c119-44c6-8ce9-4e2600bb3f93/krista-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=a2fd0675db5895947bc2bd3e2584bcd4863189e00d4e148637efaaedeb3669a0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-03T22:27:00.000Z",
			"id": "49756a11-2ed5-4971-8017-bb31be337032",
			"contadores": [
				"Melhores Sinopses"
			],
			"caps_lidos": "4",
			"imagem_name": "krista-hq",
			"data_leitura": "2023-07-27T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.webtoons.com/en/challenge/krista-portugues/list?title_no=825042",
			"name": "Krista",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"e44c19b6-9375-4ddd-9019-067937f4d4b1"
			],
			"autor": [
				"Bi Aguiart ⭐"
			],
			"insta": "https://www.instagram.com/bi.aguiart/",
			"tags": "♀️",
			"twitter": "https://twitter.com/biaguiart"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ea8c374a-f513-4fdc-b43e-29939b7f60f5/calistia.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=b03a9853d6032d450d46a6eecf58d8a99c2c8dfff845a955d5d2148b598302d6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-31T19:21:00.000Z",
			"id": "c7e1a017-8bc5-4058-87cd-7baf3542e7c7",
			"contadores": [
				"Começos JRPGlike",
				"Cobras Gigantes"
			],
			"caps_lidos": "1",
			"imagem_name": "calistia-hq",
			"data_leitura": "2023-04-09T23:37:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Calistia/info",
			"name": "Calístia",
			"porcentagem_leitura": 8,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "12",
			"autores": [
				"9bd0efc4-a2d7-4e1d-b29d-5b71d500e244"
			],
			"autor": [
				"Hud Justino"
			],
			"insta": "https://www.instagram.com/calistiahq/",
			"tags": "♂️",
			"twitter": "https://twitter.com/CalistiaHQ"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6b01e064-f8f5-4f65-be24-02f7bb671e08/cancao_do_narval.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=fca745c83fea20cf872f67c228f0de2051800c6754f0270de22a2216a51be8e8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-31T19:21:00.000Z",
			"id": "336e6ccd-ddd6-4bc1-bf37-c58ca46d1978",
			"contadores": [
				"Furry"
			],
			"caps_lidos": "1",
			"imagem_name": "cancaodonarval-hq",
			"data_leitura": "2023-03-16T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Cancao-do-Narval/info",
			"name": "Canção do Narval",
			"porcentagem_leitura": 2,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "39",
			"autores": [
				"361acf03-9198-420c-b69c-f78479dbf08d"
			],
			"autor": [
				"Sila Cinnamon"
			],
			"insta": "https://www.instagram.com/silacinnamon/",
			"tags": "♀️",
			"twitter": "https://twitter.com/SilaCinnamon"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fc8a07ff-058a-4287-8199-cd9c26b4a410/blackend_days.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=acbeec1dccdeef78f1a13e96d737599c90d11723ed1c0e8361a5d1a4ddba9955&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-31T19:20:00.000Z",
			"id": "179293ef-8840-442d-a89c-9678e739ad3f",
			"contadores": [
				"Entradas fodas",
				"Contador de merda certa",
				"Histórias com policiais eficientes de verdade",
				"Cenas na Chuva"
			],
			"caps_lidos": "1",
			"imagem_name": "blackeneddays-hq",
			"data_leitura": "2023-05-09",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.zinnes.com.br/serie/276",
			"name": "Blackened Days: Noite da Verdade",
			"porcentagem_leitura": 50,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"0760f2a2-7d35-4d5d-9b01-34fb3d76bdab"
			],
			"autor": [
				"Vortexu"
			],
			"insta": "https://www.instagram.com/jeanjulian__vrtx/",
			"tags": "♂️",
			"twitter": "https://twitter.com/JeanJulian_"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5623c6ef-d283-4c92-9d9f-f064ab59347e/Balsamus.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=635f5f65157f7f06f3036143af3dbebadcc4f661a7af9ba8b19702b01ee06db7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-31T19:18:00.000Z",
			"id": "9141c65d-e6d5-4119-ab8b-52db5f9a37e7",
			"contadores": [
				"Inícios mitológicos",
				"Husbandos",
				"Comilões",
				"Caolhos"
			],
			"caps_lidos": "2",
			"imagem_name": "balsamus-hq",
			"data_leitura": "2023-03-10T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/1828431",
			"name": "Balsamus",
			"porcentagem_leitura": 12,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "16",
			"autores": [
				"237b1a93-61fd-4841-8457-ffe31f78d0c1"
			],
			"autor": [
				"Karolyne Rocha"
			],
			"insta": "https://www.instagram.com/karolynerocha_art/",
			"tags": "♀️",
			"twitter": "https://twitter.com/KarolyneRochart"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a52a190c-569b-4439-9527-b05f95b59bbc/sense_life.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=e07b42045c320b37fbc919540ccc02bc98388b57a7b728a382959039503a70b8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-30T23:11:00.000Z",
			"id": "c7b448f3-eb39-437b-a4f0-e64c47531421",
			"contadores": [
				"Corpos Reais",
				"Camisas 10",
				"Beijocas",
				"Noitadas",
				"Consoles Desbloqueados",
				"Bang Bang",
				"Golpes bem aplicados",
				"Pessoas sem senso de direção",
				"Podrão",
				"Palavrões",
				"Desempregados \"Autonomos\" MEI ou sem direitos trabalhistas (\"\"Empreendedores\"\")",
				"Samurais",
				"No Shape",
				"Husbandos",
				"Lutas até a morte",
				"Duplinhas do Barulho",
				"Mais que irmãos brothers",
				"Legalizer",
				"Personagens Badass",
				"Mulheres Bombadas",
				"Hehe",
				"Organizações",
				"Time 7",
				"Quadrinhos com trilha sonoras indicadas pelo autor",
				"Headshots",
				"Sacodes",
				"Famosos"
			],
			"caps_lidos": "8",
			"imagem_name": "senselife-hq",
			"data_leitura": "2023-04-11T23:01:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://mangalivre.net/manga/sense-life/13493",
			"name": "Sense Life",
			"porcentagem_leitura": 80,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"c7c46061-0e31-4dfe-ba8f-618ced2b72f6"
			],
			"autor": [
				"Glitch Tellend ⭐"
			],
			"insta": "https://www.instagram.com/glitch_tellend/",
			"tags": "♂️",
			"twitter": "https://twitter.com/GlitchTellend"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b9476261-bff2-4600-b130-d0164e19c9d2/tenebrous.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=79f3f29b467ccb43d0d24418f3237a0ce52e756b18bdba7a7f9dc92fedbc35a2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-30T22:29:00.000Z",
			"id": "525953e8-6cb0-4951-ae57-7b6c95a28117",
			"contadores": [
				"Escolas que ninguem tem aula de verdade"
			],
			"caps_lidos": "1",
			"imagem_name": "tenebrous-hq",
			"data_leitura": "2023-03-21T23:35:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/tenebrous?origin=comic-index-list",
			"name": "Tenebrous",
			"porcentagem_leitura": 33,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"3c8df460-1138-472d-9127-7e848fa2cf7a"
			],
			"autor": [
				"Kenia Howard"
			],
			"insta": "https://www.instagram.com/keniahoward0912/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e62f71f2-ff9c-4f66-9f68-bed169639965/cafeina.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=e825039c195e188a9f12550b566523fdde4382c0c4e12afb94fa901c7f0e10c4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-30T22:18:00.000Z",
			"id": "d8b9d5be-68f9-468c-b4a6-b5a85dbbb39c",
			"contadores": [
				"Husbandos",
				"Camisas 10"
			],
			"caps_lidos": "2",
			"imagem_name": "cafeina-hq",
			"data_leitura": "2023-05-25T22:06:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/cafeina?origin=profile-list",
			"name": "Cafeína",
			"porcentagem_leitura": 28,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"bfbf0fcf-e897-4e41-b6fb-4b5e4120c4bb"
			],
			"autor": [
				"Kauan Breno"
			],
			"insta": "https://www.instagram.com/kauan_brenocm/",
			"tags": "♂️",
			"twitter": "https://twitter.com/kau4708"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/37edfc84-6a66-48a1-8834-8c552e0f0b06/The_Garden.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=b4525170b1805175c3a7bddfd869006ccd5e411f22070972783e290cbd577f6e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-30T02:47:00.000Z",
			"id": "59597aac-8801-4c08-a13c-470aa7ee8c83",
			"contadores": [
				"Furry",
				"Quadrinhos que falam o nome do quadrinho dentro do quadrinho (Title Drop)"
			],
			"caps_lidos": "1",
			"imagem_name": "thegarden-hq  ",
			"data_leitura": "2024-04-27",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/2486095",
			"name": "The Garden ",
			"porcentagem_leitura": 50,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"9248f707-2513-4387-ba94-fb571a336ce0"
			],
			"autor": [
				"Millie ⭐"
			],
			"insta": "https://www.instagram.com/millicamacho_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/CamachoMilli"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0ff94c22-5107-4275-b4b5-23c9ee0e0096/Albi.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=455741947521f3169066859003bd2e2354afb444135aa4692a742b63d22947e5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-30T02:40:00.000Z",
			"id": "0e1f58e4-5562-421e-98a6-be3fef14d145",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "albi-hq",
			"data_leitura": "2023-05-06",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/albi-a-origem-lk26?origin=profile-list",
			"name": "Albi",
			"porcentagem_leitura": 3,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "30",
			"autores": [
				"b02b3774-59ef-414b-bd6a-1b916bccd811"
			],
			"autor": [
				"Álex Coelho"
			],
			"insta": "https://www.instagram.com/alex.coelh0/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e04b7c4f-6317-4e97-8416-7f96df756af9/sindrome_de_domino.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=197539bc64676f76288075614e9e544817fdfad0e15ae3f1d443367af3cf43b8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-30T02:25:00.000Z",
			"id": "f9920ede-f3cc-4f61-b386-0bdb325decec",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "sindromededomino-hq",
			"data_leitura": "2023-02-26T22:15:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.webtoons.com/en/challenge/síndrome-de-dominó/list?title_no=613886",
			"name": "Sindrome de Dominó",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"5ed08bca-16fe-4526-8f25-93bf5e82b9e4"
			],
			"autor": [
				"Thomas Sasso ⭐"
			],
			"insta": "https://www.instagram.com/thomassasso/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Thomas_sasso_"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/74eff8f5-1f03-46fd-a698-9e6021955d34/A_Coordenada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=dc790ea640c4507c15472ffaf0d20389f229a7139c77cdde82eb4495a40e4176&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-27T22:24:00.000Z",
			"id": "f9b208d2-8e61-42a1-bea9-16b737f324c0",
			"contadores": [
				"Taberneiros carecas",
				"Temática de Piratas",
				"Cabelos Estilosos"
			],
			"caps_lidos": "1",
			"imagem_name": "acoordenada-hq",
			"data_leitura": "2023-04-02T23:40:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-coordenada?origin=new-from-people-you-follow-list",
			"name": "A coordenada",
			"porcentagem_leitura": 50,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"b02b3774-59ef-414b-bd6a-1b916bccd811"
			],
			"autor": [
				"Álex Coelho"
			],
			"insta": "https://www.instagram.com/alex.coelh0/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8b03850e-9f87-47ff-9521-403a6e191263/crr.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=01f138d2827b6e07729bb0f7b258c9de1d06f2777ab4470e56baf98b8717d539&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-27T02:39:00.000Z",
			"id": "7c367d12-567c-4fe2-9072-e3a4afea0b4d",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "crr-hq",
			"data_leitura": "2023-01-29T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Esporte",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/crr-caminho-para-a-vitoria-q52x/001",
			"name": "CRR Caminho Para Vitoria ",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"922dd61c-f271-49ad-b9bb-b7a36630d4b6"
			],
			"autor": [
				"Miguel Mota da Silva"
			],
			"insta": "https://www.instagram.com/arte.mms/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a1af1f73-fcb2-4ffb-9c9b-258d0506d232/T-man.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=550bdff96ace301aebcdbeb4ee88ec9477899a974409a9df9b79878f230678b9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-24T06:55:00.000Z",
			"id": "30cc92de-a307-49a9-bd3d-a717fe5b8e7e",
			"contadores": [
				"Quadrinhos Reflexivos",
				"Críticas Sociais Foderosas"
			],
			"caps_lidos": "1",
			"imagem_name": "tman-hq",
			"data_leitura": "2023-03-19T22:11:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/t-man?origin=profile-list",
			"name": "T-Man",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"ca730233-854e-49bc-a1da-bcb9dbc89651"
			],
			"autor": [
				"Reiko Yuma ⭐"
			],
			"insta": "https://www.instagram.com/reiko_yuma/",
			"tags": "♀️",
			"twitter": "https://twitter.com/studioarkano"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0173bb7f-62fc-4018-bc56-11d658dddadf/Hell_deck.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=0df93c8890fe2891dcfe285a1cc8e0877ebbf35c373de7f76fef37c28eb286bc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-24T06:52:00.000Z",
			"id": "dace1182-8d80-4f48-872d-78aabce01eb1",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "helldeck-hq",
			"data_leitura": "2023-03-07T23:15:00.000-03:00",
			"genero": [
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/hell-deck-remaster?origin=profile-list",
			"name": "Hell Deck",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"ca730233-854e-49bc-a1da-bcb9dbc89651"
			],
			"autor": [
				"Reiko Yuma ⭐"
			],
			"insta": "https://www.instagram.com/reiko_yuma/",
			"tags": "♀️",
			"twitter": "https://twitter.com/studioarkano"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8e64c7a2-224d-49f1-bb4d-c1928e1bd07a/forma_ou_consciencia.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=ffaa1c7cf9ce0e0caf4d860ab3ccb5a722c72e43eb955f0d33b86b10e063dedd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-24T00:30:00.000Z",
			"id": "9f11910e-5cd3-4839-ae88-55df741c43ca",
			"contadores": [
				"Inícios mitológicos",
				"Bigodudos",
				"Samurais",
				"Casos de Familia",
				"Furry",
				"Duelos de Espadas",
				"Rivais"
			],
			"caps_lidos": "10",
			"imagem_name": "formaouconsciencia-hq",
			"data_leitura": "2023-03-05T22:30:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/forma-ou-consciencia-0mvx?origin=search",
			"name": "Forma Ou Consciência ",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"7c78cedb-935a-4644-9aac-c31b9ba4c071"
			],
			"autor": [
				"Akila ⭐"
			],
			"insta": "https://www.instagram.com/_akigabriel/",
			"tags": "♂️",
			"twitter": "https://twitter.com/HQ_Forma"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5aa22f7c-a4c7-4f02-9c5e-3e6e86b37d2a/ato_falho.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=0895dcbce07fc128cf0cc664fa8a57ba01470f00f016d17b68a0b18f8e0648d5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-23T02:50:00.000Z",
			"id": "856d3348-9663-4529-82fc-60b5b9495300",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "atofalho-hq",
			"data_leitura": "2023-05-02T22:33:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/1371584",
			"name": "Ato Falho",
			"porcentagem_leitura": 14,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "14",
			"autores": [
				"b3cc0f04-9508-4929-b2dc-c0cbc8726fee"
			],
			"autor": [
				"Andy Corsant ⭐"
			],
			"insta": "https://www.instagram.com/andycorsant/",
			"tags": "♂️",
			"twitter": "https://twitter.com/AndyCorsant"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1b2a52da-7803-43c2-be7c-e402bf8d2bb7/florescer.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=53a679addf52ed5cea0c737401d3466e3ee06c76b5e1a4bbb46878701a019fa4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-23T02:49:00.000Z",
			"id": "b90922ff-7e39-412b-a6c0-4aa612ebdd49",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "florescer-hq",
			"data_leitura": "2023-01-29T13:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/2539547",
			"name": "Florescer (Uma das Histórias da Coletânea de Mitos e Lendas)",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"36b54fc7-4aee-4aee-b9ef-21a08fd14664",
				"9248f707-2513-4387-ba94-fb571a336ce0",
				"d5181c07-657d-4ccd-bddc-0f963644a27b"
			],
			"autor": [
				"LetyCorujapa",
				"Millie ⭐",
				"Minervini ⭐"
			],
			"insta": "https://www.instagram.com/lety.corujapa/",
			"tags": "♀️",
			"twitter": "https://twitter.com/lety_corujapa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4cbc6e2b-45f0-4d4e-a6a4-4a2ef02a8b46/silver_moon.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=21a7df5673200c3c3cde7bd4cf5a69d5d51a440ab79cfa4da90f9014e3c1c6b1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-23T02:47:00.000Z",
			"id": "34c16564-6b30-44cf-b4ba-34601f78b190",
			"contadores": [
				"Começos JRPGlike"
			],
			"caps_lidos": "3",
			"imagem_name": "silvermoon-hq",
			"data_leitura": "2023-02-23T22:22:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.webtoons.com/en/challenge/silver-moon-português/list?title_no=614835",
			"name": "Silver Moon",
			"porcentagem_leitura": 21,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "14",
			"autores": [
				"d5181c07-657d-4ccd-bddc-0f963644a27b"
			],
			"autor": [
				"Minervini ⭐"
			],
			"insta": "https://www.instagram.com/minerviniilustra/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/37a8248e-041a-46c2-a3cb-5a2f813da283/DayDreamPeak.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=ce28671c202e7152f2846d9d7ff4419cdeaf7985d9b43fba9874c4240139e320&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-23T02:46:00.000Z",
			"id": "80ba99d6-d16a-47af-a67f-4bcbab6a1760",
			"contadores": [
				"Cabelos Estilosos"
			],
			"caps_lidos": "1",
			"imagem_name": "daydreampeak-hq",
			"data_leitura": "2023-01-26T20:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/DayDream-Peak-PT-BR",
			"name": "DayDream Peak ",
			"porcentagem_leitura": 9,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"9248f707-2513-4387-ba94-fb571a336ce0"
			],
			"autor": [
				"Millie ⭐"
			],
			"insta": "https://www.instagram.com/millicamacho_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/CamachoMilli"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6a76df5b-1e63-46e5-a9bd-e56e5c0d4e12/camu_camu.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=848a5ccd901dcd5e4a42e6fa60f602c917d226d87e7096e7a3987eec56cbcced&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-19T18:07:00.000Z",
			"id": "af49fc05-908c-465a-9e1d-6c9e740cd9b0",
			"contadores": [
				"Revoluções contra governos autoritarios",
				"Brasil Alternativo"
			],
			"caps_lidos": "2",
			"imagem_name": "camucamu-hq",
			"data_leitura": "2023-01-19T22:06:00.000-03:00",
			"genero": [
				{
					"name": "Ficção Científica",
					"color": "blue"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/camu-camu",
			"name": "Camu-Camu",
			"porcentagem_leitura": 50,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"ea60c2b9-b139-4306-8f52-98c99cc9e69e"
			],
			"autor": [
				"Francinildo Sousa ⭐"
			],
			"insta": "https://www.instagram.com/oartista.fs/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Oartistafs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/507d7732-0d3f-4f04-9372-0d2bbd853bfa/inspirao.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=43cb251fc6de3b28aea7d8faafc8078530287ca61b32c7cf92f12ae26d468fd1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-19T14:52:00.000Z",
			"id": "50618aaf-f798-4749-acf6-02b57f74e0bd",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "inspiração-hq",
			"data_leitura": "2024-04-27",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://m.tapas.io/series/Inspirao-One-Shot---PT-BR/info",
			"name": "Inspiração ",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"9fd511ae-3cd4-4c19-82c7-6cf59df32a8c"
			],
			"autor": [
				"Box of Tales"
			],
			"insta": "https://www.instagram.com/boxoftales/?hl=pt-br",
			"tags": "♀️",
			"twitter": "https://twitter.com/mboxoftales"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a49d8c78-1b68-466e-aafa-fbd774e58c0c/miracle_dog.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=d3c238ce8870276a49ab3d2eae1953ae94acee9c80fd426850f84ce70b8041b4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-19T14:46:00.000Z",
			"id": "95bc977f-1791-4b9a-8b2a-0f105f2a5254",
			"contadores": [
				"Temática de Céu/Inferno",
				"Bullies",
				"Rotinas Reais",
				"Cabelos Estilosos"
			],
			"caps_lidos": "14",
			"imagem_name": "miracledog-hq",
			"data_leitura": "2023-05-01T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://m.tapas.io/series/Miracle-Dog-PT-BR/info",
			"name": "Miracle Dog",
			"porcentagem_leitura": 23,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "60",
			"autores": [
				"9fd511ae-3cd4-4c19-82c7-6cf59df32a8c"
			],
			"autor": [
				"Box of Tales"
			],
			"insta": "https://www.instagram.com/boxoftales/?hl=pt-br",
			"tags": "♀️",
			"twitter": "https://twitter.com/mboxoftales"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/af07cc28-4ce8-4f5a-94b3-04d5b50dc149/anne_e_brianna.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=d7926554661254206cf93d81e9d799af2819c1a1c0d853624158ce2be5182b9b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-19T14:43:00.000Z",
			"id": "98b0b004-78e5-407f-98e1-e2f9454e07d2",
			"contadores": [],
			"caps_lidos": "5",
			"imagem_name": "anneebrianna-hq",
			"data_leitura": "2023-05-02T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://m.tapas.io/series/Anne--Brianna-PT---BR/info",
			"name": "Anne e Brianna",
			"porcentagem_leitura": 22,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "22",
			"autores": [
				"b32f9636-7f02-493a-86b9-a82c66223dd8"
			],
			"autor": [
				"Anne Bell"
			],
			"insta": null,
			"tags": "♀️",
			"twitter": "https://twitter.com/AnneBell_Artes"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0d43a768-8709-4696-8a69-6b2a15d47dab/mamao_com_aucar.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=af5865f2411c2abdd2931d5691970d0188ace6dc1a543e8097fecd6ff2a48c6e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-19T14:41:00.000Z",
			"id": "b36b25e4-0d52-46d6-a02b-8a9a39919c62",
			"contadores": [
				"Escolas que ninguem tem aula de verdade"
			],
			"caps_lidos": "9",
			"imagem_name": "mamaocomaçucar-hq",
			"data_leitura": "2023-01-22T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Mamaocomacucar",
			"name": "Mamão Com Açúcar ",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"48f611c0-b671-4d10-ba7d-d9a7ee8acbff"
			],
			"autor": [
				"Owlopes ⭐"
			],
			"insta": "https://www.instagram.com/owlopes.arts/",
			"tags": "♂️",
			"twitter": "https://twitter.com/walparadise"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d1b44c88-d10e-4a7a-bf5d-0416cbd09558/Menmar.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=eba9e8b64ec2e18220482d007b08526e98561933cdd3700a2c1d30171694db70&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-19T14:38:00.000Z",
			"id": "2900e572-0340-456a-bb2f-1ed673044593",
			"contadores": [
				"Inícios mitológicos",
				"Cliffhangers foda"
			],
			"caps_lidos": "2",
			"imagem_name": "menmar-hq",
			"data_leitura": "2023-04-28T00:02:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/menmar-ptbr/info",
			"name": "Menmar",
			"porcentagem_leitura": 12,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "16",
			"autores": [
				"b2ad682d-c074-49cf-b43d-8d018302bc4d"
			],
			"autor": [
				"Fernanda Iridium ⭐"
			],
			"insta": "https://www.instagram.com/iridium.fernandanoronha/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e627c576-7a7a-4fe8-9fee-d7fdc2f009df/bilove.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=17ed0fe526525b1c0d9a08330b21d1f24bc02c0da40a53cbc661a874a6ab2d06&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-19T14:37:00.000Z",
			"id": "2c5d83ec-27a3-4d83-b107-378f1ea1891a",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"Ruivinhos Metidos",
				"Husbandos",
				"Camisas 10",
				"Talarico",
				"Rotinas Reais",
				"Personagens com medo de falar com o crush"
			],
			"caps_lidos": "4",
			"imagem_name": "bilove-hq",
			"data_leitura": "2023-01-29T23:50:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "LGBTQIAPN+",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://m.webtoons.com/en/challenge/bilove-ptbr/list?title_no=338963",
			"name": "BiLove",
			"porcentagem_leitura": 7,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "52",
			"autores": [
				"fae88c26-6738-4485-8741-b1172c1596f6"
			],
			"autor": [
				"Loba Art ⭐"
			],
			"insta": "https://www.instagram.com/loba.art/",
			"tags": "♀️",
			"twitter": "https://twitter.com/ArtLoba"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3fbea86b-ecd1-401d-835e-38f185a8b41e/hqsde3paginas-hq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=baf19a574080dddd37f3b9adac47e9cbd80bfbec26811ad604b30c2826521293&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-19T14:35:00.000Z",
			"id": "d38c896e-a232-4a37-b913-f25b6dd974f9",
			"contadores": [
				"Perdendo a cabeça",
				"Gore",
				"Quebras de Expectativa"
			],
			"caps_lidos": "21",
			"imagem_name": "hqsde3paginas-hq",
			"data_leitura": "2023-04-02T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/quadrinhos-com-3-paginas-a-coletanea?origin=most-popular-list-index",
			"name": "Histórias Curtas Em 3 Páginas ",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "21",
			"autores": [
				"69626598-4d93-4e11-8b11-a96e37b81dbe",
				"bfbf0fcf-e897-4e41-b6fb-4b5e4120c4bb",
				"5345a81f-7381-43d0-9dad-78ed3f0d7ce1",
				"5c602629-63a8-428e-8275-02a400ca02c7",
				"3a54bc1b-7b3e-470e-99a9-2b83d1282f2a",
				"87403cfd-8959-43a0-a2d4-3b46ac632671",
				"f8aa891a-6231-4169-9d81-755ba52a3897",
				"99671b98-0918-43e7-adae-269e1b1542b8",
				"97088075-94fd-44e8-983e-b12774cbde62",
				"039c5601-76fc-4f46-a373-209edf670759",
				"17ac82f3-82ae-4ccb-b55c-250dfb9c6439",
				"77c701e8-f649-4209-9070-142054d7a266",
				"2b57bf8e-f874-4af7-961f-1358c79f7f8a",
				"0a5c4afd-020a-44b9-a061-b46ac5ff9288",
				"711ecb32-5150-4d34-920a-4a2b49c61f9f"
			],
			"autor": [
				"Stéphanie Rachel ⭐",
				"Kauan Breno",
				"Pepasmaga ⭐",
				"Santart",
				"CarretaComics ⭐",
				"Hiroshi V Jump",
				"CyberPanda ⭐",
				"Gus Draw ⭐",
				"EmogiArts",
				"Kreb",
				"DamitGabriel ⭐",
				"Hermitão",
				"Sam The210",
				"Bundas Art ⭐",
				"Lee Enrike ⭐"
			],
			"insta": "https://www.instagram.com/_stephanierachel_/",
			"tags": "♀️",
			"twitter": "https://twitter.com/Teffyrachel_"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1a17cd5a-c1f0-48be-a57c-1074551a2398/ager_stellas.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=b2ab389eddbcb9998bc860a560eb9d7d022a7f99863c407159e2a9ea139acb42&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-18T16:39:00.000Z",
			"id": "d39c364f-a281-4c23-858c-c4a4ae2a09b3",
			"contadores": [
				"Cliffhangers foda",
				"Duplinhas do Barulho"
			],
			"caps_lidos": "8",
			"imagem_name": "agerstellas-hq",
			"data_leitura": "2023-01-22T23:40:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Ager-Stellas-PT-BR",
			"name": "Ager Stellas",
			"porcentagem_leitura": 53,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "15",
			"autores": [
				"a0e67866-b9ad-40bf-80a0-082082f5cd9d"
			],
			"autor": [
				"M2 Draws ⭐"
			],
			"insta": "https://www.instagram.com/m2_draws/",
			"tags": "♂️",
			"twitter": "https://twitter.com/M2_Draws"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ff69b6f0-f351-4863-b58a-ac2825237bc9/13_ao_topo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=7b604e9a200f71e5394f85d6f831be53ebc7723540a8ff57554c68fc1b173a72&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-18T01:52:00.000Z",
			"id": "c0d7b70e-7a9a-4196-9bf9-fbae46aca3d9",
			"contadores": [
				"Caolhos"
			],
			"caps_lidos": "1",
			"imagem_name": "13aotopo-hq",
			"data_leitura": "2023-03-05T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Esporte",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/13-ao-topo?origin=search",
			"name": "13 ao topo ",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"02e41580-e160-47d5-a4df-7970f8226f29"
			],
			"autor": [
				"Paulo Marcello ⭐"
			],
			"insta": "https://www.instagram.com/paulo_marcello_art/",
			"tags": "♂️",
			"twitter": "https://twitter.com/PauloMarcelo16"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3e587770-86fb-4912-bdf6-b9e68079b155/Ginga.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=8a106b3c929c5206276aabdd6a3e6746c3a5cbc4030458b962e5f5d5dee2bc1a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-18T01:51:00.000Z",
			"id": "a5748d22-e809-4af4-905b-0413e7de7ebe",
			"contadores": [
				"Golpes bem aplicados",
				"No Shape"
			],
			"caps_lidos": "1",
			"imagem_name": "ginga-hq",
			"data_leitura": "2023-01-19T23:30:00.000-03:00",
			"genero": [
				{
					"name": "Esporte",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/ginga-53bi?origin=search",
			"name": "Ginga (OneShot)",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"02e41580-e160-47d5-a4df-7970f8226f29"
			],
			"autor": [
				"Paulo Marcello ⭐"
			],
			"insta": "https://www.instagram.com/paulo_marcello_art/",
			"tags": "♂️",
			"twitter": "https://twitter.com/PauloMarcelo16"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bf0c3ea6-b3c0-4a19-8195-88c9551fd378/marbles_creatures.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=67acc45e63ba23e8db4b45818621be96576e9a6a4b2fff1e9bd95709723e85cb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-16T02:06:00.000Z",
			"id": "62c5ba80-4c59-4c3a-bf3f-001b2a8781ed",
			"contadores": [
				"Talarico"
			],
			"caps_lidos": "1",
			"imagem_name": "marblecreatures-hq",
			"data_leitura": "2023-04-20T22:40:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.webtoons.com/en/challenge/marble-creatures-descontinuado/list?title_no=618532",
			"name": "Marble Creatures",
			"porcentagem_leitura": 5,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "20",
			"autores": [
				"eb71df3a-a83e-435e-b36b-89205a17f82b"
			],
			"autor": [
				"Theo Herrmann ⭐"
			],
			"insta": "https://www.instagram.com/theoherrmann0025/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5e3d706b-40b5-4686-ab37-fc10e6e26747/vidas_imperfeitas.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=b76f3f0f124aeaeb14276e751065d372ffc05de7ba44398e70b5b125c719bb7e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-16T02:01:00.000Z",
			"id": "70948036-2b41-403b-a9ff-d34260c949be",
			"contadores": [
				"Rotinas Reais",
				"Biritas",
				"Beijocas"
			],
			"caps_lidos": "1",
			"imagem_name": "vidasimperfeitas-hq",
			"data_leitura": "2023-02-23T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://issuu.com/marianacagnin/docs/vidas_imperfeitas_marycagnin",
			"name": "Vidas Imperfeitas",
			"porcentagem_leitura": 10,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"f4ca287d-10f3-479b-87dd-fec3b1125680"
			],
			"autor": [
				"Mary Cagnin"
			],
			"insta": "https://www.instagram.com/marycagnin/",
			"tags": "♀️",
			"twitter": "https://twitter.com/marycagnin"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/81b260a6-fcc2-4730-a1b3-040a67d4fab3/illusion.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=8fee7cd6c3b7752866230ed4dc27f24f192c354cc5b9f9a6d7058afa9fbbfe15&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-16T01:59:00.000Z",
			"id": "e95573c1-18d6-48cf-8291-c197b8bc9f0f",
			"contadores": [
				"Criaturas sobrenaturais",
				"Pintadas de Clima"
			],
			"caps_lidos": "1",
			"imagem_name": "illusion-hq",
			"data_leitura": "2023-03-15T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/illusion?origin=search",
			"name": "Ilussion",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"0fe067e6-8752-4166-adac-4176754c42bb"
			],
			"autor": [
				"Isamara Gontijo"
			],
			"insta": "https://www.instagram.com/isamarag99/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a8d5e328-8e73-4f8f-aad8-35653bc95cc9/colibris.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=96299a07907923997655423dec40b12e9d6c38c85ff84beb4140724e7e26e6dc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-16T01:39:00.000Z",
			"id": "38597977-6bd3-4dee-8b01-0b6ac67a416e",
			"contadores": [
				"Críticas Sociais Foderosas",
				"Rotinas Reais",
				"Casos de Familia"
			],
			"caps_lidos": "1",
			"imagem_name": "colibris-hq",
			"data_leitura": "2023-03-15T23:58:00.000-03:00",
			"genero": [
				{
					"name": "Esporte",
					"color": "green"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/colibris?origin=latest-comics-list",
			"name": "Colibris",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"35fa9f77-016b-45a8-a92b-f2a81edfd6c0"
			],
			"autor": [
				"Larissa Melo"
			],
			"insta": "https://www.instagram.com/laris.mel/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f22f924e-3814-4889-add5-db3c2eef3706/Screenshot_20230115_200803_Twitter.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=bfc5c7b789541c2f2a1ae08e2f525267ef040191f08d02254c891650c0419d38&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-15T23:01:00.000Z",
			"id": "45fc84ca-f987-482f-9342-d57c75e55020",
			"contadores": [
				"Quadrinhos Feels"
			],
			"caps_lidos": "5",
			"imagem_name": "girt-hq",
			"data_leitura": "2023-01-15T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Ficção Científica",
					"color": "blue"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/GIRT-Um-conto-humano",
			"name": "GIRT - Um conto Humano",
			"porcentagem_leitura": 27,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "18",
			"autores": [
				"b33565f3-529e-4f52-be99-93ec815e92e6"
			],
			"autor": [
				"Clyver - Leonardo ⭐"
			],
			"insta": "https://www.instagram.com/clyverx/",
			"tags": "♂️",
			"twitter": "https://twitter.com/clyverx"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b94ac56e-0ac3-4fba-b444-029804bf9f8c/lendas_de_vera_cruz.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=954823e9179cd4b403f5e41208819d15c760a488b3ff4263946daa19a0f2ee7b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-13T02:15:00.000Z",
			"id": "854abf8f-4679-44af-b544-600b8ba7416b",
			"contadores": [
				"Brasil Alternativo",
				"Vovós fofas",
				"Cliffhangers foda",
				"Calvos",
				"Furry",
				"Golpes bem aplicados",
				"Vilarejos em um mundo Fantasia",
				"Vinganças",
				"Passados Trágicos",
				"Criaturas sobrenaturais",
				"Reptilianos"
			],
			"caps_lidos": "5",
			"imagem_name": "lendasdeveracruz-hq",
			"data_leitura": "2023-01-22T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/lendas-de-vera-cruz",
			"name": "Lendas de Vera Cruz",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"63fe1f46-bef0-4274-9eb9-3d0ec9497af4"
			],
			"autor": [
				"Diego SSA ⭐"
			],
			"insta": "https://www.instagram.com/diegosanderson3/",
			"tags": "♂️",
			"twitter": "https://twitter.com/ssa_diego"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/167a82b7-18b7-47e4-b622-cf28f4a62534/no_time_for_witches.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232855Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=2932156b94eef965742e34996eae9a67e320f5328350e62111795657238b8e15&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-09T01:26:00.000Z",
			"id": "c2ce2b0f-5054-43d2-89a3-88ad4174dc5f",
			"contadores": [
				"Autores pelo Celular / Mouse",
				"Bruxas"
			],
			"caps_lidos": "1",
			"imagem_name": "notimeforwitches-hq",
			"data_leitura": "2023-01-26T22:35:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/sem-tempo-para-bruxas",
			"name": "Sem Tempo Para Bruxas!",
			"porcentagem_leitura": 33,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"0a14ec04-f148-43db-9fef-7c2cea04ba52"
			],
			"autor": [
				"Arcker Dias"
			],
			"insta": "https://www.instagram.com/arcker.dias/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f1416230-27d7-41b4-a664-c9a599d8b63d/Rainy_Night.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=74d851fca62e3f1ed2d95d50c06c4477ec5856a30da5ccb0ef13d210d5c676f4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-09T01:23:00.000Z",
			"id": "665c238e-260a-4b3c-943b-a6d38bfe14dd",
			"contadores": [
				"Cenas na Chuva"
			],
			"caps_lidos": "4",
			"imagem_name": "rainynight-hq",
			"data_leitura": "2023-03-05T00:17:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/rainy-night",
			"name": "Rainy Night",
			"porcentagem_leitura": 100,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"ca730233-854e-49bc-a1da-bcb9dbc89651"
			],
			"autor": [
				"Reiko Yuma ⭐"
			],
			"insta": "https://www.instagram.com/reiko_yuma/",
			"tags": "♀️",
			"twitter": "https://twitter.com/studioarkano"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6772c018-2626-434d-a6c7-f90aca72565c/gui_inch_a_conspirao.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466YHVVTPP6%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232856Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJHMEUCIQCxTBbbF7ZjMGIVaZixSLqqkC9lb%2BXlwQm8f6cYZ%2B3LqQIge2IJwu%2FBlv2B44YYF%2FgB9QssGa%2Fkv4IC%2Fk5T2a9zE%2B0qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIjdLZ4alqhxrxdmuCrcA0liqijl3wFBKv2A9pNO1pJcM80LwYodeAqDEqrJu70nLTk8sRTggkLiealNyS8ErDDOzrAkuey%2Bl67uKarY4AkRZ%2BBqMuJ2qFaiZo6oKDCkY6Va3dqnXdWS45x8zA%2Fx1YV%2BtWfyvFIchG8GDPidV%2FOcOxqtjURPnryGKSm14p4tP%2BLmk6EtxzcjAvS6SVLJ4RHSsfJw1YXRXv2A%2Btg%2FoyMGO4ylPiEyq%2F8%2FJ2qGJBCezEPa%2BhtIzLs6ADv7BI9VH6aM51djdSBEbvrhEc5MncUwlEGUG31BmfdKkcY8UHD6OKsTzNTLX8XMOtxckdS78B5CjIo9LNDAtaVz84pQ%2BGVzT7fkPSnQyWt1zaKx%2BXt2JuRvguvjG%2BcQma50yamQd8yuEe0ZUQUkFwT6GhR75PdwzsSy4DoFgAcsGxiDjkeIMFgCAVNvqxrnFNx%2FT%2FKzuGvoZbIi4kq%2Bd%2F2rYVboJUHZN4tRXiDFK5adX2p0gD63oDYqCnh6hT%2BON3NPCtBPzvBs%2BzNu4BKqYf7UT8L4QPZDc0QKtO4M8wQn6gV0KKPSCOVHwW6Nq3vMqfayi%2FUGgsOq5%2FCpr%2FMLlzI8SKbUZVrIdzjQ5zjuUTjRvar89mhypG8RdotrfPJqmEnqMLq4q78GOqUBJ4hjz%2FOe2UxCVk%2BRLCaq70qE%2BpnXg%2FNpvJplp0BvfLpiFyLtUOLwQlmAqsmTWh%2BUyP9g2%2FGZhwrYfgx9fBEAxiEeLcobWumi4NnQEH2cccaLwQp7DiVWalmsaSrGZj5%2F15AAmTXd6hBtaU3kPDYNToiHkUnyr%2FaRpwm0jnGD%2Bzur8s5P8LtNhTmLeX6F%2BS7XxcXMNzmMjn4gGed57XOLbYmOttFu&X-Amz-Signature=22e652b037fd58896f149af6511860c48590bc321ae56e1c0320f157b748bed7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-30T19:17:00.000Z",
			"id": "b62d6f6c-1a86-4f9f-8ff5-7401964bf79c",
			"contadores": [
				"Alienígenas",
				"CLTs",
				"Pintadas de Clima",
				"Rotinas Reais"
			],
			"caps_lidos": "10",
			"imagem_name": "guiinchaconspiração-hq",
			"data_leitura": "2023-01-05T14:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/gui-inch-a-conspiracao",
			"name": "Gui Inch: A Conspiração",
			"porcentagem_leitura": 100,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "10",
			"autores": [
				"ca730233-854e-49bc-a1da-bcb9dbc89651"
			],
			"autor": [
				"Reiko Yuma ⭐"
			],
			"insta": "https://www.instagram.com/reiko_yuma/",
			"tags": "♀️",
			"twitter": "https://twitter.com/studioarkano"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8c4c86c0-d2cb-4217-9281-80d108bc32c2/lili_and_grave.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=1fa7400d16d629113a927ca367692c5be088f990540a42f6ac77993f0ae8c34e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-30T19:15:00.000Z",
			"id": "a368832b-2911-4768-baa4-093299744a88",
			"contadores": [
				"Gore",
				"Husbandos",
				"Inícios mitológicos"
			],
			"caps_lidos": "1",
			"imagem_name": "liliandgrave-hq",
			"data_leitura": "2023-01-12T14:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				},
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/lili-and-grave-one-shot-0r44",
			"name": "Lili And Grave",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"ca730233-854e-49bc-a1da-bcb9dbc89651",
				"8b381255-655c-480b-908e-472152232fc0"
			],
			"autor": [
				"Reiko Yuma ⭐",
				"Bruwi ⭐"
			],
			"insta": "https://www.instagram.com/reiko_yuma/",
			"tags": "♀️",
			"twitter": "https://twitter.com/studioarkano"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/07076a1c-d6a3-4e42-87ce-5003b62eaac1/a_grande_grug.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=e1a2fa03c7d6914b0ff7ea106dc7a6255b7faf230a0cb4f34fa734bdaf727645&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-30T19:12:00.000Z",
			"id": "0cfdec41-2fe1-4099-8d19-affd648ee609",
			"contadores": [
				"Isekai"
			],
			"caps_lidos": "1",
			"imagem_name": "agrandegrug-hq",
			"data_leitura": "2023-02-26T23:47:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/a-grande-grug",
			"name": "A Grande Grug",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"ca730233-854e-49bc-a1da-bcb9dbc89651",
				"8b381255-655c-480b-908e-472152232fc0"
			],
			"autor": [
				"Reiko Yuma ⭐",
				"Bruwi ⭐"
			],
			"insta": "https://www.instagram.com/reiko_yuma/",
			"tags": "♀️",
			"twitter": "https://twitter.com/studioarkano"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1e6a27db-386e-4bab-b14b-6dc2b57d3022/juquinha.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=d0a9ddb798477847413263bce66bbc8a5851b12bb2010a2bd96fb86f06bbc8f6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T22:22:00.000Z",
			"id": "9eaca292-6456-46c5-b37e-d2addadc380c",
			"contadores": [
				"Quadrinhos Reflexivos",
				"Quebras de quarta parede",
				"Ovo"
			],
			"caps_lidos": "2",
			"imagem_name": "juquinha-hq",
			"data_leitura": "2023-07-24",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://twitter.com/puffnopiripaf/status/1292855444734726144",
			"name": "Juquinha",
			"porcentagem_leitura": 66,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"6465bc2a-15f1-450e-ab13-1f82f0da7b71"
			],
			"autor": [
				"Max Andrade"
			],
			"insta": "https://www.instagram.com/puffnopiripaf/",
			"tags": "♂️",
			"twitter": "https://twitter.com/puffnopiripaf"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/63e91e74-18aa-4408-a6fb-8d84d66c770b/vida_longa_ao_marinheiro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=793a36c5fbabc5081a36fd1747e173d6d9000c1ace164eba28a97153d6a78ff5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T22:21:00.000Z",
			"id": "1bf1d892-ddfc-47b5-88f0-bb70f8eead14",
			"contadores": [
				"Quadrinhos Reflexivos"
			],
			"caps_lidos": "3",
			"imagem_name": "vidalongaaomarinheiro-hq",
			"data_leitura": "2023-03-12T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/vlam/info",
			"name": "Vida Longa Ao Marinheiro",
			"porcentagem_leitura": 23,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "13",
			"autores": [
				"02464348-9582-4e9a-9e57-0e0ccf52d0e0"
			],
			"autor": [
				"Mai ⭐"
			],
			"insta": "https://www.instagram.com/maifazcomics/",
			"tags": "♀️",
			"twitter": "https://twitter.com/maifazcomics"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d3b5da5a-159d-4572-b9c9-5c13a75e99aa/Calendar.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=a781d6a46a33ca808c396fa2d7a80dcdabf377b7f6b293bd79c928be7eec74dc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T22:17:00.000Z",
			"id": "1784dc99-a85e-43ca-958f-5679a832f910",
			"contadores": [
				"CLTs",
				"Coaches",
				"Herdeiros"
			],
			"caps_lidos": "2",
			"imagem_name": "calendar-hq",
			"data_leitura": "2023-01-15T13:00:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Calendar",
			"name": "Calendar",
			"porcentagem_leitura": 33,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"e6d4abda-fe9d-49a8-a78e-e6f02e1aff4d"
			],
			"autor": [
				"Ligia Zanella"
			],
			"insta": "https://www.instagram.com/ligia_zanella/",
			"tags": "♀️",
			"twitter": "https://twitter.com/LigiaZanella1"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e53812e7-d48d-4c4d-bedf-7d79c2cca6a3/gibi_de_amor.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=3195594cbbd1bfa4d8a2f3cf6e8b311a96b621034b764e642888b4b8b754edff&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T13:36:00.000Z",
			"id": "1e6d9230-da80-4b06-8257-dce20a35c140",
			"contadores": [
				"Vacilões",
				"Quebras de quarta parede"
			],
			"caps_lidos": "1",
			"imagem_name": "gibideamor-hq",
			"data_leitura": "2023-06-13T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/gibideamor/info",
			"name": "Gibi de Amor",
			"porcentagem_leitura": 50,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"9611ffc4-b3b1-4f10-b1ce-71427af28738"
			],
			"autor": [
				"Virgula Leal"
			],
			"insta": null,
			"tags": "♂️",
			"twitter": "https://twitter.com/virgulaleal"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b8c27a76-b5cf-4398-94f8-ddb23f23ae63/lampiao.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=0ce9280451e6ea339915594cce4da1d2ae2828640d30074765e2919a347262d4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T03:48:00.000Z",
			"id": "c6d2fe6b-8e0d-4ec2-afcb-40b61b5dd204",
			"contadores": [
				"Bang Bang",
				"Criaturas sobrenaturais",
				"Vinganças",
				"Aura"
			],
			"caps_lidos": "6",
			"imagem_name": "lampiao-hq",
			"data_leitura": "2023-01-12T15:00:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Lampiao/info",
			"name": "Lampião",
			"porcentagem_leitura": 85,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"96688312-d6d7-489d-8e4d-88e003d60ea4",
				"aba466e0-6283-4328-a5a2-4dd1dc45c1ab"
			],
			"autor": [
				"Heitor Amatsu ⭐",
				"Carlo"
			],
			"insta": "https://www.instagram.com/heitoramatsuart/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Heitoramatsuart"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2992fd28-8afe-47b1-b6dd-a8fba6b694c3/um_dia_ruim.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=e03f356b026f206cc20211cca8774ccc557efda07094e1bfbcc69c406f883fb2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T03:45:00.000Z",
			"id": "a7e98dd0-89e5-4d94-a133-b1e99a725cd1",
			"contadores": [
				"Era tudo um sonho"
			],
			"caps_lidos": "1",
			"imagem_name": "abadday-hq",
			"data_leitura": "2023-07-13T23:03:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://smacmag.net/v/sma16/a-bad-day-by-raphael-hhs/",
			"name": "A Bad Day",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"feecc179-8e29-4967-9452-c992f8fbeb91"
			],
			"autor": [
				"Raphael HHS ⭐"
			],
			"insta": "https://www.instagram.com/raphaelhhs/",
			"tags": "♂️",
			"twitter": "https://twitter.com/RaphaelHhs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/729381a5-426a-4f73-b5a1-5986c1136ceb/um_principe_nada_encantado.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=a5f642d5f5436a274fc25570b6cabbba62285d99d13abb70cccc963181891e24&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T03:43:00.000Z",
			"id": "9f6e7d39-fefd-45d1-8964-01fd81e4210b",
			"contadores": [
				"Ruivinhos Metidos",
				"Herdeiros"
			],
			"caps_lidos": "3",
			"imagem_name": "umprincipenadaencantado-hq",
			"data_leitura": "2023-03-12T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Um-prncipe-nada-encantado/info",
			"name": "Um príncipe nada encantado",
			"porcentagem_leitura": 33,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"964f2c86-59dc-432a-a8e4-e6ae4698b7f3"
			],
			"autor": [
				"Phyra"
			],
			"insta": "https://www.instagram.com/magic_phyra/",
			"tags": "♀️",
			"twitter": "https://twitter.com/magic_phyra"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/074add75-56a8-4371-99d9-b8c0f0322b91/elemental_kings.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=75f5d2f730203ed7bb64d3146044e0ce0c934ca4180971c00f0b15d02c5084d8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T03:41:00.000Z",
			"id": "5128a783-164b-4d9a-b908-38e02a91623d",
			"contadores": [
				"Vilões",
				"Energia",
				"Squad Goals",
				"Líderes"
			],
			"caps_lidos": "1",
			"imagem_name": "elementalkings-hq  ",
			"data_leitura": "2024-09-26",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Terror",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Elemental-Kings-PTBR/info",
			"name": "Elemental Kings",
			"porcentagem_leitura": 5,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "18",
			"autores": [
				"304ca639-1037-4d6a-8239-96f59309b247"
			],
			"autor": [
				"Henry Saints ⭐"
			],
			"insta": "https://www.instagram.com/henry_saints_art/?hl=pt-br",
			"tags": "♂️",
			"twitter": "https://twitter.com/HenrySaintsArt"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c511e238-0a98-4eb4-bc24-82753d4ce8cb/brakuman.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=246348849e176de7d47df0d2c899536f6eb4fd6b5986df99abce210691cbb1b6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T03:40:00.000Z",
			"id": "ef130bcd-f72f-4811-a29d-c009f26f8411",
			"contadores": [
				"CLTs"
			],
			"caps_lidos": "1",
			"imagem_name": "brakuman-hq",
			"data_leitura": "2023-01-15T14:00:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/brakuman?origin=profile-list",
			"name": "Brakuman",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"c3feb2a6-9e57-47b0-82bf-30dceffedb93"
			],
			"autor": [
				"Raphael Munhoz"
			],
			"insta": "https://www.instagram.com/raphaelmunhoz.art/",
			"tags": "♂️",
			"twitter": "https://twitter.com/raphamunhozart"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/128da798-64e5-4db9-8e79-9b5458af452b/aquela_pequena_e_doce_fada_mortifera_em_nosso_caminho.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=a3bce7088dbd34320d6f7537ae8766d84750d233099917cc1c8fd54c5055a66d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T03:40:00.000Z",
			"id": "78bbee2b-2991-4855-af23-f3195143b536",
			"contadores": [
				"Caolhos",
				"Criaturas sobrenaturais",
				"Heróis duvidosos"
			],
			"caps_lidos": "1",
			"imagem_name": "aquelapequenaedocefadamortiferaemnossocaminho-hq",
			"data_leitura": "2023-03-06T00:40:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/aquela-pequena-e-doce-fada-mortifera-em-nosso-caminho?origin=profile-list",
			"name": "Aquela Pequena e Doce Fada Mortífera em Nosso Caminho",
			"porcentagem_leitura": 5,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "17",
			"autores": [
				"c3feb2a6-9e57-47b0-82bf-30dceffedb93"
			],
			"autor": [
				"Raphael Munhoz"
			],
			"insta": "https://www.instagram.com/raphaelmunhoz.art/",
			"tags": "♂️",
			"twitter": "https://twitter.com/raphamunhozart"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/08d1dc8b-6524-44ac-a99a-431f8ee1ee81/de_repente_shoujo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=158903e2ca0d8e7b2214838306d205017f7ea1b72c4f45f26310d31aae51c2fe&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T03:40:00.000Z",
			"id": "20191cdd-c358-4f79-a867-933ab83d1e05",
			"contadores": [
				"Isekai"
			],
			"caps_lidos": "2",
			"imagem_name": "derepenteshoujo-hq",
			"data_leitura": "2023-01-19T23:59:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Shoujo",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/de-repente-shoujo?origin=profile-list",
			"name": "De Repente Shoujo!!",
			"porcentagem_leitura": 22,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "9",
			"autores": [
				"87ae255e-dcd7-4ed1-a2be-2d0a40845e6c"
			],
			"autor": [
				"Lucas Gesse ⭐"
			],
			"insta": "https://www.instagram.com/lucrono_1/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3e62f6b2-3529-4e84-b69a-85fdb21926c1/age_of_guardian.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=dd974673fb8a673e5b3977b261ff2edc470e788307d7b98fc9d8a5db3e21ea0e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T03:39:00.000Z",
			"id": "e5ea81fc-e160-47e8-b3dd-60c2f119c23b",
			"contadores": [
				"Casos de Familia",
				"Bullies",
				"Herdeiros",
				"Duplinhas do Barulho",
				"Escolas que ninguem tem aula de verdade"
			],
			"caps_lidos": "18",
			"imagem_name": "ageofguardian-hq",
			"data_leitura": "2023-03-09T22:13:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/age-of-guardian?origin=profile-list",
			"name": "Age of Guardian",
			"porcentagem_leitura": 81,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "22",
			"autores": [
				"88cfacb1-2105-4060-8a35-f90f2690ff85"
			],
			"autor": [
				"Ingrid Oliveira ⭐"
			],
			"insta": "https://www.instagram.com/age_of_guardian/",
			"tags": "♀️",
			"twitter": "https://twitter.com/age_of_guardian"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/20301dc6-57c8-4d7e-8839-6ccb24284c17/Oxente.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=63f601e0e8b6ad601a8077d21713f05f1592de6a10a479e9c5035d3951f6ac41&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T03:39:00.000Z",
			"id": "3ea69a90-244a-4374-b029-5872ef19cc1c",
			"contadores": [
				"Brasil Alternativo",
				"Herdeiros"
			],
			"caps_lidos": "1",
			"imagem_name": "oxente-hq",
			"data_leitura": "2023-01-12T13:00:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": "http://estudioarmon.iluria.com/pd-6e9029-oxente-vol-1.html?ct=13b576&p=1&s=1",
			"link_leitura": "https://fliptru.com.br/comic/oxente?origin=profile-list",
			"name": "Oxente",
			"porcentagem_leitura": 5,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "20",
			"autores": [
				"608b18af-5493-4a8c-ab19-dd53f501a4c8"
			],
			"autor": [
				"Rhenato Guimarães ⭐"
			],
			"insta": "https://www.instagram.com/rhenato_arts/",
			"tags": "♂️",
			"twitter": "https://twitter.com/rhenatoarts"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1fcb4e78-04e1-4820-a17c-22555809b6ac/setimos_filhos.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=a48859ab4d38ddd89562e30168e4f6e614a31e5757650891d43d204e058cd52f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-14T20:09:00.000Z",
			"id": "a63a7fd2-eea7-4b2c-a6c3-330c0608f495",
			"contadores": [
				"Criaturas sobrenaturais",
				"Folclóre Brasileiro",
				"Bruxas"
			],
			"caps_lidos": "6",
			"imagem_name": "setimosfilhos-hq",
			"data_leitura": "2023-01-08T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/SetimosFilhos",
			"name": "Sétimos Filhos ",
			"porcentagem_leitura": 15,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "40",
			"autores": [
				"9c901954-167f-435e-ada1-fad1ad581e7e"
			],
			"autor": [
				"HET"
			],
			"insta": "https://www.instagram.com/hetthepumpking/",
			"tags": "♂️",
			"twitter": "https://twitter.com/HETthePumpking"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/15545d54-6e90-4418-8cec-07d162d22c96/thunters_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=7c314bfabf3c35320a7cb6c7d9e2f6d2f6f711ea1e6cf4a5bb46747493b41692&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-14T03:05:00.000Z",
			"id": "f4d8e008-6e65-4d3b-9fe8-5af736b98f55",
			"contadores": [],
			"caps_lidos": "3",
			"imagem_name": "thunters-hq",
			"data_leitura": "2022-12-15T20:00:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/T-Hunters-PT-BR/info",
			"name": "T-Hunters",
			"porcentagem_leitura": 100,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"cbed581c-c767-4f9d-83ad-2e3f120e251c"
			],
			"autor": [
				"Israel Guedes"
			],
			"insta": "https://www.instagram.com/thuntersmanga/",
			"tags": "♂️",
			"twitter": "https://twitter.com/IsraelGuedes7"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6813be28-3bda-4cb4-af84-baf84d3907b5/paradigma.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=bca71f89a8634985e9f93ef3f388a2b4108fff8e66128ee0065cf963fa3cc1d2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T21:03:00.000Z",
			"id": "c6c3a8ab-9c5e-4829-ab22-117bc5468897",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "paradigma-hq",
			"data_leitura": "2023-02-23T22:51:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": null,
			"link_leitura": "https://www.webtoons.com/en/challenge/paradigma/list?title_no=804376",
			"name": "Paradigma",
			"porcentagem_leitura": 14,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"4b7585e5-1ef7-46c3-a6ab-70abee7e425c",
				"c8dd9091-17f3-4dbf-a55e-59d12966952f"
			],
			"autor": [
				"Luna Rapper",
				"LINKZIN"
			],
			"insta": "https://www.instagram.com/luna_rapper/",
			"tags": "♂️",
			"twitter": "https://twitter.com/CdcLuna"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a6565658-5360-410d-9550-e8698123201b/monster_odyssey_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=b25d0339235164d86dce7baf74669759163c9cad49f63d503fac7404e41aba8a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T04:18:00.000Z",
			"id": "9e5f18bc-5f28-4cd1-8153-5bfe77cccaf4",
			"contadores": [
				"Começos JRPGlike",
				"Idosos sendo agredidos",
				"Inícios mitológicos",
				"Último sobrevivente do clã",
				"Artes Pikassas",
				"Nomes fodas"
			],
			"caps_lidos": "3",
			"imagem_name": "monsterodyssey-hq",
			"data_leitura": "2022-12-18T17:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Monsters-Odyssey-BR",
			"name": "Monster Odyssey",
			"porcentagem_leitura": 18,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "16",
			"autores": [
				"ee3b4003-45ee-4238-a184-d547171a6650"
			],
			"autor": [
				"Ricardo Mango"
			],
			"insta": "https://www.instagram.com/ricardomango/",
			"tags": "♂️",
			"twitter": "https://twitter.com/_ricardomango"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e787bf2b-6575-4222-8d0e-c65380cdef72/garotas_fofas.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=4c103980302c391b214d3eee4a5e492a9381182baa9c5edd1c33a47724bfc125&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:13:00.000Z",
			"id": "153290a8-9f62-4d9c-ad70-26c32d54efb4",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"Biritas"
			],
			"caps_lidos": "1",
			"imagem_name": "garotasfofas-hq",
			"data_leitura": "2023-03-02T22:10:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Garotas-Fofas/info",
			"name": "Garotas Fofas",
			"porcentagem_leitura": 6,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "16",
			"autores": [
				"3baa6628-bb04-4190-9d5d-47ce7a67de5b"
			],
			"autor": [
				"Matt Skyder ⭐"
			],
			"insta": "https://www.instagram.com/matt.hqs/",
			"tags": "♂️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4bad5c39-6329-40b3-b292-5f98f29d0203/lebre_e_coelho_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=74fdff0c4bc72dc188ffc0396e276deaaf329498f073fd40812df136ea7ff31b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:12:00.000Z",
			"id": "272aef3d-5fcb-4628-914c-ab7c3e2bfbfa",
			"contadores": [
				"Escolas que ninguem tem aula de verdade"
			],
			"caps_lidos": "9",
			"imagem_name": "lebreecoelho-hq",
			"data_leitura": "2022-12-18T13:00:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Lebre-e-Coelho/info",
			"name": "Lebre e Coelho",
			"porcentagem_leitura": 10,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "83",
			"autores": [
				"6f4917c2-ece5-4ada-8540-f94444699522"
			],
			"autor": [
				"Alec"
			],
			"insta": "https://www.instagram.com/castelodoalec/",
			"tags": "♂️",
			"twitter": "https://twitter.com/alelecleclec"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/013a0f97-786d-4bc5-99a9-9bd8c22ac8c8/Relic_hunbters.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=218895bd2d7008db1ef0aa85647846961e7633e1845df3a4ddc5ef347c632a38&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:10:00.000Z",
			"id": "8b7e2f3c-48f1-473e-8276-98cec70a5442",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "relichunters-hq",
			"data_leitura": "2023-03-02T22:31:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Relic-Hunters-PTBR",
			"name": "Relic Hunters Legend",
			"porcentagem_leitura": 33,
			"publicacao": "Precisa de Analise",
			"status": "Lendo",
			"total_caps": "3",
			"autores": [
				"50e2ab61-ef90-40b6-9e19-3d7450458a5d"
			],
			"autor": [
				"Relic Hunters"
			],
			"insta": "https://www.instagram.com/playrelichunters/",
			"tags": "♀️",
			"twitter": "https://twitter.com/RelicHuntersU"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/10f4918a-da8b-4b26-add8-c9f5885b3c66/manual_pratico_da_garota_magica_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=3adbe3c8ab969d010326ce9e26dbf9bf0757757f0c74349516d7bacba22120ca&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:10:00.000Z",
			"id": "a650f699-0374-444b-b3f7-74aacd46e2d3",
			"contadores": [
				"Pactos"
			],
			"caps_lidos": "1",
			"imagem_name": "manualpraticodagarotamagica-hq",
			"data_leitura": "2022-12-13T23:30:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Manual-Pratico-da-Garota-Magica/info",
			"name": "Manual Prático da Garota Mágica",
			"porcentagem_leitura": 14,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"7242ebd5-9b46-4a4a-a475-a041f2d68036"
			],
			"autor": [
				"Heitor PC"
			],
			"insta": "https://www.instagram.com/heitorpc/",
			"tags": "♂️",
			"twitter": "https://twitter.com/heitorpcart"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a7a372df-6cee-40e5-8881-ff5f49e842a4/Suzy_Sukeban.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=5539923d7012f134a41b5ac79249a87bc542428cb5405abe3c9107bcf2bab238&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:08:00.000Z",
			"id": "964fed91-8a36-4112-bc6a-bc4980e06c2e",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"CLTs",
				"Golpes bem aplicados",
				"Palavrões",
				"Personagens Badass",
				"Noitadas",
				"Quadrinhos para ler chapado"
			],
			"caps_lidos": "5",
			"imagem_name": "suzysukeban-hq",
			"data_leitura": "2023-01-26T23:35:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/SUZY-SUKEBAN/info",
			"name": "SUZY SUKEBAN",
			"porcentagem_leitura": 45,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"3dd99eac-8132-4efd-bb72-92a2e7b2f588"
			],
			"autor": [
				"Dave"
			],
			"insta": "https://www.instagram.com/davenadave/",
			"tags": "♂️",
			"twitter": "https://twitter.com/davenadave"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/68f4301f-586a-4214-bb3d-cca513e5f94c/Noel_e_a_magnifica_fabrica_de_brinquedos.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=11d9c79884d92adfc5cfb67536acb3e2ed023a7d52cbd4779b6f9d0d119f7381&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:08:00.000Z",
			"id": "0b31e8d7-a189-4296-b397-1664ef6165db",
			"contadores": [
				"Beijocas"
			],
			"caps_lidos": "3",
			"imagem_name": "noeleamagnificafabricadebrinquedos-hq",
			"data_leitura": "2022-12-22T14:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/noelmfb/info",
			"name": "Noel e a Magnífica Fábrica de Brinquedos",
			"porcentagem_leitura": 37,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "8",
			"autores": [
				"79995582-6ad6-4c85-8191-6bf66d3fc0ab"
			],
			"autor": [
				"Lucas Moreira"
			],
			"insta": "https://www.instagram.com/tirinhasdorex/",
			"tags": "♂️",
			"twitter": "https://twitter.com/tirinhasdorex"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5ee5dd2a-216e-4429-a62b-033487b72f16/seasons_of_avallen_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=41a1464bfcece5697e31e7377f2ff7332c8b628cde1fd9d871fe4e9c5e7ac3b3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:07:00.000Z",
			"id": "b793ab96-6a5a-4b5a-8157-c95d5d157210",
			"contadores": [
				"Bebês Abandonados",
				"Corpos Reais",
				"Vovós fofas"
			],
			"caps_lidos": "4",
			"imagem_name": "seasonsofavallen-hq",
			"data_leitura": "2022-12-18T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Seasons-of-Avallen-PT-BR/info",
			"name": "Seasons of Avallen",
			"porcentagem_leitura": 16,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "24",
			"autores": [
				"e0f94f53-eb9e-48f9-851f-40a137e59457"
			],
			"autor": [
				"Gemini"
			],
			"insta": "https://www.instagram.com/gem.i.ni/",
			"tags": "♀️",
			"twitter": "https://twitter.com/gemini_ink"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f6923cec-53bb-4dc7-a409-1b07e08095ff/irana_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=477aab0fdfd231cd23a8364b0bf1bb92303ab803cc7c5b52a44d4ca3c2df5965&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:06:00.000Z",
			"id": "4d47ce5c-cd75-4af4-8a81-9d7f4bea3ef0",
			"contadores": [
				"Personagens Badass",
				"Protagonistas que não deixam os mortos mortos",
				"Noitadas",
				"Camisas 10",
				"Beijocas",
				"Broxadas 😳",
				"Criaturas sobrenaturais",
				"Cliffhangers foda",
				"Furry",
				"Biritas"
			],
			"caps_lidos": "6",
			"imagem_name": "irauna-hq",
			"data_leitura": "2022-12-13T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/irauna/info",
			"name": "Iraúna do Olhar Âmbar",
			"porcentagem_leitura": 85,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "7",
			"autores": [
				"82fd5183-c1db-4b7c-9f09-1197b229b217"
			],
			"autor": [
				"Gabriel Pìeri"
			],
			"insta": "https://www.instagram.com/pieridomalagueta/",
			"tags": "♂️",
			"twitter": "https://twitter.com/pieridomalaguet"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e6589b4d-1677-4070-9d83-a154e7f0fdd5/Afeto_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=9a8fc4e23f4d582718e9d3e25a19cbae222f6324ce9c4620d8d1975616b3c74c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:05:00.000Z",
			"id": "3cbc64f3-b756-4f95-8e7d-3f1715dea757",
			"contadores": [
				"Bullies"
			],
			"caps_lidos": "8",
			"imagem_name": "afeto-hq",
			"data_leitura": "2022-12-15T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": "https://outsideco.lojavirtualnuvem.com.br/produtos/afeto/",
			"link_leitura": "https://tapas.io/series/Afeto/info",
			"name": "Afeto",
			"porcentagem_leitura": 33,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "24",
			"autores": [
				"3937eb00-7325-4bb7-b409-448c9a0281a6"
			],
			"autor": [
				"Vivi Munhoz"
			],
			"insta": "https://www.instagram.com/melanciacomics/",
			"tags": "♀️",
			"twitter": "https://twitter.com/MelanciaComics"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/daa92fae-a73b-4ca9-b908-709867e0d4a8/hq_de_briga.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=7bcbaa3f3b7688b5f106e285bb2d7a5244b588d6e6f30241efc52dadfef049b4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:03:00.000Z",
			"id": "57ee1f1d-f721-4da9-bde7-ef072780deb7",
			"contadores": [],
			"caps_lidos": "2",
			"imagem_name": "hqdebriga-hq",
			"data_leitura": "2023-01-08T14:00:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/HQ-de-briga/info",
			"name": "HQ de briga",
			"porcentagem_leitura": 18,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "11",
			"autores": [
				"72557ff4-ae1c-4593-8795-8d9495d41f0f"
			],
			"autor": [
				"Silva João"
			],
			"insta": "https://www.instagram.com/silvazuao/",
			"tags": "♂️",
			"twitter": "https://twitter.com/silvazuao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/171ab152-7403-49bd-97ec-dfb35e763109/moa_sinistra_do_poker_2.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=2197060b9d5532baa2139066fae4ac7af85cb1af56dafad3d7254931f6a45999&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:03:00.000Z",
			"id": "2a1d4862-6dd4-4f04-89d9-f8bb4339fe7d",
			"contadores": [
				"Taberneiros carecas",
				"Cenas na Chuva",
				"Pais fumantes",
				"Noitadas"
			],
			"caps_lidos": "1",
			"imagem_name": "trapingame-hq",
			"data_leitura": "2022-12-29T14:00:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/@ReikoYuma",
			"name": "TRAP in Game",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"ca730233-854e-49bc-a1da-bcb9dbc89651"
			],
			"autor": [
				"Reiko Yuma ⭐"
			],
			"insta": "https://www.instagram.com/reiko_yuma/",
			"tags": "♀️",
			"twitter": "https://twitter.com/studioarkano"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3bf59ff2-e97b-4028-9cbb-8fba781291f9/CINZA.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=bb37aefe66534f0f633f61b647797045f570070fcb4219cf66b01a269d6cd40f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:02:00.000Z",
			"id": "bcbf6908-e5a5-492d-a80b-b1adc47cc27e",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "cinza-hq",
			"data_leitura": "2022-12-29T13:00:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": "https://www.mthsmnds.com.br/pd-9326da-cinza-vol-1.html?ct=&p=1&s=1",
			"link_leitura": "https://tapas.io/series/CINZA/info",
			"name": "CINZA",
			"porcentagem_leitura": 4,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "23",
			"autores": [
				"4478bb12-4bd4-42ba-a4b6-1824cda58ad7"
			],
			"autor": [
				"Matheus Mendes"
			],
			"insta": "https://www.instagram.com/mthsmnds/",
			"tags": "♂️",
			"twitter": "https://twitter.com/mthsmnds"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/39cff518-2c81-45b4-a9e9-1ecfb4ccd4b0/o_menino_que_desenha_monstros.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=3929ca201d52835b851b9b26ed1f304cef3f61e2f74521c2615c0baf935831ee&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T03:01:00.000Z",
			"id": "af3116a8-d562-4856-a74d-c96c24641da7",
			"contadores": [
				"Críticas Sociais Foderosas",
				"Personagens Badass",
				"Protagonistas sentados na janela",
				"Calvos",
				"Escolas que ninguem tem aula de verdade"
			],
			"caps_lidos": "2",
			"imagem_name": "omeninoquedesenhamonstros-hq",
			"data_leitura": "2022-12-22T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Slice of Life",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/O-Menino-que-Desenha-Monstros/info",
			"name": "O menino que desenha monstros",
			"porcentagem_leitura": 40,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"1800154d-10cd-4801-b76f-f032ce9688b1"
			],
			"autor": [
				"Jack ⭐"
			],
			"insta": "https://www.instagram.com/themoniojack/",
			"tags": "♂️",
			"twitter": "https://twitter.com/themoniojack"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/33825161-24c4-4287-a9b7-860f7337090c/OctoZine.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=8e885987a04a745ecbc043dd04b78194c31fcdc692ed8e7075169a363db99172&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-09T02:07:00.000Z",
			"id": "f0de1a17-11e3-4646-8cf4-575b95c82922",
			"contadores": [],
			"caps_lidos": "1",
			"imagem_name": "octozine-hq",
			"data_leitura": "2023-01-08T13:00:00.000-03:00",
			"genero": [
				{
					"name": "Mistério",
					"color": "default"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://bazarverde.com.br/livro/152",
			"name": "Octo - Zine 2020",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"858395b1-c36e-455c-a510-487c10272adf"
			],
			"autor": [
				"Saulo Daniel ⭐"
			],
			"insta": "https://www.instagram.com/saulodfp/",
			"tags": "♂️",
			"twitter": "https://twitter.com/saulodfp"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ddb65272-f583-4bb6-9052-8ebbcf8abf0f/Roland.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=5be5351e29a9a72499797555fb8b3c1024c7a003d0d6da90c9d34ed8c6dec2c4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T16:16:00.000Z",
			"id": "1dfbdef9-3059-4361-873e-ecd662b2cdee",
			"contadores": [
				"Vilarejos em um mundo Fantasia",
				"Cenas na Chuva",
				"Criaturas sobrenaturais",
				"Heróis duvidosos",
				"Transformações",
				"Caloteiros"
			],
			"caps_lidos": "1",
			"imagem_name": "roland-hq",
			"data_leitura": "2022-12-22T13:00:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Aventura",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Roland/info",
			"name": "Roland",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "1",
			"autores": [
				"223f7dfd-bcca-475d-bcbd-115536c079e9"
			],
			"autor": [
				"Duhgetsu ⭐"
			],
			"insta": "https://www.instagram.com/duhgetsu/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Duhgetsu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4390a469-b457-4b2e-9249-564b0a98aa14/i_wanna_be_satan.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=2ca975ec00d8ed4ca91ff58a104d30ec65b11fd3485f196ee5173357459f8052&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T15:16:00.000Z",
			"id": "4b5542d2-b1f9-4d5c-8102-d7a995708958",
			"contadores": [
				"Protagonistas que morrem no começo da história",
				"Quebras de quarta parede",
				"Hehe",
				"Isekai",
				"Eu preciso matar um certo homem",
				"Alienígenas",
				"Cliffhangers foda",
				"Wikiman/Palestrinha"
			],
			"caps_lidos": "3",
			"imagem_name": "iwannabesatan-hq  ",
			"data_leitura": "2024-03-24",
			"genero": [
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/i-wanna-be-satan",
			"name": "I Wanna be Satan",
			"porcentagem_leitura": 21,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "14",
			"autores": [
				"feecc179-8e29-4967-9452-c992f8fbeb91"
			],
			"autor": [
				"Raphael HHS ⭐"
			],
			"insta": "https://www.instagram.com/raphaelhhs/",
			"tags": "♂️",
			"twitter": "https://twitter.com/RaphaelHhs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2b54b3cd-5e49-4eba-b3cd-b7b00559dc08/Monstro_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=8e2a35eb76149cd8501746dee66d64dd62748329357ee741fdf4cec98cd6a204&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T15:15:00.000Z",
			"id": "7423e60a-dacd-4a9d-85fd-e4f7855eddb7",
			"contadores": [
				"Bebês Abandonados",
				"Quebras de Expectativa",
				"Passados Trágicos",
				"Personagens que usam o suco",
				"No Shape",
				"Criaturas sobrenaturais",
				"Personagens Badass",
				"Personagens de Óculos",
				"Desempregados \"Autonomos\" MEI ou sem direitos trabalhistas (\"\"Empreendedores\"\")"
			],
			"caps_lidos": "2",
			"imagem_name": "monstro-hq",
			"data_leitura": "2023-03-02T23:20:00.000-03:00",
			"genero": [
				{
					"name": "Terror",
					"color": "default"
				},
				{
					"name": "Sobrenatural",
					"color": "default"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/monstro",
			"name": "Monstro",
			"porcentagem_leitura": 100,
			"publicacao": "OneShot",
			"status": "Lendo",
			"total_caps": "2",
			"autores": [
				"feecc179-8e29-4967-9452-c992f8fbeb91"
			],
			"autor": [
				"Raphael HHS ⭐"
			],
			"insta": "https://www.instagram.com/raphaelhhs/",
			"tags": "♂️",
			"twitter": "https://twitter.com/RaphaelHhs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bbdbec22-177c-40fe-9448-96f26d40cd1d/lobo_mau_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=8ca810eac79abc01e631b5a113c452f724d88f7940deb341e039a89413ff1288&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T15:15:00.000Z",
			"id": "edddd453-2196-47ff-bc86-30356224d08f",
			"contadores": [
				"Quadrinhos Feels",
				"Furry",
				"Cenas na Chuva",
				"Omissões do IBAMA",
				"Sacolé"
			],
			"caps_lidos": "8",
			"imagem_name": "lobomau-hq",
			"data_leitura": "2022-12-08T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Drama",
					"color": "brown"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/LOBO-MAU",
			"name": "LOBO MAU",
			"porcentagem_leitura": 61,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "13",
			"autores": [
				"19d86a05-c01f-43f2-b4ca-5b632e61b78a"
			],
			"autor": [
				"Dani Bolinho ⭐"
			],
			"insta": "https://www.instagram.com/dani_bolim/",
			"tags": "♂️",
			"twitter": "https://twitter.com/BolimDani"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e23318ea-dd8f-4a30-b42e-6775829126ab/ping_pong_drama.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=6afdf8aa202b221c9b6b17097ebf10e263b3ffc89fca6db8cd3d23759657e0ce&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T15:15:00.000Z",
			"id": "81cbe9c4-de33-4938-905f-ed48cc8781a2",
			"contadores": [
				"Protagonistas se apaixonando por esporte",
				"Escolas que ninguem tem aula de verdade",
				"Bullies",
				"Personagens que usam o suco"
			],
			"caps_lidos": "2",
			"imagem_name": "pingpongdrama-hq",
			"data_leitura": "2023-01-05T13:00:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Drama",
					"color": "brown"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Esporte",
					"color": "green"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Ping-Pong-e-Drama",
			"name": "Ping Pong & Drama",
			"porcentagem_leitura": 16,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "12",
			"autores": [
				"b6b5904b-cfd9-4abc-9f69-12e366052083"
			],
			"autor": [
				"Hataoh ⭐"
			],
			"insta": "https://www.instagram.com/hataaoh/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Hataaoh"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b23fe9ea-b0b0-40d5-b3da-883482d89e99/Kstar_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=8cf8c9675fa3d8a05edccd5ffe9304f2a5f31e4ad48f5ae0f2a51b1a59d606bc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T15:14:00.000Z",
			"id": "75b22629-cd4d-491e-b963-33c2466de909",
			"contadores": [
				"Alienígenas",
				"Squad Goals",
				"Duplinhas do Barulho",
				"Mais que irmãos brothers",
				"Revoluções contra governos autoritarios",
				"Vilões"
			],
			"caps_lidos": "3",
			"imagem_name": "kstar-hq",
			"data_leitura": "2022-12-13T21:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": "https://indievisivelpress.com.br/produto/k-star-squad/",
			"link_leitura": "https://tapas.io/series/ksd/info",
			"name": "K-Star Squad",
			"porcentagem_leitura": 75,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"7c78cedb-935a-4644-9aac-c31b9ba4c071"
			],
			"autor": [
				"Akila ⭐"
			],
			"insta": "https://www.instagram.com/_akigabriel/",
			"tags": "♂️",
			"twitter": "https://twitter.com/HQ_Forma"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b5907138-7afe-4408-9741-5d242a2d221c/rei_de_lata_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=4d103c06b7c4953d6c7e504eba8fb77db1b74a45399d139e63eca2c7ff3ae6e1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T15:14:00.000Z",
			"id": "31a09d13-11d9-4b66-b43b-41a845aa0df7",
			"contadores": [
				"Squad Goals",
				"Entradas fodas",
				"Cenas emocionantes",
				"Power System",
				"Personagens que usam o suco",
				"Personagens fofinhos",
				"Mulheres Bombadas",
				"Você conhece a iniciativa vingadores?",
				"Conversa pós porradaria",
				"Kenpachi tirando o tapa-olho",
				"Poses Fodas",
				"Sacodes",
				"Líderes"
			],
			"caps_lidos": "16",
			"imagem_name": "reidelata-hq",
			"data_leitura": "2022-12-15T21:00:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": "https://www.amazon.com.br/Rei-Lata-01-Full-Color/dp/6586799155/ref=sr_1_1?__mk_pt_BR=%C3%85M%C3%85%C5%BD%C3%95%C3%91&dchild=1&keywords=Rei+de+Lata+-+Volume+01+%28Full+Color%29&qid=1617235923&s=books&sr=1-1",
			"link_leitura": "https://tapas.io/series/Rei-de-la",
			"name": "Rei de Lata",
			"porcentagem_leitura": 27,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "59",
			"autores": [
				"746ee996-d682-4542-b4a3-562c31ed6e40"
			],
			"autor": [
				"Jeff ⭐"
			],
			"insta": "https://www.instagram.com/jeffudecapa/",
			"tags": "♂️",
			"twitter": "https://twitter.com/PandaDeCapa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/529cc2a2-871c-4462-87cf-65d653132f95/Dracula_quer_um_namorado_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=20ece1142bfccc747a0f165f12a44b1afadc0e74476ae0352961b1885e042609&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T15:14:00.000Z",
			"id": "e7b28be6-2cfc-4156-9660-c9b484695f2c",
			"contadores": [
				"Husbandos",
				"Desempregados \"Autonomos\" MEI ou sem direitos trabalhistas (\"\"Empreendedores\"\")",
				"CLTs"
			],
			"caps_lidos": "5",
			"imagem_name": "draculaquerumnamorado-hq",
			"data_leitura": "2022-12-08T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Romance",
					"color": "pink"
				},
				{
					"name": "Fantasia",
					"color": "orange"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/Drcula-Quer-Um-Namorado",
			"name": "Dracula quer um Namorado",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"35efbd0d-e345-4e65-aca1-5e4e5b143b49"
			],
			"autor": [
				"Felipe Soullep ⭐"
			],
			"insta": "https://www.instagram.com/felipe.soullep/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Felipe_Soullep"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5c0d473d-85cd-463c-bd0c-758e2ea21d59/Pirates_title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=93ab7a8867f727ed7673267a52cdd1bd3aa153626577f703ffdff7ccda735263&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T15:13:00.000Z",
			"id": "247c5474-4f0e-4b2b-b550-bfc6448594e1",
			"contadores": [
				"Temática de Piratas",
				"Cenários Convenientemente muito bem Posicionados",
				"Idosos sendo agredidos",
				"Caloteiros"
			],
			"caps_lidos": "6",
			"imagem_name": "pirates-hq",
			"data_leitura": "2022-12-08T23:50:00.000-03:00",
			"genero": [
				{
					"name": "Fantasia",
					"color": "orange"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/pirates/info",
			"name": "Pirates!",
			"porcentagem_leitura": 15,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "40",
			"autores": [
				"83691cee-6fcb-4501-988c-17b13c1c9a8b"
			],
			"autor": [
				"Yuri ⭐"
			],
			"insta": "https://www.instagram.com/pirateyuri/",
			"tags": "♂️",
			"twitter": "https://twitter.com/pirate_yuri"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ce7cff3d-d012-48d7-84d5-4fe4bd67a68f/Onda_Title.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=e110d32c7f66b95e1362510028462cfedaf8889b47da02f1b5199d44bd163296&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T15:13:00.000Z",
			"id": "05c9eb1d-4636-41ae-9236-145d74deb8e0",
			"contadores": [
				"Protagonistas se apaixonando por esporte",
				"Calvos",
				"Ash Botando o boné pra trás",
				"Noitadas",
				"Episódio de Praia"
			],
			"caps_lidos": "4",
			"imagem_name": "onda-hq",
			"data_leitura": "2022-12-29T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Esporte",
					"color": "green"
				},
				{
					"name": "Comédia",
					"color": "purple"
				}
			],
			"link_compra": null,
			"link_leitura": "https://fliptru.com.br/comic/onda-a-serie",
			"name": "Onda",
			"porcentagem_leitura": 100,
			"publicacao": "Sendo Publicado",
			"status": "Lendo",
			"total_caps": "4",
			"autores": [
				"feecc179-8e29-4967-9452-c992f8fbeb91"
			],
			"autor": [
				"Raphael HHS ⭐"
			],
			"insta": "https://www.instagram.com/raphaelhhs/",
			"tags": "♂️",
			"twitter": "https://twitter.com/RaphaelHhs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b10f8bd8-26a3-4fce-81f2-83877d62fa91/09846584.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=4f54b26073acfec625d1cdd0e8ae0679a5fc397058c908e664ac98c496f4c6af&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T00:47:00.000Z",
			"id": "bddbd6b2-0cdc-46d3-9e05-f242f9d8df3f",
			"contadores": [
				"Quebras de quarta parede",
				"Ogras"
			],
			"caps_lidos": "3",
			"imagem_name": "inusitado-hq",
			"data_leitura": "2022-12-01T21:00:00.000-03:00",
			"genero": [
				{
					"name": "Shoujo",
					"color": "pink"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/episode/367998",
			"name": "Inusitado",
			"porcentagem_leitura": 11,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "27",
			"autores": [
				"08a5d8a0-aac4-4d32-88e4-3a91a6bfcdfc"
			],
			"autor": [
				"Isabela Flores ⭐"
			],
			"insta": "https://www.instagram.com/belatime/",
			"tags": "♀️",
			"twitter": null
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b92052c9-0944-40d0-b918-0f20e9ae0f3c/48-km-fim-capa.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=279f89025bb1f714b5ea85aad491fa40a609f4267fa3ad75ca9e872d785feaf0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T00:47:00.000Z",
			"id": "c1eba75f-532b-423a-a290-8054372ee50b",
			"contadores": [
				"Camisas 10",
				"Quebras de quarta parede",
				"Beijocas"
			],
			"caps_lidos": "3",
			"imagem_name": "48km-hq",
			"data_leitura": "2023-01-05T00:00:00.000-03:00",
			"genero": [
				{
					"name": "Slice of Life",
					"color": "green"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Romance",
					"color": "pink"
				}
			],
			"link_compra": null,
			"link_leitura": "https://tapas.io/series/48km/info",
			"name": "48km",
			"porcentagem_leitura": 4,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "72",
			"autores": [
				"87773d14-8304-4e4e-a9cd-f71f3a6b1487"
			],
			"autor": [
				"Iara Naika"
			],
			"insta": "https://www.instagram.com/iara_naika/",
			"tags": "♀️",
			"twitter": "https://twitter.com/iaraNaika"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d997ec36-0f4a-49c6-a6af-2e1bd4acb6a1/008419841.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=638e7ff224fb7a0789714591e0ce4f0ac5ae67b2318adf231071e5abec01b37f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T00:47:00.000Z",
			"id": "f71bbf12-4568-42fc-951e-1bea2607d316",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"Apocalipses Brasileiros",
				"Temática de Céu/Inferno"
			],
			"caps_lidos": "1",
			"imagem_name": "belialscontract-hq",
			"data_leitura": "2022-12-01T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Sobrenatural",
					"color": "default"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": null,
			"link_leitura": "http://belials-contract.blogspot.com/",
			"name": "Belial's Contract",
			"porcentagem_leitura": 16,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "6",
			"autores": [
				"b8b710a2-aaa7-49ce-b645-9fb53496e4c9",
				"dbf63566-b2be-49d7-ba35-d5bffd16e9ec"
			],
			"autor": [
				"Michel Costa ⭐",
				"Lucas Rennó ⭐"
			],
			"insta": "https://www.instagram.com/mimscosara/",
			"tags": "♂️",
			"twitter": "https://twitter.com/mimscosara"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/82bd3654-fba8-4bee-8b59-9cdaab48690d/0650416584.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=ce0faebe384ce5598825ea27b49b04e13a7455d8d80a8ec381aa89ef28cc19a1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T00:47:00.000Z",
			"id": "56c4f5a4-d84c-40d9-a862-fa98d89a59fa",
			"contadores": [
				"Escolas que ninguem tem aula de verdade",
				"Temática de Céu/Inferno",
				"Criaturas sobrenaturais"
			],
			"caps_lidos": "3",
			"imagem_name": "gotohell-hq",
			"data_leitura": "2022-12-04T21:00:00.000-03:00",
			"genero": [
				{
					"name": "Ação",
					"color": "yellow"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Mistério",
					"color": "default"
				}
			],
			"link_compra": "https://loja.gotohellcomic.com/",
			"link_leitura": "https://tapas.io/series/gotohellcomic",
			"name": "Go To Hell",
			"porcentagem_leitura": 18,
			"publicacao": "Hiatus",
			"status": "Lendo",
			"total_caps": "16",
			"autores": [
				"96052796-72df-424f-98ea-ecfe7c0ee43d"
			],
			"autor": [
				"Pistashi ⭐"
			],
			"insta": "https://www.instagram.com/postosho/",
			"tags": "♂️",
			"twitter": "https://twitter.com/Postosho"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c4f4e391-19b9-491c-84f6-e139ba07e30f/004198754.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=479527f5662ebb3d675db8adac400339d0c5f19b0319f52b29e04b229fd1c72f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T00:47:00.000Z",
			"id": "17397722-d811-4e0a-a42b-11d7fdd5f0c0",
			"contadores": [
				"Personagens fofinhos",
				"Entradas fodas",
				"Biritas",
				"Casos de Familia",
				"Meditações",
				"Criaturas sobrenaturais",
				"Drift",
				"Vegetas Chegando",
				"Cabelos Estilosos",
				"Poderes oriundos do Sol",
				"Squad Goals",
				"Idosos sendo agredidos",
				"Akira reference",
				"Mestre e Discipulo",
				"Vilões",
				"parece que você andou treinando desde a ultima vez que nos encontramos",
				"Lendas Arturianas",
				"Pq diabos você mandou uma criança?",
				"Rivais",
				"Mentores",
				"Arma Inusitada"
			],
			"caps_lidos": "21",
			"imagem_name": "arthureosol-hq",
			"data_leitura": "2022-12-04T22:00:00.000-03:00",
			"genero": [
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Comédia",
					"color": "purple"
				},
				{
					"name": "Ficção Científica",
					"color": "blue"
				}
			],
			"link_compra": "https://www.instagram.com/raphaelhhs/",
			"link_leitura": "https://tapas.io/episode/1810809",
			"name": "Arthur e o Sol",
			"porcentagem_leitura": 41,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "51",
			"autores": [
				"feecc179-8e29-4967-9452-c992f8fbeb91"
			],
			"autor": [
				"Raphael HHS ⭐"
			],
			"insta": "https://www.instagram.com/raphaelhhs/",
			"tags": "♂️",
			"twitter": "https://twitter.com/RaphaelHhs"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b990a229-d964-4849-a409-2fbb65252c77/004898458.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4666EVLKN3Y%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232857Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIFDh0gk%2B%2F1P9bQC1w6tpHFvzwLCu5657nq9h3h%2FTKaRZAiA2Cs0bt3VMDxkfSFusl6piDPh1tvKEMD042ldcnSb3QCqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIM5e1jVKuomn%2Bc1KI%2FKtwDIptgSryu7b7QtMOWC024BeV9nWCV%2BpBkDic%2FydREiEzsE%2BJ9NNd0i%2BQR2hhJLljPVPYrFwy3wDb8pCUM1fmy%2F9HLF9IKIM8o9vFknFFTlpd%2BNRFjvDDLPwyV9cL3%2BSAYeIuOHfs56vxOyBXjl2qStuDHyEnRsNs5iXcaqlD8lkV4m1kOU0QUaloO%2BQniQHaUnsAtnrtcPX%2Bkkqe3nIVWUCDj%2B%2F9h3AsI%2FP7DW6Kb1cnCbdXFVrVwPY7MwG3jhqgKrUHoO9WiasG50q1NpUMKlWvJuvj67stQbZWjuvnrs%2B6MEUL7BqV4srHsZvYqB%2F2d%2FdoKuVLvvmqN8Lsf9oq30snN2U0TRXP6xdRz91pnJ10sjXZ5474kcmC8ZIZvuT7exnXLhDepBc99kLQOMqiwS1A3WCXfZhrYOKRwbSzzLvqxcvK3QlFTCgfn2bgfHtYZ2Be6rFJG1a1YFnW21kBBsXrBtDTFJVDJoPO4BYv39cyCJYeCJQy98Hz3M2rbUr4F10WXCyZdHbWkdKzCAVH1GlH4fO%2BaGX7e2mbVIGi%2BApi749qXsdla7Kj3qD0tnnTTmq5mAREBok0pyCx%2FOvoC4MfXxyINSqbACMy2LZRdmN1RYzttEBT5hOqAU4Ew%2B7irvwY6pgEo4Us9BKHW86DGaLfxaXTwJfiizogzNOKCQnLXH%2FgnEjX7ugcZ51xisGxUR%2Fw9j%2F5Q1ozX2AnZqFt3MXtBohOlZICJqEHwEntpQ6b7pTRk5iBdr81OA7%2F7ECin7rWOmA9XLsBqlE17N041GgQRsntNsD9dmtcmVDHPYTiahks2GG2ndUhHs073%2BxgOwEF%2BWB5IZFgXSGIvuK9jZKGbfQrxUF6jCQ63&X-Amz-Signature=870e55a5089251dca3f929646dbac8f032e17715b6f985384a669802569c0d86&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-07T00:47:00.000Z",
			"id": "93159c36-f24d-4328-848b-e25273994629",
			"contadores": [
				"Cabelos Estilosos",
				"Golpes bem aplicados",
				"Quadrinhos com trilha sonoras indicadas pelo autor",
				"Armas Improvisadas"
			],
			"caps_lidos": "3",
			"imagem_name": "toolschallenge-hq",
			"data_leitura": "2022-12-01T23:00:00.000-03:00",
			"genero": [
				{
					"name": "Shonen",
					"color": "red"
				},
				{
					"name": "Ação",
					"color": "yellow"
				}
			],
			"link_compra": "https://www.amazon.com.br/s?k=tools+challenge&__mk_pt_BR=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=FZXO3UWXGJ3F&sprefix=tools+challeng%2Caps%2C315&ref=nb_sb_noss_2",
			"link_leitura": "https://tapas.io/episode/1578209",
			"name": "Tools Challenge",
			"porcentagem_leitura": 60,
			"publicacao": "Finalizado",
			"status": "Lendo",
			"total_caps": "5",
			"autores": [
				"6465bc2a-15f1-450e-ab13-1f82f0da7b71"
			],
			"autor": [
				"Max Andrade"
			],
			"insta": "https://www.instagram.com/puffnopiripaf/",
			"tags": "♂️",
			"twitter": "https://twitter.com/puffnopiripaf"
		}
	],
	"files": [
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8dd254db-6281-464f-8429-2bf55aa4bf4e/troublemakers-cenas-lucifer.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=b4b3a300b005138fef961ab0c372ecc9a567646dfcdefecc15dbce986f7769e4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T23:16:00.000Z",
			"id": "1c7e1ce0-0fd5-80b6-b2e8-ce370c2926d2",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Lúcifer",
			"tag": "Cenas Marcantes",
			"imagem_name": "troublemakers-cenas-lucifer"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/72763271-c14c-4992-afd1-ff832aa5f15e/guiltyheartofabsoluteevil-char-xerifepretagoista.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=8cdf4d695838b06926e8bd0c3e17f33f2358f046f5ff63fdd608aa083917d54c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T23:15:00.000Z",
			"id": "1c7e1ce0-0fd5-8056-a8c8-f000c13b520a",
			"comic_id": "1c7e1ce0-0fd5-80ea-8304-f2d7ffabd773",
			"name": "Xerife Preta Goista",
			"tag": "Personagens Maneiros",
			"imagem_name": "guiltyheartofabsoluteevil-char-xerifepretagoista"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a25ae13c-49fa-42f4-b8af-59846ea4978a/guiltyheartofabsoluteevil-artef-cintoestelar.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=2bc64e57339212b8175a6da0f8b4ee5030a135d567737beaa8f69547f4d9e34c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T23:14:00.000Z",
			"id": "1c7e1ce0-0fd5-8053-9da4-ec5359aec8d6",
			"comic_id": "1c7e1ce0-0fd5-80ea-8304-f2d7ffabd773",
			"name": "Cinto Estelar",
			"tag": "Artefatos Lendários",
			"imagem_name": "guiltyheartofabsoluteevil-artef-cintoestelar"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7302f6f3-250d-4255-838c-3594cdf758a8/arthureosol-exp-arthuraura.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=cb31ea5a2dcb752ab5ccd77130b080f9bb5bc42adca87b73cb1bd60c210542b6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T23:07:00.000Z",
			"id": "1c7e1ce0-0fd5-8092-b23e-e2a0db5470ea",
			"comic_id": "17397722-d811-4e0a-a42b-11d7fdd5f0c0",
			"name": "Arthur Aura",
			"tag": "Expressões",
			"imagem_name": "arthureosol-exp-arthuraura"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5b79a486-a52c-44ee-b199-f453f9e05a1c/deoutrosmundos-ship-ametistaeapolo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=0768c427e8dc52a8a22bb772b48352f08ccb4bde499614520967a5518444d03d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T22:59:00.000Z",
			"id": "1c7e1ce0-0fd5-803d-8b1d-ce8c4d0ddc55",
			"comic_id": "1c7e1ce0-0fd5-80f9-90e6-f2c26fbf1fce",
			"name": "Ametista e Apolo",
			"tag": "Shipps Fofos",
			"imagem_name": "deoutrosmundos-ship-ametistaeapolo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/aa3db600-faeb-4350-acb6-3d13cccaa0f3/irmaoscarranca-cenas-ataquedacobra.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=37ce2773a330d908defafe287cf34edf4e064128f5c6d6adade49ffbd14ef0cd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T22:47:00.000Z",
			"id": "1c7e1ce0-0fd5-80f2-a462-fd64c29b13c7",
			"comic_id": "1c7e1ce0-0fd5-8050-b75c-d82740e1bfe4",
			"name": "Ataque da Cobra",
			"tag": "Cenas Marcantes",
			"imagem_name": "irmaoscarranca-cenas-ataquedacobra"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b0e0d4e7-54eb-4067-b933-7fabb183ea21/irmaoscarranca-char-irmaos.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=289619f268eb47511051f66d44329cf287e582e99a2a1cac63508ff64662deb0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T22:44:00.000Z",
			"id": "1c7e1ce0-0fd5-8088-a91a-f56e50830191",
			"comic_id": "1c7e1ce0-0fd5-8050-b75c-d82740e1bfe4",
			"name": "Irmaos Carranca",
			"tag": "Personagens Maneiros",
			"imagem_name": "irmaoscarranca-char-irmaos"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f4106d09-a29d-4bff-ba68-345fb365382a/calista-golp-estacasdegelo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=e1f5db74ae1c22ecb2763f0207d2a08e208a4b186652672088dbadc59421bead&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T22:39:00.000Z",
			"id": "1c7e1ce0-0fd5-80c7-996e-dbdc7ee8434b",
			"comic_id": "c7e1a017-8bc5-4058-87cd-7baf3542e7c7",
			"name": "Estacas de Gelo",
			"tag": "Golpes Fodas",
			"imagem_name": "calista-golp-estacasdegelo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/80490ddc-ed6e-4da4-9405-3418470bc172/calista-golp-abraodassombras.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=a1b60f2f12145b5a8d032dfb424403e7104f76594c1b3835bd28fa5b4c52694b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T22:38:00.000Z",
			"id": "1c7e1ce0-0fd5-80d2-a957-e641beca1d4a",
			"comic_id": "c7e1a017-8bc5-4058-87cd-7baf3542e7c7",
			"name": "Abraço das Sombras",
			"tag": "Golpes Fodas",
			"imagem_name": "calista-golp-abraçodassombras"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/824f5d15-7423-4594-8618-c44451a35496/calistia-capa-2.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=628b729690d31651bdc3fc81e05c4f88dcc12387777c23435687f81adf4c67a1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-31T22:38:00.000Z",
			"id": "1c7e1ce0-0fd5-80b5-9b27-ed66f11ad78e",
			"comic_id": "c7e1a017-8bc5-4058-87cd-7baf3542e7c7",
			"name": "Calístia 2",
			"tag": "Capas Insanas",
			"imagem_name": "calistia-capa-2"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/86dfe536-96cc-4342-8c6a-ff5be60e48e0/paulorangers-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=9a816e2388c04bcc374b2a25ac44fab447b07624158bc2506df1220654c7f088&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T15:14:00.000Z",
			"id": "1b7e1ce0-0fd5-801e-b13d-ef478adfafa3",
			"comic_id": "1b7e1ce0-0fd5-8023-ad9b-c4edfc5786d3",
			"name": "Paulo Rangers",
			"tag": "Capas Insanas",
			"imagem_name": "paulorangers-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b60e9a77-15d6-4219-8063-4419564c4a46/magh-cenas-universo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=bcfd8a6c21f7194cfe590c3f00818311008e7cce97dc4f075870ff342ab39d1a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T15:09:00.000Z",
			"id": "1b7e1ce0-0fd5-808b-9255-fdecbbb4001a",
			"comic_id": "1ee0fa67-fbec-42fc-b605-35a3db69617d",
			"name": "Universo",
			"tag": "Cenas Marcantes",
			"imagem_name": "magh-cenas-universo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1b952988-7c2f-4433-860d-2c5bd1b22734/aprofeciaprofunda-golp-mijadaastral.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=bf8b7f91fb8996aae9d15009cdea12ff3c55d28466d05ddc568c625551586e88&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:51:00.000Z",
			"id": "1b7e1ce0-0fd5-804c-a488-c6f173074027",
			"comic_id": "1b7e1ce0-0fd5-80b2-8685-e3d799354335",
			"name": "Mijada Astral",
			"tag": "Golpes Fodas",
			"imagem_name": "aprofeciaprofunda-golp-mijadaastral"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/862fca8e-5705-47ca-9cc8-f72a81fa3c1f/kellyyoungshifty-char-kelly.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=cbd9319e2bcb86c6cf594c59f499b5d71f9dda67a6a8c52769c7b68a88b66165&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:38:00.000Z",
			"id": "1b7e1ce0-0fd5-8055-9618-cef1783321ef",
			"comic_id": "1b7e1ce0-0fd5-80cf-bc03-c2ac978e849d",
			"name": "Kelly Young",
			"tag": "Personagens Maneiros",
			"imagem_name": "kellyyoungshifty-char-kelly"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f044df1e-263a-4db3-beff-93e344f5ee98/eunaotoafimdomocinho-exp-cascandoobico.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=876500e05d6f3f500ef3f40e399717814db3f08eacac5ba769c335fb1f87d5cb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:30:00.000Z",
			"id": "1b7e1ce0-0fd5-80cd-8b06-f684f93af304",
			"comic_id": "1b7e1ce0-0fd5-80d0-9d9e-db7545313f2a",
			"name": "Cascando o Bico",
			"tag": "Expressões",
			"imagem_name": "eunaotoafimdomocinho-exp-cascandoobico"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bb219488-e6aa-493c-93a8-bdb810b53092/twinheartzodiac-lugar-formigueiro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=598ae9b475ee4d272261934a43118c91905d5705eea01ee90c5d1a9941d59994&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:21:00.000Z",
			"id": "1b7e1ce0-0fd5-8043-9349-e8b48448bdd1",
			"comic_id": "1b7e1ce0-0fd5-8070-a859-d1b4fbfef1fe",
			"name": "Formigueiro",
			"tag": "Lugares Irados",
			"imagem_name": "twinheartzodiac-lugar-formigueiro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1b430a27-9c2e-4d12-b83a-053325ccbb76/twinheartzodiac-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=0148dc575f047161ec1728e42548744f1479c1125c3cfaf600366ae03dcc81b5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:20:00.000Z",
			"id": "1b7e1ce0-0fd5-80ee-a368-e6783002a4ef",
			"comic_id": "1b7e1ce0-0fd5-8070-a859-d1b4fbfef1fe",
			"name": "Twin Heart Zodiac - 1",
			"tag": "Capas Insanas",
			"imagem_name": "twinheartzodiac-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2f25f771-5bdf-4293-9375-611a013a3c2e/missfortune-char-morte.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=2507ca1c2e021d44bfe75d5f0f949bd2dc512c2b0dc273d47e23c94fe3d6fb05&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T14:15:00.000Z",
			"id": "1b7e1ce0-0fd5-80ae-9d69-f34889be5b9a",
			"comic_id": "1b7e1ce0-0fd5-80c7-8591-fd528029fefa",
			"name": "Morte",
			"tag": "Personagens Maneiros",
			"imagem_name": "missfortune-char-morte"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/228af373-9091-446b-9ae6-daa1a799661c/splittingimage-golp-cortenebula.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ba98d7be976b86e8b22f3bce39b49f990ac8864f5a888b3115c83e16068ab0f5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:55:00.000Z",
			"id": "1b7e1ce0-0fd5-8078-8f45-db4d11c20903",
			"comic_id": "1b7e1ce0-0fd5-80d6-a66f-e05a21683a7d",
			"name": "Corte Nébula",
			"tag": "Golpes Fodas",
			"imagem_name": "splittingimage-golp-cortenebula"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d757fffa-daeb-455c-b961-f30830cc35d2/junhonaojuno-masc-freduardo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ead28cd1f823c715574a756dd47da4507e742396fcfa6cb049a4629cec4037f5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:39:00.000Z",
			"id": "1b7e1ce0-0fd5-808e-a713-e2489288bec9",
			"comic_id": "40e9af8f-7ce5-470b-bcfd-720cdeb03728",
			"name": "Freduardo",
			"tag": "Mascotes fofinhos",
			"imagem_name": "junhonaoéjuno-masc-freduardo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f3ac8563-559a-45b3-b57c-912e84ad1515/junhonaojuno-capa-2.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=8e9be3e6667c47436bfde34d5f65dcb034be69f772a7a672b97defc04897d344&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:38:00.000Z",
			"id": "1b7e1ce0-0fd5-8030-9303-d0ebbbd60dd6",
			"comic_id": "40e9af8f-7ce5-470b-bcfd-720cdeb03728",
			"name": "Junho não é Juno - 2",
			"tag": "Capas Insanas",
			"imagem_name": "junhonaoéjuno-capa-2"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/029e8e85-addc-419e-8408-2fb722d2a408/numikins-char-sapinho.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=5b9bdee00cd838ac46a8662ca131edcd8813fad5bfbacc06346c41636f0962b2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:35:00.000Z",
			"id": "1b7e1ce0-0fd5-80d6-9858-f094969cc4ef",
			"comic_id": "1b7e1ce0-0fd5-80a1-b88c-d2711faa51d6",
			"name": "Sapinho",
			"tag": "Personagens Maneiros",
			"imagem_name": "numikins-char-sapinho"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9e43b368-2cb4-41f5-855e-a9754e8d7522/dragoncity-cena-vaidartudocerto.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=19d8e959759e1267c9674ce680ed6c99071e2faa35100ba23df58bcad19b29dc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:30:00.000Z",
			"id": "1b7e1ce0-0fd5-800a-81c8-c6d588bf306f",
			"comic_id": "1b7e1ce0-0fd5-80f2-8912-dbff2317d0f3",
			"name": "Vai dar tudo certo",
			"tag": "Cenas Marcantes",
			"imagem_name": "dragoncity-cena-vaidartudocerto"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2792f4d6-1751-4d03-a5a7-c459f0b4da23/slave-char-kuro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=386cef145cd988a68f89901927f2512ad2b74ed2dc1b483c874d5b726f9b5da9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:23:00.000Z",
			"id": "1b7e1ce0-0fd5-8013-8f15-db583fc3905a",
			"comic_id": "1b7e1ce0-0fd5-802b-a5d4-cfe865ac456f",
			"name": "Kuro",
			"tag": "Personagens Maneiros",
			"imagem_name": "slave-char-kuro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1970ae07-3b8e-47e0-bd3f-eea9f37ef56e/slave-exp-conquistador.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=79de640c97e1c8a256e43502e1bff84d2e433f03feeca8c1b006a0d04cf3a7ca&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:18:00.000Z",
			"id": "1b7e1ce0-0fd5-8047-b58b-d6818a021f74",
			"comic_id": "1b7e1ce0-0fd5-802b-a5d4-cfe865ac456f",
			"name": "Conquistador",
			"tag": "Expressões",
			"imagem_name": "slave-exp-conquistador"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4182b9ce-465b-4c04-8242-ca4f20506ad2/slave-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=1c21d57241a739bda252dda7452219b3a9f075cce9bbd7f1f4388f0345d1c296&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:17:00.000Z",
			"id": "1b7e1ce0-0fd5-8061-b483-dacb8aa4d4d9",
			"comic_id": "1b7e1ce0-0fd5-802b-a5d4-cfe865ac456f",
			"name": "Slave - 1",
			"tag": "Capas Insanas",
			"imagem_name": "slave-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/89e119c7-13ad-4d06-8588-469db38d5a23/arthureosol-cena-lottos.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=291ed7202f699845b91d2605921411aa33e81bc5850af87ea59719bcbbccc1c6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:16:00.000Z",
			"id": "1b7e1ce0-0fd5-80c1-9e6a-ff58fe762975",
			"comic_id": "17397722-d811-4e0a-a42b-11d7fdd5f0c0",
			"name": "Lottos x Arthur",
			"tag": "Cenas Marcantes",
			"imagem_name": "arthureosol-cena-lottos"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e3e401ae-dcf4-4dab-b922-025de42bec3b/desculpaeugostodevc-exp-riedanada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=143ce5110e067c929220f3966589eca58fb4a6928000e4c9421faef45d022969&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T13:11:00.000Z",
			"id": "1b7e1ce0-0fd5-80f1-8dba-c23dbe74a8a1",
			"comic_id": "96f7930f-cb9f-4a31-9d53-5dc4179f6300",
			"name": "Rie danada",
			"tag": "Expressões",
			"imagem_name": "desculpaeugostodevc-exp-riedanada"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/dbfad215-b41b-4e55-a000-ade13b402e11/taico-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=934382ae24508758dda7e27e7d12bc7f3f33cdac97f8440dd0b283eda633f4da&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-03-15T12:59:00.000Z",
			"id": "1b7e1ce0-0fd5-8090-a5be-d3e8978586e0",
			"comic_id": "1b7e1ce0-0fd5-808c-ad91-d11447136daf",
			"name": "Taico - 1",
			"tag": "Capas Insanas",
			"imagem_name": "taico-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cf542171-425d-4a20-a620-7253352492c6/troublemakers-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ed49b7518de7c28f9882fbdd8ce116e62491f07b40081e5b59369abf1d131441&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-11T23:24:00.000Z",
			"id": "197e1ce0-0fd5-80a1-b111-e1add38bc0b2",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Trouble Makers 12",
			"tag": "Capas Insanas",
			"imagem_name": "troublemakers-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/832023a8-ca2f-47a2-815d-d2361d3c3019/diascinzentos-artef-espada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=a7670211f773f0a153c75610d2d190058f2029426073576dec98b7db7e9e864e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-11T23:20:00.000Z",
			"id": "197e1ce0-0fd5-80c2-946d-f4606d18bb56",
			"comic_id": "313bb11d-2310-4976-bd74-2fb7d707598a",
			"name": "Espadão",
			"tag": "Artefatos Lendários",
			"imagem_name": "diascinzentos-artef-espada"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6a13c291-0fc8-4b49-873e-5da6b1b523a9/diascinzentos-lugares-ilhascelestes.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=9c18c1c18880f990bbce5075157c117f93639b90f8ee6aa51909bfebdc3fe937&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-11T23:19:00.000Z",
			"id": "197e1ce0-0fd5-809b-ba5d-fcca23b8f5fd",
			"comic_id": "313bb11d-2310-4976-bd74-2fb7d707598a",
			"name": "Ilhas Celestes",
			"tag": "Lugares Irados",
			"imagem_name": "diascinzentos-lugares-ilhascelestes"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/49781a9b-484d-418c-bd34-24e6578bb503/diascinzentos-cenas-socofraco.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=f7dfcaaf23fb45ca3d3d6e95fc6398032e7cd07e0797b03c99c7056bfa420f4d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-11T23:19:00.000Z",
			"id": "197e1ce0-0fd5-804d-ab44-f1151ad94650",
			"comic_id": "313bb11d-2310-4976-bd74-2fb7d707598a",
			"name": "Soco Fraco",
			"tag": "Cenas Marcantes",
			"imagem_name": "diascinzentos-cenas-socofraco"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8d2f6945-ad88-4c9b-9372-966e24d6cd8a/southcurse-golpe-riodejaneiro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=d2604d6b01a281627e2bb53e4d63c3169167c305b4f13e3eeb945f105d44d37c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-07T00:06:00.000Z",
			"id": "193e1ce0-0fd5-803b-97cd-deb0638ba6cd",
			"comic_id": "193e1ce0-0fd5-80d6-b62c-d3101e755412",
			"name": "Rio de Janeiro",
			"tag": "Golpes Fodas",
			"imagem_name": "southcurse-golpe-riodejaneiro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/170a6005-7043-4d9d-87f8-ffda66bff4f4/nobicodurubu-golpe-desconstruo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=db7f2cab8228e3338883920fa579f983e11425359cdf017e2af4d99cb8e2a515&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-07T00:00:00.000Z",
			"id": "193e1ce0-0fd5-8074-a124-daf786fc163d",
			"comic_id": "13be1ce0-0fd5-8054-a615-db7be429fb73",
			"name": "Desconstrução",
			"tag": "Golpes Fodas",
			"imagem_name": "nobicodurubu-golpe-desconstrução"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bdd912af-6aae-4cba-91c6-d16841aea26a/comosetornarhumano-cenas-amormundano.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=5c0a9c0a70ef3304a77175c2b20cc2e44c5f41373e94e0e0868c7d6effc9c123&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-06T23:59:00.000Z",
			"id": "192e1ce0-0fd5-809f-b58b-dd7f62b5b96d",
			"comic_id": "cd1cf97e-6c92-47b3-89fd-36acfa1f3ecb",
			"name": "Amor Mundano",
			"tag": "Cenas Marcantes",
			"imagem_name": "comosetornarhumano-cenas-amormundano"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/10dab52e-f7b3-4dff-b29e-6c8102ca1dd5/colatino-char-carranca.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=2ba782bab9cb7c3c52300e48e70e67c723167f398a804cda07a5d0775175000f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-06T23:58:00.000Z",
			"id": "192e1ce0-0fd5-80b8-9253-e32c37feed3b",
			"comic_id": "517eea1e-3d6a-4a83-bb47-b03949210ac2",
			"name": "Carranca",
			"tag": "Personagens Maneiros",
			"imagem_name": "colatino-char-carranca"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d8d801ca-6a70-489b-a6cd-6fd59ffe87b0/colatino-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=9af7641df5c775247048901b49bb094aba53bb507cfeff63327ef3d804f07369&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-02-06T23:56:00.000Z",
			"id": "192e1ce0-0fd5-803f-8fb5-e017c6df83b2",
			"comic_id": "517eea1e-3d6a-4a83-bb47-b03949210ac2",
			"name": "Colatino ",
			"tag": "Capas Insanas",
			"imagem_name": "colatino-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f55b768c-3025-433a-9c20-42c3632f5633/straypigs-char-prtico.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=744b64a557b288279cdbf166247b69c86adc8d039a9bc07b8eec767dfb661d5e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T01:05:00.000Z",
			"id": "170e1ce0-0fd5-80d6-8a12-db5245e5ae93",
			"comic_id": "170e1ce0-0fd5-8075-9357-f7556b87bcdf",
			"name": "Prático",
			"tag": "Personagens Maneiros",
			"imagem_name": "straypigs-char-prático"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/588556d3-8a3d-495a-8520-177b5f39db04/straypigs-lugar-thecurral.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=1712afa503ee23fcad3cd6ca1decc1533e934cc0e3d33770fad6dbb9435f2748&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T01:05:00.000Z",
			"id": "170e1ce0-0fd5-805e-98c4-d1e2a1f590db",
			"comic_id": "170e1ce0-0fd5-8075-9357-f7556b87bcdf",
			"name": "The Curral",
			"tag": "Lugares Irados",
			"imagem_name": "straypigs-lugar-thecurral"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/94c19c5a-e7d0-4d91-8ec9-cb35dabe611b/macacadas-mult-contosdosamurai.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=662c56df79c468661da934d817873e271c0eec107b266467165454575a0c2f66&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T01:00:00.000Z",
			"id": "170e1ce0-0fd5-8010-a4e4-e021ac2f8cab",
			"comic_id": "e4e45844-56fa-4528-8666-612cd44cedad",
			"name": "Poster de Contos do Samurai",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "macacadas-mult-contosdosamurai"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/65856b14-b694-4d36-967a-45e3effe0c89/brainrootmirage-cenas-sos.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=0df7b3a8bffcb845765a795a805c1e539947ee21db67ffde1151b23d4e39a8d0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:58:00.000Z",
			"id": "170e1ce0-0fd5-80d4-ab68-deb131c279a2",
			"comic_id": "170e1ce0-0fd5-8011-9fd2-f9ce7de53eff",
			"name": "sos",
			"tag": "Cenas Marcantes",
			"imagem_name": "brainrootmirage-cenas-sos"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3d01e434-53dd-4ebc-a4e6-7058aeef308a/ovoluntario-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=58a73633f83ccad61d3a26d191cc2e2ea9be8acec03c056ddceca2260a62b20b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:43:00.000Z",
			"id": "170e1ce0-0fd5-8032-88d7-dc77f5c2636c",
			"comic_id": "13be1ce0-0fd5-80e8-b151-fc4a78afe574",
			"name": "O Voluntário",
			"tag": "Capas Insanas",
			"imagem_name": "ovoluntario-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bc0e61be-5f32-4053-af25-f4ed47ee388b/willowitch-cena-ocaminhocerto.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ff9f1e5f9d6e6ae20c51cc1e1e3f217a6e8c188c507a200a322814426ed7aec7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:41:00.000Z",
			"id": "170e1ce0-0fd5-80fd-b198-dafeb6ce7160",
			"comic_id": "115e1ce0-0fd5-806d-a507-e40ade9eeacd",
			"name": "O Caminho Certo",
			"tag": "Cenas Marcantes",
			"imagem_name": "willowitch-cena-ocaminhocerto"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8b3dea8d-ea9a-4348-b5e7-1d9cae70c599/willowitch-golp-bigmaxpumpkin.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=dc4bfc5b54b1b9007911cadc480036a6ceef65a4f04e73383abbc7cc4fdc5dff&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:41:00.000Z",
			"id": "170e1ce0-0fd5-808c-8f72-d4b011cd51db",
			"comic_id": "115e1ce0-0fd5-806d-a507-e40ade9eeacd",
			"name": "BigMax Pumpkin",
			"tag": "Golpes Fodas",
			"imagem_name": "willowitch-golp-bigmaxpumpkin"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/efc08ce1-9f1a-4071-aef5-d780ff2a79f9/ainsurgenciaceleste-artef-chaveslimiares.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=1a6b1c32556cdfe3e4d1740f45443d29583b27172b8ec944ea27ea49208f2fc9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:39:00.000Z",
			"id": "170e1ce0-0fd5-8060-96a9-d54864ad1047",
			"comic_id": "f37b3e11-ecf3-4c6b-be20-8da070592520",
			"name": "Chaves Limiares",
			"tag": "Artefatos Lendários",
			"imagem_name": "ainsurgenciaceleste-artef-chaveslimiares"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f63023f0-9f98-4757-98a2-ce047d461a99/rebirthofshadows-lugares-pirocaodacidade.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=97438a4197b3d616cbbc8ff878047990a64660a381857d9c3c08400de9e5ca1e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:28:00.000Z",
			"id": "170e1ce0-0fd5-8081-8da5-c83fedfb7735",
			"comic_id": "acd6fb22-b852-4c2c-b4b7-7d038aaae6c4",
			"name": "Predião da cidade",
			"tag": "Lugares Irados",
			"imagem_name": "rebirthofshadows-lugares-pirocaodacidade"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/92f7b9bc-00bb-4006-9260-9ab267fa5b64/fatalabruxadebeliverde-cena-autor.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=bb69c532f639023003485bd1652dd51fe271f726cc6f3610714be78aaf46f76a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:25:00.000Z",
			"id": "170e1ce0-0fd5-801d-9103-facee60563b2",
			"comic_id": "f5414002-efb6-45bd-b80f-296dee47d279",
			"name": "Quadrinista mais fraco",
			"tag": "Cenas Marcantes",
			"imagem_name": "fatalabruxadebeliverde-cena-autor"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cac965f9-c027-4b21-b671-cb00cbbad4a7/arinopaisdasmascaras-char-gemini.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=88c5aa5a30dd9296314da3d3f164c04592d65503f8cacd834b951d3dac029598&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:21:00.000Z",
			"id": "170e1ce0-0fd5-800e-a0ef-c375767c8de1",
			"comic_id": "170e1ce0-0fd5-80eb-a8d8-c7503f478c88",
			"name": "Gemini",
			"tag": "Personagens Maneiros",
			"imagem_name": "arinopaisdasmascaras-char-gemini"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c83ce21c-4fb7-4a0b-896d-cd20e34e595a/ovoluntario-cena-voosh.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=784c89962080bd56a6eb66b1f5d38bab193de4442f873e2e7a88e6a916469826&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:05:00.000Z",
			"id": "170e1ce0-0fd5-80a8-83c4-ff0fb145dbaf",
			"comic_id": "13be1ce0-0fd5-80e8-b151-fc4a78afe574",
			"name": "VOOSH",
			"tag": "Cenas Marcantes",
			"imagem_name": "ovoluntario-cena-voosh"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e90461db-f54f-4747-9ee3-d258e61c5b3e/impiedoso-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=47cf42fe0fbef13e35bbe0094fc10e1deb4fe6ab451b843a2560d9ce0e61521b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-03T00:03:00.000Z",
			"id": "170e1ce0-0fd5-8085-8d41-e791a28e60bc",
			"comic_id": "13be1ce0-0fd5-80c0-a676-d006ceeb48a2",
			"name": "Impiedoso - 1",
			"tag": "Capas Insanas",
			"imagem_name": "impiedoso-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/950bd564-e62e-4dc7-8087-8f42938ca638/rebirthofshadows-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ba0ff4d7538f1c724ae47df907b2c45255f60fd3b7e6fb26c007608198d4ca52&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:58:00.000Z",
			"id": "16fe1ce0-0fd5-802c-9863-e7ba453c7896",
			"comic_id": "acd6fb22-b852-4c2c-b4b7-7d038aaae6c4",
			"name": "Rebirt Of Shadows - 1",
			"tag": "Capas Insanas",
			"imagem_name": "rebirthofshadows-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d9275a1d-3234-49d4-9b29-affe7899c133/ochamadolqn-golp-ochamadolqn.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=0d81ed6ffc870a3c97c717c9b04c780dccd1627875b1e4c26e6c5129e1a8fd8f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:55:00.000Z",
			"id": "16fe1ce0-0fd5-8046-9081-ec890bb611cb",
			"comic_id": "16fe1ce0-0fd5-80c7-81e2-d1619461f119",
			"name": "O chamado LQN",
			"tag": "Golpes Fodas",
			"imagem_name": "ochamadolqn-golp-ochamadolqn"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/945903c7-e16f-4e29-9ab4-79a65a12885a/ochamadolqn-cenas-roland.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=c810c979dc9387e079927615c34b844f73b897c209c8f7f2f38f25f7f999bff8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:54:00.000Z",
			"id": "16fe1ce0-0fd5-80b1-a890-e393e503cc9f",
			"comic_id": "16fe1ce0-0fd5-80c7-81e2-d1619461f119",
			"name": "Multiverso LQN",
			"tag": "Cenas Marcantes",
			"imagem_name": "ochamadolqn-cenas-roland"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/800971b3-3a54-44bc-b3c3-b51a4924c292/nimbus-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=25a96b42f4de185b31e190b9ceb33cc61cd9df68a22fcd74a37aa63614c3ddf8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:46:00.000Z",
			"id": "16fe1ce0-0fd5-8090-9a73-c5a5f5f44f8c",
			"comic_id": "16fe1ce0-0fd5-80e7-9e3f-d0bdc4513661",
			"name": "Nimbus",
			"tag": "Capas Insanas",
			"imagem_name": "nimbus-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d6501afa-b3bd-4e33-8101-516c607f9853/caramelorex-golp-supernovacaramelo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=65d0ae12f6f805db596e390566ae0906e49366659bb8b1407c70c53468d73723&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:39:00.000Z",
			"id": "16fe1ce0-0fd5-804a-88a0-f4e47cc2509c",
			"comic_id": "16fe1ce0-0fd5-8051-b26e-dabd5b755325",
			"name": "Supernova Caramelo",
			"tag": "Golpes Fodas",
			"imagem_name": "caramelorex-golp-supernovacaramelo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c944db62-3f10-4a85-a676-39eefee9c101/caramelorex-cena-bomgaroto.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=39ddb965396395062ef8f0bd9b30ddcb09a399def923aa2a71d6c7a296b9902b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:38:00.000Z",
			"id": "16fe1ce0-0fd5-8019-b877-cf8249cc2fb0",
			"comic_id": "16fe1ce0-0fd5-8051-b26e-dabd5b755325",
			"name": "Bom garoto",
			"tag": "Cenas Marcantes",
			"imagem_name": "caramelorex-cena-bomgaroto"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c33d0f56-23af-4ce3-a380-9948cb5249c6/caramelorex-lugar-monteroraima.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=870ff3ebfb14f73a52d3b0b079f5bb0ad0a271c1e067b4b777f51ddfa81a5f69&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:37:00.000Z",
			"id": "16fe1ce0-0fd5-8080-aa80-f2f6bde091f9",
			"comic_id": "16fe1ce0-0fd5-8051-b26e-dabd5b755325",
			"name": "Monte Roraima",
			"tag": "Lugares Irados",
			"imagem_name": "caramelorex-lugar-monteroraima"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/46ae5af8-f05a-49c0-a4c7-b432b924ac0d/caramelorex-golp-garrasembrasadas.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=65cf9ca39d0b9d72c1f71e7c0763c9db839720f498f2c3ca57121e1615001f31&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:36:00.000Z",
			"id": "16fe1ce0-0fd5-805c-a560-d867a56ebe33",
			"comic_id": "16fe1ce0-0fd5-8051-b26e-dabd5b755325",
			"name": "Garras Embrasadas",
			"tag": "Golpes Fodas",
			"imagem_name": "caramelorex-golp-garrasembrasadas"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/29352e06-428e-4b44-a456-43c0bf0d704e/caramelorex-mascotes-rex.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=12d5814b5c8f4a895d46eb1ba699d146bb9333661f477f30b5cd77bb9c4956e7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:35:00.000Z",
			"id": "16fe1ce0-0fd5-8048-a16d-d29033df2f21",
			"comic_id": "16fe1ce0-0fd5-8051-b26e-dabd5b755325",
			"name": "Rex",
			"tag": "Mascotes fofinhos",
			"imagem_name": "caramelorex-mascotes-rex"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/70e2c1f7-1f5f-4232-9185-04d6bc8a2eb8/caramelorex-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=fd0edd5d764df7cdaae359cb9fa0ad5012714cd9c8a657b85d1418862a90a365&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:34:00.000Z",
			"id": "16fe1ce0-0fd5-801f-85f1-d5e8b998f649",
			"comic_id": "16fe1ce0-0fd5-8051-b26e-dabd5b755325",
			"name": "Caramelo Rex",
			"tag": "Capas Insanas",
			"imagem_name": "caramelorex-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e52fd769-115f-4096-87d5-41ec706480de/kikronicles-exp-hein.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=53af71819b150de1fad93e2236e01cd9898c3bed303a1cf2663e177e859a24b4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2025-01-02T23:31:00.000Z",
			"id": "16fe1ce0-0fd5-8061-b0ed-ee1a0b5a61ce",
			"comic_id": "881b508d-1120-46bb-a7ef-88801368cf09",
			"name": "Hein",
			"tag": "Expressões",
			"imagem_name": "kikronicles-exp-hein"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c2894522-c32b-482b-b368-aa03309dd52a/lockedoutofhell-exp-dumb.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=4496c4db89152543063d794c79392046cb06593e1697d364308a95ce69577aae&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T01:08:00.000Z",
			"id": "13be1ce0-0fd5-8057-b15b-da8889716ae8",
			"comic_id": "13be1ce0-0fd5-80e1-b394-f602da84ddbd",
			"name": "dumb",
			"tag": "Expressões",
			"imagem_name": "lockedoutofhell-exp-dumb"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6b8af1e7-7867-4920-b35c-44c755466e41/impiedoso-masc-ursinho.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=9e3c8599aebf7c0e9e7eaffdf91bfdb9de597ae5f20af104575929a462bd23bd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T00:50:00.000Z",
			"id": "13be1ce0-0fd5-80f0-8682-e611980ba5a6",
			"comic_id": "13be1ce0-0fd5-80c0-a676-d006ceeb48a2",
			"name": "Ursinho",
			"tag": "Mascotes fofinhos",
			"imagem_name": "impiedoso-masc-ursinho"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1faae40b-7aa4-447f-a324-6768272c3352/contosmacabrosdotumulododemonio-exp-medo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ddd1f6714d929d69a00b8db200f178ab1ec1a848082492af3170d51fae1cf727&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T00:41:00.000Z",
			"id": "13be1ce0-0fd5-8020-93a2-f0a68f7601a3",
			"comic_id": "f1a137b8-c1e7-4e2b-a12d-5205e0e95da1",
			"name": "Medo",
			"tag": "Expressões",
			"imagem_name": "contosmacabrosdotumulododemonio-exp-medo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/de8bac58-eab5-4b28-8a7a-4f3bc38ca412/nobicodurubu-artef-necronomicon.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=71bf2af3cf6a1da8ec99f5081d7a806c4f85636c76d4c1c21d4a80d71be57886&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T00:37:00.000Z",
			"id": "13be1ce0-0fd5-801e-8269-e64381075fc7",
			"comic_id": "13be1ce0-0fd5-8054-a615-db7be429fb73",
			"name": "Necronomicon",
			"tag": "Artefatos Lendários",
			"imagem_name": "nobicodurubu-artef-necronomicon"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/12092362-3f21-4d2f-89ce-f0baa6604eb3/nobicodurubu-lugar-horizontefragmentado.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=1bd717afdd3342dffc7d67dd5a3d0dc249706cd5d3dfdabbd91a1f2cdd0d753f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T00:37:00.000Z",
			"id": "13be1ce0-0fd5-80d3-a68a-cb1e1ee61411",
			"comic_id": "13be1ce0-0fd5-8054-a615-db7be429fb73",
			"name": "Horizonte Fragmentado",
			"tag": "Lugares Irados",
			"imagem_name": "nobicodurubu-lugar-horizontefragmentado"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4b6c9ec9-d730-4cc1-8c41-eee61a60391f/desculpaeugostodevc-cenas-euamooyuri.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=e97feabe6cac1089c8c77e3f84ebeb254ec1cc4e2dde8cdf18a0ffdc5de89885&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-11-11T00:29:00.000Z",
			"id": "13be1ce0-0fd5-80e4-a1e9-faded9031360",
			"comic_id": "96f7930f-cb9f-4a31-9d53-5dc4179f6300",
			"name": "Eu amo o Yuri",
			"tag": "Cenas Marcantes",
			"imagem_name": "desculpaeugostodevc-cenas-euamooyuri"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c2104d6a-c070-4169-bdd5-87e9e24873e9/lendasamazonicas-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=6a50bd3289ae9cbb0bf10360efc8292e637cc4b67b35b1b18143b98fe2ee6656&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-18T00:25:00.000Z",
			"id": "123e1ce0-0fd5-80a0-a3f7-e85b18171bc5",
			"comic_id": "123e1ce0-0fd5-80e2-8f0f-d7044f4dd4dc",
			"name": "Lendas Amazonicas - 1",
			"tag": "Capas Insanas",
			"imagem_name": "lendasamazonicas-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/07273d9a-cc9f-43a7-8e9d-79c7da3b4c11/comosetornarhumano-char-unknow.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=6b006aebaf97c92a9f55d3235d79ec2df80395628670141c7debaf2ea4739a9a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-18T00:21:00.000Z",
			"id": "123e1ce0-0fd5-8016-b5cb-c11d76940884",
			"comic_id": "cd1cf97e-6c92-47b3-89fd-36acfa1f3ecb",
			"name": "???",
			"tag": "Personagens Maneiros",
			"imagem_name": "comosetornarhumano-char-unknow"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2df35018-eab0-49ad-a0fe-642a8a265bf0/comosetornarhumano-capa3.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ae461665be1efa630fbcb75bc7ce8f9de1f1a5f7da2c4f05f8b06f7a2a5b7fae&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-18T00:14:00.000Z",
			"id": "123e1ce0-0fd5-8031-b93b-d0cad7834c30",
			"comic_id": "cd1cf97e-6c92-47b3-89fd-36acfa1f3ecb",
			"name": "Como se Tornar Humano - 3",
			"tag": "Capas Insanas",
			"imagem_name": "comosetornarhumano-capa3"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e5261f2c-1d57-43ff-b89a-e90587cc0aad/troublemakers-golp-manxloaghtan.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=8c6f719c31dfa721b46db815fd6052b1428474ed8e5bb2b342124c2027b8e2d5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-18T00:12:00.000Z",
			"id": "123e1ce0-0fd5-80eb-b025-d2ef1f9641bb",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Manx Loaghtan",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golp-manxloaghtan"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/57ae3ec7-02c0-4fed-9dc1-e10e9d7ad53d/troublemakers-golp-troblebreakdance.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=4f40b74e8a931c34d0898e70b3c965f16fecfbde0d7435f2a7a9b9f15a5fe8c6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-18T00:12:00.000Z",
			"id": "123e1ce0-0fd5-8065-b842-d0dd9fd9d1a1",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Trouble Break Dance",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golp-troblebreakdance"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a74d3499-691a-44d6-abff-6af99e703465/troublemakers-golp-troublecombo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ad78e94fe9ae2098579c334db8ad90048306c0ad6d5861f1df39d43ebedb1895&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-18T00:11:00.000Z",
			"id": "123e1ce0-0fd5-8015-b382-f54b36420c13",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Trouble Combo",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golp-troublecombo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c2c7e043-120a-41d3-8fc3-1a4f8cd9db0f/troublemakers-golpes-troublepunch.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=238b176687d8ae06902c4c8c30502001b385503b4602bbf86c31d929687ed0f9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-18T00:10:00.000Z",
			"id": "123e1ce0-0fd5-80f0-95d6-ce6524b89371",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Trouble Punch",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golp-troublepunch"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/be024176-698e-4182-86ba-2032c5b6b25d/potentiaorigin-exp-nojin.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=886a394ee63fbc0e06b5d5bd26282cca703c4cd92e2ab911862b857fd7e932fa&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-18T00:10:00.000Z",
			"id": "123e1ce0-0fd5-80e2-99de-d2453f9a1c64",
			"comic_id": "123e1ce0-0fd5-8038-8fd5-d9167801ac65",
			"name": "Nojin",
			"tag": "Expressões",
			"imagem_name": "potentiaorigin-exp-nojin"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/465531ba-a6e7-4b1a-ba3b-a81ec1b7dea7/willowitch-lugar-casinhadabruxa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=35f16115885bf0d4d39293d4829eabd743fbbfc35551f3803bb80e80aa0b8aa7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-06T18:14:00.000Z",
			"id": "117e1ce0-0fd5-8008-ba4e-c525a15852ed",
			"comic_id": "115e1ce0-0fd5-806d-a507-e40ade9eeacd",
			"name": "Casinha da bruxa",
			"tag": "Lugares Irados",
			"imagem_name": "willowitch-lugar-casinhadabruxa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5437ce1d-2ab0-4880-99d7-c1b6fafb69d7/willowitch-exp-desespero.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=2fc44983b8afbe1a96130a7695f1ffbb35ccf88957021a3355799a6a007c9a47&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-06T18:14:00.000Z",
			"id": "117e1ce0-0fd5-80ec-a384-fe8f4a9d888c",
			"comic_id": "115e1ce0-0fd5-806d-a507-e40ade9eeacd",
			"name": "Desespero",
			"tag": "Expressões",
			"imagem_name": "willowitch-exp-desespero"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/75dae97d-ab72-438e-993c-11fa1ece3044/willowitch-char-lancebauer.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=0e413de0c7dfdea1684277f31096117337a1dcba7a92be961f9f48637931792a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-10-06T18:13:00.000Z",
			"id": "117e1ce0-0fd5-80bb-8c52-c426f02601be",
			"comic_id": "115e1ce0-0fd5-806d-a507-e40ade9eeacd",
			"name": "Lance Baur",
			"tag": "Personagens Maneiros",
			"imagem_name": "willowitch-char-lancebauer"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c4f90303-38e6-431d-aa80-299ca4c9744a/prolasarcanas-multi-apollo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=e8948dbd12d5eb01f1cb6e9b826f92fe0636717d58d9ca16f432b20a0e48e650&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-09-09T02:39:00.000Z",
			"id": "addacb5f-7ec1-4485-af61-0a3dc9499cb0",
			"comic_id": "faf5f79f-c223-49c6-b9cb-f8e949438518",
			"name": "Poster de Apollo",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "pérolasarcanas-multi-apollo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e3ca29dd-54f8-451f-bc5d-7d6c862a7fdb/iwannabegod-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=0091a57a0bee064d209a3562f6401adc1ec0b1e4725a024fad5a5e0395e1c670&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-09-05T23:14:00.000Z",
			"id": "621fc05c-e040-4383-9a8d-b4a2e73dcec4",
			"comic_id": "42e667a4-d6cb-4acf-aa03-bdde4d2368be",
			"name": "I Wanna be God",
			"tag": "Capas Insanas",
			"imagem_name": "iwannabegod-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d6279e30-5476-44f1-b1b2-89483681c258/iwannabesatan-golp-tchecopow.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=0f103640f57d17c9faa063e4dff0d4d2891f3cf3b3d150582fb79a65a50c9e97&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-09-05T23:14:00.000Z",
			"id": "a13eccc1-b679-4a63-9a55-40a0eb7065f4",
			"comic_id": "4b5542d2-b1f9-4d5c-8102-d7a995708958",
			"name": "Tcheco Pow",
			"tag": "Golpes Fodas",
			"imagem_name": "iwannabesatan-golp-tchecopow"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e17f9212-ec93-4e52-8235-4bb5ec397aa2/iwannabesatan-golp-rumbletcheco.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=d3cc32c8c0390abae12e3c5d5f48a3f9565d0cbf56cefd1d4e9a67fd6e02c665&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-09-05T23:12:00.000Z",
			"id": "5d698e8f-a96a-4cc2-b7d0-df9a00eddec5",
			"comic_id": "4b5542d2-b1f9-4d5c-8102-d7a995708958",
			"name": "Rumble Tcheco",
			"tag": "Golpes Fodas",
			"imagem_name": "iwannabesatan-golp-rumbletcheco"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0aeecb5a-af68-4e44-9154-503d1ccd6848/cennetaespadarubra-golp-ignis.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=0657cc7423945a3b5861776fca5e219645d52b4c43c3781852c7228616f98c31&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-26T02:54:00.000Z",
			"id": "899a868e-3a11-4189-9fab-961a82e71d55",
			"comic_id": "533fbd39-5317-4dcc-a101-cc1b27d6cd9b",
			"name": "Divinus Ignis",
			"tag": "Golpes Fodas",
			"imagem_name": "cennetaespadarubra-golp-ignis"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/747992be-3f5e-42ff-80a8-0e53ab2c5617/cennetaespadarubra-exp-ooh.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=6fc6193869b7d7694f7cebf658bcdd33fd31c7f31080f4925e0ebf3f6576ca31&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-26T02:31:00.000Z",
			"id": "60dce312-b73d-4412-a59c-bc54686cfe94",
			"comic_id": "533fbd39-5317-4dcc-a101-cc1b27d6cd9b",
			"name": "ooh..",
			"tag": "Expressões",
			"imagem_name": "cennetaespadarubra-exp-ooh"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f85d9327-3c27-43eb-88b7-3eaa2e7f2648/cennetaespadarubra-golp-parumflammae.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=b5e8c7e69ce82867c1be05dad1978681d076e4bf208828d23ec96c580613ff93&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-26T02:25:00.000Z",
			"id": "bf6d6587-3438-4da0-a532-09c78ad78737",
			"comic_id": "533fbd39-5317-4dcc-a101-cc1b27d6cd9b",
			"name": "Parum Flammae",
			"tag": "Golpes Fodas",
			"imagem_name": "cennetaespadarubra-golp-parumflammae"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6d076f43-29ff-4c86-bdff-638105d1e8b9/razor-multi-faith.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ca0f0726d5db05a4e6f21427bd7f0d770891f9abef0bbec442a2b26a489f38e8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-25T23:28:00.000Z",
			"id": "d227ed95-8910-45e9-a198-c6a14d33e33d",
			"comic_id": "86199f5d-6800-4a38-9a50-e6013ab409f3",
			"name": "Faith",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "razor-multi-faith"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5fbd8120-138d-47a2-ac57-face4331da60/razor-cena-equipe.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=455f7330a44e117e117d1507b0aa8faf5222ebc5b90d5cd05668ed9b64f123f3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-25T23:28:00.000Z",
			"id": "a3a2128d-720d-4af5-aecf-40dcac5ec9a1",
			"comic_id": "86199f5d-6800-4a38-9a50-e6013ab409f3",
			"name": "Equipe",
			"tag": "Cenas Marcantes",
			"imagem_name": "razor-cena-equipe"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3b067652-2b3d-4b75-9f3d-f9fec4be6b6a/razor-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=4db13fdff471433b1fdf74502da881c073872e0d478a053f61312a3749aaa157&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-25T23:23:00.000Z",
			"id": "1fa9fc73-3d3e-4d1f-9134-98d7a992ee0b",
			"comic_id": "86199f5d-6800-4a38-9a50-e6013ab409f3",
			"name": "Razor",
			"tag": "Capas Insanas",
			"imagem_name": "razor-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/79a5a491-f9d1-4e19-a170-96f56e779e83/appleparadise-golp-shadowslaves.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ced967ca2a91e676c6e326b430523f9c9709af25ac0569619409668db9d142a6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-25T23:04:00.000Z",
			"id": "862e4a99-77ed-486e-b640-15785bc1f0e0",
			"comic_id": "a29a53a7-aafe-42b3-91d7-bb8b17cbd508",
			"name": "Shadow Slaves",
			"tag": "Golpes Fodas",
			"imagem_name": "appleparadise-golp-shadowslaves"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/85c0bbe4-0914-473a-97f5-d3becdc38341/comosetornarhumano-masc-lobinhoespectral.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=206f0c3e60b359c4c994cfbf52a0eeaba4a9a73f8780677725cd5a4aa2761a39&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-12T03:22:00.000Z",
			"id": "0b053ee5-e5ca-429f-b697-783154d0d11d",
			"comic_id": "cd1cf97e-6c92-47b3-89fd-36acfa1f3ecb",
			"name": "Cérberus",
			"tag": "Mascotes fofinhos",
			"imagem_name": "comosetornarhumano-masc-lobinhoespectral"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/82d434a2-85c7-4b1b-9e03-af7cd8b714df/desculpaeugostodevc-exp-veia.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=65a4a525bf005f1a09cdf1a3c83707e88e023b97ccebc2c5e09e52db5352d8aa&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-12T02:05:00.000Z",
			"id": "2d48b8b1-7f2c-469d-b7df-248ab2aa5e85",
			"comic_id": "96f7930f-cb9f-4a31-9d53-5dc4179f6300",
			"name": "Rie véia",
			"tag": "Expressões",
			"imagem_name": "desculpaeugostodevc-exp-veia"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/68bbe39c-6111-4ec1-b034-762a393da6b7/amalgama-cenas-boitatamapinguari.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=91f32e7278843e72801a47c3063e14e23f9b2b22089e907b203ec1d80f7253d4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-09T02:05:00.000Z",
			"id": "09721e61-5125-4a9e-be17-0b93edb63915",
			"comic_id": "bc68c49e-8609-4923-9d9f-22d9051bdb21",
			"name": "Boitata x Mapinguari",
			"tag": "Cenas Marcantes",
			"imagem_name": "amalgama-cenas-boitatamapinguari"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c7835a54-0260-4f72-b14c-8ba19761812e/redghost-char-shiro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=73edd1a51f20fb1e6ac5d86e696a7766629e01f1b7191d2f50c5068908b8790b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-08T21:17:00.000Z",
			"id": "4e09a762-00d5-42ca-96d6-465a22060529",
			"comic_id": "b0367733-af29-4113-8dfc-e6ffb79e5a3c",
			"name": "Shiro",
			"tag": "Personagens Maneiros",
			"imagem_name": "redghost-char-shiro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0294f7e2-0f36-413d-89a4-d3905ff404c8/redghost-exp-choro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=cb69d2ab1174cf4bcf83fd92478ce71e8fa716f8f72e679e96e3270c73d8d70f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-08T21:14:00.000Z",
			"id": "c56dae39-496d-43be-9d68-9bd2a6c6f546",
			"comic_id": "b0367733-af29-4113-8dfc-e6ffb79e5a3c",
			"name": "Chorinho",
			"tag": "Expressões",
			"imagem_name": "redghost-exp-choro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/60b5bfab-f3ed-4f2a-b639-0c60a342d6d8/troublemakers-exp-digubanori.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=ef310acf2b2a2f48922e042f32ab6cef1f7a12c762639177aed696986aa46326&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-08T21:12:00.000Z",
			"id": "a7c87306-de9f-495e-b1c4-00a28a8be59d",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Diguba",
			"tag": "Expressões",
			"imagem_name": "troublemakers-exp-digubanori"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1af1b3f8-5987-419b-9c5f-6712995fbbb4/troublemakers-golp-hellgrab.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=9be9beafe5b586265a22547f827a3147fcb34972744602bb348914b9d62d13e4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-08-08T21:11:00.000Z",
			"id": "af33b81c-6c65-4d27-a67a-23fe8ab28f73",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Hell Grab",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golp-hellgrab"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1aca14b5-c21d-4e66-839c-7884d39bd124/fatalabruxadebeliverde-onom-blou.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=de0589af3c6bd0a8353ab3e7c695b31c90eed80f8b4801adbb3a5e7f90a86261&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-26T02:14:00.000Z",
			"id": "d18c1201-10a0-44a3-ba12-e061b2d8d714",
			"comic_id": "f5414002-efb6-45bd-b80f-296dee47d279",
			"name": "BLÓU",
			"tag": "Onomatopéias",
			"imagem_name": "fatalabruxadebeliverde-onom-blou"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2d6f5f6d-25fb-4fde-80e0-200375f8c3ae/fatalabruxadebeliverde-cenas-asurradabruxa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=f9ad26e1c14723c149ebff09e19117135b318996c54733cb30e75111deeb9406&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-26T02:13:00.000Z",
			"id": "d34ede2b-f44a-47fb-8e03-f0775d56e18f",
			"comic_id": "f5414002-efb6-45bd-b80f-296dee47d279",
			"name": "A Surra da Bruxa",
			"tag": "Cenas Marcantes",
			"imagem_name": "fatalabruxadebeliverde-cenas-asurradabruxa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ec671fd6-419b-4640-bd72-d90082d09aeb/jonasoquasemago-exp-jonas.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663TXXA6C4%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232845Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIAVoOIEMVbDq%2BMK9rWsgQ4GXf2g4Vw2h1M%2FdQEHLlPwcAiEAinqgL166EZ7bTwKqLUckOhps7ENO6XBQv6fD6LllvyoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDEp66PC7TEGWV1YfoCrcA%2BpdpzLwErHgLo%2FZIr%2F%2FDwckk%2FHrRjmJ5cuglAwXDDG1FplM1Chv9hUK8EKZEgSQ2pTt9bLxLnKvZV4DI%2FS%2FeNEfgbngblLsZlMADvy1L0er4l1bcrfpXejtaq1csTUJTO4aGEp7cJ1qyBHCTQQe72TNCSPWmXFsn0XuI1n7FcOgZurH7trEWVI2WNq1376BJaVh67MkWClod61xbJR7LXnWqKbxbLdQ1qzB2%2BV7xxUYH%2FEdLV1r9tKZXzz5lm6zVWdyjgvOmub9H9IpeDAgDZfoRVjFTS%2BZrpWLOYCltM1EKbEBnmg1oOfEDn%2FRuCrl783XN8%2BkB9F3eOQY%2BBgzI9DctLdtQP0XuCfsSFuVpafl3CW4OH8hPXPpLbcZe7CrNCLpcpjxditHT7vU3cii9XmJMcGgea3xwXa69%2FahJWSFewe1qtK5XlUtoy31q27bTvgiTWQWPL6uWHANoaewnFz5%2BJtW52nrF1LXEDOtnOXobmxGfCDJHoz33%2FX3ts%2BVJfTjIdHEA3nyGi%2BqBUL24u%2F2On7dO685WiK6KOyLnhm2It6%2FhDZG%2FLFvVLEvdMx7%2FBezzml2Wf%2FM%2FO7LtDTop5gdtLhroKiLyyhbrUXag830IgjRTf6tLmlME1RCMJy5q78GOqUB7LLaxOddyffibleDeYEJHBLNwA%2BQmRB9WQYerUwxF%2Bm7uLUxMyvzK8TQZlPdXtI%2F504E9GjUanUFuwB0gvnUK58ggs8EzjOT6O1KfP%2FXBPsT6oSBB%2FAuoV65ozWSYbk0zAWSZdZzIQfn9In9yaAAfkzI6qkEqVd07B1v92UwBh5ilf1c4HeMBN9tB9RHPfN0qA27vhbIjr3ipviOYH0aqWXU3faR&X-Amz-Signature=730ffe413c2fcc73b24a948426d138aa60f59fd65d09f7ab735b628bc7812613&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-25T18:56:00.000Z",
			"id": "5f75d3fe-60ee-4b19-a810-58526fce677c",
			"comic_id": "2436fab4-4346-4401-bac8-f96336b28df0",
			"name": "Jonas",
			"tag": "Expressões",
			"imagem_name": "jonasoquasemago-exp-jonas"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ac8174a6-19d0-4b84-9690-0d03eb04f03e/jonasoquasemago-mascote-coelho.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=bbf17344132f1f9a652ff2524942369a810e8dc943da8a6a87b111d65618653c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-25T18:55:00.000Z",
			"id": "b5c96b62-939d-4d34-b80d-8fd410cc3d6a",
			"comic_id": "2436fab4-4346-4401-bac8-f96336b28df0",
			"name": "Coelho",
			"tag": "Mascotes fofinhos",
			"imagem_name": "jonasoquasemago-mascote-coelho"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/867fce99-a229-4315-8ec3-130f5c9d0931/magh-artef-luvadeinvocador.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=807122b06ac2f4914b93c39ade4179cdccd500a11c00c3d8c4bbc38993e2444a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-19T02:47:00.000Z",
			"id": "ef19365a-a003-4043-ba38-311cdb3937a4",
			"comic_id": "1ee0fa67-fbec-42fc-b605-35a3db69617d",
			"name": "Luva de Invocador",
			"tag": "Artefatos Lendários",
			"imagem_name": "magh-artef-luvadeinvocador"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d6c20f66-7712-4a5c-82b7-a266cd5e215c/magh-arted-espelhoroxo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=f11ce0fa3e4abcbd9aee7e66070d51c6218cd3488dc9c4cd00d0f5635e6fe6f7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-19T02:46:00.000Z",
			"id": "ed9d8ecd-4d53-4b6a-9ed4-6ea818102aa3",
			"comic_id": "1ee0fa67-fbec-42fc-b605-35a3db69617d",
			"name": "Espelho Roxo",
			"tag": "Artefatos Lendários",
			"imagem_name": "magh-arted-espelhoroxo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fe1a96d1-0022-4114-9247-7961ee9b07ff/larvas-hq-2finados.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=0c70a02c569d7b548d7d7bdd3d967bcb99b33824e84e54ab432d56e58cdef17e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-07-15T02:10:00.000Z",
			"id": "ff87aa33-106b-4ff0-a44b-ac2909b10da5",
			"comic_id": "b654bda0-baec-41c7-97c0-aae86150e79d",
			"name": "FINADOS - Cap 2",
			"tag": "Capas Insanas",
			"imagem_name": "larvas-hq-2finados"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/19609c36-4d7a-41c2-aa42-21fa00ab042f/arthureosol-artef-guardachuva.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=14d5d5f3dca29e7db780f14deca0c756264070d6d244f14c64abe1a191773fc7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-27T22:16:00.000Z",
			"id": "f0101032-9c79-4133-a5d9-6b0663bb1ebe",
			"comic_id": "17397722-d811-4e0a-a42b-11d7fdd5f0c0",
			"name": "Guarda-Chuva",
			"tag": "Artefatos Lendários",
			"imagem_name": "arthureosol-artef-guardachuva"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/27e5b086-e92a-4dff-bf6e-e5690ff7d9d8/arthureosol-golpe-goldensun.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=2b1afab3f2a20c57e8bbee21d3f5a4c67d9f2d400c544cc92abeb1a00eb282cf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-27T22:15:00.000Z",
			"id": "4c8ebfaf-ef4c-4bbc-999d-089e78e2f0fe",
			"comic_id": "17397722-d811-4e0a-a42b-11d7fdd5f0c0",
			"name": "Golden Sun Ace",
			"tag": "Golpes Fodas",
			"imagem_name": "arthureosol-golpe-goldensun"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/da04e607-c6d6-436e-9a9c-d233a382d269/arthureosol-golpe-crimsonwave-png.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=987b77b4454ea66505e6ebe14521387650bd4b1392286231ef454be2469ced51&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-27T22:15:00.000Z",
			"id": "3dff50c3-2671-48ea-a151-fb5012d785c6",
			"comic_id": "17397722-d811-4e0a-a42b-11d7fdd5f0c0",
			"name": "Crimson Wave",
			"tag": "Golpes Fodas",
			"imagem_name": "arthureosol-golpe-crimsonwave-png"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1893d7b0-fbf5-4279-a313-8b216ed42c56/amon-artef-aneldefogo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=06f4b9dbbb9558f14ae6e10e27fbb7cd17ce0fd421bbe767c27e1404da8066eb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-27T22:13:00.000Z",
			"id": "cae17e9b-b304-4b26-8067-5b623f18718d",
			"comic_id": "6d134d6e-f741-44e9-b7ed-943a14d6a1fb",
			"name": "Anel de Fogo",
			"tag": "Artefatos Lendários",
			"imagem_name": "amon-artef-aneldefogo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/db929377-4bb1-4d85-a8f1-7f91fc35f8ce/amon-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=bdfde4a2d6a114964f299f4e31cb2c9c999b011865f3c9af996399b8647db756&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-27T22:12:00.000Z",
			"id": "6afc8001-50d1-48f3-95fb-9f5be3d79ca0",
			"comic_id": "6d134d6e-f741-44e9-b7ed-943a14d6a1fb",
			"name": "Amon",
			"tag": "Capas Insanas",
			"imagem_name": "amon-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9e86d1ea-8e6a-4440-94cb-08d3bbef38ed/amon-cena-amon.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=e3846b6dbdd729c6872a3e0d9f33c5cd11dcb9b4dcc155b562f4a968cd5b5f73&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-27T22:12:00.000Z",
			"id": "eb3d1423-7f9d-4a51-a435-df0a9282e9e9",
			"comic_id": "6d134d6e-f741-44e9-b7ed-943a14d6a1fb",
			"name": "Amon em queda",
			"tag": "Cenas Marcantes",
			"imagem_name": "amon-cena-amon"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/81c28803-88e5-46dd-81da-935188a2c20a/junhonaojuno-ship-danielejuno.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=a321b57f9c7bedd773f28cfcb9bbd9c1cb7186f8f8de93066f57f115de278015&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-14T02:36:00.000Z",
			"id": "863cac4a-59e5-418a-be3e-887671b7b690",
			"comic_id": "40e9af8f-7ce5-470b-bcfd-720cdeb03728",
			"name": "Daniel e Juno",
			"tag": "Shipps Fofos",
			"imagem_name": "junhonaoéjuno-ship-danielejuno"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/27e5bcc1-0a8f-4e3f-9b9b-cca5386985db/junhonaojuno-exp-seentregou.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=3b22680374e53198bf25a76bfa8bfdf835202fdd2bb4547aef2f7cfe1a19ce27&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-14T02:35:00.000Z",
			"id": "55a13e53-3abb-4e34-964a-aa26bf78dd43",
			"comic_id": "40e9af8f-7ce5-470b-bcfd-720cdeb03728",
			"name": "Juno se entregando",
			"tag": "Expressões",
			"imagem_name": "junhonaoéjuno-exp-seentregou"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/eeeb4903-8857-47b4-b1ec-aa8ae2f7de2a/thegoatwitch-masc-duck.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=06ece8e8a30477e4e14c7e1bf3b2a119482b82387b1973151275b3fdc1e4c9cd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-10T02:29:00.000Z",
			"id": "40e4342b-9935-4f43-8127-daf8dc080591",
			"comic_id": "141d6abc-ac27-43f5-8a1d-425fa86bdc74",
			"name": "Duck",
			"tag": "Mascotes fofinhos",
			"imagem_name": "thegoatwitch-masc-duck"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ee0ec971-de20-4f99-b8bf-ff8916b83a0e/thegoatwitch-char-valerie.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=663277fd1d119cfa6ec8dec1505a030f438ee75222a5533a1acfd8e8484cca40&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-10T02:28:00.000Z",
			"id": "083d74bb-7662-4bd8-af35-248f7fe86ba9",
			"comic_id": "141d6abc-ac27-43f5-8a1d-425fa86bdc74",
			"name": "Valerie",
			"tag": "Personagens Maneiros",
			"imagem_name": "thegoatwitch-char-valerie"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c5d6d96e-5b94-426b-b14a-d6b54aaf2136/metalmancer-char-vitria.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=0690c40d1e2c95c948096913e256ece451db189344aa9101a2fe81015c8a0187&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-07T03:02:00.000Z",
			"id": "e87d17b4-85e9-446d-8429-8899f3688d6e",
			"comic_id": "68c391e8-079c-49ef-9996-e441b8e06ef4",
			"name": "Vitória",
			"tag": "Personagens Maneiros",
			"imagem_name": "metalmancer-char-vitória"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/aec04d1f-7e7d-44a5-b25f-9cdc42444dfb/metalmancer-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=33bc5a66b1a6a7f6e8b2c1ac97a309d6fc8cd2ab1dfcec813cfe786133907b3e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-07T02:41:00.000Z",
			"id": "82de2f4d-cb19-460c-b2ef-b881ff0197fc",
			"comic_id": "68c391e8-079c-49ef-9996-e441b8e06ef4",
			"name": "Metalmancer",
			"tag": "Capas Insanas",
			"imagem_name": "metalmancer-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c46c6a3b-cccb-44b8-a339-04c86299ec23/apervertidaeovirtuoso-cenas-bloqueio.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=c67223ce0b7c775796729866ec6b80a1d583fbf5dc4ae802efda9193e22a9977&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-06-07T02:21:00.000Z",
			"id": "779d9667-5685-4af8-be39-d10123e459ab",
			"comic_id": "7ee95af4-ded0-46d9-891f-0e4cbca7de4d",
			"name": "Bloqueio!!!",
			"tag": "Cenas Marcantes",
			"imagem_name": "apervertidaeovirtuoso-cenas-bloqueio"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e6b0ac52-dec3-4d92-b3fe-79f481c8c3c0/magh-multi-horrortales.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=d23d969aac31ee9c6d05f2614a8efbbf3a6382fbd0364fd283a0deae3f484cd2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-05-24T03:36:00.000Z",
			"id": "b16591e8-1911-406e-bfa3-b65bf190ae08",
			"comic_id": "1ee0fa67-fbec-42fc-b605-35a3db69617d",
			"name": "Multiverso de Horror Tales",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "magh-multi-horrortales"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/97093355-8488-45b2-a21f-25683ceeb6df/persefone-lugar-novolar.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=a14787448b28f74c8a0734148dd64059483782946abc66fdf72d48d2c560e2e7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-05-06T02:54:00.000Z",
			"id": "5245cd53-e74b-426d-991b-48c0ab6c04d7",
			"comic_id": "bfa103ea-925f-4386-9ebf-11ab376460a1",
			"name": "Um novo lar",
			"tag": "Lugares Irados",
			"imagem_name": "persefone-lugar-novolar"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a0141d08-ba82-475f-951f-247cca3faa2e/arthureosol-capa-5.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=29c9872cd73c47cf3e12ec801ab6e4c67affd9020915f8993a25fb1e20e0f449&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-29T14:01:00.000Z",
			"id": "f49eb97a-4951-4c66-80eb-c80e2aa73a26",
			"comic_id": "17397722-d811-4e0a-a42b-11d7fdd5f0c0",
			"name": "Arthur e o Sol - 5",
			"tag": "Capas Insanas",
			"imagem_name": "arthureosol-capa-5"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fc0e0059-1a41-46db-a5ee-a56c72009a6a/mellohi-mult-lqn.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=e8635f5fa734181fb65c689e21b41be83714e7db1b79679a2ac10aa043cfbf00&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-28T14:38:00.000Z",
			"id": "36ac92d6-3087-41c2-b83a-dfc2de3d4cb6",
			"comic_id": "2969ddcf-cefd-4cc5-9417-c1e1b4147094",
			"name": "B, Rapha e Duh",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "mellohi-mult-lqn"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/706ea4d6-3200-4935-969d-cf1e7aadcf0a/soulmates-ship-monicaeheloise.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=c9e508964aa7e4e36bbc5af38e00b10334bddd5c2d91f4b84d3247c20c1daef7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-28T14:21:00.000Z",
			"id": "a662a0b3-5283-4ec8-b675-b476b406b2d2",
			"comic_id": "a9839e64-e156-4b1b-be04-a7ab157b45e8",
			"name": "Mônica e Heloíse",
			"tag": "Shipps Fofos",
			"imagem_name": "soulmates-ship-monicaeheloise"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6f6c25a2-aaec-422e-af5b-95ae2cfb4639/soulmates-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=2b50248ddb70f0efc9f968383738094d29f11bcde22f30cba5ef4cb45f604086&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-28T14:13:00.000Z",
			"id": "8e4d4233-cec9-4dc5-a51a-7c7199090965",
			"comic_id": "a9839e64-e156-4b1b-be04-a7ab157b45e8",
			"name": "Soulmates",
			"tag": "Capas Insanas",
			"imagem_name": "soulmates-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/10261bff-b038-404a-ab2f-87f82d3789c1/inspirao-cena-acorda.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=8f449ad1595ef8e039a231ab750dc3488e1c127397e75c2d3dae1d7355d67023&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-28T03:28:00.000Z",
			"id": "7ab1aa9b-b9d5-480e-9ec3-dad23343a06f",
			"comic_id": "50618aaf-f798-4749-acf6-02b57f74e0bd",
			"name": "Acorda!",
			"tag": "Cenas Marcantes",
			"imagem_name": "inspiração-cena-acorda"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/155f52cc-173a-4f9d-9c5e-22ec3f8e2397/ainsurgenciaceleste-exp-kaiemchoq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=94fe37321ccb013e75a74c09bfb4456cfef81e781ddec163a47aecc2320843d6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-28T01:06:00.000Z",
			"id": "5648575c-2c60-4673-b380-7b60fb4a534f",
			"comic_id": "f37b3e11-ecf3-4c6b-be20-8da070592520",
			"name": "Kai em Choq",
			"tag": "Expressões",
			"imagem_name": "ainsurgenciaceleste-exp-kaiemchoq"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c84bdf46-eca6-493b-b10a-482731709c63/meuamigogelado-cenas-inverno.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=ac6e11bbe8e30927186f4e54d26a7472d4f4c1ad885e7526b081f43650f0c214&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-28T00:46:00.000Z",
			"id": "c7b96ce1-8fbe-4aa3-b1b1-5b5c39c8ad8d",
			"comic_id": "3ad3b7c2-9117-4517-b3d9-6923ca234821",
			"name": "Abraço Quentinho",
			"tag": "Cenas Marcantes",
			"imagem_name": "meuamigogelado-cenas-inverno"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bd965a41-c7cf-4df0-bc6e-80d56c43d9fc/magh-capas-3.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=3754c1a99652b24060562871568e13b231d41a985317303acc9b752c16924e06&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-27T23:26:00.000Z",
			"id": "dfc91726-eda4-48c0-96fa-9591bb3355b4",
			"comic_id": "1ee0fa67-fbec-42fc-b605-35a3db69617d",
			"name": "Magh - 3",
			"tag": "Capas Insanas",
			"imagem_name": "magh-capas-3"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0d0ba998-2a8d-4c6e-a848-2e2353da56be/orca-masc-orca.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=2aa868eef94b89ae19608c80d2462aeee1d719b2bca6ad215b107d6488587164&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-27T21:07:00.000Z",
			"id": "ff911cea-daba-463d-9a9f-270f67f1c9b9",
			"comic_id": "491b817b-61c5-484e-8c98-247559e01468",
			"name": "Orca",
			"tag": "Mascotes fofinhos",
			"imagem_name": "orca-masc-orca"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/07842951-2bac-4713-b87d-97a1a2ebd8fb/orca-char-sereioorca.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=eb8b8301c84e2c76ac469b8bc5a3ded9ed8870f9b3a6791f3b3f37f256afa93d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-27T21:06:00.000Z",
			"id": "c63afaf9-96bd-4bb6-a693-1ab1e4e43b0b",
			"comic_id": "491b817b-61c5-484e-8c98-247559e01468",
			"name": "Sereio Orca",
			"tag": "Personagens Maneiros",
			"imagem_name": "orca-char-sereioorca"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c8581263-78b0-438b-948d-34271237362d/suriblade-cena-turblihao.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=c363b68c5a3fca00185026a8977acba5f2e860506ddda7733260ad13417de694&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-27T17:22:00.000Z",
			"id": "10233ade-a4fe-44cf-91f3-4786dfdef25d",
			"comic_id": "839ca949-368a-4dfb-91f3-f261904ddfdd",
			"name": "Turbilhão",
			"tag": "Cenas Marcantes",
			"imagem_name": "suriblade-cena-turblihao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ddbecb14-f23a-47d9-b450-2913b9515bca/oretratoinacabadodemadamebardin-ship-francinecharlotte.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=0e2a26e06ff2846fa5afdf9c29829a86baf63c498ee05e034319d6e24b0bab37&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-26T02:40:00.000Z",
			"id": "2193b2cd-97af-4225-b852-2e5d5df96f24",
			"comic_id": "5f412d82-407f-41b4-85ee-47aa0d4812a8",
			"name": "Francine e Charlotte",
			"tag": "Shipps Fofos",
			"imagem_name": "oretratoinacabadodemadamebardin-ship-francinecharlotte"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/09fc9dd9-c1bd-40c2-8cd0-8d833e03b7e6/matandoaula-ship-bastion.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=64b8d3990054e464e1425710e6b59ee9f28d1b8175019c134ed34ed0c1f060ce&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-22T02:29:00.000Z",
			"id": "74f2321c-3e62-4fcd-aad7-6e33a1515271",
			"comic_id": "0dc5816f-17e3-4893-b75b-f738fb7c55d2",
			"name": "Bastion e Mark",
			"tag": "Shipps Fofos",
			"imagem_name": "matandoaula-ship-bastion"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1795991f-5f8a-48df-aa04-0eca25e1a7fa/juquinha-cena-viagemaofundodoego.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=ca5a2ca409ba9f96a7013df83240aa8165974aacf369502827a78810acd4cfa1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-19T02:56:00.000Z",
			"id": "76372f06-4c90-42ed-9b32-a13b9915c2dd",
			"comic_id": "9eaca292-6456-46c5-b37e-d2addadc380c",
			"name": "Viagem ao Fundo do Ego",
			"tag": "Cenas Marcantes",
			"imagem_name": "juquinha-cena-viagemaofundodoego"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4e4debe3-b12c-4939-900a-df5fd7494b70/toolschallenge-golp-socao.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=293d6025bc441802a451ee1b6fcd4941250da88b442cd7d10fc9e2064457ba63&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-19T02:32:00.000Z",
			"id": "597f7eaa-6c70-4086-943f-c2db94594f36",
			"comic_id": "93159c36-f24d-4328-848b-e25273994629",
			"name": "Socão do Raion",
			"tag": "Golpes Fodas",
			"imagem_name": "toolschallenge-golp-socao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/660b0b79-704c-44db-bbf3-478b71b82aad/comosetornarhumano-char-nonia.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=7a0177ccd9a6f7172bcffa15e2777848f983f42990ce0470ae778c1f36b91b46&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-12T01:42:00.000Z",
			"id": "3169a99b-a772-4faf-82cd-05bdad53cf94",
			"comic_id": "cd1cf97e-6c92-47b3-89fd-36acfa1f3ecb",
			"name": "Nonóia",
			"tag": "Personagens Maneiros",
			"imagem_name": "comosetornarhumano-char-nonóia"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bee0e91a-a9c3-4d80-85af-65c6f57ea957/contosdosamuraidamontanha-cenas-oultimodesafio.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=cb2ed802632a3b6160293c4a888bc0eb117dd02ff1d0490a1f76b524ef4c3357&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-11T22:59:00.000Z",
			"id": "0158b5ee-8b5d-4b92-a3a2-505c2502f063",
			"comic_id": "90de0867-ec3d-40e8-9be7-6422eca33881",
			"name": "O Último Desafio",
			"tag": "Cenas Marcantes",
			"imagem_name": "contosdosamuraidamontanha-cenas-oultimodesafio"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ae262587-8590-4942-98bd-ebddce669751/nubentes-ship-helenaetobias.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=db2a45f03be8497ce858a0d7a7cba2d90bc7125ed893b462402e6db946420bd9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-05T03:11:00.000Z",
			"id": "9639042e-141b-4933-bc92-2208e3cc39fb",
			"comic_id": "f8cc7553-233f-47c6-967c-8259085e5708",
			"name": "Tobias e Helena",
			"tag": "Shipps Fofos",
			"imagem_name": "nubentes-ship-helenaetobias"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/72b280cc-55c8-48cf-a79d-71f28e655357/bacecemena-exp-grvida.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=7a245a437eab669dc77573a7bcfbbcc48030edc240d2209517e0ab1b6ebdbc60&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-05T02:35:00.000Z",
			"id": "29d8d4e7-1507-4400-9613-8cdb4e593bae",
			"comic_id": "e413cb87-0f8b-473d-b4d8-3b068b77c132",
			"name": "Grávida",
			"tag": "Expressões",
			"imagem_name": "bacecemena-exp-grávida"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4ffcc9a8-0580-4c24-b8bf-ded62bc2426c/bacecemena-cenas-batalhadagravida.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=bba230ca200c144bffafc6445171f88fbd9205e0ea86430156aeeded992b320e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-05T02:33:00.000Z",
			"id": "0a1eacf8-dd5d-44ea-8728-25a90ac3a900",
			"comic_id": "e413cb87-0f8b-473d-b4d8-3b068b77c132",
			"name": "Batalha da Grávida",
			"tag": "Cenas Marcantes",
			"imagem_name": "bacecemena-cenas-batalhadagravida"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4ed0abe3-b4f9-49c7-aca5-8e8123c9ad3e/cennetaespadarubra-char-aylla.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=57e96634fdae364b3a7cba50004700c9dea2b9f431bdc3b1464b9f1bc4b50c67&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-01T02:38:00.000Z",
			"id": "93ea8b78-70ed-4062-a292-413a06e938fe",
			"comic_id": "533fbd39-5317-4dcc-a101-cc1b27d6cd9b",
			"name": "Aylla Legorn",
			"tag": "Personagens Maneiros",
			"imagem_name": "cennetaespadarubra-char-aylla"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d3982219-25f0-4fbd-9414-7f8a904b5d45/cennetaespadarubra-exp-moa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=e22896b7bbdf2ec7158e6a3734933f039f7f3484d25463ab5f6931af96190ae8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-01T02:16:00.000Z",
			"id": "44922cac-fc13-4870-aa0f-a1d2577d7778",
			"comic_id": "533fbd39-5317-4dcc-a101-cc1b27d6cd9b",
			"name": "Mulher desesperada",
			"tag": "Expressões",
			"imagem_name": "cennetaespadarubra-exp-moça"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/55c99710-d871-4db6-a0ad-34a6aac995a3/cennetaespadarubra-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=498bbd64cb34ef24b8adea611540026abe23b2b3681383067bd4bede8ff238b5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-04-01T02:01:00.000Z",
			"id": "95654a9d-db66-4542-98a1-4579f4524635",
			"comic_id": "533fbd39-5317-4dcc-a101-cc1b27d6cd9b",
			"name": "Cennet: A Espada Rubra",
			"tag": "Capas Insanas",
			"imagem_name": "cennetaespadarubra-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/37d79439-a08c-4c52-abf1-404c52c735e5/animus-char-almaemchoque.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=7792a421ba7bd656f2305f72d313a6624786df9110af76eec3dc78f830831ea1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-29T13:52:00.000Z",
			"id": "5dc62134-53ee-4534-bb47-8e59c6fcdffb",
			"comic_id": "ec7eda0a-6954-46f7-9bb1-90e67fcd8b2b",
			"name": "Alma em choque",
			"tag": "Expressões",
			"imagem_name": "animus-char-almaemchoque"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e59e8f24-ef2e-469d-be3d-8fb2f1af3047/animus-lugares-templo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=eb5ddc2d20fcd79ec9a2f29c4a74feeb4501669a80f89d1dfd8ba6bbdfefe155&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-29T13:51:00.000Z",
			"id": "39d0198a-e5e3-4e6b-b558-81a60e53e581",
			"comic_id": "ec7eda0a-6954-46f7-9bb1-90e67fcd8b2b",
			"name": "Templo",
			"tag": "Lugares Irados",
			"imagem_name": "animus-lugares-templo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/aaa14503-7c8b-478f-b73d-cab6c65458d8/iwannabesatan-onon-tcheco.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=6976fe5b2c0edf75d0139522a9213f5af29b089e28cf2f780da941429af2a836&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-25T01:49:00.000Z",
			"id": "a14d1bfe-7c45-4e3c-b8b1-9b4b63073f50",
			"comic_id": "4b5542d2-b1f9-4d5c-8102-d7a995708958",
			"name": "Tcheco",
			"tag": "Onomatopéias",
			"imagem_name": "iwannabesatan-onon-tcheco"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b0530b75-6e92-46b8-a2d1-bb034519abbd/iwannabesatan-multi-superfightingheroes.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=b43f614d1591a15404923e0baf7d602dd66f8082048d5d958118c896b92cfc5d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-25T01:40:00.000Z",
			"id": "afc4306b-0ecf-4f4f-8363-be46ef8a701b",
			"comic_id": "4b5542d2-b1f9-4d5c-8102-d7a995708958",
			"name": "Protagonista de Super Fighting Heroes",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "iwannabesatan-multi-superfightingheroes"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4834e6fb-51ca-430a-80f7-4f509b825ded/iwannabesatan-lugar-stworld.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=c98e25bca86e5602fb2b029960524f9ac3b9839faf0cda96f64ae0c130ea4359&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-25T01:35:00.000Z",
			"id": "dff6353c-9e3b-4e8f-80f3-9ef6d07dcaaa",
			"comic_id": "4b5542d2-b1f9-4d5c-8102-d7a995708958",
			"name": "St. World",
			"tag": "Lugares Irados",
			"imagem_name": "iwannabesatan-lugar-stworld"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e2aac648-e177-4f4c-a448-30479f5eecdc/xeretive-artef.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=4ba2d3cd9708f26fc3dda69d7d8a53403de3ebaf66cb61b9f6d7fb4397142f1d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-23T01:53:00.000Z",
			"id": "6197d094-6ce4-4658-8866-baa98aecc8e4",
			"comic_id": "1e33ae79-8ada-4c0a-89ea-7aa31a2eb053",
			"name": "Artefato",
			"tag": "Artefatos Lendários",
			"imagem_name": "xeretive-artef"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d631e6e2-5042-4af8-9c67-1533f31cdf8c/xeretive-exp-ivy.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=8c30ee71a2cc08dff5e02224bfc114eeeb2be6c853b5988263acbfc607320e05&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-23T01:52:00.000Z",
			"id": "a7215026-73df-4f9e-8e2a-c50bb2b6c686",
			"comic_id": "1e33ae79-8ada-4c0a-89ea-7aa31a2eb053",
			"name": "Decepção da Ivy",
			"tag": "Expressões",
			"imagem_name": "xeretive-exp-ivy"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/334cf56e-43f9-4566-bcd6-97f27da80f27/xeretive-multi-reidelatasenselifepinpong48km.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=6129e80917f43e84b0d4d124d1b076ccfcd1017f3e2b276c358c125781e31459&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-23T01:22:00.000Z",
			"id": "81e53e58-87c2-4227-92f7-e87717ad93bf",
			"comic_id": "1e33ae79-8ada-4c0a-89ea-7aa31a2eb053",
			"name": "Figurinhas de Rei de Lata, Ping Pong Drama, Sense Life e 48km",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "xeretive-multi-reidelatasenselifepinpong48km"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/636bca55-a02d-48e5-a81f-c0d6b49aaa41/xeretive-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=c942c761d2907a74f0d76ca2856b4e1b68d2b8cbc31b45f721cac60aa743869d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-23T01:12:00.000Z",
			"id": "c94a0193-6b19-40f8-b012-66eb02826e7a",
			"comic_id": "1e33ae79-8ada-4c0a-89ea-7aa31a2eb053",
			"name": "Xeretive - 1",
			"tag": "Capas Insanas",
			"imagem_name": "xeretive-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/34972ea1-30d7-4ce8-ba4d-0fb793baed03/contosdosamuraidamontanha-lugar-dojo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=c29a1dc1e1f8f7c1ba78a9f85be6cc44c65e60404c52a8f1c1b6e572ed8d2e60&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-19T22:39:00.000Z",
			"id": "276da701-a6d5-47a0-a915-53eefec7343b",
			"comic_id": "90de0867-ec3d-40e8-9be7-6422eca33881",
			"name": "Dojo do Samurai da Montanha",
			"tag": "Lugares Irados",
			"imagem_name": "contosdosamuraidamontanha-lugar-dojo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/34e18d82-4fd5-45a7-bd75-3f26c082beb9/lebreecoelho-ship-leonejimmy.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=970895b5cec5c656c234e1c947ead23b7f30322610b48218ec38a2155768f0de&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-04T12:45:00.000Z",
			"id": "2914e824-0b67-427b-99e4-c039ade8665c",
			"comic_id": "272aef3d-5fcb-4628-914c-ab7c3e2bfbfa",
			"name": "Leon e Jimmy",
			"tag": "Shipps Fofos",
			"imagem_name": "lebreecoelho-ship-leonejimmy"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8903bc1f-aa62-4413-911b-b7a2b3d33d18/oscontosdosamuraidamontanha-char-mestreshin.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=2b91af4654b7999f5be07f13f9adf48624bda0ea97a157a13027edf0b7f558ae&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-04T12:11:00.000Z",
			"id": "67a28d95-f7f5-4208-9d1a-d6553e425466",
			"comic_id": "90de0867-ec3d-40e8-9be7-6422eca33881",
			"name": "Mestre Shin",
			"tag": "Personagens Maneiros",
			"imagem_name": "contosdosamuraidamontanha-char-mestreshin"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/33ff6c86-3d17-4c4b-a639-287478e17aae/magh-char-rainhahel.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=aad87829ebee025ab7ff0643ae4a1f3615fc04c257b802d2a4e0e2f8f19b5771&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-03-03T22:44:00.000Z",
			"id": "5dab6322-1350-4a43-8fa8-bb1240fd7971",
			"comic_id": "1ee0fa67-fbec-42fc-b605-35a3db69617d",
			"name": "Rainha Hel",
			"tag": "Personagens Maneiros",
			"imagem_name": "magh-char-rainhahel"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/55bb9324-5cf9-45ec-82c7-cc639d278d4d/mondolis-artef-espada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=0326af44d767ea6f008b72e2798d2a758b346432506c48f063d5b0eac7a4310f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-28T02:32:00.000Z",
			"id": "963fd51e-7e8b-40c7-bee8-56b621ba395f",
			"comic_id": "6e8f55a1-5d20-424d-9b89-d47adcabf13e",
			"name": "Amutait",
			"tag": "Artefatos Lendários",
			"imagem_name": "mondolis-artef-espada"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0b0cdcd0-0fa7-4dc3-9893-270b95be6b76/mondolis-cenas-nills.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=3d2df53bf793cbb2192608d8297a4856c553828af8c2ee1e8e70bebde6adf85a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-28T02:30:00.000Z",
			"id": "3a33318c-bd5a-4ffa-b6bb-7acf13188db9",
			"comic_id": "6e8f55a1-5d20-424d-9b89-d47adcabf13e",
			"name": "Nills desesperado",
			"tag": "Cenas Marcantes",
			"imagem_name": "mondolis-cenas-nills"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a2615f63-5097-478e-a228-45adcfd51c9e/asentregasdejunior-masc-pitoquinha.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=e84a70975ad583620a4cf956e71fd75d1ad1237bf66a02c8a18a4308a52d87f5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-28T02:17:00.000Z",
			"id": "3f0b6646-470d-44ab-a1c7-e35541676d1c",
			"comic_id": "96ddc133-25d1-4d38-b470-10eb25d1208f",
			"name": "Pitoquinha",
			"tag": "Mascotes fofinhos",
			"imagem_name": "asentregasdejunior-masc-pitoquinha"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9e47e78b-c6dd-45ed-843d-924239809201/mondolis-lugar-sylseeq.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=86d27bde65e87be187ad559f95c4f3b5357f74ac166fe6d4e0de0fdf85a4be01&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-28T02:15:00.000Z",
			"id": "cb00fb8c-e453-49ed-8d62-02986b376c78",
			"comic_id": "6e8f55a1-5d20-424d-9b89-d47adcabf13e",
			"name": "Sylseeq",
			"tag": "Lugares Irados",
			"imagem_name": "mondolis-lugar-sylseeq"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ce0a9f28-a5cc-4213-94c0-2c691be5a622/fraternidades-lugares-guaruj.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=2a4412640fbc45d57aee4f19412b5771e97da8701f69e760c9f82a0e623be3da&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-16T01:54:00.000Z",
			"id": "a22713d5-fce3-426f-af00-dc06d683a67f",
			"comic_id": "3b8056dc-0008-45da-942e-3bb6b2da78f1",
			"name": "Guarujá",
			"tag": "Lugares Irados",
			"imagem_name": "fraternidades-lugares-guarujá"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/29b03e79-b6ba-4816-9096-c5b891bda93c/diascinzentos-cenas-chegadadoheroi.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=3a3e587e39b081f666c0e168f460ee4a87251fa8c95705ab60dee99450faed05&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-12T02:32:00.000Z",
			"id": "c1e697eb-5923-48e5-95a6-3db16ee068f2",
			"comic_id": "313bb11d-2310-4976-bd74-2fb7d707598a",
			"name": "A chegada do herói",
			"tag": "Cenas Marcantes",
			"imagem_name": "diascinzentos-cenas-chegadadoheroi"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3cad55e0-414c-45dd-81c2-6014a7e8c9f1/troublemakers-artef-aureola.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=e1fb70ca074c9fd7c96839dd2a150c13f6ba71f3a4fd482e21b572f4fc4b9003&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-09T01:30:00.000Z",
			"id": "e34404e7-8da7-47e0-ad29-c2a23cfabe65",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Aureola",
			"tag": "Artefatos Lendários",
			"imagem_name": "troublemakers-artef-aureola"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e2b8ef19-309c-406b-b650-5cd27ec34cd4/troublemakers-golpes-troublepunch.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=ce3728ac2b60b312cc00e571b1425a62ba9127889a590d7435f36e77fe7adc46&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-09T01:27:00.000Z",
			"id": "65fc9d7c-ddbe-4a02-819a-de5e2eeea865",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Trouble Punch!!",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golp-troublepunch"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/03166cb4-881b-4c2b-a48c-7156ae7288c6/troublemakers-golpes-combo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=67bf1288e3baeed81b977a26c671da7e9ace064f3d580972840e3de208ea5d59&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-09T01:25:00.000Z",
			"id": "08418b17-d0fa-4b34-b83b-da64e5e4d7cb",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Combo Trouble Makers",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golpes-combo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/be2ee0c1-2a49-44af-b610-58d6061f2d7b/troublemakers-cenas-norichegando.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=79dc6273fe0c1ce5606baf1f9d76c05a4ad522a7f6524df09e6743e86e6d0eca&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-09T01:24:00.000Z",
			"id": "89fc5f8c-7429-4551-909b-554698c239bd",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Nori chegando",
			"tag": "Cenas Marcantes",
			"imagem_name": "troublemakers-cenas-norichegando"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3cc281b7-23bf-4096-b45f-b0bd8c4c934a/osomdavida-ship-elisaedanielpng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=cd8364c2602428d299777f1841f666960717800e9cae88ace41cdf97ab79d826&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-07T02:59:00.000Z",
			"id": "2dbdfd2a-348e-4e53-ac53-63bc5e52bebd",
			"comic_id": "83740dac-785d-4a2a-946f-aaa286e5695c",
			"name": "Elisa e Daniel",
			"tag": "Shipps Fofos",
			"imagem_name": "osomdavida-ship-elisaedanielpng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4cb52ff3-6d58-4c89-84cf-0f4207797288/osomdavida-cenas-musica.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=7e1d3d9c73d1915d9f0ddac92948e090fd6b350a02ecdaacbcd4d1f8462a5a4b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-07T02:57:00.000Z",
			"id": "2a64e291-e915-4bed-b279-9961cfbe494e",
			"comic_id": "83740dac-785d-4a2a-946f-aaa286e5695c",
			"name": "A última música",
			"tag": "Cenas Marcantes",
			"imagem_name": "osomdavida-cenas-musica"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/65e73602-c065-4337-88eb-8ef576ba1d9a/everydaylifeatbrightrosebushhighschool-exp-alysson.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=d8ca67c4b81887a2b01f55ce52b4bdec99463db9afb2e9f1c1372976d18da8ba&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-07T02:55:00.000Z",
			"id": "7cb8f1e0-149c-48ca-8465-b220fce66e8c",
			"comic_id": "92b9941c-94b4-4758-87f7-49439afea6a0",
			"name": "Alysson ",
			"tag": "Expressões",
			"imagem_name": "everydaylifeatbrightrosebushhighschool-exp-alysson"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/35d52b94-1325-4601-bf39-1b524be89ca6/magh-capas.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=e773426561241047a3a3f2b43d3582f718394061949dbc03ff0b4588dc12bfaa&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-07T01:25:00.000Z",
			"id": "35b9c168-d7e6-4d4c-8891-0fed52b3d5f0",
			"comic_id": "1ee0fa67-fbec-42fc-b605-35a3db69617d",
			"name": "Magh",
			"tag": "Capas Insanas",
			"imagem_name": "magh-capas"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b1c722bb-b86d-4d41-9d34-4f9cd02d30c0/magh-cenas.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=c5da35c79acc39f8fb50307d087eea1e802315d0ca4a2ed3165127e95e538fa0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-07T01:24:00.000Z",
			"id": "40e96ba2-8fb2-4b31-8a61-e72d7774ca6b",
			"comic_id": "1ee0fa67-fbec-42fc-b605-35a3db69617d",
			"name": "Discurso",
			"tag": "Cenas Marcantes",
			"imagem_name": "magh-cenas"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/93103d10-25ac-4d75-8b92-7bad561fab2b/kellyyoungspooky-multi-jornadadeari.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=145e766f10b8bdcd303c0807601cbe1e851f585be904d643f9d687b2e9e89f37&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-02-02T02:14:00.000Z",
			"id": "6f8abe8a-724c-47b1-8d50-f737b52cd4b5",
			"comic_id": "08ddce89-0318-4287-a65d-bcfe10e362dc",
			"name": "Desenho da Jornada de Ari",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "kellyyoungspooky-multi-jornadadeari"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/811ccc5d-109f-4e4a-b905-db82905817e0/pitakoxpitako-multi-samuraialface.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=932aef2fd6cd722daf85a3ae819794111f57efaedebe0330b3bb579b456ab7d0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-01-23T21:15:00.000Z",
			"id": "82833c32-acf8-4d9e-a91c-e9195318c799",
			"comic_id": "81780fd3-dc42-4c7c-8436-dd496d36d065",
			"name": "Pôster de Samurai Alface",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "pitakoxpitako-multi-samuraialface"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5f0e3615-e5b5-4106-ae7f-58607cef7daa/pitakoxpitako-char-fbulo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=fb8a42ec10b7b0a7abf4333e562b7066c813087132f5081aa181ae79fdf94d7e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-01-23T21:14:00.000Z",
			"id": "0466173b-8d6e-4f8f-aeac-3f1f468f8321",
			"comic_id": "81780fd3-dc42-4c7c-8436-dd496d36d065",
			"name": "Fábulo",
			"tag": "Personagens Maneiros",
			"imagem_name": "pitakoxpitako-char-fábulo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a8abb0c7-c2f2-4fc8-ba26-8e6cecd1fa87/istella-exp-risonha.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=971700b713d2c2223c595c0000decac1e555ffa5eb1be5e148123bb243e4624c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-01-12T01:34:00.000Z",
			"id": "7b644034-591b-47b6-a516-4e20da531eb9",
			"comic_id": "486d5639-4ac3-4279-aff1-c53f9da4efc4",
			"name": "Istella Risonha",
			"tag": "Expressões",
			"imagem_name": "istella-exp-risonha"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/562d479c-ef01-4dd5-b614-700308a483fb/aliceanimo-exp-eh.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=374b397268d9b5197ce8011477b763b286ace78609a2d026c105080c51223d1c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-01-10T00:05:00.000Z",
			"id": "1f49f01a-8b6b-4497-b778-e1e4d0e37f7c",
			"comic_id": "be5d39ec-2f62-4c55-af1e-221a58de77ae",
			"name": "Alice …..",
			"tag": "Expressões",
			"imagem_name": "aliceanimo-exp-eh"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e86b133a-7107-41b5-ad54-2fd7fda5999a/ginga-multi-estudioarmon.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=6f70e7bcc7dd1e4f38abffe32d820177866dc7632df57f50d772f1f28d5fcc07&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2024-01-10T00:03:00.000Z",
			"id": "229e1bda-ed4a-4952-bcab-c6077a8a6cd0",
			"comic_id": "47df8ba6-f6f6-47ac-a203-92d0358a52a5",
			"name": "Estudio Armon",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "ginga-multi-estudioarmon"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0b623ed2-197c-48bd-ae5c-da8dde86b2ac/oretornodekurt-exp-pqp.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=b56fc1aa4d4d563e50eb0ff943ee9b3c3035a661f63afcf06f01650ac974cc00&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-12-12T23:11:00.000Z",
			"id": "58d31956-9dd9-4ae0-b430-868ee135d560",
			"comic_id": "98578353-e750-4e43-b839-1d26572bfef1",
			"name": "PQP",
			"tag": "Expressões",
			"imagem_name": "oretornodekurt-exp-pqp"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a1a8ea1b-0a02-4bdb-a936-d2b5e88ee279/diascinzentos-mult-silva.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=c0e764d99204a2a62cf10b133caef5ab36870f103d82cae4d730d4e2304a9ed8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-26T20:00:00.000Z",
			"id": "5955f2c1-f399-4258-9695-e17961eb2d60",
			"comic_id": "313bb11d-2310-4976-bd74-2fb7d707598a",
			"name": "Silva",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "diascinzentos-mult-silva"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8e0355f7-0c02-414e-bfd6-fa629e594c32/krestgale-exp-confia.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=72599979292a1288e7e139d3ea274e90cbfea7f475ac7328f92fc42149f1fc33&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-21T23:37:00.000Z",
			"id": "ce288b83-62c2-40a2-b6f3-261182369606",
			"comic_id": "bb2168c6-5bf5-4eba-97f7-360e9fd457ba",
			"name": "Confia",
			"tag": "Expressões",
			"imagem_name": "krestgale-exp-confia"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/72330ccb-cd9d-4ab8-bbb7-93a8e91f5b00/istella-exp-ameaa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=9b739070457bbef2cd730f506f73a2a66d868dc07fda6ff16f38148741c66dd9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-17T02:08:00.000Z",
			"id": "ed1e421b-4a69-413d-a07d-7a54cc47b81e",
			"comic_id": "486d5639-4ac3-4279-aff1-c53f9da4efc4",
			"name": "Istella ameaçadora",
			"tag": "Expressões",
			"imagem_name": "istella-exp-ameaça"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6a0adfa3-d905-4528-b6fd-5180729a7b94/istella-multi-reidelata.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=a543fa7a49a843a9473a8900131f2a1d9f4a9b5d46eec20194c29dcdedc54b75&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-17T01:46:00.000Z",
			"id": "4ee2d74a-1456-4796-bc91-e77c62ff37d7",
			"comic_id": "486d5639-4ac3-4279-aff1-c53f9da4efc4",
			"name": "Simbolos de Rei de Lata",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "istella-multi-reidelata"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1e763d4b-6565-431f-ab0a-f63587a68121/istella-multi-dinossauromaru.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=e0e163c40a4cfe654d99759737ddbb6ab0b37732f2b83703cc8d0a3bbd76e54c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-17T01:28:00.000Z",
			"id": "58edd184-3e9e-432d-886c-5601f4ca0427",
			"comic_id": "486d5639-4ac3-4279-aff1-c53f9da4efc4",
			"name": "Quadrinho de Dinossauromaru",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "istella-multi-dinossauromaru"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/627debbf-e80c-421c-928a-97777e656872/istella-cenas-continua.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=a1d6b7c3a0916f5e5d051bac5c3c5f5330fda47539afd0e1a322c9457cd41b37&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-17T00:54:00.000Z",
			"id": "ce5a341a-036e-4a86-9861-1f9197606df8",
			"comic_id": "486d5639-4ac3-4279-aff1-c53f9da4efc4",
			"name": "Continua…",
			"tag": "Cenas Marcantes",
			"imagem_name": "istella-cenas-continua"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a6cf337b-a009-4ffd-9a2e-2224fbfb803d/kairuede-lugar-soteropolis.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=bb2bd167da825886c7fa2af118ec5462aaff5261815b8210e4bee1a89d5b2578&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-16T22:54:00.000Z",
			"id": "01964df5-204b-47ae-a83c-e49930d45714",
			"comic_id": "b5203e86-b991-4258-b0db-0273c87d0e20",
			"name": "Soterópolis",
			"tag": "Lugares Irados",
			"imagem_name": "kairuede-lugar-soteropolis"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/99c757a1-a2b4-47c0-8b98-03bec0a88768/ginga-multi-aquelapequenaedocefada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=afbcee5d753ba30bc8b10d70fb3a74127fe9723ecc27b0fe721912b18cd31951&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-13T00:35:00.000Z",
			"id": "127bde99-9b45-42f8-b1cd-52a34a58d16b",
			"comic_id": "47df8ba6-f6f6-47ac-a203-92d0358a52a5",
			"name": "Poster de uma Fada pequena doce e mortífera",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "ginga-multi-aquelapequenaedocefada"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1d9a43aa-5c7a-4d98-9fae-5c431a493fc7/tropikalia-cenas-treinamento.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=07892c3abe9cb4f31da5a1387602ea5c3f29d8a70a809fe6ea22c5021f540f3d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-05T22:40:00.000Z",
			"id": "c595d027-7fdd-4970-8f4e-4f1c08cd18c8",
			"comic_id": "0210646b-3d70-443b-baf6-c9e3d9383fcc",
			"name": "Treinamento",
			"tag": "Cenas Marcantes",
			"imagem_name": "tropikalia-cenas-treinamento"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3914a634-b480-4407-a09b-e6cbf09851ca/tropikalia-char-mestrebesouro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=151e2f27916bcd5fbb04348f1fae452aa79246db7d1ddade0b1d33748b8611c4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-05T22:39:00.000Z",
			"id": "1793375d-9b17-4b44-9018-56d215fa953c",
			"comic_id": "0210646b-3d70-443b-baf6-c9e3d9383fcc",
			"name": "Mestre Besouro",
			"tag": "Personagens Maneiros",
			"imagem_name": "tropikalia-char-mestrebesouro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/580ddc73-0aa5-4da9-a303-e40de0b8aa8d/assombrao-exp-help.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=ca6bde907bebe8144f7eeca93f266c588c11b8d3525f9bbe951cd021f8a34a53&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-01T02:48:00.000Z",
			"id": "5c2cbd25-9f1b-4f15-8606-0c36613a19bb",
			"comic_id": "78609969-f628-4619-8334-cbd4eeb6cabb",
			"name": "Encarando a assombração",
			"tag": "Expressões",
			"imagem_name": "assombração-exp-help"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/24904a19-9361-4097-9ec4-99039cd83fcf/oretornodekurt-cenas-cartaodosuspng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=6d13911a95ccbf8df41868a0cf85e0999352f76be1fa0ccf8f3ee517c57bafb5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-01T01:48:00.000Z",
			"id": "c49267f5-7842-4d87-9050-b4aa07d91cd5",
			"comic_id": "98578353-e750-4e43-b839-1d26572bfef1",
			"name": "Cartão do SUS",
			"tag": "Cenas Marcantes",
			"imagem_name": "oretornodekurt-cenas-cartaodosuspng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b3f08b12-eea5-4e6f-86a8-8289b8181e49/oretornodekurt-exp-tedio.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=ee46c95aa01ca8338779ddf9aaf6298bcb7fb4b8d41479243c44cd6b003d05b6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-11-01T01:30:00.000Z",
			"id": "864ff7ba-2391-47f4-8d81-c9879dd0236e",
			"comic_id": "98578353-e750-4e43-b839-1d26572bfef1",
			"name": "kimberly desinteressada",
			"tag": "Expressões",
			"imagem_name": "oretornodekurt-exp-tedio"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e331c9f9-9058-4287-bb5a-526234056cc3/fatalabruxadebeliverde-exp-beicinho.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=ffa01764f159caf0842c467ac3fe364fe59781a45c87d059f6ca4898269c2be1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-27T00:54:00.000Z",
			"id": "efae5cc8-de53-41c5-98c0-ba9aa334ff94",
			"comic_id": "f5414002-efb6-45bd-b80f-296dee47d279",
			"name": "Beicinho",
			"tag": "Expressões",
			"imagem_name": "fatalabruxadebeliverde-exp-beicinho"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9a6c17cd-6c63-4e32-9fc0-c289b118505b/fatalabruxadebeliverde-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=2e191ed1bd62977fd3b532410a450c3c1f9591c30d8508c77f3ec9f7510f289b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-27T00:30:00.000Z",
			"id": "64001592-1de3-46d6-b6c3-b396dfb4596d",
			"comic_id": "f5414002-efb6-45bd-b80f-296dee47d279",
			"name": "FATAL: A Bruxa de Beliverse",
			"tag": "Capas Insanas",
			"imagem_name": "fatalabruxadebeliverde-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0e9efcf2-d01a-48ea-9de3-b4fd3b4658ce/noeleamagnificafabricadebrinquedos-artef-joiadaonipresena.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=f983ba2b7fe62bf4a72b8ac1d4256f00de1cdecc62d99cc8bac9208b603a115d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-20T01:49:00.000Z",
			"id": "245c75bb-14dd-49d4-813c-afe0809b541b",
			"comic_id": "0b31e8d7-a189-4296-b397-1664ef6165db",
			"name": "Jóia da Onipresença",
			"tag": "Artefatos Lendários",
			"imagem_name": "noeleamagnificafabricadebrinquedos-artef-joiadaonipresença"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f1b4db80-fb58-4a0d-8d7b-60a3b6475e13/osetfinal-exp-quebreeega.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=64b7942bbd98954d9d8418d748f06d3bf0711258f552725467647ba4cefa110c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-20T01:16:00.000Z",
			"id": "84c9c9a9-7d4e-4d80-a21f-503dbcb0a324",
			"comic_id": "9cd197ad-22ff-45b4-bf26-4cfe2c934f34",
			"name": "Que breeeega",
			"tag": "Expressões",
			"imagem_name": "osetfinal-exp-quebreeega"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3ab5f312-f736-4566-8bec-092b03185407/redoni-masc-gatinhocego.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=017b3aa6f3b08634e0032e2306de2438b82f75cb8b7053a710d9c72f8c09625f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-18T02:02:00.000Z",
			"id": "2943ebf3-44d0-4d9e-a4be-2e10169b6912",
			"comic_id": "d2f86747-726c-42bd-882f-37c8c208e687",
			"name": "Gatinho Cego",
			"tag": "Mascotes fofinhos",
			"imagem_name": "redoni-masc-gatinhocego"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ddf3bc8e-8e01-4b91-a5fa-bf4fc9084050/ginga-multi-valn.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=1fbb3282f8d1b5df9091d2239ef9e9811a6c40d04391a86152038fca3891e692&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:54:00.000Z",
			"id": "32b64800-032d-45a8-9274-885cbc72d8bb",
			"comic_id": "47df8ba6-f6f6-47ac-a203-92d0358a52a5",
			"name": "Valón",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "ginga-multi-valón"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ce902450-4934-4b5f-9104-9a87ee6e1901/ginga-multi-syncro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=306978a045b2eb9197e6079c565935ee5235da60e1669df6bddfbe94fda4507a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:53:00.000Z",
			"id": "a61c20b4-b398-4bf5-88e4-54ad73bca14d",
			"comic_id": "47df8ba6-f6f6-47ac-a203-92d0358a52a5",
			"name": "Syncro",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "ginga-multi-syncro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9332ccbb-0fb5-421f-ab74-2abc178c2378/reidelata-golp-superfabulosoataquefurtivodaesther.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=f3560c2ea2ff3c4c8a89a3abb57d373c89ad2be9a13c17b680e6d84667243b9b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:51:00.000Z",
			"id": "abf4616b-2594-485d-9ca6-dc9e93137005",
			"comic_id": "31a09d13-11d9-4b66-b43b-41a845aa0df7",
			"name": "Super Fabuloso ataque Furtivo da Esther",
			"tag": "Golpes Fodas",
			"imagem_name": "reidelata-golp-superfabulosoataquefurtivodaesther"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cf1bd4f4-0a67-4eb2-8abb-4f941d1a4958/reidelata-golp-soconorteesuldoreidomundo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=b48d82094cb95e1d518183a3b45b05651924c75a1009ac2c8f389e50b59669e0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:49:00.000Z",
			"id": "4a26e30c-7200-421e-af4d-ab1e4fb901e4",
			"comic_id": "31a09d13-11d9-4b66-b43b-41a845aa0df7",
			"name": "Soco Norte e Sul do Rei do Mundo",
			"tag": "Golpes Fodas",
			"imagem_name": "reidelata-golp-soconorteesuldoreidomundo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/97f4d90c-43b0-4753-a7f0-2b5b5586df9f/onda-multi-gotohell.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466ZPWMEHZT%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232846Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIQCgmtqn65YuGEwvlin%2BlV%2FqNwCoe89GeJsxIFm3%2F%2FICOAIgXagq0RdJdjNsA%2BMiOnn9Iz6AU0KQncfps0BwazMNcG4qiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDNSe0qPYbivIndIgqCrcA2pWYoaHlGEJ9BN%2BVnFxNyZ936Qqk%2B3F6eq%2FuFYG%2FLtNJwbE1wssZJFPJBf9e4WqnYkzt7Gx%2BZbxj3RsNHKCq2uJyf5U15b53D7NKbrEgD%2F76k6JmVLzrV%2BOkd%2FZ12PA%2F4%2FRjDjGpXpXqmdynOwsH9Zj8frOvCDAIpMZkuTbTl9Uthmny5yUrERhKok%2FfRlI%2FwUZgdn4vLfz1WNKvBikAJjYDVpcOMRc%2Fi5cvK8NVK68wCeOyytCwIeGKlCnm2C3NujI7IQkkhd7KCLy3yK3FQnWVzRRjD3pdCCIx%2FeRyoqaq4OHaVTYKvPK1Pc4rwKZAdNrQa1qz3tPokNQNqMkOoM7YNCuNEL1F4b%2BMW7Cd%2BbUmd8YvxMqkNZu2p4K%2BCH9hqpj8NoseDf9xSo4NeTJGgb%2FOZlE70iaz4UN23%2FoUOd0OCA%2BE6t53FXw%2Ffpj68sDqRxTZN1JKWyNzV07Sk60apDXnOhk%2F0qsCXRcwDpI3kuQxPQ0UF3So2kty%2Be67XHQ4366Thk7JIFldSUyXNLp%2FOU9DVK3%2B6XsiXhL8gRqi7TVPiwNIqwr%2BkcxWuJ2qLhWfIMvo17ebbMUsTkZA0YbupzzZ1fCb55BG2RYBCZFc4%2BwsHbqaHTSDHKypayRMN25q78GOqUBLsITrMMa2bJAQIQbbMJPcKhO0wne3mhB3l2eHICo%2FXjSBlldBjSA6u%2BVxbVe1iaYzTFM%2BiCS8BdicrthT2cepPFpVKr9P2nq7X3ElL1%2FXsY40NGHUjZn5QlnDWxNAFJrbN1pWIO7XhKQzOW9K%2FwzhvITNmkQSiWfpVQJ9M%2FMfujJVW7%2BoWDM%2B7VKsHQsA4WwMQBpZmEbmFq%2FeKHf0ZO%2FrBH7e8BG&X-Amz-Signature=fc3d1086557333b3143ebc3840de3f85e10d987b3d9ac49f22ebdf8dd66ee150&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:33:00.000Z",
			"id": "6b59ef77-c1ef-4a10-8b71-dd3513bb6d2e",
			"comic_id": "05c9eb1d-4636-41ae-9236-145d74deb8e0",
			"name": "Go To Hell",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "onda-multi-gotohell"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a5708a3c-cd16-4409-8187-475adc88c072/onda-multi-pingpongedrama.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=52e25390bef77af98118001a8795bfadb35dd181dc0de374b3c08d9dc38735ff&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-17T00:32:00.000Z",
			"id": "727e15b2-a79b-410c-9f39-a240d68dbfe5",
			"comic_id": "05c9eb1d-4636-41ae-9236-145d74deb8e0",
			"name": "Ping Pong & Drama",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "onda-multi-pingpongedrama"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/da54f956-b2fa-4927-9fd2-460350ca5aa6/formaouconsciencia-cena-eusoucomovoce.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=febba2f996f2e8ed65624491fa405081342beb6e9453bf6f6000ded1a5decdf4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-04T02:37:00.000Z",
			"id": "ef749688-ed58-4fd1-97b4-bc1f93897d4b",
			"comic_id": "9f11910e-5cd3-4839-ae88-55df741c43ca",
			"name": "Eu sou como você",
			"tag": "Cenas Marcantes",
			"imagem_name": "formaouconsciencia-cena-eusoucomovoce"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/97566cc3-d545-4740-a986-ed6261782122/arthureosol-exp-marisesegurando.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=0bd3b7de53dbd4d0644a6cc5d568bca57e54868b5e8c2a9b9a6e16a0da980fd3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-10-02T01:43:00.000Z",
			"id": "5b23f925-b41e-40ee-92e5-c105e1232b0c",
			"comic_id": "17397722-d811-4e0a-a42b-11d7fdd5f0c0",
			"name": "Mari se segurando",
			"tag": "Expressões",
			"imagem_name": "arthureosol-exp-marisesegurando"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1b8265ef-5234-4a2f-ae64-037a109660b3/algaia-multi-lendasdeveracruz.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=4f26cd5ea12625baa95fd9c11e58893cbc0945bf7317f230604cce141bcacf69&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-26T23:11:00.000Z",
			"id": "7fc4bdb0-3ad6-416a-be2c-64de70d4d6c8",
			"comic_id": "d4643cfd-f450-4d70-aa96-4c5224fc7132",
			"name": "Camiseta de Lendas de Vera Cruz",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "algaia-multi-lendasdeveracruz"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/69e0d385-bf8b-45d8-9cc9-0dfaa53e6bb3/algaia-golpe-aiven.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=8339200007601b33860c6f37169be19364c6f9cc1fc3aaa06382966e685e061b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-25T01:14:00.000Z",
			"id": "45c975ca-6045-4d20-881a-58790b97ca73",
			"comic_id": "d4643cfd-f450-4d70-aa96-4c5224fc7132",
			"name": "Alven",
			"tag": "Golpes Fodas",
			"imagem_name": "algaia-golpe-aiven"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/82fe711f-6148-4789-b10a-e6bfe4d581d9/neverlate-lugar-restaurante.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=1aa8034db914b61d4bc01a1fbce454d24cc9f1a2f290ab2a679f6d504318daec&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-20T01:53:00.000Z",
			"id": "ff879863-b464-4655-bbd7-5623556521bc",
			"comic_id": "60eeea2c-8a02-4371-8b9c-a6ac73e100cb",
			"name": "Never Late",
			"tag": "Lugares Irados",
			"imagem_name": "neverlate-lugar-restaurante"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/13be8675-ea17-43db-b2e6-cc83f092e293/neverlate-cena-nuncatarde-png.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=7ab74b8ece501feca6a9ddebac52d876a1849340cd16552c39137af45db0fa38&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-20T01:50:00.000Z",
			"id": "0dcd8a08-0e0d-4e60-a7b4-383e5faaf385",
			"comic_id": "60eeea2c-8a02-4371-8b9c-a6ac73e100cb",
			"name": "Nunca é tarde",
			"tag": "Cenas Marcantes",
			"imagem_name": "neverlate-cena-nuncaétarde-png"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d111390e-3c85-4921-b4d3-17def089bf8b/atinypromiseinaneverendingday-cena-heroinacional.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=f510de5709844c338f3a3862928b5d939de32c2584894a7d1f175ff343703955&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-20T01:16:00.000Z",
			"id": "32d97c5c-ad34-4d43-ab90-ee31e9d03241",
			"comic_id": "217bf8d2-8922-4145-9622-6d3191d074f0",
			"name": "Herói nacional",
			"tag": "Cenas Marcantes",
			"imagem_name": "atinypromiseinaneverendingday-cena-heroinacional"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/610a2273-ea8d-46c0-b727-977536b9d556/folklorewarriors98-char-vitoriaregia.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=d39107ff385e08c22bc6dcbd9ed5d3b197bbdb489419872eeda27d0ecda460a6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-17T22:56:00.000Z",
			"id": "3545f962-7795-4d48-b73c-523dad03ae75",
			"comic_id": "fdc3dac7-b5da-4f88-83ef-a4fee64c50e3",
			"name": "Vitória Régia",
			"tag": "Personagens Maneiros",
			"imagem_name": "folklorewarriors98-char-vitoriaregia"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1ff9e396-8229-416d-9f06-8e85141e47b3/folklorewarriors98-onom-pimba.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=972aa008b8d03fdadba91f34678a8754fe4b24e09fbbaea11a976fe41073ae60&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-17T22:54:00.000Z",
			"id": "bfe455c9-62ee-4676-a085-aeeff5d3cdd2",
			"comic_id": "fdc3dac7-b5da-4f88-83ef-a4fee64c50e3",
			"name": "Pimba",
			"tag": "Onomatopéias",
			"imagem_name": "folklorewarriors98-onom-pimba"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/459d119c-7b31-4c20-aebd-afb2f623fa31/justkeepdrawing-cena-brigaautor.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=3406f9ac0fdf825a5d933cc44d2dfff1f34db2901dc652d39e85d0541f6d2ac8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-09-14T23:11:00.000Z",
			"id": "bf49d8fc-8438-4736-8212-c4c7c5dfd3f0",
			"comic_id": "89c6a26e-0a85-4b8f-b029-3139a956ba55",
			"name": "Autor discutindo com personagem",
			"tag": "Cenas Marcantes",
			"imagem_name": "justkeepdrawing-cena-brigaautor"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f559077e-ea6c-4953-9239-29e366e4d156/memoriasagridoces-ship-sophieedamian.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=d904e6bf3ade3bae23c896fdfe11c16c640ac4ea86db5b2f575d7509bb4fdc5a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-30T01:39:00.000Z",
			"id": "833bbba1-80b8-4eda-a478-07c21fcf1325",
			"comic_id": "a49730c7-d6f9-435f-b069-d0d41d4cdbb7",
			"name": "Sophie e Damian",
			"tag": "Shipps Fofos",
			"imagem_name": "memoriasagridoces-ship-sophieedamian"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3f45447e-a39f-4246-96dd-c5c04d086f07/boitataespacial-cenas-boitata.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=ef1ab2189a721649a77df8c6d6bcbf62e2378def863bf88b38d35e5013dc6d0a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-28T02:32:00.000Z",
			"id": "7f69449f-f8f5-4b85-a2d3-ef31086f57c2",
			"comic_id": "3c2a8ed8-7d23-4394-9a1b-6d5f34b520dc",
			"name": "Boitata",
			"tag": "Cenas Marcantes",
			"imagem_name": "boitataespacial-cenas-boitata"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e037b563-8779-4e26-856f-e34faeb0d376/boitataespacial-char-capitaamana.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=ab765d1aa72c37ab11ed09bba8cffdfffe88701c4d310cb160770da66a1fa71c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-28T02:27:00.000Z",
			"id": "88626a2d-913b-4d51-8622-55d9e43896f5",
			"comic_id": "3c2a8ed8-7d23-4394-9a1b-6d5f34b520dc",
			"name": "Capitã Amana",
			"tag": "Personagens Maneiros",
			"imagem_name": "boitataespacial-char-capitaamana"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2873418f-a16d-44f8-86df-e09ea857b131/jucistar-lugar-jucistar.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=06cb1f9b205b70c619ba88aab147a7b85b024525ee83f2f80a125529222f90f3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-28T01:24:00.000Z",
			"id": "20837f49-63d5-4183-a25e-355ddb5bf1cf",
			"comic_id": "a80ba308-39b9-4bf0-9c4b-5725cd54d054",
			"name": "Lanchonete JuciStar",
			"tag": "Lugares Irados",
			"imagem_name": "jucistar-lugar-jucistar"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f776206e-575d-4404-b529-bb8fadbc8a68/overwift-masc-opereta.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=b234eae4707c15c3bc6f5495ff767e0c184865a0fca2a36fb4e2dbf76cc38268&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-25T00:58:00.000Z",
			"id": "d7515c89-b4ac-4f6b-bf5e-b17c218bdd4f",
			"comic_id": "aa3ee854-0c0e-4d34-acae-5ea17f607be1",
			"name": "Opereta",
			"tag": "Mascotes fofinhos",
			"imagem_name": "overwift-masc-opereta"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b397f2be-7eb9-436f-8ac3-4e5bf5d474bb/overwift-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=a934d2c74c1d37fbe6178e8c074d037434833d0ab581231d6c5de28152f9affc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-25T00:38:00.000Z",
			"id": "1a054bd1-3258-4052-9fae-845247768868",
			"comic_id": "aa3ee854-0c0e-4d34-acae-5ea17f607be1",
			"name": "Overwift",
			"tag": "Capas Insanas",
			"imagem_name": "overwift-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ff0b5f5f-d6eb-43e1-bdcb-2a5152f0e49c/ossonsqueouo-exp-vnia.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=0a8ff5f34cbee6764b82b653a05a3b2183df22a4c0ef940529201377ca4cf25e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-24T16:06:00.000Z",
			"id": "2ee00283-e1e7-41d6-875b-3ecc57f73119",
			"comic_id": "a6ea284f-c025-48eb-a3d4-59ca773aa567",
			"name": "Vânia aterrorizada",
			"tag": "Expressões",
			"imagem_name": "ossonsqueouço-exp-vânia"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/538114f6-89b2-4d1c-b750-8d68de4ebc04/ossonsqueouo-masc-kaizen.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=59968a5be3f1ac3e2365445a48ad7e9dfd96c074d75f9e14b5a17d86e99b68d7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-24T16:04:00.000Z",
			"id": "b348cac2-8f7f-433c-b2e4-87474ec52786",
			"comic_id": "a6ea284f-c025-48eb-a3d4-59ca773aa567",
			"name": "Kaizen",
			"tag": "Mascotes fofinhos",
			"imagem_name": "ossonsqueouço-masc-kaizen"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/44a98fd1-aae8-4530-837f-262d8562cb9a/krestgale-onom-bbbuuaaa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=3504926c919d0ca5b50e6b80d24b1b371471557099f6d190961b58ce13f6e07e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-24T15:58:00.000Z",
			"id": "c114fad1-0daf-4529-9374-2396b0375a3c",
			"comic_id": "bb2168c6-5bf5-4eba-97f7-360e9fd457ba",
			"name": "Bbbuuaaa",
			"tag": "Onomatopéias",
			"imagem_name": "krestgale-onom-bbbuuaaa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f095a1ff-a42f-4e53-9ec7-7d956ac7563e/samael-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=70c397883c170cbea1c75d77198d3ec489680a039d0d8a0a89fdf52a0789acc4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-21T16:41:00.000Z",
			"id": "69959fa8-d869-4ca4-9f99-717408cbd486",
			"comic_id": "8247c1b6-da5b-4769-9404-dab9fa591caf",
			"name": "Samael",
			"tag": "Capas Insanas",
			"imagem_name": "samael-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/78dc317c-33a2-4ea7-b623-0bad2e1a02f8/ahistoriadepiabinha-masc-piabinha.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=c8325b8fdc33ff4f3fa8f0df61d5e32a3e0bdb45ed14325032cf797c85937789&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-21T16:23:00.000Z",
			"id": "401f0357-ccf1-4fbb-9bd2-bf827edc926e",
			"comic_id": "d01d19cf-506b-4b3b-a3fd-a544f8353c3f",
			"name": "Piabinha",
			"tag": "Mascotes fofinhos",
			"imagem_name": "ahistoriadepiabinha-masc-piabinha"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5609a3cd-e45c-4390-a1ec-6c5a39e4cf95/oabismo-exp-francesca.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=566047996803e7cf32a4fb55d9fba84bac281408e60992c31737b5f5b15273de&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-21T16:17:00.000Z",
			"id": "a74827e4-e6df-40d5-a2ae-1e60acb537f6",
			"comic_id": "66498b9b-60ef-4b3c-bce8-023f706eaf50",
			"name": "Francesca enojinho",
			"tag": "Expressões",
			"imagem_name": "oabismo-exp-francesca"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/26eebc49-8853-40c4-ba27-2263ee668787/oabismo-onom-dlindlon.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=ae946316374bca868cc5c9140c2bf244dfaa291c9a5555fb2897d0ec7f564fe4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-21T16:13:00.000Z",
			"id": "368b33cf-4be0-4cd9-b42f-f017690b5ff5",
			"comic_id": "66498b9b-60ef-4b3c-bce8-023f706eaf50",
			"name": "Dlin Dlon",
			"tag": "Onomatopéias",
			"imagem_name": "oabismo-onom-dlindlon"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2a91bfe9-a010-4ed8-9f2d-05dd001c8b89/kungfu-ship-amadas.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=4c18807e2b78ada3e3d1bc8271dbdd9a9f23b295221a3ca8d8b2fa103db059dd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-16T01:33:00.000Z",
			"id": "ab04e3b5-7540-4be7-be89-92f535c71d90",
			"comic_id": "147936a6-60fc-40ca-889b-f1685c3089c2",
			"name": "Amadas boas de briga",
			"tag": "Shipps Fofos",
			"imagem_name": "kungfu-ship-amadas"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/717b7265-54fc-4cb6-9085-19ac13a2116f/ada-masc-fantasma.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=debcf47a2eb369f07d594a3d5a34738376b66a5216785fe1790bea88e9058d3b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-14T02:38:00.000Z",
			"id": "bc097f07-fa99-4d5b-932f-9dcce8a4c0cd",
			"comic_id": "25c2cd7f-be31-4494-8c82-692cc88f5435",
			"name": "Fantasminha",
			"tag": "Mascotes fofinhos",
			"imagem_name": "ada-masc-fantasma"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a18c71c8-d067-4952-b0c4-597c7f3966ec/ada-multi-quadrinhosa2.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=53f9bd55d7d5dff11410df56c97454e1dbd24140150ef10425e36b02610774f1&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-14T02:30:00.000Z",
			"id": "351a4dc0-d7be-496e-9e10-fe9475281cb5",
			"comic_id": "25c2cd7f-be31-4494-8c82-692cc88f5435",
			"name": "Quadrinhos A2",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "ada-multi-quadrinhosa2"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9ef61608-9a40-457b-8f19-594d6d23eae2/brisaerrada-cenas-catuaba.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=385a9cd788b6c1eb29cfe9996934badfd6dbef721b49bd0568f9c1e3ed74038c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-14T01:20:00.000Z",
			"id": "ecddd10f-bf54-4669-9c6a-0049fbf001e4",
			"comic_id": "ca1176bc-a12c-4d65-a5f4-2c6dfa7c3b53",
			"name": "Catuaba e Corote de Limão",
			"tag": "Cenas Marcantes",
			"imagem_name": "brisaerrada-cenas-catuaba"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8c3d6833-e73f-40f0-8116-5f3fc6a6b1b3/lynneogatocarteiro-masc-erik.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=28911ee5ee4adb6bff997b00da003cfbf20ebbc0e43c14a6f412323997691263&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-11T01:35:00.000Z",
			"id": "2c4929d1-ca24-463f-a2a5-673f93787483",
			"comic_id": "0c193d2b-ca91-4a8c-9ea9-777f06ebb236",
			"name": "Erik",
			"tag": "Mascotes fofinhos",
			"imagem_name": "lynneogatocarteiro-masc-erik"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0d331517-ad8f-4bdf-8c1b-b56e6a7a4c7b/asperipeciasdegabi-onom-timpng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=75e4143b3280a23a121f86df75213c91e5cc1ebb64801ab9a6144495aafd9b32&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-11T00:54:00.000Z",
			"id": "f322a297-3176-4f53-88a5-1d28173d481f",
			"comic_id": "0ed97ee9-4e05-40f4-944d-1ac32b54b392",
			"name": "Tôim",
			"tag": "Onomatopéias",
			"imagem_name": "asperipeciasdegabi-onom-tôimpng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/583c208f-ab35-499c-ba87-41943d575634/asperipeciasdegabi-exp-gabi.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=15c7ddcfffbced4d0de902ac60a27f588c40d16c1440ba4a76c6553dee5198a5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-11T00:53:00.000Z",
			"id": "f5193177-d7fa-4cfc-a41c-c8cfc6edb91a",
			"comic_id": "0ed97ee9-4e05-40f4-944d-1ac32b54b392",
			"name": "Gabriela",
			"tag": "Expressões",
			"imagem_name": "asperipeciasdegabi-exp-gabi"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c6486b1f-aedd-4b9e-a44c-4b623a9c1efb/tudoounada-onom-plau.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=6977cd8706478779879c2790b88e1a04d8cc30748e962a522cd0ea25b178c340&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-04T01:53:00.000Z",
			"id": "5f759b2f-1891-400b-8cca-2a625022b71f",
			"comic_id": "5d7ceeb6-3054-442a-9d1b-4230cd8cea50",
			"name": "Plau",
			"tag": "Onomatopéias",
			"imagem_name": "tudoounada-onom-plau"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/99a38891-de34-4c70-9f9c-6a7698799b38/starsquad-masc-robo.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=3178b07db7ed6f0d4e8a09400f2cba5cb5cc90bb5e97fc1f484c07013f896920&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-08-02T01:06:00.000Z",
			"id": "248c5faa-ea47-4dcd-87a1-1a302efb8d32",
			"comic_id": "a3074102-e47a-447a-8fe6-d12a804145fc",
			"name": "Robozin",
			"tag": "Mascotes fofinhos",
			"imagem_name": "starsquad-masc-robo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e2e78a7e-21aa-41b3-8159-9193626d1bb8/docelegado-artef-tacodedialogo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=81dff98e635d3cd8f51af53642df1b20160683f4d50ccca2a18bb96901e0185d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-31T01:12:00.000Z",
			"id": "51718c45-3ba0-4052-8859-11794b648754",
			"comic_id": "a2d38323-4ded-4405-a908-f4a56e967b7b",
			"name": "Taco de Diálogo",
			"tag": "Artefatos Lendários",
			"imagem_name": "docelegado-artef-tacodedialogo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5a6f9d15-d223-4a83-9b43-0c42bd4374ae/reidelata-onom-plau.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=22974dfbe59be7590ccc694e20363b24a86b9ddacb2b526175961a02b76a0098&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-29T18:04:00.000Z",
			"id": "dabb4bcd-25a0-49a9-8e38-c11e7eb998c8",
			"comic_id": "31a09d13-11d9-4b66-b43b-41a845aa0df7",
			"name": "PLAU",
			"tag": "Onomatopéias",
			"imagem_name": "reidelata-onom-plau"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0a935aea-ecdc-4721-8de1-9601f2ab05ca/sanguedoce-exp-uhum.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=0ac1183752e6c8011e89ebf98db289dd1756aca966964afd34867d1b8d4aab40&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-28T01:47:00.000Z",
			"id": "ecee0e74-f0ac-4d24-b95c-7972f0c4ec81",
			"comic_id": "3220051e-5e4e-499c-b773-af1090586ccd",
			"name": "uhum, prazer",
			"tag": "Expressões",
			"imagem_name": "sanguedoce-exp-uhum"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/21415b3d-8c4d-468c-a35c-eb7efb4b39b2/sanguedoce-ship-aryasara.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=4f80e57ce6745ade0d15335cf5a2dd16cce9267079821ae48060c934bd6338cf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-28T01:44:00.000Z",
			"id": "3faec63f-0667-448f-9067-067b3693f32d",
			"comic_id": "3220051e-5e4e-499c-b773-af1090586ccd",
			"name": "Alya e Sara",
			"tag": "Shipps Fofos",
			"imagem_name": "sanguedoce-ship-alyasara"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6b4c35a9-b927-4fe4-9763-355e3804d2bb/juquinha-multi-toolschallenge.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=1264bf9c289e7373fc9ca7e2404a4b5d15a403cf81fb6ee47f4bf18d0b68fabd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-24T03:12:00.000Z",
			"id": "15b05e57-0da8-4b34-9ff0-2de560f74eb1",
			"comic_id": "9eaca292-6456-46c5-b37e-d2addadc380c",
			"name": "Boneco de Tools Challenge",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "juquinha-multi-toolschallenge"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/703545b6-553f-451f-bea8-244ed46217a4/quack-golp-socomaguiladecuecassujas.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=c67e9cd60c26361faf90c2c10589d4b63d02cf6b8696cb78d02a1f1ca6112ff0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-24T02:55:00.000Z",
			"id": "8ad9c059-f9a2-4740-8de5-a7071ac45e0a",
			"comic_id": "9c7e91b0-df2d-47d8-990c-52a09ef517b6",
			"name": "Soco Maguila de Cuecas Sujas",
			"tag": "Golpes Fodas",
			"imagem_name": "quack-golp-socomaguiladecuecassujas"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/dd682a9a-1e01-462e-b6b4-f55eca4c00e9/pirates-lugar-mcronalds.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=6359ed863ff342306fe773361fb671c3fee6a6bc9d914da2538577d96048aae7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-19T02:40:00.000Z",
			"id": "d60bb4e5-3993-451d-b6df-45de917edd9d",
			"comic_id": "247c5474-4f0e-4b2b-b550-bfc6448594e1",
			"name": "Mc Ronald’s",
			"tag": "Lugares Irados",
			"imagem_name": "pirates-lugar-mcronalds"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/be36ff95-0d52-419c-9532-fe0dae860d93/pirates-exp-marina.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=761680e149fdd4a3a83c1a36976cb2d7e4144bd3050e479da54f16e53a9c0aaa&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-19T02:25:00.000Z",
			"id": "2280b47a-3ff5-401d-af29-3e19d9751973",
			"comic_id": "247c5474-4f0e-4b2b-b550-bfc6448594e1",
			"name": "Marina perplecta",
			"tag": "Expressões",
			"imagem_name": "pirates-exp-marina"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6cdd2fb6-689e-4523-8002-ef13e9a09811/troublemakers-golp-mandatumprimitivum.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=22a1417ba65c7c6ab8450c4b39f366c76dba70bd90ca93c55b98f134bfb279d9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-19T00:51:00.000Z",
			"id": "5feece17-e09d-4cc6-a4a6-a69a4abddd5a",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Mandatum Primitivus",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golp-mandatumprimitivum"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ccdc9106-62e1-4a28-ac24-89216bdf32c1/onda-masc-ratinho.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=1434443cca53416cc31dbc57e662f45198ea05a1acb4627d5077f373a7a7538b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-14T03:11:00.000Z",
			"id": "07792c56-20a4-4c72-8c8d-293fc4e26acf",
			"comic_id": "05c9eb1d-4636-41ae-9236-145d74deb8e0",
			"name": "Ratinho",
			"tag": "Mascotes fofinhos",
			"imagem_name": "onda-masc-ratinho"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/107fee61-a7bf-4af0-92f3-3069d422d108/onda-cena-surfe.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=426b6ec9bdf8550a9db88d2fc064a01d04918c3ea99547846af47cc9c35bb513&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-14T03:03:00.000Z",
			"id": "bfbe58f6-2770-49fd-9f54-75f58de2c6d9",
			"comic_id": "05c9eb1d-4636-41ae-9236-145d74deb8e0",
			"name": "Surfe!",
			"tag": "Cenas Marcantes",
			"imagem_name": "onda-cena-surfe"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1a5ce73e-5169-426c-bed5-1413c1e5e3b2/abadday-exp-queazar.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=68aae52bb113836ec50ec7c5850ccfe8e1e38ba3fc7d9d7739d085766caf0b16&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-14T02:18:00.000Z",
			"id": "4ca148d4-d570-4499-80eb-5f52da17a861",
			"comic_id": "a7e98dd0-89e5-4d94-a133-b1e99a725cd1",
			"name": "que azar",
			"tag": "Expressões",
			"imagem_name": "abadday-exp-queazar"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a8fa87f3-b865-4fdf-8137-5b57b344cee6/naganoken-ono-splurt.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=38bd985e20c4be54c042825117deee4e79d1c236155c85b73e872003012099b5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-12T02:24:00.000Z",
			"id": "a043365c-a0b7-4867-995f-1b204786aab6",
			"comic_id": "bfabdca1-6b72-464c-9cb1-2cdff3b73f39",
			"name": "Spurt",
			"tag": "Onomatopéias",
			"imagem_name": "naganoken-ono-splurt"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/98f92332-6b46-4014-87fa-3ec8e80570ad/mortalia-char-mortalia.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=42a5594a5ea08d2805887b9d29232a9986b743cb9d160832f56463e49abca9f4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-12T02:14:00.000Z",
			"id": "b87c2626-8060-44d0-83e3-56a4f47f566f",
			"comic_id": "b4e8c36f-e24f-4ab1-bcc8-650f0d3ef301",
			"name": "Mortalia",
			"tag": "Personagens Maneiros",
			"imagem_name": "mortalia-char-mortalia"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/164bd92f-7f36-4e96-9e23-86914171b7e8/aliceanimo-exp-serio.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=4bb4704e3ee561ff905f074d5cbe183400ff385379ca088335b2d7cf6799e552&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-10T00:44:00.000Z",
			"id": "4199b282-be60-4a26-acf9-a04c22acbf19",
			"comic_id": "be5d39ec-2f62-4c55-af1e-221a58de77ae",
			"name": "Sério?",
			"tag": "Expressões",
			"imagem_name": "aliceanimo-exp-serio"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3c8530c6-30d5-4c32-8661-87772084aac6/starmind-exp-inteligent.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=4ec046d4bde854df44d8d26b6117afe3dee26b90e4cb1be63148bda2ba51c5b0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-05T03:19:00.000Z",
			"id": "f91e0bc0-2a29-4a1c-8df6-7d04d10c52df",
			"comic_id": "c0fe1c30-47de-4d78-b0f1-d2f8eba5c224",
			"name": "Inteligent",
			"tag": "Expressões",
			"imagem_name": "starmind-exp-inteligent"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4866df5c-c351-4ad9-b565-5e4c1b8a6419/quack-onom-pum.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=5df65d092f014881a969871b233fe0533bd7fa8db94023467d1a31cd2f463166&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-05T02:15:00.000Z",
			"id": "b9575763-a2d3-4e46-9134-7af8e6cf8bc1",
			"comic_id": "9c7e91b0-df2d-47d8-990c-52a09ef517b6",
			"name": "Pum",
			"tag": "Onomatopéias",
			"imagem_name": "quack-onom-pum"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/04bb8d43-f6c0-4ef9-b5f7-0c260b6e4740/quack-masc-colombo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=940ce3fa5c2fb5821ab2ee87a6362fa1f43325b486306517e02693a82d9f5f6f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-05T02:14:00.000Z",
			"id": "7a77ebef-84cd-48d0-b369-1a22c09bfa7d",
			"comic_id": "9c7e91b0-df2d-47d8-990c-52a09ef517b6",
			"name": "Colombo",
			"tag": "Mascotes fofinhos",
			"imagem_name": "quack-masc-colombo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a32c5613-17c3-4883-b81a-f3772594f1b6/quack-exp-pato.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=42cabac3229a3967b331f8af9973c78f7698b2ff05e73c54debb98000e1aad49&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-05T02:12:00.000Z",
			"id": "69fb12d8-a082-47da-afb5-7fc73f78cd22",
			"comic_id": "9c7e91b0-df2d-47d8-990c-52a09ef517b6",
			"name": "Pato",
			"tag": "Expressões",
			"imagem_name": "quack-exp-pato"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/877c10cb-1084-460e-94d5-030883f13558/seca-cena-achuvacai.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=b3e2116f11c25e8f8fc3c915c9d1cc860b8b4bcc100e2de98e04125aba969e21&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-03T03:02:00.000Z",
			"id": "15a6d10d-832d-439e-b4a2-f2be21cfce94",
			"comic_id": "6a6523bb-fed6-42a5-82e9-a7c0439e2b71",
			"name": "A chuva cai",
			"tag": "Cenas Marcantes",
			"imagem_name": "seca-cena-achuvacai"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0226507c-e999-474c-bd72-0394dd88de88/lobomau-char-lobomau.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=6e97107eb7a28b7f5a7880548820babaab67e21f0a063379b6dedf15cfb8d3d5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-03T01:12:00.000Z",
			"id": "514ae176-4fa9-462d-81ab-c4d961719eb9",
			"comic_id": "edddd453-2196-47ff-bc86-30356224d08f",
			"name": "Lobo Mau",
			"tag": "Personagens Maneiros",
			"imagem_name": "lobomau-char-lobomau"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/149899d9-5ba8-4704-b444-675d1dba1187/lobomau-capa-6.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=95303bd6b2b0f1714c19bb8e77d51b83d49e4ff3ee197ba2c75958a1b48ee609&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-07-03T01:11:00.000Z",
			"id": "fcae35a9-956b-493a-94a2-1d430018e8cd",
			"comic_id": "edddd453-2196-47ff-bc86-30356224d08f",
			"name": "Lobo Mau - 6",
			"tag": "Capas Insanas",
			"imagem_name": "lobomau-capa-6"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ea752997-2d80-4a3e-9516-bcd97f349337/tropikalia-golp-bicudapng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=b1f46812038e3dedb9327c42b068771266b149e687e2d9b76c1eb396ba16a33e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-30T03:04:00.000Z",
			"id": "9bdcaa60-cd26-4648-9cbf-891397454074",
			"comic_id": "0210646b-3d70-443b-baf6-c9e3d9383fcc",
			"name": "Bicuda de Zambi",
			"tag": "Golpes Fodas",
			"imagem_name": "tropikalia-golp-bicudapng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/66f6dcd1-d0b3-4c01-8b63-154dba5123e4/tropikalia-cenas-zambi.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=3054f193b36f5b9f92ec62b437a53101dc97c26b0f256bfefd55e0df7f4d0a36&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-30T02:58:00.000Z",
			"id": "23b61791-6b1d-4401-930d-ec86e724a26f",
			"comic_id": "0210646b-3d70-443b-baf6-c9e3d9383fcc",
			"name": "Convicção de Zambi",
			"tag": "Cenas Marcantes",
			"imagem_name": "tropikalia-cenas-zambi"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7c526b48-0c98-4e0c-8ab0-6a47d4c624e6/tropikalia-char-zambi.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=ecabc6f01c2ac3925263f2f62ef6a4f8d9891c9a996d0e58a85f6dc5e26aa7e4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-30T02:48:00.000Z",
			"id": "aa731b25-32f9-4e8f-ae01-ba364f141b9a",
			"comic_id": "0210646b-3d70-443b-baf6-c9e3d9383fcc",
			"name": "Abaé",
			"tag": "Mascotes fofinhos",
			"imagem_name": "tropikalia-masc-abaé"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1f007724-f2fb-4ef3-b963-40081a69a0d8/tropikalia-char-zambi.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=ea6fa0aee9e51ce1b45b82767f30988e2ec913aa4be29d00baa997b75029c2ce&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-30T02:45:00.000Z",
			"id": "db5bc9ff-c3b6-49f5-9858-6df7818f4dc8",
			"comic_id": "0210646b-3d70-443b-baf6-c9e3d9383fcc",
			"name": "Zambi",
			"tag": "Personagens Maneiros",
			"imagem_name": "tropikalia-char-zambi"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/99c40264-165d-465b-8f55-22069d62fd5e/terex-masc-teresa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=bd305d720e47112c0c72648606ad725abf0ca91b515026a6869e0ec153e24399&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-30T01:28:00.000Z",
			"id": "2e806f70-fe62-4ec8-9dc5-f2f964ccedd6",
			"comic_id": "1715f655-f719-436c-843f-99aca48bfaa2",
			"name": "Teresa",
			"tag": "Mascotes fofinhos",
			"imagem_name": "terex-masc-teresa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9fcb4439-1bed-467c-8b8d-6672e14b8e3f/gatho-lugar-cazaltar.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=20204704d6b2503329a6e05876d6750c6e5cdcc9a1745b2b25f64a242bf73638&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-30T01:05:00.000Z",
			"id": "681b3d72-d1ea-48d8-9401-24304b3bff3c",
			"comic_id": "fbe83128-d63f-4ff7-8119-e005c2e652dc",
			"name": "O Caz’Altar",
			"tag": "Lugares Irados",
			"imagem_name": "gatho-lugar-cazaltar"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/94005822-14cc-4055-b12e-e3bc329d0029/ageofguardian-golpe-explosivepunch.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=9bcd046e44cdb5090fe470ff5e386fd744c7ce7f5ac856e03838afe13c5ae62b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-26T02:43:00.000Z",
			"id": "ca256c05-0832-4164-a013-9d17a3f19c9a",
			"comic_id": "e5ea81fc-e160-47e8-b3dd-60c2f119c23b",
			"name": "Explosive Punch!",
			"tag": "Golpes Fodas",
			"imagem_name": "ageofguardian-golpe-explosivepunch"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/655a8057-914b-4523-9ae2-68c533bca854/troublemakers-golp-hitsujibeam.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=afda8e98b7c03b4b04b5075ca6f28019e181a0732f017c2385b64adca95bc9e0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-23T00:58:00.000Z",
			"id": "3fd5cc8e-3355-4bf3-8178-8bc9da14236a",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Hitsuji Beam",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golp-hitsujibeam"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/eba1178f-c3c7-4ce0-9ae9-889e1b05d59c/perfectcheese-masc-cheese.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=4fcccaac4509aa45e0d474a45475afde9c750459d82e92b5cddd82ecb1d8a961&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-21T02:23:00.000Z",
			"id": "e5c55ffb-6356-453f-ba03-32fbb8cc6d73",
			"comic_id": "0347502c-39b0-46d0-8365-06d66d05f243",
			"name": "Cheese",
			"tag": "Mascotes fofinhos",
			"imagem_name": "perfectcheese-masc-cheese"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7243d3fc-222f-4056-bb9a-e1c427b4a9a3/paranormalpanic-cena-busquemconehcimento.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=e01c433496b304fe90de313081c5bf1f37b29cb27368ae1835d8259fa526efa2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-21T01:39:00.000Z",
			"id": "089259ca-6610-4890-9a46-446094c87009",
			"comic_id": "cbeb0a73-33a4-4071-8e80-93052c71a59d",
			"name": "Busquem Conhecimento",
			"tag": "Cenas Marcantes",
			"imagem_name": "paranormalpanic-cena-busquemconehcimento"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/70056f9a-169b-4d47-a196-431c458fb6e8/manakaru-lugar-hellcife.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=d75daf3bc0684c34c3106362a0d381d1b85aa363f50fb0dda9444fd14f59a5a9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-16T02:10:00.000Z",
			"id": "c4ac57b1-9088-448b-8745-0da5a3e15d14",
			"comic_id": "7723a503-f864-43d8-9f36-69e28ac423cf",
			"name": "Hellcife",
			"tag": "Lugares Irados",
			"imagem_name": "manakaru-lugar-hellcife"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6795306c-d687-4aa4-a11d-675c2558a826/doraeagata-masc-agata.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=732340b563f28f0df23e6a488a94d0d0eb2db17d8d277d59064f3b3d72639e4b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-16T01:34:00.000Z",
			"id": "d948d548-370b-4d35-b07a-b4aa11967339",
			"comic_id": "6b64791c-2cac-4b9b-bf68-9e7146bc4ac8",
			"name": "A Gata",
			"tag": "Mascotes fofinhos",
			"imagem_name": "doraeagata-masc-agata"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b5ec904f-2d86-4a2b-81af-152aa347dd52/gibideamor-onom-sinaaaaal.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=3efb1f2207a8606294dd857c12ad417bcfd611b84bf68f2d7db1c0a9109c1df7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-14T02:11:00.000Z",
			"id": "190267e5-945c-488b-b472-5c9885af0413",
			"comic_id": "1e6d9230-da80-4b06-8257-dce20a35c140",
			"name": "Sinaaaaaal",
			"tag": "Onomatopéias",
			"imagem_name": "gibideamor-onom-sinaaaaal"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a7f8cd2d-7c83-440a-8052-058d2f3dfcf7/gibideamor-lugar-institutoguarulhos.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=2421a976758d9d74cf5989ea72d6a5554d07b3ab76e394899a8d7eecf5801fe5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-14T02:06:00.000Z",
			"id": "e5ce516d-bb1b-418c-a481-286177e4d4ac",
			"comic_id": "1e6d9230-da80-4b06-8257-dce20a35c140",
			"name": "Instituto Guarulhos",
			"tag": "Lugares Irados",
			"imagem_name": "gibideamor-lugar-institutoguarulhos"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cc729d9e-bca5-47de-9c5d-a1d0a012a8a2/pansy-cenas-love.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=d88a231238865968473b989df694a2fedb19d8864ad31635975c1abdcb25bbcf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-12T02:49:00.000Z",
			"id": "6b15a885-682f-44fd-ae74-47de166d226b",
			"comic_id": "ff0749fb-8929-4f98-ac9b-0aa55e648cf5",
			"name": "Amores",
			"tag": "Cenas Marcantes",
			"imagem_name": "pansy-cenas-love"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4b00d92f-422e-4b19-a101-b52a0d535a5d/senselife-cena-acaada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=e3ec0c20626160f6fb7a66f0ee8a80ead2ac3004fe71fd63116ff75024a2e7ee&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-09T02:48:00.000Z",
			"id": "37c9f0fa-8f72-4d78-9386-2c4069bdb16f",
			"comic_id": "c7b448f3-eb39-437b-a4f0-e64c47531421",
			"name": "A Caçada",
			"tag": "Cenas Marcantes",
			"imagem_name": "senselife-cena-acaçada"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e44b9118-3ba1-4ca9-8159-92ac32b81532/newgame-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=368607d5d79a0edc24c67173be11d28cb838583555d22fd5bffa3a0fcfa15cf8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-07T01:02:00.000Z",
			"id": "1a54b836-ab13-49dd-b664-206d7bc64f58",
			"comic_id": "24f3c128-18f4-4cdc-87cf-a67dd38930ac",
			"name": "New Game +",
			"tag": "Capas Insanas",
			"imagem_name": "newgame+-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0aafec00-98ea-442b-8f2c-ae93d8657dd8/algaia-onom-kaplau.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=301d0cd5d998614d1d4afa692ebeb91bb5107342ffa1e850e2e45c1fafd3270e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-06T21:47:00.000Z",
			"id": "9cd7f640-f6a2-40a0-a563-3f3ccd44ae2c",
			"comic_id": "d4643cfd-f450-4d70-aa96-4c5224fc7132",
			"name": "KAPLAU!!!",
			"tag": "Onomatopéias",
			"imagem_name": "algaia-onom-kaplau"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e93d80ff-cddf-4650-9d8c-86923c64d78e/troublemakers-golp-hitsugihellgrab.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=75e00cf757abeadd4bfcea24c739438cf2e86bd44a62d8e5315d4ceee485939b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-06T21:45:00.000Z",
			"id": "07779ac3-bb96-48ca-aff8-cca4d4d51ba6",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Hitsugi Hell Grab",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golp-hitsugihellgrab"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/daf880b6-ca1a-4021-94b7-7c1da721508b/perdadecontrole-cena-parceiros.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=bd30517c132a34fa7d27dd1671c4c1c4480ce53c7f096c8963f3b46a419a2650&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-05T02:22:00.000Z",
			"id": "ec602b8e-83b4-4a57-8629-d38f286aa71b",
			"comic_id": "d0919065-baf2-40f1-9b27-d6d4547d2ad3",
			"name": "Parceiros",
			"tag": "Cenas Marcantes",
			"imagem_name": "perdadecontrole-cena-parceiros"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/39affebf-3021-40bf-ac4c-1f52890e8793/ironlady-ono-ratata.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=9346e15728cb51f4e4f4ceaa5fed75a50e004f799b43482b73653c474a8428cb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-06-02T01:32:00.000Z",
			"id": "a6f685ca-f1da-406c-893d-afb7b2e95a1e",
			"comic_id": "26ebf6cb-a54e-4716-91cd-4aa4d3574c61",
			"name": "Ratata",
			"tag": "Onomatopéias",
			"imagem_name": "ironlady-ono-ratata"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/459af1c8-0be3-4640-b44b-2542587073ea/escarrabrasa-cena-escarrafuria.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=aa109c70d06925b035bb82f4f21b0c42c880abf509785c0693f70ccf24ca8d3d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-29T02:50:00.000Z",
			"id": "35ce0491-5f02-40ed-84a5-31b84fe89042",
			"comic_id": "090c2337-1a29-4a4d-a6bb-200f11531fbb",
			"name": "Escarra Fúria",
			"tag": "Expressões",
			"imagem_name": "escarrabrasa-cena-escarrafuria"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/88a41b59-9c7e-41c5-a7b3-18694104b8b1/escarrabrasa-cena-redfury.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=8d14f17b01f442c4c4b7f9c4a6914f372baa0951dff1d75c6884801567c86df6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-29T02:43:00.000Z",
			"id": "cfb168df-9e7b-49a8-9291-c0dca518ec69",
			"comic_id": "090c2337-1a29-4a4d-a6bb-200f11531fbb",
			"name": "Red Fury",
			"tag": "Cenas Marcantes",
			"imagem_name": "escarrabrasa-cena-redfury"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/dfc02d67-f4e4-4dbf-9dc5-223bd32171ed/newgame-cena-npc.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=ac26d7a12171bdeb019a063200547c65d8536e53bc9ac2623ea553936abaae43&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-29T02:13:00.000Z",
			"id": "ccc289bd-532f-4d6a-82ca-039100472e53",
			"comic_id": "24f3c128-18f4-4cdc-87cf-a67dd38930ac",
			"name": "NPC agradecendo",
			"tag": "Cenas Marcantes",
			"imagem_name": "newgame+-cena-npc"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f79d7adf-d2e1-43f2-b8d5-4932143fd616/newgame-exp-npc.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=a0c955e1b8733abe662b19fe20cdc2c13b65c8155afb29752a4dc220de49c791&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-29T02:03:00.000Z",
			"id": "7447b0cf-d91b-4821-a863-92398419ef3f",
			"comic_id": "24f3c128-18f4-4cdc-87cf-a67dd38930ac",
			"name": "Npc",
			"tag": "Expressões",
			"imagem_name": "newgame+-exp-npc"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4acb2e6c-31b3-48a9-a069-98cfe03055e3/newgame-ship-npceheroi.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=1f21c06aecd9c4e46f422df70344333038fec6a9a852c65e488ffed5eba92f42&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-29T02:00:00.000Z",
			"id": "9dc421fa-22c5-40aa-8fec-b4dcccb4d3db",
			"comic_id": "24f3c128-18f4-4cdc-87cf-a67dd38930ac",
			"name": "NPC e Herói",
			"tag": "Shipps Fofos",
			"imagem_name": "newgame+-ship-npceheroi"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6b342508-558c-4bef-8450-0869cf49b26b/comvoce-ship-tanemishino.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=ed131b6c426d20b139387f54f517db42235454dddefc3e138de3e8f1827c13a0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-29T01:40:00.000Z",
			"id": "49913785-4dd2-4bb8-9d0a-ac9ef2bfcd5b",
			"comic_id": "7f802b99-e08b-490a-9137-443fffa7a9b9",
			"name": "Tanemi e Shino",
			"tag": "Shipps Fofos",
			"imagem_name": "comvoce-ship-tanemishino"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5f60eacb-1f16-4c86-9c8e-7f6d17fc32b9/ainsurgenciaceleste-exp-camisa0.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=ad75d61e39182d91fbcf29a05a01e37e8d56d0a78083d55cd6eb47ccef723916&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-28T13:46:00.000Z",
			"id": "1e03026f-bc6b-41ae-93b8-1dcb0e27afa5",
			"comic_id": "f37b3e11-ecf3-4c6b-be20-8da070592520",
			"name": "Camisa 0",
			"tag": "Expressões",
			"imagem_name": "ainsurgenciaceleste-exp-camisa0"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b0ddd07b-cdb5-4f32-b754-36bffd87d488/cafeina-exp-vounada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=2cfde1753edf65aacad0016e3e8da6dcba06ad4cb87ebdf00d22d3d81c071960&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-28T13:03:00.000Z",
			"id": "fa35ec23-6cc7-43e6-b40b-3775bb1509da",
			"comic_id": "d8b9d5be-68f9-468c-b4a6-b5a85dbbb39c",
			"name": "Vou nada",
			"tag": "Expressões",
			"imagem_name": "cafeina-exp-vounada"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/34cb883c-3d0d-48fc-bc94-1004ab8aeb73/formaouconsciencia-cena-pactododrago.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=77175242976e48d7a6b56bd117479d9fa1241ac28a779db91c012899972b4f76&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-19T02:35:00.000Z",
			"id": "48723b1e-51d4-46d3-a87f-294c3e6813fc",
			"comic_id": "9f11910e-5cd3-4839-ae88-55df741c43ca",
			"name": "Pacto do Dragão",
			"tag": "Cenas Marcantes",
			"imagem_name": "formaouconsciencia-cena-pactododragão"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8dc8fadb-3268-4c77-8939-e9e973651063/tobiassalazar-char-tobias.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=86aac2473b8c4b2a2f9d10737d819acf16fec9a9d235fa65dfb544386bc7fa46&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-17T02:31:00.000Z",
			"id": "7e3e320f-d32a-4203-8698-3d6eb914b665",
			"comic_id": "2dbad268-6f3b-4c1f-9adf-63cd05c7ae96",
			"name": "Tobias ",
			"tag": "Personagens Maneiros",
			"imagem_name": "tobiassalazar-char-tobias"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/44f2f218-4b44-4b70-a649-cc0145a73d88/colatino-ono-chablau.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=66cc226576da42d6fd72947fd935ae36de9e46aad5f8ceffafb823cdc9601bf0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-17T01:36:00.000Z",
			"id": "bda61894-ec7c-458e-9978-679db1ce980b",
			"comic_id": "517eea1e-3d6a-4a83-bb47-b03949210ac2",
			"name": "Chablau!",
			"tag": "Onomatopéias",
			"imagem_name": "colatino-ono-chablau"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/53ecd1f9-d34e-45b2-889d-8ff77034f5f0/garotatoupeira-lugar-rj.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=8aa2310540bae1770e00ad4fba7299e60000b8f32f401f878d020792b6faa26c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-17T01:05:00.000Z",
			"id": "b8447fb7-46d9-4ed3-9b27-91b47bb48529",
			"comic_id": "dc969a78-2295-469f-8785-db15ddb9ea84",
			"name": "Rio de Janeiro",
			"tag": "Lugares Irados",
			"imagem_name": "garotatoupeira-lugar-rj"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f2c5caee-672e-4d99-af0c-5b0fbe0d42b6/garotatoupeira-char-molly.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=b1d71ec23a75f36bc2ff6c17b889304ee3eebc37eafde36ec7b881a16eb6df4c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-17T00:57:00.000Z",
			"id": "80865ead-9c87-4bcc-af3d-61ece4bea9c8",
			"comic_id": "dc969a78-2295-469f-8785-db15ddb9ea84",
			"name": "Molly",
			"tag": "Personagens Maneiros",
			"imagem_name": "garotatoupeira-char-molly"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f934ff7f-32c9-4533-aea5-44a86af4ef74/reidelata-golp-furacaodesocos.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=0c8aacea7009b564c8608f9550f167b539d49263adbff2c5182baff5866c80de&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-12T01:39:00.000Z",
			"id": "c896cbbe-f0ae-4bbc-841d-0a9917c27616",
			"comic_id": "31a09d13-11d9-4b66-b43b-41a845aa0df7",
			"name": "Furacão de Socos",
			"tag": "Golpes Fodas",
			"imagem_name": "reidelata-golp-furacaodesocos"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c40fc8eb-09db-4097-b91d-217f37701440/reidelata-exp-ruivo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=d3b28703fe95a30ca818b619ec0e758579bb9328aa6f50b081b2b74887ccd90e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-12T01:27:00.000Z",
			"id": "de058266-0f49-44d5-bbff-3e2f72df3740",
			"comic_id": "31a09d13-11d9-4b66-b43b-41a845aa0df7",
			"name": "César",
			"tag": "Expressões",
			"imagem_name": "reidelata-exp-ruivo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e617a416-4b75-4cd9-beaa-f353d338140f/purpura-capa.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=44f8081012dbf322e402b466e4144534cfdef1d0e8173c849f7ee8121154e344&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-10T17:35:00.000Z",
			"id": "cc259bd9-1dec-4e95-b7ae-e1a1aa16b5b3",
			"comic_id": "edc72a4a-cf3f-41e7-83a2-3ff40ef31ca7",
			"name": "Púrpura",
			"tag": "Capas Insanas",
			"imagem_name": "purpura-capa"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/346092d8-bd2f-4a76-98d2-1ad4c45142a8/agrandegrug-artef-aneldedolperganger.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=2698d54a2d20a637dfe92739e129010f603352b1746a1003196f91eced0b0179&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T20:57:00.000Z",
			"id": "c95a6598-e640-4b3f-b231-86e436323168",
			"comic_id": "0cfdec41-2fe1-4099-8d19-affd648ee609",
			"name": "Anel de Dolperganger",
			"tag": "Artefatos Lendários",
			"imagem_name": "agrandegrug-artef-aneldedolperganger"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/150d63db-d0f4-4ffe-a3ce-63e5fde8b51b/toolschallenge-artef-ferramenta.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=9134fdd37f6ff6a9afe0d8e0225a00f19434b6a8d440048ef4e61445e78a2276&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T20:55:00.000Z",
			"id": "2ee34d94-cf43-4128-a9b8-a04b697f8e7f",
			"comic_id": "93159c36-f24d-4328-848b-e25273994629",
			"name": "Ferramenta do pai do Raion",
			"tag": "Artefatos Lendários",
			"imagem_name": "toolschallenge-artef-ferramenta"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9ce04074-e3c8-4b19-a767-3f322600f23d/lendasdeveracruz-artef-armatemplaria.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=5334c61117bb78975e9530ba7d678729db93b044f4bf521caf413b5a1cb38d43&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T20:54:00.000Z",
			"id": "1e7f07c6-0b88-4890-a93a-1fd6391d5ebf",
			"comic_id": "854abf8f-4679-44af-b544-600b8ba7416b",
			"name": "Espadas Templárias",
			"tag": "Artefatos Lendários",
			"imagem_name": "lendasdeveracruz-artef-armatemplaria"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7c7c91e4-363f-4386-b4b6-34ed6945a3be/lendasdeveracruz-lugar-saofranciscopng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=a242c0218b72a658ff8c324a2e4d9b1ed4d24cba30ac99c283887afd71f1bfc5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T20:52:00.000Z",
			"id": "dce7e4ba-21a3-4f71-8c36-8552f24bf1b2",
			"comic_id": "854abf8f-4679-44af-b544-600b8ba7416b",
			"name": "São Francisco",
			"tag": "Lugares Irados",
			"imagem_name": "lendasdeveracruz-lugar-saofranciscopng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/286417c7-5da3-4617-9748-35e7f111830d/unluckycrow-multi-troublemakerspng.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=3ffd8b6c7d38f9b339308e21ec29543afec5acebc95913d32b8e0bf3e8e42978&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T20:23:00.000Z",
			"id": "4ad34fb4-a5c4-4bc1-ba9d-28b7674ceb66",
			"comic_id": "707b68d5-b4f4-4923-9b59-89324371ea82",
			"name": "Trouble Makers logo",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "unluckycrow-multi-troublemakerspng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f5969691-f7d9-4bb6-b13f-59d2bf5d49ae/unluckycrow-multi-nativopower.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=120e5c564156ab3f7cc6a06551959247daa822bd5a89daf8585d5d066a96ca20&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T20:22:00.000Z",
			"id": "beb47856-d6bb-4a16-b704-632034ed1e45",
			"comic_id": "707b68d5-b4f4-4923-9b59-89324371ea82",
			"name": "Nativo Power",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "unluckycrow-multi-nativopower"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/26e43711-82dd-4d92-9463-5200a3cb73c4/perdadecontrole-shipp-erikamy.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=e1bb855a05d62c2fb2a589923d9f0109f824c83e8e9df88b7c5fc38d3d7e3ddd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T20:20:00.000Z",
			"id": "122554ce-db57-4f5a-ab98-8f534c571d70",
			"comic_id": "d0919065-baf2-40f1-9b27-d6d4547d2ad3",
			"name": "Erick e Amy ",
			"tag": "Shipps Fofos",
			"imagem_name": "perdadecontrole-shipp-erikamy"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/180e2e12-307e-4665-bfe8-8a3ce56e5b87/arthureosol-cena-eunaoqueroficarsozinhodenovo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466VCA6YKDK%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232850Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJHMEUCIEHghehCJ7BvvULzVntNxbgH%2FNVZIGyHM2IYrq6BKJcuAiEAkpjDzmle0GC0IW79NZ72zScHuAysEhFPAlXecLoT0hoqiAQIq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw2Mzc0MjMxODM4MDUiDIxnuD%2Bv2vEYaBTvAyrcA6JXlWXejrhgjC%2F8sK5ozVaaApOBPDk5tbHrj6RqaKO3MRZjNeeGJKDREIhZJCyPmpFyAbQ9GGPXtD1aunykSiHSUwGjP7MlKxpNkpVx%2FcsTBoOtuSm0wtEaS7x2EzEZDIimBh%2BIk4leB0qk%2FcOPnWwgJa5sNvyXPcX4ZJ70G6diFyFgVYSVtKFKlKJ%2FWhgBjCqoqtW3JAXZykEGa3pnTXKbnjiv6pVKJCteKoU6u2kTkT9NNFMfVQjPoeM%2BQSRq%2FP9RIZT8ZEr9P%2FFzt4MBAapwng%2FOEhiz%2FiW29VX%2FT8qeyCXiKZ1ICH8nq5yCK5HMpyn%2Bv1Z6DqUcN7MO4fJ%2BJcQAgkr6ramjCZkl74WlyQx3V8w0wBznbMlWitXpJlPm4QwiujNKplv%2FN7QSEwrS1eLgVfKqKX%2BqVpe6Qqm5FjI%2FpM3GCmh31fBpcUef1gjm9t5BvHysh%2Fp6kbObwUsW5dHBJWah7d6ckxdActe%2FhtVWnv%2Fv5cYxIEPCu8PtA48GEPkUr%2BjY%2BriHRlhUGukfekgAEHNm%2FdK7Jsftcd60L6nc%2F79Fu5kK9Q0VFDXuehTHj%2F%2FgBH2kGjFirSgNzs34fC%2FLxFW7v25DW4ceOW3u154%2BnSMTTS4gcM1uMJJAMP24q78GOqUBLLDZtIV7cikG34rGWtbXJcvj1Oc%2Bqu0R1jlmttwdtiOY56eEX9scLWU6PFjgQWo%2BtUnz1vsK2mWJhIZc4RSXqLBvKKkT%2FkB0ULmv9lWVLOUWEHcRP1pyDzmmeeF2Z1ziRtIZc0thcCapfqsph7HQ%2BYRPJIpiZFHNa8%2BXsoAHZ%2FHaYi391WP4NcFcffleClaqHWiNrecHaiTqRhVSPfTQ9evnhCSR&X-Amz-Signature=c981563105e89d07ca45417eb85b1508714dccc281d71e6cfaabffd9bea5f5c0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T20:09:00.000Z",
			"id": "84eb3134-aebf-4284-988f-af9459baa1fc",
			"comic_id": "17397722-d811-4e0a-a42b-11d7fdd5f0c0",
			"name": "Eu não quero ficar sozinho de novo",
			"tag": "Cenas Marcantes",
			"imagem_name": "arthureosol-cena-eunaoqueroficarsozinhodenovo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d56134fd-a7dd-4e5f-b340-c2adc0607b0e/acquine-shipp-niccoeshun.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=3e41e7c3edc6ed08c424b4197ce17b8c20f0da21a6e0ba7b94eee92513f87a23&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-09T20:06:00.000Z",
			"id": "e3e8a61a-8891-46c0-ac44-a1f23730ef31",
			"comic_id": "7140661f-836c-4661-8432-31b2dbd9020f",
			"name": "Nicco e Suhn",
			"tag": "Shipps Fofos",
			"imagem_name": "acquine-shipp-niccoeshun"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7d8a8eed-6e53-451b-b34b-f747cab61470/vaderetro-cenas-vaderetro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=f260c3056be32dd3bf03cfa5ebdab3f65f82414b7873d4caf10bf706cab1c383&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-08T01:55:00.000Z",
			"id": "c471cb73-9e0d-4107-a880-80cab0ffba61",
			"comic_id": "ac948942-dc73-4bf2-8141-c293ff73c1d5",
			"name": "Banda Vade Retro",
			"tag": "Cenas Marcantes",
			"imagem_name": "vaderetro-cenas-vaderetro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2168df10-5e0d-40ed-ae14-12684803e1de/lendasdeveracruz-onom-currupio.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=b3d64d9a1846c253c1f7b3f04a7a73459e51e0f3794f57f3e9759465f237b600&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-08T00:58:00.000Z",
			"id": "e0ac7877-9134-49f3-b572-38243dc0b18d",
			"comic_id": "854abf8f-4679-44af-b544-600b8ba7416b",
			"name": "Currupio",
			"tag": "Onomatopéias",
			"imagem_name": "lendasdeveracruz-onom-currupio"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/69a272c9-f88a-4d83-ac13-f4e6b400984a/madreluna-char-madreluna.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=4877d42fb3fadd7cee8c2f199bd9efcb02b436b2aa994c17cb590a8e1651a6fe&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-03T02:30:00.000Z",
			"id": "54b88daa-11b6-4014-93c0-80f54ef08ab4",
			"comic_id": "89952172-36cc-4170-89a8-8f841dc4534e",
			"name": "Madre Luna",
			"tag": "Personagens Maneiros",
			"imagem_name": "madreluna-char-madreluna"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/effce758-4485-4f49-b031-a5dde70aec93/miracledog-masc-doguinhomilagroso.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=e070b5da8d641d5e153a69c56adaa777cd075bf16e095efc2ac91cd678c9fb75&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-01T03:53:00.000Z",
			"id": "d450ebda-aa14-4f34-b90a-c09c494e6219",
			"comic_id": "95bc977f-1791-4b9a-8b2a-0f105f2a5254",
			"name": "Doguinho Milagreiro",
			"tag": "Mascotes fofinhos",
			"imagem_name": "miracledog-masc-doguinhomilagroso"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/64588438-6326-4eb4-9495-6027d495a98f/insanecrow-lugar-lacasadocaralho.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=01527e55fc5d45b5a95766d03f3241c5784d5feab58fa2a08ca77f9665c9aed0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-01T03:10:00.000Z",
			"id": "e7d728b7-3a19-474c-b7ef-1b7e33e8f657",
			"comic_id": "360d16a9-8f7a-4182-bb76-c95acbeb6168",
			"name": "La casa do Caralho",
			"tag": "Lugares Irados",
			"imagem_name": "insanecrow-lugar-lacasadocaralho"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/acd31dfd-7501-4d5b-951a-8ff9d898d1d6/insanecrow-artef-craniodecorno.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=98e56bb894f9d54721ccd33c308ae231f5a6d9732ec241bfc94e89c15257e96d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-01T03:04:00.000Z",
			"id": "d8fb4b87-5756-468e-9f5a-4b10ffc50ce7",
			"comic_id": "360d16a9-8f7a-4182-bb76-c95acbeb6168",
			"name": "Crânio de Corno",
			"tag": "Artefatos Lendários",
			"imagem_name": "insanecrow-artef-craniodecorno"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bde3ff89-e198-42f2-9d76-bbd2483b09cb/insanecrow-lugar-entquerido.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=3a68b9390dba042f182352d316de21685a57f01f52876bd11dac77cbbc4abeec&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-01T02:58:00.000Z",
			"id": "245740a1-07e0-486a-8e76-92e7e9a98b61",
			"comic_id": "360d16a9-8f7a-4182-bb76-c95acbeb6168",
			"name": "Ent Querido",
			"tag": "Lugares Irados",
			"imagem_name": "insanecrow-lugar-entquerido"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f34be5ed-5a62-42dd-92e4-f334c2f890e4/insanecrow-masc-nyu.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=8445b784603992ee456dd377207848c3c7d7ce823b61db6511e11f82e635e301&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-01T02:54:00.000Z",
			"id": "2dafc643-4d10-49e8-b339-42a427b7133f",
			"comic_id": "360d16a9-8f7a-4182-bb76-c95acbeb6168",
			"name": "Nyu",
			"tag": "Mascotes fofinhos",
			"imagem_name": "insanecrow-masc-nyu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/444ebd18-9fa2-48ed-96d2-3f092fe3d49c/jerimun-char-jerimum.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=a942c56b5f36835720d58bfd40a71194a1be982174b8ad68e9ce919e7108e420&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-01T02:31:00.000Z",
			"id": "9a876cc5-7c40-4d22-8634-5f2e2eeed794",
			"comic_id": "02495cc0-1fc5-417a-82a1-8ea77bdfb0ce",
			"name": "Jerimum",
			"tag": "Personagens Maneiros",
			"imagem_name": "jerimun-char-jerimum"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/660f55b6-f6be-419c-91a5-fddff6833e41/jerimun-exp-hein.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=a14b80dc99a70b1807c3dc2d68001d3be2c89bb7a0eff63c19be6575db594852&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-01T02:22:00.000Z",
			"id": "709288de-f9dd-4e44-a899-57a6a5bdec54",
			"comic_id": "02495cc0-1fc5-417a-82a1-8ea77bdfb0ce",
			"name": "hein?",
			"tag": "Expressões",
			"imagem_name": "jerimun-exp-hein"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/94382f46-cc55-4a2b-86d4-f01eadf163f0/jerimun-lugar-casadocao.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=40e6d7c9c76e9c28a4cdff1772f19090582ead4f608ced672ce5fc1b57e6bc3d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-05-01T02:15:00.000Z",
			"id": "4876af57-aba0-41e5-b63b-467f10f04736",
			"comic_id": "02495cc0-1fc5-417a-82a1-8ea77bdfb0ce",
			"name": "Casa do Cão",
			"tag": "Lugares Irados",
			"imagem_name": "jerimum-lugar-casadocao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/329bfa1d-766b-4b32-9249-de2885aa26ae/perfectblack-onom-bololo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=d466d6ae2d02cb8953281a9b727e8a80b389896436de9b06011d72606e7913c2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-28T02:19:00.000Z",
			"id": "8218d76c-ae8c-4e98-9fa9-858cd3c968e3",
			"comic_id": "1b3bfd55-ad83-4fb9-9b42-b1cee3b61801",
			"name": "Bololo",
			"tag": "Onomatopéias",
			"imagem_name": "perfectblack-onom-bololo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5c350125-f522-4403-a0c0-6ff99870719c/redoni-char-drago.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=3f1d69de665287defa61880effab6492262353c48dd0c15aed4651f6308fd76c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-26T02:12:00.000Z",
			"id": "1c898cf8-a6f4-4fa0-bf3a-213d01d618ef",
			"comic_id": "d2f86747-726c-42bd-882f-37c8c208e687",
			"name": "Rakshasa",
			"tag": "Personagens Maneiros",
			"imagem_name": "redoni-char-dragão"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5079f37c-9129-4944-a4cb-2325bcf28a69/omonstrodebaixodacama-exp-garoto.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=61efe0fe478c3a59a02af19ccfd015f48a775c85db0df0c4f60da77607819500&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-24T03:44:00.000Z",
			"id": "56d0895f-5a54-4ca5-a42a-72fe87744238",
			"comic_id": "ab92b08e-9276-43bd-9c7b-feef1006dc45",
			"name": "O garoto em cima da cama",
			"tag": "Expressões",
			"imagem_name": "omonstrodebaixodacama-exp-garoto"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d5a6f9d3-83d7-41f0-a46f-37455ac83b4f/omonstrodebaixodacama-multi-guerreiroestelar.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=bc05db71748f03f137e1c676142f9ff550b735dcd2d59c96cd744a7792e47de8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-24T03:35:00.000Z",
			"id": "b05e739b-861b-497e-933e-675c1aba255a",
			"comic_id": "ab92b08e-9276-43bd-9c7b-feef1006dc45",
			"name": "Poster de Guerreiro Estelar",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "omonstrodebaixodacama-multi-guerreiroestelar"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e70a8890-e688-4b59-8702-5f213b38cb16/omonstrodebaixodacama-masc-biscoitosalada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=06748c17ca3cf22017ef18430e36a7e86bf246d2e537ed856b2b8e44abaac67e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-24T03:34:00.000Z",
			"id": "9701f832-093e-4687-8a27-fe5020782c2e",
			"comic_id": "ab92b08e-9276-43bd-9c7b-feef1006dc45",
			"name": "Biscoito & Salada",
			"tag": "Mascotes fofinhos",
			"imagem_name": "omonstrodebaixodacama-masc-biscoitosalada"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/18cec8b3-7e00-47ca-aa05-963255f64446/omonstrodebaixodacama-masc-drago.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=555e069e4dddce7d72ca75ccd2c50e7df737938262f0338eaf9a879ad47694c5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-24T02:36:00.000Z",
			"id": "af571222-7436-41a4-89f2-ccccda1d5564",
			"comic_id": "ab92b08e-9276-43bd-9c7b-feef1006dc45",
			"name": "Drago",
			"tag": "Mascotes fofinhos",
			"imagem_name": "omonstrodebaixodacama-masc-drago"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bebad15b-9b5d-4ec5-bbc8-e75e0ba898c2/naoidentificado-lugar-discovoador.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=0565390f9b621f79f1f7a97806d398343e0bdfa3529f1a2533f26023bd987942&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-21T03:11:00.000Z",
			"id": "263827a4-12c7-4bc6-a30d-6c92c42c51cb",
			"comic_id": "0263228c-1be2-48e4-8e69-a8d2520867b0",
			"name": "Disco Voador",
			"tag": "Lugares Irados",
			"imagem_name": "naoidentificado-lugar-discovoador"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3256d58e-4852-4fd2-b6c4-c3ac778407ad/aretomada-cena-golpedeestado.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=19126e4653e1e8f5307f6ab51d9b098ec23a9fc78c492917fe9b6d15eef5512c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-21T03:11:00.000Z",
			"id": "e1045f13-6a30-4be8-a409-d78a7a24f58d",
			"comic_id": "d03f85f3-40c5-4da9-b942-b058e5a6bb0b",
			"name": "O Golpe de Estado",
			"tag": "Cenas Marcantes",
			"imagem_name": "aretomada-cena-golpedeestado"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d84bd48b-df45-4996-b579-685046740103/aretomada-onom-vapo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=c319fff6d51c1e300d5e542b1004df29e2fc762e4d3699949c3c28394bd31b2d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-21T02:27:00.000Z",
			"id": "8b53f44a-ea0e-4b6e-b5f3-95e8f4ddce26",
			"comic_id": "d03f85f3-40c5-4da9-b942-b058e5a6bb0b",
			"name": "Vapo",
			"tag": "Onomatopéias",
			"imagem_name": "aretomada-onom-vapo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/99abe44d-7321-49c9-b6cf-724a4e87b543/embaraada-char-prot.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=33e3ba2cee298c25b3f0066cee456748c435fa64e1afa00663ab8b5d7e0cd811&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-21T01:15:00.000Z",
			"id": "b5761a02-85d2-4e10-a3b3-003b0f8ce9f3",
			"comic_id": "e17d9f15-cd14-4159-8b87-fafc651ca856",
			"name": "Embaraçada",
			"tag": "Personagens Maneiros",
			"imagem_name": "embaraçada-char-prot"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1873a2de-8992-4836-801d-12a411ff68e5/stellacintilante-multi-restaurantearmonpng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=88daabcb22168dfa900d9cbe8dc96b92726d824f4d128cc21802f7d63c9081ca&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-19T02:56:00.000Z",
			"id": "ae8eda4d-806e-4b2f-aa50-dcdba604779f",
			"comic_id": "c427aea3-68c3-461d-a2b1-88e2a2d24484",
			"name": "Restaurante Armon",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "stellacintilante-multi-restaurantearmonpng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7b4bba20-7ee9-400e-b5ab-965651869bf3/stellacintilante-multi-sabadodesucesso.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=ab40f1fd9a09cbc3cfe3a00f51a33312784355aba5b4592ebe864a762769875a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-19T02:50:00.000Z",
			"id": "fb78ae1c-10dd-4caf-b9d4-685193974eeb",
			"comic_id": "c427aea3-68c3-461d-a2b1-88e2a2d24484",
			"name": "Apresentador de Sábado de Sucesso (Inusitado)",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "stellacintilante-multi-sabadodesucesso"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7d039e6d-a978-4c5a-b59b-0cf79b876e55/aordem-multi-soberania.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=f6dbde79e49be7dbd4e4248d29b963cc2248af25bddf1aa16bb5c53f914fca00&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-19T01:21:00.000Z",
			"id": "a6b4c196-c0f9-43c6-9058-b6b21c65a0a5",
			"comic_id": "838f81b2-c452-403d-a9dd-df82780b5d9a",
			"name": "Protagonista de Soberania",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "aordem-multi-soberania"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6bd1e600-2597-4949-9cd5-ae2ae17afbec/istella-char-istella.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=d1fc999126f085ff00f8198238908862410987159f90d408e64646efff1a7dd0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-17T03:05:00.000Z",
			"id": "564ab633-cc66-4ad4-81be-d64cbe5ed4a5",
			"comic_id": "486d5639-4ac3-4279-aff1-c53f9da4efc4",
			"name": "Istella",
			"tag": "Personagens Maneiros",
			"imagem_name": "istella-char-istella"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/eabaefd9-ea0f-4c52-bca1-1e477612886f/alice-ships-aliceekaio.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=7fc52315129f1dcd25e8be8786503186c9ef54138cc7aba4f6d5aa14f365735f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-17T01:39:00.000Z",
			"id": "82c970a9-93fd-49c3-827a-5a0d7a32ef30",
			"comic_id": "e2dae309-4512-4655-a62e-33fe84772d27",
			"name": "Alice e Kaio",
			"tag": "Shipps Fofos",
			"imagem_name": "alice-ships-aliceekaio"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/74902c9b-49fa-427c-94b0-7213c5ba4660/unluckycrow-exp-cientista.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=0e91a53933a5cc667db8378c49abd5cf7e6913100142adffae2f62e73b28fddb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-16T00:59:00.000Z",
			"id": "9643f7f9-b6bb-4088-b058-1ee9689e1011",
			"comic_id": "707b68d5-b4f4-4923-9b59-89324371ea82",
			"name": "Gilbert",
			"tag": "Expressões",
			"imagem_name": "unluckycrow-exp-cientista"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/06e31f95-f1be-40e4-a917-c3643728bb8a/acoordenada-exp-antonieta.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=6727289131569b822d89d5c0c2362129b0d7a35674affd07ccf814df0cfbe20e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-15T23:28:00.000Z",
			"id": "b9a46dde-5c88-4ee0-ac4d-b1f810b8d490",
			"comic_id": "f9b208d2-8e61-42a1-bea9-16b737f324c0",
			"name": "Antonieta",
			"tag": "Expressões",
			"imagem_name": "acoordenada-exp-antonieta"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/29de1c39-e181-4207-8924-b96a661510da/irauna-masc-doguinhospng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=babde2799c1d00797793ddb597a9c7e335854fc3db11411deaa0dd6adf5b806c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-15T22:13:00.000Z",
			"id": "3bfc7a4f-dc59-41a5-a8ba-a599f5005000",
			"comic_id": "4d47ce5c-cd75-4af4-8a81-9d7f4bea3ef0",
			"name": "Cães Espectrais",
			"tag": "Mascotes fofinhos",
			"imagem_name": "irauna-masc-doguinhospng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b45b78a4-0c65-46e0-9952-b88dcd600e6a/irauna-artef-facasobrenatural.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=74a33340c2cabd2ffdb6a621c6781884aada66222e7ad77b106fe09efca9279f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-15T22:10:00.000Z",
			"id": "4f5f54f4-5088-4122-bf06-d96b0fe9fc06",
			"comic_id": "4d47ce5c-cd75-4af4-8a81-9d7f4bea3ef0",
			"name": "Faca da Boa Presença",
			"tag": "Artefatos Lendários",
			"imagem_name": "irauna-artef-facasobrenatural"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/be3c26a9-efcb-4e00-b693-2b57989c0ef8/bluemoon-cenas-basil.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=ff0a37fce541dbccd01abc2bd1965f7cdba21235dcdd2a88af829ece0c14347a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-15T21:06:00.000Z",
			"id": "3e9e889a-ad79-4dcc-a06e-d2c3446c30f6",
			"comic_id": "38ee8870-8d2d-4fae-b521-027f80b2e117",
			"name": "Vai Basil!",
			"tag": "Cenas Marcantes",
			"imagem_name": "bluemoon-cenas-basil"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c4206047-b584-481c-b399-0370aea3d701/aquelapequenaedocefadamortiferaemnossocaminho-golp-deathslice.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=c806b609aa56a549af2112548de1eaca891b3963ea570bc5c005dfd9427c39fc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-15T20:45:00.000Z",
			"id": "e3f5df19-6bf4-49c1-b4f4-f68068ddf801",
			"comic_id": "78bbee2b-2991-4855-af23-f3195143b536",
			"name": "Death Slice!",
			"tag": "Golpes Fodas",
			"imagem_name": "aquelapequenaedocefadamortiferaemnossocaminho-golp-deathslice"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0db2d5d4-de32-415f-828b-d9df70867670/seasonsofavallen-cena-floraguardi.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=10c75e87a87661d151c88ea30a3825cd164694ce8e5cc4bcaeae20535abe79eb&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-15T19:11:00.000Z",
			"id": "d74cb11c-cca1-4487-b7b4-2c9aa6631a8e",
			"comic_id": "b793ab96-6a5a-4b5a-8157-c95d5d157210",
			"name": "Flora Guardiã de Avallen",
			"tag": "Cenas Marcantes",
			"imagem_name": "seasonsofavallen-cena-floraguardiã"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/930844fa-5356-4873-8624-ee976d2c4080/seasonsofavallen-golp-springsalegro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=e585c573d17d27edf219f5de65c1ce5dba5a723804f9187a221a047435ed22f7&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-15T19:01:00.000Z",
			"id": "83470728-d3af-4cbd-999f-468fdcc52083",
			"comic_id": "b793ab96-6a5a-4b5a-8157-c95d5d157210",
			"name": "SPRINGS ALLEGRO!!!",
			"tag": "Golpes Fodas",
			"imagem_name": "seasonsofavallen-golp-springsalegro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/26a2b993-3cd5-4235-af0f-7d4347dea28e/senselife-artef-fuzilpng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=5a0d62865042b4294e5861ba3f6f76164b58a3adca2de2af4f32679cdc7d1e8c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-15T18:40:00.000Z",
			"id": "62f5f4e6-adb3-4b2b-8b13-58f0a4cbcd49",
			"comic_id": "c7b448f3-eb39-437b-a4f0-e64c47531421",
			"name": "Fuzil de Noah",
			"tag": "Artefatos Lendários",
			"imagem_name": "senselife-artef-fuzilpng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4b104885-fc01-4388-8489-006ef97debd9/lily-chat-lily.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=b05aaf1da58f1434edbfb6624b74c59420aaa61f0970b791749bdc0d12820a3f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-14T03:27:00.000Z",
			"id": "9576f792-741f-4f18-a747-1710d4aeef5e",
			"comic_id": "b7242228-56cd-42a4-b119-ba9b5e23ef4c",
			"name": "Lily",
			"tag": "Personagens Maneiros",
			"imagem_name": "lily-chat-lily"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bf75992f-c2d8-4ac4-ac7a-21cee5f7c2be/aliceanimo-artef-espadao.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=00e7b36096d540b9ae23f6f824fb61accb435452bf07401d5681933623b54474&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-14T01:46:00.000Z",
			"id": "c8ec4ba7-5bc5-4467-97f0-9fd8d695484b",
			"comic_id": "6b863645-18c8-463a-8e85-7007950d2329",
			"name": "Espadão de Alice",
			"tag": "Artefatos Lendários",
			"imagem_name": "aliceanimo-artef-espadao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e6fee9e7-7899-474c-ba12-d2117ca59fb7/superguerreiroomega-masc-kaiju.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=5354f3f5a4ebece99fb83e41b451c31b4fbe01be87557ac189158d041cb54f45&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-12T04:03:00.000Z",
			"id": "8440094d-fd37-4268-9b80-85b803e97e8f",
			"comic_id": "1c149649-221c-43b7-9ada-68cde9fad049",
			"name": "Karina",
			"tag": "Mascotes fofinhos",
			"imagem_name": "superguerreiroomega-masc-kaiju"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8acb12a1-b650-4017-b22b-66d563488478/superguerreiroomega-lugar-netuno1.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=0d26dc72e62eb8788c1db3a7900d84cb936288017cd69f7df7d44793fa402fdd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-12T03:53:00.000Z",
			"id": "535d8b24-c90e-4bd4-82c6-e5b2099cd413",
			"comic_id": "1c149649-221c-43b7-9ada-68cde9fad049",
			"name": "A Famosa cidade do Futuro: Netuno-1",
			"tag": "Lugares Irados",
			"imagem_name": "superguerreiroomega-lugar-netuno1"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f3b304a9-6fb8-441f-b706-38a37223c1a4/senselife-exp-kaleb.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=9165b68534cea4fcfc20195285a29a2fd290f5fa11cc4f8a422d22dccc7ab6bf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-12T02:24:00.000Z",
			"id": "c6142bfb-3088-4575-b4d1-95f1707d1c35",
			"comic_id": "c7b448f3-eb39-437b-a4f0-e64c47531421",
			"name": "EU ENGOLI hehe",
			"tag": "Expressões",
			"imagem_name": "senselife-exp-kaleb"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/64c6eeaa-ff86-4cd4-aa5b-35a4e1e4039b/senselife-cen-kalebcu.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=a9f4f4295e03b8188b2fd4a7b25faf18487a472211f296d3da6618e100f4b769&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-12T02:09:00.000Z",
			"id": "214e3782-5fc4-4cf3-9937-2bf0576ce8e7",
			"comic_id": "c7b448f3-eb39-437b-a4f0-e64c47531421",
			"name": "Você abusou do meu reto?",
			"tag": "Cenas Marcantes",
			"imagem_name": "senselife-cen-kalebcu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ce41434f-be3a-4de4-a798-0cdf195f12b5/thatspecialperson-char-florel.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=07f2fa85e4187db094a12f4ce4572ad37cbbb75c1fbb5f2283f0678822912e70&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-10T01:59:00.000Z",
			"id": "c599d96a-a4d0-4632-8d1a-7885cb967abe",
			"comic_id": "23e80167-a3ff-4a29-8130-b42be42914f1",
			"name": "Florel",
			"tag": "Personagens Maneiros",
			"imagem_name": "thatspecialperson-char-florel"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ebb11066-d7c9-4e00-97ea-6bf4bca2ec2d/thatspecialperson-shipp-springleseflorel.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=51728353e98a6f960d6496f95b7feb130778ad380b16248ed0c2171842763344&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-10T01:58:00.000Z",
			"id": "fb2e418b-10c2-4a84-b0c9-998bc5329bbe",
			"comic_id": "23e80167-a3ff-4a29-8130-b42be42914f1",
			"name": "Florel e Springles",
			"tag": "Shipps Fofos",
			"imagem_name": "thatspecialperson-shipp-springleseflorel"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/11052577-c939-4e25-acfd-73a257a964a3/ocordomistico-arted-cordaomistico.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=6b7190404c0efa8f793f1fadad57a98acc57ad170cccc6cd15b5ff349af7be61&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-10T01:17:00.000Z",
			"id": "936bd176-03ce-48b8-b623-540a2cfd7cf6",
			"comic_id": "78f442b4-c403-4c03-83dd-60e13988d111",
			"name": "O Cordão Místico",
			"tag": "Artefatos Lendários",
			"imagem_name": "cordãomistico-arted-cordaomistico"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/27ea328e-c341-4b27-b1fd-2bd77cafd11c/ocordomistico-lugar-florestasagrada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=653b5c06e026c131fb66e80db0f2a0aa27fb4cb84864f7ce92d4c54536f608ac&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-10T01:16:00.000Z",
			"id": "bfcc6fec-652e-4be1-b560-eb9027213a28",
			"comic_id": "78f442b4-c403-4c03-83dd-60e13988d111",
			"name": "Floresta Sagrada",
			"tag": "Lugares Irados",
			"imagem_name": "cordãomistico-lugar-florestasagrada"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8a6aa6f4-2a7c-40a0-96ac-ed3dae8df601/mafiadrip-cenas-jeanpeladaopng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=8f51824c5549805c45c6be83e4f912e23e6e24f9ef2749c534102e5f1177aa0f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-10T00:51:00.000Z",
			"id": "e8acefed-2e5a-4c30-87ab-d1401a9c7ee9",
			"comic_id": "6ebfd638-b581-4a2f-b168-cd145a67bd57",
			"name": "Jean Livre",
			"tag": "Cenas Marcantes",
			"imagem_name": "mafiadrip-cenas-jeanpeladaopng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/99aa5f61-b2a9-4c54-8e5c-6564f19fd1ec/monsterodyssey-artef-apresaancestralpng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=eb52c3cca390cdb46a0c342d7239f5ecb95d4c2447a3aec1046cd55f0d70eb93&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-09T15:49:00.000Z",
			"id": "2e7054f5-5f4b-4b2d-a132-9ea9cf68f3f1",
			"comic_id": "9e5f18bc-5f28-4cd1-8153-5bfe77cccaf4",
			"name": "A Presa Ancestral",
			"tag": "Artefatos Lendários",
			"imagem_name": "monsterodyssey-artef-apresaancestralpng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5848d5ec-cc82-4eed-8b94-92cb80dc4bbd/unluckycrow-artef-ovo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=8791a9f24757325c480cf0e527a24d223af5c32c7d1b2bb02bbcaa832f6990be&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-09T15:46:00.000Z",
			"id": "f60a0fff-6030-432b-b83e-4971fc02d8ca",
			"comic_id": "707b68d5-b4f4-4923-9b59-89324371ea82",
			"name": "O Ovo",
			"tag": "Artefatos Lendários",
			"imagem_name": "unluckycrow-artef-ovo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5850114f-ecf0-4a3f-8fdb-cf16bfaadc22/emocoes-artef-joia.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=da80609e1ca5e142c05dbb101c0a922063fb5be93fc1de9d99e4d05fa97cbfd8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-09T15:44:00.000Z",
			"id": "cb6d4f6a-6a60-4d94-aa70-7781ba413360",
			"comic_id": "f8db11d5-2817-4ce5-b06f-d283e7ead629",
			"name": "Jóia da vida",
			"tag": "Artefatos Lendários",
			"imagem_name": "emocoes-artef-joia"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/28abdfd5-3c17-40fc-bade-2034fdbcf9fa/mafiadrip-artef-familie.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=3194f783df4b718db570f2bdc24c6364b30b14de197fae7ee644effe9d5b9820&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-09T15:39:00.000Z",
			"id": "e8c3154a-84dc-4e29-aa18-ba52ea91e9bd",
			"comic_id": "6ebfd638-b581-4a2f-b168-cd145a67bd57",
			"name": "Jaqueta Familie",
			"tag": "Artefatos Lendários",
			"imagem_name": "mafiadrip-artef-familie"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/056c6669-edda-4345-98d8-6a40e7f27130/mafiadrip-char-marcelo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=67b9cd81161fceeada17bd635a4462b1ec9fc61e4bd3b06d7d90857f35ed2876&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-08T03:51:00.000Z",
			"id": "293924e1-2f12-4deb-9bae-b19086119b8b",
			"comic_id": "6ebfd638-b581-4a2f-b168-cd145a67bd57",
			"name": "Marcelo",
			"tag": "Personagens Maneiros",
			"imagem_name": "mafiadrip-char-marcelo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5c03267a-485f-4eea-bdd9-544b33b05c7c/mafiadrip-exp-jean.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=cdb01177541799d1db70b05c97a9e10c221e541ec13a95eb1b9e9cd6c7544a30&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-08T03:40:00.000Z",
			"id": "48fff403-ff1a-4f97-b287-afeb44e50528",
			"comic_id": "6ebfd638-b581-4a2f-b168-cd145a67bd57",
			"name": "Só queria abrir uma sorveteria",
			"tag": "Expressões",
			"imagem_name": "mafiadrip-exp-jean"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fefb5c83-0114-419f-9626-5a74550ace1b/troublemakers-golp-hitsugicut.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=ab05dcaac12e2bd554996a7c2436d05072cfa62b6a480b5d86080c4b9d8c4768&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-08T02:14:00.000Z",
			"id": "afb7f835-593c-4825-ac38-a3c63a8c8784",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Hitsugi Cut",
			"tag": "Golpes Fodas",
			"imagem_name": "troublemakers-golp-hitsugicut"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d2060b01-1abc-4c12-87be-62e48c4f20de/troublemakers-exp-wasabii.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=3716d569a1d488ddebb6b3c6c76b2610b9565afce93c800aac7ec6eb2f35a862&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-08T02:07:00.000Z",
			"id": "fd9d3cda-7b84-4daa-a014-4f5de75867d6",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Que nomin hein",
			"tag": "Expressões",
			"imagem_name": "troublemakers-exp-wasabii"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/60c6119b-be76-440e-8bae-c27c4af2a796/troublemakers-char-noriedandara.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=613e9cf64b9840815d2ddcaa657f3dcef1c13bc0b93175678d52bc5e50676853&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-08T02:03:00.000Z",
			"id": "267cfee3-13fa-4611-8180-c833c2a68233",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Nori e Dandara",
			"tag": "Personagens Maneiros",
			"imagem_name": "troublemakers-char-noriedandara"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/08ff2e26-7674-42d0-8c18-041c9a8f021c/troublemakers-masc-yobuta.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=4c60ce76f4a0ef966abe49f70ee31c332c91babe0e98fbcabf1bc18ad0ee67c5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-08T01:58:00.000Z",
			"id": "dee94ed3-921a-4add-bd6d-218af881a245",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Yobuta",
			"tag": "Mascotes fofinhos",
			"imagem_name": "troublemakers-masc-yobuta"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d2f63119-7d75-4576-811f-52f266cf85e2/troublemakers-masc-gato.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=fa31ca76336b65073021208eba71b71c1db9ca9399d735caa67bce12144d5601&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-08T01:54:00.000Z",
			"id": "b91ba354-9e70-4c2f-bf7d-77a284eae0c7",
			"comic_id": "61e72b4f-994b-4a60-9016-ac58a6af3a6f",
			"name": "Wasabi",
			"tag": "Mascotes fofinhos",
			"imagem_name": "troublemakers-masc-gato"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6c19795c-4bf1-403d-b035-7983d432945a/historiacurtaemtrespaginas-char-isabela.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=07f4e173cbace290b12e642672dfcec337e9e8b551c789dea0a46f2cf3825b1e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-03T04:41:00.000Z",
			"id": "6b8a961c-c1f7-4911-8bac-ee55b2184908",
			"comic_id": "d38c896e-a232-4a37-b913-f25b6dd974f9",
			"name": "Isabela",
			"tag": "Personagens Maneiros",
			"imagem_name": "historiacurtaemtrespaginas-char-isabela"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b3f37e17-c5dd-4e59-a184-8a9ea5247136/acoordenada-onomatopeita-pocotopng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=13c447d8ba9205ca931524866d32ca96e01c13b95936e6a2e832f893aac9f16c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-03T03:55:00.000Z",
			"id": "5f702e0a-afba-4947-9a3b-7d4709338f64",
			"comic_id": "f9b208d2-8e61-42a1-bea9-16b737f324c0",
			"name": "Pocotó",
			"tag": "Onomatopéias",
			"imagem_name": "acoordenada-onomatopeita-pocotopng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/624a9b0f-1720-4e35-8f69-833fecc45a42/acoordenada-cenas-encaradanataberna.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=c39f9e5c5da88db3159e3bca76f91d0310a6a97822c761275a7f97793a7cd8b0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-03T03:52:00.000Z",
			"id": "64a3b8fb-b5fe-4936-89c0-46ee044a19fd",
			"comic_id": "f9b208d2-8e61-42a1-bea9-16b737f324c0",
			"name": "Taverna",
			"tag": "Cenas Marcantes",
			"imagem_name": "acoordenada-cenas-encaradanataberna"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c74e70ff-c24a-432b-8af9-4baf971f2804/thetalesoflibertalia-exp-jhony.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=a3b321480f3c48819bfe0f4efcda909342fe69e32adf5d33d939eb5dbbfb1af5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-04-03T02:46:00.000Z",
			"id": "53b05482-89e5-463a-8d05-6ac645681b4c",
			"comic_id": "d3b18c21-6ef4-4068-993d-0e25f25c7a5f",
			"name": "Ooof",
			"tag": "Expressões",
			"imagem_name": "thetalesoflibertalia-exp-jhony"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d1ff221e-fc10-4261-a5eb-8a2ca3d47f69/oretornodekurt-exp-imt.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=4e9cee6a946bbc9bc993387546576a0ea36c7a823b3c9775fa9c8c6af3b865d5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-31T03:13:00.000Z",
			"id": "224fca77-b7cf-4c07-8754-cf3c9496ccca",
			"comic_id": "98578353-e750-4e43-b839-1d26572bfef1",
			"name": "Exorcismo de Kim",
			"tag": "Expressões",
			"imagem_name": "oretornodekurt-exp-imt"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/0a6f9353-f35a-40a5-ae5c-862bdad6bc25/oretornodekurt-shipp-kurtekim.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=820146296c121e55514cd6c537d4df4745222d573ce0817bf8ca645f0c8cd4a6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-31T03:11:00.000Z",
			"id": "4ae437fc-8577-43ef-a9a4-18c19880cefc",
			"comic_id": "98578353-e750-4e43-b839-1d26572bfef1",
			"name": "Kurt e Kim",
			"tag": "Shipps Fofos",
			"imagem_name": "oretornodekurt-shipp-kurtekim"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/eb8d8d30-2dda-456d-91dc-8f5d549ee4c5/oretornodekurt-char-kurt.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=08b63c0745ad7c5d2058e5e69eb2b4a914c48e1c715a183fdfab9a26c438ce04&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-31T03:08:00.000Z",
			"id": "527ed1a7-1be3-4efe-aad9-f53ad67aab21",
			"comic_id": "98578353-e750-4e43-b839-1d26572bfef1",
			"name": "Kurt",
			"tag": "Personagens Maneiros",
			"imagem_name": "oretornodekurt-char-kurt"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b2f5195a-3ff9-4c3a-b081-965bc9a240d6/vivendodedesenho-multi-velhopapelao.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=294c60da0293f8bc5e93c8f6c228f70e2034f378452385e34170b00c4393f549&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-29T01:46:00.000Z",
			"id": "306b29b1-5f73-4427-820a-9e3651b4a8cc",
			"comic_id": "82d3c612-e1a5-420c-8b23-6fa2c79a4c1c",
			"name": "O Velho do Papelão",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "vivendodedesenho-multi-velhopapelao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e0eca58e-a51a-4f6f-b4a2-03856e78201d/vivendodedesenho-char-alberto.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=29d1e011289e5e191bef6775064ec3adcf209b8973fcefb6ac80ed855111df66&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-29T01:23:00.000Z",
			"id": "627db65d-d36f-453f-99d4-f65d8ebdc703",
			"comic_id": "82d3c612-e1a5-420c-8b23-6fa2c79a4c1c",
			"name": "Alberto",
			"tag": "Personagens Maneiros",
			"imagem_name": "vivendodedesenho-char-alberto"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/fa3853fe-232b-445c-9e05-bf5a2fd4ff12/basket360-exp-sonin.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=8922aa01a1637c85ee0dd5606bc3c8350d71c526c7656a1a8950e668c52e278e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-24T02:53:00.000Z",
			"id": "d3d1d9e2-417b-4c22-9907-2b8003af6d91",
			"comic_id": "1fc59bde-ae22-4ddf-abe1-2bbed1f675ab",
			"name": "Sonin",
			"tag": "Expressões",
			"imagem_name": "basket360-exp-sonin"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d9cfb405-8c42-4eb0-acef-564c69a183a0/basket360-exp-quem.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=8b0acb0c903a1b1661be46b110199ab0d4d1b84fd2ba253c57e08eccfa9e75cc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-24T02:51:00.000Z",
			"id": "0c5636e1-c7a7-469e-905d-93798f4df11e",
			"comic_id": "1fc59bde-ae22-4ddf-abe1-2bbed1f675ab",
			"name": "Quem?",
			"tag": "Expressões",
			"imagem_name": "basket360-exp-quem"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9e635346-e618-43d1-bc6e-d74ea079e8b9/arlindo-lugar-saidadaescolinha.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=4e0da19c6f9e285cafacf778078614243daa6983d1f59d85774b6c31bc30e6af&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-22T03:17:00.000Z",
			"id": "aa0e193e-50e5-4be5-90ff-a9e9856657ac",
			"comic_id": "690cc70b-99e2-4e7c-a952-9e1fcecc0ff0",
			"name": "Saída do colégio",
			"tag": "Lugares Irados",
			"imagem_name": "arlindo-lugar-saidadaescolinha"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b6c09ee1-dd2b-4d00-a26c-219c95218a58/pansy-lugar-muralha.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=1126ad074517a0d00ef2944c4a3a4af910d0689d970620b1f05c9f30d2b56000&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-22T01:17:00.000Z",
			"id": "a6bd5e3d-e13e-4093-b749-aa9dcc76c594",
			"comic_id": "ff0749fb-8929-4f98-ac9b-0aa55e648cf5",
			"name": "Muralhas da Cidade",
			"tag": "Lugares Irados",
			"imagem_name": "pansy-lugar-muralha"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/460c60b4-4724-4198-89ac-1dfc99cdb7a2/pansy-shipp-pintortenente.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=7e2619530943a16a1ebf3055a83145e8f3d7bda3066067946ba249630de37f94&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-22T01:13:00.000Z",
			"id": "d3213d65-6504-4950-b687-2600edb61347",
			"comic_id": "ff0749fb-8929-4f98-ac9b-0aa55e648cf5",
			"name": "Brian e Paulo",
			"tag": "Shipps Fofos",
			"imagem_name": "pansy-shipp-pintortenente"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/5345a525-cba3-44df-a9d7-116d068e5c00/ainsurgenciaceleste-lugar-planocelestial.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=324a2291e622b394a88d9095f34bd8162c6984ecf114b6dc45b0224322414333&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T01:57:00.000Z",
			"id": "6afcc940-a301-4f47-968c-3f121a29ae00",
			"comic_id": "f37b3e11-ecf3-4c6b-be20-8da070592520",
			"name": "Plano Celestial",
			"tag": "Lugares Irados",
			"imagem_name": "ainsurgenciaceleste-lugar-planocelestial"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/967f5cf6-c3f2-449b-8fad-f1cae6ca0f96/vaderetro-char-waldisneypng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=6eb1114f5a4629ea02a6d565302a011ede359d97fccc24926c7ef45c9c2a1842&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-20T01:42:00.000Z",
			"id": "867965ba-1e8c-4048-aaea-c58f4c60d189",
			"comic_id": "ac948942-dc73-4bf2-8141-c293ff73c1d5",
			"name": "Waldisney",
			"tag": "Personagens Maneiros",
			"imagem_name": "vaderetro-char-waldisneypng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9effeb01-7f6c-4c8a-bbcb-6084beecace4/desviantes-lugar-riodejaneiroapocalipticopng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=4792c9b61b4b156035c5d8f045937e5bca19a74cc9e242f081d1fa97314d867e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-17T03:11:00.000Z",
			"id": "752d769d-0b3c-4896-bd2e-d23fab04b970",
			"comic_id": "605b8c53-24f6-4a8c-8dcd-9b70af1c1f47",
			"name": "Rio de Janeiro Apocalíptico",
			"tag": "Lugares Irados",
			"imagem_name": "desviantes-lugar-riodejaneiroapocalipticopng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d0afe906-8418-4f3d-ba05-ba6a0cde5185/desviantes-cena-cristo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=7f3b6a97babda9d410a672aa382a881a2a0c62b12042024fff5aa66eefe6b312&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-17T03:10:00.000Z",
			"id": "7b8ade68-12d5-4104-863d-7814effe5f6c",
			"comic_id": "605b8c53-24f6-4a8c-8dcd-9b70af1c1f47",
			"name": "Cristo destruído",
			"tag": "Cenas Marcantes",
			"imagem_name": "desviantes-cena-cristo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/04b35d1b-6535-4dcf-89bc-57dcefd5b99d/vaderetro-cenas-correndoatrasdobusaoipng.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=4471dffd43efaeab54bc2f48eac823c59f92218173fb16f372c7a2a7bfcbd984&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-17T02:04:00.000Z",
			"id": "41b891e0-19eb-4c62-afe1-47e30928c5e8",
			"comic_id": "ac948942-dc73-4bf2-8141-c293ff73c1d5",
			"name": "Correndo atrás do busão",
			"tag": "Cenas Marcantes",
			"imagem_name": "vaderetro-cenas-correndoatrasdobusaoipng"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bbe38f0d-4b47-40b4-8ea2-e3bfcc95a963/vaderetro-exp-wallace.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=312eda67fff431ce27989d91600b796a9e2ee45a80fd6ddcd3d534d0ec294d70&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-17T01:51:00.000Z",
			"id": "2b0972df-250b-4afa-b9a9-5a93b837ed1b",
			"comic_id": "ac948942-dc73-4bf2-8141-c293ff73c1d5",
			"name": "Wallace",
			"tag": "Expressões",
			"imagem_name": "vaderetro-exp-wallace"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/06578787-1612-435a-8c9c-eebb4e5c9e09/vaderetro-lugar-pontofeiradesantana.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=ff860b4f22971d73a6cb5ca4d4610fb9b86af61ae09becc3bd67b33902e9b62d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-17T01:49:00.000Z",
			"id": "0854603a-a446-4c27-a0f4-0407a5dcaa68",
			"comic_id": "ac948942-dc73-4bf2-8141-c293ff73c1d5",
			"name": "Ponto de Ônibus de Feira de Santana",
			"tag": "Lugares Irados",
			"imagem_name": "vaderetro-lugar-pontofeiradesantana"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/11c6a946-bd3e-40ea-be2f-3f0c88a89716/umbra-cena-naoeraele.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=323bbf5637ed7161b3a4bf3a9e092a89f00e8130695885d0bb9d93458105382e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-15T03:48:00.000Z",
			"id": "44e542ac-7b5f-4669-b61f-252943f25729",
			"comic_id": "27c5b787-dbcb-4bff-94f9-549332c25eff",
			"name": "É… Não era ele",
			"tag": "Cenas Marcantes",
			"imagem_name": "umbra-cena-naoeraele"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/99e988ac-9ea9-4e73-b29e-a15fc7ac6e04/umbra-char-luna.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=5e86ec9b9748b135e8471b583d75b9b714a32c8358d125128639a0d4e0623eb4&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-15T03:37:00.000Z",
			"id": "bb1c716c-417b-442f-a90a-2b2d431892d7",
			"comic_id": "27c5b787-dbcb-4bff-94f9-549332c25eff",
			"name": "A vingança de Luna",
			"tag": "Expressões",
			"imagem_name": "umbra-char-luna"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/84853423-b954-4b52-ac8f-c8092f0a2a7e/sanguequente-lugar-tipicaesquinabr.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=61b69a426457f2fd8162c17344273e00dc9b2fa20e4b15c02987362eb69622a9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-13T02:54:00.000Z",
			"id": "0e423b35-4be1-49cf-a500-ae3da4f9c252",
			"comic_id": "79d2fb3d-d4d0-488d-a219-a984504a39ae",
			"name": "Uma típica esquina brasileira",
			"tag": "Lugares Irados",
			"imagem_name": "sanguequente-lugar-tipicaesquinabr"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3dbb06d6-44d6-42dc-b753-7bc43eb5f80a/umprincipenadaencantado-char-conselheiroreal.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=a28c64500c4729e5a2058445737e461c9cea215bfa50f041be403356a8a19f87&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-13T02:28:00.000Z",
			"id": "cc7ddd11-390a-4ab2-b70d-d5a1583b70d0",
			"comic_id": "9f6e7d39-fefd-45d1-8964-01fd81e4210b",
			"name": "Conselheiro Real",
			"tag": "Personagens Maneiros",
			"imagem_name": "umprincipenadaencantado-char-conselheiroreal"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c0d308c0-d7c5-44c3-9530-77f91a219ea0/umprincipenadaencantado-shipp-princeealdeao.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=933a91e1548e0449ded0daaeaf2e321047797f214145b05880fd4d47680fad47&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-13T02:21:00.000Z",
			"id": "06f186fd-5bd5-458b-90b5-cd8d976b6f75",
			"comic_id": "9f6e7d39-fefd-45d1-8964-01fd81e4210b",
			"name": "Principe e Aldeão",
			"tag": "Shipps Fofos",
			"imagem_name": "umprincipenadaencantado-shipp-princeealdeao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b7ccc341-5d06-47f3-9b98-34d4cbf3940e/vidalongaomarinheiro-cena-mardecoisasparaesquecer.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=939605201d906e7c14d1802937050539088e6fa900efbeb99cf8d3573884763f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-13T01:34:00.000Z",
			"id": "6661f603-1bed-4c82-ab09-e5ee0c40cacd",
			"comic_id": "1bf1d892-ddfc-47b5-88f0-bb70f8eead14",
			"name": "Mar de coisas para esquecer",
			"tag": "Cenas Marcantes",
			"imagem_name": "vidalongaomarinheiro-cena-mardecoisasparaesquecer"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e4297be7-04af-4292-b4c9-231b3650e842/balsamus-char-jeje.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=f8bbd48eb1183f17369d8496640b1e5ddfd43875767ec1dbd4478b568ce7288e&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-10T03:24:00.000Z",
			"id": "55117822-6504-445d-ab9e-ac516e0e783a",
			"comic_id": "9141c65d-e6d5-4119-ab8b-52db5f9a37e7",
			"name": "Jeje",
			"tag": "Personagens Maneiros",
			"imagem_name": "balsamus-char-jeje"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3ddf2267-cf73-4363-bc32-6de6705b8a00/helldeck-dean.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=21baade303950376578c3a2a1804c844a0b59b3db1b20ad1a861e1a39dbd81b6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-10T01:15:00.000Z",
			"id": "8fd1448a-f904-4f7a-9c85-042a3a0a7ae7",
			"comic_id": "dace1182-8d80-4f48-872d-78aabce01eb1",
			"name": "Dean",
			"tag": "Mascotes fofinhos",
			"imagem_name": "helldeck-dean"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/252e8ab3-0fe2-415e-bae9-920364286283/aquelapequenaedocefadamortiferaemnossocaminho-masc-fayro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=a0cbb7463069db422e38c673626ae0eeb31ebfa70d13bca621f81c11b8950bab&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-06T04:04:00.000Z",
			"id": "7eb698e6-4dc2-4ce4-9056-7ead96f37439",
			"comic_id": "78bbee2b-2991-4855-af23-f3195143b536",
			"name": "Fayro",
			"tag": "Mascotes fofinhos",
			"imagem_name": "aquelapequenaedocefadamortiferaemnossocaminho-masc-fayro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/85b7bb75-26d5-4ce5-84e5-e9fd0db3a4c1/13aotopo-cena-chegada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=76f8f1e728e2475a4931844a2ea01683e4f78eb301522b636c388474d7b80783&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-06T03:28:00.000Z",
			"id": "12c6f48b-b334-4714-aa22-bcf5bbd598f7",
			"comic_id": "c0d7b70e-7a9a-4196-9bf9-fbae46aca3d9",
			"name": "O Topo",
			"tag": "Cenas Marcantes",
			"imagem_name": "13aotopo-cena-chegada"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c1b61ece-5c43-4e02-b326-f8c23a50676a/formaouconsciencia-exp-kensu.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=a1f10ea06071a780d1a10272dcebd9b02c71a42913a9c308b50aa70add4422e6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-06T02:22:00.000Z",
			"id": "cb2f90a7-9dad-4aa4-9b26-5f6d25c3c2da",
			"comic_id": "9f11910e-5cd3-4839-ae88-55df741c43ca",
			"name": "Kensu",
			"tag": "Expressões",
			"imagem_name": "formaouconsciencia-exp-kensu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d3d85c34-e5bf-4602-a18e-dc18c3f4dd69/agerstellas-masc-fulpus.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=bfba220a8446d2685521664d16d9e89fc0be8149382d35bf772d9888805d99f2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-04T22:51:00.000Z",
			"id": "0224fe81-94a5-4055-a84a-63749992d7f3",
			"comic_id": "d39c364f-a281-4c23-858c-c4a4ae2a09b3",
			"name": "Fulpus",
			"tag": "Mascotes fofinhos",
			"imagem_name": "agerstellas-masc-fulpus"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/46658b1d-1ecc-4563-86ae-c43b72b58688/agerstellas-golp-lobaodechoque.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=0a40e46bf2e1d9edd42cfe4f776e0ac50ddaba66aa64bdad23dca928b6f51a50&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-04T22:49:00.000Z",
			"id": "60a263b0-6bad-44ef-b116-3a784d2e1b0a",
			"comic_id": "d39c364f-a281-4c23-858c-c4a4ae2a09b3",
			"name": "Lobão de choque",
			"tag": "Golpes Fodas",
			"imagem_name": "agerstellas-golp-lobaodechoque"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2423fcf1-aa39-4c5d-96b3-80e767f0987d/mamaocomaucar-mult-48km.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=2c34259c96d44d561d74b512872fc63de048e7d36556a77c61008c34d2f0ab12&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-04T21:24:00.000Z",
			"id": "31cb93ae-bcc0-45e1-941e-62d9abdf9030",
			"comic_id": "b36b25e4-0d52-46d6-a02b-8a9a39919c62",
			"name": "Poster 48km",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "mamaocomaçucar-mult-48km"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/192c433d-35d6-4d87-9686-2774f8ef1b84/mamaocomaucar-lugar-paogourmetizado.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=7eea2670eaa9fec635c2e5d6406a01476455c1203d3df00ab9b555d584cbdf23&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-04T21:05:00.000Z",
			"id": "e552c9ff-6e2e-4493-a39d-70ac3db92eac",
			"comic_id": "b36b25e4-0d52-46d6-a02b-8a9a39919c62",
			"name": "Leia 48KM",
			"tag": "Multiverso Quadrinhos Nacionais",
			"imagem_name": "mamaocomaçucar-lugar-paogourmetizado"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/69153d2a-dfc4-44c7-a158-37fb0586ebef/mamaocomaucar-lugar-paogourmetizado.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=6ec186fee47fc0e894882c0797370d0d26d6aae0cd974cd09c9fcf41b0306d1c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-04T21:03:00.000Z",
			"id": "ec395918-20be-40c8-a249-c129e30f911f",
			"comic_id": "b36b25e4-0d52-46d6-a02b-8a9a39919c62",
			"name": "Pão Gourmetizado",
			"tag": "Lugares Irados",
			"imagem_name": "mamaocomaçucar-lugar-paogourmetizado"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e906ae25-f6aa-4792-8ce6-3cde3011cdd7/onda-ono-ablubaub.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=b8edfd13dd0157f47613ef053d532252f63799062e074a9696f89583d0222b29&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-04T20:07:00.000Z",
			"id": "2e7287c4-f707-44ac-a2ce-61868736faf5",
			"comic_id": "05c9eb1d-4636-41ae-9236-145d74deb8e0",
			"name": "ABLUBALIALB",
			"tag": "Onomatopéias",
			"imagem_name": "onda-ono-ablubaub"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/58fc2ce8-ef22-4294-96b3-28943e1a4b3e/onda-exp-marcussusto.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=ee53a67d69602dfefc69ee4a8c32e67591a0465076ba1c3162859969d5113f57&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-04T20:01:00.000Z",
			"id": "bc1c553c-a516-49ca-ac15-f6531c84df95",
			"comic_id": "05c9eb1d-4636-41ae-9236-145d74deb8e0",
			"name": "Marcus em CHOQ",
			"tag": "Expressões",
			"imagem_name": "onda-exp-marcussusto"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a3f907bc-bcae-418f-adf4-148f6543ed1a/draculaquerumnamorado-exp-choro.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=8f995fc006b00d96265313c50a3b1c5f4ad04c927115875a707ac565af2fce27&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-03-04T17:36:00.000Z",
			"id": "5ac4e70e-3589-4302-a533-e5bdf1c78a00",
			"comic_id": "e7b28be6-2cfc-4156-9660-c9b484695f2c",
			"name": "Chorinho do Vlad",
			"tag": "Expressões",
			"imagem_name": "draculaquerumnamorado-exp-choro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a8da8d37-476a-4692-89c2-f1bb2e28c067/agrandegrug-char-grug.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=e708b1c425364b42f8d2b0c46b63470acaa52eac3468207ee7ca4897ac0f1c3a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-27T02:59:00.000Z",
			"id": "060d237d-5168-47ee-a1fc-92809476de7c",
			"comic_id": "0cfdec41-2fe1-4099-8d19-affd648ee609",
			"name": "Grug",
			"tag": "Personagens Maneiros",
			"imagem_name": "agrandegrug-char-grug"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4d492156-df94-4c29-95a1-0a82c370ff80/unluckycrow-cena-vocedestruiuomeuovo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB466QGXGZ2TY%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232851Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEMaCXVzLXdlc3QtMiJGMEQCIBKcJi6B%2BE89pzjtfcGXMG5EC6q3dnC3AahPMXgdKg6qAiA9pv0VT%2B8XUQJtvJCJuhNK2FMIkzZkEEHeH2bUiJKP2CqIBAir%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDYzNzQyMzE4MzgwNSIMmcbEz5z9LzKajEBPKtwDRHshoqlWTs499zByUjKfMIcrqjMqoMv55mohqCHzg3RMSHHcedM0bzZJAhzNpZ3W18IPQvKjc21h75bU4uGHG3fi%2BEqg85tZQ5by9tIe3RUJHys8amSkEDSLtFfSoKzNiz4N%2F5irwvLwhV%2BpMNjyy%2F2rUeQqi%2Fu9I8BadsCI0PF8%2FJQxS8iFsrJZI8ct9cgDr2Ly4HIE%2BrzP5ETWiK4jrxMntQXEa4dQRMo3eTnfKY6r1nLGYitAARoCZBREWuabKnRKWRhz1MCQZDmMHiYz8VxBQgC2UBfC0b2YuToWwVQ%2FpY5fxi037uOn%2B7YoyRemwONUk648cy2JQTPue8A%2FGA6L9Mhe5j%2FZkb13ohUKQgwTCirWJS0x0uoGzCu6zhO2OnwL4tqY0OS%2FBN%2BC0sFuvzjFRljku577KUvpPVhOyfqmWO5Y1pKMf2LcnIVqI%2FlIj20AYaVpVKcaqrC4D3ZjQt2Ul%2FrtPFeyzIsmiWr4OT5w9xd82oL7DpUqYXeBtURM4wzDBcy6pQtC6XRub3bGADbIcJz2BldJ%2Bs3EUAuKm1x2Pe04kEgPEKvUvY7rjsS8NyPHw%2B6fZNcR0wEm9QaZKhwNkjKgD1%2BcggHSg0mMbl29c%2Brt8zgn2yW7Y6Ew1LirvwY6pgF6m9AJ1QFrAUXdFsnYDRlZxdNFmssj7kdBXIuYnppcYwhRcTPo7d7bQhYYoUm%2BSNcXGxliPLgrK7ADZx7kMw%2BNyhNmef7b6zHPR26FOriX0CS3MMnSYmpJ3eHFup1qWDy4BMC6lgzPSgQxwMkVJKRyxy%2BnWuDukD2oSDYM3e2j0oGKF%2Fup5ButbeMteePwTB8CMLph6ZOLIVbbYSVtypca0NzsKVj5&X-Amz-Signature=0e51afd0d5d3f2ff9ade6bf262d3c6c24b5fa7b9c89e8dcbe49edf9efcfc55d9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-27T02:28:00.000Z",
			"id": "a756207f-57e9-46b6-aa08-e46f7c0ddc64",
			"comic_id": "707b68d5-b4f4-4923-9b59-89324371ea82",
			"name": "Você destruiu o meu OVO!",
			"tag": "Cenas Marcantes",
			"imagem_name": "unluckycrow-cena-vocedestruiuomeuovo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c4c582db-f19a-44da-b09b-7d36536490ea/vidasimperfeitas-cena-beijocao.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=7561b956160f2682de3884a0c9ca4ae6cb3bbd94056e28fabfdf86546f72813d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-24T03:14:00.000Z",
			"id": "53634719-de05-4a8a-b240-207735db892d",
			"comic_id": "70948036-2b41-403b-a9ff-d34260c949be",
			"name": "Beijocão",
			"tag": "Cenas Marcantes",
			"imagem_name": "vidasimperfeitas-cena-beijocao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/feb702d0-8187-47c3-a8a2-3226bcfa4a3b/irauna-char-irene.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=8537bf867e762cec4fcb3ffd660968b5f958869317c0e9121edadb62343a6052&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-23T13:27:00.000Z",
			"id": "2b59a99f-2af6-42ad-8336-ca1018d3361c",
			"comic_id": "4d47ce5c-cd75-4af4-8a81-9d7f4bea3ef0",
			"name": "Irene Nogueira",
			"tag": "Personagens Maneiros",
			"imagem_name": "irauna-char-irene"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d2c677dd-0193-429a-95d2-e4dc96af22e3/kstar-char-princesaplatina.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=a24758ea533284342b2cb8a953cf30b3e1f337c7fbc14b3cb540939199ac2b29&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-02-23T13:25:00.000Z",
			"id": "3cf64224-c70f-4852-b255-13676a129bad",
			"comic_id": "75b22629-cd4d-491e-b963-33c2466de909",
			"name": "Princesa Platina",
			"tag": "Personagens Maneiros",
			"imagem_name": "kstar-char-princesaplatina"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/165d50e7-00f8-46f9-9a5f-24fa04d160e5/oscar.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=aee1ecf1cdfff2a87b4e54b2208a2e3c4c100acbc823b0709588d58d375d7cd3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-30T02:45:00.000Z",
			"id": "216df48d-a23c-4203-8f10-8e6b4f04ecc6",
			"comic_id": "2c5d83ec-27a3-4d83-b107-378f1ea1891a",
			"name": "Oscar",
			"tag": "Mascotes fofinhos",
			"imagem_name": "bilove-masc-oscar"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ff9a1423-dc46-4edd-82cb-3ead48586580/jaci_e_nai.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=7a9a651b02b61ba4aeb5e4df47e5963a09dfaf614f2f90be74dce9939d9a380f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-30T02:09:00.000Z",
			"id": "55b9aadf-993a-4c19-80a6-1be5c5d47444",
			"comic_id": "b90922ff-7e39-412b-a6c0-4aa612ebdd49",
			"name": "Jaci e Naiá",
			"tag": "Shipps Fofos",
			"imagem_name": "florescer-shipp-jacienaia"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3f71f6b9-d2ee-4869-89dc-9c3564331578/o_mercadinho.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=473b036632fe1013fbabed4d55a0a6f284cd622a024f99125055d71bf428a726&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-30T01:18:00.000Z",
			"id": "69f04791-a9e5-4579-88aa-62724ffd0523",
			"comic_id": "964fed91-8a36-4112-bc6a-bc4980e06c2e",
			"name": "O Mercadinho",
			"tag": "Lugares Irados",
			"imagem_name": "suzysukeban-lugar-mercadinho"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ae97db0d-376b-4b23-bba7-d760f16526db/blaze.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=527f061339c5ada690bf274394b5725639be5cb9f69f1e518b9847b99010d914&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-29T14:00:00.000Z",
			"id": "bfff4606-6f43-4f9d-9d98-76c2b8c93d06",
			"comic_id": "a650f699-0374-444b-b3f7-74aacd46e2d3",
			"name": "Blaze",
			"tag": "Mascotes fofinhos",
			"imagem_name": "manualpraticodagarotamagica-masc-blaze"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/85dc07c1-b656-400f-a6a7-94ed1703f173/Tala.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=d3718df7b9abd997526e01aea835d2bd53316bc8c7b730fe951ed96ec3875023&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-29T13:58:00.000Z",
			"id": "a49f2e97-e037-4515-ac4b-4deca4e625de",
			"comic_id": "1dfbdef9-3059-4361-873e-ecd662b2cdee",
			"name": "Tala",
			"tag": "Mascotes fofinhos",
			"imagem_name": "roland-masc-tala"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/60e3509f-3b6b-42a9-8788-775dffbdbaf0/Lulaldo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=5497729b20fd2ab63f30427874400369540744412c9de72d2f91140e51f79252&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-29T13:56:00.000Z",
			"id": "34420277-f5bd-46fd-b0fd-48f90c626dfa",
			"comic_id": "f0de1a17-11e3-4646-8cf4-575b95c82922",
			"name": "Lulaldo",
			"tag": "Mascotes fofinhos",
			"imagem_name": "octozine-masc-lulaldo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/9b0c355d-7582-4325-bde6-e7bbfaafd49f/Morgan.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=81c64d2229b8259505c1d3c22d0d6b6db0ad16286b0f793cec22e294f83e1352&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-29T13:54:00.000Z",
			"id": "8625f5e9-1276-4594-8a9a-f47c521e6371",
			"comic_id": "a368832b-2911-4768-baa4-093299744a88",
			"name": "Morgan",
			"tag": "Mascotes fofinhos",
			"imagem_name": "liliandgrave-masc-morgan"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7d2ce0a8-ad52-41f4-bd62-538e33792283/jade.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=f2cd18f5aee8ade71daff61c2ef3f61a82b787d16f13d7f3a466cf44b5519687&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-29T13:47:00.000Z",
			"id": "cddebe9b-a780-4519-a28d-736d10d030eb",
			"comic_id": "80ba99d6-d16a-47af-a67f-4bcbab6a1760",
			"name": "Jade",
			"tag": "Mascotes fofinhos",
			"imagem_name": "daydreampeak-masc-jade"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/f5539acf-6f1b-45bc-9fd8-56a7923503d5/suzy_e_o_cigarro_perdido.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=168b4e273c471e6e85d3c22886347e8cfed6a5464d155b7718c20b3799260eb3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-27T02:52:00.000Z",
			"id": "548dd0c1-4a4f-4273-acac-f568104f0165",
			"comic_id": "964fed91-8a36-4112-bc6a-bc4980e06c2e",
			"name": "Suzy e o cigarro perdido",
			"tag": "Expressões",
			"imagem_name": "suzysukeban-exp-cigarro"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4a7fb086-7dbb-4280-aa0a-4cf52d6e9dbc/mundo_dos_sonhos.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=552df04657b4e562d2702a1a488696624fbdf5059dd4f4a01ce83e8c2b19acee&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-27T01:21:00.000Z",
			"id": "a3565988-1ab5-4c2f-8164-ba743924f0e5",
			"comic_id": "80ba99d6-d16a-47af-a67f-4bcbab6a1760",
			"name": "Mundo dos Sonhos",
			"tag": "Lugares Irados",
			"imagem_name": "daydreampeak-lugar-mundodossonhos"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/053100d3-3a36-440d-8c22-4edcb581c049/pilantra_lina.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=bc4c63002334e62f264a25c673dddef1c8e4582f35b3af7a4350cb3069949e34&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-23T03:10:00.000Z",
			"id": "a9cd4d61-0b89-4a69-944d-833104593fc6",
			"comic_id": "d39c364f-a281-4c23-858c-c4a4ae2a09b3",
			"name": "Lina Pilantrinha",
			"tag": "Expressões",
			"imagem_name": "agerstellas-exp-lina"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ee7d74b9-67a5-4b53-9472-6ebf2b998bf7/CORTE_CELESTIAL.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=874f2bc110c8ef4652459afd204ce7fd5f96b44082614f4337efa81ee1400c1b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-23T02:18:00.000Z",
			"id": "a01a6cbd-8a3c-4480-b00a-32ad84b497ba",
			"comic_id": "854abf8f-4679-44af-b544-600b8ba7416b",
			"name": "CORTE CELESTIAL",
			"tag": "Golpes Fodas",
			"imagem_name": "lendasdeveracruz-golpe-cortecelestial"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1e48269f-332a-4d9c-9a41-0630ce962764/Natan_e_Filipe.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=db62c1a1cc083fed93203e44d6a2c934be87e57ba5b34f1ddcba99ddddd5ea48&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-23T01:34:00.000Z",
			"id": "a3c5c696-e7d1-4322-9a38-9ca7387b957c",
			"comic_id": "b36b25e4-0d52-46d6-a02b-8a9a39919c62",
			"name": "Natan e Filipe",
			"tag": "Shipps Fofos",
			"imagem_name": "mamaocomaçucar-shipp-lucasenatan"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/cf5cf78e-3914-4ed8-929d-d021936600ac/capoeira.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=7ec7e417ca9ab0247715dfdf7a31ec27d6ff64d3711fe8adf5067759e52d1706&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-20T02:24:00.000Z",
			"id": "58f09e88-f0e6-401e-8cbf-975b924bb3f8",
			"comic_id": "a5748d22-e809-4af4-905b-0413e7de7ebe",
			"name": "Chutão do Madson",
			"tag": "Golpes Fodas",
			"imagem_name": "ginga-golpe-chute"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3f6d54ba-8f5c-4541-873a-f1728791e630/PLAFT.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=77beec714e0c4477d13701d5bcb611044110d5677444d9c19f91ef453dc59bc9&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-20T02:16:00.000Z",
			"id": "c4822475-b58f-4620-b1ea-b8081f2cc682",
			"comic_id": "a5748d22-e809-4af4-905b-0413e7de7ebe",
			"name": "PLAFT",
			"tag": "Onomatopéias",
			"imagem_name": "ginga-ono-plaft"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/1f7156f4-a061-4eeb-9a93-f32d214a7b1f/paranaueee.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=02ccdbd56670861d7530d235cf65a0a57de846d1a67efe437ef7f752323f8e00&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-20T02:14:00.000Z",
			"id": "17e998db-f786-4883-ae73-d99a9b5d7d86",
			"comic_id": "a5748d22-e809-4af4-905b-0413e7de7ebe",
			"name": "Paranaueee",
			"tag": "Cenas Marcantes",
			"imagem_name": "ginga-cena-paranaue"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/eaa0c033-3471-4aed-adf0-0d9d212d3a60/anime_brothers.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=241993a54fb07c1d0e380438ce5442c64fd3134b3a01a18426237d9461c05350&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-20T02:13:00.000Z",
			"id": "779b39cb-d024-485c-900b-104f474257c9",
			"comic_id": "ef130bcd-f72f-4811-a29d-c009f26f8411",
			"name": "Anime Brothers",
			"tag": "Lugares Irados",
			"imagem_name": "brakuman-cena-animebrothers"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/b0dd5410-366e-4ab7-b155-0f5737f1e141/salvador_ba.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=6501dc5f76544b082bbbab6f676bb51eda98a532fcec2d952240505f34972dd8&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-20T02:12:00.000Z",
			"id": "48c9e4c8-6edc-4317-9861-741e21b64dcf",
			"comic_id": "a5748d22-e809-4af4-905b-0413e7de7ebe",
			"name": "Salvador - BA",
			"tag": "Lugares Irados",
			"imagem_name": "ginga-lugar-bahia"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8f31fa70-8878-411b-ba64-3f460bca2593/brasil_sil_sil.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=de3cd45e9cd31688e02b59d9e6158b4245d7384620b000e33b4db35b98b0be66&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-20T01:49:00.000Z",
			"id": "78573fc4-15f5-45b4-b838-2e86697d924f",
			"comic_id": "af49fc05-908c-465a-9e1d-6c9e740cd9b0",
			"name": "BRASIL-SIL",
			"tag": "Onomatopéias",
			"imagem_name": "camucamu-ono-brasil"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/e9d1cd55-4a91-4a79-ba7d-91549fbff79d/Motivao_do_Quadrinista.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=411a0a47a35fe269988bac0f9e01e308fbdb38fea217203b516f16ceca261ba5&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-16T21:12:00.000Z",
			"id": "cc5f4caf-85fd-438b-8a93-91a847247670",
			"comic_id": "ef130bcd-f72f-4811-a29d-c009f26f8411",
			"name": "Quadrinista Motivado",
			"tag": "Cenas Marcantes",
			"imagem_name": "brakuman-cena-motivacao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/64082632-6f79-4919-b93c-265016241eff/Quadrinista_no_Brasil.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=970476f23a11a0dcb255b5d6027fac381b96e322367a2c605d10f030392f5d22&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-16T21:05:00.000Z",
			"id": "ff6fa58b-1caf-40c7-8f9e-a8306858ef3c",
			"comic_id": "ef130bcd-f72f-4811-a29d-c009f26f8411",
			"name": "Quadrinista no Brasil",
			"tag": "Cenas Marcantes",
			"imagem_name": "brakuman-cena-quadrinista"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d5ebdaac-1ffe-438e-84a4-4eef4623f98b/Suzan_em_CHOQ.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=d870fdcd1343c5c0201b3e12139dfb0175f42832cc68b2ba021ad674c17fa8a2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-16T20:55:00.000Z",
			"id": "04c60035-a44f-4c86-8557-917db4730f89",
			"comic_id": "1784dc99-a85e-43ca-958f-5679a832f910",
			"name": "Suzan em CHOQ",
			"tag": "Expressões",
			"imagem_name": "calendar-exp-suzan"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4aa27156-fe58-414e-975a-6b9924b93584/lampiao_e_maria.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=8f536d880133dcb45f905a09e7a318a8cdf79da414140af9823b04cccb14eb56&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-13T03:02:00.000Z",
			"id": "5fd011ab-6bc2-46e6-a260-2d9ddef7ea64",
			"comic_id": "c6d2fe6b-8e0d-4ec2-afcb-40b61b5dd204",
			"name": "Lampião e Maria",
			"tag": "Shipps Fofos",
			"imagem_name": "lampiao-shipp-lampiaoemaria"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/3b95485d-0836-454f-af3f-cb4fe491ca06/NORDESTE.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=d487aa6226cc453dd5e590502048bd82336a95c577cb90164fd8a43cdac3b80b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-13T01:23:00.000Z",
			"id": "8536f15e-f8b3-4c95-bcae-634f1857d239",
			"comic_id": "3ea69a90-244a-4374-b029-5872ef19cc1c",
			"name": "Antigo Nordeste de Oxente",
			"tag": "Lugares Irados",
			"imagem_name": "oxente-lugar-nordeste"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/c8d00c6c-8066-49fa-90e5-3856cf95e931/PEI.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=9713d55d73e002c472c5f5284bb7e2591d189a9675da303ec04c72db0343cc57&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-09T02:53:00.000Z",
			"id": "121d8461-0dc8-4d62-ad0e-4625bb6d9014",
			"comic_id": "a63a7fd2-eea7-4b2c-a6c3-330c0608f495",
			"name": "PEI",
			"tag": "Onomatopéias",
			"imagem_name": "setimosfilhos-ono-pei"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/16c6c206-361e-4747-92a4-6124d4f56161/BLOU.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=78a71332891b2226d781dee1a3bb8b8cef337adc617e301223b2178ca576b15d&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-09T02:52:00.000Z",
			"id": "c1ead066-7523-4b97-bc38-f1b83a2c2b93",
			"comic_id": "57ee1f1d-f721-4da9-bde7-ef072780deb7",
			"name": "BLOU",
			"tag": "Onomatopéias",
			"imagem_name": "hqdebriga-ono-blou"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/385361d8-244b-4347-9fad-b9df1b724ccc/BRONX.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=a3759fc7619cd450c6b92f762c48a39e6d80507eeef625967ca9a9342a5e37d0&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-09T02:38:00.000Z",
			"id": "25893e41-3387-4994-b109-46416fb18961",
			"comic_id": "57ee1f1d-f721-4da9-bde7-ef072780deb7",
			"name": "BRONX",
			"tag": "Lugares Irados",
			"imagem_name": "hqdebriga-lugar-bronx"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/ddd14ddb-789b-4cb6-be91-7c31215d72b9/alessandra_e_o_fone.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=ad4b2525f323530c41181048c2a08948976be9b5d144b20afcf294a3e4f85a78&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-09T01:38:00.000Z",
			"id": "e783cdc6-f822-4a20-ab54-aa84dc94dbf2",
			"comic_id": "a63a7fd2-eea7-4b2c-a6c3-330c0608f495",
			"name": "Alessandra e o fone bagunçado :u",
			"tag": "Expressões",
			"imagem_name": "setimosfilhos-exp-fone"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/10ca3042-95f2-44e6-8fa3-2eff3da47157/paulo_padilha.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=56120ee2f8d1a6262cb76a15d71c024252edfb55089efef803488b1c58c054dd&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-06T02:00:00.000Z",
			"id": "7d1fec49-4474-4fc3-90c4-e86dbdc64c4b",
			"comic_id": "81cbe9c4-de33-4938-905f-ed48cc8781a2",
			"name": "Paulo Padilha",
			"tag": "Personagens Maneiros",
			"imagem_name": "pingpongdrama-char-paulopadilha"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/bab229cb-9a7e-4c3a-9b5a-1c3763c61fd8/Motivao_de_Lucas.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=79591cc37687e843cbe42a332944f7f4985dee359b423959c1c5a7c639f4ae1b&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-06T01:57:00.000Z",
			"id": "d4c3c63f-87ef-494c-8be7-2fc9e9a2fadd",
			"comic_id": "81cbe9c4-de33-4938-905f-ed48cc8781a2",
			"name": "Motivação de Lucas",
			"tag": "Cenas Marcantes",
			"imagem_name": "pingpongdrama-cena-motivaçao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/7e0eb35b-c672-4ecc-a1a8-5b41081845fb/Jade_delicada.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=9bd313a730c4a5a36a60ca1d42948c820d2309ff84d69d4a371c216a301e55fc&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-06T01:28:00.000Z",
			"id": "73efda6e-13fd-4583-bddb-951773857431",
			"comic_id": "c1eba75f-532b-423a-a290-8054372ee50b",
			"name": "Jade galanteadora",
			"tag": "Cenas Marcantes",
			"imagem_name": "48km-cena-jadedelicada"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/49771c15-a40e-4f80-ac25-0dd4117d73f5/Kelly_e_Jade.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=43d86fa2673fce013898944c30f4b848dc06db9a95626880d75906a30c5518af&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2023-01-06T01:09:00.000Z",
			"id": "ebbd1247-02f8-4771-90ef-8aed93df9d79",
			"comic_id": "c1eba75f-532b-423a-a290-8054372ee50b",
			"name": "Jade e Kelly",
			"tag": "Shipps Fofos",
			"imagem_name": "48km-shipp-kellyejade"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/747fd2e2-5239-4287-8161-628abfadf8da/moa_sinistra_do_poker_2.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=a8221a562a40de814705d3162d59723e96183f2f43ef6cfdac4f50604ed1b1c2&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-30T02:56:00.000Z",
			"id": "0c19a33c-a92c-4801-a6ee-596077aa6b12",
			"comic_id": "2a1d4862-6dd4-4f04-89d9-f8bb4339fe7d",
			"name": "Moça sinistra do Poker",
			"tag": "Personagens Maneiros",
			"imagem_name": "trapingame-hq"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2e351583-34e4-4af1-b476-6a1f26657450/moa_misteriosa_de_trap_in_game.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=a42dd2f9d7f09a990bce6c8fe37aa85cfeba2b8d6b06d51a7995053a50d31148&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-30T02:44:00.000Z",
			"id": "4e52cd6c-2b7d-447e-b1b0-ad93036be134",
			"comic_id": "2a1d4862-6dd4-4f04-89d9-f8bb4339fe7d",
			"name": "Moça sinistra do Poker ^^",
			"tag": "Expressões",
			"imagem_name": "trapingame-exp-moça"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/17177ba0-6c90-441d-b0a7-69def2f58968/Jaque_e_Daniel.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=1b2cba22d2d30fbf3bc657c568a9e942106ea41a0445abff6eba4f9eb00218a3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-30T02:15:00.000Z",
			"id": "b71a3a08-b221-414f-b420-4000a6e65d29",
			"comic_id": "bddbd6b2-0cdc-46d3-9e05-f242f9d8df3f",
			"name": "Jaque e Daniel",
			"tag": "Shipps Fofos",
			"imagem_name": "inusitado-shipp-jaqueedaniel"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/a423fe76-d355-4736-8339-deb291e076a8/Nanda_e_Irene.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=b0d583cd3e8847572ff919f6ff0590b088b7d44067de57f25ea3e0f9997b8834&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-30T02:13:00.000Z",
			"id": "7e720b32-5158-4081-b572-a667409f6c1c",
			"comic_id": "4d47ce5c-cd75-4af4-8a81-9d7f4bea3ef0",
			"name": "Nanda e Irene",
			"tag": "Shipps Fofos",
			"imagem_name": "irauna-shipp-nandaeirene"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6821fe6c-9d66-4b91-9a5c-4781522f8638/arroz_e_feijo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=9221dea049b366862c33febc279fab860bb236e3b3243c2213a229e45088c32a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-30T02:06:00.000Z",
			"id": "9a893f6a-d43a-4731-b4f0-3fbd21eca164",
			"comic_id": "bcbf6908-e5a5-492d-a80b-b1adc47cc27e",
			"name": "Arroz e Feijão",
			"tag": "Shipps Fofos",
			"imagem_name": "cinza-shipp-arrozefeijao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/75e257fa-8a64-40ce-a268-f152286bf15e/A_chuva_de_volta%21.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=2638e323a0888b96a26414af4d7e980a891d79b0916a6d65d6cc1b67424a9807&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T02:03:00.000Z",
			"id": "b5d3c583-51bf-490a-a556-26bbe8edd968",
			"comic_id": "1dfbdef9-3059-4361-873e-ecd662b2cdee",
			"name": "A chuva de volta!",
			"tag": "Cenas Marcantes",
			"imagem_name": "roland-cena-chuva"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/8361e9c6-c97b-4c6d-bc3e-882ddb622c66/HELL_SURFER.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=86a06cf70cba54077f46228848cb45711e0736bd0b668c06340785321c951a9c&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-23T02:01:00.000Z",
			"id": "3319b597-bd95-4fff-8dbd-447d6293917e",
			"comic_id": "1dfbdef9-3059-4361-873e-ecd662b2cdee",
			"name": "HELL SURFER!",
			"tag": "Golpes Fodas",
			"imagem_name": "roland-golpe-hellsurfer"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/09db9183-ed92-4d36-b765-3b1823ed764d/REI_DE_LATA.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=d624987aa3d68df32c87121518228a39a4fcb7791f9d15dd6f1a7758e73a6f90&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-20T15:18:00.000Z",
			"id": "cd12ca78-f19d-436f-a1cb-bfbdf390a416",
			"comic_id": "31a09d13-11d9-4b66-b43b-41a845aa0df7",
			"name": "Rei de Lata >:)",
			"tag": "Expressões",
			"imagem_name": "reidelata-exp-reidelata"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/4f1c749d-9dbc-4fb9-bc1d-9fc002355dc6/COCONUT_SMASH%21%21.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=b0cc5bbb957173b37cf73c6b6895ca5df0b0b5deba1b6cd8fc1d0a23d3fed5ed&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-20T14:52:00.000Z",
			"id": "754bb1ca-f373-449a-9f80-cbdde3254ed8",
			"comic_id": "9e5f18bc-5f28-4cd1-8153-5bfe77cccaf4",
			"name": "COCONUT SMASH!!",
			"tag": "Golpes Fodas",
			"imagem_name": "monsterodyssey-golpe-coconutsmash"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/961adbec-2654-4911-b1a2-49164e93595a/GOBLIN_SLASH.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=e09c5b92bd945d2427f6f1d42fbae8697231eaee9c3c7eff1b5439603baff724&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-20T14:50:00.000Z",
			"id": "1eda46e9-ba65-436f-90ed-e0a565ae2ff9",
			"comic_id": "9e5f18bc-5f28-4cd1-8153-5bfe77cccaf4",
			"name": "GOBLIN SLASH!!",
			"tag": "Golpes Fodas",
			"imagem_name": "monsterodyssey-golpe-goblinsmash"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2682d372-912b-45fd-b27f-46d65cf32e09/STONE_SHIELD.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=3160f948da3eb33fdd4aec5ec09a2a4d5112003e2a79768b3e83fbf4b03724d3&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-20T14:49:00.000Z",
			"id": "47fe2cf7-eccd-41d8-a46d-2093e82a4519",
			"comic_id": "9e5f18bc-5f28-4cd1-8153-5bfe77cccaf4",
			"name": "STONE SHIELD!",
			"tag": "Golpes Fodas",
			"imagem_name": "monsterodyssey-golpe-stoneshield"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d3137637-55db-424f-ac41-21f44f36babd/gomu_gomu_no_leon.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=937820d7838551fe9dd36e45d645902af46d7c1680037637d0507a91207d22f6&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-20T14:38:00.000Z",
			"id": "d273bfcc-cc7b-4165-ab9f-d11bd22cb0b3",
			"comic_id": "272aef3d-5fcb-4628-914c-ab7c3e2bfbfa",
			"name": "Gomu Gomu no Leon",
			"tag": "Golpes Fodas",
			"imagem_name": "lebreecoelho-golpe-gomugomu"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/35c44b83-6ea3-41dc-a7ea-294c3b19131a/Ilha_caveirinha.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=581b5a2e3dbc22a028b206a768b8dcc7d9ed43ef0cf288ee7aa14a1ee54c0304&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-20T14:36:00.000Z",
			"id": "b55d0187-7143-4544-9d49-917a24739b31",
			"comic_id": "9e5f18bc-5f28-4cd1-8153-5bfe77cccaf4",
			"name": "Ilha Caveirinha",
			"tag": "Lugares Irados",
			"imagem_name": "monsterodyssey-lugar-ilhacaveirinha"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/6a9ddc1b-5b57-4bf2-a0e5-587109f30768/abertura_monster_odyssey.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=0901946a9c7e46158059730b9b56edf56af5d6decb5338c3dd3ac8daff77636f&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-20T14:35:00.000Z",
			"id": "3b442383-97da-4ffc-83ce-89258ce13928",
			"comic_id": "9e5f18bc-5f28-4cd1-8153-5bfe77cccaf4",
			"name": "Deuses da Abertura",
			"tag": "Cenas Marcantes",
			"imagem_name": "monsterodyssey-cena-abertura"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/139d8bf3-c748-474a-b6d4-31579fc346f2/Pedra_Galo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=05450c47690e639d22330411eafdfcb0912c9a63f32029ee24659af431c2144a&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-20T14:26:00.000Z",
			"id": "f6426ffc-aa0c-4572-9e3d-8b1f6ef53ab8",
			"comic_id": "9e5f18bc-5f28-4cd1-8153-5bfe77cccaf4",
			"name": "Rocky Rooster D:",
			"tag": "Expressões",
			"imagem_name": "monsterodyssey-exp-pedragalo"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/d68ba695-a423-4a77-9ea7-44f270a74a5c/IRENE_NOGUEIRA.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=05a96ab9927536c494ddd78dcb93387e35608c6d849ea403dc4971ccae8d2b15&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-20T13:59:00.000Z",
			"id": "9f8c4409-2b29-4394-a645-d53cdd4d84c7",
			"comic_id": "4d47ce5c-cd75-4af4-8a81-9d7f4bea3ef0",
			"name": "Irene Nogueira",
			"tag": "Cenas Marcantes",
			"imagem_name": "irauna-cena-irene"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/28770fab-0b0a-4aff-88e2-f7830dac21ec/Rocky_Rooster.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=09bbee9694ad8b9c52343c04689e736521887984b0730a1bf65c18ff3f203681&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-20T13:23:00.000Z",
			"id": "17bee7f5-8571-4d47-801d-e6a859373e4a",
			"comic_id": "9e5f18bc-5f28-4cd1-8153-5bfe77cccaf4",
			"name": "Rocky Rooster (Pedra Galo)",
			"tag": "Personagens Maneiros",
			"imagem_name": "monsterodyssey-char-rockyrooster"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/2762d44d-7030-4c9b-a9eb-a3141c15e81f/ROCKAO.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=4955adb8cc5757864694a672fe5a165727ab1306214776fb13c454716af91acf&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-16T02:19:00.000Z",
			"id": "37c06871-25f5-4b44-8f80-364a4255a52a",
			"comic_id": "4d47ce5c-cd75-4af4-8a81-9d7f4bea3ef0",
			"name": "ROCKÃO - Rock’ N Roll Bar",
			"tag": "Lugares Irados",
			"imagem_name": "irauna-lugar-rockao"
		},
		{
			"image": "https://prod-files-secure.s3.us-west-2.amazonaws.com/f517cedd-02e7-4b07-8d9a-65d87adf03b6/326fa097-3406-46e8-88ca-e9d8426ff87b/GOSTOSA_DO_MAL.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAZI2LB4663UZOBQHE%2F20250331%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250331T232852Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJIMEYCIQCz3EhsvT5mV0C%2BJUnzTBkNsa8Te2GpO5RjpxucX67DgQIhAMtmcajThw7gSD39qr1EIk9sXzyemwTwDNqB0%2BM%2FqVq0KogECKv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjM3NDIzMTgzODA1IgyDDHYbipM2yvf1Lg4q3AOZAc2c%2BycmJcqrRBtSjMLdX1O8jFVPUwA3uvUr1cYpZZ99PUn43402Cq9AVCpDCtZGXnUBiBCIZiQMt5YeXCPbPleVqWzUJv6dgLD7lepqwm8dmf2or2dBQLLd07l4hMKqqQw7qv%2F627wblOUJ8hjxphSOW39%2FXhtN9vPbfRxW4K5KBMMEEDoJdKDImT5qmWJEcQbdTCieyuV3pxnHcPXOM1fHV7m%2F%2FMYCt6d1ymYnYqykytIIwU2zi%2BcUA2IWp%2Bmck%2B6h%2FJOVBRtrSvI8JS6fVbKwH%2BPd43R9ya7idlqG9Y3QD4VikBDprXo7emWs1renshGpIkXXsLJcowqc9UuwbqO6aCLoc1DxIq8axzyW2cxlAxpb2r38Obymu7pc7UagpEc8OqqnBIh66%2FcuoaK%2FJzOo4TPnXvgG5CjrLhiT2SY6fUSbSBjcs5Q9zU571vq01M0uT68ObMIK4eu7bMFT%2B9eSycItdanau9vsPDkx%2BY75PaEcLApkfkZfDpqEmSEjl1H6RP%2BqvO59UWPkVx6lExx0AXDutCSOOCQXO0iNUj3uBW%2BYsM%2BrpK41cnoRnCs3bgTZ540nMTTl7now52pS%2FJhdWc6APGkc5FUMouKaiK1eytWD3g5p6mKBZTCwuKu%2FBjqkAVJeNoPD2mNDhbnxz7MLYd79aZDc6X6Y9dJAtqQRfnQXQKlQJbWbWpuRAyQjv3KZnWR9bhObrEwbiRRi7j8TGuMc2JC8YSxHTgV%2Bem74T0%2F9EvDqQRt1MXXpY0bC9rMT9nB6Gkcgua0eAP%2F1Z%2Bh%2BwKpLkyzjO0GQX8gqY7FPNW3U8V%2BRmy4pzsPbiTs7V75ncztY5aPK%2BhRERTGKT0LXfy5SCTJ%2F&X-Amz-Signature=1a0d2497d1a1a42c5d8cb29dc660e258031d7a6685b331b8847c9cb8b6238688&X-Amz-SignedHeaders=host&x-id=GetObject",
			"created_time": "2022-12-16T01:09:00.000Z",
			"id": "bbcb36d9-ed28-4a00-a9e2-2964bfaa07b7",
			"comic_id": "75b22629-cd4d-491e-b963-33c2466de909",
			"name": "A GOSTOSA DO MAU!",
			"tag": "Cenas Marcantes",
			"imagem_name": "kstar-cena-gostosadomal"
		}
	],
	"authors": [
		{
			"id": "1c7e1ce0-0fd5-8077-b321-f8155d314ac1",
			"name": "Devil Bell",
			"onLive": false,
			"insta": "https://www.instagram.com/devilbell_artes?igsh=MXRzazNza25wbGRidw%3D%3D",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1c7e1ce0-0fd5-8021-9ced-c21339c352c8"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1c7e1ce0-0fd5-8007-b410-dd818d88ec65",
			"name": "Nay Veiga",
			"onLive": false,
			"insta": "https://www.instagram.com/nayanaveiga.art/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1c7e1ce0-0fd5-806e-98ad-e2a9bd5f2642"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1c7e1ce0-0fd5-809c-a97c-d77a33ca45ad",
			"name": "Wanderjegson",
			"onLive": false,
			"insta": "https://www.instagram.com/wanderjegson/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1c7e1ce0-0fd5-80ea-8304-f2d7ffabd773"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1c7e1ce0-0fd5-8062-aac4-e2c9671ce508",
			"name": "Caosmose",
			"onLive": false,
			"insta": "https://www.instagram.com/caosmose.zine/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1c7e1ce0-0fd5-8099-a360-fdbd5d442962"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1c7e1ce0-0fd5-8055-9d38-c5d4e3f445a4",
			"name": "Krats",
			"onLive": true,
			"insta": "https://www.instagram.com/krats.hqs/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1c7e1ce0-0fd5-80bd-a1ff-e6e64f4146ea"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1c7e1ce0-0fd5-80b4-be5d-f5594adb0d14",
			"name": "Guilherme “BrushRush” Freitas",
			"onLive": true,
			"insta": "https://www.instagram.com/gui.gfreitas/",
			"twitter": "https://x.com/CanalBrushRush",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1c7e1ce0-0fd5-8050-b75c-d82740e1bfe4"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b8e1ce0-0fd5-80d9-9222-d8beb1f33d7e",
			"name": "Aninha chan",
			"onLive": false,
			"insta": "https://www.instagram.com/an_chan_s2?igsh=MXRpYnJucTVsdWJ0aQ%3D%3D",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b8e1ce0-0fd5-80a4-bbf4-eed509860df2"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-8044-bd3b-ef0c3bec3b2e",
			"name": "Dyce G",
			"onLive": true,
			"insta": "https://fliptru.com.br/@Dyce_G",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-8069-993a-e64909260934"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-8084-995d-c3c8484f6677",
			"name": "Markin the Starboy",
			"onLive": false,
			"insta": "https://fliptru.com.br/@Markin_the_Starboy",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-8001-b43d-e306faa8440a"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-8060-b536-d5adc8dbbbb9",
			"name": "Roger “Excelencia” Alberto",
			"onLive": true,
			"insta": "https://www.instagram.com/roger_alb3rto/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-8055-b489-ce1d3453cb92"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-8098-83bb-f46b1e4cf565",
			"name": "Cristiano ‘Haeckel’ Oliveira",
			"onLive": false,
			"insta": "https://www.instagram.com/haeckelalmeida/?hl=pt-br",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1b7e1ce0-0fd5-80f2-a89c-e5b64841a914"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-80f2-bf2d-d9e4842336a9",
			"name": "Ice Angel Simon",
			"onLive": false,
			"insta": "https://www.instagram.com/ice.angel.simon/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-80c1-8891-c7eadec2f8cc"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-8043-a8a0-d75bf74fb404",
			"name": "Inospito Will",
			"onLive": false,
			"insta": "https://www.instagram.com/willianinpt345/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-80a5-a94f-ec2d691a6b90"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-80a5-a33c-efbbc0095134",
			"name": "Kuraishi Rei “Bagul”",
			"onLive": true,
			"insta": "https://www.instagram.com/kuraishi_rei",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-8070-a859-d1b4fbfef1fe",
				"1c7e1ce0-0fd5-80b8-b1cd-e512250100dd"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-80a3-b3dc-edf027b631b2",
			"name": "Coelho Comic",
			"onLive": true,
			"insta": "https://www.instagram.com/coelhocomic",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-8067-9473-de156a999ec8"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-809c-adff-ff6e5b2fcfa4",
			"name": "Vesper “AGUA”",
			"onLive": true,
			"insta": "https://www.instagram.com/teiuvesper/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-807a-befd-d255c7d1d7df"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-8079-9015-d5b3fdbd552c",
			"name": "Bruno Cezar",
			"onLive": false,
			"insta": "https://www.instagram.com/22o9l/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-8034-a4a3-ef6c55bf2eb0"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-805b-a4eb-c3affe98336f",
			"name": "Iris Grimoire",
			"onLive": true,
			"insta": "https://www.instagram.com/irisgrimoire_/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1b7e1ce0-0fd5-80d6-a66f-e05a21683a7d"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-80b1-9808-e70669815a7c",
			"name": "Otatter",
			"onLive": true,
			"insta": "https://www.instagram.com/otatter/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-80df-9bf3-faee14be8d4e"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-802b-a87c-d97e01f7ac31",
			"name": "Elinho Galvão",
			"onLive": false,
			"insta": "https://www.instagram.com/elinhogalvao/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-80a1-b88c-d2711faa51d6"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-809e-a106-ef889aafe920",
			"name": "DCCGAMES",
			"onLive": true,
			"insta": "https://www.instagram.com/dccgames.3333/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1b7e1ce0-0fd5-80f2-8912-dbff2317d0f3"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-8016-a726-e5d12c714758",
			"name": "Hashimura",
			"onLive": true,
			"insta": "https://www.instagram.com/hashimura.yutaro/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-802b-a5d4-cfe865ac456f"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-80a6-aa97-d997c53869ff",
			"name": "Ivan Anderson",
			"onLive": false,
			"insta": "https://www.instagram.com/1977player",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-804c-a834-f36f17a9895f"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b7e1ce0-0fd5-806a-8c60-c2555f3c8bb6",
			"name": "Rubinho",
			"onLive": true,
			"insta": "https://www.instagram.com/binhokonoha/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1b7e1ce0-0fd5-808c-ad91-d11447136daf"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "197e1ce0-0fd5-807c-94cf-e54924178a03",
			"name": "Za Bucci",
			"onLive": false,
			"insta": "https://www.instagram.com/za_bucci/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"197e1ce0-0fd5-8036-a055-cda395cd9955"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "197e1ce0-0fd5-8015-b7ec-fd6620de9f95",
			"name": "Ailton DB",
			"onLive": false,
			"insta": "https://www.instagram.com/ailton.db/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"197e1ce0-0fd5-80a9-9b5c-d515ad3d17d5",
				"1b7e1ce0-0fd5-8091-b5a3-f6ed3ae89033"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "197e1ce0-0fd5-8023-a1f3-cd6d0e6981d8",
			"name": "Caffe",
			"onLive": false,
			"insta": "https://www.instagram.com/caffetaminado/",
			"twitter": "https://x.com/caffetaminado",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"197e1ce0-0fd5-80e4-8696-eace5bdab623"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "197e1ce0-0fd5-80b7-a20e-fdb2929b3512",
			"name": "Liw Bug",
			"onLive": false,
			"insta": "https://www.instagram.com/annoyingbug26/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"197e1ce0-0fd5-80d6-a611-ed4f768ef9db"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "193e1ce0-0fd5-80a9-bcdf-e3a5535d1f91",
			"name": "Clancy “South Curse”",
			"onLive": false,
			"insta": "https://www.instagram.com/south_curse/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"193e1ce0-0fd5-80d6-b62c-d3101e755412"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "192e1ce0-0fd5-80ff-9576-f58e4ec98586",
			"name": "MariVih",
			"onLive": false,
			"insta": "https://www.instagram.com/vih_adona/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"192e1ce0-0fd5-8093-8934-c3a72794b808"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "192e1ce0-0fd5-80a0-a37a-efba6f5ec4f6",
			"name": "Makice Hit",
			"onLive": false,
			"insta": "https://www.instagram.com/makice.hit/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"192e1ce0-0fd5-8046-b81d-dc50ede9916c"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "192e1ce0-0fd5-806b-8c0c-c6b0b051c241",
			"name": "Davi “Sakkay” Guimarães",
			"onLive": false,
			"insta": "https://www.instagram.com/sakkay.chester/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"192e1ce0-0fd5-8098-9aa5-e2cb43e74c93"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "17ce1ce0-0fd5-80b2-bba9-d2185b5082b9",
			"name": "Mila DN",
			"onLive": true,
			"insta": "https://www.instagram.com/mila_dn_/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"17ce1ce0-0fd5-80c7-8b35-fb382697ec6d"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "170e1ce0-0fd5-806c-9f73-f88565370ec5",
			"name": "Antônio Ruiz",
			"onLive": true,
			"insta": "https://www.instagram.com/antonruiz_hq/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"170e1ce0-0fd5-8019-9cdb-d5b7bc8f3039"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "170e1ce0-0fd5-803e-aae1-d686528b1a64",
			"name": "Yoru Taiyou",
			"onLive": false,
			"insta": "https://www.instagram.com/taiyouyoru_",
			"twitter": "https://x.com/TaiyouYoru",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"170e1ce0-0fd5-8011-9fd2-f9ce7de53eff"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "170e1ce0-0fd5-80c3-a167-d3492f8cc335",
			"name": "L Cotrim",
			"onLive": false,
			"insta": "https://www.instagram.com/l.cotrim1993/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"170e1ce0-0fd5-80ef-9824-e8cbb85f73c2"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "170e1ce0-0fd5-80bc-a14b-db6f3382c1ab",
			"name": "Carol “Eclética” Hencklein",
			"onLive": false,
			"insta": "https://www.instagram.com/ecleticaleitura/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"170e1ce0-0fd5-803b-a2d7-cf2a147ed88d"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "170e1ce0-0fd5-8060-b6c2-de53ad9cb8d2",
			"name": "Taygra Suza",
			"onLive": false,
			"insta": "https://www.instagram.com/taygra.suza/",
			"twitter": "https://x.com/TaygraSuza19",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [],
			"gen": "♂️",
			"status": []
		},
		{
			"id": "16fe1ce0-0fd5-8049-a9c9-d441adac3119",
			"name": "Darky Jr",
			"onLive": true,
			"insta": "https://www.instagram.com/bloodyportals",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119",
				"170e1ce0-0fd5-8037-88d7-d333b77b7f8b",
				"1b7e1ce0-0fd5-80b2-8685-e3d799354335"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "16fe1ce0-0fd5-800b-80fa-d883ddbf4e7a",
			"name": "Skyle",
			"onLive": true,
			"insta": "https://www.instagram.com/skyle_oc/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"16fe1ce0-0fd5-80e7-9e3f-d0bdc4513661",
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "13be1ce0-0fd5-8000-9fbd-e7aff4304658",
			"name": "L1nkUwu",
			"onLive": false,
			"insta": "https://www.instagram.com/l1nkuwu/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"13be1ce0-0fd5-80e1-b394-f602da84ddbd"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "13be1ce0-0fd5-80ba-93c6-f2afc39051c0",
			"name": "Miguel Kurse",
			"onLive": false,
			"insta": "https://www.instagram.com/miguelfilter/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"13be1ce0-0fd5-80e8-b151-fc4a78afe574"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "13be1ce0-0fd5-809b-9a74-ddbfa6327c2c",
			"name": "Gabzzz",
			"onLive": false,
			"insta": "https://www.instagram.com/gabs.gabs.gabzzz/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"13be1ce0-0fd5-8054-a615-db7be429fb73"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "125e1ce0-0fd5-80f8-89a1-f8c26caab191",
			"name": "Priscila Bernardo",
			"onLive": false,
			"insta": "https://www.instagram.com/priscilaber_nardo/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"125e1ce0-0fd5-8042-96b4-e6194749aa4d"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "125e1ce0-0fd5-80fb-96b5-c1f022a4784c",
			"name": "Dan Helhundaz",
			"onLive": false,
			"insta": "https://www.instagram.com/dan_helhundaz/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"125e1ce0-0fd5-8042-96b4-e6194749aa4d"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "125e1ce0-0fd5-8095-a200-fc787c02e357",
			"name": "Athus Daniel",
			"onLive": false,
			"insta": "https://www.instagram.com/athusdarts/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"125e1ce0-0fd5-8042-96b4-e6194749aa4d"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "123e1ce0-0fd5-80b6-b2fe-c5b531817efb",
			"name": "Heliton Mota",
			"onLive": false,
			"insta": "https://www.instagram.com/heliton_mota_atayde/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"123e1ce0-0fd5-80e2-8f0f-d7044f4dd4dc"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "115e1ce0-0fd5-80d0-bc85-c7d23fda9967",
			"name": "Abrakuxas",
			"onLive": true,
			"insta": "https://www.instagram.com/abrakuxas/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"115e1ce0-0fd5-806d-a507-e40ade9eeacd"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "115e1ce0-0fd5-8054-a517-d80018b88210",
			"name": "Gabriela Paciulo",
			"onLive": false,
			"insta": "https://www.instagram.com/paciulo/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"115e1ce0-0fd5-8066-83a1-ffd37bdee223"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "114e1ce0-0fd5-8093-b9f2-ff24e20c056d",
			"name": "Hyoguera",
			"onLive": false,
			"insta": "https://www.instagram.com/hyoguera/",
			"twitter": "https://www.twitter.com/hyogoborges",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"115e1ce0-0fd5-80b7-ad94-cc30899b9e20"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "110e1ce0-0fd5-80dc-8574-c9dcb15abe3c",
			"name": "Sir Gawain",
			"onLive": false,
			"insta": "https://www.instagram.com/sr.gawain/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"110e1ce0-0fd5-80e2-8ba1-c888b76f4ea7"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "110e1ce0-0fd5-8099-832c-f22ba5c9b43e",
			"name": "Sir Ysak",
			"onLive": false,
			"insta": "https://www.instagram.com/sir.ysaki/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"110e1ce0-0fd5-80e2-8ba1-c888b76f4ea7"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "103e1ce0-0fd5-800e-8227-e279d59de29c",
			"name": "Bibisavi",
			"onLive": false,
			"insta": "https://www.instagram.com/bibivs1221/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"103e1ce0-0fd5-80c9-b507-e3c392f3a436"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "d6d82d6d-545b-4c91-bc9c-185536159c48",
			"name": "Evaristo Ramos",
			"onLive": true,
			"insta": "https://www.instagram.com/_evaristoramos/",
			"twitter": "https://x.com/evaristorart",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"a94ee5d3-90a2-4d10-9ad1-ff0ff87f02e7"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "68abf776-b951-4b4d-ac5d-4f660086621a",
			"name": "Jayson Santos",
			"onLive": false,
			"insta": "https://www.instagram.com/jaysonsantosartwork/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"86199f5d-6800-4a38-9a50-e6013ab409f3"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "681feb2e-2b51-49ce-b705-47413e971ec2",
			"name": "Mouch",
			"onLive": true,
			"insta": "https://www.instagram.com/mouch_ch/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"86199f5d-6800-4a38-9a50-e6013ab409f3"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "aaad16e0-54a5-471b-b649-8c8c7446b211",
			"name": "Gaboy",
			"onLive": true,
			"insta": null,
			"twitter": "https://x.com/gabsfromAP",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"a29a53a7-aafe-42b3-91d7-bb8b17cbd508"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b9a6203d-29a9-481a-babf-1406a4c69130",
			"name": "Lorde Lobo",
			"onLive": false,
			"insta": "https://www.instagram.com/lorde_lobo/",
			"twitter": "https://x.com/lordelobo",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"17cca0bb-0dec-4f98-ad89-c04ac2eb71c1"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "42b27be0-320b-4397-859a-d5a6fbc791f1",
			"name": "Gustavo Borges",
			"onLive": false,
			"insta": "https://www.instagram.com/gustavoborgesart/",
			"twitter": "https://x.com/GusBorgesART",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"ab2f8fc7-617d-4910-9d0f-0fa6369ef182"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "5984fc32-f3f3-4ca2-85f6-cbbb9e0f7f90",
			"name": "Eric Peleias",
			"onLive": false,
			"insta": "https://www.instagram.com/ericpeleias/",
			"twitter": "https://x.com/EricPeleias",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"ab2f8fc7-617d-4910-9d0f-0fa6369ef182"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "0fce9ad5-6a3f-4a79-8cb4-ccbbfafd05e1",
			"name": "Yanagawa",
			"onLive": false,
			"insta": "https://www.instagram.com/yanagawa_masashi/",
			"twitter": "https://x.com/GawaYana",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"b0367733-af29-4113-8dfc-e6ffb79e5a3c"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "cce60cfc-446d-46bd-b9b8-aef611f664f3",
			"name": "Guilherme Dias",
			"onLive": false,
			"insta": "https://www.instagram.com/ilustreguilherme/",
			"twitter": "https://x.com/ilustre_gui",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"7a75dc99-2390-420f-9f0a-f6bf40f9a0c6"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "dadefabc-351f-488a-b535-c82dbcb47f9c",
			"name": "Matheus Avanco",
			"onLive": false,
			"insta": "https://www.instagram.com/mateusu_muto/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"ef5a29a0-c598-4f55-8e3b-c3e95673682d"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "a62ad15d-1a0a-4636-a309-589f7ae38c31",
			"name": "Eruru Comics",
			"onLive": false,
			"insta": "https://www.instagram.com/eruru_comics/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"ef5a29a0-c598-4f55-8e3b-c3e95673682d"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ec8ced61-4b99-427b-a993-f43d1123617c",
			"name": "Rafael Lima",
			"onLive": true,
			"insta": "https://www.instagram.com/rafalima831/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"b654bda0-baec-41c7-97c0-aae86150e79d",
				"a5aa737b-f597-4a89-a61c-56c0af041970",
				"1c7e1ce0-0fd5-80af-82c2-c300ca487640"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "17f1a340-4ba6-4079-a58b-d4409e49663f",
			"name": "Fred Moreatti",
			"onLive": true,
			"insta": "https://www.instagram.com/lordmoreatti/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"bc68c49e-8609-4923-9d9f-22d9051bdb21"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "68845b7c-7f06-4cd6-9f7b-fd8583164fd9",
			"name": "Victor M Ilustra",
			"onLive": true,
			"insta": "https://www.instagram.com/victor_m_ilustra/",
			"twitter": "https://x.com/Victor_M_sketch",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"e4e45844-56fa-4528-8666-612cd44cedad",
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "c89ad8e4-19b8-4146-a125-a9aa48e2198f",
			"name": "Mau Clemente",
			"onLive": true,
			"insta": "https://www.instagram.com/mau_clemente_arts/",
			"twitter": "https://x.com/MauClementeArts",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"37606a8a-344b-48ef-ad02-6ef1579c3500"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b34e152b-0055-4e00-8399-e06cb303d0dd",
			"name": "Leonardo Gomes",
			"onLive": true,
			"insta": "https://www.instagram.com/leonardogomes4908/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"faf5f79f-c223-49c6-b9cb-f8e949438518",
				"1b7e1ce0-0fd5-8091-b5a3-f6ed3ae89033"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "d83b09b3-1e12-4427-9643-7423c0a44ce2",
			"name": "Alienyando",
			"onLive": true,
			"insta": "https://www.instagram.com/alienyando",
			"twitter": "https://x.com/Alienyando",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"40e9af8f-7ce5-470b-bcfd-720cdeb03728"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "4d1aa834-8934-48b9-9181-d3a3a1fefc8b",
			"name": "Niane",
			"onLive": false,
			"insta": "https://www.instagram.com/_nianee/",
			"twitter": "https://x.com/_Nianee",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"dd6fbf1e-23a3-43f6-b6aa-0e42475d3bc7"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b4ebc8da-f313-4719-8f75-56d0d0d4944c",
			"name": "Kaiser Estudio",
			"onLive": true,
			"insta": "https://www.instagram.com/kaiserestudio/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f0e4b5bf-a033-492c-be48-b0b6a53059fe"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "8f7b6008-0ffe-4fe5-aa44-b1f2486b2282",
			"name": "Gonçalo-sensei",
			"onLive": false,
			"insta": "https://www.instagram.com/goncalo.sensei/",
			"twitter": "https://x.com/GnascimentoSamy",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"7ee95af4-ded0-46d9-891f-0e4cbca7de4d"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "85ecaba3-0539-4684-9a3c-dd69fd90522d",
			"name": "Edgar Clemente",
			"onLive": true,
			"insta": "https://www.instagram.com/martysis_/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"cfec0b27-9ef0-46af-9737-0ef2ecbc7de7"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "e4b27ba0-1807-46bd-876a-e88b0b44d080",
			"name": "Steven Constant",
			"onLive": true,
			"insta": "https://www.instagram.com/steven_constant42/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"cfec0b27-9ef0-46af-9737-0ef2ecbc7de7"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "a0fe3a2d-e74b-4867-9734-7c4b84241da1",
			"name": "BMC Studio",
			"onLive": false,
			"insta": "https://www.instagram.com/bmc_estudio/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"ec62cf56-8726-4727-b845-8963b5d6989f",
				"d80cb943-5ca6-4130-9d44-1f398a0a79b1"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "c3fc11bb-f65e-4da5-85f2-0bd8aae5dd7c",
			"name": "Taka-san",
			"onLive": false,
			"insta": null,
			"twitter": "https://twitter.com/takasantaito",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"c9996e3f-5ccb-4883-872b-64c06dd358b0"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "c448633f-708c-4f76-a740-16e58aed48dd",
			"name": "ObarbaViking",
			"onLive": false,
			"insta": "https://www.instagram.com/obarbaviking/",
			"twitter": "https://twitter.com/obarbaviking",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"3bce1eef-cde0-45de-8756-0dcb1fa57a24"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "f0a8784a-3df9-44a2-be7c-c21d55a8ee90",
			"name": "Matheus “Math” Trindade",
			"onLive": false,
			"insta": "https://www.instagram.com/hey_math__/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"05129e5a-d556-411f-80d4-5690a64b08a2"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "15e8625f-9719-48d1-adc2-ffa92a8034a2",
			"name": "Eduarda “Noha” Nohama",
			"onLive": true,
			"insta": "https://www.instagram.com/cinnamonoha/",
			"twitter": "https://twitter.com/cinnamonoha",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"d67f7c5f-9570-416d-b976-bb79e7f06ba5"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "c805f98a-1817-4152-9fc0-3e405a464756",
			"name": "Kelvin “Kemuri",
			"onLive": false,
			"insta": "https://www.instagram.com/kemurink/",
			"twitter": "https://twitter.com/kel_uriel",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"77404a93-35ba-4618-b741-ef1be2052250"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "6b107db9-34ff-4805-b69d-93ab206f6f09",
			"name": "Daniel Jonas",
			"onLive": false,
			"insta": "https://www.instagram.com/mugiwara.no.daniel/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"549eb822-eef8-4e25-9b95-e18bc6976265"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "7b7c421e-4065-4eee-b500-8cc5ad0d9b86",
			"name": "Hanna Mello",
			"onLive": true,
			"insta": "https://www.instagram.com/hannamelldraw/",
			"twitter": "https://twitter.com/MellohiOficial",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"2969ddcf-cefd-4cc5-9417-c1e1b4147094",
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "3543d9bb-8639-4c06-8866-9c1e4da358e3",
			"name": "Naythf ",
			"onLive": true,
			"insta": "https://www.instagram.com/naythf/",
			"twitter": "https://twitter.com/naythf",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"141d6abc-ac27-43f5-8a1d-425fa86bdc74"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "655cac85-5412-4fbc-99cf-acc33e61068a",
			"name": "Erlin",
			"onLive": false,
			"insta": "https://www.instagram.com/erlin.noob",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"7275054e-a04c-4900-b5f8-bfa7fb11f5aa"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "fd71c1f2-fc92-4ecf-84b3-379232649204",
			"name": "Ruan \"Stcinco” Saymon",
			"onLive": false,
			"insta": "https://www.instagram.com/_stcinco_",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"b2e93462-0c6c-40d3-8e66-d3eaca878024"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "a048989e-aab9-4407-8b8b-2f5de0cf0d68",
			"name": "Adilson Cussanda",
			"onLive": false,
			"insta": "https://www.instagram.com/ad_cussanda/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"95cdf82a-c50b-47c4-9925-b1d6ebc28e81"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "78a6a0ef-7fea-4448-894a-e054760935ee",
			"name": "Enzo Garcia",
			"onLive": false,
			"insta": "https://www.instagram.com/enzogarciaabreu",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"95cdf82a-c50b-47c4-9925-b1d6ebc28e81"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "165a02f5-2bc4-4dc6-ae5c-082b493b605c",
			"name": "Offluca",
			"onLive": false,
			"insta": "https://www.instagram.com/offluca_",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"95cdf82a-c50b-47c4-9925-b1d6ebc28e81"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "9cbc16c9-3be7-4934-b5bd-e42872ece8a5",
			"name": "TAJ Mangaka",
			"onLive": false,
			"insta": "https://www.instagram.com/taj.mangaka_mz",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"95cdf82a-c50b-47c4-9925-b1d6ebc28e81"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "4204c5c7-b2fa-4034-a28d-5d8e0c4b26e3",
			"name": "Jhonatan Lourençõ",
			"onLive": false,
			"insta": "https://www.instagram.com/jh0n_l0wrens0/",
			"twitter": "https://twitter.com/l0wrens0",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"f93731dc-96df-4f17-a3cc-4cf372d2b158"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "5e597789-8f18-45f8-b031-aea6bf46b6ae",
			"name": "AntonioIII",
			"onLive": false,
			"insta": "https://www.instagram.com/antonium3",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"f4c9e44e-a0e0-4fc5-b3c1-29e1e51c8cdf"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "0ff8f3fb-946c-4a20-996f-6b2b9dd708d4",
			"name": "Anne “Cosmic” Gabrielle",
			"onLive": false,
			"insta": "https://www.instagram.com/Cosmic_nn",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"b9b11f81-12e0-4457-a8c2-75095ca3a484"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "2185e3f2-8a8d-4e37-864c-c7944597e8b9",
			"name": "Devilin",
			"onLive": false,
			"insta": "https://www.instagram.com/devii_insider/",
			"twitter": "https://twitter.com/Dev1lin2",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"264a5358-9773-42d9-9ef2-8c01242c8e64"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "d2934e44-0f42-44b6-b42c-3bba147b2c4b",
			"name": "Gustavo Colman",
			"onLive": true,
			"insta": "https://www.instagram.com/gugacolman",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"75c03781-46d7-4dce-bffa-7f3ce0d22b37",
				"6d134d6e-f741-44e9-b7ed-943a14d6a1fb"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Lendo"
			]
		},
		{
			"id": "32296dc6-93c4-49e9-8061-b43d35c544d6",
			"name": "Yzumsm",
			"onLive": true,
			"insta": "https://www.instagram.com/yzumsm",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"edd05a2d-eeab-406b-9532-9d0e3a1f6425",
				"110e1ce0-0fd5-807d-94fa-c747e3e75690",
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "826abbb7-3a7d-45cd-a88a-305ade74948d",
			"name": "Ispupi",
			"onLive": false,
			"insta": "https://www.instagram.com/ispupiii/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"b4febda5-fcf9-4064-aa10-408207dbba5a"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "6e9a2c97-2b8d-473e-99cc-5b452fdb9a06",
			"name": "Hanzo",
			"onLive": false,
			"insta": "https://www.instagram.com/alienigenashinobi/",
			"twitter": "https://twitter.com/alienshinobi",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"731707c0-b46f-47f8-9cbd-45d30b4a42ed"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "81297506-44dd-49da-9e3d-6bd3391f5912",
			"name": "Bianca “CosmicWolf” Alvarenga",
			"onLive": false,
			"insta": "https://www.instagram.com/cosmicwolf_arts/",
			"twitter": "https://twitter.com/cosmicwolf_art",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"ed06848d-f688-4e55-8ee7-89c937bb755d"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "c4a055e4-72c7-4854-ab4e-1962c3684aac",
			"name": "Jéssica “Neon Jess” Lang",
			"onLive": false,
			"insta": "https://www.instagram.com/_neonjess",
			"twitter": "https://twitter.com/_neonjess",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"68c391e8-079c-49ef-9996-e441b8e06ef4"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "29201761-fc4a-470e-abb9-0301d5483d04",
			"name": "Alexandra Presser",
			"onLive": false,
			"insta": "https://www.instagram.com/alepresser",
			"twitter": "https://twitter.com/AlePresser",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"13255ade-4660-4c90-be93-7995d7f68bf2"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "9390e81f-feab-4547-8e72-36dc7c4413c8",
			"name": "Studio PBR",
			"onLive": false,
			"insta": "https://www.instagram.com/studio.pbr/",
			"twitter": "https://twitter.com/StudioPBR",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"9a3df967-21ba-421e-bc53-bd66308a65ac"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "612961c9-7de7-4eaa-aa6e-e919f684097d",
			"name": "Julia Bax",
			"onLive": false,
			"insta": "https://www.instagram.com/juliabax/",
			"twitter": "https://twitter.com/juliabax",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"092b8877-ba72-4afc-8f3e-fa5b1a391166"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "d03ab3df-73fb-4e82-9391-43528dd62e68",
			"name": "Higor “Digão” Sabino",
			"onLive": false,
			"insta": "https://www.instagram.com/higorsabin",
			"twitter": "https://twitter.com/digaoagressivo",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"b887ffbe-e0ed-4102-a91c-4b072589443e"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "d8b6074d-8e44-4ef4-85a2-7077395548f4",
			"name": "Daniel Moura",
			"onLive": false,
			"insta": "https://www.instagram.com/studiodaniewm/",
			"twitter": null,
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"e9df8e65-c28e-489c-82d2-adc289174547",
				"d719e11a-81fb-4eaf-9fec-a517e7462e2e",
				"ff729f29-eeb5-452b-8580-fdea22b6dda1"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "d46be073-a50b-4dd1-8a80-99696eea6686",
			"name": "Hiago HC",
			"onLive": false,
			"insta": "https://www.instagram.com/hiago_nc/",
			"twitter": "https://twitter.com/NoMundodeAltri",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"2b1ac6f5-ccd5-4005-b4d6-0a4289173228"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "17b25a6c-d5f9-46e7-92c7-e50fcd22a83e",
			"name": "Hugo Mushier",
			"onLive": false,
			"insta": "https://www.instagram.com/hugo_mushier/",
			"twitter": "https://twitter.com/HUGOMUSHIER",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"a19c4e81-4d8a-4769-9254-a582b83a51ca"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "76ec197d-f662-482a-8529-eb9823706395",
			"name": "Acir Gomes",
			"onLive": false,
			"insta": "https://www.instagram.com/acirgomesoficial/",
			"twitter": "https://twitter.com/acirgomes",
			"inedito": true,
			"etnia": "🤎",
			"quadrinhos": [
				"b5533041-1e50-4778-9d4b-78d031a4184e",
				"ca561eab-ba17-49f4-a4b9-de12a5fa6ee8"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "6734a451-8e8c-4070-b736-4fbda13036bf",
			"name": "Beatriz “Vellany”",
			"onLive": false,
			"insta": "https://www.instagram.com/existium_sui/?hl=pt-br",
			"twitter": "https://twitter.com/existium_sui",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"42c53e3c-cdef-4dc4-8059-14f2ede8a118"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "5e2383d0-270b-4d82-9f89-4d2530b86b04",
			"name": "Marco Ribeiro",
			"onLive": false,
			"insta": "https://www.instagram.com/marcoribeirofb",
			"twitter": null,
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"49c4c6db-101e-41cb-b336-82e92b4cdbf2"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "62f1c30a-aaba-4416-8551-c7022647ba32",
			"name": "Siri",
			"onLive": false,
			"insta": "https://www.instagram.com/silvestre_siri/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"64d09944-887e-4ad2-95d4-95e818303045"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "09555729-dcf1-4629-8d3a-e70db13d2616",
			"name": "Gabriel “Taga” Pinheiro",
			"onLive": false,
			"insta": "https://www.instagram.com/taga.arteiro",
			"twitter": null,
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"e5bd4328-4363-4474-b67e-9e12ca4f143c"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "bbd030d0-5664-42af-9fe0-5c911cd49ebb",
			"name": "Onaito",
			"onLive": false,
			"insta": "https://www.instagram.com/young.onaito/",
			"twitter": "https://twitter.com/___onaito",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"b95e78f5-43e8-463d-88a1-0a703d8f9d3c"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "9acbf076-d269-4ff3-b9db-753b966c976a",
			"name": "Lucas Leike",
			"onLive": false,
			"insta": "https://www.instagram.com/leiki64_/",
			"twitter": "https://twitter.com/Leiki64",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"8f694164-9073-4feb-b2a5-155c998a3331"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "290e9636-c646-4f3f-a468-32aa4f39e81c",
			"name": "Mari Santtos",
			"onLive": false,
			"insta": "https://www.instagram.com/mari_santtos/",
			"twitter": "https://twitter.com/Mari_Santtos",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"4ce40dd7-3329-4288-9f96-9c330b435482"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "6b18db60-0999-4f34-a95b-3e94bf2d4d0b",
			"name": "Ever Sousa",
			"onLive": false,
			"insta": "https://www.instagram.com/everardosousa123/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"839ca949-368a-4dfb-91f3-f261904ddfdd"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "2de18382-03b1-4440-8653-6cbe3514a474",
			"name": "Michel V.P.",
			"onLive": true,
			"insta": "https://www.instagram.com/michelvp.oficial/",
			"twitter": "https://twitter.com/MichelVPoficial",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"8e46d93e-f000-4492-b630-8893425d1864"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "bc0cbfff-b781-42fa-bf31-f7b7c2b3aa82",
			"name": "Kizolf",
			"onLive": true,
			"insta": "https://www.instagram.com/kizolf/",
			"twitter": "https://twitter.com/kizolf",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"0dc5816f-17e3-4893-b75b-f738fb7c55d2",
				"bc91f549-0554-479d-b41f-7df356dc3227",
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119",
				"16fe1ce0-0fd5-808c-887c-e0deeb343284"
			],
			"gen": "🜬",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "3b056d0c-e22e-4628-a1a1-06f64dd57645",
			"name": "S.Bittencourt",
			"onLive": true,
			"insta": "https://www.instagram.com/s_bittencourt_/",
			"twitter": "https://twitter.com/S_Bittencourt__",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"cd1cf97e-6c92-47b3-89fd-36acfa1f3ecb",
				"1c7e1ce0-0fd5-80f9-90e6-f2c26fbf1fce"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "8d1a3576-9bb9-4124-9f3b-39447c15d60f",
			"name": "Johnny Braga",
			"onLive": false,
			"insta": "https://www.instagram.com/uhhuhhq/",
			"twitter": "https://twitter.com/uhhuhhq",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f8cc7553-233f-47c6-967c-8259085e5708"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "8a4d6848-564d-424c-8164-e59d9b0df121",
			"name": "Silva Verso",
			"onLive": true,
			"insta": "https://www.instagram.com/silva_verso/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"533fbd39-5317-4dcc-a101-cc1b27d6cd9b",
				"66ab6501-d672-4b3b-a874-9d00bc49c4f2"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "fcebc835-e59d-44f4-9af7-1c8fc0c0385f",
			"name": "Manoela Costa",
			"onLive": true,
			"insta": "https://www.instagram.com/manoelacostaartwork/",
			"twitter": "https://twitter.com/ManoelaCostaArt",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"ec7eda0a-6954-46f7-9bb1-90e67fcd8b2b"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "626e9184-fc74-49ce-bafd-1f1b11b351ce",
			"name": "Sixtty",
			"onLive": true,
			"insta": null,
			"twitter": "https://twitter.com/Sixttygraph",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1e33ae79-8ada-4c0a-89ea-7aa31a2eb053"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "dc013947-ecd4-4de6-a37f-3aa70d6765ae",
			"name": "Ture",
			"onLive": true,
			"insta": "https://www.instagram.com/oarture/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"b1b2a48d-0860-4057-8851-a9e2219936b9",
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "28cc19a6-6535-4709-9634-e6249b25b15a",
			"name": "Nori",
			"onLive": false,
			"insta": "https://www.instagram.com/noriyuuart/",
			"twitter": "https://twitter.com/noriyoukinky",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"75ad13a9-dc0d-481a-9520-85a569931fc9"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "79d8c194-7143-4a2b-8965-69807db69eb2",
			"name": "Matheus lobto",
			"onLive": false,
			"insta": "https://www.instagram.com/matheuslobto/",
			"twitter": "https://twitter.com/so_chave",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"96ddc133-25d1-4d38-b470-10eb25d1208f"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "9c16133f-4074-4a9e-8c9f-7e3676764d8e",
			"name": "Paulo Estefano",
			"onLive": true,
			"insta": "https://www.instagram.com/pauloeartes/",
			"twitter": "https://twitter.com/pauloeartes",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"90de0867-ec3d-40e8-9be7-6422eca33881"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "7d156117-b3a3-44ec-8224-a6f32913a9f5",
			"name": "Edgard Carrijo",
			"onLive": true,
			"insta": "https://www.instagram.com/studioperrijo/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"b78a5e2b-9d6a-4d9e-9941-aa4397b60668"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "3fcaeef3-6671-4240-90bd-e1f4ff9b8226",
			"name": "José Luiz M Pinheiro",
			"onLive": false,
			"insta": "https://www.instagram.com/luinhadesenhista",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"047e3399-0e5a-4a01-9f57-7d6de26fb9cd"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "9c344d7c-59c1-4198-8896-ec7d8ad3cf4d",
			"name": "Rafael dos Santos",
			"onLive": false,
			"insta": "https://www.instagram.com/rafartdosantos",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [],
			"gen": "♂️",
			"status": []
		},
		{
			"id": "5629fc91-95e5-4761-b73c-f5b52084c0ed",
			"name": "vini_dsoul",
			"onLive": false,
			"insta": "https://www.instagram.com/Vini_dsoul",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"5a06efcc-0421-4f11-a594-2f74959548d0",
				"c479f12a-7251-4573-a93e-3f985f56f3a0"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "5acadfec-5c64-4238-af27-29051ba79f03",
			"name": "Marina Fujita",
			"onLive": false,
			"insta": "https://www.instagram.com/marifujiart",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"7792c7df-8129-4ed6-823c-081f253c4733"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "7bfaecd8-dba6-4d7f-9659-497c13833690",
			"name": "L Eklipse",
			"onLive": true,
			"insta": "https://www.instagram.com/l.eklipse",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"99f07811-c192-44e8-8279-42668b9f6626",
				"19424419-cc80-43ef-8e04-9b9023ad851a",
				"125e1ce0-0fd5-8042-96b4-e6194749aa4d",
				"170e1ce0-0fd5-80eb-a8d8-c7503f478c88"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "1ee79cce-3cb8-4bb4-a1c0-c9b1662a55a6",
			"name": "Artsy_louie",
			"onLive": false,
			"insta": "https://www.instagram.com/artsy_louie",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [],
			"gen": "♂️",
			"status": []
		},
		{
			"id": "45b07f79-970e-4a9e-903c-0c99068250b4",
			"name": "Buga Arts",
			"onLive": true,
			"insta": "https://www.instagram.com/m.buga_",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"cdeae53b-2f5b-46fc-8daa-de82e1ad8791",
				"c479f12a-7251-4573-a93e-3f985f56f3a0",
				"125e1ce0-0fd5-8042-96b4-e6194749aa4d"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "efbce7b7-77ea-4841-ac9e-ec54df6f9bc5",
			"name": "Janeth Vieira da Silva",
			"onLive": false,
			"insta": "https://www.instagram.com/janethvieiradasilvaoficial/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"cdeae53b-2f5b-46fc-8daa-de82e1ad8791"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "90ba8561-e559-436b-ae63-5e691204199a",
			"name": "Mincchi Nyan",
			"onLive": true,
			"insta": "https://www.instagram.com/mincchi.nyan/",
			"twitter": "https://twitter.com/mincchi_nyan",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"da85fc15-be8f-44eb-bd4b-26876c3d5541"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "872f2a9d-3ff9-435a-9ffe-3b0bef36b43d",
			"name": "Fabricio Andrade",
			"onLive": true,
			"insta": "https://www.instagram.com/fabricio_andrade88/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"3b8056dc-0008-45da-942e-3bb6b2da78f1"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "510c6a3a-5ba9-47fa-bfb1-24d4469cf7c5",
			"name": "Beatriz (Bid Desenhos)",
			"onLive": true,
			"insta": "https://www.instagram.com/bid_desenhos",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"92b9941c-94b4-4758-87f7-49439afea6a0",
				"1b7e1ce0-0fd5-80d0-9d9e-db7545313f2a"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "c10c128b-143d-465b-b75c-4c4d68442739",
			"name": "Adrikachan",
			"onLive": true,
			"insta": "https://www.instagram.com/adrikachan/",
			"twitter": "https://twitter.com/Just_Adrika",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"83740dac-785d-4a2a-946f-aaa286e5695c"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b66bf90-c6cb-410a-84f7-f5fef523b53e",
			"name": "Chinês",
			"onLive": true,
			"insta": "https://www.instagram.com/mkd_pitakoxpitako",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"81780fd3-dc42-4c7c-8436-dd496d36d065"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "cc633744-fd7a-4464-96e7-279db196842c",
			"name": "Pongo Comics",
			"onLive": false,
			"insta": "https://www.instagram.com/pongocomics/",
			"twitter": "https://twitter.com/PongoComics",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"34c26087-1164-4772-92a9-f35d00a30214"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b6165c8c-e6a2-4582-a394-ea7ec9d33163",
			"name": "Dika Araújo",
			"onLive": false,
			"insta": "https://www.instagram.com/dikaraujo/",
			"twitter": "https://twitter.com/mobydika",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"630fcf5d-1086-4963-9ca7-097e7df70c6c"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "d303258b-feaf-467a-85c8-fb32274390c6",
			"name": "Rafael “Hexverse” Arcucio",
			"onLive": false,
			"insta": "https://www.instagram.com/hexverse.oficial/",
			"twitter": "https://twitter.com/NeroHexverse",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"46d0cd90-0b84-4a23-9c48-098147d84a17",
				"170e1ce0-0fd5-80ab-a0c3-ca9a30830da6"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "84b7ce4a-beec-4715-9ab6-778b7bb89853",
			"name": "J S Art",
			"onLive": true,
			"insta": "https://www.instagram.com/j.s.art_/",
			"twitter": "https://twitter.com/JSArt12",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"1ee0fa67-fbec-42fc-b605-35a3db69617d",
				"72f3f906-9719-4068-910e-81de91c44a55",
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119",
				"1b7e1ce0-0fd5-80ed-b367-db2369438d3b"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "7e931a62-806f-416c-a9dc-267f12ecf5b4",
			"name": "Gustavo Neves",
			"onLive": false,
			"insta": "https://www.instagram.com/gus_estudios/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"67126124-0c47-4273-a099-205dc132e071"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "efd4af21-0c53-462c-836e-67cd3400a7ce",
			"name": "Bennê Oliveira",
			"onLive": false,
			"insta": "https://www.instagram.com/leve.mente.insana/",
			"twitter": "https://twitter.com/Bennearte/media",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"d818ff3d-ad0e-4ca5-bf80-06f70eb3a233"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "6ded92b5-9237-4ad7-a0f2-ed5d9a20db15",
			"name": "João Kaile",
			"onLive": false,
			"insta": "https://www.instagram.com/joaokaile/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"bb2168c6-5bf5-4eba-97f7-360e9fd457ba"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ad291298-776f-490c-9dc3-36b99e5384e3",
			"name": "Zolly Artz",
			"onLive": true,
			"insta": "https://www.instagram.com/zollyartz/",
			"twitter": "https://twitter.com/ZOLLYartz",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"de88d288-484d-4a6f-96db-ef76765d651e"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "fbf44b20-9532-4d16-9960-cf9f728ee565",
			"name": "Leo The Pard",
			"onLive": false,
			"insta": "https://www.instagram.com/leoartz998/",
			"twitter": "https://twitter.com/SoaresLeosoares",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"de88d288-484d-4a6f-96db-ef76765d651e"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "6b3b8ed4-ae56-4a49-b399-c58e8b4d009a",
			"name": "Dangotirinhas",
			"onLive": false,
			"insta": "https://www.instagram.com/dangotirinhas/",
			"twitter": "https://twitter.com/dangotirinhas",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"b5203e86-b991-4258-b0db-0273c87d0e20"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "06a0e031-70e1-4596-8c3a-3629d4bed3b4",
			"name": "Leo CE Saturn",
			"onLive": false,
			"insta": "https://www.instagram.com/leocesaturn/",
			"twitter": "https://twitter.com/leocesaturn",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"18d8bd5e-f9d1-4a1f-af8d-99d9424cc284"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b03472b4-35ac-47db-a311-261bc8c931b9",
			"name": "Apalomarte",
			"onLive": false,
			"insta": "https://www.instagram.com/apalomarte/",
			"twitter": "https://twitter.com/apalomarte",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"b2535464-993a-45fe-b50c-1c334c19ce77"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "06479745-853b-4522-ad43-4cae317479fc",
			"name": "Guicaires",
			"onLive": false,
			"insta": "https://www.instagram.com/gc_history_drawings/",
			"twitter": "https://twitter.com/GuiCaires21",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"89a2705e-980c-452e-8224-16469d8109f0"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "68c86ebb-9415-42b6-aa63-7a5df311fb9d",
			"name": "Eduardo Aguiar",
			"onLive": true,
			"insta": "https://www.instagram.com/eduardoaguiarofc/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"313bb11d-2310-4976-bd74-2fb7d707598a"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "662e3a22-ecf1-4c72-8f53-f804f0cbe823",
			"name": "Caixopolis",
			"onLive": true,
			"insta": "https://www.instagram.com/caixopolis/",
			"twitter": "https://twitter.com/caixopolis",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f1347b3a-fb52-41e3-a9c8-31575d0f6c9f"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "de15dde0-2c25-4278-bf37-0fdad910e4ee",
			"name": "PROJ Fatal",
			"onLive": true,
			"insta": "https://www.instagram.com/proj_fatal/",
			"twitter": "https://twitter.com/ProjFATAL",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f5414002-efb6-45bd-b80f-296dee47d279"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "a14bf342-da57-4e9a-af14-ca60abb1c0e9",
			"name": "Johnny Oliver",
			"onLive": true,
			"insta": "https://www.instagram.com/johnnyoliver.art",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f1f4354d-4aa5-477a-9676-c0aa64bb54ed"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "39f33dc5-7f22-4e65-90d0-a0f0b6572af3",
			"name": "Leo Amirati",
			"onLive": false,
			"insta": "https://www.instagram.com/leoamirati/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"9cd197ad-22ff-45b4-bf26-4cfe2c934f34"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "81cb51ce-aba6-45fc-bae4-43c0d42ee305",
			"name": "Diego Breno",
			"onLive": false,
			"insta": "https://www.instagram.com/hqplanetasagrado/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"6e9d01b0-6705-4b19-8c20-5e15c30e72e1"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ea798f57-6441-49b1-84c6-9201894a4333",
			"name": "Filipe Oliveira",
			"onLive": false,
			"insta": "https://www.instagram.com/kings_path1/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"24d95aa2-d80e-4931-8579-6cd9f10cdb5c"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "eeaace21-e4e2-4dec-8758-1882a28ebf1c",
			"name": "Lonpetrock",
			"onLive": false,
			"insta": "https://www.instagram.com/manga_deusdachuva/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"df12d508-d467-429a-bbe7-a24038c012a5"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "88db6903-6042-4dea-91eb-3db28e1381db",
			"name": "Studio Seasons",
			"onLive": false,
			"insta": "https://www.instagram.com/studio.seasons.manga",
			"twitter": "https://twitter.com/studioseasons",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"cebc4963-adf1-4ea4-8371-07a92169a9a6"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "8cdbd618-4f2e-43d6-b87e-cad8da9611a5",
			"name": "Selene Hammer",
			"onLive": false,
			"insta": "https://www.instagram.com/selene.hammer",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"8c800bc6-bcbc-4ccc-b1f3-69570e524f55"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "5041ec2b-69d4-4adb-88d9-8ed134016525",
			"name": "Lucas Marques",
			"onLive": false,
			"insta": "https://www.instagram.com/lucmarqx/",
			"twitter": "https://twitter.com/lucmarqx",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"60eeea2c-8a02-4371-8b9c-a6ac73e100cb"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "649b9961-6198-4a77-91e0-f535a1a645ac",
			"name": "Rogério Hanata",
			"onLive": false,
			"insta": "https://www.instagram.com/rogeriohanata/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"217bf8d2-8922-4145-9622-6d3191d074f0"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "4a2d3376-c035-4142-a428-efda4614a99e",
			"name": "MilleBitten",
			"onLive": false,
			"insta": "https://www.instagram.com/millebittenart",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d618789e-df19-4860-89ba-cc591b76a58f",
				"8c800bc6-bcbc-4ccc-b1f3-69570e524f55"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "83f1e44a-ce3b-43e5-b57d-df25f0e38d62",
			"name": "Alan \"Dark Hirkey” Godinho",
			"onLive": false,
			"insta": "https://www.instagram.com/dark_hirkey",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f274988c-d9fa-4086-98f5-ff61fbb8f033"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "06d3b37a-8697-484b-9259-d920129c1c1e",
			"name": "Dersa Marques",
			"onLive": false,
			"insta": "https://www.instagram.com/dersamarques/",
			"twitter": "https://twitter.com/dersamarques",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"89c6a26e-0a85-4b8f-b029-3139a956ba55"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "f548ba7a-0c7f-4513-9144-d0afeccb8eea",
			"name": "Walther Romualdo",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"969c7267-520f-4b5c-8dd8-c80300a3bca0"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "3ed0d619-6c9a-4dab-81c5-2a43d3b42812",
			"name": "Quillcannon",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"8f549780-f9c2-4041-94ff-cabfdd8c6cba"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "08961d54-6825-41a2-a439-3ba341d5e7a6",
			"name": "Ju Loyola",
			"onLive": false,
			"insta": "https://www.instagram.com/loyola_ju/",
			"twitter": "https://twitter.com/loyola_ju",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"c441a6f9-f7c6-4961-b3a4-4cfae9cdcad0",
				"2fab168e-8131-47b2-8b99-0d46b53d9c95"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "bd7e305f-fbde-45ab-8772-de9c9e6cf886",
			"name": "João Eddie",
			"onLive": false,
			"insta": "https://www.instagram.com/joaoeddie",
			"twitter": "https://twitter.com/joao_eddie",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"3e695df3-f54d-473e-8f05-bb5ec920b039",
				"aec52ecf-233c-4c9b-aaf2-048c08999fee",
				"2ab5ca3b-2017-4d6d-a1a1-78ee540bc7c3"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "a7e21f52-ac62-4e3c-ad45-213ec5882184",
			"name": "Zazo Aguiar",
			"onLive": false,
			"insta": "https://www.instagram.com/zazoaguiar/",
			"twitter": "https://twitter.com/ZazoAguiar",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"3a89d144-9027-46e3-9cae-87eca3b93059"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "7b2ff3b6-c46c-48f0-9c27-3578f2083e52",
			"name": "Roberto F.",
			"onLive": false,
			"insta": "https://www.instagram.com/mr.houseki/",
			"twitter": "https://twitter.com/Mr_Houseki",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"038f1bd0-cba6-4e58-89c7-174189150525",
				"1ad0e940-ad7b-439e-879c-fab15e91a9f0"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "af20bb9c-99d7-40ec-833f-ff6f8dc52970",
			"name": "Ichirou",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"891580ca-09d0-4410-8012-d6641986eac4"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "dc4ad9e5-2ab0-400b-9201-9b06e49a3909",
			"name": "Rê Rinaldi",
			"onLive": false,
			"insta": "https://www.instagram.com/tintaderaposa/",
			"twitter": "https://twitter.com/raposamatcha",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"8fa22147-8e3d-4aa4-b400-880e08dd9c93"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "f224ed6d-aa44-47f6-ad15-8b95f8be2b13",
			"name": "Priscilla Miranda",
			"onLive": false,
			"insta": "https://www.instagram.com/priscillamirands/",
			"twitter": "https://twitter.com/pricicologa",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"01e9365b-2662-4890-a6e7-91fd1cc980f9",
				"60eeea2c-8a02-4371-8b9c-a6ac73e100cb"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "c0498f9e-c712-4928-b3b4-2db3af59c56d",
			"name": "Laica Chrose",
			"onLive": false,
			"insta": "https://www.instagram.com/laica.chrose/",
			"twitter": "https://twitter.com/LaicaChrose",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"db4f7f97-e231-4c1b-b088-6187e25d32c2",
				"df45bb04-bea1-43cc-b03d-3c79e51710bc"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "15ce72c7-4f8d-4807-bd7d-ff663cb73685",
			"name": "Eudetenis",
			"onLive": false,
			"insta": "https://www.instagram.com/eudetenis/",
			"twitter": "https://twitter.com/EUDETENIS",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"56835aa2-f306-47ca-922f-dbb5c1ca4308",
				"8f549780-f9c2-4041-94ff-cabfdd8c6cba"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "56a37eb4-272a-42a3-8d61-7f2a2c0ac3a6",
			"name": "Larissa Odarp",
			"onLive": true,
			"insta": "https://www.instagram.com/odarp.inkart/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"10c2ae9d-21a9-4702-a286-fcb4e5845fa1"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "6dd09aec-6919-43e4-97b9-270c54802f73",
			"name": "Nicoly “Niceea”",
			"onLive": true,
			"insta": "https://www.instagram.com/niiceea/",
			"twitter": "https://twitter.com/niiceea",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"a49730c7-d6f9-435f-b069-d0d41d4cdbb7"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "04b581be-ae6e-42eb-a1e4-c4d6aa3a320e",
			"name": "Sabina Anzuategui",
			"onLive": false,
			"insta": "https://www.instagram.com/sabina.anz/",
			"twitter": "https://twitter.com/SabinaAnz",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"eeecf494-7790-44b3-b323-6562abf4872d"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "e4e24980-bb00-4649-85c1-be9b9f0fcbd3",
			"name": "Jey",
			"onLive": false,
			"insta": "https://www.instagram.com/jeygglypuff/",
			"twitter": "https://twitter.com/jeygglypuff",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"5eee2f57-9a7b-4e64-85ac-4df29a7ed0c8"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b9fa13a8-088d-42ea-8fcd-e3a9e2b0a044",
			"name": "Debbie Garcia",
			"onLive": true,
			"insta": "https://www.instagram.com/debbiegarcia/",
			"twitter": "https://twitter.com/florescativas",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f272b5ea-b8a6-4baa-a71f-73081bccdf5c"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "50d9467e-350d-4f04-b3f3-962a48135e19",
			"name": "Lari “Lariarts” Macedo",
			"onLive": true,
			"insta": "https://www.instagram.com/lariarts/",
			"twitter": "https://twitter.com/lariarts",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"5f412d82-407f-41b4-85ee-47aa0d4812a8",
				"a08a2103-93bb-4b2c-a62e-d0d31e10e0ba"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "de5ababf-5214-4ad1-b2fa-86868495af1e",
			"name": "Carine “Coisarine” Araújo",
			"onLive": false,
			"insta": "https://www.instagram.com/coisarine/",
			"twitter": "https://twitter.com/coisarine",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"a80ba308-39b9-4bf0-9c4b-5725cd54d054"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "370a5d3a-a76e-4ba0-86f4-39bb8362886a",
			"name": "Raviolivs",
			"onLive": false,
			"insta": "https://www.instagram.com/raviolifolio/",
			"twitter": "https://twitter.com/raviolivs",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"3c2a8ed8-7d23-4394-9a1b-6d5f34b520dc"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b09e6692-f831-45c4-b023-752ae1af5c6c",
			"name": "Cah Spirit",
			"onLive": false,
			"insta": "https://www.instagram.com/spiritcrowstudio/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"5d73e71d-f4ca-40f1-b2a4-9e4eced5beb8"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "2587c142-3d6c-48b5-87f8-638a1a64dd05",
			"name": "mariihsartt",
			"onLive": false,
			"insta": "https://www.instagram.com/mariihsartt/",
			"twitter": "https://twitter.com/mariihsartt",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"aa3ee854-0c0e-4d34-acae-5ea17f607be1"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "9478d4c4-3d0a-4af0-8818-cd867f94ceb3",
			"name": "Krizael",
			"onLive": true,
			"insta": "https://www.instagram.com/krizael/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"fb5c8334-7908-4da4-890d-87fd74b74b92"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "a9e2b1af-6b6b-44c3-9c4b-ce0bb534b740",
			"name": "Bell",
			"onLive": true,
			"insta": "https://www.instagram.com/belldesenha/",
			"twitter": "https://twitter.com/Bell_e_Krow",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"a2d38323-4ded-4405-a908-f4a56e967b7b"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "3335884f-c66f-42f8-9ca5-e6be99b4a456",
			"name": "Mmyoi",
			"onLive": false,
			"insta": "https://www.instagram.com/mmyoi_art/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"bac85bed-0ab9-41d8-a285-0dbf4491fbe4"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "fc661167-528b-4314-a048-ece7d5039c04",
			"name": "Sara “Floras” Camargo",
			"onLive": true,
			"insta": "https://www.instagram.com/_floraas/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"a6ea284f-c025-48eb-a3d4-59ca773aa567"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "2365a7b3-17c0-446d-8fe3-481dda2989fc",
			"name": "Fernanda Cardozo",
			"onLive": true,
			"insta": "https://www.instagram.com/krestgale/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"bb2168c6-5bf5-4eba-97f7-360e9fd457ba"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "e9b47739-2781-4626-bab2-dbbac7f2278e",
			"name": "Endermaul",
			"onLive": false,
			"insta": "https://www.instagram.com/endermaul_art/",
			"twitter": "https://twitter.com/endermaul_bleh",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"8247c1b6-da5b-4769-9404-dab9fa591caf"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "304ea369-c65f-46ae-8cbe-e0f5a4f476f9",
			"name": "Lana Portiguara",
			"onLive": false,
			"insta": "https://www.instagram.com/lanaflowerz/",
			"twitter": "https://twitter.com/lanaflowerz",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"180c74ab-8544-4f28-8e2f-08a01bb72a51"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "67d378ee-2f6a-4d92-8cde-b7cdd5ae3d3e",
			"name": "Má Matiazi",
			"onLive": true,
			"insta": "https://www.instagram.com/mamatiazi/",
			"twitter": "https://twitter.com/mamatiazi",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"66498b9b-60ef-4b3c-bce8-023f706eaf50"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "a7cb1646-de96-4d98-8745-6872b3c25544",
			"name": "ClauMazzu",
			"onLive": true,
			"insta": "https://www.instagram.com/claumazzu/",
			"twitter": "https://twitter.com/ClauMazzu",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"96f7930f-cb9f-4a31-9d53-5dc4179f6300"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "803fefc8-8eec-469c-b4b2-8dc2f5eca66c",
			"name": "Fernanda Nia",
			"onLive": false,
			"insta": "https://www.instagram.com/fernandania/",
			"twitter": "https://twitter.com/comoeurealmente",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"4bfcbeab-419e-489d-b8b4-520e52ced446"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "a287bdb2-9802-4513-bd50-d2f2f3aca983",
			"name": "Debs",
			"onLive": false,
			"insta": "https://www.instagram.com/boradebs/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d01d19cf-506b-4b3b-a3fd-a544f8353c3f"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "0889d274-087c-4208-a66a-17f4a86c0cd4",
			"name": "Samanta Flôor",
			"onLive": false,
			"insta": "https://www.instagram.com/samantamanta/",
			"twitter": "https://twitter.com/samantamanta",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"25c2cd7f-be31-4494-8c82-692cc88f5435",
				"9a9dbd96-572d-4998-bc44-41c8b9f57a3e"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "dd110086-2650-43b7-822f-e0b70ce2656e",
			"name": "Yel Mizuno",
			"onLive": false,
			"insta": "https://www.instagram.com/yelmizuno/",
			"twitter": "https://twitter.com/mizunoyel",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"978692df-dde8-4d9c-aeb4-5e9d48349776",
				"51ac76d9-1be1-42a7-b0ac-b6d804b1e3d7",
				"123e1ce0-0fd5-8038-8fd5-d9167801ac65"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados",
				"Lendo"
			]
		},
		{
			"id": "fd338cd3-4ec2-4bcc-8b0a-eb72f69fcec9",
			"name": "Momorsa",
			"onLive": false,
			"insta": "https://www.instagram.com/momorsa/",
			"twitter": "https://twitter.com/momorsa",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"7cb9d28f-7141-40ec-9e94-8c92a6ae4414"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "19d02c2a-38b3-422c-b1b4-ce31b4ab5e6c",
			"name": "Germana Viana",
			"onLive": false,
			"insta": "https://www.instagram.com/germana_fazgibi/",
			"twitter": "https://twitter.com/germana_fazgibi",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"c65b7552-24e5-4a65-afc1-b7fc78abff0b"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "fdf16b91-95f8-421d-b8da-b8370a813ed9",
			"name": "Lark",
			"onLive": false,
			"insta": "https://www.instagram.com/larkness_/",
			"twitter": "https://twitter.com/larknessart",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"338b9eef-4914-4112-975c-343bbeee9fc4"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "6b3cfec4-1380-4d22-bf87-91bf273c2ca0",
			"name": "Ellie Irineu",
			"onLive": false,
			"insta": "https://www.instagram.com/ellie.irineu/",
			"twitter": "https://twitter.com/gentenemegente",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"147936a6-60fc-40ca-889b-f1685c3089c2"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b44fb60b-5a8f-42ce-9c6d-6fe21dfb84b9",
			"name": "Ellie Irineu",
			"onLive": false,
			"insta": "https://www.instagram.com/ellie.irineu/",
			"twitter": "https://twitter.com/gentenemegente",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [],
			"gen": "♀️",
			"status": []
		},
		{
			"id": "28301475-072d-474d-8b7c-514b2cb6ae8d",
			"name": "Amanda Treze",
			"onLive": true,
			"insta": "https://www.instagram.com/amdtreze/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"ca1176bc-a12c-4d65-a5f4-2c6dfa7c3b53"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "846bb6b2-a380-492a-a0ff-4ca07d2bb75c",
			"name": "Mari Casimiro",
			"onLive": false,
			"insta": "https://www.instagram.com/mari.casimiro82/",
			"twitter": "https://twitter.com/mari_casimiro82",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"4947fa9e-cb78-4f5d-8be1-bf8ee763df80"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "a64e1682-fb4e-4235-b072-008746739ef4",
			"name": "Carol Rossetti",
			"onLive": false,
			"insta": "https://www.instagram.com/carolrossettidesign/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d3bd3ee6-49d2-4404-8c90-13b82df29b8e"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "698239f4-bec1-4a2f-ba2c-63423048f1f8",
			"name": "Cristal Ilustra",
			"onLive": true,
			"insta": "https://www.instagram.com/cristalilustra/",
			"twitter": "https://twitter.com/TheCristalDS",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"0ed97ee9-4e05-40f4-944d-1ac32b54b392"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "f8f947af-1208-4456-be55-eebf99886494",
			"name": "Loreartsy",
			"onLive": false,
			"insta": "https://www.instagram.com/loreartsy",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"cc638d80-47bc-4bb1-9096-dd7a2accaf4d"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "16cf2f41-3870-42af-8af8-c3dce7a6a9d7",
			"name": "Bianca Pinheiro",
			"onLive": false,
			"insta": "https://www.instagram.com/bianc_pinheir/",
			"twitter": "https://twitter.com/bianc_pinheir",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"bb7a7bc7-81f6-43d0-9845-c7499c7f7809"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "be3697cf-fa7c-4eed-814b-52fcd83ebb6d",
			"name": "Maria Jupira",
			"onLive": false,
			"insta": "https://www.instagram.com/curupira.maria/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"b20f429b-8ec4-4a35-9463-2bc536fb2a56"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "366e9ce3-d848-4426-abae-3cb38cb40148",
			"name": "Gabriel Baptista",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"5d7ceeb6-3054-442a-9d1b-4230cd8cea50"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "f40ae311-6bd7-4aa1-a2a7-a40bb6ed3ab1",
			"name": "Marcella Fiorelli",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"5d7ceeb6-3054-442a-9d1b-4230cd8cea50"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "eca31094-c3f8-4058-89df-80754dc9adb3",
			"name": "Sté Cavalcanti",
			"onLive": true,
			"insta": "https://www.instagram.com/_stecavalcanti",
			"twitter": "https://twitter.com/stearts",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"5d7ceeb6-3054-442a-9d1b-4230cd8cea50"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "cb3709e6-092d-4643-8727-c1d63b80a1c3",
			"name": "IsaGC",
			"onLive": true,
			"insta": "https://www.instagram.com/isacg_01/",
			"twitter": "https://twitter.com/isaCG_01",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"73f51b33-a312-4ce4-abf6-9b85c827c438"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "9a6601b8-47e9-4c9f-a3c7-7f6c011e2376",
			"name": "Dibis Conrado",
			"onLive": true,
			"insta": "https://www.instagram.com/dibis_conrado/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"a3074102-e47a-447a-8fe6-d12a804145fc"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "969ccfc9-ca78-4e38-8a7a-901ce09084d8",
			"name": "Little Tenshi",
			"onLive": true,
			"insta": "https://www.instagram.com/lyttle_tenshi_arts/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"b9174c78-933e-438b-8993-8fd6c65f37c4"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "54dc9681-88cb-4cce-b950-ed407e9242a9",
			"name": "Dani Martins",
			"onLive": false,
			"insta": "https://www.instagram.com/dannimee",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"56104468-872b-4e2e-a0f8-9b6c00a4b05b"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ce185b5d-3fd1-485e-8575-9853f0304624",
			"name": "Anju",
			"onLive": false,
			"insta": "https://www.instagram.com/4njuart/",
			"twitter": "https://twitter.com/4njuart",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"3220051e-5e4e-499c-b773-af1090586ccd"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "2c02b408-7ac6-41bb-b014-00646a56c5e2",
			"name": "LoveGameplayz",
			"onLive": false,
			"insta": "https://www.instagram.com/love_gameplayz/",
			"twitter": "https://twitter.com/Lovegameplayz",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"e95c0ee3-03c8-4923-ac24-bded8853a041"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "18f3da79-246e-4fd6-8b8b-011ba4b2ef15",
			"name": "Nicomikha",
			"onLive": false,
			"insta": "https://www.instagram.com/nicomikha/",
			"twitter": "https://twitter.com/nicomikha",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"ab1b63c1-3408-494f-a595-2759c4d41348",
				"9cd197ad-22ff-45b4-bf26-4cfe2c934f34"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "6ccde704-9fd4-42ee-adcf-f4fb60869e4a",
			"name": "Magic Rold",
			"onLive": true,
			"insta": "https://www.instagram.com/magic_rold/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"69110e23-6b70-4f64-b52a-6b12281d0430"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ea5cd2aa-d31d-491f-ad10-566deebfaf58",
			"name": "L1nkUwU",
			"onLive": false,
			"insta": null,
			"twitter": "https://twitter.com/L1nkUwU",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"bfabdca1-6b72-464c-9cb1-2cdff3b73f39"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "d18ac3c5-26d5-44f2-97c8-20d8aecc878b",
			"name": "Rai Skyland",
			"onLive": true,
			"insta": "https://www.instagram.com/raiskyland/",
			"twitter": "https://twitter.com/RaiSkyland",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"c9e63afa-15f9-4aa1-b726-e620d55c0b79"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "7152fb82-f8a6-40ac-81ce-a07e1dacb5b1",
			"name": "Casty Maat",
			"onLive": true,
			"insta": "https://www.instagram.com/castymaat/",
			"twitter": "https://twitter.com/castymaat",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d5ca0b23-f73d-40ff-8fe3-f0a9cb363b7e"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "4d76b611-484c-418d-be26-73f83526dcc2",
			"name": "Rafael M",
			"onLive": true,
			"insta": "https://www.instagram.com/cigato.mentolado/",
			"twitter": "https://twitter.com/c_mentolado",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"abab2d79-9031-42e7-a094-1c2533ef24e9"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ec8e8e1b-1691-4c71-a3aa-25c39fb1c524",
			"name": "Princesa Lombriga",
			"onLive": true,
			"insta": "https://www.instagram.com/princesa_lombriga/",
			"twitter": "https://twitter.com/PLombrigaXD?t=1MrANH0bwHLY5fENx3x6jA&s=09",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"6e79e835-b3ba-481e-b710-2247b4eb8ec0"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "dacd03bb-5dac-4dae-9aea-a93d25f8a2fa",
			"name": "Mauricio Miranda",
			"onLive": false,
			"insta": "https://www.instagram.com/mauriciomiranda976/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"ad95c23c-9100-459b-b24d-cbc31927bc3a",
				"533fbd39-5317-4dcc-a101-cc1b27d6cd9b"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "e1e460b6-c059-4946-bd7c-537826f903af",
			"name": "Apenas um Pedro",
			"onLive": false,
			"insta": "https://www.instagram.com/apenasumpedro/",
			"twitter": "https://twitter.com/oapenasumpedro",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"12089536-1000-4d85-93df-4dc699ebb271"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "64e4140d-3d47-4d32-9fcd-eda32af73a86",
			"name": "Gabe “Southsenpai”",
			"onLive": true,
			"insta": "https://www.instagram.com/southsenpai/",
			"twitter": "https://twitter.com/southsenpai",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"4ad2c656-5021-4ed7-bff2-1bce1f95e290"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1b4fb92a-06dc-48bd-9a46-cc12375e2b20",
			"name": "Kaji Pato",
			"onLive": false,
			"insta": "https://www.instagram.com/kaji_pato/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"9c7e91b0-df2d-47d8-990c-52a09ef517b6"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "2c625568-0c92-4c6a-8b58-5a2f45294304",
			"name": "Daniel Bretas",
			"onLive": false,
			"insta": "https://www.instagram.com/calaboca.co",
			"twitter": "https://twitter.com/bisualvoy",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"c0fe1c30-47de-4d78-b0f1-d2f8eba5c224",
				"adcb8b06-f1fc-4a27-ae11-6228e3ff8680"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "9c952ca7-2569-4afd-92da-d19b85c9da5a",
			"name": "Ricardo “Ryot” Tokumoto",
			"onLive": false,
			"insta": "https://www.instagram.com/ryotokumoto",
			"twitter": "https://twitter.com/ryot",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"c0fe1c30-47de-4d78-b0f1-d2f8eba5c224"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "aba466e0-6283-4328-a5a2-4dd1dc45c1ab",
			"name": "Carlo",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"c6d2fe6b-8e0d-4ec2-afcb-40b61b5dd204",
				"6a6523bb-fed6-42a5-82e9-a7c0439e2b71"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "d5e79061-03e5-450f-8d54-e91ff2e298e5",
			"name": "Luiz Lekston",
			"onLive": true,
			"insta": "https://www.instagram.com/luizlekston.com.br/?hl=pt",
			"twitter": "https://twitter.com/luizlekston",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"0210646b-3d70-443b-baf6-c9e3d9383fcc"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "d55724ba-4802-4642-925f-d08555a9599f",
			"name": "Debiverso",
			"onLive": false,
			"insta": "https://www.instagram.com/debiverso/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"369cc446-cde6-4f37-a2f9-b8a6bd6dc0a2"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "43d599f5-f2db-4038-871a-5858ec63381c",
			"name": "Marcelli Ibaldo",
			"onLive": true,
			"insta": "https://www.instagram.com/marcelli.ibaldo/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1715f655-f719-436c-843f-99aca48bfaa2"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ced82f98-db04-488c-9ff9-1313ba0fa35a",
			"name": "Marcel Ibaldo",
			"onLive": true,
			"insta": "https://www.instagram.com/marcel_ibaldo",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1715f655-f719-436c-843f-99aca48bfaa2"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "9996afa4-e8ed-4976-9333-825f7cd607fc",
			"name": "Thayse “Coati”",
			"onLive": true,
			"insta": "https://www.instagram.com/artcoati/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"ed2ae771-7912-420f-a6a0-4f7ad3a813ee"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "8a800299-91a0-4c6f-b965-fa94ac0888f0",
			"name": "Anderson Barboza",
			"onLive": true,
			"insta": "https://www.instagram.com/andersonbarboza/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"0347502c-39b0-46d0-8365-06d66d05f243"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "4fcfe067-2123-49e9-aa88-96181009e3cb",
			"name": "Milena Zarate",
			"onLive": true,
			"insta": "https://www.instagram.com/miileskine/",
			"twitter": "https://twitter.com/miileskine",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"cbeb0a73-33a4-4071-8e80-93052c71a59d"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "250c9248-189f-4d75-a590-f0999e8a8836",
			"name": "Helô D’Angelo",
			"onLive": false,
			"insta": "https://www.instagram.com/helodangeloarte/",
			"twitter": "https://twitter.com/helodangeloarte",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"6b64791c-2cac-4b9b-bf68-9e7146bc4ac8"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "524c8e26-b338-42f9-a7f9-ef206a99bf0a",
			"name": "Diego Kongink",
			"onLive": true,
			"insta": "https://www.instagram.com/kongink_02/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"7723a503-f864-43d8-9f36-69e28ac423cf"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ea98178c-5df5-4af9-b329-b7b917036710",
			"name": "Victor Papa",
			"onLive": true,
			"insta": "https://www.instagram.com/darkkartrealm/",
			"twitter": "https://twitter.com/DerFroschGott",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"5286b57e-838f-481b-a546-2540725ce71b"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "d5239b5b-f379-4174-9972-7be545d51903",
			"name": "Gabriel Boaventura",
			"onLive": false,
			"insta": null,
			"twitter": "https://twitter.com/nypsint",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"b13d3383-8f47-4cbf-ab39-4b0375414507"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "5b8754e8-c5b0-4558-8352-6d6762a20329",
			"name": "Ednaldo Alves",
			"onLive": false,
			"insta": "https://www.instagram.com/kamieditora",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"7c69191f-00cd-4384-a3e8-b89deb47824c"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ea4f890b-5f88-42bb-80cd-8e1be7bce2e5",
			"name": "Flavia Andrade",
			"onLive": false,
			"insta": "https://www.instagram.com/legiao_s.a/",
			"twitter": "https://twitter.com/ClaveDeFah",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"26ebf6cb-a54e-4716-91cd-4aa4d3574c61",
				"af396cf5-d0d5-4ea3-95e7-6e176156c914",
				"d4f3f978-7fc8-4e6a-a06a-ce30ddec6297",
				"e29b3fbd-55f7-42a5-a93a-f1ce458e4712",
				"707eba8c-2771-4fe6-8f8a-e806365cfcfa"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados",
				"Indicados",
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "5ced3f73-f4ac-4292-b37e-12e0cde5302f",
			"name": "Lucas Augusto",
			"onLive": true,
			"insta": "https://www.instagram.com/mkd.noah/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"124f755e-15a2-4aa6-b85e-07a2cfe973e1"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "c77bcf20-9b01-44b4-a84e-27d82178280c",
			"name": "Ivan Silva",
			"onLive": false,
			"insta": "https://www.instagram.com/ivan.s1lva/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"ad1221fc-432b-4be1-ba33-5b35d276404e"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "515b169c-eaf2-48b7-8709-fcb1130edf29",
			"name": "Pablo Fernandes",
			"onLive": true,
			"insta": "https://www.instagram.com/mkd.westranger_/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"85a31998-ba25-45b6-95df-532a98e3868a"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "0afd88c7-924b-49c1-ab37-e076168febe4",
			"name": "Taired",
			"onLive": false,
			"insta": "https://www.instagram.com/_taired/",
			"twitter": "https://twitter.com/OrangeTaired",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"7f802b99-e08b-490a-9137-443fffa7a9b9"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "209c6600-53dc-4353-aabe-18bd0058bfc6",
			"name": "Marcus Beck",
			"onLive": false,
			"insta": "https://www.instagram.com/themarcusbeck/",
			"twitter": "https://twitter.com/beckenkamp",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"ab6f0497-741f-45f5-a9d2-67bf8a76696b"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "bfd0fc80-b73a-4cfe-9aee-6331a8e79d12",
			"name": "Mellman",
			"onLive": true,
			"insta": "https://www.instagram.com/mellman_art/",
			"twitter": "https://twitter.com/MellmanArt",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"dc969a78-2295-469f-8785-db15ddb9ea84"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "7e7f7a45-a811-4b4e-8d3e-0bcb76ebab7c",
			"name": "Rafa Santos",
			"onLive": true,
			"insta": "https://www.instagram.com/tobias_detetive/",
			"twitter": "https://twitter.com/gibitales?lang=pt-br",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"2dbad268-6f3b-4c1f-9adf-63cd05c7ae96",
				"521e84d8-3849-422a-9010-35b2da0007aa",
				"090c2337-1a29-4a4d-a6bb-200f11531fbb"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "ba7b10da-e36f-4f2c-bb3c-e8522a801df8",
			"name": "Wagner Elias",
			"onLive": true,
			"insta": "https://www.instagram.com/wagner_commissions/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"517eea1e-3d6a-4a83-bb47-b03949210ac2",
				"521e84d8-3849-422a-9010-35b2da0007aa",
				"090c2337-1a29-4a4d-a6bb-200f11531fbb"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "aac86322-5c06-43a9-8dce-ff61b5bbd65c",
			"name": "Daydreamer Art",
			"onLive": true,
			"insta": "https://www.instagram.com/daydreamer_d_art/",
			"twitter": "https://twitter.com/daydreamerd_art",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1aaa1f63-8d7e-40a9-a153-d84175e94b13"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ccfc55bb-551a-4f45-8e88-eaaa54e06224",
			"name": "Aquaryart - Juliana Silva",
			"onLive": true,
			"insta": "https://www.instagram.com/_aquaryart/",
			"twitter": "https://twitter.com/aquaryart",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d313e70c-e54b-4714-bfee-02f2b8dc0191"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1570fad2-9a0f-4c30-9669-5900ad3649b0",
			"name": "636",
			"onLive": false,
			"insta": "https://www.instagram.com/lscastro_636/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"2180d6ef-6acc-491f-8a4d-ef847f3f873b",
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "db1ffb67-5754-4955-894c-c4309d5258b7",
			"name": "Magu",
			"onLive": true,
			"insta": "https://www.instagram.com/magu_capa/",
			"twitter": "https://twitter.com/magu_capa",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"0ab27508-bbad-4de6-acd4-ba7ce051478d"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "4cfd6e03-2f49-4d90-bdd2-df4e8bde2ec4",
			"name": "Bulho",
			"onLive": false,
			"insta": "https://www.instagram.com/bulhoarts/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"89952172-36cc-4170-89a8-8f841dc4534e",
				"3244cf31-de42-4ada-af88-eafc4646e28d",
				"125e1ce0-0fd5-8042-96b4-e6194749aa4d"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "aef34030-8446-4a52-892f-a61d06ec00a7",
			"name": "Juarez Oliveira",
			"onLive": false,
			"insta": "https://www.instagram.com/juarezoliveira760/",
			"twitter": "https://twitter.com/JoneByro",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"360d16a9-8f7a-4182-bb76-c95acbeb6168"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "c511a6f6-70af-47a1-a758-dd0dc8f43e49",
			"name": "Gabriel Kolbe",
			"onLive": true,
			"insta": "https://www.instagram.com/gabrielkolbe/",
			"twitter": "https://twitter.com/GabrielKolbe",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"fbe83128-d63f-4ff7-8119-e005c2e652dc"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "636cfb84-51a9-4629-9962-2cfef2834afc",
			"name": "Chris Red Artist",
			"onLive": true,
			"insta": "https://www.instagram.com/chris_red_artist/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"57b450b7-75b5-48a1-9a90-3973ec249c91"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "8653e55c-4480-4d10-b294-f9ac267c8447",
			"name": "GringoComics",
			"onLive": true,
			"insta": "https://www.instagram.com/gringocomics_insta/",
			"twitter": "https://twitter.com/gringoscomics",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"ec441778-dd4f-48be-8756-e0224adaea6a",
				"08ddce89-0318-4287-a65d-bcfe10e362dc",
				"13be1ce0-0fd5-80a1-8ed3-fdcbe093e962",
				"1b7e1ce0-0fd5-80cf-bc03-c2ac978e849d",
				"1b7e1ce0-0fd5-808c-847e-e8c97aa274cc",
				"1b7e1ce0-0fd5-803e-8d72-ee57868215f7"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "14ffa5d0-1a6a-4dfe-9932-5d4d360eb590",
			"name": "Xenomorphzoid",
			"onLive": true,
			"insta": "https://www.instagram.com/xenomorphzoid/",
			"twitter": "https://twitter.com/xenomorphzoid",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"e17d9f15-cd14-4159-8b87-fafc651ca856"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "c7d5bd15-ee3d-4419-81d5-f547353d728e",
			"name": "Dangoverso",
			"onLive": true,
			"insta": "https://www.instagram.com/dangoverso/",
			"twitter": "https://twitter.com/dangoverso",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"0263228c-1be2-48e4-8e69-a8d2520867b0"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "0715a05a-d018-4216-a1dc-afc63995b3c7",
			"name": "O Anhanguera",
			"onLive": false,
			"insta": "https://www.instagram.com/oanhanguera/",
			"twitter": "https://twitter.com/oanhanguera_",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"838f81b2-c452-403d-a9dd-df82780b5d9a"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "159a4449-259b-4314-9e29-165095aa956a",
			"name": "Morgana",
			"onLive": false,
			"insta": "https://www.instagram.com/morgana.dayo/",
			"twitter": "https://twitter.com/PlaviaMorgana",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"7d10797a-e80a-4fd5-9988-6fd48149be74"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "2f36e4d8-796f-4594-b649-8df008eb0642",
			"name": "Nathalianime",
			"onLive": false,
			"insta": "https://www.instagram.com/curse_equinox/",
			"twitter": "https://twitter.com/cursed_equinox",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"5705870c-6059-4774-a7f6-37064e2c0f02"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "66863343-1ec8-4c07-b8ea-219876f9fe3e",
			"name": "Justabrush",
			"onLive": false,
			"insta": "https://www.instagram.com/just_a.brush/?hl=pt-br",
			"twitter": "https://twitter.com/BrushAjust",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"40e23253-0184-412b-a8f1-a98a58dee215"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "448cd2ed-76f9-4619-aed3-59789f8cf102",
			"name": "Kikeluzi",
			"onLive": true,
			"insta": "https://www.instagram.com/kikeluzi/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"881b508d-1120-46bb-a7ef-88801368cf09"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "2858a502-756c-4772-9bc5-6b7e5040b7fb",
			"name": "Kavalmarinho",
			"onLive": false,
			"insta": "https://www.instagram.com/kavalomarinho/",
			"twitter": "https://twitter.com/Gust4voL",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"cfa15a43-ba3d-4573-8dca-0ed0da53ef6b",
				"4d63a756-d352-4f1b-8084-6bb48e6ce3a2",
				"1b7e1ce0-0fd5-80c7-8591-fd528029fefa"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Indicados",
				"Lendo"
			]
		},
		{
			"id": "03ab1bed-df44-49ec-85e5-e82afd6c66fa",
			"name": "Clara Carvalho - (TimidFelidae)",
			"onLive": true,
			"insta": "https://www.instagram.com/timidfelidae/",
			"twitter": "https://twitter.com/timidfelidae",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d2f86747-726c-42bd-882f-37c8c208e687"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "2bdb7977-9933-4f4a-a115-2b649b3211d0",
			"name": "jpcferreira",
			"onLive": true,
			"insta": "https://www.instagram.com/jpcferreiraa/",
			"twitter": "https://twitter.com/jpcferreiraa",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"ff70f539-1c43-4ed0-a3eb-9b331902956d"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "7189c3de-7cd6-4eae-acfc-bc45726d88d7",
			"name": "Analu",
			"onLive": true,
			"insta": "https://www.instagram.com/arts.wiwi/",
			"twitter": "https://twitter.com/wiwiArts",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1c40208f-26ba-43ce-befd-01cf939b13c3"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "eadbcf08-b51b-4a5a-8175-0c4f89d24e40",
			"name": "Fuinha Sagaz",
			"onLive": true,
			"insta": "https://www.instagram.com/fuinha_sagaz/",
			"twitter": "https://twitter.com/OsSlaps",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"5bc6a89a-77c2-4c73-9119-c9e5f5faf740",
				"958e18df-4f38-414c-8050-206c6926a183"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Lendo"
			]
		},
		{
			"id": "711ecb32-5150-4d34-920a-4a2b49c61f9f",
			"name": "Lee Enrike",
			"onLive": true,
			"insta": "https://www.instagram.com/lee_enrike/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "2b57bf8e-f874-4af7-961f-1358c79f7f8a",
			"name": "Sam The210",
			"onLive": false,
			"insta": "https://www.instagram.com/sam_the210/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "77c701e8-f649-4209-9070-142054d7a266",
			"name": "Hermitão",
			"onLive": false,
			"insta": "https://www.instagram.com/hermitao.hq/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "039c5601-76fc-4f46-a373-209edf670759",
			"name": "Kreb",
			"onLive": false,
			"insta": "https://www.instagram.com/krebdraw/",
			"twitter": "https://twitter.com/KrebDraw",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "f8aa891a-6231-4169-9d81-755ba52a3897",
			"name": "CyberPanda",
			"onLive": true,
			"insta": "https://www.instagram.com/vulgo_cyberpanda/",
			"twitter": "https://twitter.com/CyberLedisMan",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9",
				"071ec9ca-b680-4f43-a3b0-15fd4b8ebedc",
				"1b3bfd55-ad83-4fb9-9b42-b1cee3b61801",
				"06c1f119-305e-461f-82e3-5dfa0afef64f",
				"5d76c414-a9c4-4048-8202-ef9922dd3452"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Indicados",
				"Lendo",
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "97088075-94fd-44e8-983e-b12774cbde62",
			"name": "EmogiArts",
			"onLive": false,
			"insta": "https://www.instagram.com/emogiarts/?hl=pt-br",
			"twitter": "https://twitter.com/EmogiArts",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9",
				"c611aedc-09fe-4746-ad4e-9bd8ccc4d862"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "87403cfd-8959-43a0-a2d4-3b46ac632671",
			"name": "Hiroshi V Jump",
			"onLive": false,
			"insta": null,
			"twitter": "https://twitter.com/Hiroshi_V_Jump",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "3a54bc1b-7b3e-470e-99a9-2b83d1282f2a",
			"name": "CarretaComics",
			"onLive": true,
			"insta": "https://www.instagram.com/thecarretacomics/",
			"twitter": "https://twitter.com/CarretaComics",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9",
				"42ae580b-4abf-4d8b-8076-dcfddbd526b2"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "5c602629-63a8-428e-8275-02a400ca02c7",
			"name": "Santart",
			"onLive": false,
			"insta": null,
			"twitter": "https://twitter.com/c_santart",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "5345a81f-7381-43d0-9dad-78ed3f0d7ce1",
			"name": "Pepasmaga",
			"onLive": true,
			"insta": "https://www.instagram.com/pepasmaga/",
			"twitter": "https://twitter.com/pepasmaga2",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9",
				"b4e8c36f-e24f-4ab1-bcc8-650f0d3ef301",
				"e413cb87-0f8b-473d-b4d8-3b068b77c132"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "8b381255-655c-480b-908e-472152232fc0",
			"name": "Bruwi",
			"onLive": true,
			"insta": "https://www.instagram.com/bruwi.art/",
			"twitter": "https://twitter.com/BruwiDea",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"461bea2d-98f0-4f75-b135-cce8f4e9d58d",
				"0cfdec41-2fe1-4099-8d19-affd648ee609",
				"a368832b-2911-4768-baa4-093299744a88"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "2bbeb681-77b7-426d-8532-81fa797912d9",
			"name": "Caioyo",
			"onLive": false,
			"insta": "https://www.instagram.com/caioyo/",
			"twitter": "https://twitter.com/caioyo_art",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"2542a4fe-5fcd-4602-a18c-039446d1969b"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "4b985faa-091e-4f40-b858-39b72e601a53",
			"name": "Toro K.",
			"onLive": false,
			"insta": null,
			"twitter": "https://twitter.com/ranbuescalation",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"3a95235b-deaf-4d2d-a745-4ab933ffb2a2"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "fb27db3a-f4f2-4285-97a8-3b717a8a6cea",
			"name": "Davi Paraguai",
			"onLive": false,
			"insta": "https://www.instagram.com/d.paraguai_arts/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"c93cf70e-9a19-4f6b-a2f0-0d890ab7ce5b"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "99671b98-0918-43e7-adae-269e1b1542b8",
			"name": "Gus Draw",
			"onLive": true,
			"insta": "https://www.instagram.com/gus_draw_/?igshid=zn60735ar7kb",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"9774c9aa-0a6b-4e90-916f-46ea7fb0244d",
				"d38c896e-a232-4a37-b913-f25b6dd974f9"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "84e00b11-bdbe-4905-a728-be9471f134eb",
			"name": "Eliaquim Sousa",
			"onLive": false,
			"insta": "https://www.instagram.com/taygra.suza/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"8c8a5953-562a-4501-8fd9-6699e4c8a2a0"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "d63e33f0-bf60-4955-87cd-1f0729a7d270",
			"name": "Jayson Santos",
			"onLive": false,
			"insta": "https://www.instagram.com/jaysonsantosartwork/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"397c1e20-9a80-4bf0-9c51-64223f3aee1b"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "29052884-0c7f-4a09-a3d9-2477e7c63fc1",
			"name": "Edson Masakiro",
			"onLive": false,
			"insta": "https://www.instagram.com/edson_masakiro/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"6bc9edfa-aac4-435e-9c97-08dee8685e6d"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "75eb4c1c-cbf1-4a47-bdc0-2361516d3c57",
			"name": "Darlan",
			"onLive": false,
			"insta": "https://www.instagram.com/homembesouro/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"f8fbaebb-1bf8-48d3-9a70-aa5d60a6b199"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "cdce6ec0-8b21-4e29-a1ec-3483ccbb2425",
			"name": "Paulo Henrique",
			"onLive": false,
			"insta": "https://www.instagram.com/lee_enrike/",
			"twitter": null,
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"380fedbd-3c12-4e43-bc91-5aac3c33e564"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "a2790792-9d40-4b5a-b7bf-84418b11f41c",
			"name": "psyuro",
			"onLive": true,
			"insta": "https://www.instagram.com/p.sdraws/",
			"twitter": "https://twitter.com/yuroich",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"d03f85f3-40c5-4da9-b942-b058e5a6bb0b",
				"0e4e474a-01be-45df-ba35-e82d446503fe",
				"17e583bc-3117-417a-89d7-9e10a9aa4541"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "1cf219d7-a8be-485f-923d-c4a7d9a36c17",
			"name": "Dandh'ara Cássia",
			"onLive": false,
			"insta": "https://www.instagram.com/dandharacassia/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"8fe29f2a-99b7-458f-9854-7d4f8888f2b6"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "6912135f-8037-40f4-ba66-c847e42c059c",
			"name": "Valdo Artes",
			"onLive": false,
			"insta": "https://www.instagram.com/valdoarts/",
			"twitter": "https://twitter.com/ValdoDesenhos",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"4aa183b1-36a3-41c3-8ecb-1b71b49ae134",
				"1c7e1ce0-0fd5-80f3-8532-d844676f30be"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Lendo"
			]
		},
		{
			"id": "5ca27f66-e048-4463-9691-16d4a758ca8a",
			"name": "Jheymyson Batista de Sousa",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"c888d1b6-7b39-4deb-9bff-f6118f7821c8"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "cb093ef5-a66d-4228-a343-a89bd017d586",
			"name": "Lucyano Guilherme",
			"onLive": false,
			"insta": "https://www.instagram.com/lucyanoguilh_art/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"db5a149c-c949-4af4-8081-3199d70662dd"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "0703c28d-949a-4909-bf04-3ee5158393e5",
			"name": "Biulitarts",
			"onLive": false,
			"insta": "https://www.instagram.com/biulit.arts/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"74c4c82e-9ebb-4eed-bfc7-7e59142cf79a",
				"267a413c-7bfb-497c-bfe5-a59f8ff8bdbd"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "ff097212-1106-48c9-b37e-2f8167a5a27e",
			"name": "Sayuritake",
			"onLive": true,
			"insta": "https://www.instagram.com/sayuritake/",
			"twitter": "https://twitter.com/sayuritake_arts",
			"inedito": false,
			"etnia": "💛",
			"quadrinhos": [
				"24f3c128-18f4-4cdc-87cf-a67dd38930ac",
				"39b3a465-2887-41e4-815b-faa5f9b8809c",
				"08ef9f32-fea5-4df6-9000-3d150bb7096e",
				"40750467-ae3d-4808-a8ca-726e4fb5521e",
				"3e8de445-d4e2-446c-9131-cfa4e6f26e0b",
				"f5c95399-8fc7-4b64-83b7-68fb7e4794d4"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo",
				"Indicados",
				"Indicados",
				"Indicados",
				"Lendo"
			]
		},
		{
			"id": "cfe7a3d0-8497-4045-b10a-62a0c8e6f57b",
			"name": "Sarah Moon",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"ccb05a9d-86b0-4fbe-8c3f-47cd888b8398"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "3333151a-77b7-4e6b-9e00-f94ff89221fd",
			"name": "Kathleen Carvalho",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"b84c29fc-09a3-4fc1-8de6-67ef8feb49ab",
				"ba8e686d-14df-4856-8b1e-6eafa798b80f"
			],
			"gen": "♀️",
			"status": [
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "1de9e447-2cab-40ff-9e84-3c7ee1d2075e",
			"name": "CyberQuadrinhos",
			"onLive": false,
			"insta": "https://www.instagram.com/cyberquadrinhos/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"7ae03aec-dd6e-4f1c-818f-b238d36929bf"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "23d2c851-e40c-4e0b-8ee1-a1732e6e63d6",
			"name": "Neko Rama",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"4ca21394-12d6-4eeb-98a1-227a1399d9e6"
			],
			"gen": "♀️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "b61e554e-ca9e-4982-861b-573da1d734c3",
			"name": "Beto Hessel",
			"onLive": true,
			"insta": "https://www.instagram.com/ohezzel/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"edc72a4a-cf3f-41e7-83a2-3ff40ef31ca7"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b1ac50c4-2fb4-4f8e-90ed-1d3257ede6e3",
			"name": "Krow",
			"onLive": true,
			"insta": "https://www.instagram.com/krowruja_khosmika/",
			"twitter": "https://twitter.com/Bell_e_Krow",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"a2d38323-4ded-4405-a908-f4a56e967b7b"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "72eea417-b394-47b4-947c-d442844db15b",
			"name": "Uma Gata Muda",
			"onLive": false,
			"insta": "https://www.instagram.com/uma_gata_muda/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"6d3e80ee-d71c-4c43-9315-e89e1c60a999"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1368b62b-da13-4f9c-a88c-4a0b8ff4f498",
			"name": "Alex Porto",
			"onLive": false,
			"insta": "https://www.instagram.com/cadamundoqueeucriei/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"572445a4-5381-4d74-b58f-eb0c5b9d5181"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "598ee72f-f704-4bf8-b4a8-e56f13ac4de6",
			"name": "João Crepaldi",
			"onLive": false,
			"insta": "https://www.instagram.com/joaopedro_crepaldi/",
			"twitter": null,
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"20ac09f0-99dd-42c2-a021-b6e431843ed1"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "bea4327d-4683-4bc6-ac4d-499cea569084",
			"name": "Gustavo Assis",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"3ad3b7c2-9117-4517-b3d9-6923ca234821"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "d2285d68-7466-43da-8698-641f681733dc",
			"name": "Ufize",
			"onLive": false,
			"insta": "https://www.instagram.com/toonverso/",
			"twitter": "https://twitter.com/toonverso_art",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"a9c7dc20-3ef4-493c-b104-55cba316ed92"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "5fde470e-f257-4364-9a63-39095f90ab7d",
			"name": "Grazielle Gomes",
			"onLive": true,
			"insta": "https://www.instagram.com/_red.wings/",
			"twitter": "https://twitter.com/gomas_redwings",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"0b07d399-d80b-4936-82bd-9813b96b7132",
				"c11e6dc3-e58d-4d38-abe2-07abc7b232a1",
				"ea217a3f-33d0-459e-8263-51cdb47d125c",
				"afc46faf-56d2-4104-ba75-b75a12fddfc1",
				"fe8676a1-1cfa-4ea7-9738-403286236db5",
				"174da49a-985b-4e7a-a971-6f0ebb16be74",
				"031ec68f-b6e0-4623-8047-9ce498cf5ae9",
				"ec6cbbfc-4954-45ea-a3a4-4fd44337354a",
				"9b5a4bc0-f192-4d22-b839-df57b5a5db70"
			],
			"gen": "♀️",
			"status": [
				"Indicados",
				"Indicados",
				"Indicados",
				"Indicados",
				"Indicados",
				"Indicados",
				"Indicados",
				"Indicados",
				"Lendo"
			]
		},
		{
			"id": "36f2d05e-c0be-4c6b-9e66-1411c7836eaf",
			"name": "Guilherme Euller",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"93edd1bf-05ff-4732-a474-17b991ee09dc"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "40cf6691-3cc4-42fa-b8b8-9c617f26d4ad",
			"name": "Guilherme Gzolli",
			"onLive": false,
			"insta": "https://www.instagram.com/gzolli/",
			"twitter": "https://twitter.com/Gzolli",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"6d4ac9cc-df78-47c2-a574-37e80fc3a49a"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "a230cd95-01be-471e-841f-553e86c3eb61",
			"name": "Lobo Lualua",
			"onLive": true,
			"insta": "https://www.instagram.com/lobolualua/",
			"twitter": "https://twitter.com/lobolualua",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"34543757-7cbb-4cb5-bfe3-127c3b728c29",
				"0c193d2b-ca91-4a8c-9ea9-777f06ebb236",
				"d72837be-56b9-4c31-8716-d790b4be1026"
			],
			"gen": "♀️",
			"status": [
				"Indicados",
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "1e2c5717-df23-42f1-8f10-bc35502b6286",
			"name": "Fred Hildebrand",
			"onLive": true,
			"insta": "https://www.instagram.com/fredhildebrandart/",
			"twitter": "https://twitter.com/FredHildebrand5",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"26e60eb0-ed06-41ff-b885-f7c80c80f34d",
				"605b8c53-24f6-4a8c-8dcd-9b70af1c1f47"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "2f140e08-0d24-4647-8a24-c3fbd94f4d8c",
			"name": "André Inácio",
			"onLive": false,
			"insta": "https://www.instagram.com/desinho_x/",
			"twitter": "https://twitter.com/desinho_x",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"0dccb0c9-68c4-4269-b505-3da11db64130",
				"7140661f-836c-4661-8432-31b2dbd9020f"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Lendo"
			]
		},
		{
			"id": "61e006bd-f368-4703-8523-89d8df299473",
			"name": "Kenned Gadelha",
			"onLive": false,
			"insta": "https://www.instagram.com/kennedgadelha/",
			"twitter": "https://twitter.com/KD_Gadelha",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"7d513fcd-fc48-4556-bce2-2085290dbd78"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "f205d964-707c-4dfb-9bdf-af19a7bd3200",
			"name": "Monge Han",
			"onLive": true,
			"insta": "https://www.instagram.com/mongehan/",
			"twitter": "https://twitter.com/MongeHan",
			"inedito": false,
			"etnia": "💛",
			"quadrinhos": [
				"6e8f55a1-5d20-424d-9b89-d47adcabf13e"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "30cf91b5-b953-40db-b008-f4d3ac47fd3e",
			"name": "Julio_da_Gaita",
			"onLive": false,
			"insta": "https://www.instagram.com/julio.da_gaita/",
			"twitter": "https://twitter.com/Julio_daGaita",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"c24a48ab-9ef9-4aca-916f-1dbbb5fe75e8",
				"858c8636-488d-4a39-a09f-fd256b1b4683"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "8caf0be8-cb98-4115-bfef-03c73ff7f581",
			"name": "Deleon Stu",
			"onLive": false,
			"insta": "https://www.instagram.com/deleonstu/",
			"twitter": "https://twitter.com/studeleon",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"02495cc0-1fc5-417a-82a1-8ea77bdfb0ce"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "6af54170-4c80-430d-899c-7f76e5088beb",
			"name": "Pandeki",
			"onLive": false,
			"insta": "https://www.instagram.com/pandeki_art/",
			"twitter": "https://twitter.com/pandeki_art",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"a9c9016a-14e3-47d1-bbc1-50eae9ade70a",
				"ac1d608b-eb65-4607-bea2-f4e995310633"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "92f9bf1b-c451-4d6d-94ca-5e7e2e7db979",
			"name": "Antônio Ruiz",
			"onLive": false,
			"insta": "https://www.instagram.com/antonruiz_hq/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"1adf1ba6-4cd2-48e9-a737-ab2a7bc6900e"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "83b16f7d-5b9f-47c5-b31e-a51f4a08f87d",
			"name": "THAgrea",
			"onLive": false,
			"insta": "https://www.instagram.com/gremoryart/",
			"twitter": "https://twitter.com/ArtGremory",
			"inedito": true,
			"etnia": "🤎",
			"quadrinhos": [
				"0badcbf4-f550-4117-be79-eba2b9d079ca"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "e44c19b6-9375-4ddd-9019-067937f4d4b1",
			"name": "Bi Aguiart",
			"onLive": true,
			"insta": "https://www.instagram.com/bi.aguiart/",
			"twitter": "https://twitter.com/biaguiart",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"49756a11-2ed5-4971-8017-bb31be337032"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b76e79b9-e1e1-40b7-ae1d-1061e8a97529",
			"name": "Roberto koga",
			"onLive": false,
			"insta": "https://www.instagram.com/roberto_kogalima/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"146dca57-55db-4a3a-a136-af3ddf8bfc9a",
				"e0b0d201-7b34-4193-ba1d-b68c642cc0b6",
				"125e1ce0-0fd5-8042-96b4-e6194749aa4d",
				"170e1ce0-0fd5-8075-9357-f7556b87bcdf"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "838182de-11e1-4dbd-95cf-9854fbef00cd",
			"name": "Iaggo Piffero",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"49001ea7-eccd-45fa-a6a3-9aad45bee16c"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "7763d3f1-d552-4ce3-b913-1173f627e8c1",
			"name": "Alexis Portugal",
			"onLive": false,
			"insta": "https://www.instagram.com/alexisportugal030/",
			"twitter": "https://twitter.com/AlexisPortuga14",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"ab190a22-f0de-444e-ae83-a564c05e1578",
				"bf235c56-25c6-4d0d-9a02-3751afd754ae"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "f575cd8b-8419-4b75-8463-94a9d177eed2",
			"name": "Mailson Ferreira",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"4fc78708-7391-4fbe-84a2-bc652c0bb4cd"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "fc21c830-9f7e-4180-8169-2412da2f5821",
			"name": "SEVMS",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"de596398-9037-48b9-82c9-cc370289d201"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "904d33c6-c1c7-47a1-993d-fd5dfd48a95c",
			"name": "Diogo Cidades",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"a3187a57-0a19-45c1-96df-d139c37535da"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "5eb7d835-b49a-4907-9a64-98619213a846",
			"name": "Caio Barros",
			"onLive": false,
			"insta": "https://www.instagram.com/caiovombate/",
			"twitter": null,
			"inedito": true,
			"etnia": "🤎",
			"quadrinhos": [
				"9e9cf49b-20bf-43bf-829b-dbe1fd9b276d"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "0760f2a2-7d35-4d5d-9b01-34fb3d76bdab",
			"name": "Vortexu",
			"onLive": false,
			"insta": "https://www.instagram.com/jeanjulian__vrtx/",
			"twitter": "https://twitter.com/JeanJulian_",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"179293ef-8840-442d-a89c-9678e739ad3f"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "5fde32a6-e224-4886-8b29-5ca47cf5ecae",
			"name": "Viegadraw",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"4647bc43-7eaa-4ecc-9e1b-bedee2f1ff53"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "8f55f0ea-c498-492c-9947-938353a5d39f",
			"name": "Rommel",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"865a08f5-5644-4889-bf7b-415ad81b04ae"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "9a56b3f4-6cd1-4402-8f97-c90f1e005e11",
			"name": "Rodz",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"94f92eab-aeae-4cfa-9765-724190d42cc6"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "5f6ca12a-d138-432e-9f90-408e9633e98e",
			"name": "Robson Campos",
			"onLive": false,
			"insta": "https://www.instagram.com/robsoncamposdesenhos/",
			"twitter": null,
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"c340a7ec-46fa-4caa-88eb-8923cbd91407"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "0e7b3996-cf45-49bd-9341-c9c2df8a5cdb",
			"name": "Starive Art",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"121c4b88-8f99-459c-bff6-8c04b9b569d6",
				"79b73fff-b9bb-454d-8d27-c1b9f011156f",
				"33521536-2c17-49f3-814f-89942e4e6d51"
			],
			"gen": "♀️",
			"status": [
				"Indicados",
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "54d13a59-2c65-4958-abfe-59fe4dd2f4fe",
			"name": "Cadu Simões",
			"onLive": false,
			"insta": "https://www.instagram.com/cadu42/",
			"twitter": "https://twitter.com/cadusimoes",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"f56036ed-4117-4778-aba3-5bcd599d6a7e"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "1dc4a1c2-fd69-43ac-9477-f37836f11c93",
			"name": "Nick34",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"8fe2721b-d5f1-4db0-922b-62b6297c789d"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "bfbf0fcf-e897-4e41-b6fb-4b5e4120c4bb",
			"name": "Kauan Breno",
			"onLive": false,
			"insta": "https://www.instagram.com/kauan_brenocm/",
			"twitter": "https://twitter.com/kau4708",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"d8b9d5be-68f9-468c-b4a6-b5a85dbbb39c",
				"d38c896e-a232-4a37-b913-f25b6dd974f9"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "324ac60d-6616-4b50-8412-f9ebd7b8b510",
			"name": "Joselito",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"30171947-21f3-4a2b-97e6-b5fa035aac94"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "eb539ecc-ff4c-4983-8676-d195a934f227",
			"name": "R",
			"onLive": false,
			"insta": "https://www.instagram.com/ronroncora/",
			"twitter": "https://twitter.com/ronroncora",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"30268b2b-2d22-46a5-98aa-acf0d33c6144"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "75189b2b-50fc-4d6f-a24e-64d85d60c1ec",
			"name": "GreenCoatPanda",
			"onLive": false,
			"insta": "https://www.instagram.com/greencoatpanda/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"cc3ff013-8fbf-4181-b7bc-86c6dc88e539",
				"ed5809c7-db68-45d7-a092-9a13cfc9abc6"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "d33bae88-ae7d-421d-985d-fb9969283bcb",
			"name": "Haus",
			"onLive": false,
			"insta": "https://www.instagram.com/gui.haus15/",
			"twitter": null,
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"3345cbb0-d3d3-4d18-a92c-9331817f15f7",
				"50cea964-3b99-43ef-b0ae-749e69998595",
				"6fb103f8-38ec-4a21-9135-0d66f6dfbc58"
			],
			"gen": "♂️",
			"status": [
				"Indicados",
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "b3cc0f04-9508-4929-b2dc-c0cbc8726fee",
			"name": "Andy Corsant",
			"onLive": true,
			"insta": "https://www.instagram.com/andycorsant/",
			"twitter": "https://twitter.com/AndyCorsant",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"856d3348-9663-4529-82fc-60b5b9495300"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "9fd511ae-3cd4-4c19-82c7-6cf59df32a8c",
			"name": "Box of Tales",
			"onLive": false,
			"insta": "https://www.instagram.com/boxoftales/?hl=pt-br",
			"twitter": "https://twitter.com/mboxoftales",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"95bc977f-1791-4b9a-8b2a-0f105f2a5254",
				"50618aaf-f798-4749-acf6-02b57f74e0bd"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "b32f9636-7f02-493a-86b9-a82c66223dd8",
			"name": "Anne Bell",
			"onLive": false,
			"insta": null,
			"twitter": "https://twitter.com/AnneBell_Artes",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"98b0b004-78e5-407f-98e1-e2f9454e07d2"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b2ad682d-c074-49cf-b43d-8d018302bc4d",
			"name": "Fernanda Iridium",
			"onLive": true,
			"insta": "https://www.instagram.com/iridium.fernandanoronha/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"2900e572-0340-456a-bb2f-1ed673044593"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1207fa39-a8a5-4ab4-b379-1c499434b528",
			"name": "Pendra",
			"onLive": false,
			"insta": null,
			"twitter": "https://twitter.com/__penpenguin",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"1e49e1d7-a705-417c-976a-1c197b840735"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "5b159d2f-dcf0-429d-8281-eca63297eb60",
			"name": "Kenzo Tanaka",
			"onLive": false,
			"insta": "https://www.instagram.com/kenzodrawings/",
			"twitter": "https://twitter.com/kenzotanaka06",
			"inedito": true,
			"etnia": "💛",
			"quadrinhos": [
				"c35553af-2912-4247-b4e3-85e65fbe1430"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "eb71df3a-a83e-435e-b36b-89205a17f82b",
			"name": "Theo Herrmann",
			"onLive": true,
			"insta": "https://www.instagram.com/theoherrmann0025/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"62c5ba80-4c59-4c3a-bf3f-001b2a8781ed",
				"cce739b8-e675-409b-955c-97a316f8a21a"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "2c7d93e1-bbbb-4657-ac36-1b044467c2ef",
			"name": "Kenny",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"8c0d2ca9-664c-47b3-8609-4d9c95a0b098"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "0e6d11ef-5955-4699-affd-5cd66974a29e",
			"name": "Matsu",
			"onLive": false,
			"insta": null,
			"twitter": "https://twitter.com/matsuudesu",
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"6834d255-ae22-41fe-ac6c-43345b1c4c4b"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "c853ab2f-a59b-4a0a-9ffb-5496747a4834",
			"name": "José Luan",
			"onLive": false,
			"insta": "https://www.instagram.com/j.luan___/",
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"30daf93c-3b8f-4def-be5b-7164e5f6fcd6"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "9b7c669f-2e86-423b-837d-21f49d9e391b",
			"name": "Carlos Ruas",
			"onLive": false,
			"insta": "https://www.instagram.com/umsabadoqualquer/",
			"twitter": "https://twitter.com/sabadoqualquer",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"6e925697-0bbd-4228-8747-303e82016077"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "9611ffc4-b3b1-4f10-b1ce-71427af28738",
			"name": "Virgula Leal",
			"onLive": false,
			"insta": null,
			"twitter": "https://twitter.com/virgulaleal",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1e6d9230-da80-4b06-8257-dce20a35c140"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "6a54bbba-4c27-4e0f-aac3-4265dcdb8fa7",
			"name": "Augusto Nunes - AoiTakashiro",
			"onLive": false,
			"insta": "https://www.instagram.com/augusto.nunes178/",
			"twitter": "https://twitter.com/AoiTakashiro",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"869133c4-c802-4cf2-ac09-846045cd5b77"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "304ca639-1037-4d6a-8239-96f59309b247",
			"name": "Henry Saints",
			"onLive": true,
			"insta": "https://www.instagram.com/henry_saints_art/?hl=pt-br",
			"twitter": "https://twitter.com/HenrySaintsArt",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"5128a783-164b-4d9a-b908-38e02a91623d",
				"a515de81-9e69-47c6-848b-2cf456a8da3b"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "98f9c633-fe7f-4441-a4e9-d029803ff4ff",
			"name": "The Dan Velez",
			"onLive": false,
			"insta": "https://www.instagram.com/thedanvelez/",
			"twitter": "https://twitter.com/thedanvelez",
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"39535ffd-ec9d-48b0-ba7a-ab0aea88d29f"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "618e5670-a5b1-474c-a04f-24589a9ba1c0",
			"name": "Bernardo Ignarra",
			"onLive": true,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "🤍",
			"quadrinhos": [
				"33017309-5a68-494c-91a0-8cd1a725e1fa"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "5f2bee00-2dcd-4af4-b4e2-eca4f58570aa",
			"name": "Francis Ortolan",
			"onLive": false,
			"insta": null,
			"twitter": null,
			"inedito": true,
			"etnia": "❓",
			"quadrinhos": [
				"7b0722eb-4cc3-48e6-bdbb-74e7060481a0"
			],
			"gen": "♂️",
			"status": [
				"Indicados"
			]
		},
		{
			"id": "f338d09a-6987-43e6-bf55-bcfd61cde494",
			"name": "Gilton Ferreira",
			"onLive": true,
			"insta": "https://www.instagram.com/gilton_ferreira/",
			"twitter": "https://twitter.com/Passarumaru",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"486d5639-4ac3-4279-aff1-c53f9da4efc4",
				"f1a137b8-c1e7-4e2b-a12d-5205e0e95da1"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "0f0a3b52-3c2a-407a-9324-302356efeb9f",
			"name": "Lucsil Art",
			"onLive": true,
			"insta": "https://www.instagram.com/lucsil.art/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"cf2bf61b-db13-4823-869b-2a3774c08a47"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "c1c9f9b3-5ded-4f61-b3ca-624d85b4d0b9",
			"name": "Dani Henke",
			"onLive": true,
			"insta": "https://www.instagram.com/danihenke_/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"e2dae309-4512-4655-a62e-33fe84772d27"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "4c22a57b-82e5-4df0-9c9c-60819d302f86",
			"name": "Athos Kauã",
			"onLive": true,
			"insta": null,
			"twitter": "https://twitter.com/SilverWinchest",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"dd8117b6-d775-49b7-bb5e-6e6b55daa77d"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "17ac82f3-82ae-4ccb-b55c-250dfb9c6439",
			"name": "DamitGabriel",
			"onLive": true,
			"insta": "https://www.instagram.com/_ivensgabriel_/",
			"twitter": "https://twitter.com/_ivensgabriel_",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"fd4ba310-9890-4d98-87d4-1d719de81dd4",
				"d38c896e-a232-4a37-b913-f25b6dd974f9"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "1fd0131b-f771-4752-8988-080ad5fcb287",
			"name": "Juliana Lossio",
			"onLive": true,
			"insta": "https://www.instagram.com/julianalossioart/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"b7242228-56cd-42a4-b119-ba9b5e23ef4c"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "8767f477-fb98-482d-ada8-5cd397351530",
			"name": "Matheus Nobrega",
			"onLive": true,
			"insta": "https://www.instagram.com/matheusnobrega_dxtrm/",
			"twitter": "https://twitter.com/The_Xtreme28",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"6b863645-18c8-463a-8e85-7007950d2329",
				"be5d39ec-2f62-4c55-af1e-221a58de77ae"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "764f2a4d-4d36-49bf-90df-e84317b9f273",
			"name": "Milo Paulino",
			"onLive": false,
			"insta": "https://www.instagram.com/milo.paulino/",
			"twitter": "https://twitter.com/MiloPaulino",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1c149649-221c-43b7-9ada-68cde9fad049"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "3bb96b29-bf73-4008-b876-ec6b8df32133",
			"name": "Mariana Santos",
			"onLive": false,
			"insta": "https://www.instagram.com/mari_ink2002/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d05fcb24-b471-435b-831a-0d9470f44c2c",
				"1acda107-f88b-402e-9f56-ec381a7c1817",
				"f72ee320-1f99-48c5-b9c4-2540ddf852f4",
				"66f48e3f-3ead-491d-9255-ae7eb5544b8f",
				"26c10f7a-ec90-4bcf-ac47-436f23ebf5b0",
				"b79b2124-7087-4b66-85a7-a682302e4b1b",
				"3c37a3e6-91d6-4f16-b149-9043fb70ae99"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados",
				"Indicados",
				"Indicados",
				"Indicados",
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "c7c46061-0e31-4dfe-ba8f-618ced2b72f6",
			"name": "Glitch Tellend",
			"onLive": true,
			"insta": "https://www.instagram.com/glitch_tellend/",
			"twitter": "https://twitter.com/GlitchTellend",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"c7b448f3-eb39-437b-a4f0-e64c47531421"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "8de8feac-dc83-49a6-b6ca-9a0501ded48d",
			"name": "Moisés Souza",
			"onLive": true,
			"insta": "https://www.instagram.com/moisesz_13/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"2a444947-e063-4789-b302-ce83aba732c6"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "770dd53b-eba3-43b7-96bf-42a6bb0eac7f",
			"name": "RelaxeBoy",
			"onLive": true,
			"insta": "https://www.instagram.com/relaxeboy_/",
			"twitter": "https://twitter.com/RelaxeBoy",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"73c17471-afb1-44bd-ad40-74a6670819cc",
				"72116cf4-8115-426b-9894-544c5827a536",
				"390833b1-db54-48be-ac9e-6e7b1049a68c",
				"0cfad827-c429-41e0-b537-b590bde22f33"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Indicados",
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "9bd0efc4-a2d7-4e1d-b29d-5b71d500e244",
			"name": "Hud Justino",
			"onLive": false,
			"insta": "https://www.instagram.com/calistiahq/",
			"twitter": "https://twitter.com/CalistiaHQ",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"c7e1a017-8bc5-4058-87cd-7baf3542e7c7"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ae310a6a-8bce-47de-8865-98b18638040d",
			"name": "Aline Nyoh",
			"onLive": true,
			"insta": "https://www.instagram.com/aline_nidoriko/",
			"twitter": "https://twitter.com/Nydoriko",
			"inedito": false,
			"etnia": "💛",
			"quadrinhos": [
				"bb2800e7-96d5-4ad7-9f04-6ff162c8e6d5"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "70c21685-8fbe-42ec-8aae-e943dfd9070d",
			"name": "Mamãe Frederick",
			"onLive": true,
			"insta": "https://www.instagram.com/mamae_frederick/",
			"twitter": "https://twitter.com/FrederickMamae",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"23e80167-a3ff-4a29-8130-b42be42914f1"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "07dfc847-e1bb-4f15-8595-88cea34edb29",
			"name": "Palam Gil Amorin",
			"onLive": true,
			"insta": null,
			"twitter": "https://twitter.com/g_palam",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"78f442b4-c403-4c03-83dd-60e13988d111",
				"fe6cff47-c28b-401a-9122-afe2e7908d39"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "4bc73f64-c423-4a4c-8bfc-a91032c14a22",
			"name": "Jon Lizard",
			"onLive": true,
			"insta": "https://www.instagram.com/trouble_makersoficial/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"61e72b4f-994b-4a60-9016-ac58a6af3a6f"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "69626598-4d93-4e11-8b11-a96e37b81dbe",
			"name": "Stéphanie Rachel",
			"onLive": true,
			"insta": "https://www.instagram.com/_stephanierachel_/",
			"twitter": "https://twitter.com/Teffyrachel_",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d38c896e-a232-4a37-b913-f25b6dd974f9",
				"59304ab4-21cf-4f71-9c2a-1b0dfb01fbfb"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "b02b3774-59ef-414b-bd6a-1b916bccd811",
			"name": "Álex Coelho",
			"onLive": false,
			"insta": "https://www.instagram.com/alex.coelh0/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f9b208d2-8e61-42a1-bea9-16b737f324c0",
				"0e1f58e4-5562-421e-98a6-be3fef14d145",
				"26f780aa-6768-4303-a05c-3fdd2fbcb480",
				"11cf3c39-ba32-4f9e-b369-dffe758cd474"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "01a2f557-17ec-4b37-8099-4669c86127ad",
			"name": "João Vitor",
			"onLive": true,
			"insta": "https://www.instagram.com/tales_of_libertalia/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"d3b18c21-6ef4-4068-993d-0e25f25c7a5f"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b574b279-9786-4768-ba2c-c4652f65db48",
			"name": "Raqli",
			"onLive": true,
			"insta": "https://www.instagram.com/raqli_art/",
			"twitter": "https://twitter.com/raqli_art",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"98578353-e750-4e43-b839-1d26572bfef1",
				"a9839e64-e156-4b1b-be04-a7ab157b45e8"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "fd0f3c4e-17f5-4638-b29f-70e9b85a12a1",
			"name": "Kellen Karollyne",
			"onLive": false,
			"insta": "https://www.instagram.com/kellenkarollyne_/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"ee7d46ce-ee4a-4504-bcf7-afebb4b45cea",
				"2a264f95-43bb-494c-86e6-771c6a07a184"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "855318bb-bdd6-4eda-9638-b2ea1111cd39",
			"name": "Isabella Gomes",
			"onLive": true,
			"insta": "https://www.instagram.com/imagisfera/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f8db11d5-2817-4ce5-b06f-d283e7ead629"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "60c87919-d5ed-4a24-aca3-a5a039eaa4c4",
			"name": "Gabriel Barros",
			"onLive": true,
			"insta": "https://www.instagram.com/gabsthegabs/",
			"twitter": "https://twitter.com/gabsthegabs",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"605b8c53-24f6-4a8c-8dcd-9b70af1c1f47"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "6bbc581e-6873-4665-a033-0b28259bb375",
			"name": "Ana Bia",
			"onLive": true,
			"insta": "https://www.instagram.com/anabia_arte/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f09b71b7-edad-42bc-ab95-4613c841a3c4",
				"fae5ed90-b1ee-4a32-b9db-6895a29a05c1"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "91d50fd7-31a9-4826-a852-ae07d3e67b86",
			"name": "Sarah Amagi",
			"onLive": true,
			"insta": "https://www.instagram.com/sarahamagiart/",
			"twitter": "https://twitter.com/dinosarah101",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"97749624-c0e9-4017-85c4-4efccb7edc26"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "7fc01f66-676d-4f8c-b00f-04f64ecf726c",
			"name": "Yasmin Celeste",
			"onLive": true,
			"insta": "https://www.instagram.com/yasz.ilustra/",
			"twitter": "https://twitter.com/yasonenom",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"82d3c612-e1a5-420c-8b23-6fa2c79a4c1c",
				"552fedb0-875b-401e-a82d-71f262c74525",
				"35b69e69-9c94-4631-9a5f-1e8f13b5d440"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados",
				"Lendo"
			]
		},
		{
			"id": "39c242bc-29e4-4fab-9427-547e6d0d7747",
			"name": "Andrielle Bezerra",
			"onLive": false,
			"insta": "https://www.instagram.com/fartura.art/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"a27478fb-c589-4169-ba7c-4f8e1c2105c4"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "3db2ca98-29f0-47aa-9cd7-900b2cf54165",
			"name": "Mariana Takafuji",
			"onLive": false,
			"insta": "https://www.instagram.com/maritakafuji/",
			"twitter": "https://twitter.com/MariTakafuji",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"6451b8d6-2aa9-439e-9c18-8d2759b151ce"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "e983213c-2ffd-4190-af66-d82e65cf4579",
			"name": "Liebe Leta",
			"onLive": true,
			"insta": "https://www.instagram.com/liebe.leta/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"38ee8870-8d2d-4fae-b521-027f80b2e117"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b14717f2-d896-4399-a125-77402bf34c07",
			"name": "A",
			"onLive": false,
			"insta": "https://www.instagram.com/basket360_oficial/",
			"twitter": "https://twitter.com/saferehys",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"1fc59bde-ae22-4ddf-abe1-2bbed1f675ab"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "0d53e9f8-8d44-4615-8118-56ec551cb555",
			"name": "RavenNoodle",
			"onLive": false,
			"insta": "https://www.instagram.com/_ravennoodle_/",
			"twitter": "https://twitter.com/raven_noodle",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"42625a1b-face-493e-b799-01d5bde2d8ec"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "a856237d-ccc9-4e2d-8beb-7276a7ad4b9e",
			"name": "Ilustralu",
			"onLive": false,
			"insta": "https://www.instagram.com/ilustralu/",
			"twitter": "https://twitter.com/ilustralu",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"690cc70b-99e2-4e7c-a952-9e1fcecc0ff0"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "3c8df460-1138-472d-9127-7e848fa2cf7a",
			"name": "Kenia Howard",
			"onLive": false,
			"insta": "https://www.instagram.com/keniahoward0912/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"525953e8-6cb0-4951-ae57-7b6c95a28117",
				"97ac9517-ce50-4dc0-8743-a9ee7579222a"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "9da7f6e3-cb52-4c65-a4b9-0fdff2b646bf",
			"name": "Manoela",
			"onLive": true,
			"insta": "https://www.instagram.com/perdadecontrole/",
			"twitter": "https://twitter.com/perdadecontrole",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"d0919065-baf2-40f1-9b27-d6d4547d2ad3"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "0a5c4afd-020a-44b9-a061-b46ac5ff9288",
			"name": "Bundas Art",
			"onLive": true,
			"insta": "https://www.instagram.com/bundas_art/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"ff0749fb-8929-4f98-ac9b-0aa55e648cf5",
				"1e7568b1-24ee-4e9d-b54c-5658fd1b293b",
				"d38c896e-a232-4a37-b913-f25b6dd974f9",
				"acd6fb22-b852-4c2c-b4b7-7d038aaae6c4",
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "7449dc02-789b-467e-b6e2-fdf67af7b27f",
			"name": "Sofia",
			"onLive": false,
			"insta": "https://www.instagram.com/sofiaborges0306/",
			"twitter": "https://twitter.com/SofiaB0306",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"e206a308-0597-416f-bb06-dfa8e998e622",
				"e13c9e5d-70b4-49d9-8c01-823678b479fd"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "980ddb2b-2320-4f86-a8ac-bede423b7e4a",
			"name": "Maíra Colares",
			"onLive": true,
			"insta": "https://www.instagram.com/mairadraws/",
			"twitter": "https://twitter.com/ColaresMaira",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"f37b3e11-ecf3-4c6b-be20-8da070592520"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "c9539f60-94e7-438e-b4db-7f7ad836af97",
			"name": "Ana Recalde",
			"onLive": false,
			"insta": "https://www.instagram.com/anarecalde/",
			"twitter": "https://twitter.com/anarecalde",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"605b8c53-24f6-4a8c-8dcd-9b70af1c1f47"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "361acf03-9198-420c-b69c-f78479dbf08d",
			"name": "Sila Cinnamon",
			"onLive": false,
			"insta": "https://www.instagram.com/silacinnamon/",
			"twitter": "https://twitter.com/SilaCinnamon",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"336e6ccd-ddd6-4bc1-bf37-c58ca46d1978"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b680b3db-c25a-4668-b8f0-8ddd0abf9004",
			"name": "Dyo",
			"onLive": true,
			"insta": "https://www.instagram.com/_dyonisian_/",
			"twitter": "https://twitter.com/dyonisian_",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"ac948942-dc73-4bf2-8141-c293ff73c1d5"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "f0ebbdc1-09e3-4d4d-a64a-09ef2224810e",
			"name": "Sangalli",
			"onLive": false,
			"insta": "https://www.instagram.com/sangalli_draws/",
			"twitter": "https://twitter.com/sangalli__",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"27c5b787-dbcb-4bff-94f9-549332c25eff"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "35fa9f77-016b-45a8-a92b-f2a81edfd6c0",
			"name": "Larissa Melo",
			"onLive": false,
			"insta": "https://www.instagram.com/laris.mel/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"38597977-6bd3-4dee-8b01-0b6ac67a416e"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "0fe067e6-8752-4166-adac-4176754c42bb",
			"name": "Isamara Gontijo",
			"onLive": false,
			"insta": "https://www.instagram.com/isamarag99/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"e95573c1-18d6-48cf-8291-c197b8bc9f0f"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "9a910562-d74f-4ff2-b636-42b8e1c0d2b8",
			"name": "Verônica Berta",
			"onLive": false,
			"insta": "https://www.instagram.com/veronica.berta/",
			"twitter": "https://twitter.com/veronicaberta_",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"7a322772-319e-437b-8a8c-2c0f6d4dcfd8"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1f305618-54f8-420b-93fb-399650df1fee",
			"name": "Juliana Moon",
			"onLive": false,
			"insta": "https://www.instagram.com/julianamoon/",
			"twitter": "https://twitter.com/notjulianamoon",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"79d2fb3d-d4d0-488d-a219-a984504a39ae"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "964f2c86-59dc-432a-a8e4-e6ae4698b7f3",
			"name": "Phyra",
			"onLive": false,
			"insta": "https://www.instagram.com/magic_phyra/",
			"twitter": "https://twitter.com/magic_phyra",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"9f6e7d39-fefd-45d1-8964-01fd81e4210b"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "02464348-9582-4e9a-9e57-0e0ccf52d0e0",
			"name": "Mai",
			"onLive": true,
			"insta": "https://www.instagram.com/maifazcomics/",
			"twitter": "https://twitter.com/maifazcomics",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1bf1d892-ddfc-47b5-88f0-bb70f8eead14"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "237b1a93-61fd-4841-8457-ffe31f78d0c1",
			"name": "Karolyne Rocha",
			"onLive": false,
			"insta": "https://www.instagram.com/karolynerocha_art/",
			"twitter": "https://twitter.com/KarolyneRochart",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"9141c65d-e6d5-4119-ab8b-52db5f9a37e7"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "55e0ea12-3c08-48ad-b430-19ba2284b289",
			"name": "LariSugarNeko",
			"onLive": true,
			"insta": "https://www.instagram.com/larisugarneko/",
			"twitter": "https://twitter.com/LariSugarNeko",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"9c72d594-2881-45c9-928c-151fd89cb671"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "88cfacb1-2105-4060-8a35-f90f2690ff85",
			"name": "Ingrid Oliveira",
			"onLive": true,
			"insta": "https://www.instagram.com/age_of_guardian/",
			"twitter": "https://twitter.com/age_of_guardian",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"e5ea81fc-e160-47e8-b3dd-60c2f119c23b"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "02886f08-e1b5-4376-8a30-040567d125b0",
			"name": "HT Café",
			"onLive": false,
			"insta": "https://www.instagram.com/hora_de_tomar_cafe/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"17f5a8a3-34f0-4f84-aa99-f3106a072d5f"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "8d2bf7de-7c24-4245-91a7-c820c1f56ff6",
			"name": "Vitor Bardo",
			"onLive": true,
			"insta": "https://www.instagram.com/vbardoarts/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"d4643cfd-f450-4d70-aa96-4c5224fc7132",
				"2436fab4-4346-4401-bac8-f96336b28df0"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "1a7f8c62-2000-4d3e-918f-84f7978c0d1e",
			"name": "Mi Silva",
			"onLive": true,
			"insta": "https://www.instagram.com/m_mmstarmoon/",
			"twitter": "https://twitter.com/Harley77704287",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"62e9c68e-81c6-43e4-9801-cf6149ddd8aa"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "50e2ab61-ef90-40b6-9e19-3d7450458a5d",
			"name": "Relic Hunters",
			"onLive": false,
			"insta": "https://www.instagram.com/playrelichunters/",
			"twitter": "https://twitter.com/RelicHuntersU",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"8b7e2f3c-48f1-473e-8276-98cec70a5442"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "3baa6628-bb04-4190-9d5d-47ce7a67de5b",
			"name": "Matt Skyder",
			"onLive": true,
			"insta": "https://www.instagram.com/matt.hqs/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"153290a8-9f62-4d9c-ad70-26c32d54efb4"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "5ed08bca-16fe-4526-8f25-93bf5e82b9e4",
			"name": "Thomas Sasso",
			"onLive": true,
			"insta": "https://www.instagram.com/thomassasso/",
			"twitter": "https://twitter.com/Thomas_sasso_",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"f9920ede-f3cc-4f61-b386-0bdb325decec"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "4b7585e5-1ef7-46c3-a6ab-70abee7e425c",
			"name": "Luna Rapper",
			"onLive": false,
			"insta": "https://www.instagram.com/luna_rapper/",
			"twitter": "https://twitter.com/CdcLuna",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"c6c3a8ab-9c5e-4829-ab22-117bc5468897"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "36b54fc7-4aee-4aee-b9ef-21a08fd14664",
			"name": "LetyCorujapa",
			"onLive": false,
			"insta": "https://www.instagram.com/lety.corujapa/",
			"twitter": "https://twitter.com/lety_corujapa",
			"inedito": false,
			"etnia": "💛",
			"quadrinhos": [
				"b90922ff-7e39-412b-a6c0-4aa612ebdd49",
				"f246c3bc-0494-486d-ad19-12b7b9361313",
				"125e1ce0-0fd5-8042-96b4-e6194749aa4d"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados",
				"Lendo"
			]
		},
		{
			"id": "d5181c07-657d-4ccd-bddc-0f963644a27b",
			"name": "Minervini",
			"onLive": true,
			"insta": "https://www.instagram.com/minerviniilustra/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"b90922ff-7e39-412b-a6c0-4aa612ebdd49",
				"d6d94fc9-0360-4292-9f76-f4c689ff9bb8",
				"f246c3bc-0494-486d-ad19-12b7b9361313",
				"ab92b08e-9276-43bd-9c7b-feef1006dc45",
				"34c16564-6b30-44cf-b4ba-34601f78b190",
				"125e1ce0-0fd5-8042-96b4-e6194749aa4d"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados",
				"Indicados",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "f4ca287d-10f3-479b-87dd-fec3b1125680",
			"name": "Mary Cagnin",
			"onLive": false,
			"insta": "https://www.instagram.com/marycagnin/",
			"twitter": "https://twitter.com/marycagnin",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"70948036-2b41-403b-a9ff-d34260c949be",
				"eb331e3e-2732-4053-a624-ac36a8ab3d85"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "c8dd9091-17f3-4dbf-a55e-59d12966952f",
			"name": "LINKZIN",
			"onLive": false,
			"insta": "https://www.instagram.com/linkzito_125/",
			"twitter": "https://twitter.com/linkzin125",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"c6c3a8ab-9c5e-4829-ab22-117bc5468897"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "fae88c26-6738-4485-8741-b1172c1596f6",
			"name": "Loba Art",
			"onLive": true,
			"insta": "https://www.instagram.com/loba.art/",
			"twitter": "https://twitter.com/ArtLoba",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"2c5d83ec-27a3-4d83-b107-378f1ea1891a",
				"491b817b-61c5-484e-8c98-247559e01468"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "922dd61c-f271-49ad-b9bb-b7a36630d4b6",
			"name": "Miguel Mota da Silva",
			"onLive": false,
			"insta": "https://www.instagram.com/arte.mms/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"7c367d12-567c-4fe2-9072-e3a4afea0b4d"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "3dd99eac-8132-4efd-bb72-92a2e7b2f588",
			"name": "Dave",
			"onLive": false,
			"insta": "https://www.instagram.com/davenadave/",
			"twitter": "https://twitter.com/davenadave",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"964fed91-8a36-4112-bc6a-bc4980e06c2e"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "0a14ec04-f148-43db-9fef-7c2cea04ba52",
			"name": "Arcker Dias",
			"onLive": false,
			"insta": "https://www.instagram.com/arcker.dias/",
			"twitter": null,
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"c2ce2b0f-5054-43d2-89a3-88ad4174dc5f",
				"f791c032-4dd8-4c34-ba40-6c7ecee5af54",
				"494483bb-a992-418f-9230-1ae91cdda76f"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "9248f707-2513-4387-ba94-fb571a336ce0",
			"name": "Millie",
			"onLive": true,
			"insta": "https://www.instagram.com/millicamacho_/",
			"twitter": "https://twitter.com/CamachoMilli",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"80ba99d6-d16a-47af-a67f-4bcbab6a1760",
				"b90922ff-7e39-412b-a6c0-4aa612ebdd49",
				"c1b0fd5a-60a1-4f3c-96d5-ca0230fdcf34",
				"b70f7de6-bf81-46fb-aa2d-3751835d0bc8",
				"59597aac-8801-4c08-a13c-470aa7ee8c83",
				"f246c3bc-0494-486d-ad19-12b7b9361313",
				"ab92b08e-9276-43bd-9c7b-feef1006dc45",
				"95346e5b-8957-4e1f-83dc-64a40f41ef2b",
				"125e1ce0-0fd5-8042-96b4-e6194749aa4d"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo",
				"Indicados",
				"Indicados",
				"Lendo",
				"Indicados",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "a0e67866-b9ad-40bf-80a0-082082f5cd9d",
			"name": "M2 Draws",
			"onLive": true,
			"insta": "https://www.instagram.com/m2_draws/",
			"twitter": "https://twitter.com/M2_Draws",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"d39c364f-a281-4c23-858c-c4a4ae2a09b3"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "63fe1f46-bef0-4274-9eb9-3d0ec9497af4",
			"name": "Diego SSA",
			"onLive": true,
			"insta": "https://www.instagram.com/diegosanderson3/",
			"twitter": "https://twitter.com/ssa_diego",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"854abf8f-4679-44af-b544-600b8ba7416b",
				"bfa103ea-925f-4386-9ebf-11ab376460a1",
				"197e1ce0-0fd5-8097-9d9a-f8b138935da3"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "48f611c0-b671-4d10-ba7d-d9a7ee8acbff",
			"name": "Owlopes",
			"onLive": true,
			"insta": "https://www.instagram.com/owlopes.arts/",
			"twitter": "https://twitter.com/walparadise",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"b36b25e4-0d52-46d6-a02b-8a9a39919c62",
				"c427aea3-68c3-461d-a2b1-88e2a2d24484",
				"1b7e1ce0-0fd5-8023-ad9b-c4edfc5786d3"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "87ae255e-dcd7-4ed1-a2be-2d0a40845e6c",
			"name": "Lucas Gesse",
			"onLive": true,
			"insta": "https://www.instagram.com/lucrono_1/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"20191cdd-c358-4f79-a867-933ab83d1e05"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "02e41580-e160-47d5-a4df-7970f8226f29",
			"name": "Paulo Marcello",
			"onLive": true,
			"insta": "https://www.instagram.com/paulo_marcello_art/",
			"twitter": "https://twitter.com/PauloMarcelo16",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"a5748d22-e809-4af4-905b-0413e7de7ebe",
				"c0d7b70e-7a9a-4196-9bf9-fbae46aca3d9",
				"47df8ba6-f6f6-47ac-a203-92d0358a52a5"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "ea60c2b9-b139-4306-8f52-98c99cc9e69e",
			"name": "Francinildo Sousa",
			"onLive": true,
			"insta": "https://www.instagram.com/oartista.fs/",
			"twitter": "https://twitter.com/Oartistafs",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"af49fc05-908c-465a-9e1d-6c9e740cd9b0"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "c3feb2a6-9e57-47b0-82bf-30dceffedb93",
			"name": "Raphael Munhoz",
			"onLive": false,
			"insta": "https://www.instagram.com/raphaelmunhoz.art/",
			"twitter": "https://twitter.com/raphamunhozart",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"ef130bcd-f72f-4811-a29d-c009f26f8411",
				"78bbee2b-2991-4855-af23-f3195143b536"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "e6d4abda-fe9d-49a8-a78e-e6f02e1aff4d",
			"name": "Ligia Zanella",
			"onLive": false,
			"insta": "https://www.instagram.com/ligia_zanella/",
			"twitter": "https://twitter.com/LigiaZanella1",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1784dc99-a85e-43ca-958f-5679a832f910",
				"bad76e97-0d01-405e-9980-14faf91c5299",
				"b29ec634-c9aa-40c6-8e6f-96f755d1490e"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados",
				"Indicados"
			]
		},
		{
			"id": "b33565f3-529e-4f52-be99-93ec815e92e6",
			"name": "Clyver - Leonardo",
			"onLive": true,
			"insta": "https://www.instagram.com/clyverx/",
			"twitter": "https://twitter.com/clyverx",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"45fc84ca-f987-482f-9342-d57c75e55020"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "96688312-d6d7-489d-8e4d-88e003d60ea4",
			"name": "Heitor Amatsu",
			"onLive": true,
			"insta": "https://www.instagram.com/heitoramatsuart/",
			"twitter": "https://twitter.com/Heitoramatsuart",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"c6d2fe6b-8e0d-4ec2-afcb-40b61b5dd204"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "608b18af-5493-4a8c-ab19-dd53f501a4c8",
			"name": "Rhenato Guimarães",
			"onLive": true,
			"insta": "https://www.instagram.com/rhenato_arts/",
			"twitter": "https://twitter.com/rhenatoarts",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"3ea69a90-244a-4374-b029-5872ef19cc1c"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "72557ff4-ae1c-4593-8795-8d9495d41f0f",
			"name": "Silva João",
			"onLive": false,
			"insta": "https://www.instagram.com/silvazuao/",
			"twitter": "https://twitter.com/silvazuao",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"57ee1f1d-f721-4da9-bde7-ef072780deb7"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "858395b1-c36e-455c-a510-487c10272adf",
			"name": "Saulo Daniel",
			"onLive": true,
			"insta": "https://www.instagram.com/saulodfp/",
			"twitter": "https://twitter.com/saulodfp",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"f0de1a17-11e3-4646-8cf4-575b95c82922",
				"663c622b-6647-4e90-952c-f285fe93d746"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "9c901954-167f-435e-ada1-fad1ad581e7e",
			"name": "HET",
			"onLive": false,
			"insta": "https://www.instagram.com/hetthepumpking/",
			"twitter": "https://twitter.com/HETthePumpking",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"a63a7fd2-eea7-4b2c-a6c3-330c0608f495"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "b6b5904b-cfd9-4abc-9f69-12e366052083",
			"name": "Hataoh",
			"onLive": true,
			"insta": "https://www.instagram.com/hataaoh/",
			"twitter": "https://twitter.com/Hataaoh",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"81cbe9c4-de33-4938-905f-ed48cc8781a2"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "87773d14-8304-4e4e-a9cd-f71f3a6b1487",
			"name": "Iara Naika",
			"onLive": false,
			"insta": "https://www.instagram.com/iara_naika/",
			"twitter": "https://twitter.com/iaraNaika",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"c1eba75f-532b-423a-a290-8054372ee50b"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "4478bb12-4bd4-42ba-a4b6-1824cda58ad7",
			"name": "Matheus Mendes",
			"onLive": false,
			"insta": "https://www.instagram.com/mthsmnds/",
			"twitter": "https://twitter.com/mthsmnds",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"bcbf6908-e5a5-492d-a80b-b1adc47cc27e",
				"c914e0bb-132f-42ac-81c9-0feeef0f3cbc"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "79995582-6ad6-4c85-8191-6bf66d3fc0ab",
			"name": "Lucas Moreira",
			"onLive": false,
			"insta": "https://www.instagram.com/tirinhasdorex/",
			"twitter": "https://twitter.com/tirinhasdorex",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"0b31e8d7-a189-4296-b397-1664ef6165db"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "223f7dfd-bcca-475d-bcbd-115536c079e9",
			"name": "Duhgetsu",
			"onLive": true,
			"insta": "https://www.instagram.com/duhgetsu/",
			"twitter": "https://twitter.com/Duhgetsu",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"1dfbdef9-3059-4361-873e-ecd662b2cdee",
				"78609969-f628-4619-8334-cbd4eeb6cabb",
				"16fe1ce0-0fd5-8051-b26e-dabd5b755325",
				"16fe1ce0-0fd5-80c7-81e2-d1619461f119",
				"1b7e1ce0-0fd5-8032-ad06-ec9a2aeaf33c",
				"1b8e1ce0-0fd5-803a-8ea8-e85b7d90a5ee"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "1800154d-10cd-4801-b76f-f032ce9688b1",
			"name": "Jack",
			"onLive": true,
			"insta": "https://www.instagram.com/themoniojack/",
			"twitter": "https://twitter.com/themoniojack",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"af3116a8-d562-4856-a74d-c96c24641da7"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ee3b4003-45ee-4238-a184-d547171a6650",
			"name": "Ricardo Mango",
			"onLive": false,
			"insta": "https://www.instagram.com/ricardomango/",
			"twitter": "https://twitter.com/_ricardomango",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"9e5f18bc-5f28-4cd1-8153-5bfe77cccaf4",
				"fdc3dac7-b5da-4f88-83ef-a4fee64c50e3",
				"1b7e1ce0-0fd5-8021-bae3-f14978b04d11"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "6f4917c2-ece5-4ada-8540-f94444699522",
			"name": "Alec",
			"onLive": false,
			"insta": "https://www.instagram.com/castelodoalec/",
			"twitter": "https://twitter.com/alelecleclec",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"272aef3d-5fcb-4628-914c-ab7c3e2bfbfa"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "e0f94f53-eb9e-48f9-851f-40a137e59457",
			"name": "Gemini",
			"onLive": false,
			"insta": "https://www.instagram.com/gem.i.ni/",
			"twitter": "https://twitter.com/gemini_ink",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"b793ab96-6a5a-4b5a-8157-c95d5d157210"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "3937eb00-7325-4bb7-b409-448c9a0281a6",
			"name": "Vivi Munhoz",
			"onLive": false,
			"insta": "https://www.instagram.com/melanciacomics/",
			"twitter": "https://twitter.com/MelanciaComics",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"3cbc64f3-b756-4f95-8e7d-3f1715dea757",
				"b33a901d-a3af-4375-b35f-089a018e0678"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Indicados"
			]
		},
		{
			"id": "746ee996-d682-4542-b4a3-562c31ed6e40",
			"name": "Jeff",
			"onLive": true,
			"insta": "https://www.instagram.com/jeffudecapa/",
			"twitter": "https://twitter.com/PandaDeCapa",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"31a09d13-11d9-4b66-b43b-41a845aa0df7"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "cbed581c-c767-4f9d-83ad-2e3f120e251c",
			"name": "Israel Guedes",
			"onLive": false,
			"insta": "https://www.instagram.com/thuntersmanga/",
			"twitter": "https://twitter.com/IsraelGuedes7",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"f4d8e008-6e65-4d3b-9fe8-5af736b98f55"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "7242ebd5-9b46-4a4a-a475-a041f2d68036",
			"name": "Heitor PC",
			"onLive": false,
			"insta": "https://www.instagram.com/heitorpc/",
			"twitter": "https://twitter.com/heitorpcart",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"a650f699-0374-444b-b3f7-74aacd46e2d3"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "82fd5183-c1db-4b7c-9f09-1197b229b217",
			"name": "Gabriel Pìeri",
			"onLive": false,
			"insta": "https://www.instagram.com/pieridomalagueta/",
			"twitter": "https://twitter.com/pieridomalaguet",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"4d47ce5c-cd75-4af4-8a81-9d7f4bea3ef0"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "7c78cedb-935a-4644-9aac-c31b9ba4c071",
			"name": "Akila",
			"onLive": true,
			"insta": "https://www.instagram.com/_akigabriel/",
			"twitter": "https://twitter.com/HQ_Forma",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"9f11910e-5cd3-4839-ae88-55df741c43ca",
				"75b22629-cd4d-491e-b963-33c2466de909",
				"428245a1-5c9f-481c-8648-5ffa6968f65b"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "83691cee-6fcb-4501-988c-17b13c1c9a8b",
			"name": "Yuri",
			"onLive": true,
			"insta": "https://www.instagram.com/pirateyuri/",
			"twitter": "https://twitter.com/pirate_yuri",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"247c5474-4f0e-4b2b-b550-bfc6448594e1"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "19d86a05-c01f-43f2-b4ca-5b632e61b78a",
			"name": "Dani Bolinho",
			"onLive": true,
			"insta": "https://www.instagram.com/dani_bolim/",
			"twitter": "https://twitter.com/BolimDani",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"edddd453-2196-47ff-bc86-30356224d08f",
				"6a6523bb-fed6-42a5-82e9-a7c0439e2b71",
				"cb639e71-b0ab-4758-8e56-38c4e137ae06"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "35efbd0d-e345-4e65-aca1-5e4e5b143b49",
			"name": "Felipe Soullep",
			"onLive": true,
			"insta": "https://www.instagram.com/felipe.soullep/",
			"twitter": "https://twitter.com/Felipe_Soullep",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"e7b28be6-2cfc-4156-9660-c9b484695f2c"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "1705dfef-ccac-42df-b453-53ca349b261e",
			"name": "Vinicius de Souza",
			"onLive": false,
			"insta": "https://www.instagram.com/viniciusdesouzaart/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"22e79d5d-b39d-46e3-aedc-790004bdcf54",
				"c27f4bf4-e746-4fe7-a37f-d347738d01ff"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "96052796-72df-424f-98ea-ecfe7c0ee43d",
			"name": "Pistashi",
			"onLive": true,
			"insta": "https://www.instagram.com/postosho/",
			"twitter": "https://twitter.com/Postosho",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"56c4f5a4-d84c-40d9-a862-fa98d89a59fa"
			],
			"gen": "♂️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "6465bc2a-15f1-450e-ab13-1f82f0da7b71",
			"name": "Max Andrade",
			"onLive": false,
			"insta": "https://www.instagram.com/puffnopiripaf/",
			"twitter": "https://twitter.com/puffnopiripaf",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"93159c36-f24d-4328-848b-e25273994629",
				"9eaca292-6456-46c5-b37e-d2addadc380c",
				"733a35a1-2053-4b3f-af72-1246df259206",
				"ada11d59-9500-40d1-b3b4-916de1ae6e7b"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "b8b710a2-aaa7-49ce-b645-9fb53496e4c9",
			"name": "Michel Costa",
			"onLive": true,
			"insta": "https://www.instagram.com/mimscosara/",
			"twitter": "https://twitter.com/mimscosara",
			"inedito": false,
			"etnia": "🤎",
			"quadrinhos": [
				"f71bbf12-4568-42fc-951e-1bea2607d316",
				"13be1ce0-0fd5-80c0-a676-d006ceeb48a2"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "dbf63566-b2be-49d7-ba35-d5bffd16e9ec",
			"name": "Lucas Rennó",
			"onLive": true,
			"insta": "https://www.instagram.com/renno.lucas/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"f71bbf12-4568-42fc-951e-1bea2607d316",
				"13be1ce0-0fd5-80c0-a676-d006ceeb48a2"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "08a5d8a0-aac4-4d32-88e4-3a91a6bfcdfc",
			"name": "Isabela Flores",
			"onLive": true,
			"insta": "https://www.instagram.com/belatime/",
			"twitter": null,
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"bddbd6b2-0cdc-46d3-9e05-f242f9d8df3f"
			],
			"gen": "♀️",
			"status": [
				"Lendo"
			]
		},
		{
			"id": "ca730233-854e-49bc-a1da-bcb9dbc89651",
			"name": "Reiko Yuma",
			"onLive": true,
			"insta": "https://www.instagram.com/reiko_yuma/",
			"twitter": "https://twitter.com/studioarkano",
			"inedito": false,
			"etnia": "❓",
			"quadrinhos": [
				"dace1182-8d80-4f48-872d-78aabce01eb1",
				"707b68d5-b4f4-4923-9b59-89324371ea82",
				"2a1d4862-6dd4-4f04-89d9-f8bb4339fe7d",
				"b62d6f6c-1a86-4f9f-8ff5-7401964bf79c",
				"a368832b-2911-4768-baa4-093299744a88",
				"0cfdec41-2fe1-4099-8d19-affd648ee609",
				"461bea2d-98f0-4f75-b135-cce8f4e9d58d",
				"665c238e-260a-4b3c-943b-a6d38bfe14dd",
				"30cc92de-a307-49a9-bd3d-a717fe5b8e7e"
			],
			"gen": "♀️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		},
		{
			"id": "feecc179-8e29-4967-9452-c992f8fbeb91",
			"name": "Raphael HHS",
			"onLive": true,
			"insta": "https://www.instagram.com/raphaelhhs/",
			"twitter": "https://twitter.com/RaphaelHhs",
			"inedito": false,
			"etnia": "🤍",
			"quadrinhos": [
				"05c9eb1d-4636-41ae-9236-145d74deb8e0",
				"7423e60a-dacd-4a9d-85fd-e4f7855eddb7",
				"4b5542d2-b1f9-4d5c-8102-d7a995708958",
				"7ef84045-8377-4856-8880-4a454255aac8",
				"17397722-d811-4e0a-a42b-11d7fdd5f0c0",
				"6ebfd638-b581-4a2f-b168-cd145a67bd57",
				"1fedea07-28c3-4063-805a-1773ac3d6f28",
				"85e378fb-158c-4f19-9849-4b5ddc9fe150",
				"12bc55bb-2325-4a9f-928d-15475f046dfc",
				"cb04cafc-56d0-409d-a423-1b4349ac8d33",
				"a7e98dd0-89e5-4d94-a133-b1e99a725cd1",
				"70ef1e0a-3d22-4ffc-bc19-660f6fc3d746",
				"42e667a4-d6cb-4acf-aa03-bdde4d2368be"
			],
			"gen": "♂️",
			"status": [
				"Lendo",
				"Lendo",
				"Lendo",
				"Indicados",
				"Lendo",
				"Lendo",
				"Indicados",
				"Indicados",
				"Indicados",
				"Indicados",
				"Lendo",
				"Lendo",
				"Lendo"
			]
		}
	]
}